
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireea93"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireea93"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jCgCX", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 4.2.0, Wed Aug 13 2025
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $41ddcddbc48bb87d$var$extendStatics = function(d, b) {
    $41ddcddbc48bb87d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $41ddcddbc48bb87d$var$extendStatics(d, b);
};
function $41ddcddbc48bb87d$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $41ddcddbc48bb87d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $41ddcddbc48bb87d$var$__assign = function() {
    $41ddcddbc48bb87d$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $41ddcddbc48bb87d$var$__assign.apply(this, arguments);
};
function $41ddcddbc48bb87d$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $41ddcddbc48bb87d$var$_global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
var $41ddcddbc48bb87d$var$keys = Object.keys;
var $41ddcddbc48bb87d$var$isArray = Array.isArray;
if (typeof Promise !== 'undefined' && !$41ddcddbc48bb87d$var$_global.Promise) $41ddcddbc48bb87d$var$_global.Promise = Promise;
function $41ddcddbc48bb87d$var$extend(obj, extension) {
    if (typeof extension !== 'object') return obj;
    $41ddcddbc48bb87d$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $41ddcddbc48bb87d$var$getProto = Object.getPrototypeOf;
var $41ddcddbc48bb87d$var$_hasOwn = {}.hasOwnProperty;
function $41ddcddbc48bb87d$var$hasOwn(obj, prop) {
    return $41ddcddbc48bb87d$var$_hasOwn.call(obj, prop);
}
function $41ddcddbc48bb87d$var$props(proto, extension) {
    if (typeof extension === 'function') extension = extension($41ddcddbc48bb87d$var$getProto(proto));
    (typeof Reflect === "undefined" ? $41ddcddbc48bb87d$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $41ddcddbc48bb87d$var$setProp(proto, key, extension[key]);
    });
}
var $41ddcddbc48bb87d$var$defineProperty = Object.defineProperty;
function $41ddcddbc48bb87d$var$setProp(obj, prop, functionOrGetSet, options) {
    $41ddcddbc48bb87d$var$defineProperty(obj, prop, $41ddcddbc48bb87d$var$extend(functionOrGetSet && $41ddcddbc48bb87d$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $41ddcddbc48bb87d$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $41ddcddbc48bb87d$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $41ddcddbc48bb87d$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $41ddcddbc48bb87d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $41ddcddbc48bb87d$var$getPropertyDescriptor(obj, prop) {
    var pd = $41ddcddbc48bb87d$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $41ddcddbc48bb87d$var$getProto(obj)) && $41ddcddbc48bb87d$var$getPropertyDescriptor(proto, prop);
}
var $41ddcddbc48bb87d$var$_slice = [].slice;
function $41ddcddbc48bb87d$var$slice(args, start, end) {
    return $41ddcddbc48bb87d$var$_slice.call(args, start, end);
}
function $41ddcddbc48bb87d$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $41ddcddbc48bb87d$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $41ddcddbc48bb87d$var$asap$1(fn) {
    if ($41ddcddbc48bb87d$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $41ddcddbc48bb87d$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $41ddcddbc48bb87d$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string' && $41ddcddbc48bb87d$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $41ddcddbc48bb87d$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $41ddcddbc48bb87d$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $41ddcddbc48bb87d$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        $41ddcddbc48bb87d$var$assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$41ddcddbc48bb87d$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($41ddcddbc48bb87d$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$41ddcddbc48bb87d$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $41ddcddbc48bb87d$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($41ddcddbc48bb87d$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $41ddcddbc48bb87d$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') $41ddcddbc48bb87d$var$setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        $41ddcddbc48bb87d$var$setByKeyPath(obj, kp, undefined);
    });
}
function $41ddcddbc48bb87d$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($41ddcddbc48bb87d$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $41ddcddbc48bb87d$var$concat = [].concat;
function $41ddcddbc48bb87d$var$flatten(a) {
    return $41ddcddbc48bb87d$var$concat.apply([], a);
}
var $41ddcddbc48bb87d$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(',').concat($41ddcddbc48bb87d$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $41ddcddbc48bb87d$var$_global[t];
});
var $41ddcddbc48bb87d$var$intrinsicTypes = new Set($41ddcddbc48bb87d$var$intrinsicTypeNames.map(function(t) {
    return $41ddcddbc48bb87d$var$_global[t];
}));
function $41ddcddbc48bb87d$var$cloneSimpleObjectTree(o) {
    var rv = {};
    for(var k in o)if ($41ddcddbc48bb87d$var$hasOwn(o, k)) {
        var v = o[k];
        rv[k] = !v || typeof v !== 'object' || $41ddcddbc48bb87d$var$intrinsicTypes.has(v.constructor) ? v : $41ddcddbc48bb87d$var$cloneSimpleObjectTree(v);
    }
    return rv;
}
function $41ddcddbc48bb87d$var$objectIsEmpty(o) {
    for(var k in o)if ($41ddcddbc48bb87d$var$hasOwn(o, k)) return false;
    return true;
}
var $41ddcddbc48bb87d$var$circularRefs = null;
function $41ddcddbc48bb87d$var$deepClone(any) {
    $41ddcddbc48bb87d$var$circularRefs = new WeakMap();
    var rv = $41ddcddbc48bb87d$var$innerDeepClone(any);
    $41ddcddbc48bb87d$var$circularRefs = null;
    return rv;
}
function $41ddcddbc48bb87d$var$innerDeepClone(x) {
    if (!x || typeof x !== 'object') return x;
    var rv = $41ddcddbc48bb87d$var$circularRefs.get(x);
    if (rv) return rv;
    if ($41ddcddbc48bb87d$var$isArray(x)) {
        rv = [];
        $41ddcddbc48bb87d$var$circularRefs.set(x, rv);
        for(var i = 0, l = x.length; i < l; ++i)rv.push($41ddcddbc48bb87d$var$innerDeepClone(x[i]));
    } else if ($41ddcddbc48bb87d$var$intrinsicTypes.has(x.constructor)) rv = x;
    else {
        var proto = $41ddcddbc48bb87d$var$getProto(x);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $41ddcddbc48bb87d$var$circularRefs.set(x, rv);
        for(var prop in x)if ($41ddcddbc48bb87d$var$hasOwn(x, prop)) rv[prop] = $41ddcddbc48bb87d$var$innerDeepClone(x[prop]);
    }
    return rv;
}
var $41ddcddbc48bb87d$var$toString = {}.toString;
function $41ddcddbc48bb87d$var$toStringTag(o) {
    return $41ddcddbc48bb87d$var$toString.call(o).slice(8, -1);
}
var $41ddcddbc48bb87d$var$iteratorSymbol = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
var $41ddcddbc48bb87d$var$getIteratorOf = typeof $41ddcddbc48bb87d$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$41ddcddbc48bb87d$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
function $41ddcddbc48bb87d$var$delArrayItem(a, x) {
    var i = a.indexOf(x);
    if (i >= 0) a.splice(i, 1);
    return i >= 0;
}
var $41ddcddbc48bb87d$var$NO_CHAR_ARRAY = {};
function $41ddcddbc48bb87d$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($41ddcddbc48bb87d$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $41ddcddbc48bb87d$var$NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = $41ddcddbc48bb87d$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $41ddcddbc48bb87d$var$isAsyncFunction = typeof Symbol !== 'undefined' ? function(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
} : function() {
    return false;
};
var $41ddcddbc48bb87d$var$dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var $41ddcddbc48bb87d$var$idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var $41ddcddbc48bb87d$var$errorList = $41ddcddbc48bb87d$var$dexieErrorNames.concat($41ddcddbc48bb87d$var$idbDomErrorNames);
var $41ddcddbc48bb87d$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $41ddcddbc48bb87d$var$DexieError(name, msg) {
    this.name = name;
    this.message = msg;
}
$41ddcddbc48bb87d$var$derive($41ddcddbc48bb87d$var$DexieError).from(Error).extend({
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $41ddcddbc48bb87d$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join('\n');
}
function $41ddcddbc48bb87d$var$ModifyError(msg, failures, successCount, failedKeys) {
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $41ddcddbc48bb87d$var$getMultiErrorMessage(msg, failures);
}
$41ddcddbc48bb87d$var$derive($41ddcddbc48bb87d$var$ModifyError).from($41ddcddbc48bb87d$var$DexieError);
function $41ddcddbc48bb87d$var$BulkError(msg, failures) {
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $41ddcddbc48bb87d$var$getMultiErrorMessage(msg, this.failures);
}
$41ddcddbc48bb87d$var$derive($41ddcddbc48bb87d$var$BulkError).from($41ddcddbc48bb87d$var$DexieError);
var $41ddcddbc48bb87d$var$errnames = $41ddcddbc48bb87d$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $41ddcddbc48bb87d$var$BaseException = $41ddcddbc48bb87d$var$DexieError;
var $41ddcddbc48bb87d$var$exceptions = $41ddcddbc48bb87d$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $41ddcddbc48bb87d$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = "".concat(msgOrInner).concat(!inner ? '' : '\n ' + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === 'object') {
            this.message = "".concat(msgOrInner.name, " ").concat(msgOrInner.message);
            this.inner = msgOrInner;
        }
    }
    $41ddcddbc48bb87d$var$derive(DexieError).from($41ddcddbc48bb87d$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$41ddcddbc48bb87d$var$exceptions.Syntax = SyntaxError;
$41ddcddbc48bb87d$var$exceptions.Type = TypeError;
$41ddcddbc48bb87d$var$exceptions.Range = RangeError;
var $41ddcddbc48bb87d$var$exceptionMap = $41ddcddbc48bb87d$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $41ddcddbc48bb87d$var$exceptions[name];
    return obj;
}, {});
function $41ddcddbc48bb87d$var$mapError(domError, message) {
    if (!domError || domError instanceof $41ddcddbc48bb87d$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$41ddcddbc48bb87d$var$exceptionMap[domError.name]) return domError;
    var rv = new $41ddcddbc48bb87d$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $41ddcddbc48bb87d$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $41ddcddbc48bb87d$var$fullNameExceptions = $41ddcddbc48bb87d$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $41ddcddbc48bb87d$var$exceptions[name];
    return obj;
}, {});
$41ddcddbc48bb87d$var$fullNameExceptions.ModifyError = $41ddcddbc48bb87d$var$ModifyError;
$41ddcddbc48bb87d$var$fullNameExceptions.DexieError = $41ddcddbc48bb87d$var$DexieError;
$41ddcddbc48bb87d$var$fullNameExceptions.BulkError = $41ddcddbc48bb87d$var$BulkError;
function $41ddcddbc48bb87d$var$nop() {}
function $41ddcddbc48bb87d$var$mirror(val) {
    return val;
}
function $41ddcddbc48bb87d$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $41ddcddbc48bb87d$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $41ddcddbc48bb87d$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $41ddcddbc48bb87d$var$hookCreatingChain(f1, f2) {
    if (f1 === $41ddcddbc48bb87d$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $41ddcddbc48bb87d$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $41ddcddbc48bb87d$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $41ddcddbc48bb87d$var$hookDeletingChain(f1, f2) {
    if (f1 === $41ddcddbc48bb87d$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $41ddcddbc48bb87d$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $41ddcddbc48bb87d$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $41ddcddbc48bb87d$var$hookUpdatingChain(f1, f2) {
    if (f1 === $41ddcddbc48bb87d$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $41ddcddbc48bb87d$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $41ddcddbc48bb87d$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $41ddcddbc48bb87d$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $41ddcddbc48bb87d$var$extend(res, res2);
    };
}
function $41ddcddbc48bb87d$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $41ddcddbc48bb87d$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $41ddcddbc48bb87d$var$promisableChain(f1, f2) {
    if (f1 === $41ddcddbc48bb87d$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $41ddcddbc48bb87d$var$debug = typeof location !== 'undefined' && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $41ddcddbc48bb87d$var$setDebug(value, filter) {
    $41ddcddbc48bb87d$var$debug = value;
}
var $41ddcddbc48bb87d$var$INTERNAL = {};
var $41ddcddbc48bb87d$var$ZONE_ECHO_LIMIT = 100, $41ddcddbc48bb87d$var$_a$1 = typeof Promise === 'undefined' ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === 'undefined' || !crypto.subtle) return [
        globalP,
        $41ddcddbc48bb87d$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $41ddcddbc48bb87d$var$getProto(nativeP),
        globalP
    ];
}(), $41ddcddbc48bb87d$var$resolvedNativePromise = $41ddcddbc48bb87d$var$_a$1[0], $41ddcddbc48bb87d$var$nativePromiseProto = $41ddcddbc48bb87d$var$_a$1[1], $41ddcddbc48bb87d$var$resolvedGlobalPromise = $41ddcddbc48bb87d$var$_a$1[2], $41ddcddbc48bb87d$var$nativePromiseThen = $41ddcddbc48bb87d$var$nativePromiseProto && $41ddcddbc48bb87d$var$nativePromiseProto.then;
var $41ddcddbc48bb87d$var$NativePromise = $41ddcddbc48bb87d$var$resolvedNativePromise && $41ddcddbc48bb87d$var$resolvedNativePromise.constructor;
var $41ddcddbc48bb87d$var$patchGlobalPromise = !!$41ddcddbc48bb87d$var$resolvedGlobalPromise;
function $41ddcddbc48bb87d$var$schedulePhysicalTick() {
    queueMicrotask($41ddcddbc48bb87d$var$physicalTick);
}
var $41ddcddbc48bb87d$var$asap = function(callback, args) {
    $41ddcddbc48bb87d$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($41ddcddbc48bb87d$var$needsNewPhysicalTick) {
        $41ddcddbc48bb87d$var$schedulePhysicalTick();
        $41ddcddbc48bb87d$var$needsNewPhysicalTick = false;
    }
};
var $41ddcddbc48bb87d$var$isOutsideMicroTick = true, $41ddcddbc48bb87d$var$needsNewPhysicalTick = true, $41ddcddbc48bb87d$var$unhandledErrors = [], $41ddcddbc48bb87d$var$rejectingErrors = [], $41ddcddbc48bb87d$var$rejectionMapper = $41ddcddbc48bb87d$var$mirror;
var $41ddcddbc48bb87d$var$globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $41ddcddbc48bb87d$var$nop,
    pgp: false,
    env: {},
    finalize: $41ddcddbc48bb87d$var$nop
};
var $41ddcddbc48bb87d$var$PSD = $41ddcddbc48bb87d$var$globalPSD;
var $41ddcddbc48bb87d$var$microtickQueue = [];
var $41ddcddbc48bb87d$var$numScheduledCalls = 0;
var $41ddcddbc48bb87d$var$tickFinalizers = [];
function $41ddcddbc48bb87d$var$DexiePromise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this._lib = false;
    var psd = this._PSD = $41ddcddbc48bb87d$var$PSD;
    if (typeof fn !== 'function') {
        if (fn !== $41ddcddbc48bb87d$var$INTERNAL) throw new TypeError('Not a function');
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $41ddcddbc48bb87d$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $41ddcddbc48bb87d$var$executePromiseTask(this, fn);
}
var $41ddcddbc48bb87d$var$thenProp = {
    get: function() {
        var psd = $41ddcddbc48bb87d$var$PSD, microTaskId = $41ddcddbc48bb87d$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $41ddcddbc48bb87d$var$PSD || microTaskId !== $41ddcddbc48bb87d$var$totalEchoes);
            var cleanup = possibleAwait && !$41ddcddbc48bb87d$var$decrementExpectedAwaits();
            var rv = new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
                $41ddcddbc48bb87d$var$propagateToListener(_this, new $41ddcddbc48bb87d$var$Listener($41ddcddbc48bb87d$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $41ddcddbc48bb87d$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            if (this._consoleTask) rv._consoleTask = this._consoleTask;
            return rv;
        }
        then.prototype = $41ddcddbc48bb87d$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $41ddcddbc48bb87d$var$setProp(this, 'then', value && value.prototype === $41ddcddbc48bb87d$var$INTERNAL ? $41ddcddbc48bb87d$var$thenProp : {
            get: function() {
                return value;
            },
            set: $41ddcddbc48bb87d$var$thenProp.set
        });
    }
};
$41ddcddbc48bb87d$var$props($41ddcddbc48bb87d$var$DexiePromise.prototype, {
    then: $41ddcddbc48bb87d$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $41ddcddbc48bb87d$var$propagateToListener(this, new $41ddcddbc48bb87d$var$Listener(null, null, onFulfilled, onRejected, $41ddcddbc48bb87d$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $41ddcddbc48bb87d$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $41ddcddbc48bb87d$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            return $41ddcddbc48bb87d$var$DexiePromise.resolve(onFinally()).then(function() {
                return value;
            });
        }, function(err) {
            return $41ddcddbc48bb87d$var$DexiePromise.resolve(onFinally()).then(function() {
                return $41ddcddbc48bb87d$var$PromiseReject(err);
            });
        });
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $41ddcddbc48bb87d$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) $41ddcddbc48bb87d$var$setProp($41ddcddbc48bb87d$var$DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
$41ddcddbc48bb87d$var$globalPSD.env = $41ddcddbc48bb87d$var$snapShot();
function $41ddcddbc48bb87d$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$41ddcddbc48bb87d$var$props($41ddcddbc48bb87d$var$DexiePromise, {
    all: function() {
        var values = $41ddcddbc48bb87d$var$getArrayOf.apply(null, arguments).map($41ddcddbc48bb87d$var$onPossibleParallellAsync);
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $41ddcddbc48bb87d$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $41ddcddbc48bb87d$var$DexiePromise) return value;
        if (value && typeof value.then === 'function') return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $41ddcddbc48bb87d$var$DexiePromise($41ddcddbc48bb87d$var$INTERNAL, true, value);
        return rv;
    },
    reject: $41ddcddbc48bb87d$var$PromiseReject,
    race: function() {
        var values = $41ddcddbc48bb87d$var$getArrayOf.apply(null, arguments).map($41ddcddbc48bb87d$var$onPossibleParallellAsync);
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $41ddcddbc48bb87d$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $41ddcddbc48bb87d$var$PSD;
        },
        set: function(value) {
            return $41ddcddbc48bb87d$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $41ddcddbc48bb87d$var$totalEchoes;
        }
    },
    newPSD: $41ddcddbc48bb87d$var$newScope,
    usePSD: $41ddcddbc48bb87d$var$usePSD,
    scheduler: {
        get: function() {
            return $41ddcddbc48bb87d$var$asap;
        },
        set: function(value) {
            $41ddcddbc48bb87d$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $41ddcddbc48bb87d$var$rejectionMapper;
        },
        set: function(value) {
            $41ddcddbc48bb87d$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            return $41ddcddbc48bb87d$var$newScope(function(resolve, reject) {
                var psd = $41ddcddbc48bb87d$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $41ddcddbc48bb87d$var$callBoth(function() {
                    var _this = this;
                    $41ddcddbc48bb87d$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($41ddcddbc48bb87d$var$NativePromise) {
    if ($41ddcddbc48bb87d$var$NativePromise.allSettled) $41ddcddbc48bb87d$var$setProp($41ddcddbc48bb87d$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $41ddcddbc48bb87d$var$getArrayOf.apply(null, arguments).map($41ddcddbc48bb87d$var$onPossibleParallellAsync);
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $41ddcddbc48bb87d$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($41ddcddbc48bb87d$var$NativePromise.any && typeof AggregateError !== 'undefined') $41ddcddbc48bb87d$var$setProp($41ddcddbc48bb87d$var$DexiePromise, "any", function() {
        var possiblePromises = $41ddcddbc48bb87d$var$getArrayOf.apply(null, arguments).map($41ddcddbc48bb87d$var$onPossibleParallellAsync);
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $41ddcddbc48bb87d$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
    if ($41ddcddbc48bb87d$var$NativePromise.withResolvers) $41ddcddbc48bb87d$var$DexiePromise.withResolvers = $41ddcddbc48bb87d$var$NativePromise.withResolvers;
}
function $41ddcddbc48bb87d$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && $41ddcddbc48bb87d$var$beginMicroTickScope();
            if (value && typeof value.then === 'function') $41ddcddbc48bb87d$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $41ddcddbc48bb87d$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $41ddcddbc48bb87d$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $41ddcddbc48bb87d$var$endMicroTickScope();
        }, $41ddcddbc48bb87d$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $41ddcddbc48bb87d$var$handleRejection(promise, ex);
    }
}
function $41ddcddbc48bb87d$var$handleRejection(promise, reason) {
    $41ddcddbc48bb87d$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $41ddcddbc48bb87d$var$beginMicroTickScope();
    reason = $41ddcddbc48bb87d$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $41ddcddbc48bb87d$var$addPossiblyUnhandledError(promise);
    $41ddcddbc48bb87d$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $41ddcddbc48bb87d$var$endMicroTickScope();
}
function $41ddcddbc48bb87d$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$41ddcddbc48bb87d$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($41ddcddbc48bb87d$var$numScheduledCalls === 0) {
        ++$41ddcddbc48bb87d$var$numScheduledCalls;
        $41ddcddbc48bb87d$var$asap(function() {
            if (--$41ddcddbc48bb87d$var$numScheduledCalls === 0) $41ddcddbc48bb87d$var$finalizePhysicalTick();
        }, []);
    }
}
function $41ddcddbc48bb87d$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$41ddcddbc48bb87d$var$numScheduledCalls;
    $41ddcddbc48bb87d$var$asap($41ddcddbc48bb87d$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $41ddcddbc48bb87d$var$callListener(cb, promise, listener) {
    try {
        var ret, value = promise._value;
        if (!promise._state && $41ddcddbc48bb87d$var$rejectingErrors.length) $41ddcddbc48bb87d$var$rejectingErrors = [];
        ret = $41ddcddbc48bb87d$var$debug && promise._consoleTask ? promise._consoleTask.run(function() {
            return cb(value);
        }) : cb(value);
        if (!promise._state && $41ddcddbc48bb87d$var$rejectingErrors.indexOf(value) === -1) $41ddcddbc48bb87d$var$markErrorAsHandled(promise);
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        if (--$41ddcddbc48bb87d$var$numScheduledCalls === 0) $41ddcddbc48bb87d$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $41ddcddbc48bb87d$var$physicalTick() {
    $41ddcddbc48bb87d$var$usePSD($41ddcddbc48bb87d$var$globalPSD, function() {
        $41ddcddbc48bb87d$var$beginMicroTickScope() && $41ddcddbc48bb87d$var$endMicroTickScope();
    });
}
function $41ddcddbc48bb87d$var$beginMicroTickScope() {
    var wasRootExec = $41ddcddbc48bb87d$var$isOutsideMicroTick;
    $41ddcddbc48bb87d$var$isOutsideMicroTick = false;
    $41ddcddbc48bb87d$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $41ddcddbc48bb87d$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($41ddcddbc48bb87d$var$microtickQueue.length > 0){
        callbacks = $41ddcddbc48bb87d$var$microtickQueue;
        $41ddcddbc48bb87d$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($41ddcddbc48bb87d$var$microtickQueue.length > 0);
    $41ddcddbc48bb87d$var$isOutsideMicroTick = true;
    $41ddcddbc48bb87d$var$needsNewPhysicalTick = true;
}
function $41ddcddbc48bb87d$var$finalizePhysicalTick() {
    var unhandledErrs = $41ddcddbc48bb87d$var$unhandledErrors;
    $41ddcddbc48bb87d$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $41ddcddbc48bb87d$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $41ddcddbc48bb87d$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $41ddcddbc48bb87d$var$tickFinalizers.splice($41ddcddbc48bb87d$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $41ddcddbc48bb87d$var$tickFinalizers.push(finalizer);
    ++$41ddcddbc48bb87d$var$numScheduledCalls;
    $41ddcddbc48bb87d$var$asap(function() {
        if (--$41ddcddbc48bb87d$var$numScheduledCalls === 0) $41ddcddbc48bb87d$var$finalizePhysicalTick();
    }, []);
}
function $41ddcddbc48bb87d$var$addPossiblyUnhandledError(promise) {
    if (!$41ddcddbc48bb87d$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $41ddcddbc48bb87d$var$unhandledErrors.push(promise);
}
function $41ddcddbc48bb87d$var$markErrorAsHandled(promise) {
    var i = $41ddcddbc48bb87d$var$unhandledErrors.length;
    while(i)if ($41ddcddbc48bb87d$var$unhandledErrors[--i]._value === promise._value) {
        $41ddcddbc48bb87d$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $41ddcddbc48bb87d$var$PromiseReject(reason) {
    return new $41ddcddbc48bb87d$var$DexiePromise($41ddcddbc48bb87d$var$INTERNAL, false, reason);
}
function $41ddcddbc48bb87d$var$wrap(fn, errorCatcher) {
    var psd = $41ddcddbc48bb87d$var$PSD;
    return function() {
        var wasRootExec = $41ddcddbc48bb87d$var$beginMicroTickScope(), outerScope = $41ddcddbc48bb87d$var$PSD;
        try {
            $41ddcddbc48bb87d$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $41ddcddbc48bb87d$var$switchToZone(outerScope, false);
            if (wasRootExec) $41ddcddbc48bb87d$var$endMicroTickScope();
        }
    };
}
var $41ddcddbc48bb87d$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $41ddcddbc48bb87d$var$taskCounter = 0;
var $41ddcddbc48bb87d$var$zoneStack = [];
var $41ddcddbc48bb87d$var$zoneEchoes = 0;
var $41ddcddbc48bb87d$var$totalEchoes = 0;
var $41ddcddbc48bb87d$var$zone_id_counter = 0;
function $41ddcddbc48bb87d$var$newScope(fn, props, a1, a2) {
    var parent = $41ddcddbc48bb87d$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$41ddcddbc48bb87d$var$zone_id_counter;
    $41ddcddbc48bb87d$var$globalPSD.env;
    psd.env = $41ddcddbc48bb87d$var$patchGlobalPromise ? {
        Promise: $41ddcddbc48bb87d$var$DexiePromise,
        PromiseProp: {
            value: $41ddcddbc48bb87d$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $41ddcddbc48bb87d$var$DexiePromise.all,
        race: $41ddcddbc48bb87d$var$DexiePromise.race,
        allSettled: $41ddcddbc48bb87d$var$DexiePromise.allSettled,
        any: $41ddcddbc48bb87d$var$DexiePromise.any,
        resolve: $41ddcddbc48bb87d$var$DexiePromise.resolve,
        reject: $41ddcddbc48bb87d$var$DexiePromise.reject
    } : {};
    if (props) $41ddcddbc48bb87d$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $41ddcddbc48bb87d$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $41ddcddbc48bb87d$var$incrementExpectedAwaits() {
    if (!$41ddcddbc48bb87d$var$task.id) $41ddcddbc48bb87d$var$task.id = ++$41ddcddbc48bb87d$var$taskCounter;
    ++$41ddcddbc48bb87d$var$task.awaits;
    $41ddcddbc48bb87d$var$task.echoes += $41ddcddbc48bb87d$var$ZONE_ECHO_LIMIT;
    return $41ddcddbc48bb87d$var$task.id;
}
function $41ddcddbc48bb87d$var$decrementExpectedAwaits() {
    if (!$41ddcddbc48bb87d$var$task.awaits) return false;
    if (--$41ddcddbc48bb87d$var$task.awaits === 0) $41ddcddbc48bb87d$var$task.id = 0;
    $41ddcddbc48bb87d$var$task.echoes = $41ddcddbc48bb87d$var$task.awaits * $41ddcddbc48bb87d$var$ZONE_ECHO_LIMIT;
    return true;
}
if (('' + $41ddcddbc48bb87d$var$nativePromiseThen).indexOf('[native code]') === -1) $41ddcddbc48bb87d$var$incrementExpectedAwaits = $41ddcddbc48bb87d$var$decrementExpectedAwaits = $41ddcddbc48bb87d$var$nop;
function $41ddcddbc48bb87d$var$onPossibleParallellAsync(possiblePromise) {
    if ($41ddcddbc48bb87d$var$task.echoes && possiblePromise && possiblePromise.constructor === $41ddcddbc48bb87d$var$NativePromise) {
        $41ddcddbc48bb87d$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $41ddcddbc48bb87d$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $41ddcddbc48bb87d$var$decrementExpectedAwaits();
            return $41ddcddbc48bb87d$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $41ddcddbc48bb87d$var$zoneEnterEcho(targetZone) {
    ++$41ddcddbc48bb87d$var$totalEchoes;
    if (!$41ddcddbc48bb87d$var$task.echoes || --$41ddcddbc48bb87d$var$task.echoes === 0) $41ddcddbc48bb87d$var$task.echoes = $41ddcddbc48bb87d$var$task.awaits = $41ddcddbc48bb87d$var$task.id = 0;
    $41ddcddbc48bb87d$var$zoneStack.push($41ddcddbc48bb87d$var$PSD);
    $41ddcddbc48bb87d$var$switchToZone(targetZone, true);
}
function $41ddcddbc48bb87d$var$zoneLeaveEcho() {
    var zone = $41ddcddbc48bb87d$var$zoneStack[$41ddcddbc48bb87d$var$zoneStack.length - 1];
    $41ddcddbc48bb87d$var$zoneStack.pop();
    $41ddcddbc48bb87d$var$switchToZone(zone, false);
}
function $41ddcddbc48bb87d$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $41ddcddbc48bb87d$var$PSD;
    if (bEnteringZone ? $41ddcddbc48bb87d$var$task.echoes && (!$41ddcddbc48bb87d$var$zoneEchoes++ || targetZone !== $41ddcddbc48bb87d$var$PSD) : $41ddcddbc48bb87d$var$zoneEchoes && (!--$41ddcddbc48bb87d$var$zoneEchoes || targetZone !== $41ddcddbc48bb87d$var$PSD)) queueMicrotask(bEnteringZone ? $41ddcddbc48bb87d$var$zoneEnterEcho.bind(null, targetZone) : $41ddcddbc48bb87d$var$zoneLeaveEcho);
    if (targetZone === $41ddcddbc48bb87d$var$PSD) return;
    $41ddcddbc48bb87d$var$PSD = targetZone;
    if (currentZone === $41ddcddbc48bb87d$var$globalPSD) $41ddcddbc48bb87d$var$globalPSD.env = $41ddcddbc48bb87d$var$snapShot();
    if ($41ddcddbc48bb87d$var$patchGlobalPromise) {
        var GlobalPromise = $41ddcddbc48bb87d$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($41ddcddbc48bb87d$var$_global, 'Promise', targetEnv.PromiseProp);
            GlobalPromise.all = targetEnv.all;
            GlobalPromise.race = targetEnv.race;
            GlobalPromise.resolve = targetEnv.resolve;
            GlobalPromise.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise.any = targetEnv.any;
        }
    }
}
function $41ddcddbc48bb87d$var$snapShot() {
    var GlobalPromise = $41ddcddbc48bb87d$var$_global.Promise;
    return $41ddcddbc48bb87d$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($41ddcddbc48bb87d$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject
    } : {};
}
function $41ddcddbc48bb87d$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $41ddcddbc48bb87d$var$PSD;
    try {
        $41ddcddbc48bb87d$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $41ddcddbc48bb87d$var$switchToZone(outerScope, false);
    }
}
function $41ddcddbc48bb87d$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = $41ddcddbc48bb87d$var$PSD;
        if (possibleAwait) $41ddcddbc48bb87d$var$incrementExpectedAwaits();
        $41ddcddbc48bb87d$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $41ddcddbc48bb87d$var$switchToZone(outerZone, false);
            if (cleanup) queueMicrotask($41ddcddbc48bb87d$var$decrementExpectedAwaits);
        }
    };
}
function $41ddcddbc48bb87d$var$execInGlobalContext(cb) {
    if (Promise === $41ddcddbc48bb87d$var$NativePromise && $41ddcddbc48bb87d$var$task.echoes === 0) {
        if ($41ddcddbc48bb87d$var$zoneEchoes === 0) cb();
        else enqueueNativeMicroTask(cb);
    } else setTimeout(cb, 0);
}
var $41ddcddbc48bb87d$var$rejection = $41ddcddbc48bb87d$var$DexiePromise.reject;
function $41ddcddbc48bb87d$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$41ddcddbc48bb87d$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._state.autoOpen) return $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed());
            db.open().catch($41ddcddbc48bb87d$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $41ddcddbc48bb87d$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $41ddcddbc48bb87d$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $41ddcddbc48bb87d$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $41ddcddbc48bb87d$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $41ddcddbc48bb87d$var$newScope(function() {
                $41ddcddbc48bb87d$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            if (mode === 'readwrite') try {
                trans.idbtrans.commit();
            } catch (_a) {}
            return mode === 'readonly' ? result : trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $41ddcddbc48bb87d$var$DEXIE_VERSION = '4.2.0';
var $41ddcddbc48bb87d$var$maxString = String.fromCharCode(65535);
var $41ddcddbc48bb87d$var$minKey = -Infinity;
var $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $41ddcddbc48bb87d$var$STRING_EXPECTED = "String expected.";
var $41ddcddbc48bb87d$var$connections = [];
var $41ddcddbc48bb87d$var$DBNAMES_DB = '__dbnames';
var $41ddcddbc48bb87d$var$READONLY = 'readonly';
var $41ddcddbc48bb87d$var$READWRITE = 'readwrite';
function $41ddcddbc48bb87d$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $41ddcddbc48bb87d$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $41ddcddbc48bb87d$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $41ddcddbc48bb87d$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
function $41ddcddbc48bb87d$export$bc644a473284d944() {
    throw $41ddcddbc48bb87d$var$exceptions.Type("Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.");
}
function $41ddcddbc48bb87d$export$6154dcdb7d23e37b(a, b) {
    try {
        var ta = $41ddcddbc48bb87d$var$type(a);
        var tb = $41ddcddbc48bb87d$var$type(b);
        if (ta !== tb) {
            if (ta === 'Array') return 1;
            if (tb === 'Array') return -1;
            if (ta === 'binary') return 1;
            if (tb === 'binary') return -1;
            if (ta === 'string') return 1;
            if (tb === 'string') return -1;
            if (ta === 'Date') return 1;
            if (tb !== 'Date') return NaN;
            return -1;
        }
        switch(ta){
            case 'number':
            case 'Date':
            case 'string':
                return a > b ? 1 : a < b ? -1 : 0;
            case 'binary':
                return $41ddcddbc48bb87d$var$compareUint8Arrays($41ddcddbc48bb87d$var$getUint8Array(a), $41ddcddbc48bb87d$var$getUint8Array(b));
            case 'Array':
                return $41ddcddbc48bb87d$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $41ddcddbc48bb87d$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $41ddcddbc48bb87d$export$6154dcdb7d23e37b(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $41ddcddbc48bb87d$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $41ddcddbc48bb87d$var$type(x) {
    var t = typeof x;
    if (t !== 'object') return t;
    if (ArrayBuffer.isView(x)) return 'binary';
    var tsTag = $41ddcddbc48bb87d$var$toStringTag(x);
    return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
}
function $41ddcddbc48bb87d$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
function $41ddcddbc48bb87d$var$builtInDeletionTrigger(table, keys, res) {
    var yProps = table.schema.yProps;
    if (!yProps) return res;
    if (keys && res.numFailures > 0) keys = keys.filter(function(_, i) {
        return !res.failures[i];
    });
    return Promise.all(yProps.map(function(_a) {
        var updatesTable = _a.updatesTable;
        return keys ? table.db.table(updatesTable).where('k').anyOf(keys).delete() : table.db.table(updatesTable).clear();
    })).then(function() {
        return res;
    });
}
var $41ddcddbc48bb87d$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $41ddcddbc48bb87d$var$PSD.trans;
        var tableName = this.name;
        var task = $41ddcddbc48bb87d$var$debug && typeof console !== 'undefined' && console.createTask && console.createTask("Dexie: ".concat(mode === 'readonly' ? 'read' : 'write', " ").concat(this.name));
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $41ddcddbc48bb87d$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $41ddcddbc48bb87d$var$beginMicroTickScope();
        try {
            var p = trans && trans.db._novip === this.db._novip ? trans === $41ddcddbc48bb87d$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $41ddcddbc48bb87d$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $41ddcddbc48bb87d$var$PSD.transless || $41ddcddbc48bb87d$var$PSD
            }) : $41ddcddbc48bb87d$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
            if (task) {
                p._consoleTask = task;
                p = p.catch(function(err) {
                    console.trace(err);
                    return $41ddcddbc48bb87d$var$rejection(err);
                });
            }
            return p;
        } finally{
            if (wasRootExec) $41ddcddbc48bb87d$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        if (keyOrCrit == null) return $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.Type("Invalid argument to Table.get()"));
        return this._trans('readonly', function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === 'string') return new this.db.WhereClause(this, indexOrCrit);
        if ($41ddcddbc48bb87d$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[".concat(indexOrCrit.join('+'), "]"));
        var keyPaths = $41ddcddbc48bb87d$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $41ddcddbc48bb87d$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $41ddcddbc48bb87d$var$debug) console.warn("The query ".concat(JSON.stringify(indexOrCrit), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(keyPaths.join('+'), "]"));
        var idxByName = this.schema.idxByName;
        function equals(a, b) {
            return $41ddcddbc48bb87d$export$6154dcdb7d23e37b(a, b) === 0;
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $41ddcddbc48bb87d$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $41ddcddbc48bb87d$var$getByKeyPath(x, keyPath);
                    return $41ddcddbc48bb87d$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $41ddcddbc48bb87d$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals('');
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $41ddcddbc48bb87d$var$isArray(index) ? "[".concat(index.join('+'), "]") : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        var _a = this, db = _a.db, tableName = _a.name;
        this.schema.mappedClass = constructor;
        if (constructor.prototype instanceof $41ddcddbc48bb87d$export$bc644a473284d944) constructor = function(_super) {
            $41ddcddbc48bb87d$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(class_1.prototype, "db", {
                get: function() {
                    return db;
                },
                enumerable: false,
                configurable: true
            });
            class_1.prototype.table = function() {
                return tableName;
            };
            return class_1;
        }(constructor);
        var inheritedProps = new Set();
        for(var proto = constructor.prototype; proto; proto = $41ddcddbc48bb87d$var$getProto(proto))Object.getOwnPropertyNames(proto).forEach(function(propName) {
            return inheritedProps.add(propName);
        });
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if (!inheritedProps.has(m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $41ddcddbc48bb87d$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $41ddcddbc48bb87d$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $41ddcddbc48bb87d$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $41ddcddbc48bb87d$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === 'object' && !$41ddcddbc48bb87d$var$isArray(keyOrObject)) {
            var key = $41ddcddbc48bb87d$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $41ddcddbc48bb87d$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $41ddcddbc48bb87d$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $41ddcddbc48bb87d$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: [
                    key
                ]
            }).then(function(res) {
                return $41ddcddbc48bb87d$var$builtInDeletionTrigger(_this, [
                    key
                ], res);
            }).then(function(res) {
                return res.numFailures ? $41ddcddbc48bb87d$var$DexiePromise.reject(res.failures[0]) : undefined;
            });
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'deleteRange',
                range: $41ddcddbc48bb87d$var$AnyRange
            }).then(function(res) {
                return $41ddcddbc48bb87d$var$builtInDeletionTrigger(_this, null, res);
            });
        }).then(function(res) {
            return res.numFailures ? $41ddcddbc48bb87d$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans('readonly', function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($41ddcddbc48bb87d$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $41ddcddbc48bb87d$var$BulkError("".concat(_this.name, ".bulkAdd(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($41ddcddbc48bb87d$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $41ddcddbc48bb87d$var$BulkError("".concat(_this.name, ".bulkPut(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkUpdate = function(keysAndChanges) {
        var _this = this;
        var coreTable = this.core;
        var keys = keysAndChanges.map(function(entry) {
            return entry.key;
        });
        var changeSpecs = keysAndChanges.map(function(entry) {
            return entry.changes;
        });
        var offsetMap = [];
        return this._trans('readwrite', function(trans) {
            return coreTable.getMany({
                trans: trans,
                keys: keys,
                cache: 'clone'
            }).then(function(objs) {
                var resultKeys = [];
                var resultObjs = [];
                keysAndChanges.forEach(function(_a, idx) {
                    var key = _a.key, changes = _a.changes;
                    var obj = objs[idx];
                    if (obj) {
                        for(var _i = 0, _b = Object.keys(changes); _i < _b.length; _i++){
                            var keyPath = _b[_i];
                            var value = changes[keyPath];
                            if (keyPath === _this.schema.primKey.keyPath) {
                                if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(value, key) !== 0) throw new $41ddcddbc48bb87d$var$exceptions.Constraint("Cannot update primary key in bulkUpdate()");
                            } else $41ddcddbc48bb87d$var$setByKeyPath(obj, keyPath, value);
                        }
                        offsetMap.push(idx);
                        resultKeys.push(key);
                        resultObjs.push(obj);
                    }
                });
                var numEntries = resultKeys.length;
                return coreTable.mutate({
                    trans: trans,
                    type: 'put',
                    keys: resultKeys,
                    values: resultObjs,
                    updates: {
                        keys: keys,
                        changeSpecs: changeSpecs
                    }
                }).then(function(_a) {
                    var numFailures = _a.numFailures, failures = _a.failures;
                    if (numFailures === 0) return numEntries;
                    for(var _i = 0, _b = Object.keys(failures); _i < _b.length; _i++){
                        var offset = _b[_i];
                        var mappedOffset = offsetMap[Number(offset)];
                        if (mappedOffset != null) {
                            var failure = failures[offset];
                            delete failures[offset];
                            failures[mappedOffset] = failure;
                        }
                    }
                    throw new $41ddcddbc48bb87d$var$BulkError("".concat(_this.name, ".bulkUpdate(): ").concat(numFailures, " of ").concat(numEntries, " operations failed"), failures);
                });
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: keys
            }).then(function(res) {
                return $41ddcddbc48bb87d$var$builtInDeletionTrigger(_this, keys, res);
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $41ddcddbc48bb87d$var$BulkError("".concat(_this.name, ".bulkDelete(): ").concat(numFailures, " of ").concat(numKeys, " operations failed"), failures);
        });
    };
    return Table;
}();
function $41ddcddbc48bb87d$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $41ddcddbc48bb87d$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $41ddcddbc48bb87d$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $41ddcddbc48bb87d$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($41ddcddbc48bb87d$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') var context = add(eventName, $41ddcddbc48bb87d$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $41ddcddbc48bb87d$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $41ddcddbc48bb87d$var$makeClassConstructor(prototype, constructor) {
    $41ddcddbc48bb87d$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $41ddcddbc48bb87d$var$createTableConstructor(db) {
    return $41ddcddbc48bb87d$var$makeClassConstructor($41ddcddbc48bb87d$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $41ddcddbc48bb87d$var$Events(null, {
            "creating": [
                $41ddcddbc48bb87d$var$hookCreatingChain,
                $41ddcddbc48bb87d$var$nop
            ],
            "reading": [
                $41ddcddbc48bb87d$var$pureFunctionChain,
                $41ddcddbc48bb87d$var$mirror
            ],
            "updating": [
                $41ddcddbc48bb87d$var$hookUpdatingChain,
                $41ddcddbc48bb87d$var$nop
            ],
            "deleting": [
                $41ddcddbc48bb87d$var$hookDeletingChain,
                $41ddcddbc48bb87d$var$nop
            ]
        });
    });
}
function $41ddcddbc48bb87d$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $41ddcddbc48bb87d$var$addFilter(ctx, fn) {
    ctx.filter = $41ddcddbc48bb87d$var$combine(ctx.filter, fn);
}
function $41ddcddbc48bb87d$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $41ddcddbc48bb87d$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $41ddcddbc48bb87d$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $41ddcddbc48bb87d$var$combine(ctx.isMatch, fn);
}
function $41ddcddbc48bb87d$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $41ddcddbc48bb87d$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $41ddcddbc48bb87d$var$openCursor(ctx, coreTable, trans) {
    var index = $41ddcddbc48bb87d$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === 'prev',
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $41ddcddbc48bb87d$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $41ddcddbc48bb87d$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $41ddcddbc48bb87d$var$iterate($41ddcddbc48bb87d$var$openCursor(ctx, coreTable, coreTrans), $41ddcddbc48bb87d$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = '' + primaryKey;
                if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                if (!$41ddcddbc48bb87d$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $41ddcddbc48bb87d$var$iterate($41ddcddbc48bb87d$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $41ddcddbc48bb87d$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $41ddcddbc48bb87d$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $41ddcddbc48bb87d$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $41ddcddbc48bb87d$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
var $41ddcddbc48bb87d$export$4118fdb20badc28d = function() {
    function PropModification(spec) {
        this["@@propmod"] = spec;
    }
    PropModification.prototype.execute = function(value) {
        var _a;
        var spec = this["@@propmod"];
        if (spec.add !== undefined) {
            var term = spec.add;
            if ($41ddcddbc48bb87d$var$isArray(term)) return $41ddcddbc48bb87d$var$__spreadArray($41ddcddbc48bb87d$var$__spreadArray([], $41ddcddbc48bb87d$var$isArray(value) ? value : [], true), term, true).sort();
            if (typeof term === 'number') return (Number(value) || 0) + term;
            if (typeof term === 'bigint') try {
                return BigInt(value) + term;
            } catch (_b) {
                return BigInt(0) + term;
            }
            throw new TypeError("Invalid term ".concat(term));
        }
        if (spec.remove !== undefined) {
            var subtrahend_1 = spec.remove;
            if ($41ddcddbc48bb87d$var$isArray(subtrahend_1)) return $41ddcddbc48bb87d$var$isArray(value) ? value.filter(function(item) {
                return !subtrahend_1.includes(item);
            }).sort() : [];
            if (typeof subtrahend_1 === 'number') return Number(value) - subtrahend_1;
            if (typeof subtrahend_1 === 'bigint') try {
                return BigInt(value) - subtrahend_1;
            } catch (_c) {
                return BigInt(0) - subtrahend_1;
            }
            throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
        }
        var prefixToReplace = (_a = spec.replacePrefix) === null || _a === void 0 ? void 0 : _a[0];
        if (prefixToReplace && typeof value === 'string' && value.startsWith(prefixToReplace)) return spec.replacePrefix[1] + value.substring(prefixToReplace.length);
        return value;
    };
    return PropModification;
}();
var $41ddcddbc48bb87d$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $41ddcddbc48bb87d$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readonly', fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $41ddcddbc48bb87d$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readwrite', fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $41ddcddbc48bb87d$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $41ddcddbc48bb87d$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $41ddcddbc48bb87d$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $41ddcddbc48bb87d$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($41ddcddbc48bb87d$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $41ddcddbc48bb87d$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $41ddcddbc48bb87d$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return $41ddcddbc48bb87d$export$6154dcdb7d23e37b(aVal, bVal) * order;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === 'next' && $41ddcddbc48bb87d$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $41ddcddbc48bb87d$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $41ddcddbc48bb87d$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($41ddcddbc48bb87d$var$isPlainKeyRange(ctx)) $41ddcddbc48bb87d$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $41ddcddbc48bb87d$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $41ddcddbc48bb87d$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $41ddcddbc48bb87d$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $41ddcddbc48bb87d$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $41ddcddbc48bb87d$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === 'next' && $41ddcddbc48bb87d$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $41ddcddbc48bb87d$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $41ddcddbc48bb87d$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $41ddcddbc48bb87d$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === 'function') modifyer = changes;
            else {
                var keyPaths = $41ddcddbc48bb87d$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i];
                        var val = changes[keyPath];
                        var origVal = $41ddcddbc48bb87d$var$getByKeyPath(item, keyPath);
                        if (val instanceof $41ddcddbc48bb87d$export$4118fdb20badc28d) {
                            $41ddcddbc48bb87d$var$setByKeyPath(item, keyPath, val.execute(origVal));
                            anythingModified = true;
                        } else if (origVal !== val) {
                            $41ddcddbc48bb87d$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = 200;
            var modifyChunkSize = _this.db._options.modifyChunkSize;
            if (modifyChunkSize) {
                if (typeof modifyChunkSize == 'object') limit = modifyChunkSize[coreTable.name] || modifyChunkSize['*'] || 200;
                else limit = modifyChunkSize;
            }
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $41ddcddbc48bb87d$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            var isUnconditionalDelete = changes === $41ddcddbc48bb87d$var$deleteCallback;
            return _this.clone().primaryKeys().then(function(keys) {
                var criteria = $41ddcddbc48bb87d$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== 'function' || isUnconditionalDelete) && {
                    index: ctx.index,
                    range: ctx.range
                };
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    var keysInChunk = keys.slice(offset, offset + count);
                    return (isUnconditionalDelete ? Promise.resolve([]) : coreTable.getMany({
                        trans: trans,
                        keys: keysInChunk,
                        cache: "immutable"
                    })).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = isUnconditionalDelete ? keysInChunk : [];
                        if (!isUnconditionalDelete) for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $41ddcddbc48bb87d$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $41ddcddbc48bb87d$export$6154dcdb7d23e37b(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: 'add',
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === 'object') && coreTable.mutate({
                                trans: trans,
                                type: 'put',
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== 'function' && changes,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && isUnconditionalDelete) && coreTable.mutate({
                                trans: trans,
                                type: 'delete',
                                keys: deleteKeys,
                                criteria: criteria,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return $41ddcddbc48bb87d$var$builtInDeletionTrigger(ctx.table, deleteKeys, res);
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $41ddcddbc48bb87d$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($41ddcddbc48bb87d$var$isPlainKeyRange(ctx) && !ctx.table.schema.yProps && (ctx.isPrimKey || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: 'deleteRange',
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures, numFailures = _a.numFailures;
                    if (numFailures) throw new $41ddcddbc48bb87d$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($41ddcddbc48bb87d$var$deleteCallback);
    };
    return Collection;
}();
var $41ddcddbc48bb87d$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $41ddcddbc48bb87d$var$createCollectionConstructor(db) {
    return $41ddcddbc48bb87d$var$makeClassConstructor($41ddcddbc48bb87d$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $41ddcddbc48bb87d$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $41ddcddbc48bb87d$var$mirror ? readingHook : null
        };
    });
}
function $41ddcddbc48bb87d$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $41ddcddbc48bb87d$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $41ddcddbc48bb87d$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $41ddcddbc48bb87d$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $41ddcddbc48bb87d$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $41ddcddbc48bb87d$var$rangeEqual("");
    }).limit(0);
}
function $41ddcddbc48bb87d$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $41ddcddbc48bb87d$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $41ddcddbc48bb87d$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $41ddcddbc48bb87d$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === 'string';
    })) return $41ddcddbc48bb87d$var$fail(whereClause, $41ddcddbc48bb87d$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $41ddcddbc48bb87d$var$upperFactory(dir);
        lower = $41ddcddbc48bb87d$var$lowerFactory(dir);
        compare = dir === "next" ? $41ddcddbc48bb87d$var$simpleCompare : $41ddcddbc48bb87d$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $41ddcddbc48bb87d$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== 'string') return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $41ddcddbc48bb87d$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $41ddcddbc48bb87d$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $41ddcddbc48bb87d$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $41ddcddbc48bb87d$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $41ddcddbc48bb87d$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $41ddcddbc48bb87d$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $41ddcddbc48bb87d$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $41ddcddbc48bb87d$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $41ddcddbc48bb87d$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $41ddcddbc48bb87d$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $41ddcddbc48bb87d$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== 'string') return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$STRING_EXPECTED);
        return this.between(str, str + $41ddcddbc48bb87d$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $41ddcddbc48bb87d$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $41ddcddbc48bb87d$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $41ddcddbc48bb87d$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $41ddcddbc48bb87d$var$getArrayOf.apply($41ddcddbc48bb87d$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $41ddcddbc48bb87d$var$emptyCollection(this);
        return $41ddcddbc48bb87d$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $41ddcddbc48bb87d$var$getArrayOf.apply($41ddcddbc48bb87d$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $41ddcddbc48bb87d$var$emptyCollection(this);
        return $41ddcddbc48bb87d$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $41ddcddbc48bb87d$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $41ddcddbc48bb87d$var$getArrayOf.apply($41ddcddbc48bb87d$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $41ddcddbc48bb87d$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $41ddcddbc48bb87d$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $41ddcddbc48bb87d$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $41ddcddbc48bb87d$var$getArrayOf.apply($41ddcddbc48bb87d$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $41ddcddbc48bb87d$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $41ddcddbc48bb87d$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $41ddcddbc48bb87d$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $41ddcddbc48bb87d$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $41ddcddbc48bb87d$var$fail(this, $41ddcddbc48bb87d$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $41ddcddbc48bb87d$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $41ddcddbc48bb87d$var$getArrayOf.apply($41ddcddbc48bb87d$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === 'string';
        })) return $41ddcddbc48bb87d$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $41ddcddbc48bb87d$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $41ddcddbc48bb87d$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $41ddcddbc48bb87d$var$createWhereClauseConstructor(db) {
    return $41ddcddbc48bb87d$var$makeClassConstructor($41ddcddbc48bb87d$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        this._cmp = this._ascending = $41ddcddbc48bb87d$export$6154dcdb7d23e37b;
        this._descending = function(a, b) {
            return $41ddcddbc48bb87d$export$6154dcdb7d23e37b(b, a);
        };
        this._max = function(a, b) {
            return $41ddcddbc48bb87d$export$6154dcdb7d23e37b(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return $41ddcddbc48bb87d$export$6154dcdb7d23e37b(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
        if (!this._IDBKeyRange) throw new $41ddcddbc48bb87d$var$exceptions.MissingAPI();
    });
}
function $41ddcddbc48bb87d$var$eventRejectHandler(reject) {
    return $41ddcddbc48bb87d$var$wrap(function(event) {
        $41ddcddbc48bb87d$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $41ddcddbc48bb87d$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $41ddcddbc48bb87d$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
var $41ddcddbc48bb87d$var$STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
var $41ddcddbc48bb87d$var$globalEvents = $41ddcddbc48bb87d$var$Events(null, $41ddcddbc48bb87d$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $41ddcddbc48bb87d$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $41ddcddbc48bb87d$var$assert(!$41ddcddbc48bb87d$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$41ddcddbc48bb87d$var$PSD.global) $41ddcddbc48bb87d$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $41ddcddbc48bb87d$var$assert(!$41ddcddbc48bb87d$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$41ddcddbc48bb87d$var$PSD.global) $41ddcddbc48bb87d$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $41ddcddbc48bb87d$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $41ddcddbc48bb87d$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $41ddcddbc48bb87d$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $41ddcddbc48bb87d$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $41ddcddbc48bb87d$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $41ddcddbc48bb87d$var$exceptions.TransactionInactive();
        $41ddcddbc48bb87d$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $41ddcddbc48bb87d$var$wrap(function(ev) {
            $41ddcddbc48bb87d$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $41ddcddbc48bb87d$var$wrap(function(ev) {
            $41ddcddbc48bb87d$var$preventDefault(ev);
            _this.active && _this._reject(new $41ddcddbc48bb87d$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $41ddcddbc48bb87d$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ('mutatedParts' in idbtrans) $41ddcddbc48bb87d$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === 'readwrite' && this.mode !== 'readwrite') return $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.TransactionInactive());
        if (this._locked()) return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $41ddcddbc48bb87d$var$PSD
            ]);
        });
        else if (bWriteLock) return $41ddcddbc48bb87d$var$newScope(function() {
            var p = new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $41ddcddbc48bb87d$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($41ddcddbc48bb87d$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($41ddcddbc48bb87d$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $41ddcddbc48bb87d$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($41ddcddbc48bb87d$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $41ddcddbc48bb87d$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $41ddcddbc48bb87d$var$createTransactionConstructor(db) {
    return $41ddcddbc48bb87d$var$makeClassConstructor($41ddcddbc48bb87d$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        if (mode !== 'readonly') storeNames.forEach(function(storeName) {
            var _a;
            var yProps = (_a = dbschema[storeName]) === null || _a === void 0 ? void 0 : _a.yProps;
            if (yProps) storeNames = storeNames.concat(yProps.map(function(p) {
                return p.updatesTable;
            }));
        });
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $41ddcddbc48bb87d$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $41ddcddbc48bb87d$var$rejection(e);
        });
    });
}
function $41ddcddbc48bb87d$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey, type) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + $41ddcddbc48bb87d$var$nameFromKeyPath(keyPath),
        type: type
    };
}
function $41ddcddbc48bb87d$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
function $41ddcddbc48bb87d$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $41ddcddbc48bb87d$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $41ddcddbc48bb87d$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $41ddcddbc48bb87d$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $41ddcddbc48bb87d$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $41ddcddbc48bb87d$var$getMaxKey = function() {
            return $41ddcddbc48bb87d$var$maxString;
        };
        return $41ddcddbc48bb87d$var$maxString;
    }
};
function $41ddcddbc48bb87d$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === 'string') return $41ddcddbc48bb87d$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $41ddcddbc48bb87d$var$getByKeyPath(obj, keyPath);
    };
}
function $41ddcddbc48bb87d$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split('.');
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $41ddcddbc48bb87d$var$getByKeyPath(obj, keyPath);
    };
}
function $41ddcddbc48bb87d$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $41ddcddbc48bb87d$var$_id_counter = 0;
function $41ddcddbc48bb87d$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === 'string' ? keyPath : "[".concat(keyPath.join('+'), "]");
}
function $41ddcddbc48bb87d$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $41ddcddbc48bb87d$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $41ddcddbc48bb87d$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $41ddcddbc48bb87d$var$getKeyExtractor(keyPath)
                        },
                        indexes: $41ddcddbc48bb87d$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $41ddcddbc48bb87d$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $41ddcddbc48bb87d$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$41ddcddbc48bb87d$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$41ddcddbc48bb87d$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$41ddcddbc48bb87d$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && 'getAll' in trans.objectStore(tables[0]) && !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $41ddcddbc48bb87d$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange') throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $41ddcddbc48bb87d$var$preventDefault(event);
                };
                if (type === 'deleteRange') {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $41ddcddbc48bb87d$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !('openKeyCursor' in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                req.onsuccess = $41ddcddbc48bb87d$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$41ddcddbc48bb87d$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $41ddcddbc48bb87d$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $41ddcddbc48bb87d$var$wrap(resolveIteration);
                            req.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $41ddcddbc48bb87d$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $41ddcddbc48bb87d$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !('openKeyCursor' in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $41ddcddbc48bb87d$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $41ddcddbc48bb87d$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $41ddcddbc48bb87d$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '".concat(name, "' not found"));
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $41ddcddbc48bb87d$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $41ddcddbc48bb87d$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $41ddcddbc48bb87d$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $41ddcddbc48bb87d$var$createMiddlewareStack($41ddcddbc48bb87d$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $41ddcddbc48bb87d$var$generateMiddlewareStacks(db, tmpTrans) {
    var idbdb = tmpTrans.db;
    var stacks = $41ddcddbc48bb87d$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $41ddcddbc48bb87d$var$setApiOnPlace(db, objs, tableNames, dbschema) {
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $41ddcddbc48bb87d$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $41ddcddbc48bb87d$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $41ddcddbc48bb87d$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $41ddcddbc48bb87d$var$removeTablesApi(db, objs) {
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $41ddcddbc48bb87d$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $41ddcddbc48bb87d$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    if (idbUpgradeTrans.objectStoreNames.contains('$meta') && !globalSchema.$meta) {
        globalSchema.$meta = $41ddcddbc48bb87d$var$createTableSchema("$meta", $41ddcddbc48bb87d$var$parseIndexSyntax("")[0], []);
        db._storeNames.push('$meta');
    }
    var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $41ddcddbc48bb87d$var$PSD.transless || $41ddcddbc48bb87d$var$PSD;
    $41ddcddbc48bb87d$var$newScope(function() {
        $41ddcddbc48bb87d$var$PSD.trans = trans;
        $41ddcddbc48bb87d$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $41ddcddbc48bb87d$var$keys(globalSchema).forEach(function(tableName) {
                $41ddcddbc48bb87d$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $41ddcddbc48bb87d$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $41ddcddbc48bb87d$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else {
            $41ddcddbc48bb87d$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            return $41ddcddbc48bb87d$var$getExistingVersion(db, trans, oldVersion).then(function(oldVersion) {
                return $41ddcddbc48bb87d$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans);
            }).catch(rejectTransaction);
        }
    });
}
function $41ddcddbc48bb87d$var$patchCurrentVersion(db, idbUpgradeTrans) {
    $41ddcddbc48bb87d$var$createMissingTables(db._dbSchema, idbUpgradeTrans);
    if (idbUpgradeTrans.db.version % 10 === 0 && !idbUpgradeTrans.objectStoreNames.contains('$meta')) idbUpgradeTrans.db.createObjectStore('$meta').add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), 'version');
    var globalSchema = $41ddcddbc48bb87d$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    $41ddcddbc48bb87d$var$adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
    var diff = $41ddcddbc48bb87d$var$getSchemaDiff(globalSchema, db._dbSchema);
    var _loop_1 = function(tableChange) {
        if (tableChange.change.length || tableChange.recreate) {
            console.warn("Unable to patch indexes of table ".concat(tableChange.name, " because it has changes on the type of index or primary key."));
            return {
                value: void 0
            };
        }
        var store = idbUpgradeTrans.objectStore(tableChange.name);
        tableChange.add.forEach(function(idx) {
            if ($41ddcddbc48bb87d$var$debug) console.debug("Dexie upgrade patch: Creating missing index ".concat(tableChange.name, ".").concat(idx.src));
            $41ddcddbc48bb87d$var$addIndex(store, idx);
        });
    };
    for(var _i = 0, _a = diff.change; _i < _a.length; _i++){
        var tableChange = _a[_i];
        var state_1 = _loop_1(tableChange);
        if (typeof state_1 === "object") return state_1.value;
    }
}
function $41ddcddbc48bb87d$var$getExistingVersion(db, trans, oldVersion) {
    if (trans.storeNames.includes('$meta')) return trans.table('$meta').get('version').then(function(metaVersion) {
        return metaVersion != null ? metaVersion : oldVersion;
    });
    else return $41ddcddbc48bb87d$var$DexiePromise.resolve(oldVersion);
}
function $41ddcddbc48bb87d$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $41ddcddbc48bb87d$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    if (versToRun.length === 0) return $41ddcddbc48bb87d$var$DexiePromise.resolve();
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $41ddcddbc48bb87d$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $41ddcddbc48bb87d$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $41ddcddbc48bb87d$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $41ddcddbc48bb87d$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $41ddcddbc48bb87d$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $41ddcddbc48bb87d$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $41ddcddbc48bb87d$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $41ddcddbc48bb87d$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                var upgradeSchema_1 = $41ddcddbc48bb87d$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $41ddcddbc48bb87d$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $41ddcddbc48bb87d$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $41ddcddbc48bb87d$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $41ddcddbc48bb87d$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $41ddcddbc48bb87d$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $41ddcddbc48bb87d$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $41ddcddbc48bb87d$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === 'function' ? $41ddcddbc48bb87d$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            var newSchema = version._cfg.dbschema;
            $41ddcddbc48bb87d$var$deleteRemovedTables(newSchema, idbtrans);
            $41ddcddbc48bb87d$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $41ddcddbc48bb87d$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
        queue.push(function(idbtrans) {
            if (db.idbdb.objectStoreNames.contains('$meta')) {
                if (Math.ceil(db.idbdb.version / 10) === version._cfg.version) {
                    db.idbdb.deleteObjectStore('$meta');
                    delete db._dbSchema.$meta;
                    db._storeNames = db._storeNames.filter(function(name) {
                        return name !== '$meta';
                    });
                } else idbtrans.objectStore('$meta').put(version._cfg.version, 'version');
            }
        });
    });
    function runQueue() {
        return queue.length ? $41ddcddbc48bb87d$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $41ddcddbc48bb87d$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $41ddcddbc48bb87d$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $41ddcddbc48bb87d$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ('' + (oldDef.primKey.keyPath || '') !== '' + (newDef.primKey.keyPath || '') || oldDef.primKey.auto !== newDef.primKey.auto) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $41ddcddbc48bb87d$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $41ddcddbc48bb87d$var$addIndex(store, idx);
    });
    return store;
}
function $41ddcddbc48bb87d$var$createMissingTables(newSchema, idbtrans) {
    $41ddcddbc48bb87d$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) {
            if ($41ddcddbc48bb87d$var$debug) console.debug('Dexie: Creating missing table', tableName);
            $41ddcddbc48bb87d$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
        }
    });
}
function $41ddcddbc48bb87d$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $41ddcddbc48bb87d$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $41ddcddbc48bb87d$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $41ddcddbc48bb87d$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $41ddcddbc48bb87d$var$createIndexSpec($41ddcddbc48bb87d$var$nameFromKeyPath(keyPath), keyPath || "", true, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $41ddcddbc48bb87d$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $41ddcddbc48bb87d$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $41ddcddbc48bb87d$var$readGlobalSchema(db, idbdb, tmpTrans) {
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $41ddcddbc48bb87d$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $41ddcddbc48bb87d$var$slice(idbdb.objectStoreNames, 0);
    $41ddcddbc48bb87d$var$setApiOnPlace(db, [
        db._allTables
    ], $41ddcddbc48bb87d$var$keys(globalSchema), globalSchema);
}
function $41ddcddbc48bb87d$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $41ddcddbc48bb87d$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $41ddcddbc48bb87d$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $41ddcddbc48bb87d$var$adjustToExistingIndexNames(db, schema, idbtrans) {
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = 'getAll' in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === 'string' ? keyPath : "[" + $41ddcddbc48bb87d$var$slice(keyPath).join('+') + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $41ddcddbc48bb87d$var$_global.WorkerGlobalScope && $41ddcddbc48bb87d$var$_global instanceof $41ddcddbc48bb87d$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $41ddcddbc48bb87d$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(',').map(function(index, indexNum) {
        var _a;
        var typeSplit = index.split(':');
        var type = (_a = typeSplit[1]) === null || _a === void 0 ? void 0 : _a.trim();
        index = typeSplit[0].trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
        return $41ddcddbc48bb87d$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $41ddcddbc48bb87d$var$isArray(keyPath), indexNum === 0, type);
    });
}
var $41ddcddbc48bb87d$var$Version = function() {
    function Version() {}
    Version.prototype._createTableSchema = function(name, primKey, indexes) {
        return $41ddcddbc48bb87d$var$createTableSchema(name, primKey, indexes);
    };
    Version.prototype._parseIndexSyntax = function(primKeyAndIndexes) {
        return $41ddcddbc48bb87d$var$parseIndexSyntax(primKeyAndIndexes);
    };
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        var _this = this;
        $41ddcddbc48bb87d$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = _this._parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (!primKey) throw new $41ddcddbc48bb87d$var$exceptions.Schema('Invalid schema for table ' + tableName + ': ' + stores[tableName]);
                primKey.unique = true;
                if (primKey.multi) throw new $41ddcddbc48bb87d$var$exceptions.Schema('Primary key cannot be multiEntry*');
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $41ddcddbc48bb87d$var$exceptions.Schema('Only primary key can be marked as autoIncrement (++)');
                    if (!idx.keyPath) throw new $41ddcddbc48bb87d$var$exceptions.Schema('Index must have a name and cannot be an empty string');
                });
                var tblSchema = _this._createTableSchema(tableName, primKey, indexes);
                outSchema[tableName] = tblSchema;
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $41ddcddbc48bb87d$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $41ddcddbc48bb87d$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $41ddcddbc48bb87d$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $41ddcddbc48bb87d$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $41ddcddbc48bb87d$var$keys(dbschema), dbschema);
        db._storeNames = $41ddcddbc48bb87d$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $41ddcddbc48bb87d$var$promisableChain(this._cfg.contentUpgrade || $41ddcddbc48bb87d$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $41ddcddbc48bb87d$var$createVersionConstructor(db) {
    return $41ddcddbc48bb87d$var$makeClassConstructor($41ddcddbc48bb87d$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $41ddcddbc48bb87d$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $41ddcddbc48bb87d$export$4ece27d405df7279($41ddcddbc48bb87d$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $41ddcddbc48bb87d$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $41ddcddbc48bb87d$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $41ddcddbc48bb87d$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $41ddcddbc48bb87d$var$DBNAMES_DB;
        });
    }) : $41ddcddbc48bb87d$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $41ddcddbc48bb87d$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$41ddcddbc48bb87d$var$hasDatabasesNative(indexedDB1) && name !== $41ddcddbc48bb87d$var$DBNAMES_DB && $41ddcddbc48bb87d$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($41ddcddbc48bb87d$var$nop);
}
function $41ddcddbc48bb87d$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$41ddcddbc48bb87d$var$hasDatabasesNative(indexedDB1) && name !== $41ddcddbc48bb87d$var$DBNAMES_DB && $41ddcddbc48bb87d$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($41ddcddbc48bb87d$var$nop);
}
function $41ddcddbc48bb87d$var$vip(fn) {
    return $41ddcddbc48bb87d$var$newScope(function() {
        $41ddcddbc48bb87d$var$PSD.letThrough = true;
        return fn();
    });
}
function $41ddcddbc48bb87d$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var $41ddcddbc48bb87d$var$_a;
function $41ddcddbc48bb87d$var$isEmptyRange(node) {
    return !("from" in node);
}
var $41ddcddbc48bb87d$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $41ddcddbc48bb87d$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $41ddcddbc48bb87d$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $41ddcddbc48bb87d$var$extend(rv, fromOrTree);
        return rv;
    }
};
$41ddcddbc48bb87d$var$props($41ddcddbc48bb87d$export$34cb5241245008dd.prototype, ($41ddcddbc48bb87d$var$_a = {
    add: function(rangeSet) {
        $41ddcddbc48bb87d$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $41ddcddbc48bb87d$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $41ddcddbc48bb87d$var$addRange(_this, key, key);
        });
        return this;
    },
    hasKey: function(key) {
        var node = $41ddcddbc48bb87d$var$getRangeSetIterator(this).next(key).value;
        return node && $41ddcddbc48bb87d$export$6154dcdb7d23e37b(node.from, key) <= 0 && $41ddcddbc48bb87d$export$6154dcdb7d23e37b(node.to, key) >= 0;
    }
}, $41ddcddbc48bb87d$var$_a[$41ddcddbc48bb87d$var$iteratorSymbol] = function() {
    return $41ddcddbc48bb87d$var$getRangeSetIterator(this);
}, $41ddcddbc48bb87d$var$_a));
function $41ddcddbc48bb87d$var$addRange(target, from, to) {
    var diff = $41ddcddbc48bb87d$export$6154dcdb7d23e37b(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($41ddcddbc48bb87d$var$isEmptyRange(target)) return $41ddcddbc48bb87d$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(to, target.from) < 0) {
        left ? $41ddcddbc48bb87d$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $41ddcddbc48bb87d$var$rebalance(target);
    }
    if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(from, target.to) > 0) {
        right ? $41ddcddbc48bb87d$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $41ddcddbc48bb87d$var$rebalance(target);
    }
    if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $41ddcddbc48bb87d$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $41ddcddbc48bb87d$export$4876cc3130d3f820(target, right);
}
function $41ddcddbc48bb87d$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $41ddcddbc48bb87d$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$41ddcddbc48bb87d$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $41ddcddbc48bb87d$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $41ddcddbc48bb87d$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $41ddcddbc48bb87d$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(b.from, a.to) <= 0 && $41ddcddbc48bb87d$export$6154dcdb7d23e37b(b.to, a.from) >= 0) return true;
        $41ddcddbc48bb87d$export$6154dcdb7d23e37b(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $41ddcddbc48bb87d$var$getRangeSetIterator(node) {
    var state = $41ddcddbc48bb87d$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $41ddcddbc48bb87d$export$6154dcdb7d23e37b(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $41ddcddbc48bb87d$export$6154dcdb7d23e37b(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $41ddcddbc48bb87d$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $41ddcddbc48bb87d$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $41ddcddbc48bb87d$var$computeDepth(rootClone);
    }
    target.d = $41ddcddbc48bb87d$var$computeDepth(target);
}
function $41ddcddbc48bb87d$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
function $41ddcddbc48bb87d$var$extendObservabilitySet(target, newSet) {
    $41ddcddbc48bb87d$var$keys(newSet).forEach(function(part) {
        if (target[part]) $41ddcddbc48bb87d$export$4876cc3130d3f820(target[part], newSet[part]);
        else target[part] = $41ddcddbc48bb87d$var$cloneSimpleObjectTree(newSet[part]);
    });
    return target;
}
function $41ddcddbc48bb87d$var$obsSetsOverlap(os1, os2) {
    return os1.all || os2.all || Object.keys(os1).some(function(key) {
        return os2[key] && $41ddcddbc48bb87d$export$8f43b23b5d8de905(os2[key], os1[key]);
    });
}
var $41ddcddbc48bb87d$var$cache = {};
var $41ddcddbc48bb87d$var$unsignaledParts = {};
var $41ddcddbc48bb87d$var$isTaskEnqueued = false;
function $41ddcddbc48bb87d$var$signalSubscribersLazily(part, optimistic) {
    $41ddcddbc48bb87d$var$extendObservabilitySet($41ddcddbc48bb87d$var$unsignaledParts, part);
    if (!$41ddcddbc48bb87d$var$isTaskEnqueued) {
        $41ddcddbc48bb87d$var$isTaskEnqueued = true;
        setTimeout(function() {
            $41ddcddbc48bb87d$var$isTaskEnqueued = false;
            var parts = $41ddcddbc48bb87d$var$unsignaledParts;
            $41ddcddbc48bb87d$var$unsignaledParts = {};
            $41ddcddbc48bb87d$var$signalSubscribersNow(parts, false);
        }, 0);
    }
}
function $41ddcddbc48bb87d$var$signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
    if (deleteAffectedCacheEntries === void 0) deleteAffectedCacheEntries = false;
    var queriesToSignal = new Set();
    if (updatedParts.all) for(var _i = 0, _a = Object.values($41ddcddbc48bb87d$var$cache); _i < _a.length; _i++){
        var tblCache = _a[_i];
        $41ddcddbc48bb87d$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
    }
    else for(var key in updatedParts){
        var parts = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
        if (parts) {
            var dbName = parts[1], tableName = parts[2];
            var tblCache = $41ddcddbc48bb87d$var$cache["idb://".concat(dbName, "/").concat(tableName)];
            if (tblCache) $41ddcddbc48bb87d$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
        }
    }
    queriesToSignal.forEach(function(requery) {
        return requery();
    });
}
function $41ddcddbc48bb87d$var$collectTableSubscribers(tblCache, updatedParts, outQueriesToSignal, deleteAffectedCacheEntries) {
    var updatedEntryLists = [];
    for(var _i = 0, _a = Object.entries(tblCache.queries.query); _i < _a.length; _i++){
        var _b = _a[_i], indexName = _b[0], entries = _b[1];
        var filteredEntries = [];
        for(var _c = 0, entries_1 = entries; _c < entries_1.length; _c++){
            var entry = entries_1[_c];
            if ($41ddcddbc48bb87d$var$obsSetsOverlap(updatedParts, entry.obsSet)) entry.subscribers.forEach(function(requery) {
                return outQueriesToSignal.add(requery);
            });
            else if (deleteAffectedCacheEntries) filteredEntries.push(entry);
        }
        if (deleteAffectedCacheEntries) updatedEntryLists.push([
            indexName,
            filteredEntries
        ]);
    }
    if (deleteAffectedCacheEntries) for(var _d = 0, updatedEntryLists_1 = updatedEntryLists; _d < updatedEntryLists_1.length; _d++){
        var _e = updatedEntryLists_1[_d], indexName = _e[0], filteredEntries = _e[1];
        tblCache.queries.query[indexName] = filteredEntries;
    }
}
function $41ddcddbc48bb87d$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $41ddcddbc48bb87d$var$rejection(state.dbOpenError) : db;
    });
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    var nativeVerToOpen = Math.round(db.verno * 10);
    var schemaPatchMode = false;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed('db.open() was cancelled');
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $41ddcddbc48bb87d$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema || !nativeVerToOpen ? indexedDB1.open(dbName) : indexedDB1.open(dbName, nativeVerToOpen);
            if (!req) throw new $41ddcddbc48bb87d$var$exceptions.MissingAPI();
            req.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
            req.onblocked = $41ddcddbc48bb87d$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $41ddcddbc48bb87d$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $41ddcddbc48bb87d$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $41ddcddbc48bb87d$var$wrap(function() {
                        reject(new $41ddcddbc48bb87d$var$exceptions.NoSuchDatabase("Database ".concat(dbName, " doesnt exist")));
                    });
                } else {
                    upgradeTransaction.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db.idbdb = req.result;
                    if (schemaPatchMode) $41ddcddbc48bb87d$var$patchCurrentVersion(db, upgradeTransaction);
                    $41ddcddbc48bb87d$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $41ddcddbc48bb87d$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db.idbdb = req.result;
                var objectStoreNames = $41ddcddbc48bb87d$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($41ddcddbc48bb87d$var$safariMultiStoreFix(objectStoreNames), 'readonly');
                    if (state.autoSchema) $41ddcddbc48bb87d$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $41ddcddbc48bb87d$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$41ddcddbc48bb87d$var$verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                            console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.");
                            idbdb.close();
                            nativeVerToOpen = idbdb.version + 1;
                            schemaPatchMode = true;
                            return resolve(tryOpenDB());
                        }
                    }
                    $41ddcddbc48bb87d$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $41ddcddbc48bb87d$var$connections.push(db);
                idbdb.onversionchange = $41ddcddbc48bb87d$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $41ddcddbc48bb87d$var$wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) $41ddcddbc48bb87d$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            switch(err === null || err === void 0 ? void 0 : err.name){
                case "UnknownError":
                    if (state.PR1398_maxLoop > 0) {
                        state.PR1398_maxLoop--;
                        console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                        return tryOpenDB();
                    }
                    break;
                case "VersionError":
                    if (nativeVerToOpen > 0) {
                        nativeVerToOpen = 0;
                        return tryOpenDB();
                    }
                    break;
            }
            return $41ddcddbc48bb87d$var$DexiePromise.reject(err);
        });
    };
    return $41ddcddbc48bb87d$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === 'undefined' ? $41ddcddbc48bb87d$var$DexiePromise.resolve() : $41ddcddbc48bb87d$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $41ddcddbc48bb87d$var$DexiePromise.resolve($41ddcddbc48bb87d$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($41ddcddbc48bb87d$var$promisableChain, $41ddcddbc48bb87d$var$nop);
                state.onReadyBeingFired = [];
                return $41ddcddbc48bb87d$var$DexiePromise.resolve($41ddcddbc48bb87d$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        if (state.openCanceller === openCanceller) {
            state.onReadyBeingFired = null;
            state.isBeingOpened = false;
        }
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $41ddcddbc48bb87d$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    }).then(function() {
        if (wasCreated) {
            var everything_1 = {};
            db.tables.forEach(function(table) {
                table.schema.indexes.forEach(function(idx) {
                    if (idx.name) everything_1["idb://".concat(db.name, "/").concat(table.name, "/").concat(idx.name)] = new $41ddcddbc48bb87d$export$34cb5241245008dd(-Infinity, [
                        [
                            []
                        ]
                    ]);
                });
                everything_1["idb://".concat(db.name, "/").concat(table.name, "/")] = everything_1["idb://".concat(db.name, "/").concat(table.name, "/:dels")] = new $41ddcddbc48bb87d$export$34cb5241245008dd(-Infinity, [
                    [
                        []
                    ]
                ]);
            });
            $41ddcddbc48bb87d$var$globalEvents($41ddcddbc48bb87d$var$DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
            $41ddcddbc48bb87d$var$signalSubscribersNow(everything_1, true);
        }
        return db;
    });
}
function $41ddcddbc48bb87d$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? $41ddcddbc48bb87d$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $41ddcddbc48bb87d$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $41ddcddbc48bb87d$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $41ddcddbc48bb87d$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $41ddcddbc48bb87d$var$DexiePromise.resolve().then(function() {
        var transless = $41ddcddbc48bb87d$var$PSD.transless || $41ddcddbc48bb87d$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        trans.explicit = true;
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            trans.idbtrans._explicit = true;
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $41ddcddbc48bb87d$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $41ddcddbc48bb87d$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $41ddcddbc48bb87d$var$rejection(ex);
        }
        var scopeFuncIsAsync = $41ddcddbc48bb87d$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $41ddcddbc48bb87d$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $41ddcddbc48bb87d$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $41ddcddbc48bb87d$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') returnValue = $41ddcddbc48bb87d$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === 'function' ? $41ddcddbc48bb87d$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $41ddcddbc48bb87d$var$rejection(e);
        });
    });
}
function $41ddcddbc48bb87d$var$pad(a, value, count) {
    var result = $41ddcddbc48bb87d$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $41ddcddbc48bb87d$var$createVirtualIndexMiddleware(down) {
    return $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $41ddcddbc48bb87d$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, lowLevelIndex), {
                    name: isVirtual ? "".concat(keyPathAlias, "(virtual-from:").concat(lowLevelIndex.name, ")") : lowLevelIndex.name,
                    lowLevelIndex: lowLevelIndex,
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $41ddcddbc48bb87d$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$41ddcddbc48bb87d$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $41ddcddbc48bb87d$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $41ddcddbc48bb87d$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, req), {
                    query: {
                        index: index.lowLevelIndex,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, table), {
                schema: $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($41ddcddbc48bb87d$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($41ddcddbc48bb87d$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $41ddcddbc48bb87d$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $41ddcddbc48bb87d$var$createVirtualIndexMiddleware
};
function $41ddcddbc48bb87d$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || '';
    $41ddcddbc48bb87d$var$keys(a).forEach(function(prop) {
        if (!$41ddcddbc48bb87d$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === 'object' && typeof bp === 'object' && ap && bp) {
                var apTypeName = $41ddcddbc48bb87d$var$toStringTag(ap);
                var bpTypeName = $41ddcddbc48bb87d$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === 'Object') $41ddcddbc48bb87d$var$getObjectDiff(ap, bp, rv, prfx + prop + '.');
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $41ddcddbc48bb87d$var$keys(b).forEach(function(prop) {
        if (!$41ddcddbc48bb87d$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $41ddcddbc48bb87d$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === 'delete') return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $41ddcddbc48bb87d$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $41ddcddbc48bb87d$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case 'add':
                                if (creating.fire === $41ddcddbc48bb87d$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'put':
                                if (creating.fire === $41ddcddbc48bb87d$var$nop && updating.fire === $41ddcddbc48bb87d$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'delete':
                                if (deleting.fire === $41ddcddbc48bb87d$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'deleteRange':
                                if (deleting.fire === $41ddcddbc48bb87d$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $41ddcddbc48bb87d$var$PSD.trans;
                            var keys = req.keys || $41ddcddbc48bb87d$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, req), {
                                keys: keys
                            }) : $41ddcddbc48bb87d$var$__assign({}, req);
                            if (req.type !== 'delete') req.values = $41ddcddbc48bb87d$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $41ddcddbc48bb87d$var$__spreadArray([], req.keys, true);
                            return $41ddcddbc48bb87d$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === 'delete') deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $41ddcddbc48bb87d$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $41ddcddbc48bb87d$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($41ddcddbc48bb87d$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $41ddcddbc48bb87d$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: 'delete',
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $41ddcddbc48bb87d$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $41ddcddbc48bb87d$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $41ddcddbc48bb87d$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $41ddcddbc48bb87d$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $41ddcddbc48bb87d$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $41ddcddbc48bb87d$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $41ddcddbc48bb87d$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
function $41ddcddbc48bb87d$var$isCachableContext(ctx, table) {
    return ctx.trans.mode === 'readonly' && !!ctx.subscr && !ctx.trans.explicit && ctx.trans.db._options.cache !== 'disabled' && !table.schema.primaryKey.outbound;
}
function $41ddcddbc48bb87d$var$isCachableRequest(type, req) {
    switch(type){
        case 'query':
            return req.values && !req.unique;
        case 'get':
            return false;
        case 'getMany':
            return false;
        case 'count':
            return false;
        case 'openCursor':
            return false;
    }
}
var $41ddcddbc48bb87d$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Observability",
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $41ddcddbc48bb87d$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, core), {
            transaction: function(stores, mode, options) {
                if ($41ddcddbc48bb87d$var$PSD.subscr && mode !== 'readonly') throw new $41ddcddbc48bb87d$var$exceptions.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat($41ddcddbc48bb87d$var$PSD.querier));
                return core.transaction(stores, mode, options);
            },
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey, indexes = schema.indexes;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var indexesWithAutoIncPK = primaryKey.autoIncrement && indexes.filter(function(index) {
                    return index.compound && index.keyPath.includes(primaryKey.keyPath);
                });
                var tableClone = $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, table), {
                    mutate: function(req) {
                        var _a, _b;
                        var trans = req.trans;
                        var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                            return mutatedParts[part] || (mutatedParts[part] = new $41ddcddbc48bb87d$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _c = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            $41ddcddbc48bb87d$var$getEffectiveKeys(primaryKey, req).filter(function(id) {
                                return id;
                            }),
                            req.values
                        ] : [], keys = _c[0], newObjs = _c[1];
                        var oldCache = req.trans["_cache"];
                        if ($41ddcddbc48bb87d$var$isArray(keys)) {
                            pkRangeSet.addKeys(keys);
                            var oldObjs = type === 'delete' || keys.length === newObjs.length ? $41ddcddbc48bb87d$var$getFromTransactionCache(keys, oldCache) : null;
                            if (!oldObjs) delsRangeSet.addKeys(keys);
                            if (oldObjs || newObjs) $41ddcddbc48bb87d$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                        } else if (keys) {
                            var range = {
                                from: (_a = keys.lower) !== null && _a !== void 0 ? _a : core.MIN_KEY,
                                to: (_b = keys.upper) !== null && _b !== void 0 ? _b : core.MAX_KEY
                            };
                            delsRangeSet.add(range);
                            pkRangeSet.add(range);
                        } else {
                            pkRangeSet.add(FULL_RANGE);
                            delsRangeSet.add(FULL_RANGE);
                            schema.indexes.forEach(function(idx) {
                                return getRangeSet(idx.name).add(FULL_RANGE);
                            });
                        }
                        return table.mutate(req).then(function(res) {
                            if (keys && (req.type === 'add' || req.type === 'put')) {
                                pkRangeSet.addKeys(res.results);
                                if (indexesWithAutoIncPK) indexesWithAutoIncPK.forEach(function(idx) {
                                    var idxVals = req.values.map(function(v) {
                                        return idx.extractKey(v);
                                    });
                                    var pkPos = idx.keyPath.findIndex(function(prop) {
                                        return prop === primaryKey.keyPath;
                                    });
                                    for(var i = 0, len = res.results.length; i < len; ++i)idxVals[i][pkPos] = res.results[i];
                                    getRangeSet(idx.name).addKeys(idxVals);
                                });
                            }
                            trans.mutatedParts = $41ddcddbc48bb87d$var$extendObservabilitySet(trans.mutatedParts || {}, mutatedParts);
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $41ddcddbc48bb87d$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $41ddcddbc48bb87d$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $41ddcddbc48bb87d$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $41ddcddbc48bb87d$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $41ddcddbc48bb87d$var$PSD.subscr;
                        var isLiveQuery = !!subscr;
                        var cachable = $41ddcddbc48bb87d$var$isCachableContext($41ddcddbc48bb87d$var$PSD, table) && $41ddcddbc48bb87d$var$isCachableRequest(method, req);
                        var obsSet = cachable ? req.obsSet = {} : subscr;
                        if (isLiveQuery) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                return obsSet[part] || (obsSet[part] = new $41ddcddbc48bb87d$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            if (method === 'query' && queriedIndex.isPrimaryKey && !req.values) delsRangeSet_1.add(queriedRanges);
                            else getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $41ddcddbc48bb87d$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $41ddcddbc48bb87d$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($41ddcddbc48bb87d$export$6154dcdb7d23e37b(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
function $41ddcddbc48bb87d$var$adjustOptimisticFromFailures(tblCache, req, res) {
    if (res.numFailures === 0) return req;
    if (req.type === 'deleteRange') return null;
    var numBulkOps = req.keys ? req.keys.length : 'values' in req && req.values ? req.values.length : 1;
    if (res.numFailures === numBulkOps) return null;
    var clone = $41ddcddbc48bb87d$var$__assign({}, req);
    if ($41ddcddbc48bb87d$var$isArray(clone.keys)) clone.keys = clone.keys.filter(function(_, i) {
        return !(i in res.failures);
    });
    if ('values' in clone && $41ddcddbc48bb87d$var$isArray(clone.values)) clone.values = clone.values.filter(function(_, i) {
        return !(i in res.failures);
    });
    return clone;
}
function $41ddcddbc48bb87d$var$isAboveLower(key, range) {
    return range.lower === undefined ? true : range.lowerOpen ? $41ddcddbc48bb87d$export$6154dcdb7d23e37b(key, range.lower) > 0 : $41ddcddbc48bb87d$export$6154dcdb7d23e37b(key, range.lower) >= 0;
}
function $41ddcddbc48bb87d$var$isBelowUpper(key, range) {
    return range.upper === undefined ? true : range.upperOpen ? $41ddcddbc48bb87d$export$6154dcdb7d23e37b(key, range.upper) < 0 : $41ddcddbc48bb87d$export$6154dcdb7d23e37b(key, range.upper) <= 0;
}
function $41ddcddbc48bb87d$var$isWithinRange(key, range) {
    return $41ddcddbc48bb87d$var$isAboveLower(key, range) && $41ddcddbc48bb87d$var$isBelowUpper(key, range);
}
function $41ddcddbc48bb87d$var$applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
    if (!ops || ops.length === 0) return result;
    var index = req.query.index;
    var multiEntry = index.multiEntry;
    var queryRange = req.query.range;
    var primaryKey = table.schema.primaryKey;
    var extractPrimKey = primaryKey.extractKey;
    var extractIndex = index.extractKey;
    var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
    var finalResult = ops.reduce(function(result, op) {
        var modifedResult = result;
        var includedValues = [];
        if (op.type === 'add' || op.type === 'put') {
            var includedPKs = new $41ddcddbc48bb87d$export$34cb5241245008dd();
            for(var i = op.values.length - 1; i >= 0; --i){
                var value = op.values[i];
                var pk = extractPrimKey(value);
                if (includedPKs.hasKey(pk)) continue;
                var key = extractIndex(value);
                if (multiEntry && $41ddcddbc48bb87d$var$isArray(key) ? key.some(function(k) {
                    return $41ddcddbc48bb87d$var$isWithinRange(k, queryRange);
                }) : $41ddcddbc48bb87d$var$isWithinRange(key, queryRange)) {
                    includedPKs.addKey(pk);
                    includedValues.push(value);
                }
            }
        }
        switch(op.type){
            case 'add':
                var existingKeys_1 = new $41ddcddbc48bb87d$export$34cb5241245008dd().addKeys(req.values ? result.map(function(v) {
                    return extractPrimKey(v);
                }) : result);
                modifedResult = result.concat(req.values ? includedValues.filter(function(v) {
                    var key = extractPrimKey(v);
                    if (existingKeys_1.hasKey(key)) return false;
                    existingKeys_1.addKey(key);
                    return true;
                }) : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }).filter(function(k) {
                    if (existingKeys_1.hasKey(k)) return false;
                    existingKeys_1.addKey(k);
                    return true;
                }));
                break;
            case 'put':
                var keySet_1 = new $41ddcddbc48bb87d$export$34cb5241245008dd().addKeys(op.values.map(function(v) {
                    return extractPrimKey(v);
                }));
                modifedResult = result.filter(function(item) {
                    return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
                }).concat(req.values ? includedValues : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }));
                break;
            case 'delete':
                var keysToDelete_1 = new $41ddcddbc48bb87d$export$34cb5241245008dd().addKeys(op.keys);
                modifedResult = result.filter(function(item) {
                    return !keysToDelete_1.hasKey(req.values ? extractPrimKey(item) : item);
                });
                break;
            case 'deleteRange':
                var range_1 = op.range;
                modifedResult = result.filter(function(item) {
                    return !$41ddcddbc48bb87d$var$isWithinRange(extractPrimKey(item), range_1);
                });
                break;
        }
        return modifedResult;
    }, result);
    if (finalResult === result) return result;
    finalResult.sort(function(a, b) {
        return $41ddcddbc48bb87d$export$6154dcdb7d23e37b(extractLowLevelIndex(a), extractLowLevelIndex(b)) || $41ddcddbc48bb87d$export$6154dcdb7d23e37b(extractPrimKey(a), extractPrimKey(b));
    });
    if (req.limit && req.limit < Infinity) {
        if (finalResult.length > req.limit) finalResult.length = req.limit;
        else if (result.length === req.limit && finalResult.length < req.limit) cacheEntry.dirty = true;
    }
    return immutable ? Object.freeze(finalResult) : finalResult;
}
function $41ddcddbc48bb87d$var$areRangesEqual(r1, r2) {
    return $41ddcddbc48bb87d$export$6154dcdb7d23e37b(r1.lower, r2.lower) === 0 && $41ddcddbc48bb87d$export$6154dcdb7d23e37b(r1.upper, r2.upper) === 0 && !!r1.lowerOpen === !!r2.lowerOpen && !!r1.upperOpen === !!r2.upperOpen;
}
function $41ddcddbc48bb87d$var$compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
    if (lower1 === undefined) return lower2 !== undefined ? -1 : 0;
    if (lower2 === undefined) return 1;
    var c = $41ddcddbc48bb87d$export$6154dcdb7d23e37b(lower1, lower2);
    if (c === 0) {
        if (lowerOpen1 && lowerOpen2) return 0;
        if (lowerOpen1) return 1;
        if (lowerOpen2) return -1;
    }
    return c;
}
function $41ddcddbc48bb87d$var$compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
    if (upper1 === undefined) return upper2 !== undefined ? 1 : 0;
    if (upper2 === undefined) return -1;
    var c = $41ddcddbc48bb87d$export$6154dcdb7d23e37b(upper1, upper2);
    if (c === 0) {
        if (upperOpen1 && upperOpen2) return 0;
        if (upperOpen1) return -1;
        if (upperOpen2) return 1;
    }
    return c;
}
function $41ddcddbc48bb87d$var$isSuperRange(r1, r2) {
    return $41ddcddbc48bb87d$var$compareLowers(r1.lower, r2.lower, r1.lowerOpen, r2.lowerOpen) <= 0 && $41ddcddbc48bb87d$var$compareUppers(r1.upper, r2.upper, r1.upperOpen, r2.upperOpen) >= 0;
}
function $41ddcddbc48bb87d$var$findCompatibleQuery(dbName, tableName, type, req) {
    var tblCache = $41ddcddbc48bb87d$var$cache["idb://".concat(dbName, "/").concat(tableName)];
    if (!tblCache) return [];
    var queries = tblCache.queries[type];
    if (!queries) return [
        null,
        false,
        tblCache,
        null
    ];
    var indexName = req.query ? req.query.index.name : null;
    var entries = queries[indexName || ''];
    if (!entries) return [
        null,
        false,
        tblCache,
        null
    ];
    switch(type){
        case 'query':
            var equalEntry = entries.find(function(entry) {
                return entry.req.limit === req.limit && entry.req.values === req.values && $41ddcddbc48bb87d$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            if (equalEntry) return [
                equalEntry,
                true,
                tblCache,
                entries
            ];
            var superEntry = entries.find(function(entry) {
                var limit = 'limit' in entry.req ? entry.req.limit : Infinity;
                return limit >= req.limit && (req.values ? entry.req.values : true) && $41ddcddbc48bb87d$var$isSuperRange(entry.req.query.range, req.query.range);
            });
            return [
                superEntry,
                false,
                tblCache,
                entries
            ];
        case 'count':
            var countQuery = entries.find(function(entry) {
                return $41ddcddbc48bb87d$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            return [
                countQuery,
                !!countQuery,
                tblCache,
                entries
            ];
    }
}
function $41ddcddbc48bb87d$var$subscribeToCacheEntry(cacheEntry, container, requery, signal) {
    cacheEntry.subscribers.add(requery);
    signal.addEventListener("abort", function() {
        cacheEntry.subscribers.delete(requery);
        if (cacheEntry.subscribers.size === 0) $41ddcddbc48bb87d$var$enqueForDeletion(cacheEntry, container);
    });
}
function $41ddcddbc48bb87d$var$enqueForDeletion(cacheEntry, container) {
    setTimeout(function() {
        if (cacheEntry.subscribers.size === 0) $41ddcddbc48bb87d$var$delArrayItem(container, cacheEntry);
    }, 3000);
}
var $41ddcddbc48bb87d$var$cacheMiddleware = {
    stack: 'dbcore',
    level: 0,
    name: 'Cache',
    create: function(core) {
        var dbName = core.schema.name;
        var coreMW = $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, core), {
            transaction: function(stores, mode, options) {
                var idbtrans = core.transaction(stores, mode, options);
                if (mode === 'readwrite') {
                    var ac_1 = new AbortController();
                    var signal = ac_1.signal;
                    var endTransaction = function(wasCommitted) {
                        return function() {
                            ac_1.abort();
                            if (mode === 'readwrite') {
                                var affectedSubscribers_1 = new Set();
                                for(var _i = 0, stores_1 = stores; _i < stores_1.length; _i++){
                                    var storeName = stores_1[_i];
                                    var tblCache = $41ddcddbc48bb87d$var$cache["idb://".concat(dbName, "/").concat(storeName)];
                                    if (tblCache) {
                                        var table = core.table(storeName);
                                        var ops = tblCache.optimisticOps.filter(function(op) {
                                            return op.trans === idbtrans;
                                        });
                                        if (idbtrans._explicit && wasCommitted && idbtrans.mutatedParts) for(var _a = 0, _b = Object.values(tblCache.queries.query); _a < _b.length; _a++){
                                            var entries = _b[_a];
                                            for(var _c = 0, _d = entries.slice(); _c < _d.length; _c++){
                                                var entry = _d[_c];
                                                if ($41ddcddbc48bb87d$var$obsSetsOverlap(entry.obsSet, idbtrans.mutatedParts)) {
                                                    $41ddcddbc48bb87d$var$delArrayItem(entries, entry);
                                                    entry.subscribers.forEach(function(requery) {
                                                        return affectedSubscribers_1.add(requery);
                                                    });
                                                }
                                            }
                                        }
                                        else if (ops.length > 0) {
                                            tblCache.optimisticOps = tblCache.optimisticOps.filter(function(op) {
                                                return op.trans !== idbtrans;
                                            });
                                            for(var _e = 0, _f = Object.values(tblCache.queries.query); _e < _f.length; _e++){
                                                var entries = _f[_e];
                                                for(var _g = 0, _h = entries.slice(); _g < _h.length; _g++){
                                                    var entry = _h[_g];
                                                    if (entry.res != null && idbtrans.mutatedParts) {
                                                        if (wasCommitted && !entry.dirty) {
                                                            var freezeResults = Object.isFrozen(entry.res);
                                                            var modRes = $41ddcddbc48bb87d$var$applyOptimisticOps(entry.res, entry.req, ops, table, entry, freezeResults);
                                                            if (entry.dirty) {
                                                                $41ddcddbc48bb87d$var$delArrayItem(entries, entry);
                                                                entry.subscribers.forEach(function(requery) {
                                                                    return affectedSubscribers_1.add(requery);
                                                                });
                                                            } else if (modRes !== entry.res) {
                                                                entry.res = modRes;
                                                                entry.promise = $41ddcddbc48bb87d$var$DexiePromise.resolve({
                                                                    result: modRes
                                                                });
                                                            }
                                                        } else {
                                                            if (entry.dirty) $41ddcddbc48bb87d$var$delArrayItem(entries, entry);
                                                            entry.subscribers.forEach(function(requery) {
                                                                return affectedSubscribers_1.add(requery);
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                affectedSubscribers_1.forEach(function(requery) {
                                    return requery();
                                });
                            }
                        };
                    };
                    idbtrans.addEventListener('abort', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('error', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('complete', endTransaction(true), {
                        signal: signal
                    });
                }
                return idbtrans;
            },
            table: function(tableName) {
                var downTable = core.table(tableName);
                var primKey = downTable.schema.primaryKey;
                var tableMW = $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var trans = $41ddcddbc48bb87d$var$PSD.trans;
                        if (primKey.outbound || trans.db._options.cache === 'disabled' || trans.explicit || trans.idbtrans.mode !== 'readwrite') return downTable.mutate(req);
                        var tblCache = $41ddcddbc48bb87d$var$cache["idb://".concat(dbName, "/").concat(tableName)];
                        if (!tblCache) return downTable.mutate(req);
                        var promise = downTable.mutate(req);
                        if ((req.type === 'add' || req.type === 'put') && (req.values.length >= 50 || $41ddcddbc48bb87d$var$getEffectiveKeys(primKey, req).some(function(key) {
                            return key == null;
                        }))) promise.then(function(res) {
                            var reqWithResolvedKeys = $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, req), {
                                values: req.values.map(function(value, i) {
                                    var _a;
                                    if (res.failures[i]) return value;
                                    var valueWithKey = ((_a = primKey.keyPath) === null || _a === void 0 ? void 0 : _a.includes('.')) ? $41ddcddbc48bb87d$var$deepClone(value) : $41ddcddbc48bb87d$var$__assign({}, value);
                                    $41ddcddbc48bb87d$var$setByKeyPath(valueWithKey, primKey.keyPath, res.results[i]);
                                    return valueWithKey;
                                })
                            });
                            var adjustedReq = $41ddcddbc48bb87d$var$adjustOptimisticFromFailures(tblCache, reqWithResolvedKeys, res);
                            tblCache.optimisticOps.push(adjustedReq);
                            queueMicrotask(function() {
                                return req.mutatedParts && $41ddcddbc48bb87d$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        });
                        else {
                            tblCache.optimisticOps.push(req);
                            req.mutatedParts && $41ddcddbc48bb87d$var$signalSubscribersLazily(req.mutatedParts);
                            promise.then(function(res) {
                                if (res.numFailures > 0) {
                                    $41ddcddbc48bb87d$var$delArrayItem(tblCache.optimisticOps, req);
                                    var adjustedReq = $41ddcddbc48bb87d$var$adjustOptimisticFromFailures(tblCache, req, res);
                                    if (adjustedReq) tblCache.optimisticOps.push(adjustedReq);
                                    req.mutatedParts && $41ddcddbc48bb87d$var$signalSubscribersLazily(req.mutatedParts);
                                }
                            });
                            promise.catch(function() {
                                $41ddcddbc48bb87d$var$delArrayItem(tblCache.optimisticOps, req);
                                req.mutatedParts && $41ddcddbc48bb87d$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        }
                        return promise;
                    },
                    query: function(req) {
                        var _a;
                        if (!$41ddcddbc48bb87d$var$isCachableContext($41ddcddbc48bb87d$var$PSD, downTable) || !$41ddcddbc48bb87d$var$isCachableRequest("query", req)) return downTable.query(req);
                        var freezeResults = ((_a = $41ddcddbc48bb87d$var$PSD.trans) === null || _a === void 0 ? void 0 : _a.db._options.cache) === 'immutable';
                        var _b = $41ddcddbc48bb87d$var$PSD, requery = _b.requery, signal = _b.signal;
                        var _c = $41ddcddbc48bb87d$var$findCompatibleQuery(dbName, tableName, 'query', req), cacheEntry = _c[0], exactMatch = _c[1], tblCache = _c[2], container = _c[3];
                        if (cacheEntry && exactMatch) cacheEntry.obsSet = req.obsSet;
                        else {
                            var promise = downTable.query(req).then(function(res) {
                                var result = res.result;
                                if (cacheEntry) cacheEntry.res = result;
                                if (freezeResults) {
                                    for(var i = 0, l = result.length; i < l; ++i)Object.freeze(result[i]);
                                    Object.freeze(result);
                                } else res.result = $41ddcddbc48bb87d$var$deepClone(result);
                                return res;
                            }).catch(function(error) {
                                if (container && cacheEntry) $41ddcddbc48bb87d$var$delArrayItem(container, cacheEntry);
                                return Promise.reject(error);
                            });
                            cacheEntry = {
                                obsSet: req.obsSet,
                                promise: promise,
                                subscribers: new Set(),
                                type: 'query',
                                req: req,
                                dirty: false
                            };
                            if (container) container.push(cacheEntry);
                            else {
                                container = [
                                    cacheEntry
                                ];
                                if (!tblCache) tblCache = $41ddcddbc48bb87d$var$cache["idb://".concat(dbName, "/").concat(tableName)] = {
                                    queries: {
                                        query: {},
                                        count: {}
                                    },
                                    objs: new Map(),
                                    optimisticOps: [],
                                    unsignaledParts: {}
                                };
                                tblCache.queries.query[req.query.index.name || ''] = container;
                            }
                        }
                        $41ddcddbc48bb87d$var$subscribeToCacheEntry(cacheEntry, container, requery, signal);
                        return cacheEntry.promise.then(function(res) {
                            return {
                                result: $41ddcddbc48bb87d$var$applyOptimisticOps(res.result, req, tblCache === null || tblCache === void 0 ? void 0 : tblCache.optimisticOps, downTable, cacheEntry, freezeResults)
                            };
                        });
                    }
                });
                return tableMW;
            }
        });
        return coreMW;
    }
};
function $41ddcddbc48bb87d$var$vipify(target, vipDb) {
    return new Proxy(target, {
        get: function(target, prop, receiver) {
            if (prop === 'db') return vipDb;
            return Reflect.get(target, prop, receiver);
        }
    });
}
var $41ddcddbc48bb87d$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $41ddcddbc48bb87d$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange,
            cache: 'cloned'
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $41ddcddbc48bb87d$var$nop,
            dbReadyPromise: null,
            cancelOpen: $41ddcddbc48bb87d$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3,
            autoOpen: options.autoOpen
        };
        state.dbReadyPromise = new $41ddcddbc48bb87d$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $41ddcddbc48bb87d$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $41ddcddbc48bb87d$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $41ddcddbc48bb87d$var$promisableChain,
                $41ddcddbc48bb87d$var$nop
            ]
        });
        this.once = function(event, callback) {
            var fn = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this.on(event).unsubscribe(fn);
                callback.apply(_this, args);
            };
            return _this.on(event, fn);
        };
        this.on.ready.subscribe = $41ddcddbc48bb87d$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $41ddcddbc48bb87d$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $41ddcddbc48bb87d$var$createCollectionConstructor(this);
        this.Table = $41ddcddbc48bb87d$var$createTableConstructor(this);
        this.Transaction = $41ddcddbc48bb87d$var$createTransactionConstructor(this);
        this.Version = $41ddcddbc48bb87d$var$createVersionConstructor(this);
        this.WhereClause = $41ddcddbc48bb87d$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '".concat(_this.name, "'. Closing db now to resume the upgrade."));
            else console.warn("Another connection wants to delete database '".concat(_this.name, "'. Closing db now to resume the delete request."));
            _this.close({
                disableAutoOpen: false
            });
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
            else console.warn("Upgrade '".concat(_this.name, "' blocked by other connection holding version ").concat(ev.oldVersion / 10));
        });
        this._maxKey = $41ddcddbc48bb87d$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $41ddcddbc48bb87d$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($41ddcddbc48bb87d$var$cacheExistingValuesMiddleware);
        this.use($41ddcddbc48bb87d$var$cacheMiddleware);
        this.use($41ddcddbc48bb87d$var$observabilityMiddleware);
        this.use($41ddcddbc48bb87d$var$virtualIndexMiddleware);
        this.use($41ddcddbc48bb87d$var$hooksMiddleware);
        var vipDB = new Proxy(this, {
            get: function(_, prop, receiver) {
                if (prop === '_vip') return true;
                if (prop === 'table') return function(tableName) {
                    return $41ddcddbc48bb87d$var$vipify(_this.table(tableName), vipDB);
                };
                var rv = Reflect.get(_, prop, receiver);
                if (rv instanceof $41ddcddbc48bb87d$var$Table) return $41ddcddbc48bb87d$var$vipify(rv, vipDB);
                if (prop === 'tables') return rv.map(function(t) {
                    return $41ddcddbc48bb87d$var$vipify(t, vipDB);
                });
                if (prop === '_createTransaction') return function() {
                    var tx = rv.apply(this, arguments);
                    return $41ddcddbc48bb87d$var$vipify(tx, vipDB);
                };
                return rv;
            }
        });
        this.vip = vipDB;
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $41ddcddbc48bb87d$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $41ddcddbc48bb87d$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($41ddcddbc48bb87d$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $41ddcddbc48bb87d$var$PSD.letThrough || this._vip) ? fn() : new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._state.autoOpen) {
                    reject(new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($41ddcddbc48bb87d$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        var _this = this;
        return $41ddcddbc48bb87d$var$usePSD($41ddcddbc48bb87d$var$globalPSD, function() {
            return $41ddcddbc48bb87d$var$dexieOpen(_this);
        });
    };
    Dexie.prototype._close = function() {
        this.on.close.fire(new CustomEvent('close'));
        var state = this._state;
        var idx = $41ddcddbc48bb87d$var$connections.indexOf(this);
        if (idx >= 0) $41ddcddbc48bb87d$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        if (!state.isBeingOpened) {
            state.dbReadyPromise = new $41ddcddbc48bb87d$var$DexiePromise(function(resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new $41ddcddbc48bb87d$var$DexiePromise(function(_, reject) {
                state.cancelOpen = reject;
            });
        }
    };
    Dexie.prototype.close = function(_a) {
        var _b = _a === void 0 ? {
            disableAutoOpen: true
        } : _a, disableAutoOpen = _b.disableAutoOpen;
        var state = this._state;
        if (disableAutoOpen) {
            if (state.isBeingOpened) state.cancelOpen(new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed());
            this._close();
            state.autoOpen = false;
            state.dbOpenError = new $41ddcddbc48bb87d$var$exceptions.DatabaseClosed();
        } else {
            this._close();
            state.autoOpen = this._options.autoOpen || state.isBeingOpened;
            state.openComplete = false;
            state.dbOpenError = null;
        }
    };
    Dexie.prototype.delete = function(closeOptions) {
        var _this = this;
        if (closeOptions === void 0) closeOptions = {
            disableAutoOpen: true
        };
        var hasInvalidArguments = arguments.length > 0 && typeof arguments[0] !== 'object';
        var state = this._state;
        return new $41ddcddbc48bb87d$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close(closeOptions);
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $41ddcddbc48bb87d$var$wrap(function() {
                    $41ddcddbc48bb87d$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $41ddcddbc48bb87d$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasInvalidArguments) throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("Invalid closeOptions argument to db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === 'DatabaseClosed';
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $41ddcddbc48bb87d$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $41ddcddbc48bb87d$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $41ddcddbc48bb87d$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', '');
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $41ddcddbc48bb87d$var$READONLY) idbMode = $41ddcddbc48bb87d$var$READONLY;
            else if (mode == "rw" || mode == $41ddcddbc48bb87d$var$READWRITE) idbMode = $41ddcddbc48bb87d$var$READWRITE;
            else throw new $41ddcddbc48bb87d$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $41ddcddbc48bb87d$var$READONLY && idbMode === $41ddcddbc48bb87d$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $41ddcddbc48bb87d$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $41ddcddbc48bb87d$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $41ddcddbc48bb87d$var$rejection(e);
        }
        var enterTransaction = $41ddcddbc48bb87d$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $41ddcddbc48bb87d$var$PSD.trans ? $41ddcddbc48bb87d$var$usePSD($41ddcddbc48bb87d$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$41ddcddbc48bb87d$var$hasOwn(this._allTables, tableName)) throw new $41ddcddbc48bb87d$var$exceptions.InvalidTable("Table ".concat(tableName, " does not exist"));
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $41ddcddbc48bb87d$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $41ddcddbc48bb87d$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$41ddcddbc48bb87d$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
var $41ddcddbc48bb87d$var$domDeps;
try {
    $41ddcddbc48bb87d$var$domDeps = {
        indexedDB: $41ddcddbc48bb87d$var$_global.indexedDB || $41ddcddbc48bb87d$var$_global.mozIndexedDB || $41ddcddbc48bb87d$var$_global.webkitIndexedDB || $41ddcddbc48bb87d$var$_global.msIndexedDB,
        IDBKeyRange: $41ddcddbc48bb87d$var$_global.IDBKeyRange || $41ddcddbc48bb87d$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $41ddcddbc48bb87d$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
function $41ddcddbc48bb87d$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue;
    var observable = new $41ddcddbc48bb87d$var$Observable(function(observer) {
        var scopeFuncIsAsync = $41ddcddbc48bb87d$var$isAsyncFunction(querier);
        function execute(ctx) {
            var wasRootExec = $41ddcddbc48bb87d$var$beginMicroTickScope();
            try {
                if (scopeFuncIsAsync) $41ddcddbc48bb87d$var$incrementExpectedAwaits();
                var rv = $41ddcddbc48bb87d$var$newScope(querier, ctx);
                if (scopeFuncIsAsync) rv = rv.finally($41ddcddbc48bb87d$var$decrementExpectedAwaits);
                return rv;
            } finally{
                wasRootExec && $41ddcddbc48bb87d$var$endMicroTickScope();
            }
        }
        var closed = false;
        var abortController;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                if (closed) return;
                closed = true;
                if (abortController) abortController.abort();
                if (startedListening) $41ddcddbc48bb87d$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var startedListening = false;
        var doQuery = function() {
            return $41ddcddbc48bb87d$var$execInGlobalContext(_doQuery);
        };
        function shouldNotify() {
            return $41ddcddbc48bb87d$var$obsSetsOverlap(currentObs, accumMuts);
        }
        var mutationListener = function(parts) {
            $41ddcddbc48bb87d$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var _doQuery = function() {
            if (closed || !$41ddcddbc48bb87d$var$domDeps.indexedDB) return;
            accumMuts = {};
            var subscr = {};
            if (abortController) abortController.abort();
            abortController = new AbortController();
            var ctx = {
                subscr: subscr,
                signal: abortController.signal,
                requery: doQuery,
                querier: querier,
                trans: null
            };
            var ret = execute(ctx);
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                if (closed || ctx.signal.aborted) return;
                accumMuts = {};
                currentObs = subscr;
                if (!$41ddcddbc48bb87d$var$objectIsEmpty(currentObs) && !startedListening) {
                    $41ddcddbc48bb87d$var$globalEvents($41ddcddbc48bb87d$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                    startedListening = true;
                }
                $41ddcddbc48bb87d$var$execInGlobalContext(function() {
                    return !closed && observer.next && observer.next(result);
                });
            }, function(err) {
                hasValue = false;
                if (![
                    'DatabaseClosedError',
                    'AbortError'
                ].includes(err === null || err === void 0 ? void 0 : err.name)) {
                    if (!closed) $41ddcddbc48bb87d$var$execInGlobalContext(function() {
                        if (closed) return;
                        observer.error && observer.error(err);
                    });
                }
            });
        };
        setTimeout(doQuery, 0);
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $41ddcddbc48bb87d$var$Dexie = $41ddcddbc48bb87d$export$4ece27d405df7279;
$41ddcddbc48bb87d$var$props($41ddcddbc48bb87d$var$Dexie, $41ddcddbc48bb87d$var$__assign($41ddcddbc48bb87d$var$__assign({}, $41ddcddbc48bb87d$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $41ddcddbc48bb87d$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $41ddcddbc48bb87d$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch('NoSuchDatabaseError', function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $41ddcddbc48bb87d$var$getDatabaseNames($41ddcddbc48bb87d$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $41ddcddbc48bb87d$var$rejection(new $41ddcddbc48bb87d$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $41ddcddbc48bb87d$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $41ddcddbc48bb87d$var$PSD.trans ? $41ddcddbc48bb87d$var$usePSD($41ddcddbc48bb87d$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $41ddcddbc48bb87d$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $41ddcddbc48bb87d$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return $41ddcddbc48bb87d$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $41ddcddbc48bb87d$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $41ddcddbc48bb87d$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return $41ddcddbc48bb87d$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $41ddcddbc48bb87d$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $41ddcddbc48bb87d$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $41ddcddbc48bb87d$var$DexiePromise.resolve(typeof promiseOrFunction === 'function' ? $41ddcddbc48bb87d$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $41ddcddbc48bb87d$var$PSD.trans ? $41ddcddbc48bb87d$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $41ddcddbc48bb87d$var$DexiePromise,
    debug: {
        get: function() {
            return $41ddcddbc48bb87d$var$debug;
        },
        set: function(value) {
            $41ddcddbc48bb87d$var$setDebug(value);
        }
    },
    derive: $41ddcddbc48bb87d$var$derive,
    extend: $41ddcddbc48bb87d$var$extend,
    props: $41ddcddbc48bb87d$var$props,
    override: $41ddcddbc48bb87d$var$override,
    Events: $41ddcddbc48bb87d$var$Events,
    on: $41ddcddbc48bb87d$var$globalEvents,
    liveQuery: $41ddcddbc48bb87d$export$6a9705d8f6f38796,
    extendObservabilitySet: $41ddcddbc48bb87d$var$extendObservabilitySet,
    getByKeyPath: $41ddcddbc48bb87d$var$getByKeyPath,
    setByKeyPath: $41ddcddbc48bb87d$var$setByKeyPath,
    delByKeyPath: $41ddcddbc48bb87d$var$delByKeyPath,
    shallowClone: $41ddcddbc48bb87d$var$shallowClone,
    deepClone: $41ddcddbc48bb87d$var$deepClone,
    getObjectDiff: $41ddcddbc48bb87d$var$getObjectDiff,
    cmp: $41ddcddbc48bb87d$export$6154dcdb7d23e37b,
    asap: $41ddcddbc48bb87d$var$asap$1,
    minKey: $41ddcddbc48bb87d$var$minKey,
    addons: [],
    connections: $41ddcddbc48bb87d$var$connections,
    errnames: $41ddcddbc48bb87d$var$errnames,
    dependencies: $41ddcddbc48bb87d$var$domDeps,
    cache: $41ddcddbc48bb87d$var$cache,
    semVer: $41ddcddbc48bb87d$var$DEXIE_VERSION,
    version: $41ddcddbc48bb87d$var$DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$41ddcddbc48bb87d$var$Dexie.maxKey = $41ddcddbc48bb87d$var$getMaxKey($41ddcddbc48bb87d$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
    $41ddcddbc48bb87d$var$globalEvents($41ddcddbc48bb87d$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$41ddcddbc48bb87d$var$propagatingLocally) {
            var event_1;
            event_1 = new CustomEvent($41ddcddbc48bb87d$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $41ddcddbc48bb87d$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $41ddcddbc48bb87d$var$propagatingLocally = false;
        }
    });
    addEventListener($41ddcddbc48bb87d$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$41ddcddbc48bb87d$var$propagatingLocally) $41ddcddbc48bb87d$var$propagateLocally(detail);
    });
}
function $41ddcddbc48bb87d$var$propagateLocally(updateParts) {
    var wasMe = $41ddcddbc48bb87d$var$propagatingLocally;
    try {
        $41ddcddbc48bb87d$var$propagatingLocally = true;
        $41ddcddbc48bb87d$var$globalEvents.storagemutated.fire(updateParts);
        $41ddcddbc48bb87d$var$signalSubscribersNow(updateParts, true);
    } finally{
        $41ddcddbc48bb87d$var$propagatingLocally = wasMe;
    }
}
var $41ddcddbc48bb87d$var$propagatingLocally = false;
var $41ddcddbc48bb87d$var$bc;
var $41ddcddbc48bb87d$var$createBC = function() {};
if (typeof BroadcastChannel !== 'undefined') {
    $41ddcddbc48bb87d$var$createBC = function() {
        $41ddcddbc48bb87d$var$bc = new BroadcastChannel($41ddcddbc48bb87d$var$STORAGE_MUTATED_DOM_EVENT_NAME);
        $41ddcddbc48bb87d$var$bc.onmessage = function(ev) {
            return ev.data && $41ddcddbc48bb87d$var$propagateLocally(ev.data);
        };
    };
    $41ddcddbc48bb87d$var$createBC();
    if (typeof $41ddcddbc48bb87d$var$bc.unref === 'function') $41ddcddbc48bb87d$var$bc.unref();
    $41ddcddbc48bb87d$var$globalEvents($41ddcddbc48bb87d$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$41ddcddbc48bb87d$var$propagatingLocally) $41ddcddbc48bb87d$var$bc.postMessage(changedParts);
    });
}
if (typeof addEventListener !== 'undefined') {
    addEventListener('pagehide', function(event) {
        if (!$41ddcddbc48bb87d$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($41ddcddbc48bb87d$var$debug) console.debug('Dexie: handling persisted pagehide');
            $41ddcddbc48bb87d$var$bc === null || $41ddcddbc48bb87d$var$bc === void 0 || $41ddcddbc48bb87d$var$bc.close();
            for(var _i = 0, connections_1 = $41ddcddbc48bb87d$var$connections; _i < connections_1.length; _i++){
                var db = connections_1[_i];
                db.close({
                    disableAutoOpen: false
                });
            }
        }
    });
    addEventListener('pageshow', function(event) {
        if (!$41ddcddbc48bb87d$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($41ddcddbc48bb87d$var$debug) console.debug('Dexie: handling persisted pageshow');
            $41ddcddbc48bb87d$var$createBC();
            $41ddcddbc48bb87d$var$propagateLocally({
                all: new $41ddcddbc48bb87d$export$34cb5241245008dd(-Infinity, [
                    []
                ])
            });
        }
    });
}
function $41ddcddbc48bb87d$export$e16d8520af44a096(value) {
    return new $41ddcddbc48bb87d$export$4118fdb20badc28d({
        add: value
    });
}
function $41ddcddbc48bb87d$export$cd7f480d6b8286c3(value) {
    return new $41ddcddbc48bb87d$export$4118fdb20badc28d({
        remove: value
    });
}
function $41ddcddbc48bb87d$export$22ef8700548ec20(a, b) {
    return new $41ddcddbc48bb87d$export$4118fdb20badc28d({
        replacePrefix: [
            a,
            b
        ]
    });
}
$41ddcddbc48bb87d$var$DexiePromise.rejectionMapper = $41ddcddbc48bb87d$var$mapError;
$41ddcddbc48bb87d$var$setDebug($41ddcddbc48bb87d$var$debug);


class $fc6713b144381258$export$c91d04c0fa74c77 extends (0, $41ddcddbc48bb87d$export$4ece27d405df7279) {
    constructor(name, options){
        super(name, options), this.name = "xeroconv-db";
        this.version(1).stores({
            files: '++id, name, checked, checksum',
            stats: '++, fileid',
            units: '++, fileid',
            shots: '++, fileid, shotnumber'
        });
    }
}
function $fc6713b144381258$export$31ba1aa1956e5261(name = 'xeroconv-db', options) {
    return new $fc6713b144381258$export$c91d04c0fa74c77(name, options);
} /*export function createXeroConvDB(opts?: { indexedDB?: IDBFactory; IDBKeyRange?: any; name?: string }) {
    const { indexedDB, IDBKeyRange, name = "xeroconv-db" } = opts || {};
    const db = new Dexie(name, { indexedDB, IDBKeyRange });
  
    if (IDBKeyRange) (Dexie as any).dependencies.IDBKeyRange = IDBKeyRange;
  
    db.version(1).stores({
        files: '++id, name',
        stats: '++id, fileid',
        units: '++id, fileid',
        shots: '++id, fileid, shotnumber'
    });

    return db as Dexie & {
        files: EntityTable<FileInfoEntry, 'id'>;
        stats: EntityTable<SessionStatsEntry, 'id'>;
        units: EntityTable<SessionUnitsEntry, 'id'>;
        shots: EntityTable<ShotEntry, 'id'>;
    };
}

// Optional shared singleton (lazy)
let _shared: ReturnType<typeof createXeroConvDB> | null = null;
export function getXeroConvDB() {
  if (!_shared) _shared = createXeroConvDB();
  return _shared;
}*/ 


const $8c181515f0907a6d$var$db = new (0, $fc6713b144381258$export$c91d04c0fa74c77)();
var /*export async function nameddb(name: string, indexedDB?: DexieOptions["indexedDB"], IDBKeyRange?: DexieOptions["IDBKeyRange"]):Promise<Dexie> {
    return new AppDB(name, indexedDB, IDBKeyRange)
}*/ $8c181515f0907a6d$export$2e2bcd8739ae039 = $8c181515f0907a6d$var$db;


/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
const $4883ab303b017428$var$crcTable = [
    0x0000,
    0xCC01,
    0xD801,
    0x1400,
    0xF001,
    0x3C00,
    0x2800,
    0xE401,
    0xA001,
    0x6C00,
    0x7800,
    0xB401,
    0x5000,
    0x9C01,
    0x8801,
    0x4400
];
class $4883ab303b017428$var$CrcCalculator {
    #crc = 0;
    constructor(){}
    get crc() {
        return this.#crc;
    }
    #updateCRC(value) {
        // compute checksum of lower four bits of byte
        let tmp = $4883ab303b017428$var$crcTable[this.#crc & 0xF];
        this.#crc = this.#crc >> 4 & 0x0FFF;
        this.#crc = this.#crc ^ tmp ^ $4883ab303b017428$var$crcTable[value & 0xF];
        // compute checksum of upper four bits of byte
        tmp = $4883ab303b017428$var$crcTable[this.#crc & 0xF];
        this.#crc = this.#crc >> 4 & 0x0FFF;
        this.#crc = this.#crc ^ tmp ^ $4883ab303b017428$var$crcTable[value >> 4 & 0xF];
        return this.#crc;
    }
    addBytes(buf, start, end) {
        for(let i = start; i < end; i++)this.#crc = this.#updateCRC(buf[i]);
        return this.#crc;
    }
    static calculateCRC(buf, start, end) {
        const crcCalculator = new $4883ab303b017428$var$CrcCalculator();
        return crcCalculator.addBytes(buf, start, end);
    }
}
var $4883ab303b017428$export$2e2bcd8739ae039 = $4883ab303b017428$var$CrcCalculator;


/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
class $672b154b305381f7$var$AccumulatedField {
    #accumulatedValue = 0;
    #lastValue = 0;
    constructor(value){
        this.#accumulatedValue = value;
        this.#lastValue = value;
    }
    accumulate(value, bits) {
        const mask = (1 << bits) - 1;
        this.#accumulatedValue += value - this.#lastValue & mask;
        this.#lastValue = value;
        return this.#accumulatedValue;
    }
}
class $672b154b305381f7$var$Accumulator {
    #messages = {};
    createAccumulatedField(mesgNum, fieldNum, value) {
        const accumualtedField = new $672b154b305381f7$var$AccumulatedField(value);
        if (this.#messages[mesgNum] == null) this.#messages[mesgNum] = {};
        this.#messages[mesgNum][fieldNum] = accumualtedField;
        return accumualtedField;
    }
    accumulate(mesgNum, fieldNum, value, bits) {
        let accumualtedField = this.#messages[mesgNum]?.[fieldNum];
        if (accumualtedField == null) accumualtedField = this.createAccumulatedField(mesgNum, fieldNum, value);
        return accumualtedField.accumulate(value, bits);
    }
}
var $672b154b305381f7$export$2e2bcd8739ae039 = $672b154b305381f7$var$Accumulator;


/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
/**
 * FIT Base Type enum
 */ const $6fb08636b36a917e$var$BaseType = {
    ENUM: 0x00,
    SINT8: 0x01,
    UINT8: 0x02,
    SINT16: 0x83,
    UINT16: 0x84,
    SINT32: 0x85,
    UINT32: 0x86,
    STRING: 0x07,
    FLOAT32: 0x88,
    FLOAT64: 0x89,
    UINT8Z: 0x0A,
    UINT16Z: 0x8B,
    UINT32Z: 0x8C,
    BYTE: 0x0D,
    SINT64: 0x8E,
    UINT64: 0x8F,
    UINT64Z: 0x90
};
const $6fb08636b36a917e$var$BaseTypeDefinitions = {
    0x00: {
        size: 1,
        type: $6fb08636b36a917e$var$BaseType.ENUM,
        invalid: 0xFF
    },
    0x01: {
        size: 1,
        type: $6fb08636b36a917e$var$BaseType.SINT8,
        invalid: 0x7F
    },
    0x02: {
        size: 1,
        type: $6fb08636b36a917e$var$BaseType.UINT8,
        invalid: 0xFF
    },
    0x83: {
        size: 2,
        type: $6fb08636b36a917e$var$BaseType.SINT16,
        invalid: 0x7FFF
    },
    0x84: {
        size: 2,
        type: $6fb08636b36a917e$var$BaseType.UINT16,
        invalid: 0xFFFF
    },
    0x85: {
        size: 4,
        type: $6fb08636b36a917e$var$BaseType.SINT32,
        invalid: 0x7FFFFFFF
    },
    0x86: {
        size: 4,
        type: $6fb08636b36a917e$var$BaseType.UINT32,
        invalid: 0xFFFFFFFF
    },
    0x07: {
        size: 1,
        type: $6fb08636b36a917e$var$BaseType.STRING,
        invalid: 0x00
    },
    0x88: {
        size: 4,
        type: $6fb08636b36a917e$var$BaseType.FLOAT32,
        invalid: 0xFFFFFFFF
    },
    0x89: {
        size: 8,
        type: $6fb08636b36a917e$var$BaseType.FLOAT64,
        invalid: 0xFFFFFFFFFFFFFFFF
    },
    0x0A: {
        size: 1,
        type: $6fb08636b36a917e$var$BaseType.UINT8Z,
        invalid: 0x00
    },
    0x8B: {
        size: 2,
        type: $6fb08636b36a917e$var$BaseType.UINT16Z,
        invalid: 0x0000
    },
    0x8C: {
        size: 4,
        type: $6fb08636b36a917e$var$BaseType.UINT32Z,
        invalid: 0x00000000
    },
    0x0D: {
        size: 1,
        type: $6fb08636b36a917e$var$BaseType.BYTE,
        invalid: 0xFF
    },
    0x8E: {
        size: 8,
        type: $6fb08636b36a917e$var$BaseType.SINT64,
        invalid: 0x7FFFFFFFFFFFFFFF
    },
    0x8F: {
        size: 8,
        type: $6fb08636b36a917e$var$BaseType.UINT64,
        invalid: 0xFFFFFFFFFFFFFFFF
    },
    0x90: {
        size: 8,
        type: $6fb08636b36a917e$var$BaseType.UINT64Z,
        invalid: 0x0000000000000000
    }
};
const $6fb08636b36a917e$var$NumericFieldTypes = [
    "sint8",
    "uint8",
    "sint16",
    "uint16",
    "sint32",
    "uint32",
    "float32",
    "float64",
    "uint8z",
    "uint16z",
    "uint32z",
    "byte",
    "sint64",
    "uint64",
    "uint64z"
];
const $6fb08636b36a917e$var$FloatingPointFieldTypes = [
    "float32",
    "float64"
];
const $6fb08636b36a917e$var$FieldTypeToBaseType = {
    "enum": $6fb08636b36a917e$var$BaseType.UINT8,
    "sint8": $6fb08636b36a917e$var$BaseType.SINT8,
    "uint8": $6fb08636b36a917e$var$BaseType.UINT8,
    "sint16": $6fb08636b36a917e$var$BaseType.SINT16,
    "uint16": $6fb08636b36a917e$var$BaseType.UINT16,
    "sint32": $6fb08636b36a917e$var$BaseType.SINT32,
    "uint32": $6fb08636b36a917e$var$BaseType.UINT32,
    "string": $6fb08636b36a917e$var$BaseType.STRING,
    "float32": $6fb08636b36a917e$var$BaseType.FLOAT32,
    "float64": $6fb08636b36a917e$var$BaseType.FLOAT64,
    "uint8z": $6fb08636b36a917e$var$BaseType.UINT8Z,
    "uint16z": $6fb08636b36a917e$var$BaseType.UINT16Z,
    "uint32z": $6fb08636b36a917e$var$BaseType.UINT32Z,
    "byte": $6fb08636b36a917e$var$BaseType.BYTE,
    "sint64": $6fb08636b36a917e$var$BaseType.SINT64,
    "uint64": $6fb08636b36a917e$var$BaseType.UINT64,
    "uint64z": $6fb08636b36a917e$var$BaseType.UINT64Z
};
const $6fb08636b36a917e$var$BaseTypeToFieldType = {
    [$6fb08636b36a917e$var$BaseType.ENUM]: "enum",
    [$6fb08636b36a917e$var$BaseType.SINT8]: "sint8",
    [$6fb08636b36a917e$var$BaseType.UINT8]: "uint8",
    [$6fb08636b36a917e$var$BaseType.SINT16]: "sint16",
    [$6fb08636b36a917e$var$BaseType.UINT16]: "uint16",
    [$6fb08636b36a917e$var$BaseType.SINT32]: "sint32",
    [$6fb08636b36a917e$var$BaseType.UINT32]: "uint32",
    [$6fb08636b36a917e$var$BaseType.STRING]: "string",
    [$6fb08636b36a917e$var$BaseType.FLOAT32]: "float32",
    [$6fb08636b36a917e$var$BaseType.FLOAT64]: "float64",
    [$6fb08636b36a917e$var$BaseType.UINT8Z]: "uint8z",
    [$6fb08636b36a917e$var$BaseType.UINT16Z]: "uint16z",
    [$6fb08636b36a917e$var$BaseType.UINT32Z]: "uint32z",
    [$6fb08636b36a917e$var$BaseType.BYTE]: "byte",
    [$6fb08636b36a917e$var$BaseType.SINT64]: "sint64",
    [$6fb08636b36a917e$var$BaseType.UINT64]: "uint64",
    [$6fb08636b36a917e$var$BaseType.UINT64Z]: "uint64z"
};
const $6fb08636b36a917e$var$isNullOrUndefined = (obj)=>{
    return obj == null;
};
const $6fb08636b36a917e$var$isObject = (obj)=>{
    return typeof obj === "object";
};
const $6fb08636b36a917e$var$isBoolean = (obj)=>{
    return "boolean" === typeof obj;
};
const $6fb08636b36a917e$var$isDate = (obj)=>{
    return typeof obj === "object" && obj instanceof Date;
};
const $6fb08636b36a917e$var$isString = (obj)=>{
    return typeof obj === "string";
};
const $6fb08636b36a917e$var$isNumeric = (obj)=>{
    return !isNaN(parseFloat(obj)) && isFinite(obj);
};
const $6fb08636b36a917e$var$isNotNumberStringDateOrBoolean = (obj)=>{
    return !$6fb08636b36a917e$var$isNumberStringDateOrBoolean(obj);
};
const $6fb08636b36a917e$var$isNumberStringDateOrBoolean = (obj)=>{
    if ($6fb08636b36a917e$var$isNullOrUndefined(obj)) return false;
    if (!$6fb08636b36a917e$var$isDate(obj) && !$6fb08636b36a917e$var$isString(obj) && !$6fb08636b36a917e$var$isNumeric(obj) && !$6fb08636b36a917e$var$isBoolean(obj)) return false;
    return true;
};
var $6fb08636b36a917e$export$2e2bcd8739ae039 = {
    BaseType: $6fb08636b36a917e$var$BaseType,
    BaseTypeDefinitions: $6fb08636b36a917e$var$BaseTypeDefinitions,
    NumericFieldTypes: $6fb08636b36a917e$var$NumericFieldTypes,
    FloatingPointFieldTypes: $6fb08636b36a917e$var$FloatingPointFieldTypes,
    FieldTypeToBaseType: $6fb08636b36a917e$var$FieldTypeToBaseType,
    BaseTypeToFieldType: $6fb08636b36a917e$var$BaseTypeToFieldType,
    isNullOrUndefined: $6fb08636b36a917e$var$isNullOrUndefined,
    isObject: $6fb08636b36a917e$var$isObject,
    isBoolean: $6fb08636b36a917e$var$isBoolean,
    isDate: $6fb08636b36a917e$var$isDate,
    isString: $6fb08636b36a917e$var$isString,
    isNumeric: $6fb08636b36a917e$var$isNumeric,
    isNumberStringDateOrBoolean: $6fb08636b36a917e$var$isNumberStringDateOrBoolean,
    isNotNumberStringDateOrBoolean: $6fb08636b36a917e$var$isNotNumberStringDateOrBoolean,
    MAX_FIELD_SIZE: 255,
    FIELD_DEFAULT_SCALE: 1,
    FIELD_DEFAULT_OFFSET: 0,
    MESG_DEFINITION_MASK: 0x40,
    LOCAL_MESG_NUM_MASK: 0x0F,
    ARCH_LITTLE_ENDIAN: 0x00,
    DEV_DATA_MASK: 0x20
};


class $fe826815364cfcee$var$BitStream {
    #array = null;
    #currentArrayPosition = 0;
    #bitPerPosition = 0;
    #currentByte = 0;
    #currentBit = 0;
    #bitsAvailable = 0;
    constructor(data, baseType = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8){
        this.#array = Array.isArray(data) ? data : [
            data
        ];
        const baseTypeSize = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[baseType].size;
        this.#bitPerPosition = baseTypeSize * 8;
        this.reset();
    }
    get bitsAvailable() {
        return this.#bitsAvailable;
    }
    get hasBitsAvailable() {
        return this.#bitsAvailable > 0;
    }
    reset() {
        this.#currentArrayPosition = 0;
        this.#bitsAvailable = this.#bitPerPosition * this.#array.length;
        this.#nextByte();
    }
    readBit() {
        if (!this.hasBitsAvailable) this.#throwError();
        if (this.#currentBit >= this.#bitPerPosition) this.#nextByte();
        const bit = this.#currentByte & 0x01;
        this.#currentByte = this.#currentByte >> 1;
        this.#currentBit++;
        this.#bitsAvailable--;
        return bit;
    }
    readBits(nBitsToRead) {
        let value = 0n;
        for(let i = 0n; i < nBitsToRead; i++)value |= BigInt(this.readBit()) << i;
        return Number(value);
    }
    #nextByte() {
        if (this.#currentArrayPosition >= this.#array.length) this.#throwError();
        this.#currentByte = this.#array[this.#currentArrayPosition++];
        this.#currentBit = 0;
    }
    #throwError(error = "") {
        throw Error("FIT Runtime Error no bits available.");
    }
}
var $fe826815364cfcee$export$2e2bcd8739ae039 = $fe826815364cfcee$var$BitStream;




/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////

/**
 * The millisecond offset between UNIX and FIT Epochs (631065600000).
 * @const {number}
 */ const $519e72961d771fc4$var$FIT_EPOCH_MS = 631065600000;
/**
 * Convert a FIT DateTime to a JavaScript Date
 * @param {number} datetime - Seconds since FIT EPOCH
 * @returns {Date} A JavaScript Date object
 */ const $519e72961d771fc4$var$convertDateTimeToDate = (datetime)=>{
    return new Date((datetime ?? 0) * 1000 + $519e72961d771fc4$var$FIT_EPOCH_MS);
};
/**
 * Convert a JavaScript Date to a FIT DateTime
 * @param {Date} A JavaScript Date object
 * @return {number} datetime - Seconds since FIT EPOCH
 */ const $519e72961d771fc4$var$convertDateToDateTime = (date)=>{
    return (date.getTime() - $519e72961d771fc4$var$FIT_EPOCH_MS) / 1000;
};
var $519e72961d771fc4$export$2e2bcd8739ae039 = {
    FIT_EPOCH_MS: $519e72961d771fc4$var$FIT_EPOCH_MS,
    convertDateTimeToDate: $519e72961d771fc4$var$convertDateTimeToDate,
    convertDateToDateTime: $519e72961d771fc4$var$convertDateToDateTime,
    FitBaseType: (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType,
    BaseTypeToFieldType: (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeToFieldType,
    FieldTypeToBaseType: (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FieldTypeToBaseType
};


const $4c13e134286d0771$var$mergeHeartRates = (hrMesgs, recordMesgs)=>{
    if (hrMesgs == null || recordMesgs == null || hrMesgs.length == 0 || recordMesgs.length == 0) return;
    const heartrates = $4c13e134286d0771$var$expandHeartRates(hrMesgs);
    let heartrateIndex = 0;
    let recordRangeStartTime = null;
    for(let i = 0; i < recordMesgs.length; ++i){
        const recordMesg = recordMesgs[i];
        let hrSum = 0;
        let hrSumCount = 0;
        const recordRangeEndTime = $4c13e134286d0771$var$secondsSinceFitEpoch(recordMesg.timestamp);
        if (recordRangeStartTime == null) recordRangeStartTime = recordRangeEndTime;
        if (recordRangeStartTime === recordRangeEndTime) {
            recordRangeStartTime--;
            heartrateIndex = heartrateIndex >= 1 ? heartrateIndex - 1 : 0;
        }
        let findingInRangeHrMesgs = true;
        while(findingInRangeHrMesgs && heartrateIndex < heartrates.length){
            const heartrate = heartrates[heartrateIndex];
            // Check if the heartrate timestamp is gt record start time
            // and if the heartrate timestamp is lte to record end time
            if (heartrate.timestamp > recordRangeStartTime && heartrate.timestamp <= recordRangeEndTime) {
                hrSum += heartrate.heartRate;
                hrSumCount++;
            } else if (heartrate.timestamp > recordRangeEndTime) {
                findingInRangeHrMesgs = false;
                if (hrSumCount > 0) {
                    // Update record's heart rate value
                    const avgHR = Math.round(hrSum / hrSumCount);
                    recordMesg.heartRate = avgHR;
                }
                // Reset HR average accumulators
                hrSum = 0;
                hrSumCount = 0;
                recordRangeStartTime = recordRangeEndTime;
                break;
            }
            heartrateIndex++;
        }
    }
};
const $4c13e134286d0771$var$expandHeartRates = (hrMesgs)=>{
    const GAP_INCREMENT_MILLISECONDS = 250;
    const GAP_INCREMENT_SECONDS = GAP_INCREMENT_MILLISECONDS / 1000.0;
    const GAP_MAX_MILLISECONDS = 5000;
    const GAP_MAX_STEPS = GAP_MAX_MILLISECONDS / GAP_INCREMENT_MILLISECONDS;
    if (hrMesgs == null || hrMesgs.length == 0) return [];
    let anchorEventTimestamp = 0.0;
    let anchorTimestamp = null;
    const heartrates = [];
    hrMesgs.forEach((hrMesg)=>{
        if (hrMesg == null) $4c13e134286d0771$var$throwError("HR mesg must not be null");
        const eventTimestamps = Array.isArray(hrMesg.eventTimestamp) ? hrMesg.eventTimestamp : [
            hrMesg.eventTimestamp
        ];
        const filteredBpms = Array.isArray(hrMesg.filteredBpm) ? hrMesg.filteredBpm : [
            hrMesg.filteredBpm
        ];
        // Update HR timestamp anchor, if present
        if (hrMesg.timestamp != null) {
            anchorTimestamp = $4c13e134286d0771$var$secondsSinceFitEpoch(hrMesg.timestamp);
            if (hrMesg.fractionalTimestamp != null) anchorTimestamp += hrMesg.fractionalTimestamp;
            if (eventTimestamps.length == 1) anchorEventTimestamp = eventTimestamps[0];
            else $4c13e134286d0771$var$throwError("anchor HR mesg must have 1 event_timestamp");
        }
        if (anchorTimestamp == null || anchorEventTimestamp == null) // We cannot process any HR messages if we have not received a timestamp anchor
        $4c13e134286d0771$var$throwError("no anchor timestamp received in a HR mesg before delta HR mesgs");
        else if (eventTimestamps.length != filteredBpms.length) $4c13e134286d0771$var$throwError("HR mesg with mismatching event timestamp and filtered bpm");
        for(let i = 0; i < eventTimestamps.length; i++){
            let eventTimestamp = eventTimestamps[i];
            // Check to see if the event timestamp rolled over
            if (eventTimestamp < anchorEventTimestamp) {
                if (anchorEventTimestamp - eventTimestamp > 0x400000) eventTimestamp += 0x400000;
                else $4c13e134286d0771$var$throwError("anchor event_timestamp is greater than subsequent event_timestamp. This does not allow for correct delta calculation.");
            }
            const currentHr = {
                timestamp: anchorTimestamp,
                heartRate: filteredBpms[i]
            };
            currentHr.timestamp += eventTimestamp - anchorEventTimestamp;
            // Carry the previous HR value forward across the gap to the current
            // HR value for up to 5 Seconds (5000ms) in 250ms increments
            if (heartrates.length > 0) {
                const previousHR = heartrates[heartrates.length - 1];
                let gapInMilliseconds = Math.abs(currentHr.timestamp - previousHR.timestamp) * 1000;
                let step = 1;
                while(gapInMilliseconds > GAP_INCREMENT_MILLISECONDS && step <= GAP_MAX_STEPS){
                    const gapHR = {
                        timestamp: previousHR.timestamp,
                        heartRate: previousHR.heartRate
                    };
                    gapHR.timestamp += GAP_INCREMENT_SECONDS * step;
                    heartrates.push(gapHR);
                    gapInMilliseconds -= GAP_INCREMENT_MILLISECONDS;
                    step++;
                }
            }
            heartrates.push(currentHr);
        }
    });
    return heartrates;
};
const $4c13e134286d0771$var$secondsSinceFitEpoch = (timestamp)=>{
    if (timestamp instanceof Date) return (timestamp.getTime() - (0, $519e72961d771fc4$export$2e2bcd8739ae039).FIT_EPOCH_MS) / 1000;
    return timestamp;
};
const $4c13e134286d0771$var$throwError = (error = "")=>{
    throw Error(`FIT Runtime Error ${error}`.trimEnd());
};
var $4c13e134286d0771$export$2e2bcd8739ae039 = {
    mergeHeartRates: $4c13e134286d0771$var$mergeHeartRates,
    expandHeartRates: $4c13e134286d0771$var$expandHeartRates
};


/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
const $d64f2254b548006a$var$Profile = {
    version: {
        major: 21,
        minor: 178,
        patch: 0,
        type: "Release"
    },
    CommonFields: {
        PartIndex: 250,
        Timestamp: 253,
        MessageIndex: 254
    },
    messages: {
        0: {
            num: 0,
            name: "fileId",
            messagesKey: "fileIdMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "type",
                    type: "file",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "manufacturer",
                    type: "manufacturer",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "product",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "faveroProduct",
                            type: "faveroProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 263
                                }
                            ]
                        },
                        {
                            name: "garminProduct",
                            type: "garminProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 1
                                },
                                {
                                    name: "manufacturer",
                                    value: 15
                                },
                                {
                                    name: "manufacturer",
                                    value: 13
                                },
                                {
                                    name: "manufacturer",
                                    value: 89
                                }
                            ]
                        }
                    ]
                },
                3: {
                    num: 3,
                    name: "serialNumber",
                    type: "uint32z",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "timeCreated",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "number",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "productName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        49: {
            num: 49,
            name: "fileCreator",
            messagesKey: "fileCreatorMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "softwareVersion",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "hardwareVersion",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        162: {
            num: 162,
            name: "timestampCorrelation",
            messagesKey: "timestampCorrelationMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "fractionalTimestamp",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 32768,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "systemTimestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "fractionalSystemTimestamp",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 32768,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "localTimestamp",
                    type: "localDateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "systemTimestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        35: {
            num: 35,
            name: "software",
            messagesKey: "softwareMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "version",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "partNumber",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        106: {
            num: 106,
            name: "slaveDevice",
            messagesKey: "slaveDeviceMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "manufacturer",
                    type: "manufacturer",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "product",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "faveroProduct",
                            type: "faveroProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 263
                                }
                            ]
                        },
                        {
                            name: "garminProduct",
                            type: "garminProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 1
                                },
                                {
                                    name: "manufacturer",
                                    value: 15
                                },
                                {
                                    name: "manufacturer",
                                    value: 13
                                },
                                {
                                    name: "manufacturer",
                                    value: 89
                                }
                            ]
                        }
                    ]
                }
            }
        },
        1: {
            num: 1,
            name: "capabilities",
            messagesKey: "capabilitiesMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "languages",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sports",
                    type: "sportBits0",
                    baseType: "uint8z",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "workoutsSupported",
                    type: "workoutCapabilities",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "connectivitySupported",
                    type: "connectivityCapabilities",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        37: {
            num: 37,
            name: "fileCapabilities",
            messagesKey: "fileCapabilitiesMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "type",
                    type: "file",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "flags",
                    type: "fileFlags",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "directory",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "maxCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "maxSize",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bytes",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        38: {
            num: 38,
            name: "mesgCapabilities",
            messagesKey: "mesgCapabilitiesMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "file",
                    type: "file",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "mesgNum",
                    type: "mesgNum",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "countType",
                    type: "mesgCount",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "count",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "numPerFile",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "countType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "maxPerFile",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "countType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "maxPerFileType",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "countType",
                                    value: 2
                                }
                            ]
                        }
                    ]
                }
            }
        },
        39: {
            num: 39,
            name: "fieldCapabilities",
            messagesKey: "fieldCapabilitiesMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "file",
                    type: "file",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "mesgNum",
                    type: "mesgNum",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "fieldNum",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "count",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        2: {
            num: 2,
            name: "deviceSettings",
            messagesKey: "deviceSettingsMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "activeTimeZone",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "utcOffset",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "timeOffset",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "timeMode",
                    type: "timeMode",
                    baseType: "enum",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "timeZoneOffset",
                    type: "sint8",
                    baseType: "sint8",
                    array: true,
                    scale: 4,
                    offset: 0,
                    units: "hr",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "backlightMode",
                    type: "backlightMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                36: {
                    num: 36,
                    name: "activityTrackerEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                39: {
                    num: 39,
                    name: "clockTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                40: {
                    num: 40,
                    name: "pagesEnabled",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                46: {
                    num: 46,
                    name: "moveAlertEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                47: {
                    num: 47,
                    name: "dateMode",
                    type: "dateMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                55: {
                    num: 55,
                    name: "displayOrientation",
                    type: "displayOrientation",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                56: {
                    num: 56,
                    name: "mountingSide",
                    type: "side",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                57: {
                    num: 57,
                    name: "defaultPage",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                58: {
                    num: 58,
                    name: "autosyncMinSteps",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "steps",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                59: {
                    num: 59,
                    name: "autosyncMinTime",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "minutes",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                80: {
                    num: 80,
                    name: "lactateThresholdAutodetectEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                86: {
                    num: 86,
                    name: "bleAutoUploadEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                89: {
                    num: 89,
                    name: "autoSyncFrequency",
                    type: "autoSyncFrequency",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                90: {
                    num: 90,
                    name: "autoActivityDetect",
                    type: "autoActivityDetect",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                94: {
                    num: 94,
                    name: "numberOfScreens",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                95: {
                    num: 95,
                    name: "smartNotificationDisplayOrientation",
                    type: "displayOrientation",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                134: {
                    num: 134,
                    name: "tapInterface",
                    type: "switch",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                174: {
                    num: 174,
                    name: "tapSensitivity",
                    type: "tapSensitivity",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        3: {
            num: 3,
            name: "userProfile",
            messagesKey: "userProfileMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "friendlyName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "gender",
                    type: "gender",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "age",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "years",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "height",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "weight",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "language",
                    type: "language",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "elevSetting",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "weightSetting",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "restingHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "defaultMaxRunningHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "defaultMaxBikingHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "defaultMaxHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "hrSetting",
                    type: "displayHeart",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "speedSetting",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "distSetting",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "powerSetting",
                    type: "displayPower",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "activityClass",
                    type: "activityClass",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "positionSetting",
                    type: "displayPosition",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "temperatureSetting",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "localId",
                    type: "userLocalId",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "globalId",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                28: {
                    num: 28,
                    name: "wakeTime",
                    type: "localtimeIntoDay",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                29: {
                    num: 29,
                    name: "sleepTime",
                    type: "localtimeIntoDay",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                30: {
                    num: 30,
                    name: "heightSetting",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                31: {
                    num: 31,
                    name: "userRunningStepLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "userWalkingStepLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                47: {
                    num: 47,
                    name: "depthSetting",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                49: {
                    num: 49,
                    name: "diveCount",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        4: {
            num: 4,
            name: "hrmProfile",
            messagesKey: "hrmProfileMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "hrmAntId",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "logHrv",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "hrmAntIdTransType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        5: {
            num: 5,
            name: "sdmProfile",
            messagesKey: "sdmProfileMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sdmAntId",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "sdmCalFactor",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "odometer",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "speedSource",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "sdmAntIdTransType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "odometerRollover",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        6: {
            num: 6,
            name: "bikeProfile",
            messagesKey: "bikeProfileMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "odometer",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "bikeSpdAntId",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "bikeCadAntId",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "bikeSpdcadAntId",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "bikePowerAntId",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "customWheelsize",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "autoWheelsize",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "bikeWeight",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "powerCalFactor",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "autoWheelCal",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "autoPowerZero",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "id",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "spdEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "cadEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "spdcadEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "powerEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "crankLength",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: -110,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                20: {
                    num: 20,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "bikeSpdAntIdTransType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "bikeCadAntIdTransType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "bikeSpdcadAntIdTransType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "bikePowerAntIdTransType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                37: {
                    num: 37,
                    name: "odometerRollover",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                38: {
                    num: 38,
                    name: "frontGearNum",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                39: {
                    num: 39,
                    name: "frontGear",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                40: {
                    num: 40,
                    name: "rearGearNum",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                41: {
                    num: 41,
                    name: "rearGear",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                44: {
                    num: 44,
                    name: "shimanoDi2Enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        127: {
            num: 127,
            name: "connectivity",
            messagesKey: "connectivityMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "bluetoothEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "bluetoothLeEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "antEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "liveTrackingEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "weatherConditionsEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "weatherAlertsEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "autoActivityUploadEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "courseDownloadEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "workoutDownloadEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "gpsEphemerisDownloadEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "incidentDetectionEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "grouptrackEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        159: {
            num: 159,
            name: "watchfaceSettings",
            messagesKey: "watchfaceSettingsMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "mode",
                    type: "watchfaceMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "layout",
                    type: "byte",
                    baseType: "byte",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "digitalLayout",
                            type: "digitalWatchfaceLayout",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "mode",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "analogLayout",
                            type: "analogWatchfaceLayout",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "mode",
                                    value: 1
                                }
                            ]
                        }
                    ]
                }
            }
        },
        188: {
            num: 188,
            name: "ohrSettings",
            messagesKey: "ohrSettingsMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "enabled",
                    type: "switch",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        216: {
            num: 216,
            name: "timeInZone",
            messagesKey: "timeInZoneMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "referenceMesg",
                    type: "mesgNum",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "referenceIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "timeInHrZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "timeInSpeedZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "timeInCadenceZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "timeInPowerZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "hrZoneHighBoundary",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "speedZoneHighBoundary",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "cadenceZoneHighBondary",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "powerZoneHighBoundary",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "hrCalcType",
                    type: "hrZoneCalc",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "maxHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "restingHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "thresholdHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "pwrCalcType",
                    type: "pwrZoneCalc",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "functionalThresholdPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        7: {
            num: 7,
            name: "zonesTarget",
            messagesKey: "zonesTargetMesgs",
            fields: {
                1: {
                    num: 1,
                    name: "maxHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "thresholdHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "functionalThresholdPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "hrCalcType",
                    type: "hrZoneCalc",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "pwrCalcType",
                    type: "pwrZoneCalc",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        12: {
            num: 12,
            name: "sport",
            messagesKey: "sportMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        8: {
            num: 8,
            name: "hrZone",
            messagesKey: "hrZoneMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "highBpm",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        53: {
            num: 53,
            name: "speedZone",
            messagesKey: "speedZoneMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "highValue",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        131: {
            num: 131,
            name: "cadenceZone",
            messagesKey: "cadenceZoneMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "highValue",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        9: {
            num: 9,
            name: "powerZone",
            messagesKey: "powerZoneMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "highValue",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        10: {
            num: 10,
            name: "metZone",
            messagesKey: "metZoneMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "highBpm",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "calories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "kcal / min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "fatCalories",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "kcal / min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        13: {
            num: 13,
            name: "trainingSettings",
            messagesKey: "trainingSettingsMesgs",
            fields: {
                31: {
                    num: 31,
                    name: "targetDistance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "targetSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                33: {
                    num: 33,
                    name: "targetTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                153: {
                    num: 153,
                    name: "preciseTargetSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        258: {
            num: 258,
            name: "diveSettings",
            messagesKey: "diveSettingsMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "model",
                    type: "tissueModelType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "gfLow",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "gfHigh",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "waterType",
                    type: "waterType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "waterDensity",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kg/m^3",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "po2Warn",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "po2Critical",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "po2Deco",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "safetyStopEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "bottomDepth",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "bottomTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "apneaCountdownEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "apneaCountdownTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "backlightMode",
                    type: "diveBacklightMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "backlightBrightness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "backlightTimeout",
                    type: "backlightTimeout",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "repeatDiveInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "safetyStopTime",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "heartRateSourceType",
                    type: "sourceType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                20: {
                    num: 20,
                    name: "heartRateSource",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "heartRateAntplusDeviceType",
                            type: "antplusDeviceType",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "heartRateSourceType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "heartRateLocalDeviceType",
                            type: "localDeviceType",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "heartRateSourceType",
                                    value: 5
                                }
                            ]
                        }
                    ]
                },
                21: {
                    num: 21,
                    name: "travelGas",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "ccrLowSetpointSwitchMode",
                    type: "ccrSetpointSwitchMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "ccrLowSetpoint",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "ccrLowSetpointDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "ccrHighSetpointSwitchMode",
                    type: "ccrSetpointSwitchMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                26: {
                    num: 26,
                    name: "ccrHighSetpoint",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                27: {
                    num: 27,
                    name: "ccrHighSetpointDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                29: {
                    num: 29,
                    name: "gasConsumptionDisplay",
                    type: "gasConsumptionRateType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                30: {
                    num: 30,
                    name: "upKeyEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                35: {
                    num: 35,
                    name: "diveSounds",
                    type: "tone",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                36: {
                    num: 36,
                    name: "lastStopMultiple",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                37: {
                    num: 37,
                    name: "noFlyTimeMode",
                    type: "noFlyTimeMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        262: {
            num: 262,
            name: "diveAlarm",
            messagesKey: "diveAlarmMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "depth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "time",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "alarmType",
                    type: "diveAlarmType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "sound",
                    type: "tone",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "diveTypes",
                    type: "subSport",
                    baseType: "enum",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "id",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "popupEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "triggerOnDescent",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "triggerOnAscent",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "repeating",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "speed",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "mps",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        393: {
            num: 393,
            name: "diveApneaAlarm",
            messagesKey: "diveApneaAlarmMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "depth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "time",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "alarmType",
                    type: "diveAlarmType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "sound",
                    type: "tone",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "diveTypes",
                    type: "subSport",
                    baseType: "enum",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "id",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "popupEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "triggerOnDescent",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "triggerOnAscent",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "repeating",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "speed",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "mps",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        259: {
            num: 259,
            name: "diveGas",
            messagesKey: "diveGasMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "heliumContent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "oxygenContent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "status",
                    type: "diveGasStatus",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "mode",
                    type: "diveGasMode",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        15: {
            num: 15,
            name: "goal",
            messagesKey: "goalMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "startDate",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "endDate",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "type",
                    type: "goal",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "value",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "repeat",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "targetValue",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "recurrence",
                    type: "goalRecurrence",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "recurrenceValue",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "source",
                    type: "goalSource",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        34: {
            num: 34,
            name: "activity",
            messagesKey: "activityMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "totalTimerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "numSessions",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "type",
                    type: "activity",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "event",
                    type: "event",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "eventType",
                    type: "eventType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "localTimestamp",
                    type: "localDateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "eventGroup",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        18: {
            num: 18,
            name: "session",
            messagesKey: "sessionMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "event",
                    type: "event",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "eventType",
                    type: "eventType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "startTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "startPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "startPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "totalElapsedTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "totalTimerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "totalDistance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "totalCycles",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "totalStrides",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "strides",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 1
                                },
                                {
                                    name: "sport",
                                    value: 11
                                }
                            ]
                        },
                        {
                            name: "totalStrokes",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "strokes",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 2
                                },
                                {
                                    name: "sport",
                                    value: 5
                                },
                                {
                                    name: "sport",
                                    value: 15
                                },
                                {
                                    name: "sport",
                                    value: 37
                                }
                            ]
                        }
                    ]
                },
                11: {
                    num: 11,
                    name: "totalCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "totalFatCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "avgSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1000
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "m/s"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "124"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "maxSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1000
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "m/s"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "125"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "avgHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "maxHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "avgCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "avgRunningCadence",
                            type: "uint8",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "strides/min",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 1
                                }
                            ]
                        }
                    ]
                },
                19: {
                    num: 19,
                    name: "maxCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "maxRunningCadence",
                            type: "uint8",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "strides/min",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 1
                                }
                            ]
                        }
                    ]
                },
                20: {
                    num: 20,
                    name: "avgPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "maxPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "totalAscent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "totalDescent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "totalTrainingEffect",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "firstLapIndex",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                26: {
                    num: 26,
                    name: "numLaps",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                27: {
                    num: 27,
                    name: "eventGroup",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                28: {
                    num: 28,
                    name: "trigger",
                    type: "sessionTrigger",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                29: {
                    num: 29,
                    name: "necLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                30: {
                    num: 30,
                    name: "necLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                31: {
                    num: 31,
                    name: "swcLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "swcLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                33: {
                    num: 33,
                    name: "numLengths",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "lengths",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                34: {
                    num: 34,
                    name: "normalizedPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                35: {
                    num: 35,
                    name: "trainingStressScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "tss",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                36: {
                    num: 36,
                    name: "intensityFactor",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "if",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                37: {
                    num: 37,
                    name: "leftRightBalance",
                    type: "leftRightBalance100",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                38: {
                    num: 38,
                    name: "endPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                39: {
                    num: 39,
                    name: "endPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                41: {
                    num: 41,
                    name: "avgStrokeCount",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "strokes/lap",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                42: {
                    num: 42,
                    name: "avgStrokeDistance",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                43: {
                    num: 43,
                    name: "swimStroke",
                    type: "swimStroke",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "swim_stroke",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                44: {
                    num: 44,
                    name: "poolLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                45: {
                    num: 45,
                    name: "thresholdPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                46: {
                    num: 46,
                    name: "poolLengthUnit",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                47: {
                    num: 47,
                    name: "numActiveLengths",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "lengths",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                48: {
                    num: 48,
                    name: "totalWork",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "J",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                49: {
                    num: 49,
                    name: "avgAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "126"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                50: {
                    num: 50,
                    name: "maxAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "128"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                51: {
                    num: 51,
                    name: "gpsAccuracy",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                52: {
                    num: 52,
                    name: "avgGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                53: {
                    num: 53,
                    name: "avgPosGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                54: {
                    num: 54,
                    name: "avgNegGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                55: {
                    num: 55,
                    name: "maxPosGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                56: {
                    num: 56,
                    name: "maxNegGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                57: {
                    num: 57,
                    name: "avgTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                58: {
                    num: 58,
                    name: "maxTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                59: {
                    num: 59,
                    name: "totalMovingTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                60: {
                    num: 60,
                    name: "avgPosVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                61: {
                    num: 61,
                    name: "avgNegVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                62: {
                    num: 62,
                    name: "maxPosVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                63: {
                    num: 63,
                    name: "maxNegVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                64: {
                    num: 64,
                    name: "minHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                65: {
                    num: 65,
                    name: "timeInHrZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                66: {
                    num: 66,
                    name: "timeInSpeedZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                67: {
                    num: 67,
                    name: "timeInCadenceZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                68: {
                    num: 68,
                    name: "timeInPowerZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                69: {
                    num: 69,
                    name: "avgLapTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                70: {
                    num: 70,
                    name: "bestLapIndex",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                71: {
                    num: 71,
                    name: "minAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "127"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                82: {
                    num: 82,
                    name: "playerScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                83: {
                    num: 83,
                    name: "opponentScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                84: {
                    num: 84,
                    name: "opponentName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                85: {
                    num: 85,
                    name: "strokeCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                86: {
                    num: 86,
                    name: "zoneCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                87: {
                    num: 87,
                    name: "maxBallSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                88: {
                    num: 88,
                    name: "avgBallSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                89: {
                    num: 89,
                    name: "avgVerticalOscillation",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                90: {
                    num: 90,
                    name: "avgStanceTimePercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                91: {
                    num: 91,
                    name: "avgStanceTime",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                92: {
                    num: 92,
                    name: "avgFractionalCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                93: {
                    num: 93,
                    name: "maxFractionalCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                94: {
                    num: 94,
                    name: "totalFractionalCycles",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                95: {
                    num: 95,
                    name: "avgTotalHemoglobinConc",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                96: {
                    num: 96,
                    name: "minTotalHemoglobinConc",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                97: {
                    num: 97,
                    name: "maxTotalHemoglobinConc",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                98: {
                    num: 98,
                    name: "avgSaturatedHemoglobinPercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                99: {
                    num: 99,
                    name: "minSaturatedHemoglobinPercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                100: {
                    num: 100,
                    name: "maxSaturatedHemoglobinPercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                101: {
                    num: 101,
                    name: "avgLeftTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                102: {
                    num: 102,
                    name: "avgRightTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                103: {
                    num: 103,
                    name: "avgLeftPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                104: {
                    num: 104,
                    name: "avgRightPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                105: {
                    num: 105,
                    name: "avgCombinedPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                110: {
                    num: 110,
                    name: "sportProfileName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                111: {
                    num: 111,
                    name: "sportIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                112: {
                    num: 112,
                    name: "timeStanding",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                113: {
                    num: 113,
                    name: "standCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                114: {
                    num: 114,
                    name: "avgLeftPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                115: {
                    num: 115,
                    name: "avgRightPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                116: {
                    num: 116,
                    name: "avgLeftPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                117: {
                    num: 117,
                    name: "avgLeftPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                118: {
                    num: 118,
                    name: "avgRightPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                119: {
                    num: 119,
                    name: "avgRightPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                120: {
                    num: 120,
                    name: "avgPowerPosition",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                121: {
                    num: 121,
                    name: "maxPowerPosition",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                122: {
                    num: 122,
                    name: "avgCadencePosition",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                123: {
                    num: 123,
                    name: "maxCadencePosition",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                124: {
                    num: 124,
                    name: "enhancedAvgSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                125: {
                    num: 125,
                    name: "enhancedMaxSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                126: {
                    num: 126,
                    name: "enhancedAvgAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                127: {
                    num: 127,
                    name: "enhancedMinAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                128: {
                    num: 128,
                    name: "enhancedMaxAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                129: {
                    num: 129,
                    name: "avgLevMotorPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                130: {
                    num: 130,
                    name: "maxLevMotorPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                131: {
                    num: 131,
                    name: "levBatteryConsumption",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                132: {
                    num: 132,
                    name: "avgVerticalRatio",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                133: {
                    num: 133,
                    name: "avgStanceTimeBalance",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                134: {
                    num: 134,
                    name: "avgStepLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                137: {
                    num: 137,
                    name: "totalAnaerobicTrainingEffect",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                139: {
                    num: 139,
                    name: "avgVam",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                140: {
                    num: 140,
                    name: "avgDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                141: {
                    num: 141,
                    name: "maxDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                142: {
                    num: 142,
                    name: "surfaceInterval",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                143: {
                    num: 143,
                    name: "startCns",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                144: {
                    num: 144,
                    name: "endCns",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                145: {
                    num: 145,
                    name: "startN2",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                146: {
                    num: 146,
                    name: "endN2",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                147: {
                    num: 147,
                    name: "avgRespirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "169"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                148: {
                    num: 148,
                    name: "maxRespirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "170"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                149: {
                    num: 149,
                    name: "minRespirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "180"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                150: {
                    num: 150,
                    name: "minTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                155: {
                    num: 155,
                    name: "o2Toxicity",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "OTUs",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                156: {
                    num: 156,
                    name: "diveNumber",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                168: {
                    num: 168,
                    name: "trainingLoadPeak",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 65536,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                169: {
                    num: 169,
                    name: "enhancedAvgRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "Breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                170: {
                    num: 170,
                    name: "enhancedMaxRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "Breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                180: {
                    num: 180,
                    name: "enhancedMinRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                181: {
                    num: 181,
                    name: "totalGrit",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kGrit",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                182: {
                    num: 182,
                    name: "totalFlow",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "Flow",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                183: {
                    num: 183,
                    name: "jumpCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                186: {
                    num: 186,
                    name: "avgGrit",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kGrit",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                187: {
                    num: 187,
                    name: "avgFlow",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "Flow",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                192: {
                    num: 192,
                    name: "workoutFeel",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                193: {
                    num: 193,
                    name: "workoutRpe",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                194: {
                    num: 194,
                    name: "avgSpo2",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                195: {
                    num: 195,
                    name: "avgStress",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                197: {
                    num: 197,
                    name: "sdrrHrv",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mS",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                198: {
                    num: 198,
                    name: "rmssdHrv",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mS",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                199: {
                    num: 199,
                    name: "totalFractionalAscent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                200: {
                    num: 200,
                    name: "totalFractionalDescent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                208: {
                    num: 208,
                    name: "avgCoreTemperature",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                209: {
                    num: 209,
                    name: "minCoreTemperature",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                210: {
                    num: 210,
                    name: "maxCoreTemperature",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        19: {
            num: 19,
            name: "lap",
            messagesKey: "lapMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "event",
                    type: "event",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "eventType",
                    type: "eventType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "startTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "startPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "startPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "endPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "endPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "totalElapsedTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "totalTimerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "totalDistance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "totalCycles",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "totalStrides",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "strides",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 1
                                },
                                {
                                    name: "sport",
                                    value: 11
                                }
                            ]
                        },
                        {
                            name: "totalStrokes",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "strokes",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 2
                                },
                                {
                                    name: "sport",
                                    value: 5
                                },
                                {
                                    name: "sport",
                                    value: 15
                                },
                                {
                                    name: "sport",
                                    value: 37
                                }
                            ]
                        }
                    ]
                },
                11: {
                    num: 11,
                    name: "totalCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "totalFatCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "avgSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1000
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "m/s"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "110"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "maxSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1000
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "m/s"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "111"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "avgHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "maxHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "avgCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "avgRunningCadence",
                            type: "uint8",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "strides/min",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 1
                                }
                            ]
                        }
                    ]
                },
                18: {
                    num: 18,
                    name: "maxCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "maxRunningCadence",
                            type: "uint8",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "strides/min",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 1
                                }
                            ]
                        }
                    ]
                },
                19: {
                    num: 19,
                    name: "avgPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                20: {
                    num: 20,
                    name: "maxPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "totalAscent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "totalDescent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "intensity",
                    type: "intensity",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "lapTrigger",
                    type: "lapTrigger",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                26: {
                    num: 26,
                    name: "eventGroup",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "numLengths",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "lengths",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                33: {
                    num: 33,
                    name: "normalizedPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                34: {
                    num: 34,
                    name: "leftRightBalance",
                    type: "leftRightBalance100",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                35: {
                    num: 35,
                    name: "firstLengthIndex",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                37: {
                    num: 37,
                    name: "avgStrokeDistance",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                38: {
                    num: 38,
                    name: "swimStroke",
                    type: "swimStroke",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                39: {
                    num: 39,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                40: {
                    num: 40,
                    name: "numActiveLengths",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "lengths",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                41: {
                    num: 41,
                    name: "totalWork",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "J",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                42: {
                    num: 42,
                    name: "avgAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "112"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                43: {
                    num: 43,
                    name: "maxAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "114"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                44: {
                    num: 44,
                    name: "gpsAccuracy",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                45: {
                    num: 45,
                    name: "avgGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                46: {
                    num: 46,
                    name: "avgPosGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                47: {
                    num: 47,
                    name: "avgNegGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                48: {
                    num: 48,
                    name: "maxPosGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                49: {
                    num: 49,
                    name: "maxNegGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                50: {
                    num: 50,
                    name: "avgTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                51: {
                    num: 51,
                    name: "maxTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                52: {
                    num: 52,
                    name: "totalMovingTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                53: {
                    num: 53,
                    name: "avgPosVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                54: {
                    num: 54,
                    name: "avgNegVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                55: {
                    num: 55,
                    name: "maxPosVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                56: {
                    num: 56,
                    name: "maxNegVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                57: {
                    num: 57,
                    name: "timeInHrZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                58: {
                    num: 58,
                    name: "timeInSpeedZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                59: {
                    num: 59,
                    name: "timeInCadenceZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                60: {
                    num: 60,
                    name: "timeInPowerZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                61: {
                    num: 61,
                    name: "repetitionNum",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                62: {
                    num: 62,
                    name: "minAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "113"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                63: {
                    num: 63,
                    name: "minHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                71: {
                    num: 71,
                    name: "wktStepIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                74: {
                    num: 74,
                    name: "opponentScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                75: {
                    num: 75,
                    name: "strokeCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                76: {
                    num: 76,
                    name: "zoneCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                77: {
                    num: 77,
                    name: "avgVerticalOscillation",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                78: {
                    num: 78,
                    name: "avgStanceTimePercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                79: {
                    num: 79,
                    name: "avgStanceTime",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                80: {
                    num: 80,
                    name: "avgFractionalCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                81: {
                    num: 81,
                    name: "maxFractionalCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                82: {
                    num: 82,
                    name: "totalFractionalCycles",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                83: {
                    num: 83,
                    name: "playerScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                84: {
                    num: 84,
                    name: "avgTotalHemoglobinConc",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                85: {
                    num: 85,
                    name: "minTotalHemoglobinConc",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                86: {
                    num: 86,
                    name: "maxTotalHemoglobinConc",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                87: {
                    num: 87,
                    name: "avgSaturatedHemoglobinPercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                88: {
                    num: 88,
                    name: "minSaturatedHemoglobinPercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                89: {
                    num: 89,
                    name: "maxSaturatedHemoglobinPercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                91: {
                    num: 91,
                    name: "avgLeftTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                92: {
                    num: 92,
                    name: "avgRightTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                93: {
                    num: 93,
                    name: "avgLeftPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                94: {
                    num: 94,
                    name: "avgRightPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                95: {
                    num: 95,
                    name: "avgCombinedPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                98: {
                    num: 98,
                    name: "timeStanding",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                99: {
                    num: 99,
                    name: "standCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                100: {
                    num: 100,
                    name: "avgLeftPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                101: {
                    num: 101,
                    name: "avgRightPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                102: {
                    num: 102,
                    name: "avgLeftPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                103: {
                    num: 103,
                    name: "avgLeftPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                104: {
                    num: 104,
                    name: "avgRightPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                105: {
                    num: 105,
                    name: "avgRightPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                106: {
                    num: 106,
                    name: "avgPowerPosition",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                107: {
                    num: 107,
                    name: "maxPowerPosition",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                108: {
                    num: 108,
                    name: "avgCadencePosition",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                109: {
                    num: 109,
                    name: "maxCadencePosition",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                110: {
                    num: 110,
                    name: "enhancedAvgSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                111: {
                    num: 111,
                    name: "enhancedMaxSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                112: {
                    num: 112,
                    name: "enhancedAvgAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                113: {
                    num: 113,
                    name: "enhancedMinAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                114: {
                    num: 114,
                    name: "enhancedMaxAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                115: {
                    num: 115,
                    name: "avgLevMotorPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                116: {
                    num: 116,
                    name: "maxLevMotorPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                117: {
                    num: 117,
                    name: "levBatteryConsumption",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                118: {
                    num: 118,
                    name: "avgVerticalRatio",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                119: {
                    num: 119,
                    name: "avgStanceTimeBalance",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                120: {
                    num: 120,
                    name: "avgStepLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                121: {
                    num: 121,
                    name: "avgVam",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                122: {
                    num: 122,
                    name: "avgDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                123: {
                    num: 123,
                    name: "maxDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                124: {
                    num: 124,
                    name: "minTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                136: {
                    num: 136,
                    name: "enhancedAvgRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "Breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                137: {
                    num: 137,
                    name: "enhancedMaxRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "Breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                147: {
                    num: 147,
                    name: "avgRespirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "136"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                148: {
                    num: 148,
                    name: "maxRespirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "137"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                149: {
                    num: 149,
                    name: "totalGrit",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kGrit",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                150: {
                    num: 150,
                    name: "totalFlow",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "Flow",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                151: {
                    num: 151,
                    name: "jumpCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                153: {
                    num: 153,
                    name: "avgGrit",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kGrit",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                154: {
                    num: 154,
                    name: "avgFlow",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "Flow",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                156: {
                    num: 156,
                    name: "totalFractionalAscent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                157: {
                    num: 157,
                    name: "totalFractionalDescent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                158: {
                    num: 158,
                    name: "avgCoreTemperature",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                159: {
                    num: 159,
                    name: "minCoreTemperature",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                160: {
                    num: 160,
                    name: "maxCoreTemperature",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        101: {
            num: 101,
            name: "length",
            messagesKey: "lengthMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "event",
                    type: "event",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "eventType",
                    type: "eventType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "startTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "totalElapsedTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "totalTimerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "totalStrokes",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "strokes",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "avgSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "swimStroke",
                    type: "swimStroke",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "swim_stroke",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "avgSwimmingCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "strokes/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "eventGroup",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "totalCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "lengthType",
                    type: "lengthType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "playerScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "opponentScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                20: {
                    num: 20,
                    name: "strokeCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "zoneCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "enhancedAvgRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "Breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "enhancedMaxRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "Breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "avgRespirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "22"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "maxRespirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "23"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                }
            }
        },
        20: {
            num: 20,
            name: "record",
            messagesKey: "recordMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "positionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "positionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "altitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "78"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "heartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "cadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "distance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: true,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "speed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1000
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "m/s"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "73"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "power",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "compressedSpeedDistance",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: [
                        100,
                        16
                    ],
                    offset: [
                        0,
                        0
                    ],
                    units: [
                        "m/s",
                        "m"
                    ],
                    bits: [
                        12,
                        12
                    ],
                    components: [
                        "6",
                        "5"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "grade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "resistance",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "timeFromCourse",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "cycleLength",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "temperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "speed1s",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 16,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "cycles",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "cycles"
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "19"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "totalCycles",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: true,
                    hasComponents: false,
                    subFields: []
                },
                28: {
                    num: 28,
                    name: "compressedAccumulatedPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "watts"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "29"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                29: {
                    num: 29,
                    name: "accumulatedPower",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: true,
                    hasComponents: false,
                    subFields: []
                },
                30: {
                    num: 30,
                    name: "leftRightBalance",
                    type: "leftRightBalance",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                31: {
                    num: 31,
                    name: "gpsAccuracy",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "verticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                33: {
                    num: 33,
                    name: "calories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                39: {
                    num: 39,
                    name: "verticalOscillation",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                40: {
                    num: 40,
                    name: "stanceTimePercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                41: {
                    num: 41,
                    name: "stanceTime",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                42: {
                    num: 42,
                    name: "activityType",
                    type: "activityType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                43: {
                    num: 43,
                    name: "leftTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                44: {
                    num: 44,
                    name: "rightTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                45: {
                    num: 45,
                    name: "leftPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                46: {
                    num: 46,
                    name: "rightPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                47: {
                    num: 47,
                    name: "combinedPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                48: {
                    num: 48,
                    name: "time128",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                49: {
                    num: 49,
                    name: "strokeType",
                    type: "strokeType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                50: {
                    num: 50,
                    name: "zone",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                51: {
                    num: 51,
                    name: "ballSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                52: {
                    num: 52,
                    name: "cadence256",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 256,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                53: {
                    num: 53,
                    name: "fractionalCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                54: {
                    num: 54,
                    name: "totalHemoglobinConc",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                55: {
                    num: 55,
                    name: "totalHemoglobinConcMin",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                56: {
                    num: 56,
                    name: "totalHemoglobinConcMax",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "g/dL",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                57: {
                    num: 57,
                    name: "saturatedHemoglobinPercent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                58: {
                    num: 58,
                    name: "saturatedHemoglobinPercentMin",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                59: {
                    num: 59,
                    name: "saturatedHemoglobinPercentMax",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                62: {
                    num: 62,
                    name: "deviceIndex",
                    type: "deviceIndex",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                67: {
                    num: 67,
                    name: "leftPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                68: {
                    num: 68,
                    name: "rightPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                69: {
                    num: 69,
                    name: "leftPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                70: {
                    num: 70,
                    name: "leftPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                71: {
                    num: 71,
                    name: "rightPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                72: {
                    num: 72,
                    name: "rightPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                73: {
                    num: 73,
                    name: "enhancedSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                78: {
                    num: 78,
                    name: "enhancedAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                81: {
                    num: 81,
                    name: "batterySoc",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                82: {
                    num: 82,
                    name: "motorPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                83: {
                    num: 83,
                    name: "verticalRatio",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                84: {
                    num: 84,
                    name: "stanceTimeBalance",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                85: {
                    num: 85,
                    name: "stepLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                87: {
                    num: 87,
                    name: "cycleLength16",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                91: {
                    num: 91,
                    name: "absolutePressure",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "Pa",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                92: {
                    num: 92,
                    name: "depth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                93: {
                    num: 93,
                    name: "nextStopDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                94: {
                    num: 94,
                    name: "nextStopTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                95: {
                    num: 95,
                    name: "timeToSurface",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                96: {
                    num: 96,
                    name: "ndlTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                97: {
                    num: 97,
                    name: "cnsLoad",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                98: {
                    num: 98,
                    name: "n2Load",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                99: {
                    num: 99,
                    name: "respirationRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "s"
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "108"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                108: {
                    num: 108,
                    name: "enhancedRespirationRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "Breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                114: {
                    num: 114,
                    name: "grit",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                115: {
                    num: 115,
                    name: "flow",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                116: {
                    num: 116,
                    name: "currentStress",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                117: {
                    num: 117,
                    name: "ebikeTravelRange",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "km",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                118: {
                    num: 118,
                    name: "ebikeBatteryLevel",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                119: {
                    num: 119,
                    name: "ebikeAssistMode",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "depends on sensor",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                120: {
                    num: 120,
                    name: "ebikeAssistLevelPercent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                123: {
                    num: 123,
                    name: "airTimeRemaining",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                124: {
                    num: 124,
                    name: "pressureSac",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "bar/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                125: {
                    num: 125,
                    name: "volumeSac",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "L/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                126: {
                    num: 126,
                    name: "rmv",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "L/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                127: {
                    num: 127,
                    name: "ascentRate",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                129: {
                    num: 129,
                    name: "po2",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                139: {
                    num: 139,
                    name: "coreTemperature",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        21: {
            num: 21,
            name: "event",
            messagesKey: "eventMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "event",
                    type: "event",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "eventType",
                    type: "eventType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "data16",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        ""
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "3"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "data",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "timerTrigger",
                            type: "timerTrigger",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "coursePointIndex",
                            type: "messageIndex",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 10
                                }
                            ]
                        },
                        {
                            name: "batteryLevel",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1000,
                            offset: 0,
                            units: "V",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 11
                                }
                            ]
                        },
                        {
                            name: "virtualPartnerSpeed",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1000,
                            offset: 0,
                            units: "m/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 12
                                }
                            ]
                        },
                        {
                            name: "hrHighAlert",
                            type: "uint8",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 13
                                }
                            ]
                        },
                        {
                            name: "hrLowAlert",
                            type: "uint8",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 14
                                }
                            ]
                        },
                        {
                            name: "speedHighAlert",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "m/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 15
                                }
                            ]
                        },
                        {
                            name: "speedLowAlert",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "m/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 16
                                }
                            ]
                        },
                        {
                            name: "cadHighAlert",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "rpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 17
                                }
                            ]
                        },
                        {
                            name: "cadLowAlert",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "rpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 18
                                }
                            ]
                        },
                        {
                            name: "powerHighAlert",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 19
                                }
                            ]
                        },
                        {
                            name: "powerLowAlert",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 20
                                }
                            ]
                        },
                        {
                            name: "timeDurationAlert",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 23
                                }
                            ]
                        },
                        {
                            name: "distanceDurationAlert",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 100,
                            offset: 0,
                            units: "m",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 24
                                }
                            ]
                        },
                        {
                            name: "calorieDurationAlert",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "calories",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 25
                                }
                            ]
                        },
                        {
                            name: "fitnessEquipmentState",
                            type: "fitnessEquipmentState",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 27
                                }
                            ]
                        },
                        {
                            name: "sportPoint",
                            type: "uint32",
                            baseType: "uint32",
                            scale: [
                                1,
                                1
                            ],
                            offset: [
                                0,
                                0
                            ],
                            units: [
                                "",
                                ""
                            ],
                            bits: [
                                16,
                                16
                            ],
                            components: [
                                "7",
                                "8"
                            ],
                            hasComponents: true,
                            map: [
                                {
                                    name: "event",
                                    value: 33
                                }
                            ]
                        },
                        {
                            name: "gearChangeData",
                            type: "uint32",
                            baseType: "uint32",
                            scale: [
                                1,
                                1,
                                1,
                                1
                            ],
                            offset: [
                                0,
                                0,
                                0,
                                0
                            ],
                            units: [
                                "",
                                "",
                                "",
                                ""
                            ],
                            bits: [
                                8,
                                8,
                                8,
                                8
                            ],
                            components: [
                                "11",
                                "12",
                                "9",
                                "10"
                            ],
                            hasComponents: true,
                            map: [
                                {
                                    name: "event",
                                    value: 42
                                },
                                {
                                    name: "event",
                                    value: 43
                                }
                            ]
                        },
                        {
                            name: "riderPosition",
                            type: "riderPositionType",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 44
                                }
                            ]
                        },
                        {
                            name: "commTimeout",
                            type: "commTimeoutType",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 47
                                }
                            ]
                        },
                        {
                            name: "diveAlert",
                            type: "diveAlert",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 56
                                }
                            ]
                        },
                        {
                            name: "autoActivityDetectDuration",
                            type: "uint16",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "min",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 54
                                }
                            ]
                        },
                        {
                            name: "radarThreatAlert",
                            type: "uint32",
                            baseType: "uint32",
                            scale: [
                                1,
                                1,
                                10,
                                10
                            ],
                            offset: [
                                0,
                                0,
                                0,
                                0
                            ],
                            units: [
                                "",
                                "",
                                "",
                                ""
                            ],
                            bits: [
                                8,
                                8,
                                8,
                                8
                            ],
                            components: [
                                "21",
                                "22",
                                "23",
                                "24"
                            ],
                            hasComponents: true,
                            map: [
                                {
                                    name: "event",
                                    value: 75
                                }
                            ]
                        }
                    ]
                },
                4: {
                    num: 4,
                    name: "eventGroup",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "score",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "opponentScore",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "frontGearNum",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "frontGear",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "rearGearNum",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "rearGear",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "deviceIndex",
                    type: "deviceIndex",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "activityType",
                    type: "activityType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "startTimestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "autoActivityDetectStartTimestamp",
                            type: "dateTime",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "event",
                                    value: 54
                                }
                            ]
                        }
                    ]
                },
                21: {
                    num: 21,
                    name: "radarThreatLevelMax",
                    type: "radarThreatLevelType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "radarThreatCount",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "radarThreatAvgApproachSpeed",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "radarThreatMaxApproachSpeed",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        23: {
            num: 23,
            name: "deviceInfo",
            messagesKey: "deviceInfoMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "deviceIndex",
                    type: "deviceIndex",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "deviceType",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "bleDeviceType",
                            type: "bleDeviceType",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sourceType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "antplusDeviceType",
                            type: "antplusDeviceType",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sourceType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "antDeviceType",
                            type: "uint8",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sourceType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "localDeviceType",
                            type: "localDeviceType",
                            baseType: "uint8",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sourceType",
                                    value: 5
                                }
                            ]
                        }
                    ]
                },
                2: {
                    num: 2,
                    name: "manufacturer",
                    type: "manufacturer",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "serialNumber",
                    type: "uint32z",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "product",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "faveroProduct",
                            type: "faveroProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 263
                                }
                            ]
                        },
                        {
                            name: "garminProduct",
                            type: "garminProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 1
                                },
                                {
                                    name: "manufacturer",
                                    value: 15
                                },
                                {
                                    name: "manufacturer",
                                    value: 13
                                },
                                {
                                    name: "manufacturer",
                                    value: 89
                                }
                            ]
                        }
                    ]
                },
                5: {
                    num: 5,
                    name: "softwareVersion",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "hardwareVersion",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "cumOperatingTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "batteryVoltage",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 256,
                    offset: 0,
                    units: "V",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "batteryStatus",
                    type: "batteryStatus",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "sensorPosition",
                    type: "bodyLocation",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "descriptor",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                20: {
                    num: 20,
                    name: "antTransmissionType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "antDeviceNumber",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "antNetwork",
                    type: "antNetwork",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "sourceType",
                    type: "sourceType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                27: {
                    num: 27,
                    name: "productName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "batteryLevel",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        375: {
            num: 375,
            name: "deviceAuxBatteryInfo",
            messagesKey: "deviceAuxBatteryInfoMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "deviceIndex",
                    type: "deviceIndex",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "batteryVoltage",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 256,
                    offset: 0,
                    units: "V",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "batteryStatus",
                    type: "batteryStatus",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "batteryIdentifier",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        72: {
            num: 72,
            name: "trainingFile",
            messagesKey: "trainingFileMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "type",
                    type: "file",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "manufacturer",
                    type: "manufacturer",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "product",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "faveroProduct",
                            type: "faveroProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 263
                                }
                            ]
                        },
                        {
                            name: "garminProduct",
                            type: "garminProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 1
                                },
                                {
                                    name: "manufacturer",
                                    value: 15
                                },
                                {
                                    name: "manufacturer",
                                    value: 13
                                },
                                {
                                    name: "manufacturer",
                                    value: 89
                                }
                            ]
                        }
                    ]
                },
                3: {
                    num: 3,
                    name: "serialNumber",
                    type: "uint32z",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "timeCreated",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        128: {
            num: 128,
            name: "weatherConditions",
            messagesKey: "weatherConditionsMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "weatherReport",
                    type: "weatherReport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "temperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "condition",
                    type: "weatherStatus",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "windDirection",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "windSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "precipitationProbability",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "temperatureFeelsLike",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "relativeHumidity",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "location",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "observedAtTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "observedLocationLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "observedLocationLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "dayOfWeek",
                    type: "dayOfWeek",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "highTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "lowTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        129: {
            num: 129,
            name: "weatherAlert",
            messagesKey: "weatherAlertMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "reportId",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "issueTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "expireTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "severity",
                    type: "weatherSeverity",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "type",
                    type: "weatherSevereType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        160: {
            num: 160,
            name: "gpsMetadata",
            messagesKey: "gpsMetadataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "positionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "positionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "enhancedAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "enhancedSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "heading",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "utcTimestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "velocity",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        161: {
            num: 161,
            name: "cameraEvent",
            messagesKey: "cameraEventMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "cameraEventType",
                    type: "cameraEventType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "cameraFileUuid",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "cameraOrientation",
                    type: "cameraOrientationType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        164: {
            num: 164,
            name: "gyroscopeData",
            messagesKey: "gyroscopeDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sampleTimeOffset",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "gyroX",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "gyroY",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "gyroZ",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "calibratedGyroX",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "deg/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "calibratedGyroY",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "deg/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "calibratedGyroZ",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "deg/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        165: {
            num: 165,
            name: "accelerometerData",
            messagesKey: "accelerometerDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sampleTimeOffset",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "accelX",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "accelY",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "accelZ",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "calibratedAccelX",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "g",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "calibratedAccelY",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "g",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "calibratedAccelZ",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "g",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "compressedCalibratedAccelX",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "mG",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "compressedCalibratedAccelY",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "mG",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "compressedCalibratedAccelZ",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "mG",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        208: {
            num: 208,
            name: "magnetometerData",
            messagesKey: "magnetometerDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sampleTimeOffset",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "magX",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "magY",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "magZ",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "calibratedMagX",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "G",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "calibratedMagY",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "G",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "calibratedMagZ",
                    type: "float32",
                    baseType: "float32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "G",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        209: {
            num: 209,
            name: "barometerData",
            messagesKey: "barometerDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sampleTimeOffset",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "baroPres",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "Pa",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        167: {
            num: 167,
            name: "threeDSensorCalibration",
            messagesKey: "threeDSensorCalibrationMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "sensorType",
                    type: "sensorType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "calibrationFactor",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "accelCalFactor",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "g",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sensorType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "gyroCalFactor",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "deg/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sensorType",
                                    value: 1
                                }
                            ]
                        }
                    ]
                },
                2: {
                    num: 2,
                    name: "calibrationDivisor",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "levelShift",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "offsetCal",
                    type: "sint32",
                    baseType: "sint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "orientationMatrix",
                    type: "sint32",
                    baseType: "sint32",
                    array: true,
                    scale: 65535,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        210: {
            num: 210,
            name: "oneDSensorCalibration",
            messagesKey: "oneDSensorCalibrationMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "sensorType",
                    type: "sensorType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "calibrationFactor",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "baroCalFactor",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "Pa",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sensorType",
                                    value: 3
                                }
                            ]
                        }
                    ]
                },
                2: {
                    num: 2,
                    name: "calibrationDivisor",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "counts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "levelShift",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "offsetCal",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        169: {
            num: 169,
            name: "videoFrame",
            messagesKey: "videoFrameMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "frameNumber",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        174: {
            num: 174,
            name: "obdiiData",
            messagesKey: "obdiiDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "timeOffset",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "pid",
                    type: "byte",
                    baseType: "byte",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "rawData",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "pidDataSize",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "systemTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "startTimestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "startTimestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        177: {
            num: 177,
            name: "nmeaSentence",
            messagesKey: "nmeaSentenceMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "sentence",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        178: {
            num: 178,
            name: "aviationAttitude",
            messagesKey: "aviationAttitudeMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "systemTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "pitch",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 10430.38,
                    offset: 0,
                    units: "radians",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "roll",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 10430.38,
                    offset: 0,
                    units: "radians",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "accelLateral",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "m/s^2",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "accelNormal",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "m/s^2",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "turnRate",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1024,
                    offset: 0,
                    units: "radians/second",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "stage",
                    type: "attitudeStage",
                    baseType: "enum",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "attitudeStageComplete",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "track",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 10430.38,
                    offset: 0,
                    units: "radians",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "validity",
                    type: "attitudeValidity",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        184: {
            num: 184,
            name: "video",
            messagesKey: "videoMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "url",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "hostingProvider",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "duration",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        185: {
            num: 185,
            name: "videoTitle",
            messagesKey: "videoTitleMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "messageCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "text",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        186: {
            num: 186,
            name: "videoDescription",
            messagesKey: "videoDescriptionMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "messageCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "text",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        187: {
            num: 187,
            name: "videoClip",
            messagesKey: "videoClipMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "clipNumber",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "startTimestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "startTimestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "endTimestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "endTimestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "clipStart",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "clipEnd",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        225: {
            num: 225,
            name: "set",
            messagesKey: "setMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "duration",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "repetitions",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "weight",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 16,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "setType",
                    type: "setType",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "startTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "category",
                    type: "exerciseCategory",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "categorySubtype",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "weightDisplayUnit",
                    type: "fitBaseUnit",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "wktStepIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        285: {
            num: 285,
            name: "jump",
            messagesKey: "jumpMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "distance",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "height",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "rotations",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "hangTime",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "score",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "positionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "positionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "speed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        1000
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "m/s"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "8"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "enhancedSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        312: {
            num: 312,
            name: "split",
            messagesKey: "splitMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "splitType",
                    type: "splitType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "totalElapsedTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "totalTimerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "totalDistance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "avgSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "startTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "totalAscent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "totalDescent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "startPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "startPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "endPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "endPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "maxSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                26: {
                    num: 26,
                    name: "avgVertSpeed",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                27: {
                    num: 27,
                    name: "endTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                28: {
                    num: 28,
                    name: "totalCalories",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                74: {
                    num: 74,
                    name: "startElevation",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                110: {
                    num: 110,
                    name: "totalMovingTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        313: {
            num: 313,
            name: "splitSummary",
            messagesKey: "splitSummaryMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "splitType",
                    type: "splitType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "numSplits",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "totalTimerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "totalDistance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "avgSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "maxSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "totalAscent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "totalDescent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "avgHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "maxHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "avgVertSpeed",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "totalCalories",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                77: {
                    num: 77,
                    name: "totalMovingTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        317: {
            num: 317,
            name: "climbPro",
            messagesKey: "climbProMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "positionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "positionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "climbProEvent",
                    type: "climbProEvent",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "climbNumber",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "climbCategory",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "currentDist",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        206: {
            num: 206,
            name: "fieldDescription",
            messagesKey: "fieldDescriptionMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "developerDataIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "fieldDefinitionNumber",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "fitBaseTypeId",
                    type: "fitBaseType",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "fieldName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "array",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "components",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "scale",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "offset",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "units",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "bits",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "accumulate",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "fitBaseUnitId",
                    type: "fitBaseUnit",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "nativeMesgNum",
                    type: "mesgNum",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "nativeFieldNum",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        207: {
            num: 207,
            name: "developerDataId",
            messagesKey: "developerDataIdMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "developerId",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "applicationId",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "manufacturerId",
                    type: "manufacturer",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "developerDataIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "applicationVersion",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        31: {
            num: 31,
            name: "course",
            messagesKey: "courseMesgs",
            fields: {
                4: {
                    num: 4,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "capabilities",
                    type: "courseCapabilities",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        32: {
            num: 32,
            name: "coursePoint",
            messagesKey: "coursePointMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "positionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "positionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "distance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "type",
                    type: "coursePoint",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "favorite",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        148: {
            num: 148,
            name: "segmentId",
            messagesKey: "segmentIdMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "uuid",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "userProfilePrimaryKey",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "deviceId",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "defaultRaceLeader",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "deleteStatus",
                    type: "segmentDeleteStatus",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "selectionType",
                    type: "segmentSelectionType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        149: {
            num: 149,
            name: "segmentLeaderboardEntry",
            messagesKey: "segmentLeaderboardEntryMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "type",
                    type: "segmentLeaderboardType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "groupPrimaryKey",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "activityId",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "segmentTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "activityIdString",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        150: {
            num: 150,
            name: "segmentPoint",
            messagesKey: "segmentPointMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "positionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "positionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "distance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "altitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "6"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "leaderTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "enhancedAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        142: {
            num: 142,
            name: "segmentLap",
            messagesKey: "segmentLapMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "event",
                    type: "event",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "eventType",
                    type: "eventType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "startTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "startPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "startPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "endPositionLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "endPositionLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "totalElapsedTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "totalTimerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "totalDistance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "totalCycles",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "totalStrokes",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "strokes",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "sport",
                                    value: 2
                                }
                            ]
                        }
                    ]
                },
                11: {
                    num: 11,
                    name: "totalCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "totalFatCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "avgSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "maxSpeed",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "avgHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "maxHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "avgCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                18: {
                    num: 18,
                    name: "maxCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "avgPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                20: {
                    num: 20,
                    name: "maxPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                21: {
                    num: 21,
                    name: "totalAscent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "totalDescent",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "eventGroup",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "necLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                26: {
                    num: 26,
                    name: "necLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                27: {
                    num: 27,
                    name: "swcLat",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                28: {
                    num: 28,
                    name: "swcLong",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "semicircles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                29: {
                    num: 29,
                    name: "name",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                30: {
                    num: 30,
                    name: "normalizedPower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                31: {
                    num: 31,
                    name: "leftRightBalance",
                    type: "leftRightBalance100",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                33: {
                    num: 33,
                    name: "totalWork",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "J",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                34: {
                    num: 34,
                    name: "avgAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "91"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                35: {
                    num: 35,
                    name: "maxAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "92"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                36: {
                    num: 36,
                    name: "gpsAccuracy",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                37: {
                    num: 37,
                    name: "avgGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                38: {
                    num: 38,
                    name: "avgPosGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                39: {
                    num: 39,
                    name: "avgNegGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                40: {
                    num: 40,
                    name: "maxPosGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                41: {
                    num: 41,
                    name: "maxNegGrade",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                42: {
                    num: 42,
                    name: "avgTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                43: {
                    num: 43,
                    name: "maxTemperature",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                44: {
                    num: 44,
                    name: "totalMovingTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                45: {
                    num: 45,
                    name: "avgPosVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                46: {
                    num: 46,
                    name: "avgNegVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                47: {
                    num: 47,
                    name: "maxPosVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                48: {
                    num: 48,
                    name: "maxNegVerticalSpeed",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                49: {
                    num: 49,
                    name: "timeInHrZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                50: {
                    num: 50,
                    name: "timeInSpeedZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                51: {
                    num: 51,
                    name: "timeInCadenceZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                52: {
                    num: 52,
                    name: "timeInPowerZone",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                53: {
                    num: 53,
                    name: "repetitionNum",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                54: {
                    num: 54,
                    name: "minAltitude",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: [
                        5
                    ],
                    offset: [
                        500
                    ],
                    units: [
                        "m"
                    ],
                    bits: [
                        16
                    ],
                    components: [
                        "93"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                55: {
                    num: 55,
                    name: "minHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                56: {
                    num: 56,
                    name: "activeTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                57: {
                    num: 57,
                    name: "wktStepIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                58: {
                    num: 58,
                    name: "sportEvent",
                    type: "sportEvent",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                59: {
                    num: 59,
                    name: "avgLeftTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                60: {
                    num: 60,
                    name: "avgRightTorqueEffectiveness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                61: {
                    num: 61,
                    name: "avgLeftPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                62: {
                    num: 62,
                    name: "avgRightPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                63: {
                    num: 63,
                    name: "avgCombinedPedalSmoothness",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                64: {
                    num: 64,
                    name: "status",
                    type: "segmentLapStatus",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                65: {
                    num: 65,
                    name: "uuid",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                66: {
                    num: 66,
                    name: "avgFractionalCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                67: {
                    num: 67,
                    name: "maxFractionalCadence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                68: {
                    num: 68,
                    name: "totalFractionalCycles",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                69: {
                    num: 69,
                    name: "frontGearShiftCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                70: {
                    num: 70,
                    name: "rearGearShiftCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                71: {
                    num: 71,
                    name: "timeStanding",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                72: {
                    num: 72,
                    name: "standCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                73: {
                    num: 73,
                    name: "avgLeftPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                74: {
                    num: 74,
                    name: "avgRightPco",
                    type: "sint8",
                    baseType: "sint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                75: {
                    num: 75,
                    name: "avgLeftPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                76: {
                    num: 76,
                    name: "avgLeftPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                77: {
                    num: 77,
                    name: "avgRightPowerPhase",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                78: {
                    num: 78,
                    name: "avgRightPowerPhasePeak",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 0.7111111,
                    offset: 0,
                    units: "degrees",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                79: {
                    num: 79,
                    name: "avgPowerPosition",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                80: {
                    num: 80,
                    name: "maxPowerPosition",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "watts",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                81: {
                    num: 81,
                    name: "avgCadencePosition",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                82: {
                    num: 82,
                    name: "maxCadencePosition",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "rpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                83: {
                    num: 83,
                    name: "manufacturer",
                    type: "manufacturer",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                84: {
                    num: 84,
                    name: "totalGrit",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kGrit",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                85: {
                    num: 85,
                    name: "totalFlow",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "Flow",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                86: {
                    num: 86,
                    name: "avgGrit",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kGrit",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                87: {
                    num: 87,
                    name: "avgFlow",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "Flow",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                89: {
                    num: 89,
                    name: "totalFractionalAscent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                90: {
                    num: 90,
                    name: "totalFractionalDescent",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                91: {
                    num: 91,
                    name: "enhancedAvgAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                92: {
                    num: 92,
                    name: "enhancedMaxAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                93: {
                    num: 93,
                    name: "enhancedMinAltitude",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 5,
                    offset: 500,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        151: {
            num: 151,
            name: "segmentFile",
            messagesKey: "segmentFileMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "fileUuid",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "enabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "userProfilePrimaryKey",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "leaderType",
                    type: "segmentLeaderboardType",
                    baseType: "enum",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "leaderGroupPrimaryKey",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "leaderActivityId",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "leaderActivityIdString",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "defaultRaceLeader",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        26: {
            num: 26,
            name: "workout",
            messagesKey: "workoutMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "capabilities",
                    type: "workoutCapabilities",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "numValidSteps",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "wktName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "poolLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "poolLengthUnit",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "wktDescription",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        158: {
            num: 158,
            name: "workoutSession",
            messagesKey: "workoutSessionMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "numValidSteps",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "firstStepIndex",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "poolLength",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "poolLengthUnit",
                    type: "displayMeasure",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        27: {
            num: 27,
            name: "workoutStep",
            messagesKey: "workoutStepMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "wktStepName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "durationType",
                    type: "wktStepDuration",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "durationValue",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "durationTime",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 0
                                },
                                {
                                    name: "durationType",
                                    value: 28
                                }
                            ]
                        },
                        {
                            name: "durationDistance",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 100,
                            offset: 0,
                            units: "m",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "durationHr",
                            type: "workoutHr",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 2
                                },
                                {
                                    name: "durationType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "durationCalories",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "calories",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 4
                                }
                            ]
                        },
                        {
                            name: "durationStep",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 6
                                },
                                {
                                    name: "durationType",
                                    value: 7
                                },
                                {
                                    name: "durationType",
                                    value: 8
                                },
                                {
                                    name: "durationType",
                                    value: 9
                                },
                                {
                                    name: "durationType",
                                    value: 10
                                },
                                {
                                    name: "durationType",
                                    value: 11
                                },
                                {
                                    name: "durationType",
                                    value: 12
                                },
                                {
                                    name: "durationType",
                                    value: 13
                                }
                            ]
                        },
                        {
                            name: "durationPower",
                            type: "workoutPower",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 14
                                },
                                {
                                    name: "durationType",
                                    value: 15
                                }
                            ]
                        },
                        {
                            name: "durationReps",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 29
                                }
                            ]
                        }
                    ]
                },
                3: {
                    num: 3,
                    name: "targetType",
                    type: "wktStepTarget",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "targetValue",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "targetSpeedZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "targetHrZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "targetCadenceZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "targetPowerZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 4
                                }
                            ]
                        },
                        {
                            name: "repeatSteps",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 6
                                }
                            ]
                        },
                        {
                            name: "repeatTime",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 7
                                }
                            ]
                        },
                        {
                            name: "repeatDistance",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 100,
                            offset: 0,
                            units: "m",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 8
                                }
                            ]
                        },
                        {
                            name: "repeatCalories",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "calories",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 9
                                }
                            ]
                        },
                        {
                            name: "repeatHr",
                            type: "workoutHr",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 10
                                },
                                {
                                    name: "durationType",
                                    value: 11
                                }
                            ]
                        },
                        {
                            name: "repeatPower",
                            type: "workoutPower",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "durationType",
                                    value: 12
                                },
                                {
                                    name: "durationType",
                                    value: 13
                                }
                            ]
                        },
                        {
                            name: "targetStrokeType",
                            type: "swimStroke",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 11
                                }
                            ]
                        }
                    ]
                },
                5: {
                    num: 5,
                    name: "customTargetValueLow",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "customTargetSpeedLow",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "m/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "customTargetHeartRateLow",
                            type: "workoutHr",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "customTargetCadenceLow",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "rpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "customTargetPowerLow",
                            type: "workoutPower",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 4
                                }
                            ]
                        }
                    ]
                },
                6: {
                    num: 6,
                    name: "customTargetValueHigh",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "customTargetSpeedHigh",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "m/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "customTargetHeartRateHigh",
                            type: "workoutHr",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "customTargetCadenceHigh",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "rpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "customTargetPowerHigh",
                            type: "workoutPower",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "targetType",
                                    value: 4
                                }
                            ]
                        }
                    ]
                },
                7: {
                    num: 7,
                    name: "intensity",
                    type: "intensity",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "notes",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "equipment",
                    type: "workoutEquipment",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "exerciseCategory",
                    type: "exerciseCategory",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "exerciseName",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "exerciseWeight",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "weightDisplayUnit",
                    type: "fitBaseUnit",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "secondaryTargetType",
                    type: "wktStepTarget",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                20: {
                    num: 20,
                    name: "secondaryTargetValue",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "secondaryTargetSpeedZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "secondaryTargetHrZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "secondaryTargetCadenceZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "secondaryTargetPowerZone",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 4
                                }
                            ]
                        },
                        {
                            name: "secondaryTargetStrokeType",
                            type: "swimStroke",
                            baseType: "enum",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 11
                                }
                            ]
                        }
                    ]
                },
                21: {
                    num: 21,
                    name: "secondaryCustomTargetValueLow",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "secondaryCustomTargetSpeedLow",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "m/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "secondaryCustomTargetHeartRateLow",
                            type: "workoutHr",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "secondaryCustomTargetCadenceLow",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "rpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "secondaryCustomTargetPowerLow",
                            type: "workoutPower",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 4
                                }
                            ]
                        }
                    ]
                },
                22: {
                    num: 22,
                    name: "secondaryCustomTargetValueHigh",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "secondaryCustomTargetSpeedHigh",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1000,
                            offset: 0,
                            units: "m/s",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 0
                                }
                            ]
                        },
                        {
                            name: "secondaryCustomTargetHeartRateHigh",
                            type: "workoutHr",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or bpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "secondaryCustomTargetCadenceHigh",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "rpm",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 3
                                }
                            ]
                        },
                        {
                            name: "secondaryCustomTargetPowerHigh",
                            type: "workoutPower",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "% or watts",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "secondaryTargetType",
                                    value: 4
                                }
                            ]
                        }
                    ]
                }
            }
        },
        264: {
            num: 264,
            name: "exerciseTitle",
            messagesKey: "exerciseTitleMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "exerciseCategory",
                    type: "exerciseCategory",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "exerciseName",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "wktStepName",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        28: {
            num: 28,
            name: "schedule",
            messagesKey: "scheduleMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "manufacturer",
                    type: "manufacturer",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "product",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "faveroProduct",
                            type: "faveroProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 263
                                }
                            ]
                        },
                        {
                            name: "garminProduct",
                            type: "garminProduct",
                            baseType: "uint16",
                            scale: 1,
                            offset: 0,
                            units: "",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "manufacturer",
                                    value: 1
                                },
                                {
                                    name: "manufacturer",
                                    value: 15
                                },
                                {
                                    name: "manufacturer",
                                    value: 13
                                },
                                {
                                    name: "manufacturer",
                                    value: 89
                                }
                            ]
                        }
                    ]
                },
                2: {
                    num: 2,
                    name: "serialNumber",
                    type: "uint32z",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "timeCreated",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "completed",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "type",
                    type: "schedule",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "scheduledTime",
                    type: "localDateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        33: {
            num: 33,
            name: "totals",
            messagesKey: "totalsMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timerTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "distance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "calories",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "elapsedTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "sessions",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "activeTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "sportIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        30: {
            num: 30,
            name: "weightScale",
            messagesKey: "weightScaleMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "weight",
                    type: "weight",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "percentFat",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "percentHydration",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "%",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "visceralFatMass",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "boneMass",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "muscleMass",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "kg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "basalMet",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 4,
                    offset: 0,
                    units: "kcal/day",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "physiqueRating",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "activeMet",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 4,
                    offset: 0,
                    units: "kcal/day",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "metabolicAge",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "years",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "visceralFatRating",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "userProfileIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "bmi",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "kg/m^2",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        51: {
            num: 51,
            name: "bloodPressure",
            messagesKey: "bloodPressureMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "systolicPressure",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mmHg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "diastolicPressure",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mmHg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "meanArterialPressure",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mmHg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "map3SampleMean",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mmHg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "mapMorningValues",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mmHg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "mapEveningValues",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "mmHg",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "heartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "heartRateType",
                    type: "hrType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "status",
                    type: "bpStatus",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "userProfileIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        103: {
            num: 103,
            name: "monitoringInfo",
            messagesKey: "monitoringInfoMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "localTimestamp",
                    type: "localDateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "activityType",
                    type: "activityType",
                    baseType: "enum",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "cyclesToDistance",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 5000,
                    offset: 0,
                    units: "m/cycle",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "cyclesToCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 5000,
                    offset: 0,
                    units: "kcal/cycle",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "restingMetabolicRate",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal / day",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        55: {
            num: 55,
            name: "monitoring",
            messagesKey: "monitoringMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "deviceIndex",
                    type: "deviceIndex",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "calories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "distance",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "cycles",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 2,
                    offset: 0,
                    units: "cycles",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: [
                        {
                            name: "steps",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 1,
                            offset: 0,
                            units: "steps",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "activityType",
                                    value: 6
                                },
                                {
                                    name: "activityType",
                                    value: 1
                                }
                            ]
                        },
                        {
                            name: "strokes",
                            type: "uint32",
                            baseType: "uint32",
                            scale: 2,
                            offset: 0,
                            units: "strokes",
                            bits: [],
                            components: [],
                            hasComponents: false,
                            map: [
                                {
                                    name: "activityType",
                                    value: 2
                                },
                                {
                                    name: "activityType",
                                    value: 5
                                }
                            ]
                        }
                    ]
                },
                4: {
                    num: 4,
                    name: "activeTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "activityType",
                    type: "activityType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "activitySubtype",
                    type: "activitySubtype",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "activityLevel",
                    type: "activityLevel",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "distance16",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "100 * m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "cycles16",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "2 * cycles (steps)",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "activeTime16",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "localTimestamp",
                    type: "localDateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "temperature",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "temperatureMin",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "temperatureMax",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "C",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "activityTime",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "minutes",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                19: {
                    num: 19,
                    name: "activeCalories",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "kcal",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "currentActivityTypeIntensity",
                    type: "byte",
                    baseType: "byte",
                    array: false,
                    scale: [
                        1,
                        1
                    ],
                    offset: [
                        0,
                        0
                    ],
                    units: [
                        "",
                        ""
                    ],
                    bits: [
                        5,
                        3
                    ],
                    components: [
                        "5",
                        "28"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "timestampMin8",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                26: {
                    num: 26,
                    name: "timestamp16",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                27: {
                    num: 27,
                    name: "heartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                28: {
                    num: 28,
                    name: "intensity",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                29: {
                    num: 29,
                    name: "durationMin",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                30: {
                    num: 30,
                    name: "duration",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                31: {
                    num: 31,
                    name: "ascent",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                32: {
                    num: 32,
                    name: "descent",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                33: {
                    num: 33,
                    name: "moderateActivityMinutes",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "minutes",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                34: {
                    num: 34,
                    name: "vigorousActivityMinutes",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "minutes",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        211: {
            num: 211,
            name: "monitoringHrData",
            messagesKey: "monitoringHrDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "restingHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "currentDayRestingHeartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        269: {
            num: 269,
            name: "spo2Data",
            messagesKey: "spo2DataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "readingSpo2",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "readingConfidence",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "mode",
                    type: "spo2MeasurementType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        132: {
            num: 132,
            name: "hr",
            messagesKey: "hrMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "fractionalTimestamp",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 32768,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "time256",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: [
                        256
                    ],
                    offset: [
                        0
                    ],
                    units: [
                        "s"
                    ],
                    bits: [
                        8
                    ],
                    components: [
                        "0"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "filteredBpm",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "eventTimestamp",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1024,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: true,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "eventTimestamp12",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: [
                        1024,
                        1024,
                        1024,
                        1024,
                        1024,
                        1024,
                        1024,
                        1024,
                        1024,
                        1024
                    ],
                    offset: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    units: [
                        "s",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ],
                    bits: [
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12
                    ],
                    components: [
                        "9",
                        "9",
                        "9",
                        "9",
                        "9",
                        "9",
                        "9",
                        "9",
                        "9",
                        "9"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                }
            }
        },
        227: {
            num: 227,
            name: "stressLevel",
            messagesKey: "stressLevelMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "stressLevelValue",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "stressLevelTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        229: {
            num: 229,
            name: "maxMetData",
            messagesKey: "maxMetDataMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "updateTime",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "vo2Max",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "mL/kg/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "sport",
                    type: "sport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "subSport",
                    type: "subSport",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "maxMetCategory",
                    type: "maxMetCategory",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "calibratedData",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "hrSource",
                    type: "maxMetHeartRateSource",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "speedSource",
                    type: "maxMetSpeedSource",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        314: {
            num: 314,
            name: "hsaBodyBatteryData",
            messagesKey: "hsaBodyBatteryDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "processingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "level",
                    type: "sint8",
                    baseType: "sint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "charged",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "uncharged",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        315: {
            num: 315,
            name: "hsaEvent",
            messagesKey: "hsaEventMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "eventId",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        302: {
            num: 302,
            name: "hsaAccelerometerData",
            messagesKey: "hsaAccelerometerDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "samplingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "accelX",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1.024,
                    offset: 0,
                    units: "mG",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "accelY",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1.024,
                    offset: 0,
                    units: "mG",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "accelZ",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 1.024,
                    offset: 0,
                    units: "mG",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "timestamp32k",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        376: {
            num: 376,
            name: "hsaGyroscopeData",
            messagesKey: "hsaGyroscopeDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "samplingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "1/32768 s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "gyroX",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 28.57143,
                    offset: 0,
                    units: "deg/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "gyroY",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 28.57143,
                    offset: 0,
                    units: "deg/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "gyroZ",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 28.57143,
                    offset: 0,
                    units: "deg/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "timestamp32k",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "1/32768 s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        304: {
            num: 304,
            name: "hsaStepData",
            messagesKey: "hsaStepDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "processingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "steps",
                    type: "uint32",
                    baseType: "uint32",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "steps",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        305: {
            num: 305,
            name: "hsaSpo2Data",
            messagesKey: "hsaSpo2DataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "processingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "readingSpo2",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "confidence",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        306: {
            num: 306,
            name: "hsaStressData",
            messagesKey: "hsaStressDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "processingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "stressLevel",
                    type: "sint8",
                    baseType: "sint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        307: {
            num: 307,
            name: "hsaRespirationData",
            messagesKey: "hsaRespirationDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "processingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "respirationRate",
                    type: "sint16",
                    baseType: "sint16",
                    array: true,
                    scale: 100,
                    offset: 0,
                    units: "breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        308: {
            num: 308,
            name: "hsaHeartRateData",
            messagesKey: "hsaHeartRateDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "processingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "status",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "heartRate",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "bpm",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        389: {
            num: 389,
            name: "hsaConfigurationData",
            messagesKey: "hsaConfigurationDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "data",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "dataSize",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        409: {
            num: 409,
            name: "hsaWristTemperatureData",
            messagesKey: "hsaWristTemperatureDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "processingInterval",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "value",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "degC",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        145: {
            num: 145,
            name: "memoGlob",
            messagesKey: "memoGlobMesgs",
            fields: {
                250: {
                    num: 250,
                    name: "partIndex",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "memo",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "mesgNum",
                    type: "mesgNum",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "parentIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "fieldNum",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "data",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        275: {
            num: 275,
            name: "sleepLevel",
            messagesKey: "sleepLevelMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "sleepLevel",
                    type: "sleepLevel",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        82: {
            num: 82,
            name: "antChannelId",
            messagesKey: "antChannelIdMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "channelNumber",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "deviceType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "deviceNumber",
                    type: "uint16z",
                    baseType: "uint16z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "transmissionType",
                    type: "uint8z",
                    baseType: "uint8z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "deviceIndex",
                    type: "deviceIndex",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        80: {
            num: 80,
            name: "antRx",
            messagesKey: "antRxMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "fractionalTimestamp",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 32768,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "mesgId",
                    type: "byte",
                    baseType: "byte",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "mesgData",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    offset: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    units: [
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ],
                    bits: [
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8
                    ],
                    components: [
                        "3",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "channelNumber",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "data",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        81: {
            num: 81,
            name: "antTx",
            messagesKey: "antTxMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "fractionalTimestamp",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 32768,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "mesgId",
                    type: "byte",
                    baseType: "byte",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "mesgData",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    offset: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    units: [
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ],
                    bits: [
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8
                    ],
                    components: [
                        "3",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4",
                        "4"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "channelNumber",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "data",
                    type: "byte",
                    baseType: "byte",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        200: {
            num: 200,
            name: "exdScreenConfiguration",
            messagesKey: "exdScreenConfigurationMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "screenIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "fieldCount",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "layout",
                    type: "exdLayout",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "screenEnabled",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        201: {
            num: 201,
            name: "exdDataFieldConfiguration",
            messagesKey: "exdDataFieldConfigurationMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "screenIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "conceptField",
                    type: "byte",
                    baseType: "byte",
                    array: false,
                    scale: [
                        1,
                        1
                    ],
                    offset: [
                        0,
                        0
                    ],
                    units: [
                        "",
                        ""
                    ],
                    bits: [
                        4,
                        4
                    ],
                    components: [
                        "2",
                        "3"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "fieldId",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "conceptCount",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "displayType",
                    type: "exdDisplayType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "title",
                    type: "string",
                    baseType: "string",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        202: {
            num: 202,
            name: "exdDataConceptConfiguration",
            messagesKey: "exdDataConceptConfigurationMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "screenIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "conceptField",
                    type: "byte",
                    baseType: "byte",
                    array: false,
                    scale: [
                        1,
                        1
                    ],
                    offset: [
                        0,
                        0
                    ],
                    units: [
                        "",
                        ""
                    ],
                    bits: [
                        4,
                        4
                    ],
                    components: [
                        "2",
                        "3"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "fieldId",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "conceptIndex",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "dataPage",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "conceptKey",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "scaling",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "dataUnits",
                    type: "exdDataUnits",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "qualifier",
                    type: "exdQualifiers",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "descriptor",
                    type: "exdDescriptors",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "isSigned",
                    type: "bool",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        268: {
            num: 268,
            name: "diveSummary",
            messagesKey: "diveSummaryMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "referenceMesg",
                    type: "mesgNum",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "referenceIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "avgDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "maxDepth",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "surfaceInterval",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "startCns",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "endCns",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "startN2",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "endN2",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "percent",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "o2Toxicity",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "OTUs",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "diveNumber",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "bottomTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                12: {
                    num: 12,
                    name: "avgPressureSac",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "bar/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                13: {
                    num: 13,
                    name: "avgVolumeSac",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "L/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "avgRmv",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "L/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "descentTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                16: {
                    num: 16,
                    name: "ascentTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                17: {
                    num: 17,
                    name: "avgAscentRate",
                    type: "sint32",
                    baseType: "sint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                22: {
                    num: 22,
                    name: "avgDescentRate",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                23: {
                    num: 23,
                    name: "maxAscentRate",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                24: {
                    num: 24,
                    name: "maxDescentRate",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                25: {
                    num: 25,
                    name: "hangTime",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        289: {
            num: 289,
            name: "aadAccelFeatures",
            messagesKey: "aadAccelFeaturesMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "time",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "energyTotal",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "zeroCrossCnt",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "instance",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "timeAboveThreshold",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 25,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        78: {
            num: 78,
            name: "hrv",
            messagesKey: "hrvMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "time",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1000,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        290: {
            num: 290,
            name: "beatIntervals",
            messagesKey: "beatIntervalsMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "time",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        370: {
            num: 370,
            name: "hrvStatusSummary",
            messagesKey: "hrvStatusSummaryMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "weeklyAverage",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "lastNightAverage",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "lastNight5MinHigh",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "baselineLowUpper",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "baselineBalancedLower",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "baselineBalancedUpper",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "status",
                    type: "hrvStatus",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        371: {
            num: 371,
            name: "hrvValue",
            messagesKey: "hrvValueMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "value",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 128,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        372: {
            num: 372,
            name: "rawBbi",
            messagesKey: "rawBbiMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "timestampMs",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "data",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    offset: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    units: [
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ],
                    bits: [
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1,
                        14,
                        1,
                        1
                    ],
                    components: [
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4",
                        "2",
                        "3",
                        "4"
                    ],
                    isAccumulated: false,
                    hasComponents: true,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "time",
                    type: "uint16",
                    baseType: "uint16",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "ms",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "quality",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "gap",
                    type: "uint8",
                    baseType: "uint8",
                    array: true,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        297: {
            num: 297,
            name: "respirationRate",
            messagesKey: "respirationRateMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "respirationRate",
                    type: "sint16",
                    baseType: "sint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "breaths/min",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        387: {
            num: 387,
            name: "chronoShotSession",
            messagesKey: "chronoShotSessionMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "minSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "maxSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "avgSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "shotCount",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "projectileType",
                    type: "projectileType",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "grainWeight",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 10,
                    offset: 0,
                    units: "gr",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "standardDeviation",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        388: {
            num: 388,
            name: "chronoShotData",
            messagesKey: "chronoShotDataMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "shotSpeed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 1000,
                    offset: 0,
                    units: "m/s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "shotNum",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        319: {
            num: 319,
            name: "tankUpdate",
            messagesKey: "tankUpdateMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "sensor",
                    type: "antChannelId",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "pressure",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "bar",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        323: {
            num: 323,
            name: "tankSummary",
            messagesKey: "tankSummaryMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "s",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "sensor",
                    type: "antChannelId",
                    baseType: "uint32z",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "startPressure",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "bar",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "endPressure",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "bar",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "volumeUsed",
                    type: "uint32",
                    baseType: "uint32",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "L",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        346: {
            num: 346,
            name: "sleepAssessment",
            messagesKey: "sleepAssessmentMesgs",
            fields: {
                0: {
                    num: 0,
                    name: "combinedAwakeScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "awakeTimeScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "awakeningsCountScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                3: {
                    num: 3,
                    name: "deepSleepScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "sleepDurationScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                5: {
                    num: 5,
                    name: "lightSleepScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                6: {
                    num: 6,
                    name: "overallSleepScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                7: {
                    num: 7,
                    name: "sleepQualityScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                8: {
                    num: 8,
                    name: "sleepRecoveryScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                9: {
                    num: 9,
                    name: "remSleepScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                10: {
                    num: 10,
                    name: "sleepRestlessnessScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                11: {
                    num: 11,
                    name: "awakeningsCount",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                14: {
                    num: 14,
                    name: "interruptionsScore",
                    type: "uint8",
                    baseType: "uint8",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                15: {
                    num: 15,
                    name: "averageStressDuringSleep",
                    type: "uint16",
                    baseType: "uint16",
                    array: false,
                    scale: 100,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        470: {
            num: 470,
            name: "sleepDisruptionSeverityPeriod",
            messagesKey: "sleepDisruptionSeverityPeriodMesgs",
            fields: {
                254: {
                    num: 254,
                    name: "messageIndex",
                    type: "messageIndex",
                    baseType: "uint16",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "severity",
                    type: "sleepDisruptionSeverity",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        471: {
            num: 471,
            name: "sleepDisruptionOvernightSeverity",
            messagesKey: "sleepDisruptionOvernightSeverityMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "severity",
                    type: "sleepDisruptionSeverity",
                    baseType: "enum",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        398: {
            num: 398,
            name: "skinTempOvernight",
            messagesKey: "skinTempOvernightMesgs",
            fields: {
                253: {
                    num: 253,
                    name: "timestamp",
                    type: "dateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                0: {
                    num: 0,
                    name: "localTimestamp",
                    type: "localDateTime",
                    baseType: "uint32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                1: {
                    num: 1,
                    name: "averageDeviation",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                2: {
                    num: 2,
                    name: "average7DayDeviation",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                },
                4: {
                    num: 4,
                    name: "nightlyValue",
                    type: "float32",
                    baseType: "float32",
                    array: false,
                    scale: 1,
                    offset: 0,
                    units: "",
                    bits: [],
                    components: [],
                    isAccumulated: false,
                    hasComponents: false,
                    subFields: []
                }
            }
        },
        105: {
            num: 105,
            name: "pad",
            messagesKey: "padMesgs",
            fields: {}
        }
    },
    types: {
        file: {
            1: "device",
            2: "settings",
            3: "sport",
            4: "activity",
            5: "workout",
            6: "course",
            7: "schedules",
            9: "weight",
            10: "totals",
            11: "goals",
            14: "bloodPressure",
            15: "monitoringA",
            20: "activitySummary",
            28: "monitoringDaily",
            32: "monitoringB",
            34: "segment",
            35: "segmentList",
            40: "exdConfiguration",
            0xF7: "mfgRangeMin",
            0xFE: "mfgRangeMax"
        },
        mesgNum: {
            0: "fileId",
            1: "capabilities",
            2: "deviceSettings",
            3: "userProfile",
            4: "hrmProfile",
            5: "sdmProfile",
            6: "bikeProfile",
            7: "zonesTarget",
            8: "hrZone",
            9: "powerZone",
            10: "metZone",
            12: "sport",
            13: "trainingSettings",
            15: "goal",
            18: "session",
            19: "lap",
            20: "record",
            21: "event",
            23: "deviceInfo",
            26: "workout",
            27: "workoutStep",
            28: "schedule",
            30: "weightScale",
            31: "course",
            32: "coursePoint",
            33: "totals",
            34: "activity",
            35: "software",
            37: "fileCapabilities",
            38: "mesgCapabilities",
            39: "fieldCapabilities",
            49: "fileCreator",
            51: "bloodPressure",
            53: "speedZone",
            55: "monitoring",
            72: "trainingFile",
            78: "hrv",
            80: "antRx",
            81: "antTx",
            82: "antChannelId",
            101: "length",
            103: "monitoringInfo",
            105: "pad",
            106: "slaveDevice",
            127: "connectivity",
            128: "weatherConditions",
            129: "weatherAlert",
            131: "cadenceZone",
            132: "hr",
            142: "segmentLap",
            145: "memoGlob",
            148: "segmentId",
            149: "segmentLeaderboardEntry",
            150: "segmentPoint",
            151: "segmentFile",
            158: "workoutSession",
            159: "watchfaceSettings",
            160: "gpsMetadata",
            161: "cameraEvent",
            162: "timestampCorrelation",
            164: "gyroscopeData",
            165: "accelerometerData",
            167: "threeDSensorCalibration",
            169: "videoFrame",
            174: "obdiiData",
            177: "nmeaSentence",
            178: "aviationAttitude",
            184: "video",
            185: "videoTitle",
            186: "videoDescription",
            187: "videoClip",
            188: "ohrSettings",
            200: "exdScreenConfiguration",
            201: "exdDataFieldConfiguration",
            202: "exdDataConceptConfiguration",
            206: "fieldDescription",
            207: "developerDataId",
            208: "magnetometerData",
            209: "barometerData",
            210: "oneDSensorCalibration",
            211: "monitoringHrData",
            216: "timeInZone",
            225: "set",
            227: "stressLevel",
            229: "maxMetData",
            258: "diveSettings",
            259: "diveGas",
            262: "diveAlarm",
            264: "exerciseTitle",
            268: "diveSummary",
            269: "spo2Data",
            275: "sleepLevel",
            285: "jump",
            289: "aadAccelFeatures",
            290: "beatIntervals",
            297: "respirationRate",
            302: "hsaAccelerometerData",
            304: "hsaStepData",
            305: "hsaSpo2Data",
            306: "hsaStressData",
            307: "hsaRespirationData",
            308: "hsaHeartRateData",
            312: "split",
            313: "splitSummary",
            314: "hsaBodyBatteryData",
            315: "hsaEvent",
            317: "climbPro",
            319: "tankUpdate",
            323: "tankSummary",
            346: "sleepAssessment",
            370: "hrvStatusSummary",
            371: "hrvValue",
            372: "rawBbi",
            375: "deviceAuxBatteryInfo",
            376: "hsaGyroscopeData",
            387: "chronoShotSession",
            388: "chronoShotData",
            389: "hsaConfigurationData",
            393: "diveApneaAlarm",
            398: "skinTempOvernight",
            409: "hsaWristTemperatureData",
            470: "sleepDisruptionSeverityPeriod",
            471: "sleepDisruptionOvernightSeverity",
            0xFF00: "mfgRangeMin",
            0xFFFE: "mfgRangeMax"
        },
        checksum: {
            0: "clear",
            1: "ok"
        },
        fileFlags: {
            0x02: "read",
            0x04: "write",
            0x08: "erase"
        },
        mesgCount: {
            0: "numPerFile",
            1: "maxPerFile",
            2: "maxPerFileType"
        },
        dateTime: {
            0x10000000: "min"
        },
        localDateTime: {
            0x10000000: "min"
        },
        messageIndex: {
            0x8000: "selected",
            0x7000: "reserved",
            0x0FFF: "mask"
        },
        deviceIndex: {
            0: "creator"
        },
        gender: {
            0: "female",
            1: "male"
        },
        language: {
            0: "english",
            1: "french",
            2: "italian",
            3: "german",
            4: "spanish",
            5: "croatian",
            6: "czech",
            7: "danish",
            8: "dutch",
            9: "finnish",
            10: "greek",
            11: "hungarian",
            12: "norwegian",
            13: "polish",
            14: "portuguese",
            15: "slovakian",
            16: "slovenian",
            17: "swedish",
            18: "russian",
            19: "turkish",
            20: "latvian",
            21: "ukrainian",
            22: "arabic",
            23: "farsi",
            24: "bulgarian",
            25: "romanian",
            26: "chinese",
            27: "japanese",
            28: "korean",
            29: "taiwanese",
            30: "thai",
            31: "hebrew",
            32: "brazilianPortuguese",
            33: "indonesian",
            34: "malaysian",
            35: "vietnamese",
            36: "burmese",
            37: "mongolian",
            254: "custom"
        },
        languageBits0: {
            0x01: "english",
            0x02: "french",
            0x04: "italian",
            0x08: "german",
            0x10: "spanish",
            0x20: "croatian",
            0x40: "czech",
            0x80: "danish"
        },
        languageBits1: {
            0x01: "dutch",
            0x02: "finnish",
            0x04: "greek",
            0x08: "hungarian",
            0x10: "norwegian",
            0x20: "polish",
            0x40: "portuguese",
            0x80: "slovakian"
        },
        languageBits2: {
            0x01: "slovenian",
            0x02: "swedish",
            0x04: "russian",
            0x08: "turkish",
            0x10: "latvian",
            0x20: "ukrainian",
            0x40: "arabic",
            0x80: "farsi"
        },
        languageBits3: {
            0x01: "bulgarian",
            0x02: "romanian",
            0x04: "chinese",
            0x08: "japanese",
            0x10: "korean",
            0x20: "taiwanese",
            0x40: "thai",
            0x80: "hebrew"
        },
        languageBits4: {
            0x01: "brazilianPortuguese",
            0x02: "indonesian",
            0x04: "malaysian",
            0x08: "vietnamese",
            0x10: "burmese",
            0x20: "mongolian"
        },
        timeZone: {
            0: "almaty",
            1: "bangkok",
            2: "bombay",
            3: "brasilia",
            4: "cairo",
            5: "capeVerdeIs",
            6: "darwin",
            7: "eniwetok",
            8: "fiji",
            9: "hongKong",
            10: "islamabad",
            11: "kabul",
            12: "magadan",
            13: "midAtlantic",
            14: "moscow",
            15: "muscat",
            16: "newfoundland",
            17: "samoa",
            18: "sydney",
            19: "tehran",
            20: "tokyo",
            21: "usAlaska",
            22: "usAtlantic",
            23: "usCentral",
            24: "usEastern",
            25: "usHawaii",
            26: "usMountain",
            27: "usPacific",
            28: "other",
            29: "auckland",
            30: "kathmandu",
            31: "europeWesternWet",
            32: "europeCentralCet",
            33: "europeEasternEet",
            34: "jakarta",
            35: "perth",
            36: "adelaide",
            37: "brisbane",
            38: "tasmania",
            39: "iceland",
            40: "amsterdam",
            41: "athens",
            42: "barcelona",
            43: "berlin",
            44: "brussels",
            45: "budapest",
            46: "copenhagen",
            47: "dublin",
            48: "helsinki",
            49: "lisbon",
            50: "london",
            51: "madrid",
            52: "munich",
            53: "oslo",
            54: "paris",
            55: "prague",
            56: "reykjavik",
            57: "rome",
            58: "stockholm",
            59: "vienna",
            60: "warsaw",
            61: "zurich",
            62: "quebec",
            63: "ontario",
            64: "manitoba",
            65: "saskatchewan",
            66: "alberta",
            67: "britishColumbia",
            68: "boise",
            69: "boston",
            70: "chicago",
            71: "dallas",
            72: "denver",
            73: "kansasCity",
            74: "lasVegas",
            75: "losAngeles",
            76: "miami",
            77: "minneapolis",
            78: "newYork",
            79: "newOrleans",
            80: "phoenix",
            81: "santaFe",
            82: "seattle",
            83: "washingtonDc",
            84: "usArizona",
            85: "chita",
            86: "ekaterinburg",
            87: "irkutsk",
            88: "kaliningrad",
            89: "krasnoyarsk",
            90: "novosibirsk",
            91: "petropavlovskKamchatskiy",
            92: "samara",
            93: "vladivostok",
            94: "mexicoCentral",
            95: "mexicoMountain",
            96: "mexicoPacific",
            97: "capeTown",
            98: "winkhoek",
            99: "lagos",
            100: "riyahd",
            101: "venezuela",
            102: "australiaLh",
            103: "santiago",
            253: "manual",
            254: "automatic"
        },
        displayMeasure: {
            0: "metric",
            1: "statute",
            2: "nautical"
        },
        displayHeart: {
            0: "bpm",
            1: "max",
            2: "reserve"
        },
        displayPower: {
            0: "watts",
            1: "percentFtp"
        },
        displayPosition: {
            0: "degree",
            1: "degreeMinute",
            2: "degreeMinuteSecond",
            3: "austrianGrid",
            4: "britishGrid",
            5: "dutchGrid",
            6: "hungarianGrid",
            7: "finnishGrid",
            8: "germanGrid",
            9: "icelandicGrid",
            10: "indonesianEquatorial",
            11: "indonesianIrian",
            12: "indonesianSouthern",
            13: "indiaZone0",
            14: "indiaZoneIA",
            15: "indiaZoneIB",
            16: "indiaZoneIIA",
            17: "indiaZoneIIB",
            18: "indiaZoneIIIA",
            19: "indiaZoneIIIB",
            20: "indiaZoneIVA",
            21: "indiaZoneIVB",
            22: "irishTransverse",
            23: "irishGrid",
            24: "loran",
            25: "maidenheadGrid",
            26: "mgrsGrid",
            27: "newZealandGrid",
            28: "newZealandTransverse",
            29: "qatarGrid",
            30: "modifiedSwedishGrid",
            31: "swedishGrid",
            32: "southAfricanGrid",
            33: "swissGrid",
            34: "taiwanGrid",
            35: "unitedStatesGrid",
            36: "utmUpsGrid",
            37: "westMalayan",
            38: "borneoRso",
            39: "estonianGrid",
            40: "latvianGrid",
            41: "swedishRef99Grid"
        },
        switch: {
            0: "off",
            1: "on",
            2: "auto"
        },
        sport: {
            0: "generic",
            1: "running",
            2: "cycling",
            3: "transition",
            4: "fitnessEquipment",
            5: "swimming",
            6: "basketball",
            7: "soccer",
            8: "tennis",
            9: "americanFootball",
            10: "training",
            11: "walking",
            12: "crossCountrySkiing",
            13: "alpineSkiing",
            14: "snowboarding",
            15: "rowing",
            16: "mountaineering",
            17: "hiking",
            18: "multisport",
            19: "paddling",
            20: "flying",
            21: "eBiking",
            22: "motorcycling",
            23: "boating",
            24: "driving",
            25: "golf",
            26: "hangGliding",
            27: "horsebackRiding",
            28: "hunting",
            29: "fishing",
            30: "inlineSkating",
            31: "rockClimbing",
            32: "sailing",
            33: "iceSkating",
            34: "skyDiving",
            35: "snowshoeing",
            36: "snowmobiling",
            37: "standUpPaddleboarding",
            38: "surfing",
            39: "wakeboarding",
            40: "waterSkiing",
            41: "kayaking",
            42: "rafting",
            43: "windsurfing",
            44: "kitesurfing",
            45: "tactical",
            46: "jumpmaster",
            47: "boxing",
            48: "floorClimbing",
            49: "baseball",
            53: "diving",
            62: "hiit",
            64: "racket",
            65: "wheelchairPushWalk",
            66: "wheelchairPushRun",
            67: "meditation",
            69: "discGolf",
            71: "cricket",
            72: "rugby",
            73: "hockey",
            74: "lacrosse",
            75: "volleyball",
            76: "waterTubing",
            77: "wakesurfing",
            80: "mixedMartialArts",
            82: "snorkeling",
            83: "dance",
            84: "jumpRope",
            254: "all"
        },
        sportBits0: {
            0x01: "generic",
            0x02: "running",
            0x04: "cycling",
            0x08: "transition",
            0x10: "fitnessEquipment",
            0x20: "swimming",
            0x40: "basketball",
            0x80: "soccer"
        },
        sportBits1: {
            0x01: "tennis",
            0x02: "americanFootball",
            0x04: "training",
            0x08: "walking",
            0x10: "crossCountrySkiing",
            0x20: "alpineSkiing",
            0x40: "snowboarding",
            0x80: "rowing"
        },
        sportBits2: {
            0x01: "mountaineering",
            0x02: "hiking",
            0x04: "multisport",
            0x08: "paddling",
            0x10: "flying",
            0x20: "eBiking",
            0x40: "motorcycling",
            0x80: "boating"
        },
        sportBits3: {
            0x01: "driving",
            0x02: "golf",
            0x04: "hangGliding",
            0x08: "horsebackRiding",
            0x10: "hunting",
            0x20: "fishing",
            0x40: "inlineSkating",
            0x80: "rockClimbing"
        },
        sportBits4: {
            0x01: "sailing",
            0x02: "iceSkating",
            0x04: "skyDiving",
            0x08: "snowshoeing",
            0x10: "snowmobiling",
            0x20: "standUpPaddleboarding",
            0x40: "surfing",
            0x80: "wakeboarding"
        },
        sportBits5: {
            0x01: "waterSkiing",
            0x02: "kayaking",
            0x04: "rafting",
            0x08: "windsurfing",
            0x10: "kitesurfing",
            0x20: "tactical",
            0x40: "jumpmaster",
            0x80: "boxing"
        },
        sportBits6: {
            0x01: "floorClimbing"
        },
        subSport: {
            0: "generic",
            1: "treadmill",
            2: "street",
            3: "trail",
            4: "track",
            5: "spin",
            6: "indoorCycling",
            7: "road",
            8: "mountain",
            9: "downhill",
            10: "recumbent",
            11: "cyclocross",
            12: "handCycling",
            13: "trackCycling",
            14: "indoorRowing",
            15: "elliptical",
            16: "stairClimbing",
            17: "lapSwimming",
            18: "openWater",
            19: "flexibilityTraining",
            20: "strengthTraining",
            21: "warmUp",
            22: "match",
            23: "exercise",
            24: "challenge",
            25: "indoorSkiing",
            26: "cardioTraining",
            27: "indoorWalking",
            28: "eBikeFitness",
            29: "bmx",
            30: "casualWalking",
            31: "speedWalking",
            32: "bikeToRunTransition",
            33: "runToBikeTransition",
            34: "swimToBikeTransition",
            35: "atv",
            36: "motocross",
            37: "backcountry",
            38: "resort",
            39: "rcDrone",
            40: "wingsuit",
            41: "whitewater",
            42: "skateSkiing",
            43: "yoga",
            44: "pilates",
            45: "indoorRunning",
            46: "gravelCycling",
            47: "eBikeMountain",
            48: "commuting",
            49: "mixedSurface",
            50: "navigate",
            51: "trackMe",
            52: "map",
            53: "singleGasDiving",
            54: "multiGasDiving",
            55: "gaugeDiving",
            56: "apneaDiving",
            57: "apneaHunting",
            58: "virtualActivity",
            59: "obstacle",
            62: "breathing",
            65: "sailRace",
            67: "ultra",
            68: "indoorClimbing",
            69: "bouldering",
            70: "hiit",
            73: "amrap",
            74: "emom",
            75: "tabata",
            84: "pickleball",
            85: "padel",
            86: "indoorWheelchairWalk",
            87: "indoorWheelchairRun",
            88: "indoorHandCycling",
            94: "squash",
            95: "badminton",
            96: "racquetball",
            97: "tableTennis",
            110: "flyCanopy",
            111: "flyParaglide",
            112: "flyParamotor",
            113: "flyPressurized",
            114: "flyNavigate",
            115: "flyTimer",
            116: "flyAltimeter",
            117: "flyWx",
            118: "flyVfr",
            119: "flyIfr",
            254: "all"
        },
        sportEvent: {
            0: "uncategorized",
            1: "geocaching",
            2: "fitness",
            3: "recreation",
            4: "race",
            5: "specialEvent",
            6: "training",
            7: "transportation",
            8: "touring"
        },
        activity: {
            0: "manual",
            1: "autoMultiSport"
        },
        intensity: {
            0: "active",
            1: "rest",
            2: "warmup",
            3: "cooldown",
            4: "recovery",
            5: "interval",
            6: "other"
        },
        sessionTrigger: {
            0: "activityEnd",
            1: "manual",
            2: "autoMultiSport",
            3: "fitnessEquipment"
        },
        autolapTrigger: {
            0: "time",
            1: "distance",
            2: "positionStart",
            3: "positionLap",
            4: "positionWaypoint",
            5: "positionMarked",
            6: "off",
            13: "autoSelect"
        },
        lapTrigger: {
            0: "manual",
            1: "time",
            2: "distance",
            3: "positionStart",
            4: "positionLap",
            5: "positionWaypoint",
            6: "positionMarked",
            7: "sessionEnd",
            8: "fitnessEquipment"
        },
        timeMode: {
            0: "hour12",
            1: "hour24",
            2: "military",
            3: "hour12WithSeconds",
            4: "hour24WithSeconds",
            5: "utc"
        },
        backlightMode: {
            0: "off",
            1: "manual",
            2: "keyAndMessages",
            3: "autoBrightness",
            4: "smartNotifications",
            5: "keyAndMessagesNight",
            6: "keyAndMessagesAndSmartNotifications"
        },
        dateMode: {
            0: "dayMonth",
            1: "monthDay"
        },
        backlightTimeout: {
            0: "infinite"
        },
        event: {
            0: "timer",
            3: "workout",
            4: "workoutStep",
            5: "powerDown",
            6: "powerUp",
            7: "offCourse",
            8: "session",
            9: "lap",
            10: "coursePoint",
            11: "battery",
            12: "virtualPartnerPace",
            13: "hrHighAlert",
            14: "hrLowAlert",
            15: "speedHighAlert",
            16: "speedLowAlert",
            17: "cadHighAlert",
            18: "cadLowAlert",
            19: "powerHighAlert",
            20: "powerLowAlert",
            21: "recoveryHr",
            22: "batteryLow",
            23: "timeDurationAlert",
            24: "distanceDurationAlert",
            25: "calorieDurationAlert",
            26: "activity",
            27: "fitnessEquipment",
            28: "length",
            32: "userMarker",
            33: "sportPoint",
            36: "calibration",
            42: "frontGearChange",
            43: "rearGearChange",
            44: "riderPositionChange",
            45: "elevHighAlert",
            46: "elevLowAlert",
            47: "commTimeout",
            54: "autoActivityDetect",
            56: "diveAlert",
            57: "diveGasSwitched",
            71: "tankPressureReserve",
            72: "tankPressureCritical",
            73: "tankLost",
            75: "radarThreatAlert",
            76: "tankBatteryLow",
            81: "tankPodConnected",
            82: "tankPodDisconnected"
        },
        eventType: {
            0: "start",
            1: "stop",
            2: "consecutiveDepreciated",
            3: "marker",
            4: "stopAll",
            5: "beginDepreciated",
            6: "endDepreciated",
            7: "endAllDepreciated",
            8: "stopDisable",
            9: "stopDisableAll"
        },
        timerTrigger: {
            0: "manual",
            1: "auto",
            2: "fitnessEquipment"
        },
        fitnessEquipmentState: {
            0: "ready",
            1: "inUse",
            2: "paused",
            3: "unknown"
        },
        tone: {
            0: "off",
            1: "tone",
            2: "vibrate",
            3: "toneAndVibrate"
        },
        autoscroll: {
            0: "none",
            1: "slow",
            2: "medium",
            3: "fast"
        },
        activityClass: {
            0x7F: "level",
            100: "levelMax",
            0x80: "athlete"
        },
        hrZoneCalc: {
            0: "custom",
            1: "percentMaxHr",
            2: "percentHrr",
            3: "percentLthr"
        },
        pwrZoneCalc: {
            0: "custom",
            1: "percentFtp"
        },
        wktStepDuration: {
            0: "time",
            1: "distance",
            2: "hrLessThan",
            3: "hrGreaterThan",
            4: "calories",
            5: "open",
            6: "repeatUntilStepsCmplt",
            7: "repeatUntilTime",
            8: "repeatUntilDistance",
            9: "repeatUntilCalories",
            10: "repeatUntilHrLessThan",
            11: "repeatUntilHrGreaterThan",
            12: "repeatUntilPowerLessThan",
            13: "repeatUntilPowerGreaterThan",
            14: "powerLessThan",
            15: "powerGreaterThan",
            16: "trainingPeaksTss",
            17: "repeatUntilPowerLastLapLessThan",
            18: "repeatUntilMaxPowerLastLapLessThan",
            19: "power3sLessThan",
            20: "power10sLessThan",
            21: "power30sLessThan",
            22: "power3sGreaterThan",
            23: "power10sGreaterThan",
            24: "power30sGreaterThan",
            25: "powerLapLessThan",
            26: "powerLapGreaterThan",
            27: "repeatUntilTrainingPeaksTss",
            28: "repetitionTime",
            29: "reps",
            31: "timeOnly"
        },
        wktStepTarget: {
            0: "speed",
            1: "heartRate",
            2: "open",
            3: "cadence",
            4: "power",
            5: "grade",
            6: "resistance",
            7: "power3s",
            8: "power10s",
            9: "power30s",
            10: "powerLap",
            11: "swimStroke",
            12: "speedLap",
            13: "heartRateLap"
        },
        goal: {
            0: "time",
            1: "distance",
            2: "calories",
            3: "frequency",
            4: "steps",
            5: "ascent",
            6: "activeMinutes"
        },
        goalRecurrence: {
            0: "off",
            1: "daily",
            2: "weekly",
            3: "monthly",
            4: "yearly",
            5: "custom"
        },
        goalSource: {
            0: "auto",
            1: "community",
            2: "user"
        },
        schedule: {
            0: "workout",
            1: "course"
        },
        coursePoint: {
            0: "generic",
            1: "summit",
            2: "valley",
            3: "water",
            4: "food",
            5: "danger",
            6: "left",
            7: "right",
            8: "straight",
            9: "firstAid",
            10: "fourthCategory",
            11: "thirdCategory",
            12: "secondCategory",
            13: "firstCategory",
            14: "horsCategory",
            15: "sprint",
            16: "leftFork",
            17: "rightFork",
            18: "middleFork",
            19: "slightLeft",
            20: "sharpLeft",
            21: "slightRight",
            22: "sharpRight",
            23: "uTurn",
            24: "segmentStart",
            25: "segmentEnd",
            27: "campsite",
            28: "aidStation",
            29: "restArea",
            30: "generalDistance",
            31: "service",
            32: "energyGel",
            33: "sportsDrink",
            34: "mileMarker",
            35: "checkpoint",
            36: "shelter",
            37: "meetingSpot",
            38: "overlook",
            39: "toilet",
            40: "shower",
            41: "gear",
            42: "sharpCurve",
            43: "steepIncline",
            44: "tunnel",
            45: "bridge",
            46: "obstacle",
            47: "crossing",
            48: "store",
            49: "transition",
            50: "navaid",
            51: "transport",
            52: "alert",
            53: "info"
        },
        manufacturer: {
            1: "garmin",
            2: "garminFr405Antfs",
            3: "zephyr",
            4: "dayton",
            5: "idt",
            6: "srm",
            7: "quarq",
            8: "ibike",
            9: "saris",
            10: "sparkHk",
            11: "tanita",
            12: "echowell",
            13: "dynastreamOem",
            14: "nautilus",
            15: "dynastream",
            16: "timex",
            17: "metrigear",
            18: "xelic",
            19: "beurer",
            20: "cardiosport",
            21: "aAndD",
            22: "hmm",
            23: "suunto",
            24: "thitaElektronik",
            25: "gpulse",
            26: "cleanMobile",
            27: "pedalBrain",
            28: "peaksware",
            29: "saxonar",
            30: "lemondFitness",
            31: "dexcom",
            32: "wahooFitness",
            33: "octaneFitness",
            34: "archinoetics",
            35: "theHurtBox",
            36: "citizenSystems",
            37: "magellan",
            38: "osynce",
            39: "holux",
            40: "concept2",
            41: "shimano",
            42: "oneGiantLeap",
            43: "aceSensor",
            44: "brimBrothers",
            45: "xplova",
            46: "perceptionDigital",
            47: "bf1systems",
            48: "pioneer",
            49: "spantec",
            50: "metalogics",
            51: "4iiiis",
            52: "seikoEpson",
            53: "seikoEpsonOem",
            54: "iforPowell",
            55: "maxwellGuider",
            56: "starTrac",
            57: "breakaway",
            58: "alatechTechnologyLtd",
            59: "mioTechnologyEurope",
            60: "rotor",
            61: "geonaute",
            62: "idBike",
            63: "specialized",
            64: "wtek",
            65: "physicalEnterprises",
            66: "northPoleEngineering",
            67: "bkool",
            68: "cateye",
            69: "stagesCycling",
            70: "sigmasport",
            71: "tomtom",
            72: "peripedal",
            73: "wattbike",
            76: "moxy",
            77: "ciclosport",
            78: "powerbahn",
            79: "acornProjectsAps",
            80: "lifebeam",
            81: "bontrager",
            82: "wellgo",
            83: "scosche",
            84: "magura",
            85: "woodway",
            86: "elite",
            87: "nielsenKellerman",
            88: "dkCity",
            89: "tacx",
            90: "directionTechnology",
            91: "magtonic",
            92: "1partcarbon",
            93: "insideRideTechnologies",
            94: "soundOfMotion",
            95: "stryd",
            96: "icg",
            97: "miPulse",
            98: "bsxAthletics",
            99: "look",
            100: "campagnoloSrl",
            101: "bodyBikeSmart",
            102: "praxisworks",
            103: "limitsTechnology",
            104: "topactionTechnology",
            105: "cosinuss",
            106: "fitcare",
            107: "magene",
            108: "giantManufacturingCo",
            109: "tigrasport",
            110: "salutron",
            111: "technogym",
            112: "brytonSensors",
            113: "latitudeLimited",
            114: "soaringTechnology",
            115: "igpsport",
            116: "thinkrider",
            117: "gopherSport",
            118: "waterrower",
            119: "orangetheory",
            120: "inpeak",
            121: "kinetic",
            122: "johnsonHealthTech",
            123: "polarElectro",
            124: "seesense",
            125: "nciTechnology",
            126: "iqsquare",
            127: "leomo",
            128: "ifitCom",
            129: "corosByte",
            130: "versaDesign",
            131: "chileaf",
            132: "cycplus",
            133: "gravaaByte",
            134: "sigeyi",
            135: "coospo",
            136: "geoid",
            137: "bosch",
            138: "kyto",
            139: "kineticSports",
            140: "decathlonByte",
            141: "tqSystems",
            142: "tagHeuer",
            143: "keiserFitness",
            144: "zwiftByte",
            145: "porscheEp",
            146: "blackbird",
            147: "meilanByte",
            148: "ezon",
            149: "laisi",
            150: "myzone",
            151: "abawo",
            152: "bafang",
            153: "luhongTechnology",
            255: "development",
            257: "healthandlife",
            258: "lezyne",
            259: "scribeLabs",
            260: "zwift",
            261: "watteam",
            262: "recon",
            263: "faveroElectronics",
            264: "dynovelo",
            265: "strava",
            266: "precor",
            267: "bryton",
            268: "sram",
            269: "navman",
            270: "cobi",
            271: "spivi",
            272: "mioMagellan",
            273: "evesports",
            274: "sensitivusGauge",
            275: "podoon",
            276: "lifeTimeFitness",
            277: "falcoEMotors",
            278: "minoura",
            279: "cycliq",
            280: "luxottica",
            281: "trainerRoad",
            282: "theSufferfest",
            283: "fullspeedahead",
            284: "virtualtraining",
            285: "feedbacksports",
            286: "omata",
            287: "vdo",
            288: "magneticdays",
            289: "hammerhead",
            290: "kineticByKurt",
            291: "shapelog",
            292: "dabuziduo",
            293: "jetblack",
            294: "coros",
            295: "virtugo",
            296: "velosense",
            297: "cycligentinc",
            298: "trailforks",
            299: "mahleEbikemotion",
            300: "nurvv",
            301: "microprogram",
            302: "zone5cloud",
            303: "greenteg",
            304: "yamahaMotors",
            305: "whoop",
            306: "gravaa",
            307: "onelap",
            308: "monarkExercise",
            309: "form",
            310: "decathlon",
            311: "syncros",
            312: "heatup",
            313: "cannondale",
            314: "trueFitness",
            315: "rGTCycling",
            316: "vasa",
            317: "raceRepublic",
            318: "fazua",
            319: "orekaTraining",
            320: "lsec",
            321: "lululemonStudio",
            322: "shanyue",
            323: "spinningMda",
            324: "hilldating",
            325: "aeroSensor",
            326: "nike",
            327: "magicshine",
            328: "ictrainer",
            329: "absoluteCycling",
            330: "eoSwimbetter",
            331: "mywhoosh",
            332: "ravemen",
            333: "tektroRacingProducts",
            334: "daradInnovationCorporation",
            335: "cycloptim",
            337: "runna",
            5759: "actigraphcorp"
        },
        garminProduct: {
            1: "hrm1",
            2: "axh01",
            3: "axb01",
            4: "axb02",
            5: "hrm2ss",
            6: "dsiAlf02",
            7: "hrm3ss",
            8: "hrmRunSingleByteProductId",
            9: "bsm",
            10: "bcm",
            11: "axs01",
            12: "hrmTriSingleByteProductId",
            13: "hrm4RunSingleByteProductId",
            14: "fr225SingleByteProductId",
            15: "gen3BsmSingleByteProductId",
            16: "gen3BcmSingleByteProductId",
            22: "hrmFitSingleByteProductId",
            255: "oHR",
            473: "fr301China",
            474: "fr301Japan",
            475: "fr301Korea",
            494: "fr301Taiwan",
            717: "fr405",
            782: "fr50",
            987: "fr405Japan",
            988: "fr60",
            1011: "dsiAlf01",
            1018: "fr310xt",
            1036: "edge500",
            1124: "fr110",
            1169: "edge800",
            1199: "edge500Taiwan",
            1213: "edge500Japan",
            1253: "chirp",
            1274: "fr110Japan",
            1325: "edge200",
            1328: "fr910xt",
            1333: "edge800Taiwan",
            1334: "edge800Japan",
            1341: "alf04",
            1345: "fr610",
            1360: "fr210Japan",
            1380: "vectorSs",
            1381: "vectorCp",
            1386: "edge800China",
            1387: "edge500China",
            1405: "approachG10",
            1410: "fr610Japan",
            1422: "edge500Korea",
            1436: "fr70",
            1446: "fr310xt4t",
            1461: "amx",
            1482: "fr10",
            1497: "edge800Korea",
            1499: "swim",
            1537: "fr910xtChina",
            1551: "fenix",
            1555: "edge200Taiwan",
            1561: "edge510",
            1567: "edge810",
            1570: "tempe",
            1600: "fr910xtJapan",
            1623: "fr620",
            1632: "fr220",
            1664: "fr910xtKorea",
            1688: "fr10Japan",
            1721: "edge810Japan",
            1735: "virbElite",
            1736: "edgeTouring",
            1742: "edge510Japan",
            1743: "hrmTri",
            1752: "hrmRun",
            1765: "fr920xt",
            1821: "edge510Asia",
            1822: "edge810China",
            1823: "edge810Taiwan",
            1836: "edge1000",
            1837: "vivoFit",
            1853: "virbRemote",
            1885: "vivoKi",
            1903: "fr15",
            1907: "vivoActive",
            1918: "edge510Korea",
            1928: "fr620Japan",
            1929: "fr620China",
            1930: "fr220Japan",
            1931: "fr220China",
            1936: "approachS6",
            1956: "vivoSmart",
            1967: "fenix2",
            1988: "epix",
            2050: "fenix3",
            2052: "edge1000Taiwan",
            2053: "edge1000Japan",
            2061: "fr15Japan",
            2067: "edge520",
            2070: "edge1000China",
            2072: "fr620Russia",
            2073: "fr220Russia",
            2079: "vectorS",
            2100: "edge1000Korea",
            2130: "fr920xtTaiwan",
            2131: "fr920xtChina",
            2132: "fr920xtJapan",
            2134: "virbx",
            2135: "vivoSmartApac",
            2140: "etrexTouch",
            2147: "edge25",
            2148: "fr25",
            2150: "vivoFit2",
            2153: "fr225",
            2156: "fr630",
            2157: "fr230",
            2158: "fr735xt",
            2160: "vivoActiveApac",
            2161: "vector2",
            2162: "vector2s",
            2172: "virbxe",
            2173: "fr620Taiwan",
            2174: "fr220Taiwan",
            2175: "truswing",
            2187: "d2airvenu",
            2188: "fenix3China",
            2189: "fenix3Twn",
            2192: "variaHeadlight",
            2193: "variaTaillightOld",
            2204: "edgeExplore1000",
            2219: "fr225Asia",
            2225: "variaRadarTaillight",
            2226: "variaRadarDisplay",
            2238: "edge20",
            2260: "edge520Asia",
            2261: "edge520Japan",
            2262: "d2Bravo",
            2266: "approachS20",
            2271: "vivoSmart2",
            2274: "edge1000Thai",
            2276: "variaRemote",
            2288: "edge25Asia",
            2289: "edge25Jpn",
            2290: "edge20Asia",
            2292: "approachX40",
            2293: "fenix3Japan",
            2294: "vivoSmartEmea",
            2310: "fr630Asia",
            2311: "fr630Jpn",
            2313: "fr230Jpn",
            2327: "hrm4Run",
            2332: "epixJapan",
            2337: "vivoActiveHr",
            2347: "vivoSmartGpsHr",
            2348: "vivoSmartHr",
            2361: "vivoSmartHrAsia",
            2362: "vivoSmartGpsHrAsia",
            2368: "vivoMove",
            2379: "variaTaillight",
            2396: "fr235Asia",
            2397: "fr235Japan",
            2398: "variaVision",
            2406: "vivoFit3",
            2407: "fenix3Korea",
            2408: "fenix3Sea",
            2413: "fenix3Hr",
            2417: "virbUltra30",
            2429: "indexSmartScale",
            2431: "fr235",
            2432: "fenix3Chronos",
            2441: "oregon7xx",
            2444: "rino7xx",
            2457: "epixKorea",
            2473: "fenix3HrChn",
            2474: "fenix3HrTwn",
            2475: "fenix3HrJpn",
            2476: "fenix3HrSea",
            2477: "fenix3HrKor",
            2496: "nautix",
            2497: "vivoActiveHrApac",
            2503: "fr35",
            2512: "oregon7xxWw",
            2530: "edge820",
            2531: "edgeExplore820",
            2533: "fr735xtApac",
            2534: "fr735xtJapan",
            2544: "fenix5s",
            2547: "d2BravoTitanium",
            2567: "variaUt800",
            2593: "runningDynamicsPod",
            2599: "edge820China",
            2600: "edge820Japan",
            2604: "fenix5x",
            2606: "vivoFitJr",
            2622: "vivoSmart3",
            2623: "vivoSport",
            2628: "edge820Taiwan",
            2629: "edge820Korea",
            2630: "edge820Sea",
            2650: "fr35Hebrew",
            2656: "approachS60",
            2667: "fr35Apac",
            2668: "fr35Japan",
            2675: "fenix3ChronosAsia",
            2687: "virb360",
            2691: "fr935",
            2697: "fenix5",
            2700: "vivoactive3",
            2733: "fr235ChinaNfc",
            2769: "foretrex601_701",
            2772: "vivoMoveHr",
            2713: "edge1030",
            2727: "fr35Sea",
            2787: "vector3",
            2796: "fenix5Asia",
            2797: "fenix5sAsia",
            2798: "fenix5xAsia",
            2806: "approachZ80",
            2814: "fr35Korea",
            2819: "d2charlie",
            2831: "vivoSmart3Apac",
            2832: "vivoSportApac",
            2833: "fr935Asia",
            2859: "descent",
            2878: "vivoFit4",
            2886: "fr645",
            2888: "fr645m",
            2891: "fr30",
            2900: "fenix5sPlus",
            2909: "edge130",
            2924: "edge1030Asia",
            2927: "vivosmart4",
            2945: "vivoMoveHrAsia",
            2962: "approachX10",
            2977: "fr30Asia",
            2988: "vivoactive3mW",
            3003: "fr645Asia",
            3004: "fr645mAsia",
            3011: "edgeExplore",
            3028: "gpsmap66",
            3049: "approachS10",
            3066: "vivoactive3mL",
            3076: "fr245",
            3077: "fr245Music",
            3085: "approachG80",
            3092: "edge130Asia",
            3095: "edge1030Bontrager",
            3110: "fenix5Plus",
            3111: "fenix5xPlus",
            3112: "edge520Plus",
            3113: "fr945",
            3121: "edge530",
            3122: "edge830",
            3126: "instinctEsports",
            3134: "fenix5sPlusApac",
            3135: "fenix5xPlusApac",
            3142: "edge520PlusApac",
            3143: "descentT1",
            3144: "fr235lAsia",
            3145: "fr245Asia",
            3163: "vivoActive3mApac",
            3192: "gen3Bsm",
            3193: "gen3Bcm",
            3218: "vivoSmart4Asia",
            3224: "vivoactive4Small",
            3225: "vivoactive4Large",
            3226: "venu",
            3246: "marqDriver",
            3247: "marqAviator",
            3248: "marqCaptain",
            3249: "marqCommander",
            3250: "marqExpedition",
            3251: "marqAthlete",
            3258: "descentMk2",
            3282: "fr45",
            3284: "gpsmap66i",
            3287: "fenix6SSport",
            3288: "fenix6S",
            3289: "fenix6Sport",
            3290: "fenix6",
            3291: "fenix6x",
            3299: "hrmDual",
            3300: "hrmPro",
            3308: "vivoMove3Premium",
            3314: "approachS40",
            3321: "fr245mAsia",
            3349: "edge530Apac",
            3350: "edge830Apac",
            3378: "vivoMove3",
            3387: "vivoActive4SmallAsia",
            3388: "vivoActive4LargeAsia",
            3389: "vivoActive4OledAsia",
            3405: "swim2",
            3420: "marqDriverAsia",
            3421: "marqAviatorAsia",
            3422: "vivoMove3Asia",
            3441: "fr945Asia",
            3446: "vivoActive3tChn",
            3448: "marqCaptainAsia",
            3449: "marqCommanderAsia",
            3450: "marqExpeditionAsia",
            3451: "marqAthleteAsia",
            3461: "indexSmartScale2",
            3466: "instinctSolar",
            3469: "fr45Asia",
            3473: "vivoactive3Daimler",
            3498: "legacyRey",
            3499: "legacyDarthVader",
            3500: "legacyCaptainMarvel",
            3501: "legacyFirstAvenger",
            3512: "fenix6sSportAsia",
            3513: "fenix6sAsia",
            3514: "fenix6SportAsia",
            3515: "fenix6Asia",
            3516: "fenix6xAsia",
            3535: "legacyCaptainMarvelAsia",
            3536: "legacyFirstAvengerAsia",
            3537: "legacyReyAsia",
            3538: "legacyDarthVaderAsia",
            3542: "descentMk2s",
            3558: "edge130Plus",
            3570: "edge1030Plus",
            3578: "rally200",
            3589: "fr745",
            3596: "venusqMusic",
            3599: "venusqMusicV2",
            3600: "venusq",
            3615: "lily",
            3624: "marqAdventurer",
            3638: "enduro",
            3639: "swim2Apac",
            3648: "marqAdventurerAsia",
            3652: "fr945Lte",
            3702: "descentMk2Asia",
            3703: "venu2",
            3704: "venu2s",
            3737: "venuDaimlerAsia",
            3739: "marqGolfer",
            3740: "venuDaimler",
            3794: "fr745Asia",
            3808: "variaRct715",
            3809: "lilyAsia",
            3812: "edge1030PlusAsia",
            3813: "edge130PlusAsia",
            3823: "approachS12",
            3872: "enduroAsia",
            3837: "venusqAsia",
            3843: "edge1040",
            3850: "marqGolferAsia",
            3851: "venu2Plus",
            3865: "gnss",
            3869: "fr55",
            3888: "instinct2",
            3889: "instinct2s",
            3905: "fenix7s",
            3906: "fenix7",
            3907: "fenix7x",
            3908: "fenix7sApac",
            3909: "fenix7Apac",
            3910: "fenix7xApac",
            3927: "approachG12",
            3930: "descentMk2sAsia",
            3934: "approachS42",
            3943: "epixGen2",
            3944: "epixGen2Apac",
            3949: "venu2sAsia",
            3950: "venu2Asia",
            3978: "fr945LteAsia",
            3982: "vivoMoveSport",
            3983: "vivomoveTrend",
            3986: "approachS12Asia",
            3990: "fr255Music",
            3991: "fr255SmallMusic",
            3992: "fr255",
            3993: "fr255Small",
            4001: "approachG12Asia",
            4002: "approachS42Asia",
            4005: "descentG1",
            4017: "venu2PlusAsia",
            4024: "fr955",
            4033: "fr55Asia",
            4061: "edge540",
            4062: "edge840",
            4063: "vivosmart5",
            4071: "instinct2Asia",
            4105: "marqGen2",
            4115: "venusq2",
            4116: "venusq2music",
            4124: "marqGen2Aviator",
            4125: "d2AirX10",
            4130: "hrmProPlus",
            4132: "descentG1Asia",
            4135: "tactix7",
            4155: "instinctCrossover",
            4169: "edgeExplore2",
            4222: "descentMk3",
            4223: "descentMk3i",
            4233: "approachS70",
            4257: "fr265Large",
            4258: "fr265Small",
            4260: "venu3",
            4261: "venu3s",
            4265: "tacxNeoSmart",
            4266: "tacxNeo2Smart",
            4267: "tacxNeo2TSmart",
            4268: "tacxNeoSmartBike",
            4269: "tacxSatoriSmart",
            4270: "tacxFlowSmart",
            4271: "tacxVortexSmart",
            4272: "tacxBushidoSmart",
            4273: "tacxGeniusSmart",
            4274: "tacxFluxFluxSSmart",
            4275: "tacxFlux2Smart",
            4276: "tacxMagnum",
            4305: "edge1040Asia",
            4312: "epixGen2Pro42",
            4313: "epixGen2Pro47",
            4314: "epixGen2Pro51",
            4315: "fr965",
            4341: "enduro2",
            4374: "fenix7sProSolar",
            4375: "fenix7ProSolar",
            4376: "fenix7xProSolar",
            4380: "lily2",
            4394: "instinct2x",
            4426: "vivoactive5",
            4432: "fr165",
            4433: "fr165Music",
            4440: "edge1050",
            4442: "descentT2",
            4446: "hrmFit",
            4472: "marqGen2Commander",
            4477: "lilyAthlete",
            4532: "fenix8Solar",
            4533: "fenix8SolarLarge",
            4534: "fenix8Small",
            4536: "fenix8",
            4556: "d2Mach1Pro",
            4575: "enduro3",
            4583: "instinctE40mm",
            4584: "instinctE45mm",
            4585: "instinct3Solar45mm",
            4586: "instinct3Amoled45mm",
            4587: "instinct3Amoled50mm",
            4588: "descentG2",
            4603: "venuX1",
            4606: "hrm200",
            4625: "vivoactive6",
            4647: "approachS44",
            4655: "edgeMtb",
            4656: "approachS50",
            4666: "fenixE",
            4759: "instinct3Solar50mm",
            4775: "tactix8Amoled",
            4776: "tactix8Solar",
            10007: "sdm4",
            10014: "edgeRemote",
            20533: "tacxTrainingAppWin",
            20534: "tacxTrainingAppMac",
            20565: "tacxTrainingAppMacCatalyst",
            20119: "trainingCenter",
            30045: "tacxTrainingAppAndroid",
            30046: "tacxTrainingAppIos",
            30047: "tacxTrainingAppLegacy",
            65531: "connectiqSimulator",
            65532: "androidAntplusPlugin",
            65534: "connect"
        },
        antplusDeviceType: {
            1: "antfs",
            11: "bikePower",
            12: "environmentSensorLegacy",
            15: "multiSportSpeedDistance",
            16: "control",
            17: "fitnessEquipment",
            18: "bloodPressure",
            19: "geocacheNode",
            20: "lightElectricVehicle",
            25: "envSensor",
            26: "racquet",
            27: "controlHub",
            31: "muscleOxygen",
            34: "shifting",
            35: "bikeLightMain",
            36: "bikeLightShared",
            38: "exd",
            40: "bikeRadar",
            46: "bikeAero",
            119: "weightScale",
            120: "heartRate",
            121: "bikeSpeedCadence",
            122: "bikeCadence",
            123: "bikeSpeed",
            124: "strideSpeedDistance"
        },
        antNetwork: {
            0: "public",
            1: "antplus",
            2: "antfs",
            3: "private"
        },
        workoutCapabilities: {
            0x00000001: "interval",
            0x00000002: "custom",
            0x00000004: "fitnessEquipment",
            0x00000008: "firstbeat",
            0x00000010: "newLeaf",
            0x00000020: "tcx",
            0x00000080: "speed",
            0x00000100: "heartRate",
            0x00000200: "distance",
            0x00000400: "cadence",
            0x00000800: "power",
            0x00001000: "grade",
            0x00002000: "resistance",
            0x00004000: "protected"
        },
        batteryStatus: {
            1: "new",
            2: "good",
            3: "ok",
            4: "low",
            5: "critical",
            6: "charging",
            7: "unknown"
        },
        hrType: {
            0: "normal",
            1: "irregular"
        },
        courseCapabilities: {
            0x00000001: "processed",
            0x00000002: "valid",
            0x00000004: "time",
            0x00000008: "distance",
            0x00000010: "position",
            0x00000020: "heartRate",
            0x00000040: "power",
            0x00000080: "cadence",
            0x00000100: "training",
            0x00000200: "navigation",
            0x00000400: "bikeway",
            0x00001000: "aviation"
        },
        weight: {
            0xFFFE: "calculating"
        },
        workoutHr: {
            100: "bpmOffset"
        },
        workoutPower: {
            1000: "wattsOffset"
        },
        bpStatus: {
            0: "noError",
            1: "errorIncompleteData",
            2: "errorNoMeasurement",
            3: "errorDataOutOfRange",
            4: "errorIrregularHeartRate"
        },
        userLocalId: {
            0x0000: "localMin",
            0x000F: "localMax",
            0x0010: "stationaryMin",
            0x00FF: "stationaryMax",
            0x0100: "portableMin",
            0xFFFE: "portableMax"
        },
        swimStroke: {
            0: "freestyle",
            1: "backstroke",
            2: "breaststroke",
            3: "butterfly",
            4: "drill",
            5: "mixed",
            6: "im",
            7: "imByRound",
            8: "rimo"
        },
        activityType: {
            0: "generic",
            1: "running",
            2: "cycling",
            3: "transition",
            4: "fitnessEquipment",
            5: "swimming",
            6: "walking",
            8: "sedentary",
            254: "all"
        },
        activitySubtype: {
            0: "generic",
            1: "treadmill",
            2: "street",
            3: "trail",
            4: "track",
            5: "spin",
            6: "indoorCycling",
            7: "road",
            8: "mountain",
            9: "downhill",
            10: "recumbent",
            11: "cyclocross",
            12: "handCycling",
            13: "trackCycling",
            14: "indoorRowing",
            15: "elliptical",
            16: "stairClimbing",
            17: "lapSwimming",
            18: "openWater",
            254: "all"
        },
        activityLevel: {
            0: "low",
            1: "medium",
            2: "high"
        },
        side: {
            0: "right",
            1: "left"
        },
        leftRightBalance: {
            0x7F: "mask",
            0x80: "right"
        },
        leftRightBalance100: {
            0x3FFF: "mask",
            0x8000: "right"
        },
        lengthType: {
            0: "idle",
            1: "active"
        },
        dayOfWeek: {
            0: "sunday",
            1: "monday",
            2: "tuesday",
            3: "wednesday",
            4: "thursday",
            5: "friday",
            6: "saturday"
        },
        connectivityCapabilities: {
            0x00000001: "bluetooth",
            0x00000002: "bluetoothLe",
            0x00000004: "ant",
            0x00000008: "activityUpload",
            0x00000010: "courseDownload",
            0x00000020: "workoutDownload",
            0x00000040: "liveTrack",
            0x00000080: "weatherConditions",
            0x00000100: "weatherAlerts",
            0x00000200: "gpsEphemerisDownload",
            0x00000400: "explicitArchive",
            0x00000800: "setupIncomplete",
            0x00001000: "continueSyncAfterSoftwareUpdate",
            0x00002000: "connectIqAppDownload",
            0x00004000: "golfCourseDownload",
            0x00008000: "deviceInitiatesSync",
            0x00010000: "connectIqWatchAppDownload",
            0x00020000: "connectIqWidgetDownload",
            0x00040000: "connectIqWatchFaceDownload",
            0x00080000: "connectIqDataFieldDownload",
            0x00100000: "connectIqAppManagment",
            0x00200000: "swingSensor",
            0x00400000: "swingSensorRemote",
            0x00800000: "incidentDetection",
            0x01000000: "audioPrompts",
            0x02000000: "wifiVerification",
            0x04000000: "trueUp",
            0x08000000: "findMyWatch",
            0x10000000: "remoteManualSync",
            0x20000000: "liveTrackAutoStart",
            0x40000000: "liveTrackMessaging",
            0x80000000: "instantInput"
        },
        weatherReport: {
            0: "current",
            1: "forecast",
            1: "hourlyForecast",
            2: "dailyForecast"
        },
        weatherStatus: {
            0: "clear",
            1: "partlyCloudy",
            2: "mostlyCloudy",
            3: "rain",
            4: "snow",
            5: "windy",
            6: "thunderstorms",
            7: "wintryMix",
            8: "fog",
            11: "hazy",
            12: "hail",
            13: "scatteredShowers",
            14: "scatteredThunderstorms",
            15: "unknownPrecipitation",
            16: "lightRain",
            17: "heavyRain",
            18: "lightSnow",
            19: "heavySnow",
            20: "lightRainSnow",
            21: "heavyRainSnow",
            22: "cloudy"
        },
        weatherSeverity: {
            0: "unknown",
            1: "warning",
            2: "watch",
            3: "advisory",
            4: "statement"
        },
        weatherSevereType: {
            0: "unspecified",
            1: "tornado",
            2: "tsunami",
            3: "hurricane",
            4: "extremeWind",
            5: "typhoon",
            6: "inlandHurricane",
            7: "hurricaneForceWind",
            8: "waterspout",
            9: "severeThunderstorm",
            10: "wreckhouseWinds",
            11: "lesSuetesWind",
            12: "avalanche",
            13: "flashFlood",
            14: "tropicalStorm",
            15: "inlandTropicalStorm",
            16: "blizzard",
            17: "iceStorm",
            18: "freezingRain",
            19: "debrisFlow",
            20: "flashFreeze",
            21: "dustStorm",
            22: "highWind",
            23: "winterStorm",
            24: "heavyFreezingSpray",
            25: "extremeCold",
            26: "windChill",
            27: "coldWave",
            28: "heavySnowAlert",
            29: "lakeEffectBlowingSnow",
            30: "snowSquall",
            31: "lakeEffectSnow",
            32: "winterWeather",
            33: "sleet",
            34: "snowfall",
            35: "snowAndBlowingSnow",
            36: "blowingSnow",
            37: "snowAlert",
            38: "arcticOutflow",
            39: "freezingDrizzle",
            40: "storm",
            41: "stormSurge",
            42: "rainfall",
            43: "arealFlood",
            44: "coastalFlood",
            45: "lakeshoreFlood",
            46: "excessiveHeat",
            47: "heat",
            48: "weather",
            49: "highHeatAndHumidity",
            50: "humidexAndHealth",
            51: "humidex",
            52: "gale",
            53: "freezingSpray",
            54: "specialMarine",
            55: "squall",
            56: "strongWind",
            57: "lakeWind",
            58: "marineWeather",
            59: "wind",
            60: "smallCraftHazardousSeas",
            61: "hazardousSeas",
            62: "smallCraft",
            63: "smallCraftWinds",
            64: "smallCraftRoughBar",
            65: "highWaterLevel",
            66: "ashfall",
            67: "freezingFog",
            68: "denseFog",
            69: "denseSmoke",
            70: "blowingDust",
            71: "hardFreeze",
            72: "freeze",
            73: "frost",
            74: "fireWeather",
            75: "flood",
            76: "ripTide",
            77: "highSurf",
            78: "smog",
            79: "airQuality",
            80: "briskWind",
            81: "airStagnation",
            82: "lowWater",
            83: "hydrological",
            84: "specialWeather"
        },
        timeIntoDay: {},
        localtimeIntoDay: {},
        strokeType: {
            0: "noEvent",
            1: "other",
            2: "serve",
            3: "forehand",
            4: "backhand",
            5: "smash"
        },
        bodyLocation: {
            0: "leftLeg",
            1: "leftCalf",
            2: "leftShin",
            3: "leftHamstring",
            4: "leftQuad",
            5: "leftGlute",
            6: "rightLeg",
            7: "rightCalf",
            8: "rightShin",
            9: "rightHamstring",
            10: "rightQuad",
            11: "rightGlute",
            12: "torsoBack",
            13: "leftLowerBack",
            14: "leftUpperBack",
            15: "rightLowerBack",
            16: "rightUpperBack",
            17: "torsoFront",
            18: "leftAbdomen",
            19: "leftChest",
            20: "rightAbdomen",
            21: "rightChest",
            22: "leftArm",
            23: "leftShoulder",
            24: "leftBicep",
            25: "leftTricep",
            26: "leftBrachioradialis",
            27: "leftForearmExtensors",
            28: "rightArm",
            29: "rightShoulder",
            30: "rightBicep",
            31: "rightTricep",
            32: "rightBrachioradialis",
            33: "rightForearmExtensors",
            34: "neck",
            35: "throat",
            36: "waistMidBack",
            37: "waistFront",
            38: "waistLeft",
            39: "waistRight"
        },
        segmentLapStatus: {
            0: "end",
            1: "fail"
        },
        segmentLeaderboardType: {
            0: "overall",
            1: "personalBest",
            2: "connections",
            3: "group",
            4: "challenger",
            5: "kom",
            6: "qom",
            7: "pr",
            8: "goal",
            9: "carrot",
            10: "clubLeader",
            11: "rival",
            12: "last",
            13: "recentBest",
            14: "courseRecord"
        },
        segmentDeleteStatus: {
            0: "doNotDelete",
            1: "deleteOne",
            2: "deleteAll"
        },
        segmentSelectionType: {
            0: "starred",
            1: "suggested"
        },
        sourceType: {
            0: "ant",
            1: "antplus",
            2: "bluetooth",
            3: "bluetoothLowEnergy",
            4: "wifi",
            5: "local"
        },
        localDeviceType: {
            0: "gps",
            1: "glonass",
            2: "gpsGlonass",
            3: "accelerometer",
            4: "barometer",
            5: "temperature",
            10: "whr",
            12: "sensorHub"
        },
        bleDeviceType: {
            0: "connectedGps",
            1: "heartRate",
            2: "bikePower",
            3: "bikeSpeedCadence",
            4: "bikeSpeed",
            5: "bikeCadence",
            6: "footpod",
            7: "bikeTrainer"
        },
        antChannelId: {
            0xF0000000: "antExtendedDeviceNumberUpperNibble",
            0x0F000000: "antTransmissionTypeLowerNibble",
            0x00FF0000: "antDeviceType",
            0x0000FFFF: "antDeviceNumber"
        },
        displayOrientation: {
            0: "auto",
            1: "portrait",
            2: "landscape",
            3: "portraitFlipped",
            4: "landscapeFlipped"
        },
        workoutEquipment: {
            0: "none",
            1: "swimFins",
            2: "swimKickboard",
            3: "swimPaddles",
            4: "swimPullBuoy",
            5: "swimSnorkel"
        },
        watchfaceMode: {
            0: "digital",
            1: "analog",
            2: "connectIq",
            3: "disabled"
        },
        digitalWatchfaceLayout: {
            0: "traditional",
            1: "modern",
            2: "bold"
        },
        analogWatchfaceLayout: {
            0: "minimal",
            1: "traditional",
            2: "modern"
        },
        riderPositionType: {
            0: "seated",
            1: "standing",
            2: "transitionToSeated",
            3: "transitionToStanding"
        },
        powerPhaseType: {
            0: "powerPhaseStartAngle",
            1: "powerPhaseEndAngle",
            2: "powerPhaseArcLength",
            3: "powerPhaseCenter"
        },
        cameraEventType: {
            0: "videoStart",
            1: "videoSplit",
            2: "videoEnd",
            3: "photoTaken",
            4: "videoSecondStreamStart",
            5: "videoSecondStreamSplit",
            6: "videoSecondStreamEnd",
            7: "videoSplitStart",
            8: "videoSecondStreamSplitStart",
            11: "videoPause",
            12: "videoSecondStreamPause",
            13: "videoResume",
            14: "videoSecondStreamResume"
        },
        sensorType: {
            0: "accelerometer",
            1: "gyroscope",
            2: "compass",
            3: "barometer"
        },
        bikeLightNetworkConfigType: {
            0: "auto",
            4: "individual",
            5: "highVisibility",
            6: "trail"
        },
        commTimeoutType: {
            0: "wildcardPairingTimeout",
            1: "pairingTimeout",
            2: "connectionLost",
            3: "connectionTimeout"
        },
        cameraOrientationType: {
            0: "cameraOrientation0",
            1: "cameraOrientation90",
            2: "cameraOrientation180",
            3: "cameraOrientation270"
        },
        attitudeStage: {
            0: "failed",
            1: "aligning",
            2: "degraded",
            3: "valid"
        },
        attitudeValidity: {
            0x0001: "trackAngleHeadingValid",
            0x0002: "pitchValid",
            0x0004: "rollValid",
            0x0008: "lateralBodyAccelValid",
            0x0010: "normalBodyAccelValid",
            0x0020: "turnRateValid",
            0x0040: "hwFail",
            0x0080: "magInvalid",
            0x0100: "noGps",
            0x0200: "gpsInvalid",
            0x0400: "solutionCoasting",
            0x0800: "trueTrackAngle",
            0x1000: "magneticHeading"
        },
        autoSyncFrequency: {
            0: "never",
            1: "occasionally",
            2: "frequent",
            3: "onceADay",
            4: "remote"
        },
        exdLayout: {
            0: "fullScreen",
            1: "halfVertical",
            2: "halfHorizontal",
            3: "halfVerticalRightSplit",
            4: "halfHorizontalBottomSplit",
            5: "fullQuarterSplit",
            6: "halfVerticalLeftSplit",
            7: "halfHorizontalTopSplit",
            8: "dynamic"
        },
        exdDisplayType: {
            0: "numerical",
            1: "simple",
            2: "graph",
            3: "bar",
            4: "circleGraph",
            5: "virtualPartner",
            6: "balance",
            7: "stringList",
            8: "string",
            9: "simpleDynamicIcon",
            10: "gauge"
        },
        exdDataUnits: {
            0: "noUnits",
            1: "laps",
            2: "milesPerHour",
            3: "kilometersPerHour",
            4: "feetPerHour",
            5: "metersPerHour",
            6: "degreesCelsius",
            7: "degreesFarenheit",
            8: "zone",
            9: "gear",
            10: "rpm",
            11: "bpm",
            12: "degrees",
            13: "millimeters",
            14: "meters",
            15: "kilometers",
            16: "feet",
            17: "yards",
            18: "kilofeet",
            19: "miles",
            20: "time",
            21: "enumTurnType",
            22: "percent",
            23: "watts",
            24: "wattsPerKilogram",
            25: "enumBatteryStatus",
            26: "enumBikeLightBeamAngleMode",
            27: "enumBikeLightBatteryStatus",
            28: "enumBikeLightNetworkConfigType",
            29: "lights",
            30: "seconds",
            31: "minutes",
            32: "hours",
            33: "calories",
            34: "kilojoules",
            35: "milliseconds",
            36: "secondPerMile",
            37: "secondPerKilometer",
            38: "centimeter",
            39: "enumCoursePoint",
            40: "bradians",
            41: "enumSport",
            42: "inchesHg",
            43: "mmHg",
            44: "mbars",
            45: "hectoPascals",
            46: "feetPerMin",
            47: "metersPerMin",
            48: "metersPerSec",
            49: "eightCardinal"
        },
        exdQualifiers: {
            0: "noQualifier",
            1: "instantaneous",
            2: "average",
            3: "lap",
            4: "maximum",
            5: "maximumAverage",
            6: "maximumLap",
            7: "lastLap",
            8: "averageLap",
            9: "toDestination",
            10: "toGo",
            11: "toNext",
            12: "nextCoursePoint",
            13: "total",
            14: "threeSecondAverage",
            15: "tenSecondAverage",
            16: "thirtySecondAverage",
            17: "percentMaximum",
            18: "percentMaximumAverage",
            19: "lapPercentMaximum",
            20: "elapsed",
            21: "sunrise",
            22: "sunset",
            23: "comparedToVirtualPartner",
            24: "maximum24h",
            25: "minimum24h",
            26: "minimum",
            27: "first",
            28: "second",
            29: "third",
            30: "shifter",
            31: "lastSport",
            32: "moving",
            33: "stopped",
            34: "estimatedTotal",
            242: "zone9",
            243: "zone8",
            244: "zone7",
            245: "zone6",
            246: "zone5",
            247: "zone4",
            248: "zone3",
            249: "zone2",
            250: "zone1"
        },
        exdDescriptors: {
            0: "bikeLightBatteryStatus",
            1: "beamAngleStatus",
            2: "bateryLevel",
            3: "lightNetworkMode",
            4: "numberLightsConnected",
            5: "cadence",
            6: "distance",
            7: "estimatedTimeOfArrival",
            8: "heading",
            9: "time",
            10: "batteryLevel",
            11: "trainerResistance",
            12: "trainerTargetPower",
            13: "timeSeated",
            14: "timeStanding",
            15: "elevation",
            16: "grade",
            17: "ascent",
            18: "descent",
            19: "verticalSpeed",
            20: "di2BatteryLevel",
            21: "frontGear",
            22: "rearGear",
            23: "gearRatio",
            24: "heartRate",
            25: "heartRateZone",
            26: "timeInHeartRateZone",
            27: "heartRateReserve",
            28: "calories",
            29: "gpsAccuracy",
            30: "gpsSignalStrength",
            31: "temperature",
            32: "timeOfDay",
            33: "balance",
            34: "pedalSmoothness",
            35: "power",
            36: "functionalThresholdPower",
            37: "intensityFactor",
            38: "work",
            39: "powerRatio",
            40: "normalizedPower",
            41: "trainingStressScore",
            42: "timeOnZone",
            43: "speed",
            44: "laps",
            45: "reps",
            46: "workoutStep",
            47: "courseDistance",
            48: "navigationDistance",
            49: "courseEstimatedTimeOfArrival",
            50: "navigationEstimatedTimeOfArrival",
            51: "courseTime",
            52: "navigationTime",
            53: "courseHeading",
            54: "navigationHeading",
            55: "powerZone",
            56: "torqueEffectiveness",
            57: "timerTime",
            58: "powerWeightRatio",
            59: "leftPlatformCenterOffset",
            60: "rightPlatformCenterOffset",
            61: "leftPowerPhaseStartAngle",
            62: "rightPowerPhaseStartAngle",
            63: "leftPowerPhaseFinishAngle",
            64: "rightPowerPhaseFinishAngle",
            65: "gears",
            66: "pace",
            67: "trainingEffect",
            68: "verticalOscillation",
            69: "verticalRatio",
            70: "groundContactTime",
            71: "leftGroundContactTimeBalance",
            72: "rightGroundContactTimeBalance",
            73: "strideLength",
            74: "runningCadence",
            75: "performanceCondition",
            76: "courseType",
            77: "timeInPowerZone",
            78: "navigationTurn",
            79: "courseLocation",
            80: "navigationLocation",
            81: "compass",
            82: "gearCombo",
            83: "muscleOxygen",
            84: "icon",
            85: "compassHeading",
            86: "gpsHeading",
            87: "gpsElevation",
            88: "anaerobicTrainingEffect",
            89: "course",
            90: "offCourse",
            91: "glideRatio",
            92: "verticalDistance",
            93: "vmg",
            94: "ambientPressure",
            95: "pressure",
            96: "vam"
        },
        autoActivityDetect: {
            0x00000000: "none",
            0x00000001: "running",
            0x00000002: "cycling",
            0x00000004: "swimming",
            0x00000008: "walking",
            0x00000020: "elliptical",
            0x00000400: "sedentary"
        },
        supportedExdScreenLayouts: {
            0x00000001: "fullScreen",
            0x00000002: "halfVertical",
            0x00000004: "halfHorizontal",
            0x00000008: "halfVerticalRightSplit",
            0x00000010: "halfHorizontalBottomSplit",
            0x00000020: "fullQuarterSplit",
            0x00000040: "halfVerticalLeftSplit",
            0x00000080: "halfHorizontalTopSplit"
        },
        fitBaseType: {
            0: "enum",
            1: "sint8",
            2: "uint8",
            131: "sint16",
            132: "uint16",
            133: "sint32",
            134: "uint32",
            7: "string",
            136: "float32",
            137: "float64",
            10: "uint8z",
            139: "uint16z",
            140: "uint32z",
            13: "byte",
            142: "sint64",
            143: "uint64",
            144: "uint64z"
        },
        turnType: {
            0: "arrivingIdx",
            1: "arrivingLeftIdx",
            2: "arrivingRightIdx",
            3: "arrivingViaIdx",
            4: "arrivingViaLeftIdx",
            5: "arrivingViaRightIdx",
            6: "bearKeepLeftIdx",
            7: "bearKeepRightIdx",
            8: "continueIdx",
            9: "exitLeftIdx",
            10: "exitRightIdx",
            11: "ferryIdx",
            12: "roundabout45Idx",
            13: "roundabout90Idx",
            14: "roundabout135Idx",
            15: "roundabout180Idx",
            16: "roundabout225Idx",
            17: "roundabout270Idx",
            18: "roundabout315Idx",
            19: "roundabout360Idx",
            20: "roundaboutNeg45Idx",
            21: "roundaboutNeg90Idx",
            22: "roundaboutNeg135Idx",
            23: "roundaboutNeg180Idx",
            24: "roundaboutNeg225Idx",
            25: "roundaboutNeg270Idx",
            26: "roundaboutNeg315Idx",
            27: "roundaboutNeg360Idx",
            28: "roundaboutGenericIdx",
            29: "roundaboutNegGenericIdx",
            30: "sharpTurnLeftIdx",
            31: "sharpTurnRightIdx",
            32: "turnLeftIdx",
            33: "turnRightIdx",
            34: "uturnLeftIdx",
            35: "uturnRightIdx",
            36: "iconInvIdx",
            37: "iconIdxCnt"
        },
        bikeLightBeamAngleMode: {
            0: "manual",
            1: "auto"
        },
        fitBaseUnit: {
            0: "other",
            1: "kilogram",
            2: "pound"
        },
        setType: {
            0: "rest",
            1: "active"
        },
        maxMetCategory: {
            0: "generic",
            1: "cycling"
        },
        exerciseCategory: {
            0: "benchPress",
            1: "calfRaise",
            2: "cardio",
            3: "carry",
            4: "chop",
            5: "core",
            6: "crunch",
            7: "curl",
            8: "deadlift",
            9: "flye",
            10: "hipRaise",
            11: "hipStability",
            12: "hipSwing",
            13: "hyperextension",
            14: "lateralRaise",
            15: "legCurl",
            16: "legRaise",
            17: "lunge",
            18: "olympicLift",
            19: "plank",
            20: "plyo",
            21: "pullUp",
            22: "pushUp",
            23: "row",
            24: "shoulderPress",
            25: "shoulderStability",
            26: "shrug",
            27: "sitUp",
            28: "squat",
            29: "totalBody",
            30: "tricepsExtension",
            31: "warmUp",
            32: "run",
            33: "bike",
            34: "cardioSensors",
            35: "move",
            36: "pose",
            37: "bandedExercises",
            38: "battleRope",
            39: "elliptical",
            40: "floorClimb",
            41: "indoorBike",
            42: "indoorRow",
            43: "ladder",
            44: "sandbag",
            45: "sled",
            46: "sledgeHammer",
            47: "stairStepper",
            49: "suspension",
            50: "tire",
            52: "runIndoor",
            53: "bikeOutdoor",
            65534: "unknown"
        },
        benchPressExerciseName: {
            0: "alternatingDumbbellChestPressOnSwissBall",
            1: "barbellBenchPress",
            2: "barbellBoardBenchPress",
            3: "barbellFloorPress",
            4: "closeGripBarbellBenchPress",
            5: "declineDumbbellBenchPress",
            6: "dumbbellBenchPress",
            7: "dumbbellFloorPress",
            8: "inclineBarbellBenchPress",
            9: "inclineDumbbellBenchPress",
            10: "inclineSmithMachineBenchPress",
            11: "isometricBarbellBenchPress",
            12: "kettlebellChestPress",
            13: "neutralGripDumbbellBenchPress",
            14: "neutralGripDumbbellInclineBenchPress",
            15: "oneArmFloorPress",
            16: "weightedOneArmFloorPress",
            17: "partialLockout",
            18: "reverseGripBarbellBenchPress",
            19: "reverseGripInclineBenchPress",
            20: "singleArmCableChestPress",
            21: "singleArmDumbbellBenchPress",
            22: "smithMachineBenchPress",
            23: "swissBallDumbbellChestPress",
            24: "tripleStopBarbellBenchPress",
            25: "wideGripBarbellBenchPress",
            26: "alternatingDumbbellChestPress"
        },
        calfRaiseExerciseName: {
            0: "3WayCalfRaise",
            1: "3WayWeightedCalfRaise",
            2: "3WaySingleLegCalfRaise",
            3: "3WayWeightedSingleLegCalfRaise",
            4: "donkeyCalfRaise",
            5: "weightedDonkeyCalfRaise",
            6: "seatedCalfRaise",
            7: "weightedSeatedCalfRaise",
            8: "seatedDumbbellToeRaise",
            9: "singleLegBentKneeCalfRaise",
            10: "weightedSingleLegBentKneeCalfRaise",
            11: "singleLegDeclinePushUp",
            12: "singleLegDonkeyCalfRaise",
            13: "weightedSingleLegDonkeyCalfRaise",
            14: "singleLegHipRaiseWithKneeHold",
            15: "singleLegStandingCalfRaise",
            16: "singleLegStandingDumbbellCalfRaise",
            17: "standingBarbellCalfRaise",
            18: "standingCalfRaise",
            19: "weightedStandingCalfRaise",
            20: "standingDumbbellCalfRaise"
        },
        cardioExerciseName: {
            0: "bobAndWeaveCircle",
            1: "weightedBobAndWeaveCircle",
            2: "cardioCoreCrawl",
            3: "weightedCardioCoreCrawl",
            4: "doubleUnder",
            5: "weightedDoubleUnder",
            6: "jumpRope",
            7: "weightedJumpRope",
            8: "jumpRopeCrossover",
            9: "weightedJumpRopeCrossover",
            10: "jumpRopeJog",
            11: "weightedJumpRopeJog",
            12: "jumpingJacks",
            13: "weightedJumpingJacks",
            14: "skiMoguls",
            15: "weightedSkiMoguls",
            16: "splitJacks",
            17: "weightedSplitJacks",
            18: "squatJacks",
            19: "weightedSquatJacks",
            20: "tripleUnder",
            21: "weightedTripleUnder",
            22: "elliptical",
            23: "spinning",
            24: "polePaddleForwardWheelchair",
            25: "polePaddleBackwardWheelchair",
            26: "poleHandcycleForwardWheelchair",
            27: "poleHandcycleBackwardWheelchair",
            28: "poleRainbowWheelchair",
            29: "doublePunchForwardWheelchair",
            30: "doublePunchDownWheelchair",
            31: "doublePunchSidewaysWheelchair",
            32: "doublePunchUpWheelchair",
            33: "sitSkiWheelchair",
            34: "sittingJacksWheelchair",
            35: "punchForwardWheelchair",
            36: "punchDownWheelchair",
            37: "punchSidewaysWheelchair",
            38: "punchUpWheelchair",
            39: "punchBagWheelchair",
            40: "poleDdFfUuWheelchair",
            41: "butterflyArmsWheelchair",
            42: "punch"
        },
        carryExerciseName: {
            0: "barHolds",
            1: "farmersWalk",
            2: "farmersWalkOnToes",
            3: "hexDumbbellHold",
            4: "overheadCarry",
            5: "dumbbellWaiterCarry",
            6: "farmersCarryWalkLunge",
            7: "farmersCarry",
            8: "farmersCarryOnToes"
        },
        chopExerciseName: {
            0: "cablePullThrough",
            1: "cableRotationalLift",
            2: "cableWoodchop",
            3: "crossChopToKnee",
            4: "weightedCrossChopToKnee",
            5: "dumbbellChop",
            6: "halfKneelingRotation",
            7: "weightedHalfKneelingRotation",
            8: "halfKneelingRotationalChop",
            9: "halfKneelingRotationalReverseChop",
            10: "halfKneelingStabilityChop",
            11: "halfKneelingStabilityReverseChop",
            12: "kneelingRotationalChop",
            13: "kneelingRotationalReverseChop",
            14: "kneelingStabilityChop",
            15: "kneelingWoodchopper",
            16: "medicineBallWoodChops",
            17: "powerSquatChops",
            18: "weightedPowerSquatChops",
            19: "standingRotationalChop",
            20: "standingSplitRotationalChop",
            21: "standingSplitRotationalReverseChop",
            22: "standingStabilityReverseChop"
        },
        coreExerciseName: {
            0: "absJabs",
            1: "weightedAbsJabs",
            2: "alternatingPlateReach",
            3: "barbellRollout",
            4: "weightedBarbellRollout",
            5: "bodyBarObliqueTwist",
            6: "cableCorePress",
            7: "cableSideBend",
            8: "sideBend",
            9: "weightedSideBend",
            10: "crescentCircle",
            11: "weightedCrescentCircle",
            12: "cyclingRussianTwist",
            13: "weightedCyclingRussianTwist",
            14: "elevatedFeetRussianTwist",
            15: "weightedElevatedFeetRussianTwist",
            16: "halfTurkishGetUp",
            17: "kettlebellWindmill",
            18: "kneelingAbWheel",
            19: "weightedKneelingAbWheel",
            20: "modifiedFrontLever",
            21: "openKneeTucks",
            22: "weightedOpenKneeTucks",
            23: "sideAbsLegLift",
            24: "weightedSideAbsLegLift",
            25: "swissBallJackknife",
            26: "weightedSwissBallJackknife",
            27: "swissBallPike",
            28: "weightedSwissBallPike",
            29: "swissBallRollout",
            30: "weightedSwissBallRollout",
            31: "triangleHipPress",
            32: "weightedTriangleHipPress",
            33: "trxSuspendedJackknife",
            34: "weightedTrxSuspendedJackknife",
            35: "uBoat",
            36: "weightedUBoat",
            37: "windmillSwitches",
            38: "weightedWindmillSwitches",
            39: "alternatingSlideOut",
            40: "weightedAlternatingSlideOut",
            41: "ghdBackExtensions",
            42: "weightedGhdBackExtensions",
            43: "overheadWalk",
            44: "inchworm",
            45: "weightedModifiedFrontLever",
            46: "russianTwist",
            47: "abdominalLegRotations",
            48: "armAndLegExtensionOnKnees",
            49: "bicycle",
            50: "bicepCurlWithLegExtension",
            51: "catCow",
            52: "corkscrew",
            53: "crissCross",
            54: "crissCrossWithBall",
            55: "doubleLegStretch",
            56: "kneeFolds",
            57: "lowerLift",
            58: "neckPull",
            59: "pelvicClocks",
            60: "rollOver",
            61: "rollUp",
            62: "rolling",
            63: "rowing1",
            64: "rowing2",
            65: "scissors",
            66: "singleLegCircles",
            67: "singleLegStretch",
            68: "snakeTwist1And2",
            69: "swan",
            70: "swimming",
            71: "teaser",
            72: "theHundred",
            73: "bicepCurlWithLegExtensionWithWeights",
            75: "hangingLSit",
            77: "lowerLiftWithWeights",
            79: "ringLSit",
            80: "rowing1WithWeights",
            81: "rowing2WithWeights",
            82: "scissorsWithWeights",
            83: "singleLegStretchWithWeights",
            84: "toesToElbows",
            85: "weightedCrissCross",
            86: "weightedDoubleLegStretch",
            87: "weightedTheHundred",
            88: "lSit",
            89: "turkishGetUp",
            90: "weightedRingLSit",
            91: "weightedHangingLSit",
            92: "weightedLSit",
            93: "sideBendLowWheelchair",
            94: "sideBendMidWheelchair",
            95: "sideBendHighWheelchair",
            96: "seatedSideBend"
        },
        crunchExerciseName: {
            0: "bicycleCrunch",
            1: "cableCrunch",
            2: "circularArmCrunch",
            3: "crossedArmsCrunch",
            4: "weightedCrossedArmsCrunch",
            5: "crossLegReverseCrunch",
            6: "weightedCrossLegReverseCrunch",
            7: "crunchChop",
            8: "weightedCrunchChop",
            9: "doubleCrunch",
            10: "weightedDoubleCrunch",
            11: "elbowToKneeCrunch",
            12: "weightedElbowToKneeCrunch",
            13: "flutterKicks",
            14: "weightedFlutterKicks",
            15: "foamRollerReverseCrunchOnBench",
            16: "weightedFoamRollerReverseCrunchOnBench",
            17: "foamRollerReverseCrunchWithDumbbell",
            18: "foamRollerReverseCrunchWithMedicineBall",
            19: "frogPress",
            20: "hangingKneeRaiseObliqueCrunch",
            21: "weightedHangingKneeRaiseObliqueCrunch",
            22: "hipCrossover",
            23: "weightedHipCrossover",
            24: "hollowRock",
            25: "weightedHollowRock",
            26: "inclineReverseCrunch",
            27: "weightedInclineReverseCrunch",
            28: "kneelingCableCrunch",
            29: "kneelingCrossCrunch",
            30: "weightedKneelingCrossCrunch",
            31: "kneelingObliqueCableCrunch",
            32: "kneesToElbow",
            33: "legExtensions",
            34: "weightedLegExtensions",
            35: "legLevers",
            36: "mcgillCurlUp",
            37: "weightedMcgillCurlUp",
            38: "modifiedPilatesRollUpWithBall",
            39: "weightedModifiedPilatesRollUpWithBall",
            40: "pilatesCrunch",
            41: "weightedPilatesCrunch",
            42: "pilatesRollUpWithBall",
            43: "weightedPilatesRollUpWithBall",
            44: "raisedLegsCrunch",
            45: "weightedRaisedLegsCrunch",
            46: "reverseCrunch",
            47: "weightedReverseCrunch",
            48: "reverseCrunchOnABench",
            49: "weightedReverseCrunchOnABench",
            50: "reverseCurlAndLift",
            51: "weightedReverseCurlAndLift",
            52: "rotationalLift",
            53: "weightedRotationalLift",
            54: "seatedAlternatingReverseCrunch",
            55: "weightedSeatedAlternatingReverseCrunch",
            56: "seatedLegU",
            57: "weightedSeatedLegU",
            58: "sideToSideCrunchAndWeave",
            59: "weightedSideToSideCrunchAndWeave",
            60: "singleLegReverseCrunch",
            61: "weightedSingleLegReverseCrunch",
            62: "skaterCrunchCross",
            63: "weightedSkaterCrunchCross",
            64: "standingCableCrunch",
            65: "standingSideCrunch",
            66: "stepClimb",
            67: "weightedStepClimb",
            68: "swissBallCrunch",
            69: "swissBallReverseCrunch",
            70: "weightedSwissBallReverseCrunch",
            71: "swissBallRussianTwist",
            72: "weightedSwissBallRussianTwist",
            73: "swissBallSideCrunch",
            74: "weightedSwissBallSideCrunch",
            75: "thoracicCrunchesOnFoamRoller",
            76: "weightedThoracicCrunchesOnFoamRoller",
            77: "tricepsCrunch",
            78: "weightedBicycleCrunch",
            79: "weightedCrunch",
            80: "weightedSwissBallCrunch",
            81: "toesToBar",
            82: "weightedToesToBar",
            83: "crunch",
            84: "straightLegCrunchWithBall",
            86: "legClimbCrunch"
        },
        curlExerciseName: {
            0: "alternatingDumbbellBicepsCurl",
            1: "alternatingDumbbellBicepsCurlOnSwissBall",
            2: "alternatingInclineDumbbellBicepsCurl",
            3: "barbellBicepsCurl",
            4: "barbellReverseWristCurl",
            5: "barbellWristCurl",
            6: "behindTheBackBarbellReverseWristCurl",
            7: "behindTheBackOneArmCableCurl",
            8: "cableBicepsCurl",
            9: "cableHammerCurl",
            10: "cheatingBarbellBicepsCurl",
            11: "closeGripEzBarBicepsCurl",
            12: "crossBodyDumbbellHammerCurl",
            13: "deadHangBicepsCurl",
            14: "declineHammerCurl",
            15: "dumbbellBicepsCurlWithStaticHold",
            16: "dumbbellHammerCurl",
            17: "dumbbellReverseWristCurl",
            18: "dumbbellWristCurl",
            19: "ezBarPreacherCurl",
            20: "forwardBendBicepsCurl",
            21: "hammerCurlToPress",
            22: "inclineDumbbellBicepsCurl",
            23: "inclineOffsetThumbDumbbellCurl",
            24: "kettlebellBicepsCurl",
            25: "lyingConcentrationCableCurl",
            26: "oneArmPreacherCurl",
            27: "platePinchCurl",
            28: "preacherCurlWithCable",
            29: "reverseEzBarCurl",
            30: "reverseGripWristCurl",
            31: "reverseGripBarbellBicepsCurl",
            32: "seatedAlternatingDumbbellBicepsCurl",
            33: "seatedDumbbellBicepsCurl",
            34: "seatedReverseDumbbellCurl",
            35: "splitStanceOffsetPinkyDumbbellCurl",
            36: "standingAlternatingDumbbellCurls",
            37: "standingDumbbellBicepsCurl",
            38: "standingEzBarBicepsCurl",
            39: "staticCurl",
            40: "swissBallDumbbellOverheadTricepsExtension",
            41: "swissBallEzBarPreacherCurl",
            42: "twistingStandingDumbbellBicepsCurl",
            43: "wideGripEzBarBicepsCurl",
            44: "oneArmConcentrationCurl",
            45: "standingZottmanBicepsCurl",
            46: "dumbbellBicepsCurl",
            47: "dragCurlWheelchair",
            48: "dumbbellBicepsCurlWheelchair",
            49: "bottleCurl",
            50: "seatedBottleCurl"
        },
        deadliftExerciseName: {
            0: "barbellDeadlift",
            1: "barbellStraightLegDeadlift",
            2: "dumbbellDeadlift",
            3: "dumbbellSingleLegDeadliftToRow",
            4: "dumbbellStraightLegDeadlift",
            5: "kettlebellFloorToShelf",
            6: "oneArmOneLegDeadlift",
            7: "rackPull",
            8: "rotationalDumbbellStraightLegDeadlift",
            9: "singleArmDeadlift",
            10: "singleLegBarbellDeadlift",
            11: "singleLegBarbellStraightLegDeadlift",
            12: "singleLegDeadliftWithBarbell",
            13: "singleLegRdlCircuit",
            14: "singleLegRomanianDeadliftWithDumbbell",
            15: "sumoDeadlift",
            16: "sumoDeadliftHighPull",
            17: "trapBarDeadlift",
            18: "wideGripBarbellDeadlift",
            20: "kettlebellDeadlift",
            21: "kettlebellSumoDeadlift",
            23: "romanianDeadlift",
            24: "singleLegRomanianDeadliftCircuit",
            25: "straightLegDeadlift"
        },
        flyeExerciseName: {
            0: "cableCrossover",
            1: "declineDumbbellFlye",
            2: "dumbbellFlye",
            3: "inclineDumbbellFlye",
            4: "kettlebellFlye",
            5: "kneelingRearFlye",
            6: "singleArmStandingCableReverseFlye",
            7: "swissBallDumbbellFlye",
            8: "armRotations",
            9: "hugATree",
            10: "faceDownInclineReverseFlye",
            11: "inclineReverseFlye",
            12: "rearDeltFlyWheelchair"
        },
        hipRaiseExerciseName: {
            0: "barbellHipThrustOnFloor",
            1: "barbellHipThrustWithBench",
            2: "bentKneeSwissBallReverseHipRaise",
            3: "weightedBentKneeSwissBallReverseHipRaise",
            4: "bridgeWithLegExtension",
            5: "weightedBridgeWithLegExtension",
            6: "clamBridge",
            7: "frontKickTabletop",
            8: "weightedFrontKickTabletop",
            9: "hipExtensionAndCross",
            10: "weightedHipExtensionAndCross",
            11: "hipRaise",
            12: "weightedHipRaise",
            13: "hipRaiseWithFeetOnSwissBall",
            14: "weightedHipRaiseWithFeetOnSwissBall",
            15: "hipRaiseWithHeadOnBosuBall",
            16: "weightedHipRaiseWithHeadOnBosuBall",
            17: "hipRaiseWithHeadOnSwissBall",
            18: "weightedHipRaiseWithHeadOnSwissBall",
            19: "hipRaiseWithKneeSqueeze",
            20: "weightedHipRaiseWithKneeSqueeze",
            21: "inclineRearLegExtension",
            22: "weightedInclineRearLegExtension",
            23: "kettlebellSwing",
            24: "marchingHipRaise",
            25: "weightedMarchingHipRaise",
            26: "marchingHipRaiseWithFeetOnASwissBall",
            27: "weightedMarchingHipRaiseWithFeetOnASwissBall",
            28: "reverseHipRaise",
            29: "weightedReverseHipRaise",
            30: "singleLegHipRaise",
            31: "weightedSingleLegHipRaise",
            32: "singleLegHipRaiseWithFootOnBench",
            33: "weightedSingleLegHipRaiseWithFootOnBench",
            34: "singleLegHipRaiseWithFootOnBosuBall",
            35: "weightedSingleLegHipRaiseWithFootOnBosuBall",
            36: "singleLegHipRaiseWithFootOnFoamRoller",
            37: "weightedSingleLegHipRaiseWithFootOnFoamRoller",
            38: "singleLegHipRaiseWithFootOnMedicineBall",
            39: "weightedSingleLegHipRaiseWithFootOnMedicineBall",
            40: "singleLegHipRaiseWithHeadOnBosuBall",
            41: "weightedSingleLegHipRaiseWithHeadOnBosuBall",
            42: "weightedClamBridge",
            43: "singleLegSwissBallHipRaiseAndLegCurl",
            44: "clams",
            45: "innerThighCircles",
            46: "innerThighSideLift",
            47: "legCircles",
            48: "legLift",
            49: "legLiftInExternalRotation"
        },
        hipStabilityExerciseName: {
            0: "bandSideLyingLegRaise",
            1: "deadBug",
            2: "weightedDeadBug",
            3: "externalHipRaise",
            4: "weightedExternalHipRaise",
            5: "fireHydrantKicks",
            6: "weightedFireHydrantKicks",
            7: "hipCircles",
            8: "weightedHipCircles",
            9: "innerThighLift",
            10: "weightedInnerThighLift",
            11: "lateralWalksWithBandAtAnkles",
            12: "pretzelSideKick",
            13: "weightedPretzelSideKick",
            14: "proneHipInternalRotation",
            15: "weightedProneHipInternalRotation",
            16: "quadruped",
            17: "quadrupedHipExtension",
            18: "weightedQuadrupedHipExtension",
            19: "quadrupedWithLegLift",
            20: "weightedQuadrupedWithLegLift",
            21: "sideLyingLegRaise",
            22: "weightedSideLyingLegRaise",
            23: "slidingHipAdduction",
            24: "weightedSlidingHipAdduction",
            25: "standingAdduction",
            26: "weightedStandingAdduction",
            27: "standingCableHipAbduction",
            28: "standingHipAbduction",
            29: "weightedStandingHipAbduction",
            30: "standingRearLegRaise",
            31: "weightedStandingRearLegRaise",
            32: "supineHipInternalRotation",
            33: "weightedSupineHipInternalRotation",
            34: "lyingAbductionStretch"
        },
        hipSwingExerciseName: {
            0: "singleArmKettlebellSwing",
            1: "singleArmDumbbellSwing",
            2: "stepOutSwing",
            3: "oneArmSwing"
        },
        hyperextensionExerciseName: {
            0: "backExtensionWithOppositeArmAndLegReach",
            1: "weightedBackExtensionWithOppositeArmAndLegReach",
            2: "baseRotations",
            3: "weightedBaseRotations",
            4: "bentKneeReverseHyperextension",
            5: "weightedBentKneeReverseHyperextension",
            6: "hollowHoldAndRoll",
            7: "weightedHollowHoldAndRoll",
            8: "kicks",
            9: "weightedKicks",
            10: "kneeRaises",
            11: "weightedKneeRaises",
            12: "kneelingSuperman",
            13: "weightedKneelingSuperman",
            14: "latPullDownWithRow",
            15: "medicineBallDeadliftToReach",
            16: "oneArmOneLegRow",
            17: "oneArmRowWithBand",
            18: "overheadLungeWithMedicineBall",
            19: "plankKneeTucks",
            20: "weightedPlankKneeTucks",
            21: "sideStep",
            22: "weightedSideStep",
            23: "singleLegBackExtension",
            24: "weightedSingleLegBackExtension",
            25: "spineExtension",
            26: "weightedSpineExtension",
            27: "staticBackExtension",
            28: "weightedStaticBackExtension",
            29: "supermanFromFloor",
            30: "weightedSupermanFromFloor",
            31: "swissBallBackExtension",
            32: "weightedSwissBallBackExtension",
            33: "swissBallHyperextension",
            34: "weightedSwissBallHyperextension",
            35: "swissBallOppositeArmAndLegLift",
            36: "weightedSwissBallOppositeArmAndLegLift",
            37: "supermanOnSwissBall",
            38: "cobra",
            39: "supineFloorBarre"
        },
        lateralRaiseExerciseName: {
            0: "45DegreeCableExternalRotation",
            1: "alternatingLateralRaiseWithStaticHold",
            2: "barMuscleUp",
            3: "bentOverLateralRaise",
            4: "cableDiagonalRaise",
            5: "cableFrontRaise",
            6: "calorieRow",
            7: "comboShoulderRaise",
            8: "dumbbellDiagonalRaise",
            9: "dumbbellVRaise",
            10: "frontRaise",
            11: "leaningDumbbellLateralRaise",
            12: "lyingDumbbellRaise",
            13: "muscleUp",
            14: "oneArmCableLateralRaise",
            15: "overhandGripRearLateralRaise",
            16: "plateRaises",
            17: "ringDip",
            18: "weightedRingDip",
            19: "ringMuscleUp",
            20: "weightedRingMuscleUp",
            21: "ropeClimb",
            22: "weightedRopeClimb",
            23: "scaption",
            24: "seatedLateralRaise",
            25: "seatedRearLateralRaise",
            26: "sideLyingLateralRaise",
            27: "standingLift",
            28: "suspendedRow",
            29: "underhandGripRearLateralRaise",
            30: "wallSlide",
            31: "weightedWallSlide",
            32: "armCircles",
            33: "shavingTheHead",
            34: "dumbbellLateralRaise",
            36: "ringDipKipping",
            37: "wallWalk",
            38: "dumbbellFrontRaiseWheelchair",
            39: "dumbbellLateralRaiseWheelchair",
            40: "poleDoubleArmOverheadAndForwardWheelchair",
            41: "poleStraightArmOverheadWheelchair"
        },
        legCurlExerciseName: {
            0: "legCurl",
            1: "weightedLegCurl",
            2: "goodMorning",
            3: "seatedBarbellGoodMorning",
            4: "singleLegBarbellGoodMorning",
            5: "singleLegSlidingLegCurl",
            6: "slidingLegCurl",
            7: "splitBarbellGoodMorning",
            8: "splitStanceExtension",
            9: "staggeredStanceGoodMorning",
            10: "swissBallHipRaiseAndLegCurl",
            11: "zercherGoodMorning",
            12: "bandGoodMorning",
            13: "barGoodMorning"
        },
        legRaiseExerciseName: {
            0: "hangingKneeRaise",
            1: "hangingLegRaise",
            2: "weightedHangingLegRaise",
            3: "hangingSingleLegRaise",
            4: "weightedHangingSingleLegRaise",
            5: "kettlebellLegRaises",
            6: "legLoweringDrill",
            7: "weightedLegLoweringDrill",
            8: "lyingStraightLegRaise",
            9: "weightedLyingStraightLegRaise",
            10: "medicineBallLegDrops",
            11: "quadrupedLegRaise",
            12: "weightedQuadrupedLegRaise",
            13: "reverseLegRaise",
            14: "weightedReverseLegRaise",
            15: "reverseLegRaiseOnSwissBall",
            16: "weightedReverseLegRaiseOnSwissBall",
            17: "singleLegLoweringDrill",
            18: "weightedSingleLegLoweringDrill",
            19: "weightedHangingKneeRaise",
            20: "lateralStepover",
            21: "weightedLateralStepover"
        },
        lungeExerciseName: {
            0: "overheadLunge",
            1: "lungeMatrix",
            2: "weightedLungeMatrix",
            3: "alternatingBarbellForwardLunge",
            4: "alternatingDumbbellLungeWithReach",
            5: "backFootElevatedDumbbellSplitSquat",
            6: "barbellBoxLunge",
            7: "barbellBulgarianSplitSquat",
            8: "barbellCrossoverLunge",
            9: "barbellFrontSplitSquat",
            10: "barbellLunge",
            11: "barbellReverseLunge",
            12: "barbellSideLunge",
            13: "barbellSplitSquat",
            14: "coreControlRearLunge",
            15: "diagonalLunge",
            16: "dropLunge",
            17: "dumbbellBoxLunge",
            18: "dumbbellBulgarianSplitSquat",
            19: "dumbbellCrossoverLunge",
            20: "dumbbellDiagonalLunge",
            21: "dumbbellLunge",
            22: "dumbbellLungeAndRotation",
            23: "dumbbellOverheadBulgarianSplitSquat",
            24: "dumbbellReverseLungeToHighKneeAndPress",
            25: "dumbbellSideLunge",
            26: "elevatedFrontFootBarbellSplitSquat",
            27: "frontFootElevatedDumbbellSplitSquat",
            28: "gunslingerLunge",
            29: "lawnmowerLunge",
            30: "lowLungeWithIsometricAdduction",
            31: "lowSideToSideLunge",
            32: "lunge",
            33: "weightedLunge",
            34: "lungeWithArmReach",
            35: "lungeWithDiagonalReach",
            36: "lungeWithSideBend",
            37: "offsetDumbbellLunge",
            38: "offsetDumbbellReverseLunge",
            39: "overheadBulgarianSplitSquat",
            40: "overheadDumbbellReverseLunge",
            41: "overheadDumbbellSplitSquat",
            42: "overheadLungeWithRotation",
            43: "reverseBarbellBoxLunge",
            44: "reverseBoxLunge",
            45: "reverseDumbbellBoxLunge",
            46: "reverseDumbbellCrossoverLunge",
            47: "reverseDumbbellDiagonalLunge",
            48: "reverseLungeWithReachBack",
            49: "weightedReverseLungeWithReachBack",
            50: "reverseLungeWithTwistAndOverheadReach",
            51: "weightedReverseLungeWithTwistAndOverheadReach",
            52: "reverseSlidingBoxLunge",
            53: "weightedReverseSlidingBoxLunge",
            54: "reverseSlidingLunge",
            55: "weightedReverseSlidingLunge",
            56: "runnersLungeToBalance",
            57: "weightedRunnersLungeToBalance",
            58: "shiftingSideLunge",
            59: "sideAndCrossoverLunge",
            60: "weightedSideAndCrossoverLunge",
            61: "sideLunge",
            62: "weightedSideLunge",
            63: "sideLungeAndPress",
            64: "sideLungeJumpOff",
            65: "sideLungeSweep",
            66: "weightedSideLungeSweep",
            67: "sideLungeToCrossoverTap",
            68: "weightedSideLungeToCrossoverTap",
            69: "sideToSideLungeChops",
            70: "weightedSideToSideLungeChops",
            71: "siffJumpLunge",
            72: "weightedSiffJumpLunge",
            73: "singleArmReverseLungeAndPress",
            74: "slidingLateralLunge",
            75: "weightedSlidingLateralLunge",
            76: "walkingBarbellLunge",
            77: "walkingDumbbellLunge",
            78: "walkingLunge",
            79: "weightedWalkingLunge",
            80: "wideGripOverheadBarbellSplitSquat",
            81: "alternatingDumbbellLunge",
            82: "dumbbellReverseLunge",
            83: "overheadDumbbellLunge",
            84: "scissorPowerSwitch",
            85: "dumbbellOverheadWalkingLunge",
            86: "curtsyLunge",
            87: "weightedCurtsyLunge",
            88: "weightedShiftingSideLunge",
            89: "weightedSideLungeAndPress",
            90: "weightedSideLungeJumpOff"
        },
        olympicLiftExerciseName: {
            0: "barbellHangPowerClean",
            1: "barbellHangSquatClean",
            2: "barbellPowerClean",
            3: "barbellPowerSnatch",
            4: "barbellSquatClean",
            5: "cleanAndJerk",
            6: "barbellHangPowerSnatch",
            7: "barbellHangPull",
            8: "barbellHighPull",
            9: "barbellSnatch",
            10: "barbellSplitJerk",
            11: "clean",
            12: "dumbbellClean",
            13: "dumbbellHangPull",
            14: "oneHandDumbbellSplitSnatch",
            15: "pushJerk",
            16: "singleArmDumbbellSnatch",
            17: "singleArmHangSnatch",
            18: "singleArmKettlebellSnatch",
            19: "splitJerk",
            20: "squatCleanAndJerk",
            21: "dumbbellHangSnatch",
            22: "dumbbellPowerCleanAndJerk",
            23: "dumbbellPowerCleanAndPushPress",
            24: "dumbbellPowerCleanAndStrictPress",
            25: "dumbbellSnatch",
            26: "medicineBallClean",
            27: "cleanAndPress",
            28: "snatch"
        },
        plankExerciseName: {
            0: "45DegreePlank",
            1: "weighted45DegreePlank",
            2: "90DegreeStaticHold",
            3: "weighted90DegreeStaticHold",
            4: "bearCrawl",
            5: "weightedBearCrawl",
            6: "crossBodyMountainClimber",
            7: "weightedCrossBodyMountainClimber",
            8: "elbowPlankPikeJacks",
            9: "weightedElbowPlankPikeJacks",
            10: "elevatedFeetPlank",
            11: "weightedElevatedFeetPlank",
            12: "elevatorAbs",
            13: "weightedElevatorAbs",
            14: "extendedPlank",
            15: "weightedExtendedPlank",
            16: "fullPlankPasseTwist",
            17: "weightedFullPlankPasseTwist",
            18: "inchingElbowPlank",
            19: "weightedInchingElbowPlank",
            20: "inchwormToSidePlank",
            21: "weightedInchwormToSidePlank",
            22: "kneelingPlank",
            23: "weightedKneelingPlank",
            24: "kneelingSidePlankWithLegLift",
            25: "weightedKneelingSidePlankWithLegLift",
            26: "lateralRoll",
            27: "weightedLateralRoll",
            28: "lyingReversePlank",
            29: "weightedLyingReversePlank",
            30: "medicineBallMountainClimber",
            31: "weightedMedicineBallMountainClimber",
            32: "modifiedMountainClimberAndExtension",
            33: "weightedModifiedMountainClimberAndExtension",
            34: "mountainClimber",
            35: "weightedMountainClimber",
            36: "mountainClimberOnSlidingDiscs",
            37: "weightedMountainClimberOnSlidingDiscs",
            38: "mountainClimberWithFeetOnBosuBall",
            39: "weightedMountainClimberWithFeetOnBosuBall",
            40: "mountainClimberWithHandsOnBench",
            41: "mountainClimberWithHandsOnSwissBall",
            42: "weightedMountainClimberWithHandsOnSwissBall",
            43: "plank",
            44: "plankJacksWithFeetOnSlidingDiscs",
            45: "weightedPlankJacksWithFeetOnSlidingDiscs",
            46: "plankKneeTwist",
            47: "weightedPlankKneeTwist",
            48: "plankPikeJumps",
            49: "weightedPlankPikeJumps",
            50: "plankPikes",
            51: "weightedPlankPikes",
            52: "plankToStandUp",
            53: "weightedPlankToStandUp",
            54: "plankWithArmRaise",
            55: "weightedPlankWithArmRaise",
            56: "plankWithKneeToElbow",
            57: "weightedPlankWithKneeToElbow",
            58: "plankWithObliqueCrunch",
            59: "weightedPlankWithObliqueCrunch",
            60: "plyometricSidePlank",
            61: "weightedPlyometricSidePlank",
            62: "rollingSidePlank",
            63: "weightedRollingSidePlank",
            64: "sideKickPlank",
            65: "weightedSideKickPlank",
            66: "sidePlank",
            67: "weightedSidePlank",
            68: "sidePlankAndRow",
            69: "weightedSidePlankAndRow",
            70: "sidePlankLift",
            71: "weightedSidePlankLift",
            72: "sidePlankWithElbowOnBosuBall",
            73: "weightedSidePlankWithElbowOnBosuBall",
            74: "sidePlankWithFeetOnBench",
            75: "weightedSidePlankWithFeetOnBench",
            76: "sidePlankWithKneeCircle",
            77: "weightedSidePlankWithKneeCircle",
            78: "sidePlankWithKneeTuck",
            79: "weightedSidePlankWithKneeTuck",
            80: "sidePlankWithLegLift",
            81: "weightedSidePlankWithLegLift",
            82: "sidePlankWithReachUnder",
            83: "weightedSidePlankWithReachUnder",
            84: "singleLegElevatedFeetPlank",
            85: "weightedSingleLegElevatedFeetPlank",
            86: "singleLegFlexAndExtend",
            87: "weightedSingleLegFlexAndExtend",
            88: "singleLegSidePlank",
            89: "weightedSingleLegSidePlank",
            90: "spidermanPlank",
            91: "weightedSpidermanPlank",
            92: "straightArmPlank",
            93: "weightedStraightArmPlank",
            94: "straightArmPlankWithShoulderTouch",
            95: "weightedStraightArmPlankWithShoulderTouch",
            96: "swissBallPlank",
            97: "weightedSwissBallPlank",
            98: "swissBallPlankLegLift",
            99: "weightedSwissBallPlankLegLift",
            100: "swissBallPlankLegLiftAndHold",
            101: "swissBallPlankWithFeetOnBench",
            102: "weightedSwissBallPlankWithFeetOnBench",
            103: "swissBallProneJackknife",
            104: "weightedSwissBallProneJackknife",
            105: "swissBallSidePlank",
            106: "weightedSwissBallSidePlank",
            107: "threeWayPlank",
            108: "weightedThreeWayPlank",
            109: "towelPlankAndKneeIn",
            110: "weightedTowelPlankAndKneeIn",
            111: "tStabilization",
            112: "weightedTStabilization",
            113: "turkishGetUpToSidePlank",
            114: "weightedTurkishGetUpToSidePlank",
            115: "twoPointPlank",
            116: "weightedTwoPointPlank",
            117: "weightedPlank",
            118: "wideStancePlankWithDiagonalArmLift",
            119: "weightedWideStancePlankWithDiagonalArmLift",
            120: "wideStancePlankWithDiagonalLegLift",
            121: "weightedWideStancePlankWithDiagonalLegLift",
            122: "wideStancePlankWithLegLift",
            123: "weightedWideStancePlankWithLegLift",
            124: "wideStancePlankWithOppositeArmAndLegLift",
            125: "weightedMountainClimberWithHandsOnBench",
            126: "weightedSwissBallPlankLegLiftAndHold",
            127: "weightedWideStancePlankWithOppositeArmAndLegLift",
            128: "plankWithFeetOnSwissBall",
            129: "sidePlankToPlankWithReachUnder",
            130: "bridgeWithGluteLowerLift",
            131: "bridgeOneLegBridge",
            132: "plankWithArmVariations",
            133: "plankWithLegLift",
            134: "reversePlankWithLegPull",
            135: "ringPlankSprawls"
        },
        plyoExerciseName: {
            0: "alternatingJumpLunge",
            1: "weightedAlternatingJumpLunge",
            2: "barbellJumpSquat",
            3: "bodyWeightJumpSquat",
            4: "weightedJumpSquat",
            5: "crossKneeStrike",
            6: "weightedCrossKneeStrike",
            7: "depthJump",
            8: "weightedDepthJump",
            9: "dumbbellJumpSquat",
            10: "dumbbellSplitJump",
            11: "frontKneeStrike",
            12: "weightedFrontKneeStrike",
            13: "highBoxJump",
            14: "weightedHighBoxJump",
            15: "isometricExplosiveBodyWeightJumpSquat",
            16: "weightedIsometricExplosiveJumpSquat",
            17: "lateralLeapAndHop",
            18: "weightedLateralLeapAndHop",
            19: "lateralPlyoSquats",
            20: "weightedLateralPlyoSquats",
            21: "lateralSlide",
            22: "weightedLateralSlide",
            23: "medicineBallOverheadThrows",
            24: "medicineBallSideThrow",
            25: "medicineBallSlam",
            26: "sideToSideMedicineBallThrows",
            27: "sideToSideShuffleJump",
            28: "weightedSideToSideShuffleJump",
            29: "squatJumpOntoBox",
            30: "weightedSquatJumpOntoBox",
            31: "squatJumpsInAndOut",
            32: "weightedSquatJumpsInAndOut",
            33: "boxJump",
            34: "boxJumpOvers",
            35: "boxJumpOversOverTheBox",
            36: "starJumpSquats",
            37: "jumpSquat"
        },
        pullUpExerciseName: {
            0: "bandedPullUps",
            1: "30DegreeLatPulldown",
            2: "bandAssistedChinUp",
            3: "closeGripChinUp",
            4: "weightedCloseGripChinUp",
            5: "closeGripLatPulldown",
            6: "crossoverChinUp",
            7: "weightedCrossoverChinUp",
            8: "ezBarPullover",
            9: "hangingHurdle",
            10: "weightedHangingHurdle",
            11: "kneelingLatPulldown",
            12: "kneelingUnderhandGripLatPulldown",
            13: "latPulldown",
            14: "mixedGripChinUp",
            15: "weightedMixedGripChinUp",
            16: "mixedGripPullUp",
            17: "weightedMixedGripPullUp",
            18: "reverseGripPulldown",
            19: "standingCablePullover",
            20: "straightArmPulldown",
            21: "swissBallEzBarPullover",
            22: "towelPullUp",
            23: "weightedTowelPullUp",
            24: "weightedPullUp",
            25: "wideGripLatPulldown",
            26: "wideGripPullUp",
            27: "weightedWideGripPullUp",
            28: "burpeePullUp",
            29: "weightedBurpeePullUp",
            30: "jumpingPullUps",
            31: "weightedJumpingPullUps",
            32: "kippingPullUp",
            33: "weightedKippingPullUp",
            34: "lPullUp",
            35: "weightedLPullUp",
            36: "suspendedChinUp",
            37: "weightedSuspendedChinUp",
            38: "pullUp",
            39: "chinUp",
            40: "neutralGripChinUp",
            41: "weightedChinUp",
            42: "bandAssistedPullUp",
            43: "neutralGripPullUp",
            44: "weightedNeutralGripChinUp",
            45: "weightedNeutralGripPullUp"
        },
        pushUpExerciseName: {
            0: "chestPressWithBand",
            1: "alternatingStaggeredPushUp",
            2: "weightedAlternatingStaggeredPushUp",
            3: "alternatingHandsMedicineBallPushUp",
            4: "weightedAlternatingHandsMedicineBallPushUp",
            5: "bosuBallPushUp",
            6: "weightedBosuBallPushUp",
            7: "clappingPushUp",
            8: "weightedClappingPushUp",
            9: "closeGripMedicineBallPushUp",
            10: "weightedCloseGripMedicineBallPushUp",
            11: "closeHandsPushUp",
            12: "weightedCloseHandsPushUp",
            13: "declinePushUp",
            14: "weightedDeclinePushUp",
            15: "diamondPushUp",
            16: "weightedDiamondPushUp",
            17: "explosiveCrossoverPushUp",
            18: "weightedExplosiveCrossoverPushUp",
            19: "explosivePushUp",
            20: "weightedExplosivePushUp",
            21: "feetElevatedSideToSidePushUp",
            22: "weightedFeetElevatedSideToSidePushUp",
            23: "handReleasePushUp",
            24: "weightedHandReleasePushUp",
            25: "handstandPushUp",
            26: "weightedHandstandPushUp",
            27: "inclinePushUp",
            28: "weightedInclinePushUp",
            29: "isometricExplosivePushUp",
            30: "weightedIsometricExplosivePushUp",
            31: "judoPushUp",
            32: "weightedJudoPushUp",
            33: "kneelingPushUp",
            34: "weightedKneelingPushUp",
            35: "medicineBallChestPass",
            36: "medicineBallPushUp",
            37: "weightedMedicineBallPushUp",
            38: "oneArmPushUp",
            39: "weightedOneArmPushUp",
            40: "weightedPushUp",
            41: "pushUpAndRow",
            42: "weightedPushUpAndRow",
            43: "pushUpPlus",
            44: "weightedPushUpPlus",
            45: "pushUpWithFeetOnSwissBall",
            46: "weightedPushUpWithFeetOnSwissBall",
            47: "pushUpWithOneHandOnMedicineBall",
            48: "weightedPushUpWithOneHandOnMedicineBall",
            49: "shoulderPushUp",
            50: "weightedShoulderPushUp",
            51: "singleArmMedicineBallPushUp",
            52: "weightedSingleArmMedicineBallPushUp",
            53: "spidermanPushUp",
            54: "weightedSpidermanPushUp",
            55: "stackedFeetPushUp",
            56: "weightedStackedFeetPushUp",
            57: "staggeredHandsPushUp",
            58: "weightedStaggeredHandsPushUp",
            59: "suspendedPushUp",
            60: "weightedSuspendedPushUp",
            61: "swissBallPushUp",
            62: "weightedSwissBallPushUp",
            63: "swissBallPushUpPlus",
            64: "weightedSwissBallPushUpPlus",
            65: "tPushUp",
            66: "weightedTPushUp",
            67: "tripleStopPushUp",
            68: "weightedTripleStopPushUp",
            69: "wideHandsPushUp",
            70: "weightedWideHandsPushUp",
            71: "paralletteHandstandPushUp",
            72: "weightedParalletteHandstandPushUp",
            73: "ringHandstandPushUp",
            74: "weightedRingHandstandPushUp",
            75: "ringPushUp",
            76: "weightedRingPushUp",
            77: "pushUp",
            78: "pilatesPushup",
            79: "dynamicPushUp",
            80: "kippingHandstandPushUp",
            81: "shoulderTappingPushUp",
            82: "bicepsPushUp",
            83: "hinduPushUp",
            84: "pikePushUp",
            85: "wideGripPushUp",
            86: "weightedBicepsPushUp",
            87: "weightedHinduPushUp",
            88: "weightedPikePushUp",
            89: "kippingParalletteHandstandPushUp",
            90: "wallPushUp"
        },
        rowExerciseName: {
            0: "barbellStraightLegDeadliftToRow",
            1: "cableRowStanding",
            2: "dumbbellRow",
            3: "elevatedFeetInvertedRow",
            4: "weightedElevatedFeetInvertedRow",
            5: "facePull",
            6: "facePullWithExternalRotation",
            7: "invertedRowWithFeetOnSwissBall",
            8: "weightedInvertedRowWithFeetOnSwissBall",
            9: "kettlebellRow",
            10: "modifiedInvertedRow",
            11: "weightedModifiedInvertedRow",
            12: "neutralGripAlternatingDumbbellRow",
            13: "oneArmBentOverRow",
            14: "oneLeggedDumbbellRow",
            15: "renegadeRow",
            16: "reverseGripBarbellRow",
            17: "ropeHandleCableRow",
            18: "seatedCableRow",
            19: "seatedDumbbellRow",
            20: "singleArmCableRow",
            21: "singleArmCableRowAndRotation",
            22: "singleArmInvertedRow",
            23: "weightedSingleArmInvertedRow",
            24: "singleArmNeutralGripDumbbellRow",
            25: "singleArmNeutralGripDumbbellRowAndRotation",
            26: "suspendedInvertedRow",
            27: "weightedSuspendedInvertedRow",
            28: "tBarRow",
            29: "towelGripInvertedRow",
            30: "weightedTowelGripInvertedRow",
            31: "underhandGripCableRow",
            32: "vGripCableRow",
            33: "wideGripSeatedCableRow",
            34: "alternatingDumbbellRow",
            35: "invertedRow",
            36: "row",
            37: "weightedRow",
            38: "indoorRow",
            39: "bandedFacePulls",
            40: "chestSupportedDumbbellRow",
            41: "declineRingRow",
            42: "elevatedRingRow",
            43: "rdlBentOverRowWithBarbellDumbbell",
            44: "ringRow",
            45: "barbellRow",
            46: "bentOverRowWithBarbell",
            47: "bentOverRowWithDumbell",
            48: "seatedUnderhandGripCableRow",
            49: "trxInvertedRow",
            50: "weightedInvertedRow",
            51: "weightedTrxInvertedRow",
            52: "dumbbellRowWheelchair"
        },
        shoulderPressExerciseName: {
            0: "alternatingDumbbellShoulderPress",
            1: "arnoldPress",
            2: "barbellFrontSquatToPushPress",
            3: "barbellPushPress",
            4: "barbellShoulderPress",
            5: "deadCurlPress",
            6: "dumbbellAlternatingShoulderPressAndTwist",
            7: "dumbbellHammerCurlToLungeToPress",
            8: "dumbbellPushPress",
            9: "floorInvertedShoulderPress",
            10: "weightedFloorInvertedShoulderPress",
            11: "invertedShoulderPress",
            12: "weightedInvertedShoulderPress",
            13: "oneArmPushPress",
            14: "overheadBarbellPress",
            15: "overheadDumbbellPress",
            16: "seatedBarbellShoulderPress",
            17: "seatedDumbbellShoulderPress",
            18: "singleArmDumbbellShoulderPress",
            19: "singleArmStepUpAndPress",
            20: "smithMachineOverheadPress",
            21: "splitStanceHammerCurlToPress",
            22: "swissBallDumbbellShoulderPress",
            23: "weightPlateFrontRaise",
            24: "dumbbellShoulderPress",
            25: "militaryPress",
            27: "strictPress",
            28: "dumbbellFrontRaise",
            29: "dumbbellCurlToOverheadPressWheelchair",
            30: "arnoldPressWheelchair",
            31: "overheadDumbbellPressWheelchair"
        },
        shoulderStabilityExerciseName: {
            0: "90DegreeCableExternalRotation",
            1: "bandExternalRotation",
            2: "bandInternalRotation",
            3: "bentArmLateralRaiseAndExternalRotation",
            4: "cableExternalRotation",
            5: "dumbbellFacePullWithExternalRotation",
            6: "floorIRaise",
            7: "weightedFloorIRaise",
            8: "floorTRaise",
            9: "weightedFloorTRaise",
            10: "floorYRaise",
            11: "weightedFloorYRaise",
            12: "inclineIRaise",
            13: "weightedInclineIRaise",
            14: "inclineLRaise",
            15: "weightedInclineLRaise",
            16: "inclineTRaise",
            17: "weightedInclineTRaise",
            18: "inclineWRaise",
            19: "weightedInclineWRaise",
            20: "inclineYRaise",
            21: "weightedInclineYRaise",
            22: "lyingExternalRotation",
            23: "seatedDumbbellExternalRotation",
            24: "standingLRaise",
            25: "swissBallIRaise",
            26: "weightedSwissBallIRaise",
            27: "swissBallTRaise",
            28: "weightedSwissBallTRaise",
            29: "swissBallWRaise",
            30: "weightedSwissBallWRaise",
            31: "swissBallYRaise",
            32: "weightedSwissBallYRaise",
            33: "cableInternalRotation",
            34: "lyingInternalRotation",
            35: "seatedDumbbellInternalRotation"
        },
        shrugExerciseName: {
            0: "barbellJumpShrug",
            1: "barbellShrug",
            2: "barbellUprightRow",
            3: "behindTheBackSmithMachineShrug",
            4: "dumbbellJumpShrug",
            5: "dumbbellShrug",
            6: "dumbbellUprightRow",
            7: "inclineDumbbellShrug",
            8: "overheadBarbellShrug",
            9: "overheadDumbbellShrug",
            10: "scaptionAndShrug",
            11: "scapularRetraction",
            12: "serratusChairShrug",
            13: "weightedSerratusChairShrug",
            14: "serratusShrug",
            15: "weightedSerratusShrug",
            16: "wideGripJumpShrug",
            17: "wideGripBarbellShrug",
            18: "behindTheBackShrug",
            19: "dumbbellShrugWheelchair",
            20: "shrugWheelchair",
            21: "shrugArmDownWheelchair",
            22: "shrugArmMidWheelchair",
            23: "shrugArmUpWheelchair",
            24: "uprightRow"
        },
        sitUpExerciseName: {
            0: "alternatingSitUp",
            1: "weightedAlternatingSitUp",
            2: "bentKneeVUp",
            3: "weightedBentKneeVUp",
            4: "butterflySitUp",
            5: "weightedButterflySitup",
            6: "crossPunchRollUp",
            7: "weightedCrossPunchRollUp",
            8: "crossedArmsSitUp",
            9: "weightedCrossedArmsSitUp",
            10: "getUpSitUp",
            11: "weightedGetUpSitUp",
            12: "hoveringSitUp",
            13: "weightedHoveringSitUp",
            14: "kettlebellSitUp",
            15: "medicineBallAlternatingVUp",
            16: "medicineBallSitUp",
            17: "medicineBallVUp",
            18: "modifiedSitUp",
            19: "negativeSitUp",
            20: "oneArmFullSitUp",
            21: "recliningCircle",
            22: "weightedRecliningCircle",
            23: "reverseCurlUp",
            24: "weightedReverseCurlUp",
            25: "singleLegSwissBallJackknife",
            26: "weightedSingleLegSwissBallJackknife",
            27: "theTeaser",
            28: "theTeaserWeighted",
            29: "threePartRollDown",
            30: "weightedThreePartRollDown",
            31: "vUp",
            32: "weightedVUp",
            33: "weightedRussianTwistOnSwissBall",
            34: "weightedSitUp",
            35: "xAbs",
            36: "weightedXAbs",
            37: "sitUp",
            38: "ghdSitUps",
            39: "sitUpTurkishGetUp",
            40: "russianTwistOnSwissBall"
        },
        squatExerciseName: {
            0: "legPress",
            1: "backSquatWithBodyBar",
            2: "backSquats",
            3: "weightedBackSquats",
            4: "balancingSquat",
            5: "weightedBalancingSquat",
            6: "barbellBackSquat",
            7: "barbellBoxSquat",
            8: "barbellFrontSquat",
            9: "barbellHackSquat",
            10: "barbellHangSquatSnatch",
            11: "barbellLateralStepUp",
            12: "barbellQuarterSquat",
            13: "barbellSiffSquat",
            14: "barbellSquatSnatch",
            15: "barbellSquatWithHeelsRaised",
            16: "barbellStepover",
            17: "barbellStepUp",
            18: "benchSquatWithRotationalChop",
            19: "weightedBenchSquatWithRotationalChop",
            20: "bodyWeightWallSquat",
            21: "weightedWallSquat",
            22: "boxStepSquat",
            23: "weightedBoxStepSquat",
            24: "bracedSquat",
            25: "crossedArmBarbellFrontSquat",
            26: "crossoverDumbbellStepUp",
            27: "dumbbellFrontSquat",
            28: "dumbbellSplitSquat",
            29: "dumbbellSquat",
            30: "dumbbellSquatClean",
            31: "dumbbellStepover",
            32: "dumbbellStepUp",
            33: "elevatedSingleLegSquat",
            34: "weightedElevatedSingleLegSquat",
            35: "figureFourSquats",
            36: "weightedFigureFourSquats",
            37: "gobletSquat",
            38: "kettlebellSquat",
            39: "kettlebellSwingOverhead",
            40: "kettlebellSwingWithFlipToSquat",
            41: "lateralDumbbellStepUp",
            42: "oneLeggedSquat",
            43: "overheadDumbbellSquat",
            44: "overheadSquat",
            45: "partialSingleLegSquat",
            46: "weightedPartialSingleLegSquat",
            47: "pistolSquat",
            48: "weightedPistolSquat",
            49: "plieSlides",
            50: "weightedPlieSlides",
            51: "plieSquat",
            52: "weightedPlieSquat",
            53: "prisonerSquat",
            54: "weightedPrisonerSquat",
            55: "singleLegBenchGetUp",
            56: "weightedSingleLegBenchGetUp",
            57: "singleLegBenchSquat",
            58: "weightedSingleLegBenchSquat",
            59: "singleLegSquatOnSwissBall",
            60: "weightedSingleLegSquatOnSwissBall",
            61: "squat",
            62: "weightedSquat",
            63: "squatsWithBand",
            64: "staggeredSquat",
            65: "weightedStaggeredSquat",
            66: "stepUp",
            67: "weightedStepUp",
            68: "suitcaseSquats",
            69: "sumoSquat",
            70: "sumoSquatSlideIn",
            71: "weightedSumoSquatSlideIn",
            72: "sumoSquatToHighPull",
            73: "sumoSquatToStand",
            74: "weightedSumoSquatToStand",
            75: "sumoSquatWithRotation",
            76: "weightedSumoSquatWithRotation",
            77: "swissBallBodyWeightWallSquat",
            78: "weightedSwissBallWallSquat",
            79: "thrusters",
            80: "unevenSquat",
            81: "weightedUnevenSquat",
            82: "waistSlimmingSquat",
            83: "wallBall",
            84: "wideStanceBarbellSquat",
            85: "wideStanceGobletSquat",
            86: "zercherSquat",
            87: "kbsOverhead",
            88: "squatAndSideKick",
            89: "squatJumpsInNOut",
            90: "pilatesPlieSquatsParallelTurnedOutFlatAndHeels",
            91: "releveStraightLegAndKneeBentWithOneLegVariation",
            92: "alternatingBoxDumbbellStepUps",
            93: "dumbbellOverheadSquatSingleArm",
            94: "dumbbellSquatSnatch",
            95: "medicineBallSquat",
            97: "wallBallSquatAndPress",
            98: "squatAmericanSwing",
            100: "airSquat",
            101: "dumbbellThrusters",
            102: "overheadBarbellSquat"
        },
        totalBodyExerciseName: {
            0: "burpee",
            1: "weightedBurpee",
            2: "burpeeBoxJump",
            3: "weightedBurpeeBoxJump",
            4: "highPullBurpee",
            5: "manMakers",
            6: "oneArmBurpee",
            7: "squatThrusts",
            8: "weightedSquatThrusts",
            9: "squatPlankPushUp",
            10: "weightedSquatPlankPushUp",
            11: "standingTRotationBalance",
            12: "weightedStandingTRotationBalance",
            13: "barbellBurpee",
            15: "burpeeBoxJumpOverYesLiterallyJumpingOverTheBox",
            16: "burpeeBoxJumpStepUpOver",
            17: "lateralBarbellBurpee",
            18: "totalBodyBurpeeOverBar",
            19: "burpeeBoxJumpOver",
            20: "burpeeWheelchair"
        },
        moveExerciseName: {
            0: "archAndCurl",
            1: "armCirclesWithBallBandAndWeight",
            2: "armStretch",
            3: "backMassage",
            4: "bellyBreathing",
            5: "bridgeWithBall",
            6: "diamondLegCrunch",
            7: "diamondLegLift",
            8: "eightPointShoulderOpener",
            9: "footRolling",
            10: "footwork",
            11: "footworkOnDisc",
            12: "forwardFold",
            13: "frogWithBand",
            14: "halfRollUp",
            15: "hamstringCurl",
            16: "hamstringStretch",
            17: "hipStretch",
            18: "hugATreeWithBallBandAndWeight",
            19: "kneeCircles",
            20: "kneeFoldsOnDisc",
            21: "lateralFlexion",
            22: "legStretchWithBand",
            23: "legStretchWithLegCircles",
            24: "lowerLiftOnDisc",
            25: "lungeSquat",
            26: "lungesWithKneeLift",
            27: "mermaidStretch",
            28: "neutralPelvicPosition",
            29: "pelvicClocksOnDisc",
            30: "pilatesPlieSquatsParallelTurnedOutFlatAndHeelsWithChair",
            31: "piriformisStretch",
            32: "plankKneeCrosses",
            33: "plankKneePulls",
            34: "plankUpDowns",
            35: "prayerMudra",
            36: "psoasLungeStretch",
            37: "ribcageBreathing",
            38: "rollDown",
            39: "rollUpWithWeightAndBand",
            40: "saw",
            41: "scapularStabilization",
            42: "scissorsOnDisc",
            43: "seatedHipStretchup",
            44: "seatedTwist",
            45: "shavingTheHeadWithBallBandAndWeight",
            46: "spinalTwist",
            47: "spinalTwistStretch",
            48: "spineStretchForward",
            49: "squatOpenArmTwistPose",
            50: "squatsWithBall",
            51: "standAndHang",
            52: "standingSideStretch",
            53: "standingSingleLegForwardBendWithItBandOpener",
            54: "straightLegCrunchWithLegLift",
            55: "straightLegCrunchWithLegLiftWithBall",
            56: "straightLegCrunchWithLegsCrossed",
            57: "straightLegCrunchWithLegsCrossedWithBall",
            58: "straightLegDiagonalCrunch",
            59: "straightLegDiagonalCrunchWithBall",
            60: "tailboneCurl",
            61: "throatLock",
            62: "tickTockSideRoll",
            63: "twist",
            64: "vLegCrunches",
            65: "vSit",
            66: "forwardFoldWheelchair",
            67: "forwardFoldPlusWheelchair",
            68: "armCirclesLowForwardWheelchair",
            69: "armCirclesMidForwardWheelchair",
            70: "armCirclesHighForwardWheelchair",
            71: "armCirclesLowBackwardWheelchair",
            72: "armCirclesMidBackwardWheelchair",
            73: "armCirclesHighBackwardWheelchair",
            74: "coreTwistsWheelchair",
            75: "armRaiseWheelchair",
            76: "chestExpandWheelchair",
            77: "armExtendWheelchair",
            78: "forwardBendWheelchair",
            79: "toeTouchWheelchair",
            80: "extendedToeTouchWheelchair",
            81: "seatedArmCircles",
            82: "trunkRotations",
            83: "seatedTrunkRotations",
            84: "toeTouch"
        },
        poseExerciseName: {
            0: "allFours",
            1: "ankleToKnee",
            2: "babyCobra",
            3: "boat",
            4: "boundAngle",
            5: "boundSeatedSingleLegForwardBend",
            6: "bow",
            7: "bowedHalfMoon",
            8: "bridge",
            9: "cat",
            10: "chair",
            11: "childs",
            12: "corpse",
            13: "cowFace",
            14: "cow",
            15: "devotionalWarrior",
            16: "dolphinPlank",
            17: "dolphin",
            18: "downDogKneeToNose",
            19: "downDogSplit",
            20: "downDogSplitOpenHipBentKnee",
            21: "downwardFacingDog",
            22: "eagle",
            23: "easySeated",
            24: "extendedPuppy",
            25: "extendedSideAngle",
            26: "fish",
            27: "fourLimbedStaff",
            28: "fullSplit",
            29: "gate",
            30: "halfChairHalfAnkleToKnee",
            31: "halfMoon",
            32: "headToKnee",
            33: "heron",
            34: "heros",
            35: "highLunge",
            36: "kneesChestChin",
            37: "lizard",
            38: "locust",
            39: "lowLunge",
            40: "lowLungeTwist",
            41: "lowLungeWithKneeDown",
            42: "mermaid",
            43: "mountain",
            44: "oneLeggedDownwardFacingPoseOpenHipBentKnee",
            45: "oneLeggedPigeon",
            46: "peacefulWarrior",
            47: "plank",
            48: "plow",
            49: "reclinedHandToFoot",
            50: "revolvedHalfMoon",
            51: "revolvedHeadToKnee",
            52: "revolvedTriangle",
            53: "runnersLunge",
            54: "seatedEasySideBend",
            55: "seatedEasyTwist",
            56: "seatedLongLegForwardBend",
            57: "seatedWideLegForwardBend",
            58: "shoulderStand",
            59: "sideBoat",
            60: "sidePlank",
            61: "sphinx",
            62: "squatOpenArmTwist",
            63: "squatPalmPress",
            64: "staff",
            65: "standingArmsUp",
            66: "standingForwardBendHalfwayUp",
            67: "standingForwardBend",
            68: "standingSideOpener",
            69: "standingSingleLegForwardBend",
            70: "standingSplit",
            71: "standingWideLegForwardBend",
            72: "standingWideLegForwardBendWithTwist",
            73: "supineSpinalTwist",
            74: "tableTop",
            75: "threadTheNeedle",
            76: "thunderbolt",
            77: "thunderboltPoseBothSidesArmStretch",
            78: "tree",
            79: "triangle",
            80: "upDog",
            81: "upwardFacingPlank",
            82: "warriorOne",
            83: "warriorThree",
            84: "warriorTwo",
            85: "wheel",
            86: "wideSideLunge",
            87: "deepBreathingWheelchair",
            88: "deepBreathingLowWheelchair",
            89: "deepBreathingMidWheelchair",
            90: "deepBreathingHighWheelchair",
            91: "prayerWheelchair",
            92: "overheadPrayerWheelchair",
            93: "cactusWheelchair",
            94: "breathingPunchesWheelchair",
            95: "breathingPunchesExtendedWheelchair",
            96: "breathingPunchesOverheadWheelchair",
            97: "breathingPunchesOverheadAndDownWheelchair",
            98: "breathingPunchesSideWheelchair",
            99: "breathingPunchesExtendedSideWheelchair",
            100: "breathingPunchesOverheadSideWheelchair",
            101: "breathingPunchesOverheadAndDownSideWheelchair",
            102: "leftHandBackWheelchair",
            103: "triangleWheelchair",
            104: "threadTheNeedleWheelchair",
            105: "neckFlexionAndExtensionWheelchair",
            106: "neckLateralFlexionWheelchair",
            107: "spineFlexionAndExtensionWheelchair",
            108: "spineRotationWheelchair",
            109: "spineLateralFlexionWheelchair",
            110: "alternativeSkiingWheelchair",
            111: "reachForwardWheelchair",
            112: "warriorWheelchair",
            113: "reverseWarriorWheelchair",
            114: "downwardFacingDogToCobra",
            115: "seatedCatCow"
        },
        tricepsExtensionExerciseName: {
            0: "benchDip",
            1: "weightedBenchDip",
            2: "bodyWeightDip",
            3: "cableKickback",
            4: "cableLyingTricepsExtension",
            5: "cableOverheadTricepsExtension",
            6: "dumbbellKickback",
            7: "dumbbellLyingTricepsExtension",
            8: "ezBarOverheadTricepsExtension",
            9: "inclineDip",
            10: "weightedInclineDip",
            11: "inclineEzBarLyingTricepsExtension",
            12: "lyingDumbbellPulloverToExtension",
            13: "lyingEzBarTricepsExtension",
            14: "lyingTricepsExtensionToCloseGripBenchPress",
            15: "overheadDumbbellTricepsExtension",
            16: "recliningTricepsPress",
            17: "reverseGripPressdown",
            18: "reverseGripTricepsPressdown",
            19: "ropePressdown",
            20: "seatedBarbellOverheadTricepsExtension",
            21: "seatedDumbbellOverheadTricepsExtension",
            22: "seatedEzBarOverheadTricepsExtension",
            23: "seatedSingleArmOverheadDumbbellExtension",
            24: "singleArmDumbbellOverheadTricepsExtension",
            25: "singleDumbbellSeatedOverheadTricepsExtension",
            26: "singleLegBenchDipAndKick",
            27: "weightedSingleLegBenchDipAndKick",
            28: "singleLegDip",
            29: "weightedSingleLegDip",
            30: "staticLyingTricepsExtension",
            31: "suspendedDip",
            32: "weightedSuspendedDip",
            33: "swissBallDumbbellLyingTricepsExtension",
            34: "swissBallEzBarLyingTricepsExtension",
            35: "swissBallEzBarOverheadTricepsExtension",
            36: "tabletopDip",
            37: "weightedTabletopDip",
            38: "tricepsExtensionOnFloor",
            39: "tricepsPressdown",
            40: "weightedDip",
            41: "alternatingDumbbellLyingTricepsExtension",
            42: "tricepsPress",
            43: "dumbbellKickbackWheelchair",
            44: "overheadDumbbellTricepsExtensionWheelchair"
        },
        warmUpExerciseName: {
            0: "quadrupedRocking",
            1: "neckTilts",
            2: "ankleCircles",
            3: "ankleDorsiflexionWithBand",
            4: "ankleInternalRotation",
            5: "armCircles",
            6: "bentOverReachToSky",
            7: "catCamel",
            8: "elbowToFootLunge",
            9: "forwardAndBackwardLegSwings",
            10: "groiners",
            11: "invertedHamstringStretch",
            12: "lateralDuckUnder",
            13: "neckRotations",
            14: "oppositeArmAndLegBalance",
            15: "reachRollAndLift",
            16: "scorpion",
            17: "shoulderCircles",
            18: "sideToSideLegSwings",
            19: "sleeperStretch",
            20: "slideOut",
            21: "swissBallHipCrossover",
            22: "swissBallReachRollAndLift",
            23: "swissBallWindshieldWipers",
            24: "thoracicRotation",
            25: "walkingHighKicks",
            26: "walkingHighKnees",
            27: "walkingKneeHugs",
            28: "walkingLegCradles",
            29: "walkout",
            30: "walkoutFromPushUpPosition",
            31: "bicepsStretch",
            32: "glutesStretch",
            33: "standingHamstringStretch",
            34: "stretch90_90",
            35: "stretchAbs",
            36: "stretchButterfly",
            37: "stretchCalf",
            38: "stretchCatCow",
            39: "stretchChildsPose",
            40: "stretchCobra",
            41: "stretchForearms",
            42: "stretchForwardGlutes",
            43: "stretchFrontSplit",
            44: "stretchHamstring",
            45: "stretchHipFlexorAndQuad",
            46: "stretchLat",
            47: "stretchLevatorScapulae",
            48: "stretchLungeWithSpinalTwist",
            49: "stretchLungingHipFlexor",
            50: "stretchLyingAbduction",
            51: "stretchLyingItBand",
            52: "stretchLyingKneeToChest",
            53: "stretchLyingPiriformis",
            54: "stretchLyingSpinalTwist",
            55: "stretchNeck",
            56: "stretchObliques",
            57: "stretchOverUnderShoulder",
            58: "stretchPectoral",
            59: "stretchPigeonPose",
            60: "stretchPiriformis",
            61: "stretchQuad",
            62: "stretchScorpion",
            63: "stretchShoulder",
            64: "stretchSide",
            65: "stretchSideLunge",
            66: "stretchSideSplit",
            67: "stretchStandingItBand",
            68: "stretchStraddle",
            69: "stretchTriceps",
            70: "stretchWallChestAndShoulder",
            71: "neckRotationsWheelchair",
            72: "halfKneelingArmRotation",
            73: "threeWayAnkleMobilization",
            74: "ninetyNinetyHipSwitch",
            75: "activeFrog",
            76: "shoulderSweeps",
            77: "ankleLunges",
            78: "backRollFoamRoller",
            79: "bearCrawl",
            80: "latissimusDorsiFoamRoll",
            81: "reverseTHipOpener",
            82: "shoulderRolls",
            83: "chestOpeners",
            84: "tricepsStretch",
            85: "upperBackStretch",
            86: "hipCircles",
            87: "ankleStretch",
            88: "marchingInPlace",
            89: "tricepsStretchWheelchair",
            90: "upperBackStretchWheelchair"
        },
        runExerciseName: {
            0: "run",
            1: "walk",
            2: "jog",
            3: "sprint",
            4: "runOrWalk",
            5: "speedWalk",
            6: "warmUp"
        },
        bikeExerciseName: {
            0: "bike",
            1: "ride",
            2: "sprint"
        },
        bandedExercisesExerciseName: {
            1: "abTwist",
            2: "backExtension",
            3: "bicycleCrunch",
            4: "calfRaises",
            5: "chestPress",
            6: "clamShells",
            7: "curl",
            8: "deadbug",
            9: "deadlift",
            10: "donkeyKick",
            11: "externalRotation",
            12: "externalRotationAt90DegreeAbduction",
            13: "facePull",
            14: "fireHydrant",
            15: "fly",
            16: "frontRaise",
            17: "gluteBridge",
            18: "hamstringCurls",
            19: "highPlankLegLifts",
            20: "hipExtension",
            21: "internalRotation",
            22: "jumpingJack",
            23: "kneelingCrunch",
            24: "lateralBandWalks",
            25: "lateralRaise",
            26: "latpull",
            27: "legAbduction",
            28: "legAdduction",
            29: "legExtension",
            30: "lunge",
            31: "plank",
            32: "pullApart",
            33: "pushUps",
            34: "reverseCrunch",
            35: "row",
            36: "shoulderAbduction",
            37: "shoulderExtension",
            38: "shoulderExternalRotation",
            39: "shoulderFlexionTo90Degrees",
            40: "sidePlankLegLifts",
            41: "sideRaise",
            42: "squat",
            43: "squatToPress",
            44: "tricepExtension",
            45: "tricepKickback",
            46: "uprightRow",
            47: "wallCrawlWithExternalRotation",
            49: "lateralRaiseWheelchair",
            50: "tricepsExtensionWheelchair",
            51: "chestFlyInclineWheelchair",
            52: "chestFlyDeclineWheelchair",
            53: "pullDownWheelchair",
            54: "straightArmPullDownWheelchair",
            55: "curlWheelchair",
            56: "overheadCurlWheelchair",
            57: "facePullWheelchair",
            58: "aroundTheWorldWheelchair",
            59: "pullApartWheelchair",
            60: "sideCurlWheelchair",
            61: "overheadPressWheelchair"
        },
        battleRopeExerciseName: {
            0: "alternatingFigureEight",
            1: "alternatingJumpWave",
            2: "alternatingKneelingToStandingWave",
            3: "alternatingLungeWave",
            4: "alternatingSquatWave",
            5: "alternatingWave",
            6: "alternatingWaveWithLateralShuffle",
            7: "clapWave",
            8: "doubleArmFigureEight",
            9: "doubleArmSideToSideSnake",
            10: "doubleArmSideWave",
            11: "doubleArmSlam",
            12: "doubleArmWave",
            13: "grapplerToss",
            14: "hipToss",
            15: "inAndOutWave",
            16: "insideCircle",
            17: "jumpingJacks",
            18: "outsideCircle",
            19: "rainbow",
            20: "sidePlankWave",
            21: "sidewinder",
            22: "sittingRussianTwist",
            23: "snakeWave",
            24: "splitJack",
            25: "stageCoach",
            26: "ultimateWarrior",
            27: "upperCuts"
        },
        ellipticalExerciseName: {
            0: "elliptical"
        },
        floorClimbExerciseName: {
            0: "floorClimb"
        },
        indoorBikeExerciseName: {
            0: "airBike",
            1: "assaultBike",
            3: "stationaryBike"
        },
        indoorRowExerciseName: {
            0: "rowingMachine"
        },
        ladderExerciseName: {
            0: "agility",
            1: "speed"
        },
        sandbagExerciseName: {
            0: "aroundTheWorld",
            1: "backSquat",
            2: "bearCrawlPullThrough",
            3: "bearHugSquat",
            4: "clean",
            5: "cleanAndPress",
            6: "curl",
            7: "frontCarry",
            8: "frontSquat",
            9: "lunge",
            10: "overheadPress",
            11: "plankPullThrough",
            12: "rotationalLunge",
            13: "row",
            14: "russianTwist",
            15: "shouldering",
            16: "shoveling",
            17: "sideLunge",
            18: "sprint",
            19: "zercherSquat"
        },
        sledExerciseName: {
            0: "backwardDrag",
            1: "chestPress",
            2: "forwardDrag",
            3: "lowPush",
            4: "push",
            5: "row"
        },
        sledgeHammerExerciseName: {
            0: "lateralSwing",
            1: "hammerSlam"
        },
        stairStepperExerciseName: {
            0: "stairStepper"
        },
        suspensionExerciseName: {
            0: "chestFly",
            1: "chestPress",
            2: "crunch",
            3: "curl",
            4: "dip",
            5: "facePull",
            6: "gluteBridge",
            7: "hamstringCurl",
            8: "hipDrop",
            9: "invertedRow",
            10: "kneeDriveJump",
            11: "kneeToChest",
            12: "latPullover",
            13: "lunge",
            14: "mountainClimber",
            15: "pendulum",
            16: "pike",
            17: "plank",
            18: "powerPull",
            19: "pullUp",
            20: "pushUp",
            21: "reverseMountainClimber",
            22: "reversePlank",
            23: "rollout",
            24: "row",
            25: "sideLunge",
            26: "sidePlank",
            27: "singleLegDeadlift",
            28: "singleLegSquat",
            29: "sitUp",
            30: "split",
            31: "squat",
            32: "squatJump",
            33: "tricepPress",
            34: "yFly"
        },
        tireExerciseName: {
            0: "flip"
        },
        bikeOutdoorExerciseName: {
            0: "bike"
        },
        runIndoorExerciseName: {
            0: "indoorTrackRun",
            1: "treadmill"
        },
        waterType: {
            0: "fresh",
            1: "salt",
            2: "en13319",
            3: "custom"
        },
        tissueModelType: {
            0: "zhl16c"
        },
        diveGasStatus: {
            0: "disabled",
            1: "enabled",
            2: "backupOnly"
        },
        diveAlert: {
            0: "ndlReached",
            1: "gasSwitchPrompted",
            2: "nearSurface",
            3: "approachingNdl",
            4: "po2Warn",
            5: "po2CritHigh",
            6: "po2CritLow",
            7: "timeAlert",
            8: "depthAlert",
            9: "decoCeilingBroken",
            10: "decoComplete",
            11: "safetyStopBroken",
            12: "safetyStopComplete",
            13: "cnsWarning",
            14: "cnsCritical",
            15: "otuWarning",
            16: "otuCritical",
            17: "ascentCritical",
            18: "alertDismissedByKey",
            19: "alertDismissedByTimeout",
            20: "batteryLow",
            21: "batteryCritical",
            22: "safetyStopStarted",
            23: "approachingFirstDecoStop",
            24: "setpointSwitchAutoLow",
            25: "setpointSwitchAutoHigh",
            26: "setpointSwitchManualLow",
            27: "setpointSwitchManualHigh",
            28: "autoSetpointSwitchIgnored",
            29: "switchedToOpenCircuit",
            30: "switchedToClosedCircuit",
            32: "tankBatteryLow",
            33: "po2CcrDilLow",
            34: "decoStopCleared",
            35: "apneaNeutralBuoyancy",
            36: "apneaTargetDepth",
            37: "apneaSurface",
            38: "apneaHighSpeed",
            39: "apneaLowSpeed"
        },
        diveAlarmType: {
            0: "depth",
            1: "time",
            2: "speed"
        },
        diveBacklightMode: {
            0: "atDepth",
            1: "alwaysOn"
        },
        sleepLevel: {
            0: "unmeasurable",
            1: "awake",
            2: "light",
            3: "deep",
            4: "rem"
        },
        spo2MeasurementType: {
            0: "offWrist",
            1: "spotCheck",
            2: "continuousCheck",
            3: "periodic"
        },
        ccrSetpointSwitchMode: {
            0: "manual",
            1: "automatic"
        },
        diveGasMode: {
            0: "openCircuit",
            1: "closedCircuitDiluent"
        },
        projectileType: {
            0: "arrow",
            1: "rifleCartridge",
            2: "pistolCartridge",
            3: "shotshell",
            4: "airRiflePellet",
            5: "other"
        },
        faveroProduct: {
            10: "assiomaUno",
            12: "assiomaDuo"
        },
        splitType: {
            1: "ascentSplit",
            2: "descentSplit",
            3: "intervalActive",
            4: "intervalRest",
            5: "intervalWarmup",
            6: "intervalCooldown",
            7: "intervalRecovery",
            8: "intervalOther",
            9: "climbActive",
            10: "climbRest",
            11: "surfActive",
            12: "runActive",
            13: "runRest",
            14: "workoutRound",
            17: "rwdRun",
            18: "rwdWalk",
            21: "windsurfActive",
            22: "rwdStand",
            23: "transition",
            28: "skiLiftSplit",
            29: "skiRunSplit"
        },
        climbProEvent: {
            0: "approach",
            1: "start",
            2: "complete"
        },
        gasConsumptionRateType: {
            0: "pressureSac",
            1: "volumeSac",
            2: "rmv"
        },
        tapSensitivity: {
            0: "high",
            1: "medium",
            2: "low"
        },
        radarThreatLevelType: {
            0: "threatUnknown",
            1: "threatNone",
            2: "threatApproaching",
            3: "threatApproachingFast"
        },
        sleepDisruptionSeverity: {
            0: "none",
            1: "low",
            2: "medium",
            3: "high"
        },
        maxMetSpeedSource: {
            0: "onboardGps",
            1: "connectedGps",
            2: "cadence"
        },
        maxMetHeartRateSource: {
            0: "whr",
            1: "hrm"
        },
        hrvStatus: {
            0: "none",
            1: "poor",
            2: "low",
            3: "unbalanced",
            4: "balanced"
        },
        noFlyTimeMode: {
            0: "standard",
            1: "flat24Hours"
        }
    },
    MesgNum: {
        FILE_ID: 0,
        FILE_CREATOR: 49,
        TIMESTAMP_CORRELATION: 162,
        SOFTWARE: 35,
        SLAVE_DEVICE: 106,
        CAPABILITIES: 1,
        FILE_CAPABILITIES: 37,
        MESG_CAPABILITIES: 38,
        FIELD_CAPABILITIES: 39,
        DEVICE_SETTINGS: 2,
        USER_PROFILE: 3,
        HRM_PROFILE: 4,
        SDM_PROFILE: 5,
        BIKE_PROFILE: 6,
        CONNECTIVITY: 127,
        WATCHFACE_SETTINGS: 159,
        OHR_SETTINGS: 188,
        TIME_IN_ZONE: 216,
        ZONES_TARGET: 7,
        SPORT: 12,
        HR_ZONE: 8,
        SPEED_ZONE: 53,
        CADENCE_ZONE: 131,
        POWER_ZONE: 9,
        MET_ZONE: 10,
        TRAINING_SETTINGS: 13,
        DIVE_SETTINGS: 258,
        DIVE_ALARM: 262,
        DIVE_APNEA_ALARM: 393,
        DIVE_GAS: 259,
        GOAL: 15,
        ACTIVITY: 34,
        SESSION: 18,
        LAP: 19,
        LENGTH: 101,
        RECORD: 20,
        EVENT: 21,
        DEVICE_INFO: 23,
        DEVICE_AUX_BATTERY_INFO: 375,
        TRAINING_FILE: 72,
        WEATHER_CONDITIONS: 128,
        WEATHER_ALERT: 129,
        GPS_METADATA: 160,
        CAMERA_EVENT: 161,
        GYROSCOPE_DATA: 164,
        ACCELEROMETER_DATA: 165,
        MAGNETOMETER_DATA: 208,
        BAROMETER_DATA: 209,
        THREE_D_SENSOR_CALIBRATION: 167,
        ONE_D_SENSOR_CALIBRATION: 210,
        VIDEO_FRAME: 169,
        OBDII_DATA: 174,
        NMEA_SENTENCE: 177,
        AVIATION_ATTITUDE: 178,
        VIDEO: 184,
        VIDEO_TITLE: 185,
        VIDEO_DESCRIPTION: 186,
        VIDEO_CLIP: 187,
        SET: 225,
        JUMP: 285,
        SPLIT: 312,
        SPLIT_SUMMARY: 313,
        CLIMB_PRO: 317,
        FIELD_DESCRIPTION: 206,
        DEVELOPER_DATA_ID: 207,
        COURSE: 31,
        COURSE_POINT: 32,
        SEGMENT_ID: 148,
        SEGMENT_LEADERBOARD_ENTRY: 149,
        SEGMENT_POINT: 150,
        SEGMENT_LAP: 142,
        SEGMENT_FILE: 151,
        WORKOUT: 26,
        WORKOUT_SESSION: 158,
        WORKOUT_STEP: 27,
        EXERCISE_TITLE: 264,
        SCHEDULE: 28,
        TOTALS: 33,
        WEIGHT_SCALE: 30,
        BLOOD_PRESSURE: 51,
        MONITORING_INFO: 103,
        MONITORING: 55,
        MONITORING_HR_DATA: 211,
        SPO2_DATA: 269,
        HR: 132,
        STRESS_LEVEL: 227,
        MAX_MET_DATA: 229,
        HSA_BODY_BATTERY_DATA: 314,
        HSA_EVENT: 315,
        HSA_ACCELEROMETER_DATA: 302,
        HSA_GYROSCOPE_DATA: 376,
        HSA_STEP_DATA: 304,
        HSA_SPO2_DATA: 305,
        HSA_STRESS_DATA: 306,
        HSA_RESPIRATION_DATA: 307,
        HSA_HEART_RATE_DATA: 308,
        HSA_CONFIGURATION_DATA: 389,
        HSA_WRIST_TEMPERATURE_DATA: 409,
        MEMO_GLOB: 145,
        SLEEP_LEVEL: 275,
        ANT_CHANNEL_ID: 82,
        ANT_RX: 80,
        ANT_TX: 81,
        EXD_SCREEN_CONFIGURATION: 200,
        EXD_DATA_FIELD_CONFIGURATION: 201,
        EXD_DATA_CONCEPT_CONFIGURATION: 202,
        DIVE_SUMMARY: 268,
        AAD_ACCEL_FEATURES: 289,
        HRV: 78,
        BEAT_INTERVALS: 290,
        HRV_STATUS_SUMMARY: 370,
        HRV_VALUE: 371,
        RAW_BBI: 372,
        RESPIRATION_RATE: 297,
        CHRONO_SHOT_SESSION: 387,
        CHRONO_SHOT_DATA: 388,
        TANK_UPDATE: 319,
        TANK_SUMMARY: 323,
        SLEEP_ASSESSMENT: 346,
        SLEEP_DISRUPTION_SEVERITY_PERIOD: 470,
        SLEEP_DISRUPTION_OVERNIGHT_SEVERITY: 471,
        SKIN_TEMP_OVERNIGHT: 398,
        PAD: 105
    }
};
var $d64f2254b548006a$export$2e2bcd8739ae039 = $d64f2254b548006a$var$Profile;


const $0418c05b568b35af$var$decodeMemoGlobs = (messages)=>{
    if ((messages?.memoGlobMesgs?.length ?? 0) == 0) return;
    const memoGlobMesgs = messages.memoGlobMesgs;
    // Group memoGlob mesgs by mesgNum, parentIndex, and fieldNum
    const groupedMemoGlobs = Object.groupBy(memoGlobMesgs, ({ mesgNum: mesgNum, parentIndex: parentIndex, fieldNum: fieldNum })=>{
        return JSON.stringify({
            mesgNum: mesgNum,
            parentIndex: parentIndex,
            fieldNum: fieldNum
        });
    });
    Object.entries(groupedMemoGlobs).forEach(([key, memoGlobMesgs])=>{
        const { mesgNum: mesgNum, parentIndex: parentIndex, fieldNum: fieldNum } = JSON.parse(key);
        // Sort grouped memoGlob messages by part index
        memoGlobMesgs.sort((a, b)=>a.partIndex - b.partIndex);
        const mesgProfile = Object.values((0, $d64f2254b548006a$export$2e2bcd8739ae039).messages).find((mesgDefinition)=>{
            return mesgDefinition.name == mesgNum || mesgDefinition.num == mesgNum;
        });
        const targetMesg = messages[mesgProfile?.messagesKey ?? mesgNum]?.[parentIndex];
        if (targetMesg == null) return;
        const targetFieldKey = mesgProfile?.fields?.[fieldNum]?.name ?? fieldNum;
        const memoGlobBytes = memoGlobMesgs.reduce((accumluatedBytes, mesg)=>{
            return accumluatedBytes.concat(mesg.data);
        }, []);
        targetMesg[targetFieldKey] = $0418c05b568b35af$var$decodeMemoGlobBytesToUtf8(memoGlobBytes);
    });
};
const $0418c05b568b35af$var$decodeMemoGlobBytesToUtf8 = (memoGlobBytes)=>{
    let decoder = new TextDecoder('utf-8');
    let bytes = new Uint8Array(memoGlobBytes);
    return decoder.decode(bytes);
};
var $0418c05b568b35af$export$2e2bcd8739ae039 = {
    decodeMemoGlobs: $0418c05b568b35af$var$decodeMemoGlobs,
    decodeMemoGlobBytesToUtf8: $0418c05b568b35af$var$decodeMemoGlobBytesToUtf8
};



/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////
const $550b00c7b4a6322d$var$sanitizeValues = (values)=>{
    if ($550b00c7b4a6322d$var$onlyNullValues(values)) return null;
    return values.length === 1 ? values[0] : values;
};
const $550b00c7b4a6322d$var$trimStringTrailingNulls = (string)=>{
    if (string == null) return;
    let strings = string.split("\u0000");
    while(strings[strings.length - 1] === ""){
        strings.pop();
        if (strings.length === 0) return "";
    }
    return strings.length === 1 ? strings[0] : strings;
};
const $550b00c7b4a6322d$var$onlyNullValues = (values)=>values.reduce((state, value)=>value != null ? false : state, true);
const $550b00c7b4a6322d$var$onlyInvalidValues = (rawFieldValue, invalidValue)=>{
    if (Array.isArray(rawFieldValue)) return rawFieldValue.reduce((state, value)=>value != invalidValue ? false : state, true);
    return rawFieldValue === invalidValue;
};
var $550b00c7b4a6322d$export$2e2bcd8739ae039 = {
    sanitizeValues: $550b00c7b4a6322d$var$sanitizeValues,
    trimStringTrailingNulls: $550b00c7b4a6322d$var$trimStringTrailingNulls,
    onlyNullValues: $550b00c7b4a6322d$var$onlyNullValues,
    onlyInvalidValues: $550b00c7b4a6322d$var$onlyInvalidValues
};


class $2b03d198a24d6ce0$var$Stream {
    static LITTLE_ENDIAN = true;
    static BIG_ENDIAN = false;
    #position = 0;
    #arrayBuffer = null;
    #textDecoder = new TextDecoder("utf-8", {
        fatal: false,
        ignoreBOM: true
    });
    #crcCalculator = null;
    /**
     * Convenience method for creating a Stream from a byte array
     * @param {Array<number>} data An array of bytes
     * @returns {Stream} A new Stream object
     * @static
     */ static fromByteArray(data) {
        const buf = new Uint8Array(data);
        return this.fromArrayBuffer(buf.buffer);
    }
    /**
     * Convenience method for creating a Stream from a Node Buffer
     * @param {Buffer} buffer - Node Buffer of bytes
     * @returns {Stream} A new Stream object
     * @static
     */ static fromBuffer(buffer) {
        const arrayBuffer = buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
        return this.fromArrayBuffer(arrayBuffer);
    }
    /**
     * Convenience method for creating a Stream from an ArrayBuffer
     * @param {ArrayBuffer} arrayBuffer - An ArrayBuffer of bytes
     * @returns {Stream} A new Stream object
     * @static
     */ static fromArrayBuffer(arrayBuffer) {
        const stream = new $2b03d198a24d6ce0$var$Stream(arrayBuffer);
        return stream;
    }
    /**
     * Creates a Stream containing a FIT file
     * @constructor
     * @param {ArrayBuffer} stream - ArrayBuffer containing a FIT file
     */ constructor(arrayBuffer){
        this.#position = 0;
        this.#arrayBuffer = arrayBuffer;
    }
    get length() {
        return this.#arrayBuffer.byteLength;
    }
    get bytesRead() {
        return this.#position;
    }
    get position() {
        return this.#position;
    }
    get crcCalculator() {
        return this.#crcCalculator;
    }
    set crcCalculator(crcCalculator) {
        this.#crcCalculator = crcCalculator;
    }
    reset() {
        this.seek(0);
    }
    seek(position) {
        this.#position = position;
    }
    slice(begin, end) {
        return this.#arrayBuffer.slice(begin, end);
    }
    peekByte() {
        const arrayBuffer = this.#arrayBuffer.slice(this.#position, this.#position + 1);
        const dataView = new DataView(arrayBuffer);
        return dataView.getUint8(0);
    }
    readByte() {
        return this.readUInt8();
    }
    readBytes(size) {
        if (this.#position + size > this.#arrayBuffer.byteLength) throw Error(`FIT Runtime Error end of stream at byte ${this.#position}`);
        const bytes = new Uint8Array(this.#arrayBuffer, this.#position, size);
        this.#position += size;
        this.#crcCalculator?.addBytes(bytes, 0, size);
        return bytes;
    }
    readUInt8(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8, 1, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readInt8(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT8, 1, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readUInt16(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT16, 2, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readInt16(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT16, 2, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readUInt32(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT32, 4, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readInt32(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT32, 4, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readUInt64(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT64, 8, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readInt64(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT64, 8, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readFloat32(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT32, 4, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readFloat64(opts) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT64, 8, {
            convertInvalidToNull: false,
            ...opts
        });
    }
    readString(strlen) {
        return this.readValue((0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.STRING, strlen);
    }
    readValue(baseType, size, { endianness: endianness = $2b03d198a24d6ce0$var$Stream.LITTLE_ENDIAN, convertInvalidToNull: convertInvalidToNull = true } = {}) {
        const baseTypeSize = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[baseType].size;
        const baseTypeInvalid = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[baseType].invalid;
        const bytes = this.readBytes(size);
        if (size % baseTypeSize !== 0) return convertInvalidToNull ? null : baseTypeInvalid;
        if (baseType === (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.STRING) {
            const string = this.#textDecoder.decode(bytes).replace(/\uFFFD/g, "");
            const strings = string.split('\0');
            while(strings[strings.length - 1] === "")strings.pop();
            if (strings.length === 0) return null;
            return strings.length === 1 ? strings[0] : strings;
        }
        const dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        let values = [];
        const count = size / baseTypeSize;
        for(let i = 0; i < count; i++)switch(baseType){
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.BYTE:
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.ENUM:
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8:
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8Z:
                values.push(dataView.getUint8(i * baseTypeSize));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT8:
                values.push(dataView.getInt8(i * baseTypeSize));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT16:
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT16Z:
                values.push(dataView.getUint16(i * baseTypeSize, endianness));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT16:
                values.push(dataView.getInt16(i * baseTypeSize, endianness));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT32:
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT32Z:
                values.push(dataView.getUint32(i * baseTypeSize, endianness));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT32:
                values.push(dataView.getInt32(i * baseTypeSize, endianness));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT64:
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT64Z:
                values.push(dataView.getBigUint64(i * baseTypeSize, endianness));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT64:
                values.push(dataView.getBigInt64(i * baseTypeSize, endianness));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT32:
                values.push(dataView.getFloat32(i * baseTypeSize, endianness));
                break;
            case (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT64:
                values.push(dataView.getFloat64(i * baseTypeSize, endianness));
                break;
        }
        if (baseType === (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.BYTE) return (0, $550b00c7b4a6322d$export$2e2bcd8739ae039).onlyInvalidValues(values, baseTypeInvalid) ? null : values;
        if (convertInvalidToNull) values = values.map((value)=>value === baseTypeInvalid ? null : value);
        return (0, $550b00c7b4a6322d$export$2e2bcd8739ae039).sanitizeValues(values);
    }
}
var $2b03d198a24d6ce0$export$2e2bcd8739ae039 = $2b03d198a24d6ce0$var$Stream;




const $9a417e2fdf8841c7$var$COMPRESSED_HEADER_MASK = 0x80;
const $9a417e2fdf8841c7$var$MESG_DEFINITION_MASK = 0x40;
const $9a417e2fdf8841c7$var$DEV_DATA_MASK = 0x20;
const $9a417e2fdf8841c7$var$MESG_HEADER_MASK = 0x00;
const $9a417e2fdf8841c7$var$LOCAL_MESG_NUM_MASK = 0x0F;
const $9a417e2fdf8841c7$var$HEADER_WITH_CRC_SIZE = 14;
const $9a417e2fdf8841c7$var$HEADER_WITHOUT_CRC_SIZE = 12;
const $9a417e2fdf8841c7$var$CRC_SIZE = 2;
const $9a417e2fdf8841c7$var$DecodeMode = Object.freeze({
    NORMAL: "normal",
    SKIP_HEADER: "skipHeader",
    DATA_ONLY: "dataOnly"
});
class $9a417e2fdf8841c7$var$Decoder {
    #localMessageDefinitions = [];
    #developerDataDefinitions = {};
    #stream = null;
    #accumulator = new (0, $672b154b305381f7$export$2e2bcd8739ae039)();
    #messages = {};
    #fieldsWithSubFields = [];
    #fieldsToExpand = [];
    #decodeMode = $9a417e2fdf8841c7$var$DecodeMode.NORMAL;
    #mesgListener = null;
    #mesgDefinitionListener = null;
    #fieldDescriptionListener = null;
    #optExpandSubFields = true;
    #optExpandComponents = true;
    #optApplyScaleAndOffset = true;
    #optConvertTypesToStrings = true;
    #optConvertDateTimesToDates = true;
    #optIncludeUnknownData = false;
    #optMergeHeartRates = true;
    #optDecodeMemoGlobs = false;
    /**
     * Creates a FIT File Decoder
     * @constructor
     * @param {Stream} stream - representing the FIT file to decode
     */ constructor(stream){
        if (stream == null) throw Error("FIT Runtime Error stream parameter is null or undefined");
        this.#stream = stream;
    }
    /**
     * Inspects the file header to determine if the input stream is a FIT file
     * @param {Stream} stream
     * @returns {Boolean} True if the stream is a FIT file
     * @static
     */ static isFIT(stream) {
        try {
            const fileHeaderSize = stream.peekByte();
            if ([
                $9a417e2fdf8841c7$var$HEADER_WITH_CRC_SIZE,
                $9a417e2fdf8841c7$var$HEADER_WITHOUT_CRC_SIZE
            ].includes(fileHeaderSize) != true) return false;
            if (stream.length < fileHeaderSize + $9a417e2fdf8841c7$var$CRC_SIZE) return false;
            const fileHeader = $9a417e2fdf8841c7$var$Decoder.#readFileHeader(stream, {
                resetPosition: true
            });
            if (fileHeader.dataType !== ".FIT") return false;
        } catch (error) {
            return false;
        }
        return true;
    }
    /**
     * Inspects the file header to determine if the input stream is a FIT file
     * @returns {Boolean} True if the stream is a FIT file
     */ isFIT() {
        return $9a417e2fdf8841c7$var$Decoder.isFIT(this.#stream);
    }
    /**
     * Checks that the input stream is a FIT file and verifies both the header and file CRC values
     * @returns {Boolean} True if the stream passes the isFit() and CRC checks
     */ checkIntegrity() {
        try {
            if (!this.isFIT()) return false;
            const fileHeader = $9a417e2fdf8841c7$var$Decoder.#readFileHeader(this.#stream, {
                resetPosition: true
            });
            if (this.#stream.length < fileHeader.headerSize + fileHeader.dataSize + $9a417e2fdf8841c7$var$CRC_SIZE) return false;
            const buf = new Uint8Array(this.#stream.slice(0, this.#stream.length));
            if (fileHeader.headerSize === $9a417e2fdf8841c7$var$HEADER_WITH_CRC_SIZE && fileHeader.headerCRC !== 0x0000 && fileHeader.headerCRC != (0, $4883ab303b017428$export$2e2bcd8739ae039).calculateCRC(buf, 0, 12)) return false;
            const fileCRC = (buf[fileHeader.headerSize + fileHeader.dataSize + 1] << 8) + buf[fileHeader.headerSize + fileHeader.dataSize];
            if (fileCRC != (0, $4883ab303b017428$export$2e2bcd8739ae039).calculateCRC(buf, 0, fileHeader.headerSize + fileHeader.dataSize)) return false;
        } catch (error) {
            return false;
        }
        return true;
    }
    /**
     * Message Listener Callback
     *
     * @callback Decoder~mesgListener
     * @param {Number} mesgNum - Profile.MesgNum
     * @param {Object} message - The message
     */ /**
     * Message Definition Listener Callback
     *
     * @callback Decoder~mesgDefinitionListener
     * @param {Object} messageDefinition - The message Definition
     */ /**
     * Developer Field Description Listener Callback
     *
     * @callback Decoder~fieldDescriptionListener
     * @param {Number} key - The key associated with this pairing of of Developer Data Id and Field Description Mesgs
     * @param {Object} developerDataIdMesg - The Developer Data Id Mesg associated with this pairing
     * @param {Object} fieldDescriptionMesg - The Field Description Mesg associated with this pairing
     */ /**
     * Read the messages from the stream.
     * @param {Object=} [options] - Read options (optional)
     * @param {Decoder~mesgListener} [options.mesgListener=null] - (optional, default null) mesgListener(mesgNum, message)
     * @param {Decoder~mesgDefinitionListener} [options.mesgDefinitionListener=null] - (optional, default null) mesgDefinitionListener(mesgDefinition)
     * @param {Decoder~fieldDescriptionListener} [options.fieldDescriptionListener=null] - (optional, default null) fieldDescriptionListener(key, developerDataIdMesg, fieldDescriptionMesg)
     * @param {Boolean} [options.expandSubFields=true] - (optional, default true)
     * @param {Boolean} [options.expandComponents=true] - (optional, default true)
     * @param {Boolean} [options.applyScaleAndOffset=true] - (optional, default true)
     * @param {Boolean} [options.convertTypesToStrings=true] - (optional, default true)
     * @param {boolean} [options.convertDateTimesToDates=true] - (optional, default true)
     * @param {Boolean} [options.includeUnknownData=false] - (optional, default false)
     * @param {boolean} [options.mergeHeartRates=true] - (optional, default true)
     * @param {boolean} [options.decodeMemoGlobs=true] - (optional, default false)
     * @param {boolean} [options.skipHeader=false] - (optional, default false)
     * @param {boolean} [options.dataOnly=false] - (optional, default false)
     * @return {Object} result - {messages:Array, errors:Array}
     */ read({ mesgListener: mesgListener = null, mesgDefinitionListener: mesgDefinitionListener = null, fieldDescriptionListener: fieldDescriptionListener = null, expandSubFields: expandSubFields = true, expandComponents: expandComponents = true, applyScaleAndOffset: applyScaleAndOffset = true, convertTypesToStrings: convertTypesToStrings = true, convertDateTimesToDates: convertDateTimesToDates = true, includeUnknownData: includeUnknownData = false, mergeHeartRates: mergeHeartRates = true, decodeMemoGlobs: decodeMemoGlobs = false, skipHeader: skipHeader = false, dataOnly: dataOnly = false } = {}) {
        this.#mesgListener = mesgListener;
        this.#mesgDefinitionListener = mesgDefinitionListener;
        this.#fieldDescriptionListener = fieldDescriptionListener;
        this.#optExpandSubFields = expandSubFields;
        this.#optExpandComponents = expandComponents;
        this.#optApplyScaleAndOffset = applyScaleAndOffset;
        this.#optConvertTypesToStrings = convertTypesToStrings;
        this.#optConvertDateTimesToDates = convertDateTimesToDates;
        this.#optIncludeUnknownData = includeUnknownData;
        this.#optMergeHeartRates = mergeHeartRates;
        this.#optDecodeMemoGlobs = decodeMemoGlobs;
        this.#localMessageDefinitions = [];
        this.#developerDataDefinitions = {};
        this.#messages = {};
        const errors = [];
        try {
            if (this.#optMergeHeartRates && (!this.#optApplyScaleAndOffset || !this.#optExpandComponents)) this.#throwError("mergeHeartRates requires applyScaleAndOffset and expandComponents to be enabled");
            if (dataOnly && skipHeader) this.#throwError("dataOnly and skipHeader cannot both be enabled");
            this.#decodeMode = skipHeader ? $9a417e2fdf8841c7$var$DecodeMode.SKIP_HEADER : dataOnly ? $9a417e2fdf8841c7$var$DecodeMode.DATA_ONLY : $9a417e2fdf8841c7$var$DecodeMode.NORMAL;
            while(this.#stream.position < this.#stream.length)this.#decodeNextFile();
            if (this.#optMergeHeartRates) (0, $4c13e134286d0771$export$2e2bcd8739ae039).mergeHeartRates(this.#messages.hrMesgs, this.#messages.recordMesgs);
            if (this.#optDecodeMemoGlobs) (0, $0418c05b568b35af$export$2e2bcd8739ae039).decodeMemoGlobs(this.#messages);
        } catch (error) {
            errors.push(error);
        } finally{
            return {
                messages: this.#messages,
                errors: errors
            };
        }
    }
    #decodeNextFile() {
        const position = this.#stream.position;
        if (this.#decodeMode === $9a417e2fdf8841c7$var$DecodeMode.NORMAL && !this.isFIT()) this.#throwError("input is not a FIT file");
        this.#stream.crcCalculator = new (0, $4883ab303b017428$export$2e2bcd8739ae039)();
        const { headerSize: headerSize, dataSize: dataSize } = $9a417e2fdf8841c7$var$Decoder.#readFileHeader(this.#stream, {
            decodeMode: this.#decodeMode
        });
        // Read data messages and definitions
        while(this.#stream.position < position + headerSize + dataSize)this.#decodeNextRecord();
        // Check the CRC
        const calculatedCrc = this.#stream.crcCalculator.crc;
        const crc = this.#stream.readUInt16();
        if (this.#decodeMode === $9a417e2fdf8841c7$var$DecodeMode.NORMAL && crc !== calculatedCrc) this.#throwError("CRC error");
    }
    #decodeNextRecord() {
        const recordHeader = this.#stream.peekByte();
        if ((recordHeader & $9a417e2fdf8841c7$var$COMPRESSED_HEADER_MASK) === $9a417e2fdf8841c7$var$COMPRESSED_HEADER_MASK) return this.#decodeCompressedTimestampDataMessage();
        if ((recordHeader & $9a417e2fdf8841c7$var$MESG_DEFINITION_MASK) === $9a417e2fdf8841c7$var$MESG_HEADER_MASK) return this.#decodeMessage();
        if ((recordHeader & $9a417e2fdf8841c7$var$MESG_DEFINITION_MASK) === $9a417e2fdf8841c7$var$MESG_DEFINITION_MASK) return this.#decodeMessageDefinition();
    }
    #decodeMessageDefinition() {
        const recordHeader = this.#stream.readByte();
        const messageDefinition = {};
        messageDefinition["recordHeader"] = recordHeader;
        messageDefinition["localMesgNum"] = recordHeader & $9a417e2fdf8841c7$var$LOCAL_MESG_NUM_MASK;
        messageDefinition["reserved"] = this.#stream.readByte();
        messageDefinition["architecture"] = this.#stream.readByte();
        messageDefinition["endianness"] = messageDefinition.architecture === 0 ? (0, $2b03d198a24d6ce0$export$2e2bcd8739ae039).LITTLE_ENDIAN : (0, $2b03d198a24d6ce0$export$2e2bcd8739ae039).BIG_ENDIAN;
        messageDefinition["globalMessageNumber"] = this.#stream.readUInt16({
            endianness: messageDefinition["endianness"]
        });
        messageDefinition["numFields"] = this.#stream.readByte();
        messageDefinition["fieldDefinitions"] = [];
        messageDefinition["developerFieldDefinitions"] = [];
        messageDefinition["messageSize"] = 0;
        messageDefinition["developerDataSize"] = 0;
        for(let i = 0; i < messageDefinition.numFields; i++){
            const fieldDefinition = {
                fieldDefinitionNumber: this.#stream.readByte(),
                size: this.#stream.readByte(),
                baseType: this.#stream.readByte()
            };
            if (!(fieldDefinition.baseType in (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions)) this.#throwError();
            fieldDefinition["invalidValue"] = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[fieldDefinition.baseType].invalid;
            fieldDefinition["baseTypeSize"] = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[fieldDefinition.baseType].size;
            messageDefinition.fieldDefinitions.push(fieldDefinition);
            messageDefinition.messageSize += fieldDefinition.size;
        }
        if ((recordHeader & $9a417e2fdf8841c7$var$DEV_DATA_MASK) === $9a417e2fdf8841c7$var$DEV_DATA_MASK) {
            const numDevFields = this.#stream.readByte();
            for(let i = 0; i < numDevFields; i++){
                const developerFieldDefinition = {
                    fieldDefinitionNumber: this.#stream.readByte(),
                    size: this.#stream.readByte(),
                    developerDataIndex: this.#stream.readByte()
                };
                messageDefinition.developerFieldDefinitions.push(developerFieldDefinition);
                messageDefinition.developerDataSize += developerFieldDefinition.size;
            }
        }
        this.#mesgDefinitionListener?.({
            ...messageDefinition
        });
        let messageProfile = (0, $d64f2254b548006a$export$2e2bcd8739ae039).messages[messageDefinition.globalMessageNumber];
        if (messageProfile == null && this.#optIncludeUnknownData) messageProfile = {
            name: messageDefinition["globalMessageNumber"].toString(),
            messagesKey: messageDefinition["globalMessageNumber"].toString(),
            num: messageDefinition["globalMessageNumber"],
            fields: {}
        };
        this.#localMessageDefinitions[messageDefinition.localMesgNum] = {
            ...messageDefinition,
            ...messageProfile
        };
        if (messageProfile && !this.#messages.hasOwnProperty(messageProfile.messagesKey)) this.#messages[messageProfile.messagesKey] = [];
    }
    #decodeMessage() {
        const recordHeader = this.#stream.readByte();
        const localMesgNum = recordHeader & $9a417e2fdf8841c7$var$LOCAL_MESG_NUM_MASK;
        const messageDefinition = this.#localMessageDefinitions[localMesgNum];
        if (messageDefinition == null) this.#throwError();
        const fields = messageDefinition.fields ?? {};
        const mesgNum = messageDefinition.num;
        const message = {};
        this.#fieldsWithSubFields = [];
        this.#fieldsToExpand = [];
        messageDefinition.fieldDefinitions.forEach((fieldDefinition)=>{
            const field = fields[fieldDefinition.fieldDefinitionNumber];
            const { fieldName: fieldName, rawFieldValue: rawFieldValue } = this.#readFieldValue(messageDefinition, fieldDefinition, field);
            if (fieldName != null && (field != null || this.#optIncludeUnknownData)) {
                message[fieldName] = {
                    rawFieldValue: rawFieldValue,
                    fieldDefinitionNumber: fieldDefinition.fieldDefinitionNumber
                };
                if (field?.subFields?.length > 0) this.#fieldsWithSubFields.push(fieldName);
                if (field?.hasComponents) this.#fieldsToExpand.push(fieldName);
                if (field?.isAccumulated) this.#setAccumulatedField(messageDefinition, message, field, rawFieldValue);
            }
        });
        const developerFields = {};
        messageDefinition.developerFieldDefinitions.forEach((developerFieldDefinition)=>{
            const field = this.#lookupDeveloperDataField(developerFieldDefinition);
            if (field == null) {
                // If there is not a field definition, then read past the field data.
                this.#stream.readBytes(developerFieldDefinition.size);
                return;
            }
            developerFieldDefinition["baseType"] = field.fitBaseTypeId;
            developerFieldDefinition["invalidValue"] = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[developerFieldDefinition.baseType].invalid;
            developerFieldDefinition["baseTypeSize"] = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[developerFieldDefinition.baseType].size;
            const { rawFieldValue: fieldValue } = this.#readFieldValue(messageDefinition, developerFieldDefinition, field);
            if (fieldValue != null) developerFields[field.key] = fieldValue;
        });
        if (mesgNum === (0, $d64f2254b548006a$export$2e2bcd8739ae039).MesgNum.DEVELOPER_DATA_ID) this.#addDeveloperDataIdToProfile(message);
        else if (mesgNum === (0, $d64f2254b548006a$export$2e2bcd8739ae039).MesgNum.FIELD_DESCRIPTION) {
            const key = Object.keys(this.#developerDataDefinitions).reduce((count, key)=>count + this.#developerDataDefinitions[key].fields.length, 0);
            message["key"] = {
                fieldValue: key,
                rawFieldValue: key
            };
            this.#addFieldDescriptionToProfile(message);
        } else {
            this.#expandSubFields(mesgNum, message);
            this.#expandComponents(mesgNum, message, fields);
        }
        this.#transformValues(message, messageDefinition);
        if (messageDefinition.name != null) {
            Object.keys(message).forEach((key)=>{
                message[key] = message[key].fieldValue;
            });
            if (Object.keys(developerFields).length > 0) message.developerFields = developerFields;
            this.#messages[messageDefinition.messagesKey].push(message);
            this.#mesgListener?.(messageDefinition.globalMessageNumber, message);
            if (mesgNum === (0, $d64f2254b548006a$export$2e2bcd8739ae039).MesgNum.FIELD_DESCRIPTION && this.#fieldDescriptionListener != null) {
                const developerDataIdMesg = this.#messages.developerDataIdMesgs?.find((developerDataIdMesg)=>{
                    return developerDataIdMesg.developerDataIndex === message.developerDataIndex;
                }) ?? {};
                this.#fieldDescriptionListener(message.key, {
                    ...developerDataIdMesg
                }, {
                    ...message
                });
            }
        }
    }
    #decodeCompressedTimestampDataMessage() {
        this.#throwError("compressed timestamp messages are not currently supported");
    }
    #readFieldValue(messageDefinition, fieldDefinition, field) {
        const rawFieldValue = this.#readRawFieldValue(messageDefinition, fieldDefinition, field);
        if (rawFieldValue == null) return {};
        return {
            fieldName: field?.name ?? ~~fieldDefinition.fieldDefinitionNumber,
            rawFieldValue: rawFieldValue
        };
    }
    #readRawFieldValue(messageDefinition, fieldDefinition, field) {
        const rawFieldValue = this.#stream.readValue(fieldDefinition.baseType, fieldDefinition.size, {
            endianness: messageDefinition["endianness"],
            convertInvalidToNull: !field?.hasComponents ?? false
        });
        return rawFieldValue;
    }
    #addDeveloperDataIdToProfile(message) {
        if (message == null || message.developerDataIndex.rawFieldValue == null || message.developerDataIndex.rawFieldValue === 0xFF) return;
        this.#developerDataDefinitions[message.developerDataIndex.rawFieldValue] = {
            developerDataIndex: message.developerDataIndex?.rawFieldValue,
            developerId: message.developerId?.rawFieldValue ?? null,
            applicationId: message.applicationId?.rawFieldValue ?? null,
            manufacturerId: message.manufacturerId?.rawFieldValue ?? null,
            applicationVersion: message.applicationVersion?.rawFieldValue ?? null,
            fields: []
        };
    }
    #addFieldDescriptionToProfile(message) {
        if (message == null || message.developerDataIndex.rawFieldValue == null || message.developerDataIndex.rawFieldValue === 0xFF) return;
        if (this.#developerDataDefinitions[message.developerDataIndex.rawFieldValue] == null) return;
        this.#developerDataDefinitions[message.developerDataIndex.rawFieldValue].fields.push({
            developerDataIndex: message.developerDataIndex?.rawFieldValue,
            fieldDefinitionNumber: message.fieldDefinitionNumber?.rawFieldValue,
            fitBaseTypeId: message.fitBaseTypeId?.rawFieldValue ?? null,
            fieldName: message.fieldName?.rawFieldValue ?? null,
            array: message.array?.rawFieldValue ?? null,
            components: message.components?.rawFieldValue ?? null,
            scale: message.scale?.rawFieldValue ?? null,
            offset: message.offset?.rawFieldValue ?? null,
            units: message.units?.rawFieldValue ?? null,
            bits: message.bits?.rawFieldValue ?? null,
            accumulate: message.accumulate?.rawFieldValue ?? null,
            refFieldName: message.refFieldName?.rawFieldValue ?? null,
            refFieldValue: message.refFieldValue?.rawFieldValue ?? null,
            fitBaseUnitId: message.fitBaseUnitId?.rawFieldValue ?? null,
            nativeMesgNum: message.nativeMesgNum?.rawFieldValue ?? null,
            nativeFieldNum: message.nativeFieldNum?.rawFieldValue ?? null,
            key: message.key.rawFieldValue
        });
    }
    #lookupDeveloperDataField(developerFieldDefinition) {
        try {
            return this.#developerDataDefinitions[developerFieldDefinition.developerDataIndex]?.fields?.find((def)=>def.fieldDefinitionNumber == developerFieldDefinition.fieldDefinitionNumber) ?? null;
        } catch  {
            return null;
        }
    }
    #expandSubFields(mesgNum, message) {
        if (!this.#optExpandSubFields || this.#fieldsWithSubFields.length == 0) return;
        this.#fieldsWithSubFields.forEach((name)=>{
            const field = (0, $d64f2254b548006a$export$2e2bcd8739ae039).messages[mesgNum].fields[message[name].fieldDefinitionNumber];
            this.#expandSubField(message, field);
        });
    }
    #expandSubField(message, field) {
        for(let i = 0; i < field.subFields.length; i++){
            const subField = field.subFields[i];
            for(let j = 0; j < subField.map.length; j++){
                const map = subField.map[j];
                const referenceField = message[map.name];
                if (referenceField == null) continue;
                if (referenceField.rawFieldValue === map.value) {
                    message[subField.name] = JSON.parse(JSON.stringify(message[field.name]));
                    message[subField.name].isSubField = true;
                    if (subField.hasComponents) this.#fieldsToExpand.push(subField.name);
                    break;
                }
            }
        }
    }
    #expandComponents(mesgNum, message, fields) {
        // TODO - What do do when the target field is not in the Profile?
        // TODO - This can happen in theory, but can it happen in practice?
        if (!this.#optExpandComponents || this.#fieldsToExpand.length == 0) return;
        const mesg = {};
        while(this.#fieldsToExpand.length > 0){
            const name = this.#fieldsToExpand.shift();
            const { rawFieldValue: rawFieldValue, fieldDefinitionNumber: fieldDefinitionNumber, isSubField: isSubField } = message[name] ?? mesg[name];
            let field = (0, $d64f2254b548006a$export$2e2bcd8739ae039).messages[mesgNum].fields[fieldDefinitionNumber];
            field = isSubField ? this.#lookupSubfield(field, name) : field;
            const baseType = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FieldTypeToBaseType[field.type];
            if (field.hasComponents === false || baseType == null) continue;
            if ((0, $550b00c7b4a6322d$export$2e2bcd8739ae039).onlyInvalidValues(rawFieldValue, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[baseType].invalid)) continue;
            const bitStream = new (0, $fe826815364cfcee$export$2e2bcd8739ae039)(rawFieldValue, baseType);
            for(let j = 0; j < field.components.length; j++){
                if (bitStream.bitsAvailable < field.bits[j]) break;
                const targetField = fields[field.components[j]];
                if (mesg[targetField.name] == null) {
                    const baseType = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FieldTypeToBaseType[targetField.type];
                    const invalidValue = baseType != null ? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[baseType].invalid : 0xFF;
                    mesg[targetField.name] = {
                        fieldValue: [],
                        rawFieldValue: [],
                        fieldDefinitionNumber: targetField.num,
                        isExpandedField: true,
                        invalidValue: invalidValue
                    };
                }
                let value = bitStream.readBits(field.bits[j]);
                if (targetField.isAccumulated) value = this.#accumulator.accumulate(mesgNum, targetField.num, value, field.bits[j]);
                // Undo component scale and offset before applying the destination field's scale and offset
                value = value / field.scale[j] - field.offset[j];
                const rawValue = (value + targetField.offset) * targetField.scale;
                mesg[targetField.name].rawFieldValue.push(rawValue);
                if (rawValue === mesg[targetField.name].invalidValue) mesg[targetField.name].fieldValue.push(null);
                else {
                    if (this.#optConvertTypesToStrings) value = this.#convertTypeToString(mesg, targetField, value);
                    mesg[targetField.name].fieldValue.push(value);
                }
                if (targetField.hasComponents) this.#fieldsToExpand.push(targetField.name);
                if (!bitStream.hasBitsAvailable) break;
            }
        }
        Object.keys(mesg).forEach((key)=>{
            mesg[key].fieldValue = (0, $550b00c7b4a6322d$export$2e2bcd8739ae039).sanitizeValues(mesg[key].fieldValue);
            mesg[key].rawFieldValue = (0, $550b00c7b4a6322d$export$2e2bcd8739ae039).sanitizeValues(mesg[key].rawFieldValue);
            message[key] = mesg[key];
        });
    }
    #transformValues(message, messageDefinition) {
        const fields = messageDefinition?.fields ?? {};
        for(const name in message){
            const { rawFieldValue: rawFieldValue, fieldDefinitionNumber: fieldDefinitionNumber, isExpandedField: isExpandedField, isSubField: isSubField } = message[name];
            let field = fields[fieldDefinitionNumber];
            field = isSubField ? this.#lookupSubfield(field, name) : field;
            if (!isExpandedField) {
                const fieldValue = this.#transformValue(messageDefinition, field, rawFieldValue);
                message[name].fieldValue = fieldValue;
            }
        }
    }
    #transformValue(messageDefinition, field, rawFieldValue) {
        let fieldValue = rawFieldValue;
        if (field == null) fieldValue = rawFieldValue;
        else if ((0, $6fb08636b36a917e$export$2e2bcd8739ae039).NumericFieldTypes.includes(field?.type ?? -1)) fieldValue = this.#applyScaleAndOffset(messageDefinition, field, rawFieldValue);
        else if (field.type === "string") fieldValue = rawFieldValue;
        else if (field.type === "dateTime" && this.#optConvertDateTimesToDates) fieldValue = (0, $519e72961d771fc4$export$2e2bcd8739ae039).convertDateTimeToDate(rawFieldValue);
        else if (this.#optConvertTypesToStrings) fieldValue = this.#convertTypeToString(messageDefinition, field, rawFieldValue);
        else fieldValue = rawFieldValue;
        return fieldValue;
    }
    #applyScaleAndOffset(messageDefinition, field, rawFieldValue) {
        if (!this.#optApplyScaleAndOffset) return rawFieldValue;
        if ((0, $6fb08636b36a917e$export$2e2bcd8739ae039).NumericFieldTypes.includes(field?.type ?? -1) === false) return rawFieldValue;
        if ([
            (0, $d64f2254b548006a$export$2e2bcd8739ae039).MesgNum.DEVELOPER_DATA_ID,
            (0, $d64f2254b548006a$export$2e2bcd8739ae039).MesgNum.FIELD_DESCRIPTION
        ].includes(messageDefinition.globalMessageNumber)) return rawFieldValue;
        if (rawFieldValue == null) return rawFieldValue;
        if (Array.isArray(field?.scale ?? 1) && field.scale.length > 1) return rawFieldValue;
        const scale = Array.isArray(field?.scale ?? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_SCALE) ? field?.scale[0] : field?.scale ?? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_SCALE;
        const offset = Array.isArray(field?.offset ?? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_OFFSET) ? field?.offset[0] : field?.offset ?? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_OFFSET;
        try {
            if (Array.isArray(rawFieldValue)) return rawFieldValue.map((value)=>{
                return value == null ? value : value / scale - offset;
            });
            return rawFieldValue / scale - offset;
        } catch  {
            return rawFieldValue;
        }
    }
    #setAccumulatedField(messageDefinition, message, field, rawFieldValue) {
        const rawFieldValues = Array.isArray(rawFieldValue) ? rawFieldValue : [
            rawFieldValue
        ];
        rawFieldValues.forEach((value)=>{
            Object.values(message).forEach((containingField)=>{
                let components = messageDefinition.fields[containingField.fieldDefinitionNumber].components ?? [];
                components.forEach((componentFieldNum, i)=>{
                    const targetField = messageDefinition.fields[componentFieldNum];
                    if (targetField?.num == field.num && targetField?.isAccumulated) value = (value / field.scale - field.offset + containingField.offset[i]) * containingField.scale[i];
                });
            });
            this.#accumulator.createAccumulatedField(messageDefinition.num, field.num, value);
        });
    }
    #convertTypeToString(messageDefinition, field, rawFieldValue) {
        if ([
            (0, $d64f2254b548006a$export$2e2bcd8739ae039).MesgNum.DEVELOPER_DATA_ID,
            (0, $d64f2254b548006a$export$2e2bcd8739ae039).MesgNum.FIELD_DESCRIPTION
        ].includes(messageDefinition.globalMessageNumber)) return rawFieldValue;
        if ((0, $6fb08636b36a917e$export$2e2bcd8739ae039).NumericFieldTypes.includes(field?.type ?? -1)) return rawFieldValue;
        try {
            const type = (0, $d64f2254b548006a$export$2e2bcd8739ae039).types[field?.type ?? -1];
            if (Array.isArray(rawFieldValue)) return rawFieldValue.map((value)=>{
                return value == null ? value : type?.[value] ?? value;
            });
            return type?.[rawFieldValue] ?? rawFieldValue;
        } catch  {
            return rawFieldValue;
        }
    }
    #lookupSubfield(field, name) {
        const subField = field.subFields.find((subField)=>subField.name === name);
        return subField != null ? subField : {};
    }
    static #readFileHeader(stream, { resetPosition: resetPosition = false, decodeMode: decodeMode = $9a417e2fdf8841c7$var$DecodeMode.NORMAL }) {
        const position = stream.position;
        if (decodeMode !== $9a417e2fdf8841c7$var$DecodeMode.NORMAL) {
            if (decodeMode === $9a417e2fdf8841c7$var$DecodeMode.SKIP_HEADER) stream.seek($9a417e2fdf8841c7$var$HEADER_WITH_CRC_SIZE);
            const headerSize = decodeMode === $9a417e2fdf8841c7$var$DecodeMode.SKIP_HEADER ? $9a417e2fdf8841c7$var$HEADER_WITH_CRC_SIZE : 0;
            return {
                headerSize: headerSize,
                dataSize: stream.length - headerSize - $9a417e2fdf8841c7$var$CRC_SIZE
            };
        }
        const fileHeader = {
            headerSize: stream.readByte(),
            protocolVersion: stream.readByte(),
            profileVersion: stream.readUInt16(),
            dataSize: stream.readUInt32(),
            dataType: stream.readString(4),
            headerCRC: 0
        };
        if (fileHeader.headerSize === 14) fileHeader.headerCRC = stream.readUInt16();
        if (resetPosition) stream.seek(position);
        return fileHeader;
    }
    #throwError(error = "") {
        throw Error(`FIT Runtime Error at byte ${this.#stream.position} ${error}`.trimEnd());
    }
}
var $9a417e2fdf8841c7$export$2e2bcd8739ae039 = $9a417e2fdf8841c7$var$Decoder;


/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////


const $ca3b752a95c10397$var$textEncoder = new TextEncoder();
class $ca3b752a95c10397$var$MesgDefinition {
    globalMessageNumber;
    localMesgNum;
    fieldDefinitions = [];
    developerFieldDefinitions = [];
    constructor(mesgNum, mesg, { fieldDescriptions: fieldDescriptions = null } = {}){
        try {
            if (mesg == null) throw new Error("mesg is missing or null");
            if (mesgNum == null) throw new Error("mesgNum is missing or null");
            const mesgProfile = (0, $d64f2254b548006a$export$2e2bcd8739ae039).messages[mesgNum];
            if (mesgProfile == null) throw new Error(`mesgNum: ${mesgNum} could not be found in the Profile`);
            this.globalMessageNumber = mesgNum;
            this.localMesgNum = 0;
            Object.keys(mesg).forEach((fieldName)=>{
                if (mesg[fieldName] == null) return;
                const fieldProfile = Object.entries(mesgProfile.fields).find(([, fieldProfile])=>{
                    return fieldProfile.name === fieldName;
                });
                if (fieldProfile == null) return;
                const baseType = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FieldTypeToBaseType[fieldProfile[1].baseType];
                const baseTypeDef = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[baseType];
                let scale = fieldProfile[1].components.length > 1 ? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_SCALE : fieldProfile[1].scale;
                let offset = fieldProfile[1].components.length > 1 ? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_OFFSET : fieldProfile[1].offset;
                scale = Array.isArray(scale) ? scale[0] : scale ?? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_SCALE;
                offset = Array.isArray(offset) ? offset[0] : offset ?? (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_OFFSET;
                this.fieldDefinitions.push({
                    name: fieldName,
                    num: fieldProfile[1].num,
                    size: this.#fieldSize(mesg[fieldName], baseTypeDef),
                    baseType: baseType,
                    type: fieldProfile[1].type,
                    scale: scale,
                    offset: offset,
                    components: fieldProfile[1].components
                });
            });
            Object.keys(mesg.developerFields ?? {})?.sort()?.forEach((key)=>{
                const { developerDataIdMesg: developerDataIdMesg, fieldDescriptionMesg: fieldDescriptionMesg } = this.#fieldDescriptionForKey(fieldDescriptions, key);
                const baseTypeDef = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[fieldDescriptionMesg.fitBaseTypeId];
                this.developerFieldDefinitions.push({
                    key: key,
                    baseType: fieldDescriptionMesg.fitBaseTypeId,
                    fieldDefinitionNumber: fieldDescriptionMesg.fieldDefinitionNumber,
                    size: this.#fieldSize(mesg.developerFields[key], baseTypeDef),
                    developerDataIndex: developerDataIdMesg.developerDataIndex
                });
            });
            if (this.fieldDefinitions.length === 0) throw new Error("No valid fields were found in the message");
            if (this.fieldDefinitions.some((fieldDefinition)=>{
                return fieldDefinition.size > (0, $6fb08636b36a917e$export$2e2bcd8739ae039).MAX_FIELD_SIZE;
            })) throw new Error(`Some field sizes are greater than ${(0, $6fb08636b36a917e$export$2e2bcd8739ae039).MAX_FIELD_SIZE}`, {
                cause: this.fieldDefinitions
            });
        } catch (error) {
            throw new Error("Could not construct MesgDefinition from Message", {
                cause: {
                    cause: {
                        message: error.message,
                        cause: error.cause
                    }
                }
            });
        }
    }
    write(outputStream) {
        // Header
        let headerByte = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).MESG_DEFINITION_MASK | this.localMesgNum & (0, $6fb08636b36a917e$export$2e2bcd8739ae039).LOCAL_MESG_NUM_MASK;
        if (this.developerFieldDefinitions.length > 0) headerByte |= (0, $6fb08636b36a917e$export$2e2bcd8739ae039).DEV_DATA_MASK;
        outputStream.writeUInt8(headerByte);
        // Reserved Byte
        outputStream.writeUInt8(0x00);
        // Architecture
        outputStream.writeUInt8((0, $6fb08636b36a917e$export$2e2bcd8739ae039).ARCH_LITTLE_ENDIAN);
        // Global Message Number
        outputStream.writeUInt16(this.globalMessageNumber);
        // Field Count
        outputStream.writeUInt8(this.fieldDefinitions.length);
        // Field Definitions
        this.fieldDefinitions.forEach((fieldDefinition)=>{
            outputStream.writeUInt8(fieldDefinition.num);
            outputStream.writeUInt8(fieldDefinition.size);
            outputStream.writeUInt8(fieldDefinition.baseType);
        });
        // Developer Field Definitions
        if (this.developerFieldDefinitions.length > 0) {
            outputStream.writeUInt8(this.developerFieldDefinitions.length);
            this.developerFieldDefinitions.forEach((developerFieldDefinition)=>{
                outputStream.writeUInt8(developerFieldDefinition.fieldDefinitionNumber);
                outputStream.writeUInt8(developerFieldDefinition.size);
                outputStream.writeUInt8(developerFieldDefinition.developerDataIndex);
            });
        }
    }
    equals(other) {
        if (this.globalMessageNumber !== other.globalMessageNumber || this.fieldDefinitions.length !== other.fieldDefinitions.length || this.developerFieldDefinitions.length !== other.developerFieldDefinitions.length) return false;
        // Field Definitions
        for(let i = 0; i < this.fieldDefinitions.length; i++){
            const lhs = this.fieldDefinitions[i];
            if (null == other.fieldDefinitions.find((rhs)=>{
                return lhs.num === rhs.num && lhs.size === rhs.size && lhs.baseType === rhs.baseType;
            })) return false;
        }
        // Developer Field Definitions
        for(let i = 0; i < this.developerFieldDefinitions.length; i++){
            const lhs = this.developerFieldDefinitions[i];
            if (null == other.developerFieldDefinitions.find((rhs)=>{
                return lhs.fieldDefinitionNumber === rhs.fieldDefinitionNumber && lhs.size === rhs.size && lhs.developerDataIndex === rhs.developerDataIndex;
            })) return false;
        }
        return true;
    }
    #fieldSize(value, baseTypeDef) {
        const values = Array.isArray(value) ? value : [
            value
        ];
        if (baseTypeDef.type === (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.STRING) {
            const size = values.reduce((accumulator, currentValue)=>{
                return accumulator + $ca3b752a95c10397$var$textEncoder.encode(currentValue).length + 1;
            }, 0);
            return size;
        }
        return baseTypeDef.size * values.length;
    }
    /**
     * Look up the field description for the key, and validate the required fields.
     */ #fieldDescriptionForKey(fieldDescriptions, key) {
        try {
            if (fieldDescriptions == null) throw new Error("no developer data field descriptions provided", {
                cause: {
                    fieldDescriptions: fieldDescriptions
                }
            });
            const { developerDataIdMesg: developerDataIdMesg, fieldDescriptionMesg: fieldDescriptionMesg } = fieldDescriptions?.[key] ?? {};
            if (developerDataIdMesg == null || fieldDescriptionMesg == null) throw new Error(`could not find a developer field description for key ${key}`);
            const errors = [];
            if (fieldDescriptionMesg.fitBaseTypeId == null) errors.push(`fieldDescriptionMesg fitBaseTypeId is ${fieldDescriptionMesg.fitBaseTypeId}`);
            if (fieldDescriptionMesg.fieldDefinitionNumber == null) errors.push(`fieldDescriptionMesg fieldDefinitionNumber is ${fieldDescriptionMesg.fieldDefinitionNumber}`);
            if (fieldDescriptionMesg.developerDataIndex == null) errors.push(`fieldDescriptionMesg developerDataIndex is ${fieldDescriptionMesg.developerDataIndex}`);
            if (developerDataIdMesg.developerDataIndex == null) errors.push(`developerDataIdMesg developerDataIndex is ${developerDataIdMesg.developerDataIndex}`);
            if (developerDataIdMesg.developerDataIndex !== fieldDescriptionMesg.developerDataIndex) errors.push("developerDataIndex values do not match in fieldDescription" + ` ${developerDataIdMesg.developerDataIndex} != ${fieldDescriptionMesg.developerDataIndex}`);
            if (errors.length > 0) throw new Error("missing or invalid values in the fieldDescription,", {
                cause: {
                    developerDataIdMesg: developerDataIdMesg,
                    fieldDescriptionMesg: fieldDescriptionMesg,
                    cause: errors
                }
            });
            return {
                key: key,
                developerDataIdMesg: developerDataIdMesg,
                fieldDescriptionMesg: fieldDescriptionMesg
            };
        } catch (error) {
            throw new Error(`invalid field description for key ${key}`, {
                cause: {
                    key: key,
                    cause: {
                        message: error.message,
                        cause: error.cause
                    }
                }
            });
        }
    }
}
var $ca3b752a95c10397$export$2e2bcd8739ae039 = $ca3b752a95c10397$var$MesgDefinition;


/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2025 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.178.0Release
// Tag = production/release/21.178.0-0-g3bea629
/////////////////////////////////////////////////////////////////////////////////////////////

const $c15605d8e375b851$var$ONE_MEGABYTE = 1048576;
const $c15605d8e375b851$var$TEN_MEGABYTES = $c15605d8e375b851$var$ONE_MEGABYTE * 10;
const $c15605d8e375b851$var$HALF_MEGABYTE = $c15605d8e375b851$var$ONE_MEGABYTE / 2;
class $c15605d8e375b851$var$OutputStream {
    #arrayBuffer = null;
    #dataView = null;
    #byteOffset = 0;
    #resizeByBytes = 0;
    #baseTypeDefinitions = null;
    #textEncoder = new TextEncoder();
    /**
     * Creates an OutputStream
     * @constructor
     * @param {Object=} [options] - Read options (optional)
     * @param {Number} [options.initialByteLength=0.5MB] - (optional, default 0.5 MB)
     * @param {Number} [options.maxByteLength=2MB] - (optional, default 2 MB)
     * @param {Number} [options.resizeByBytes=0.5MB] - (optional, default 0.5 MB)
     */ constructor({ initialByteLength: initialByteLength = $c15605d8e375b851$var$HALF_MEGABYTE, maxByteLength: maxByteLength = $c15605d8e375b851$var$TEN_MEGABYTES, resizeByBytes: resizeByBytes = $c15605d8e375b851$var$HALF_MEGABYTE } = {}){
        this.#arrayBuffer = new ArrayBuffer(initialByteLength, {
            maxByteLength: maxByteLength
        });
        this.#dataView = new DataView(this.#arrayBuffer);
        this.#resizeByBytes = resizeByBytes;
        this.#baseTypeDefinitions = {
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.ENUM]: {
                setValue: this.#dataView.setUint8.bind(this.#dataView),
                size: 1,
                mask: 0xFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8]: {
                setValue: this.#dataView.setUint8.bind(this.#dataView),
                size: 1,
                mask: 0xFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT16]: {
                setValue: this.#dataView.setUint16.bind(this.#dataView),
                size: 2,
                mask: 0xFFFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT32]: {
                setValue: this.#dataView.setUint32.bind(this.#dataView),
                size: 4,
                mask: 0xFFFFFFFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT64]: {
                setValue: this.#dataView.setBigUint64.bind(this.#dataView),
                size: 8,
                mask: 0xFFFFFFFFFFFFFFFFn
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT8]: {
                setValue: this.#dataView.setInt8.bind(this.#dataView),
                size: 1,
                mask: 0xFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT16]: {
                setValue: this.#dataView.setInt16.bind(this.#dataView),
                size: 2,
                mask: 0xFFFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT32]: {
                setValue: this.#dataView.setInt32.bind(this.#dataView),
                size: 4,
                mask: 0xFFFFFFFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT64]: {
                setValue: this.#dataView.setBigInt64.bind(this.#dataView),
                size: 8,
                mask: 0xFFFFFFFFFFFFFFFFn
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT32]: {
                setValue: this.#dataView.setFloat32.bind(this.#dataView),
                size: 4
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT64]: {
                setValue: this.#dataView.setFloat64.bind(this.#dataView),
                size: 8
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8Z]: {
                setValue: this.#dataView.setUint8.bind(this.#dataView),
                size: 1,
                mask: 0xFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT16Z]: {
                setValue: this.#dataView.setUint16.bind(this.#dataView),
                size: 2,
                mask: 0xFFFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT32Z]: {
                setValue: this.#dataView.setUint32.bind(this.#dataView),
                size: 4,
                mask: 0xFFFFFFFF
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT64Z]: {
                setValue: this.#dataView.setBigUint64.bind(this.#dataView),
                size: 8,
                mask: 0xFFFFFFFFFFFFFFFFn
            },
            [(0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.BYTE]: {
                setValue: this.#dataView.setUint8.bind(this.#dataView),
                size: 1,
                mask: 0xFF
            }
        };
    }
    get length() {
        return this.#byteOffset;
    }
    get uint8Array() {
        return new Uint8Array(this.#arrayBuffer.slice(0, this.#byteOffset));
    }
    writeUInt8(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8);
    }
    writeUInt16(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT16);
    }
    writeUInt32(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT32);
    }
    writeUInt64(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT64);
    }
    writeSInt8(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT8);
    }
    writeSInt16(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT16);
    }
    writeSInt32(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT32);
    }
    writeSInt64(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.SINT64);
    }
    writeFloat32(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT32);
    }
    writeFloat64(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.FLOAT64);
    }
    writeUInt8z(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT8Z);
    }
    writeUInt16z(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT16Z);
    }
    writeUInt32z(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT32Z);
    }
    writeUInt64z(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.UINT64Z);
    }
    writeByte(value) {
        return this.write(value, (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.BYTE);
    }
    writeString(text) {
        const bytes = this.#textEncoder.encode(text);
        this.#resizeIfNeeded(bytes.byteLength);
        const uint8Array = new Uint8Array(this.#arrayBuffer, this.#byteOffset, bytes.byteLength);
        uint8Array.set(bytes);
        this.#byteOffset += bytes.byteLength;
        // Add a null terminator
        this.writeUInt8(0);
        return this;
    }
    write(value, baseType) {
        if (baseType === (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseType.STRING) return this.writeString(value);
        this.#setValues(baseType, value);
        return;
    }
    set(typedarray, targetOffset = 0) {
        this.#resizeIfNeeded(typedarray.byteLength + targetOffset);
        const uint8Array = new Uint8Array(this.#arrayBuffer);
        uint8Array.set(typedarray, targetOffset);
        this.#byteOffset = Math.max(this.#byteOffset, typedarray.byteLength + targetOffset);
        return this;
    }
    [Symbol.iterator]() {
        let start = 0;
        const end = this.#byteOffset;
        const dataView = this.#dataView;
        return {
            next () {
                if (start < end) return {
                    value: dataView.getUint8(start++),
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    }
    #setValues(baseType, value) {
        const values = Array.isArray(value) ? value : [
            value
        ];
        values.forEach((value)=>{
            return this.#setValue(baseType, value);
        });
    }
    #setValue(baseType, value) {
        const def = this.#baseTypeDefinitions[baseType];
        this.#resizeIfNeeded(def.size);
        const val = def.mask == null ? value : value & def.mask;
        def.setValue(this.#byteOffset, val, true);
        this.#byteOffset += def.size;
        return this;
    }
    #resizeIfNeeded(byteCount = 1) {
        if (this.#arrayBuffer.byteLength - this.#byteOffset >= byteCount) return;
        if (!this.#arrayBuffer.resizable) throw new Error("Can not resize OutputStream. Set a larger initial size.");
        this.#arrayBuffer.resize(this.#arrayBuffer.byteLength + Math.max(this.#resizeByBytes, byteCount));
    }
}
var $c15605d8e375b851$export$2e2bcd8739ae039 = $c15605d8e375b851$var$OutputStream;




const $5f5c23345e79f8cf$var$HEADER_WITH_CRC_SIZE = 14;
const $5f5c23345e79f8cf$var$HEADER_WITHOUT_CRC_SIZE = 12;
/**
 * A class for encoding FIT files.
 * @class
 */ class $5f5c23345e79f8cf$var$Encoder {
    /**
     Creates a FIT File Encoder
     * @param {Object} [options] - Encoder options (optional)
     * @param {Object.<number,{object, object }} [options.fieldDescriptions=null] - (optional, default null) fieldDescriptions
     * @constructor
     */ constructor({ fieldDescriptions: fieldDescriptions = null } = {}){
        this.#fieldDescriptions = {};
        for (const [key, { developerDataIdMesg: developerDataIdMesg, fieldDescriptionMesg: fieldDescriptionMesg }] of Object.entries(fieldDescriptions ?? {}))this.addDeveloperField(key, developerDataIdMesg, fieldDescriptionMesg);
        this.#writeEmptyFileHeader();
    }
    /**
     * Closes the encoder and returns the file data
     * @returns {Uint8Array} A Uint8Array containing the file data
     */ close() {
        this.#updateFileHeader();
        this.#writeFileCrc();
        return this.#outputStream.uint8Array;
    }
    /**
     * Encodes a mesg into the file.
     * @param {Object} mesg - The message data
     * @param {Number} mesg.mesgNum - The mesg number for this message
     * @return {this}
     */ writeMesg(mesg) {
        return this.onMesg(mesg.mesgNum, mesg);
    }
    /**
     * Encodes a mesg into the file.
     * This method can be used as a Decoder~mesgListener callback.
     * @param {Number} mesgNum - The message number for this message
     * @param {Object} mesg - The message data
     * @return {this}
     */ onMesg(mesgNum, mesg) {
        try {
            const mesgDefinition = this.#createMesgDefinition(mesgNum, mesg);
            this.#writeMesgDefinitionIfNotActive(mesgDefinition);
            // Write Message Header
            this.#outputStream.writeUInt8(mesgDefinition.localMesgNum);
            // Write Field Values
            mesgDefinition.fieldDefinitions.forEach((fieldDefinition)=>{
                const values = this.#transformValues(mesg[fieldDefinition.name], fieldDefinition);
                const baseTypeDef = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[fieldDefinition.baseType];
                this.#outputStream.write(values, baseTypeDef.type);
            });
            // Write Developer Field Values
            mesgDefinition.developerFieldDefinitions.forEach((developerFieldDefinition)=>{
                const values = this.#transformValues(mesg.developerFields[developerFieldDefinition.key], developerFieldDefinition);
                const baseTypeDef = (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[developerFieldDefinition.baseType];
                this.#outputStream.write(values, baseTypeDef.type);
            });
        } catch (error) {
            throw new Error("Could not write Message", {
                cause: {
                    mesg: mesg,
                    cause: {
                        message: error.message,
                        cause: error.cause
                    }
                }
            });
        }
        return this;
    }
    /**
     * Adds a Developer Data Field Description and associated Developer Data Id Message to the Endoder
     * This provides the Encoder with the context required to write Developer Fields to the output-stream.
     * *** This method does not write the messages to the output-stream ***
     * This method can be used as a Decoder~fieldDescriptionListener callback.
     * @param {Number} key - The message number for this message
     * @param {Object} developerDataIdMesg - The Developer Data Id mesg
     * @param {Object} fieldDescriptionMesg - The Field Description mesg
     * @return {this}
     */ addDeveloperField(key, developerDataIdMesg, fieldDescriptionMesg) {
        if (developerDataIdMesg.developerDataIndex == null || fieldDescriptionMesg.developerDataIndex == null) throw new Error("addDeveloperField() - one or more developerDataIndex values are null.", {
            cause: {
                key: key,
                developerDataIdMesg: developerDataIdMesg,
                fieldDescriptionMesg: fieldDescriptionMesg
            }
        });
        if (developerDataIdMesg.developerDataIndex !== fieldDescriptionMesg.developerDataIndex) throw new Error("addDeveloperField() - developerDataIndex values do not match.", {
            cause: {
                key: key,
                developerDataIdMesg: developerDataIdMesg,
                fieldDescriptionMesg: fieldDescriptionMesg
            }
        });
        this.#fieldDescriptions[key] = {
            developerDataIdMesg: developerDataIdMesg,
            fieldDescriptionMesg: fieldDescriptionMesg
        };
        return this;
    }
    #writeEmptyFileHeader() {
        Array($5f5c23345e79f8cf$var$HEADER_WITH_CRC_SIZE).fill(0).forEach((zero)=>{
            this.#outputStream.writeUInt8(zero);
        });
    }
    #updateFileHeader() {
        const arrayBuffer = new ArrayBuffer($5f5c23345e79f8cf$var$HEADER_WITH_CRC_SIZE);
        const dataView = new DataView(arrayBuffer);
        // Header Size
        dataView.setUint8(0, $5f5c23345e79f8cf$var$HEADER_WITH_CRC_SIZE);
        // Protocol Version
        dataView.setUint8(1, 2);
        // Profile Version
        dataView.setUint16(2, (0, $d64f2254b548006a$export$2e2bcd8739ae039).version.major * 1000 + (0, $d64f2254b548006a$export$2e2bcd8739ae039).version.minor, true);
        // Data Size
        dataView.setUint32(4, this.#outputStream.length - $5f5c23345e79f8cf$var$HEADER_WITH_CRC_SIZE, true);
        // Data Type ".FIT"
        dataView.setUint8(8, 0x2E);
        dataView.setUint8(9, 0x46);
        dataView.setUint8(10, 0x49);
        dataView.setUint8(11, 0x54);
        // Header CRC
        const crc = (0, $4883ab303b017428$export$2e2bcd8739ae039).calculateCRC(new Uint8Array(arrayBuffer), 0, $5f5c23345e79f8cf$var$HEADER_WITHOUT_CRC_SIZE);
        dataView.setUint16(12, crc, true);
        this.#outputStream.set(new Uint8Array(arrayBuffer));
    }
    #writeFileCrc() {
        const crc = (0, $4883ab303b017428$export$2e2bcd8739ae039).calculateCRC(this.#outputStream.uint8Array, 0, this.#outputStream.length);
        this.#outputStream.writeUInt16(crc);
    }
    #transformValues(value, fieldDefinition) {
        const values = Array.isArray(value) ? value : [
            value
        ];
        return values.map((value)=>{
            return this.#transformValue(value, fieldDefinition);
        });
    }
    #transformValue(value, fieldDefinition) {
        try {
            if ((0, $6fb08636b36a917e$export$2e2bcd8739ae039).isNotNumberStringDateOrBoolean(value)) return (0, $6fb08636b36a917e$export$2e2bcd8739ae039).BaseTypeDefinitions[fieldDefinition.baseType].invalid;
            // Is this a numeric field?
            if ((0, $6fb08636b36a917e$export$2e2bcd8739ae039).NumericFieldTypes.includes(fieldDefinition.type)) {
                if (!(0, $6fb08636b36a917e$export$2e2bcd8739ae039).isNumeric(value)) throw new Error();
                const hasScaleOrOffset = fieldDefinition.scale != (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_SCALE || fieldDefinition.offset != (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FIELD_DEFAULT_OFFSET;
                if (hasScaleOrOffset) {
                    const scaledValue = (value + fieldDefinition.offset) * fieldDefinition.scale;
                    return (0, $6fb08636b36a917e$export$2e2bcd8739ae039).FloatingPointFieldTypes.includes(fieldDefinition.type) ? scaledValue : Math.round(scaledValue);
                }
                return value;
            }
            // Is this a date_time field?
            if (fieldDefinition.type === "dateTime") {
                if ((0, $6fb08636b36a917e$export$2e2bcd8739ae039).isDate(value)) return (0, $519e72961d771fc4$export$2e2bcd8739ae039).convertDateToDateTime(value);
                if (!(0, $6fb08636b36a917e$export$2e2bcd8739ae039).isNumeric(value)) throw new Error();
                return value;
            }
            // Is this a string field
            if (fieldDefinition.type === "string") {
                if (!(0, $6fb08636b36a917e$export$2e2bcd8739ae039).isString(value)) throw new Error();
                return value;
            }
            // Must be a FIT type field
            if ((0, $6fb08636b36a917e$export$2e2bcd8739ae039).isNumeric(value)) return value;
            const profileType = (0, $d64f2254b548006a$export$2e2bcd8739ae039).types[fieldDefinition.type];
            const [typeValue] = Object.entries(profileType).find(([, typeValue])=>{
                return typeValue === value;
            });
            return typeValue;
        } catch  {
            throw new Error(`Could not convert "${value}" to "${fieldDefinition.type}"`, {
                cause: {
                    value: value,
                    fieldDefinition: fieldDefinition
                }
            });
        }
    }
    /**
     * Creates a MesgDefinition from the mesgNum and mesg.
     * @param {Number} mesgNum - The mesg number for this message
     * @param {Object} [mesg] - The message data
     * @return {MesgDefinition}
     */ #createMesgDefinition = (mesgNum, mesg)=>{
        const mesgDefinition = new (0, $ca3b752a95c10397$export$2e2bcd8739ae039)(mesgNum, mesg, {
            fieldDescriptions: this.#fieldDescriptions
        });
        mesgDefinition.localMesgNum = this.#lookupLocalMesgNum(mesgDefinition);
        return mesgDefinition;
    };
    /**
     * Searches the #localMesgDefinitions for a matching mesgDefinition
     * @param {Object} mesgDefinition - the mesg definition to match
     * @return The localMesgNum to be used with mesgDefinition
     */ #lookupLocalMesgNum = (mesgDefinition)=>{
        const localMesgNum = this.#localMesgDefinitions.findIndex((localMesgDefinition)=>{
            return localMesgDefinition?.equals(mesgDefinition) ?? false;
        });
        return (localMesgNum !== -1 ? localMesgNum : this.#nextLocalMesgNum++) & (0, $6fb08636b36a917e$export$2e2bcd8739ae039).LOCAL_MESG_NUM_MASK;
    };
    /**
     * Writes the mesgDefinition to the output stream, if it is not one of the currently active 16
     * @param {Object} mesgDefinition - the mesg definition to match
     * @return The localMesgNum to be used with mesgDefinition
     */ #writeMesgDefinitionIfNotActive = (mesgDefinition)=>{
        const localMesgNum = mesgDefinition.localMesgNum;
        if (this.#localMesgDefinitions[localMesgNum] == null || !this.#localMesgDefinitions[localMesgNum].equals(mesgDefinition)) this.#writeMesgDefinition(mesgDefinition);
        return localMesgNum;
    };
    /**
     * Writes the mesgDefinition to the output stream
     * @param {Object} mesgDefinition - the mesg definition to write
     * @return {this}
     */ #writeMesgDefinition(mesgDefinition) {
        mesgDefinition.write(this.#outputStream);
        this.#localMesgDefinitions[mesgDefinition.localMesgNum] = mesgDefinition;
        return this;
    }
    #localMesgDefinitions = Array(16).fill(null);
    #nextLocalMesgNum = 0;
    #outputStream = new (0, $c15605d8e375b851$export$2e2bcd8739ae039)();
    #fieldDescriptions = null;
}
var $5f5c23345e79f8cf$export$2e2bcd8739ae039 = $5f5c23345e79f8cf$var$Encoder;







function $ba78bcf4027a58ae$export$7c6fbe0aaa821023(arr) {
    // thanks https://www.geeksforgeeks.org/how-to-get-the-standard-deviation-of-an-array-of-numbers-using-javascript/
    // Creating the mean with Array.reduce
    const mean = arr.reduce((acc, curr)=>{
        return acc + curr;
    }, 0) / arr.length;
    // Assigning (value - mean) ^ 2 to
    // every array item
    arr = arr.map((k)=>{
        return (k - mean) ** 2;
    });
    // Calculating the sum of updated array 
    const sum = arr.reduce((acc, curr)=>acc + curr, 0);
    // Calculating the variance
    const variance = sum / arr.length;
    // Returning the standard deviation
    return Math.sqrt(sum / arr.length);
}
function $ba78bcf4027a58ae$export$1cb78577db373fdf(arr, mu) {
    return Math.sqrt(arr.reduce((s, x)=>s + (x - mu) ** 2, 0) / arr.length);
}


function $265d7365eca81a2e$export$2e2bcd8739ae039(velocity_in_ms, weight_in_grains) {
    //returns the kinetic energy
    const weight_in_kg = weight_in_grains / 15.432 / 1000;
    return (Math.round(0.5 * weight_in_kg * Math.pow(velocity_in_ms, 2) * 100) / 100).toFixed(2);
}


function $fbe7bf898f270681$var$nnf(number) {
    if (!number) return 0;
    else if (typeof number == 'number') return number;
    else if (typeof number == 'string') {
        if (number.replace(' ', '').length > 0) //parse a comma float string to a nice number float
        return parseFloat(number.toString().replace(',', '.'));
    }
    return 0;
}
var $fbe7bf898f270681$export$2e2bcd8739ae039 = $fbe7bf898f270681$var$nnf;


/** Generate CRC32 table once */ const $f86ba9a509d1cca0$var$CRC32_TABLE = (()=>{
    const table = new Uint32Array(256);
    for(let i = 0; i < 256; i++){
        let c = i;
        for(let k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[i] = c >>> 0;
    }
    return table;
})();
function $f86ba9a509d1cca0$export$1cd93882633e45f5(buffer) {
    const bytes = new Uint8Array(buffer);
    let crc = 4294967295;
    for(let i = 0; i < bytes.length; i++){
        const byte = bytes[i];
        crc = ($f86ba9a509d1cca0$var$CRC32_TABLE[(crc ^ byte) & 0xFF] ^ crc >>> 8) >>> 0;
    }
    return (crc ^ 0xFFFFFFFF) >>> 0;
}
function $f86ba9a509d1cca0$export$585b273162778445(buffer) {
    return $f86ba9a509d1cca0$export$1cd93882633e45f5(buffer).toString(16).padStart(8, '0');
} /** Example usage:
import { crc32, crc32Hex } from './checksum';
const buf = new TextEncoder().encode('hello').buffer;
console.log(crc32(buf)); // number
console.log(crc32Hex(buf)); // '3610a686' style hex
*/ 


async function $c91d22194aeccb79$export$2e2bcd8739ae039(fileData, ofilename) {
    return new Promise(async (resolve, reject)=>{
        const start = Date.now();
        const filename = ofilename.replace(/\.fit$/, '-xeroconv.csv');
        const checksum = (0, $f86ba9a509d1cca0$export$585b273162778445)(fileData);
        const streamfromFileSync = (0, $2b03d198a24d6ce0$export$2e2bcd8739ae039).fromArrayBuffer(fileData);
        const decoder = new (0, $9a417e2fdf8841c7$export$2e2bcd8739ae039)(streamfromFileSync);
        console.log("[fit2json]: " + ofilename + " isFIT (instance method): " + decoder.isFIT());
        console.log("[fit2json]: " + ofilename + " checkIntegrity: " + decoder.checkIntegrity());
        if (!(decoder.isFIT() && decoder.checkIntegrity())) {
            console.error("[fit2json]: " + ofilename + ' - not a working fit file.');
            return reject('Error: ' + ofilename + ' - not a working fit file.');
        }
        const { messages: messages, errors: errors } = decoder.read({
            //mesgListener: (messageNumber, message) => {},
            //applyScaleAndOffset: true,
            expandSubFields: true,
            expandComponents: true,
            convertTypesToStrings: true,
            convertDateTimesToDates: true,
            includeUnknownData: true
        });
        if (errors.length > 0) {
            console.error("[fit2json]: " + ofilename + " - Error found during reading.");
            return reject("Error" + ofilename + " - Error found during reading.");
        }
        if (!(Object.hasOwn(messages, 'chronoShotSessionMesgs') && Object.hasOwn(messages, 'chronoShotDataMesgs') && Object.hasOwn(messages, 'deviceInfoMesgs'))) {
            //showError("Error: " + ofilename + ' does not contain shot sessions file.');
            console.error("[fit2json]: " + ofilename + ' does not contain shot sessions.');
            return reject('Error: ' + ofilename + ' does not contain shot sessions.');
        }
        try {
            const DeviceData = messages.deviceInfoMesgs[0];
            const SessionData = messages.chronoShotSessionMesgs[0];
            const speeds = messages.chronoShotDataMesgs.map((row)=>row.shotSpeed);
            const sd = (0, $ba78bcf4027a58ae$export$7c6fbe0aaa821023)(speeds);
            const es = SessionData.maxSpeed - SessionData.minSpeed;
            const unit_velocity = false;
            const unit_distance = false;
            const unit_energy = false;
            const unit_weight = false;
            console.log("[fit2json]: parsed " + ofilename + " in " + (Date.now() - start) + " milliseconds.");
            //resolve(values[0])
            return resolve({
                file: {
                    name: ofilename,
                    title: ofilename,
                    deviceid: DeviceData.manufacturer + '-' + DeviceData.serialNumber.toString(),
                    checksum: checksum
                },
                stats: {
                    shots_total: SessionData.shotCount,
                    speed_avg: SessionData.avgSpeed,
                    speed_max: SessionData.maxSpeed,
                    speed_min: SessionData.minSpeed,
                    speed_es: Math.round(es * 1000) / 1000,
                    speed_sd: Math.round(sd * 1000) / 1000,
                    projectile: SessionData.grainWeight,
                    timestamp: SessionData.timestamp.getTime(),
                    timezone: 0
                },
                units: {
                    velocity: unit_velocity,
                    distance: unit_distance,
                    energy: unit_energy,
                    weight: unit_weight
                },
                shots: messages.chronoShotDataMesgs.map((row)=>({
                        shotnumber: row.shotNum,
                        velocity: row.shotSpeed,
                        energy: (0, $fbe7bf898f270681$export$2e2bcd8739ae039)((0, $265d7365eca81a2e$export$2e2bcd8739ae039)(row.shotSpeed, SessionData.grainWeight)),
                        timestamp: row.timestamp.getTime()
                    }))
            });
        } catch (err) {
            console.error(err);
            if (Object.hasOwn(err, 'message')) return reject(err.message);
            else return reject(err);
        }
    });
}


/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ var $4293c27bcfbce771$exports = {};
"use strict";


var $3ee4f50b1ae43a89$require$Buffer = $4293c27bcfbce771$exports.Buffer;
var $3ee4f50b1ae43a89$var$XLSX = {};
$3ee4f50b1ae43a89$var$XLSX.version = '0.20.3';
var $3ee4f50b1ae43a89$var$current_codepage = 1200, $3ee4f50b1ae43a89$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $3ee4f50b1ae43a89$var$$cptable;
var $3ee4f50b1ae43a89$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $3ee4f50b1ae43a89$var$CS2CP = {
    0: 1252,
    /* ANSI */ 1: 65001,
    /* DEFAULT */ 2: 65001,
    /* SYMBOL */ 77: 10000,
    /* MAC */ 128: 932,
    /* SHIFTJIS */ 129: 949,
    /* HANGUL */ 130: 1361,
    /* JOHAB */ 134: 936,
    /* GB2312 */ 136: 950,
    /* CHINESEBIG5 */ 161: 1253,
    /* GREEK */ 162: 1254,
    /* TURKISH */ 163: 1258,
    /* VIETNAMESE */ 177: 1255,
    /* HEBREW */ 178: 1256,
    /* ARABIC */ 186: 1257,
    /* BALTIC */ 204: 1251,
    /* RUSSIAN */ 222: 874,
    /* THAI */ 238: 1250,
    /* EASTEUROPE */ 255: 1252,
    /* OEM */ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$set_ansi = function(cp /*:number*/ ) {
    if ($3ee4f50b1ae43a89$var$VALID_ANSI.indexOf(cp) == -1) return;
    $3ee4f50b1ae43a89$var$current_ansi = $3ee4f50b1ae43a89$var$CS2CP[0] = cp;
};
function $3ee4f50b1ae43a89$var$reset_ansi() {
    $3ee4f50b1ae43a89$var$set_ansi(1252);
}
var $3ee4f50b1ae43a89$var$set_cp = function(cp /*:number*/ ) {
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    $3ee4f50b1ae43a89$var$set_ansi(cp);
};
function $3ee4f50b1ae43a89$var$reset_cp() {
    $3ee4f50b1ae43a89$var$set_cp(1200);
    $3ee4f50b1ae43a89$var$reset_ansi();
}
function $3ee4f50b1ae43a89$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $3ee4f50b1ae43a89$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $3ee4f50b1ae43a89$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $3ee4f50b1ae43a89$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $3ee4f50b1ae43a89$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $3ee4f50b1ae43a89$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $3ee4f50b1ae43a89$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $3ee4f50b1ae43a89$export$58f247d16f363b86(cptable) {
    $3ee4f50b1ae43a89$var$$cptable = cptable;
    $3ee4f50b1ae43a89$var$set_cp = function(cp /*:number*/ ) {
        $3ee4f50b1ae43a89$var$current_codepage = cp;
        $3ee4f50b1ae43a89$var$set_ansi(cp);
    };
    $3ee4f50b1ae43a89$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, $3ee4f50b1ae43a89$var$char_codes(data.slice(2)));
        return data;
    };
    $3ee4f50b1ae43a89$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($3ee4f50b1ae43a89$var$current_codepage === 1200) return String.fromCharCode(x);
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $3ee4f50b1ae43a89$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_ansi, [
            x
        ])[0];
    };
    $3ee4f50b1ae43a89$var$cpdoit();
}
var $3ee4f50b1ae43a89$var$DENSE = null;
var $3ee4f50b1ae43a89$var$DIF_XL = true;
var $3ee4f50b1ae43a89$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $3ee4f50b1ae43a89$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $3ee4f50b1ae43a89$var$Base64_map.charAt(e1) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e2) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e3) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e4);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $3ee4f50b1ae43a89$var$Base64_map.charAt(e1) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e2) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e3) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e4);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$Base64_encode_arr(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input[i++];
        e1 = c1 >> 2;
        c2 = input[i++];
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input[i++];
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $3ee4f50b1ae43a89$var$Base64_map.charAt(e1) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e2) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e3) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e4);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    if (input.slice(0, 5) == "data:") {
        var i = input.slice(0, 1024).indexOf(";base64,");
        if (i > -1) input = input.slice(i + 8);
    }
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $3ee4f50b1ae43a89$var$has_buf = /*#__PURE__*/ function() {
    return typeof $3ee4f50b1ae43a89$require$Buffer !== 'undefined' && false;
}();
var $3ee4f50b1ae43a89$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $3ee4f50b1ae43a89$require$Buffer !== 'undefined') {
        var nbfs = !$3ee4f50b1ae43a89$require$Buffer.from;
        if (!nbfs) try {
            $3ee4f50b1ae43a89$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $3ee4f50b1ae43a89$require$Buffer(buf, enc) : new $3ee4f50b1ae43a89$require$Buffer(buf);
        } : $3ee4f50b1ae43a89$require$Buffer.from.bind($3ee4f50b1ae43a89$require$Buffer);
    }
    return function() {};
}();
var $3ee4f50b1ae43a89$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $3ee4f50b1ae43a89$require$Buffer === 'undefined') return false;
    var x = $3ee4f50b1ae43a89$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $3ee4f50b1ae43a89$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.alloc ? $3ee4f50b1ae43a89$require$Buffer.alloc(len) : new $3ee4f50b1ae43a89$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $3ee4f50b1ae43a89$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.allocUnsafe ? $3ee4f50b1ae43a89$require$Buffer.allocUnsafe(len) : new $3ee4f50b1ae43a89$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $3ee4f50b1ae43a89$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $3ee4f50b1ae43a89$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $3ee4f50b1ae43a89$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $3ee4f50b1ae43a89$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $3ee4f50b1ae43a89$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $3ee4f50b1ae43a89$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $3ee4f50b1ae43a89$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $3ee4f50b1ae43a89$var$bconcat = $3ee4f50b1ae43a89$var$has_buf ? function(bufs) {
    return $3ee4f50b1ae43a89$require$Buffer.concat(bufs.map(function(buf) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(buf) ? buf : $3ee4f50b1ae43a89$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($3ee4f50b1ae43a89$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $3ee4f50b1ae43a89$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $3ee4f50b1ae43a89$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $3ee4f50b1ae43a89$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
var $3ee4f50b1ae43a89$var$chr0 = /\u0000/g, $3ee4f50b1ae43a89$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $3ee4f50b1ae43a89$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $3ee4f50b1ae43a89$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill('0', d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill(' ', d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $3ee4f50b1ae43a89$var$fill(' ', d - t.length);
}
function $3ee4f50b1ae43a89$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill('0', d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill('0', d - t.length) + t;
}
var $3ee4f50b1ae43a89$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $3ee4f50b1ae43a89$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $3ee4f50b1ae43a89$var$p2_32 || v < -$3ee4f50b1ae43a89$var$p2_32) return $3ee4f50b1ae43a89$var$pad0r1(v, d);
    var i = Math.round(v);
    return $3ee4f50b1ae43a89$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $3ee4f50b1ae43a89$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $3ee4f50b1ae43a89$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $3ee4f50b1ae43a89$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $3ee4f50b1ae43a89$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $3ee4f50b1ae43a89$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $3ee4f50b1ae43a89$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $3ee4f50b1ae43a89$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $3ee4f50b1ae43a89$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $3ee4f50b1ae43a89$var$SSF_normalize_xl_unsafe(v /*:number*/ ) /*:number*/ {
    var s = v.toPrecision(16);
    if (s.indexOf("e") > -1) {
        var m = s.slice(0, s.indexOf("e"));
        m = m.indexOf(".") > -1 ? m.slice(0, m.slice(0, 2) == "0." ? 17 : 16) : m.slice(0, 15) + $3ee4f50b1ae43a89$var$fill("0", m.length - 15);
        return m + s.slice(s.indexOf("e"));
    }
    var n = s.indexOf(".") > -1 ? s.slice(0, s.slice(0, 2) == "0." ? 17 : 16) : s.slice(0, 15) + $3ee4f50b1ae43a89$var$fill("0", s.length - 15);
    return Number(n);
}
function $3ee4f50b1ae43a89$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    v = $3ee4f50b1ae43a89$var$SSF_normalize_xl_unsafe(v);
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $3ee4f50b1ae43a89$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $3ee4f50b1ae43a89$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $3ee4f50b1ae43a89$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $3ee4f50b1ae43a89$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $3ee4f50b1ae43a89$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $3ee4f50b1ae43a89$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $3ee4f50b1ae43a89$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $3ee4f50b1ae43a89$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    if (!isFinite(v)) return isNaN(v) ? "#NUM!" : "#DIV/0!";
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $3ee4f50b1ae43a89$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $3ee4f50b1ae43a89$var$SSF_large_exp(v);
    return $3ee4f50b1ae43a89$var$SSF_strip_decimal($3ee4f50b1ae43a89$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $3ee4f50b1ae43a89$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $3ee4f50b1ae43a89$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $3ee4f50b1ae43a89$var$SSF_format(14, $3ee4f50b1ae43a89$var$datenum(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $3ee4f50b1ae43a89$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $3ee4f50b1ae43a89$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val1, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val1.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val1.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $3ee4f50b1ae43a89$var$months[val1.m - 1][1];
                case 5:
                    return $3ee4f50b1ae43a89$var$months[val1.m - 1][0];
                default:
                    return $3ee4f50b1ae43a89$var$months[val1.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $3ee4f50b1ae43a89$var$days[val1.q][0];
                default:
                    return $3ee4f50b1ae43a89$var$days[val1.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val1.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val1.u === 0 && (fmt == "s" || fmt == "ss")) return $3ee4f50b1ae43a89$var$pad0(val1.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val1.S + val1.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $3ee4f50b1ae43a89$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val1.D * 24 + val1.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val1.D * 24 + val1.H) * 60 + val1.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val1.D * 24 + val1.H) * 60 + val1.M) * 60 + (ss0 == 0 ? Math.round(val1.S + val1.u) : val1.S);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $3ee4f50b1ae43a89$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $3ee4f50b1ae43a89$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $3ee4f50b1ae43a89$var$pct1 = /%/g;
function $3ee4f50b1ae43a89$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($3ee4f50b1ae43a89$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $3ee4f50b1ae43a89$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $3ee4f50b1ae43a89$var$fill("%", mul);
}
function $3ee4f50b1ae43a89$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $3ee4f50b1ae43a89$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $3ee4f50b1ae43a89$var$write_num_exp(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $3ee4f50b1ae43a89$var$write_num_exp(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $3ee4f50b1ae43a89$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $3ee4f50b1ae43a89$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $3ee4f50b1ae43a89$var$fill(" ", r[1].length + 1 + r[4].length) : $3ee4f50b1ae43a89$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$pad0(myd, r[4].length));
}
function $3ee4f50b1ae43a89$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $3ee4f50b1ae43a89$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $3ee4f50b1ae43a89$var$dec1 = /^#*0*\.([0#]+)/;
var $3ee4f50b1ae43a89$var$closeparen = /\)[^)]*[0#]/;
var $3ee4f50b1ae43a89$var$phone = /\(###\) ###\\?-####/;
function $3ee4f50b1ae43a89$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$rnd(val1 /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val1 * dd) / dd;
}
function $3ee4f50b1ae43a89$var$dec(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val1 - Math.floor(val1), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $3ee4f50b1ae43a89$var$carry(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val1 - Math.floor(val1)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $3ee4f50b1ae43a89$var$flr(val1 /*:number*/ ) /*:string*/ {
    if (val1 < 2147483647 && val1 > -2147483648) return "" + (val1 >= 0 ? val1 | 0 : val1 - 1 | 0);
    return "" + Math.floor(val1);
}
function $3ee4f50b1ae43a89$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($3ee4f50b1ae43a89$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $3ee4f50b1ae43a89$var$write_num_flt('n', ffmt, val1);
        return '(' + $3ee4f50b1ae43a89$var$write_num_flt('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $3ee4f50b1ae43a89$var$write_num_cm(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $3ee4f50b1ae43a89$var$write_num_pct(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $3ee4f50b1ae43a89$var$write_num_exp(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $3ee4f50b1ae43a89$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $3ee4f50b1ae43a89$var$pad0r(val1, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($3ee4f50b1ae43a89$var$frac1)) return $3ee4f50b1ae43a89$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $3ee4f50b1ae43a89$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($3ee4f50b1ae43a89$var$dec1)) {
        o = $3ee4f50b1ae43a89$var$rnd(val1, r[1].length).replace(/^([^\.]+)$/, "$1." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.$/, "." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $3ee4f50b1ae43a89$var$fill("0", $3ee4f50b1ae43a89$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $3ee4f50b1ae43a89$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, -val1) : $3ee4f50b1ae43a89$var$commaify("" + (Math.floor(val1) + $3ee4f50b1ae43a89$var$carry(val1, r[1].length))) + "." + $3ee4f50b1ae43a89$var$pad0($3ee4f50b1ae43a89$var$dec(val1, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $3ee4f50b1ae43a89$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($3ee4f50b1ae43a89$var$phone)) {
        o = $3ee4f50b1ae43a89$var$write_num_flt(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $3ee4f50b1ae43a89$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $3ee4f50b1ae43a89$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $3ee4f50b1ae43a89$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $3ee4f50b1ae43a89$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$rpad_(ff[2], ri) : $3ee4f50b1ae43a89$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $3ee4f50b1ae43a89$var$pad0r(val1, 0);
        if (fmt.length <= o.length) return o;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $3ee4f50b1ae43a89$var$dec(val1, r[1].length);
        return val1 < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, -val1) : $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$flr(val1)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $3ee4f50b1ae43a89$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $3ee4f50b1ae43a89$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "#,##0.00", val1);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "###,##0.00", val1).replace(/^0\./, ".");
        case "#,###.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "#,##0.00", val1).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $3ee4f50b1ae43a89$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $3ee4f50b1ae43a89$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $3ee4f50b1ae43a89$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($3ee4f50b1ae43a89$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $3ee4f50b1ae43a89$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $3ee4f50b1ae43a89$var$fill("%", mul);
}
function $3ee4f50b1ae43a89$var$write_num_exp2(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $3ee4f50b1ae43a89$var$write_num_exp2(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $3ee4f50b1ae43a89$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($3ee4f50b1ae43a89$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $3ee4f50b1ae43a89$var$write_num_int('n', ffmt, val1);
        return '(' + $3ee4f50b1ae43a89$var$write_num_int('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $3ee4f50b1ae43a89$var$write_num_cm2(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $3ee4f50b1ae43a89$var$write_num_pct2(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $3ee4f50b1ae43a89$var$write_num_exp2(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $3ee4f50b1ae43a89$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val1;
        if (val1 === 0) o = "";
        return o.length > fmt.length ? o : $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($3ee4f50b1ae43a89$var$frac1)) return $3ee4f50b1ae43a89$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $3ee4f50b1ae43a89$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($3ee4f50b1ae43a89$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val1).replace(/^([^\.]+)$/, "$1." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.$/, "." + $3ee4f50b1ae43a89$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $3ee4f50b1ae43a89$var$fill("0", $3ee4f50b1ae43a89$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $3ee4f50b1ae43a89$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt, -val1) : $3ee4f50b1ae43a89$var$commaify("" + val1) + "." + $3ee4f50b1ae43a89$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $3ee4f50b1ae43a89$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($3ee4f50b1ae43a89$var$phone)) {
        o = $3ee4f50b1ae43a89$var$write_num_int(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $3ee4f50b1ae43a89$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $3ee4f50b1ae43a89$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $3ee4f50b1ae43a89$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $3ee4f50b1ae43a89$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$rpad_(ff[2], ri) : $3ee4f50b1ae43a89$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val1;
        if (fmt.length <= o.length) return o;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val1 < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt, -val1) : $3ee4f50b1ae43a89$var$commaify("" + val1).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $3ee4f50b1ae43a89$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $3ee4f50b1ae43a89$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $3ee4f50b1ae43a89$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $3ee4f50b1ae43a89$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val1) + $3ee4f50b1ae43a89$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $3ee4f50b1ae43a89$var$write_num(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    return (val1 | 0) === val1 ? $3ee4f50b1ae43a89$var$write_num_int(type, fmt, val1) : $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, val1);
}
function $3ee4f50b1ae43a89$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $3ee4f50b1ae43a89$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $3ee4f50b1ae43a89$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($3ee4f50b1ae43a89$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($3ee4f50b1ae43a89$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$3ee4f50b1ae43a89$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($3ee4f50b1ae43a89$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$3ee4f50b1ae43a89$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) {
                ss0 = Math.max(ss0, ssm[0].length - 1);
                bt = 4;
            }
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'e':
            lst = out[i].t;
            break;
        case 'M':
            lst = out[i].t;
            if (bt < 2) bt = 2;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ var _dt;
    switch(bt){
        case 0:
            break;
        case 1:
        case 2:
        case 3:
            if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
        case 4:
            switch(ss0){
                case 1:
                    dt.u = Math.round(dt.u * 10) / 10;
                    break;
                case 2:
                    dt.u = Math.round(dt.u * 100) / 100;
                    break;
                case 3:
                    dt.u = Math.round(dt.u * 1000) / 1000;
                    break;
            }
            if (dt.u >= 1) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $3ee4f50b1ae43a89$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $3ee4f50b1ae43a89$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $3ee4f50b1ae43a89$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $3ee4f50b1ae43a89$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $3ee4f50b1ae43a89$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $3ee4f50b1ae43a89$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $3ee4f50b1ae43a89$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $3ee4f50b1ae43a89$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    /* NOTE: most spreadsheet software do not support NaN or infinities */ if (typeof v === "number" && !isFinite(v)) v = 0;
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($3ee4f50b1ae43a89$var$cfregex2);
        var m2 = fmt[1].match($3ee4f50b1ae43a89$var$cfregex2);
        return $3ee4f50b1ae43a89$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $3ee4f50b1ae43a89$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $3ee4f50b1ae43a89$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $3ee4f50b1ae43a89$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$3ee4f50b1ae43a89$var$SSF_default_map[fmt]] || $3ee4f50b1ae43a89$var$table_fmt[$3ee4f50b1ae43a89$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $3ee4f50b1ae43a89$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($3ee4f50b1ae43a89$var$SSF_isgeneral(sfmt, 0)) return $3ee4f50b1ae43a89$var$SSF_general(v, o);
    if (v instanceof Date) v = $3ee4f50b1ae43a89$var$datenum(v, o.date1904);
    var f = $3ee4f50b1ae43a89$var$choose_fmt(sfmt, v);
    if ($3ee4f50b1ae43a89$var$SSF_isgeneral(f[1])) return $3ee4f50b1ae43a89$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    else if (isNaN(v) && f[1].indexOf("0") > -1) return "#NUM!";
    else if (!isFinite(v) && f[1].indexOf("0") > -1) return "#DIV/0!";
    return $3ee4f50b1ae43a89$var$eval_fmt(f[1], v, o, f[0]);
}
function $3ee4f50b1ae43a89$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($3ee4f50b1ae43a89$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($3ee4f50b1ae43a89$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $3ee4f50b1ae43a89$var$table_fmt[idx] = fmt;
    return idx;
}
function $3ee4f50b1ae43a89$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $3ee4f50b1ae43a89$var$SSF_load(tbl[i], i);
}
function $3ee4f50b1ae43a89$var$make_ssf() {
    $3ee4f50b1ae43a89$var$table_fmt = $3ee4f50b1ae43a89$var$SSF_init_table();
}
var $3ee4f50b1ae43a89$export$40d8edd678456c2b = {
    format: $3ee4f50b1ae43a89$var$SSF_format,
    load: $3ee4f50b1ae43a89$var$SSF_load,
    _table: $3ee4f50b1ae43a89$var$table_fmt,
    load_table: $3ee4f50b1ae43a89$var$SSF_load_table,
    parse_date_code: $3ee4f50b1ae43a89$var$SSF_parse_date_code,
    is_date: $3ee4f50b1ae43a89$var$fmt_is_date,
    get_table: function get_table() {
        return $3ee4f50b1ae43a89$export$40d8edd678456c2b._table = $3ee4f50b1ae43a89$var$table_fmt;
    }
};
var $3ee4f50b1ae43a89$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $3ee4f50b1ae43a89$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $3ee4f50b1ae43a89$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $3ee4f50b1ae43a89$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($3ee4f50b1ae43a89$var$dateNFregex, "(\\d+)");
    $3ee4f50b1ae43a89$var$dateNFregex.lastIndex = 0;
    return new RegExp("^" + fmt + "$");
}
function $3ee4f50b1ae43a89$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($3ee4f50b1ae43a89$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    $3ee4f50b1ae43a89$var$dateNFregex.lastIndex = 0;
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $3ee4f50b1ae43a89$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $3ee4f50b1ae43a89$var$SSF__load(fmt, idx) {
    return $3ee4f50b1ae43a89$var$SSF_load($3ee4f50b1ae43a89$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $3ee4f50b1ae43a89$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /*::
type CRC32TableType = Array<number> | Int32Array;
*/ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:?number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $3ee4f50b1ae43a89$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val1 = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val1.setMilliseconds(0);
        val1.setFullYear(ymd + 1980);
        val1.setMonth(m - 1);
        val1.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val1.setHours(hms);
        val1.setMinutes(M);
        val1.setSeconds(S << 1);
        return val1;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $3ee4f50b1ae43a89$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $3ee4f50b1ae43a89$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $3ee4f50b1ae43a89$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $3ee4f50b1ae43a89$var$new_buf(0);
        return $3ee4f50b1ae43a89$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $3ee4f50b1ae43a89$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($3ee4f50b1ae43a89$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $3ee4f50b1ae43a89$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $3ee4f50b1ae43a89$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $3ee4f50b1ae43a89$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $3ee4f50b1ae43a89$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $3ee4f50b1ae43a89$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $3ee4f50b1ae43a89$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $3ee4f50b1ae43a89$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($3ee4f50b1ae43a89$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $3ee4f50b1ae43a89$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($3ee4f50b1ae43a89$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $3ee4f50b1ae43a89$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $3ee4f50b1ae43a89$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 31) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 31));
                _nm = _nm.slice(0, 31);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($3ee4f50b1ae43a89$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($3ee4f50b1ae43a89$var$chr1);
        UCPath = UCPath.replace($3ee4f50b1ae43a89$var$chr0, '');
        if (m) UCPath = UCPath.replace($3ee4f50b1ae43a89$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($3ee4f50b1ae43a89$var$chr1, '!') : UCFullPaths[w]).replace($3ee4f50b1ae43a89$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($3ee4f50b1ae43a89$var$chr1, '!') : UCPaths[w]).replace($3ee4f50b1ae43a89$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $3ee4f50b1ae43a89$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.isBuffer(o) ? o : $3ee4f50b1ae43a89$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $3ee4f50b1ae43a89$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($3ee4f50b1ae43a89$var$has_buf) {
            var o = $3ee4f50b1ae43a89$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $3ee4f50b1ae43a89$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $3ee4f50b1ae43a89$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $3ee4f50b1ae43a89$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = EF[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                blob.l += _csz;
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $3ee4f50b1ae43a89$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || Array.isArray(fi.content) && fi.content.length == 0 || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $3ee4f50b1ae43a89$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $3ee4f50b1ae43a89$var$CRC32.bstr(fi.content, 0) : $3ee4f50b1ae43a89$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $3ee4f50b1ae43a89$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $3ee4f50b1ae43a89$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $3ee4f50b1ae43a89$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $3ee4f50b1ae43a89$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $3ee4f50b1ae43a89$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $3ee4f50b1ae43a89$var$bconcat([
            $3ee4f50b1ae43a89$var$bconcat(out /*:any*/ ),
            $3ee4f50b1ae43a89$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $3ee4f50b1ae43a89$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $3ee4f50b1ae43a89$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^([^:]*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $3ee4f50b1ae43a89$var$ReadShift,
        CheckField: $3ee4f50b1ae43a89$var$CheckField,
        prep_blob: $3ee4f50b1ae43a89$var$prep_blob,
        bconcat: $3ee4f50b1ae43a89$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $3ee4f50b1ae43a89$var$_fs;
function $3ee4f50b1ae43a89$export$a48eb669e1768bcf(fs) {
    $3ee4f50b1ae43a89$var$_fs = fs;
}
/* normalize data for blob ctor */ function $3ee4f50b1ae43a89$var$blobify(data) {
    if (typeof data === "string") return $3ee4f50b1ae43a89$var$s2ab(data);
    if (Array.isArray(data)) return $3ee4f50b1ae43a89$var$a2u(data);
    return data;
}
/* write or download file */ function $3ee4f50b1ae43a89$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $3ee4f50b1ae43a89$var$_fs !== 'undefined' && $3ee4f50b1ae43a89$var$_fs.writeFileSync) return enc ? $3ee4f50b1ae43a89$var$_fs.writeFileSync(fname, payload, enc) : $3ee4f50b1ae43a89$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $3ee4f50b1ae43a89$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $3ee4f50b1ae43a89$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $3ee4f50b1ae43a89$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        } else if (typeof URL !== 'undefined' && !URL.createObjectURL && typeof chrome === 'object') {
            /* manifest v3 extensions -- no URL.createObjectURL */ var b64 = "data:application/octet-stream;base64," + $3ee4f50b1ae43a89$var$Base64_encode_arr(new Uint8Array($3ee4f50b1ae43a89$var$blobify(data)));
            return chrome.downloads.download({
                url: b64,
                filename: fname,
                saveAs: true
            });
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $3ee4f50b1ae43a89$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $3ee4f50b1ae43a89$var$read_binary(path /*:string*/ ) {
    if (typeof $3ee4f50b1ae43a89$var$_fs !== 'undefined') return $3ee4f50b1ae43a89$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $3ee4f50b1ae43a89$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $3ee4f50b1ae43a89$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $3ee4f50b1ae43a89$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $3ee4f50b1ae43a89$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $3ee4f50b1ae43a89$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $3ee4f50b1ae43a89$var$dnthresh = /*#__PURE__*/ Date.UTC(1899, 11, 30, 0, 0, 0); // -2209161600000
var $3ee4f50b1ae43a89$var$dnthresh1 = /*#__PURE__*/ Date.UTC(1899, 11, 31, 0, 0, 0); // -2209075200000
var $3ee4f50b1ae43a89$var$dnthresh2 = /*#__PURE__*/ Date.UTC(1904, 0, 1, 0, 0, 0); // -2209075200000
function $3ee4f50b1ae43a89$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    var res = (epoch - $3ee4f50b1ae43a89$var$dnthresh) / 86400000;
    if (date1904) {
        res -= 1462;
        return res < -1402 ? res - 1 : res;
    }
    return res < 60 ? res - 1 : res;
}
function $3ee4f50b1ae43a89$var$numdate(v /*:number*/ ) /*:Date|number*/ {
    if (v >= 60 && v < 61) return v;
    var out = new Date();
    out.setTime((v > 60 ? v : v + 1) * 86400000 + $3ee4f50b1ae43a89$var$dnthresh);
    return out;
}
/* ISO 8601 Duration */ function $3ee4f50b1ae43a89$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
/* Blame https://bugs.chromium.org/p/v8/issues/detail?id=7863 for the regexide */ var $3ee4f50b1ae43a89$var$pdre1 = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/; // HH:MM[:SS[.UUU]]
var $3ee4f50b1ae43a89$var$pdre2 = /^(\d+)-(\d+)-(\d+)$/; // YYYY-mm-dd
var $3ee4f50b1ae43a89$var$pdre3 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/; // YYYY-mm-dd(T or space)HH:MM[:SS[.UUU]], sans "Z"
/* parses a date string as a UTC date */ function $3ee4f50b1ae43a89$var$parseDate(str /*:string*/ , date1904 /*:boolean*/ ) /*:Date*/ {
    if (str instanceof Date) return str;
    var m = str.match($3ee4f50b1ae43a89$var$pdre1);
    if (m) return new Date((date1904 ? $3ee4f50b1ae43a89$var$dnthresh2 : $3ee4f50b1ae43a89$var$dnthresh1) + ((parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) * 60 + (m[3] ? parseInt(m[3].slice(1), 10) : 0)) * 1000 + (m[4] ? parseInt((m[4] + "000").slice(1, 4), 10) : 0));
    m = str.match($3ee4f50b1ae43a89$var$pdre2);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0));
    /* TODO: 1900-02-29T00:00:00.000 should return a flag to treat as a date code (affects xlml) */ m = str.match($3ee4f50b1ae43a89$var$pdre3);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] && parseInt(m[6].slice(1), 10) || 0, m[7] && parseInt((m[7] + "0000").slice(1, 4), 10) || 0));
    var d = new Date(str);
    return d;
}
function $3ee4f50b1ae43a89$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(arr)) {
        if (debomit && $3ee4f50b1ae43a89$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $3ee4f50b1ae43a89$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $3ee4f50b1ae43a89$var$utf8write($3ee4f50b1ae43a89$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $3ee4f50b1ae43a89$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $3ee4f50b1ae43a89$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [], i = 0;
    // this cascade is for the browsers and runtimes of antiquity (and for modern runtimes that lack TextEncoder)
    try {
        for(i = 0; i < arr.length - 65536; i += 65536)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 65536)));
        o.push(String.fromCharCode.apply(0, arr.slice(i)));
    } catch (e) {
        try {
            for(; i < arr.length - 16384; i += 16384)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 16384)));
            o.push(String.fromCharCode.apply(0, arr.slice(i)));
        } catch (e) {
            for(; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
        }
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $3ee4f50b1ae43a89$var$dup(o[k]);
    return out;
}
function $3ee4f50b1ae43a89$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $3ee4f50b1ae43a89$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(]([^()]*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $3ee4f50b1ae43a89$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
var $3ee4f50b1ae43a89$var$FDRE2 = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/;
var $3ee4f50b1ae43a89$var$FDISO = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/; // YYYY-mm-dd(T or space)HH:MM:SS[.UUU][Z]
/* TODO: 1904 adjustment */ var $3ee4f50b1ae43a89$var$utc_append_works = new Date("6/9/69 00:00 UTC").valueOf() == -17798400000;
function $3ee4f50b1ae43a89$var$fuzzytime1(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0));
}
function $3ee4f50b1ae43a89$var$fuzzytime2(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1], 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], 0, 0));
}
var $3ee4f50b1ae43a89$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $3ee4f50b1ae43a89$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    // See issue 2863 -- this is technically not supported in Excel but is otherwise useful
    if ($3ee4f50b1ae43a89$var$FDISO.test(s)) return s.indexOf("Z") == -1 ? $3ee4f50b1ae43a89$var$local_to_utc(new Date(s)) : new Date(s);
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($3ee4f50b1ae43a89$var$FDRE1);
    if (M) return $3ee4f50b1ae43a89$var$fuzzytime1(M);
    M = lnos.match($3ee4f50b1ae43a89$var$FDRE2);
    if (M) return $3ee4f50b1ae43a89$var$fuzzytime2(M);
    M = lnos.match($3ee4f50b1ae43a89$var$pdre3);
    if (M) return new Date(Date.UTC(+M[1], +M[2] - 1, +M[3], +M[4], +M[5], M[6] && parseInt(M[6].slice(1), 10) || 0, M[7] && parseInt((M[7] + "0000").slice(1, 4), 10) || 0));
    var o = new Date($3ee4f50b1ae43a89$var$utc_append_works && s.indexOf("UTC") == -1 ? s + " UTC" : s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $3ee4f50b1ae43a89$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\\ ]/)) return n;
    return o;
}
var $3ee4f50b1ae43a89$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $3ee4f50b1ae43a89$var$utc_to_local(utc) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds(), utc.getUTCMilliseconds());
}
function $3ee4f50b1ae43a89$var$local_to_utc(local) {
    return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds(), local.getMilliseconds()));
}
function $3ee4f50b1ae43a89$var$remove_doctype(str) {
    var preamble = str.slice(0, 1024);
    var si = preamble.indexOf("<!DOCTYPE");
    if (si == -1) return str;
    var m = str.match(/<[\w]/);
    if (!m) return str;
    return str.slice(0, si) + str.slice(m.index);
}
/* str.match(/<!--[\s\S]*?-->/g) --> str_match_ng(str, "<!--", "-->") */ function $3ee4f50b1ae43a89$var$str_match_ng(str, s, e) {
    var out = [];
    var si = str.indexOf(s);
    while(si > -1){
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        out.push(str.slice(si, ei + e.length));
        si = str.indexOf(s, ei + e.length);
    }
    return out.length > 0 ? out : null;
}
/* str.replace(/<!--[\s\S]*?-->/g, "") --> str_remove_ng(str, "<!--", "-->") */ function $3ee4f50b1ae43a89$var$str_remove_ng(str, s, e) {
    var out = [], last = 0;
    var si = str.indexOf(s);
    if (si == -1) return str;
    while(si > -1){
        out.push(str.slice(last, si));
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        if ((si = str.indexOf(s, last = ei + e.length)) == -1) out.push(str.slice(last));
    }
    return out.join("");
}
/* str.match(/<tag\b[^>]*?>([\s\S]*?)</tag>/) --> str_match_xml(str, "tag") */ var $3ee4f50b1ae43a89$var$xml_boundary = {
    " ": 1,
    "\t": 1,
    "\r": 1,
    "\n": 1,
    ">": 1
};
function $3ee4f50b1ae43a89$var$str_match_xml(str, tag) {
    var si = str.indexOf('<' + tag), w = tag.length + 1, L = str.length;
    while(si >= 0 && si <= L - w && !$3ee4f50b1ae43a89$var$xml_boundary[str.charAt(si + w)])si = str.indexOf('<' + tag, si + 1);
    if (si === -1) return null;
    var sf = str.indexOf(">", si + tag.length);
    if (sf === -1) return null;
    var et = "</" + tag + ">";
    var ei = str.indexOf(et, sf);
    if (ei == -1) return null;
    return [
        str.slice(si, ei + et.length),
        str.slice(sf + 1, ei)
    ];
}
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/) --> str_match_xml(str, "tag") */ var $3ee4f50b1ae43a89$var$str_match_xml_ns = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m = res[0].exec(str);
        if (!m) return null;
        var si = m.index;
        var sf = res[0].lastIndex;
        res[1].lastIndex = res[0].lastIndex;
        m = res[1].exec(str);
        if (!m) return null;
        var ei = m.index;
        var ef = res[1].lastIndex;
        return [
            str.slice(si, ef),
            str.slice(sf, ei)
        ];
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/g) --> str_match_xml_ns_g(str, "tag") */ var $3ee4f50b1ae43a89$var$str_match_xml_ns_g = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
var $3ee4f50b1ae43a89$var$str_remove_xml_ns_g = /*#__PURE__*/ function() {
    var str_remove_xml_ns_cache = {};
    return function str_remove_xml_ns_g(str, tag) {
        var out = [];
        var res = str_remove_xml_ns_cache[tag];
        if (!res) str_remove_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        var si = 0, ef = 0;
        while(m = res[0].exec(str)){
            si = m.index;
            out.push(str.slice(ef, si));
            ef = si;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            ef = res[1].lastIndex;
            res[0].lastIndex = res[1].lastIndex;
        }
        out.push(str.slice(ef));
        return out.length == 0 ? "" : out.join("");
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/gi) --> str_match_xml_ns_ig(str, "tag") */ var $3ee4f50b1ae43a89$var$str_match_xml_ig = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<' + tag + '\\b[^<>]*>', "ig"),
            new RegExp('</' + tag + '>', "ig")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
function $3ee4f50b1ae43a89$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $3ee4f50b1ae43a89$var$cc2str(data.content, true);
    if (data.data) return $3ee4f50b1ae43a89$var$debom(data.data);
    if (data.asNodeBuffer && $3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $3ee4f50b1ae43a89$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $3ee4f50b1ae43a89$var$debom($3ee4f50b1ae43a89$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $3ee4f50b1ae43a89$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $3ee4f50b1ae43a89$var$char_codes(data.data);
    if (data.asNodeBuffer && $3ee4f50b1ae43a89$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $3ee4f50b1ae43a89$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $3ee4f50b1ae43a89$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$getdatabin(data) : $3ee4f50b1ae43a89$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $3ee4f50b1ae43a89$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $3ee4f50b1ae43a89$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $3ee4f50b1ae43a89$var$getzipfile(zip, file /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $3ee4f50b1ae43a89$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdata($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdatastr($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdatabin($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$zipentries(zip) {
    var k = zip.FullPaths || $3ee4f50b1ae43a89$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $3ee4f50b1ae43a89$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (Array.isArray(content) && typeof content[0] == "string") content = content.join("");
        if (typeof content == "string") {
            var res;
            if ($3ee4f50b1ae43a89$var$has_buf) res = $3ee4f50b1ae43a89$var$Buffer_from(content);
            else res = $3ee4f50b1ae43a89$var$utf8decode(content);
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $3ee4f50b1ae43a89$var$zip_new() {
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new();
}
function $3ee4f50b1ae43a89$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $3ee4f50b1ae43a89$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $3ee4f50b1ae43a89$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $3ee4f50b1ae43a89$var$attregexg = /\s([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $3ee4f50b1ae43a89$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?<>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'"<>\s=]+))*\s*[\/\?]?>/mg, $3ee4f50b1ae43a89$var$tagregex2 = /<[^<>]*>/g;
var $3ee4f50b1ae43a89$var$tagregex = /*#__PURE__*/ $3ee4f50b1ae43a89$var$XML_HEADER.match($3ee4f50b1ae43a89$var$tagregex1) ? $3ee4f50b1ae43a89$var$tagregex1 : $3ee4f50b1ae43a89$var$tagregex2;
var $3ee4f50b1ae43a89$var$nsregex = /<\w*:/, $3ee4f50b1ae43a89$var$nsregex2 = /<(\/?)\w+:/;
function $3ee4f50b1ae43a89$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $3ee4f50b1ae43a89$var$parsexmltagraw(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
        z[q] = v;
        if (!skip_LC) z[q.toLowerCase()] = v;
    }
    return z;
}
function $3ee4f50b1ae43a89$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($3ee4f50b1ae43a89$var$nsregex2, "<$1");
}
var $3ee4f50b1ae43a89$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $3ee4f50b1ae43a89$var$rencoding = /*#__PURE__*/ $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $3ee4f50b1ae43a89$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $3ee4f50b1ae43a89$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $3ee4f50b1ae43a89$var$decregex = /[&<>'"]/g, $3ee4f50b1ae43a89$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $3ee4f50b1ae43a89$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace($3ee4f50b1ae43a89$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $3ee4f50b1ae43a89$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $3ee4f50b1ae43a89$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $3ee4f50b1ae43a89$var$htmlcharegex = /[\u0000-\u001f]/g;
function $3ee4f50b1ae43a89$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($3ee4f50b1ae43a89$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $3ee4f50b1ae43a89$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace($3ee4f50b1ae43a89$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $3ee4f50b1ae43a89$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $3ee4f50b1ae43a89$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $3ee4f50b1ae43a89$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $3ee4f50b1ae43a89$var$utf8readb(data) {
    var out = $3ee4f50b1ae43a89$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $3ee4f50b1ae43a89$var$utf8readc(data) {
    return $3ee4f50b1ae43a89$var$Buffer_from(data, 'binary').toString('utf8');
}
var $3ee4f50b1ae43a89$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $3ee4f50b1ae43a89$var$utf8read = $3ee4f50b1ae43a89$var$has_buf && /*#__PURE__*/ ($3ee4f50b1ae43a89$var$utf8readc($3ee4f50b1ae43a89$var$utf8corpus) == /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8reada($3ee4f50b1ae43a89$var$utf8corpus) && $3ee4f50b1ae43a89$var$utf8readc || /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8readb($3ee4f50b1ae43a89$var$utf8corpus) == /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8reada($3ee4f50b1ae43a89$var$utf8corpus) && $3ee4f50b1ae43a89$var$utf8readb) || $3ee4f50b1ae43a89$var$utf8reada;
var $3ee4f50b1ae43a89$var$utf8write /*:StringConv*/  = $3ee4f50b1ae43a89$var$has_buf ? function(data) {
    return $3ee4f50b1ae43a89$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
var $3ee4f50b1ae43a89$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/(^|[^\t\n\r ])[\t\n\r ]+$/, "$1")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\b\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^<>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $3ee4f50b1ae43a89$var$vtvregex = /<\/?(?:vt:)?variant>/g, $3ee4f50b1ae43a89$var$vtmregex = /<(?:vt:)([^<"'>]*)>([\s\S]*)</;
function $3ee4f50b1ae43a89$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $3ee4f50b1ae43a89$var$parsexmltag(data);
    var matches /*:Array<string>*/  = $3ee4f50b1ae43a89$var$str_match_xml_ns_g(data, h.baseType) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($3ee4f50b1ae43a89$var$vtvregex, "").match($3ee4f50b1ae43a89$var$vtmregex);
        if (v) res.push({
            v: $3ee4f50b1ae43a89$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $3ee4f50b1ae43a89$var$wtregex = /(^\s|\s$|\n)/;
function $3ee4f50b1ae43a89$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($3ee4f50b1ae43a89$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $3ee4f50b1ae43a89$var$wxt_helper(h) /*:string*/ {
    return $3ee4f50b1ae43a89$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $3ee4f50b1ae43a89$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $3ee4f50b1ae43a89$var$wxt_helper(h) : "") + (g != null ? (g.match($3ee4f50b1ae43a89$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $3ee4f50b1ae43a89$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $3ee4f50b1ae43a89$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $3ee4f50b1ae43a89$var$writextag('vt:lpwstr', $3ee4f50b1ae43a89$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $3ee4f50b1ae43a89$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $3ee4f50b1ae43a89$var$escapexml(String(s)));
        case 'boolean':
            return $3ee4f50b1ae43a89$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $3ee4f50b1ae43a89$var$writextag('vt:filetime', $3ee4f50b1ae43a89$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $3ee4f50b1ae43a89$var$xlml_normalize(d) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $3ee4f50b1ae43a89$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $3ee4f50b1ae43a89$var$utf8read($3ee4f50b1ae43a89$var$a2s($3ee4f50b1ae43a89$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags, ODS uses invalid XML */ var $3ee4f50b1ae43a89$var$xlmlregex = /<([\/]?)([^\s?><!\/:"]*:|)([^\s?<>:\/"]+)(?:\s+[^<>=?"'\s]+="[^"]*?")*\s*[\/]?>/mg;
var $3ee4f50b1ae43a89$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $3ee4f50b1ae43a89$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $3ee4f50b1ae43a89$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $3ee4f50b1ae43a89$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $3ee4f50b1ae43a89$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $3ee4f50b1ae43a89$var$__toBuffer = $3ee4f50b1ae43a89$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $3ee4f50b1ae43a89$require$Buffer.isBuffer(bufs[0][0]) ? $3ee4f50b1ae43a89$require$Buffer.concat(bufs[0].map(function(x) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(x) ? x : $3ee4f50b1ae43a89$var$Buffer_from(x);
    })) : $3ee4f50b1ae43a89$var$___toBuffer(bufs);
} : $3ee4f50b1ae43a89$var$___toBuffer;
var $3ee4f50b1ae43a89$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt16LE(b, i)));
    return ss.join("").replace($3ee4f50b1ae43a89$var$chr0, '');
};
var $3ee4f50b1ae43a89$var$__utf16le = $3ee4f50b1ae43a89$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b) || !$3ee4f50b1ae43a89$var$buf_utf16le) return $3ee4f50b1ae43a89$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($3ee4f50b1ae43a89$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $3ee4f50b1ae43a89$var$___utf16le;
var $3ee4f50b1ae43a89$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $3ee4f50b1ae43a89$var$__hexlify = $3ee4f50b1ae43a89$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $3ee4f50b1ae43a89$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $3ee4f50b1ae43a89$var$___hexlify(b, s, l);
} : $3ee4f50b1ae43a89$var$___hexlify;
var $3ee4f50b1ae43a89$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt8(b, i)));
    return ss.join("");
};
var $3ee4f50b1ae43a89$var$__utf8 = $3ee4f50b1ae43a89$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $3ee4f50b1ae43a89$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $3ee4f50b1ae43a89$var$___utf8(b, s, e);
} : $3ee4f50b1ae43a89$var$___utf8;
var $3ee4f50b1ae43a89$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__lpstr = $3ee4f50b1ae43a89$var$___lpstr;
var $3ee4f50b1ae43a89$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__cpstr = $3ee4f50b1ae43a89$var$___cpstr;
var $3ee4f50b1ae43a89$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__lpwstr = $3ee4f50b1ae43a89$var$___lpwstr;
var $3ee4f50b1ae43a89$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $3ee4f50b1ae43a89$var$__lpp4 = $3ee4f50b1ae43a89$var$___lpp4;
var $3ee4f50b1ae43a89$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $3ee4f50b1ae43a89$var$__8lpp4 = $3ee4f50b1ae43a89$var$___8lpp4;
var $3ee4f50b1ae43a89$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $3ee4f50b1ae43a89$var$read_double_le(b, idx);
};
var $3ee4f50b1ae43a89$var$__double = $3ee4f50b1ae43a89$var$___double;
var $3ee4f50b1ae43a89$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($3ee4f50b1ae43a89$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $3ee4f50b1ae43a89$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $3ee4f50b1ae43a89$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $3ee4f50b1ae43a89$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b) || !$3ee4f50b1ae43a89$var$buf_utf16le) return $3ee4f50b1ae43a89$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $3ee4f50b1ae43a89$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b) || !$3ee4f50b1ae43a89$var$buf_utf16le) return $3ee4f50b1ae43a89$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $3ee4f50b1ae43a89$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $3ee4f50b1ae43a89$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $3ee4f50b1ae43a89$var$___double(b, i);
    };
    $3ee4f50b1ae43a89$var$is_buf = function is_buf_b(a) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $3ee4f50b1ae43a89$var$cpdoit() {
    $3ee4f50b1ae43a89$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($3ee4f50b1ae43a89$var$chr0, '');
    };
    $3ee4f50b1ae43a89$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $3ee4f50b1ae43a89$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $3ee4f50b1ae43a89$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined') $3ee4f50b1ae43a89$var$cpdoit();
var $3ee4f50b1ae43a89$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $3ee4f50b1ae43a89$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $3ee4f50b1ae43a89$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $3ee4f50b1ae43a89$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(this) && $3ee4f50b1ae43a89$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $3ee4f50b1ae43a89$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $3ee4f50b1ae43a89$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined') o = $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $3ee4f50b1ae43a89$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $3ee4f50b1ae43a89$var$__lpstr(this, this.l);
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $3ee4f50b1ae43a89$var$__cpstr(this, this.l);
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $3ee4f50b1ae43a89$var$__lpwstr(this, this.l);
            size = 4 + 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            o = $3ee4f50b1ae43a89$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            o = $3ee4f50b1ae43a89$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $3ee4f50b1ae43a89$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($3ee4f50b1ae43a89$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $3ee4f50b1ae43a89$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($3ee4f50b1ae43a89$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $3ee4f50b1ae43a89$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $3ee4f50b1ae43a89$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($3ee4f50b1ae43a89$var$_getchar($3ee4f50b1ae43a89$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined') {
                o = $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $3ee4f50b1ae43a89$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $3ee4f50b1ae43a89$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($3ee4f50b1ae43a89$var$_getchar($3ee4f50b1ae43a89$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $3ee4f50b1ae43a89$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $3ee4f50b1ae43a89$var$__readInt16LE : $3ee4f50b1ae43a89$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $3ee4f50b1ae43a89$var$__readInt32LE : $3ee4f50b1ae43a89$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $3ee4f50b1ae43a89$var$__double(this, this.l);
                        else oR = $3ee4f50b1ae43a89$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $3ee4f50b1ae43a89$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $3ee4f50b1ae43a89$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
    b[idx + 2] = val1 >>> 16 & 0xFF;
    b[idx + 3] = val1 >>> 24 & 0xFF;
};
var $3ee4f50b1ae43a89$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >> 8 & 0xFF;
    b[idx + 2] = val1 >> 16 & 0xFF;
    b[idx + 3] = val1 >> 24 & 0xFF;
};
var $3ee4f50b1ae43a89$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
};
function $3ee4f50b1ae43a89$var$WriteShift(t /*:number*/ , val1 /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)$3ee4f50b1ae43a89$var$__writeUInt16LE(this, val1.charCodeAt(i), this.l + 2 * i);
        size = 2 * val1.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined' && $3ee4f50b1ae43a89$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i){
                var cpp = $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_ansi, val1.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val1.length;
        } else if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_codepage, val1);
            /* replace null bytes with _ when relevant */ if (cpp.length == val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[i] == 0 && val1.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val1.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val1 = val1.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)this[this.l + i] = val1.charCodeAt(i) & 0xFF;
            size = val1.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val1.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val1.length, t); ++i){
            var cc = val1.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val1 & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 2] = val1 & 0xFF;
            break;
        case 4:
            size = 4;
            $3ee4f50b1ae43a89$var$__writeUInt32LE(this, val1, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $3ee4f50b1ae43a89$var$write_double_le(this, val1, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $3ee4f50b1ae43a89$var$__writeInt32LE(this, val1, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $3ee4f50b1ae43a89$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $3ee4f50b1ae43a89$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $3ee4f50b1ae43a89$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $3ee4f50b1ae43a89$var$ReadShift /*:: :any)*/ ;
    blob.chk = $3ee4f50b1ae43a89$var$CheckField;
    blob.write_shift = $3ee4f50b1ae43a89$var$WriteShift;
}
function $3ee4f50b1ae43a89$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $3ee4f50b1ae43a89$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $3ee4f50b1ae43a89$var$new_raw_buf(sz);
    $3ee4f50b1ae43a89$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $3ee4f50b1ae43a89$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $3ee4f50b1ae43a89$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $3ee4f50b1ae43a89$var$XLSBRecordEnum[RT] || $3ee4f50b1ae43a89$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $3ee4f50b1ae43a89$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $3ee4f50b1ae43a89$var$has_buf ? 16384 : 2048;
    var has_buf_copy = $3ee4f50b1ae43a89$var$has_buf && typeof $3ee4f50b1ae43a89$var$new_buf(blksz).copy == "function";
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $3ee4f50b1ae43a89$var$new_buf(sz);
        $3ee4f50b1ae43a89$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $3ee4f50b1ae43a89$var$bconcat(bufs);
    };
    var end2 = function() {
        endbuf();
        return bufs;
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs,
        end2: end2
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $3ee4f50b1ae43a89$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $3ee4f50b1ae43a89$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $3ee4f50b1ae43a89$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $3ee4f50b1ae43a89$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $3ee4f50b1ae43a89$var$shift_range_xls(cell, range, opts) {
    var out = $3ee4f50b1ae43a89$var$dup(cell);
    out.s = $3ee4f50b1ae43a89$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $3ee4f50b1ae43a89$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $3ee4f50b1ae43a89$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $3ee4f50b1ae43a89$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $3ee4f50b1ae43a89$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $3ee4f50b1ae43a89$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $3ee4f50b1ae43a89$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $3ee4f50b1ae43a89$var$fix_row(s);
    return s;
}
function $3ee4f50b1ae43a89$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(r.e.r);
    }
    return $3ee4f50b1ae43a89$var$encode_cell_xls(r.s, opts.biff) + ":" + $3ee4f50b1ae43a89$var$encode_cell_xls(r.e, opts.biff);
}
function $3ee4f50b1ae43a89$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($3ee4f50b1ae43a89$var$unfix_row(rowstr), 10) - 1;
}
function $3ee4f50b1ae43a89$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $3ee4f50b1ae43a89$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $3ee4f50b1ae43a89$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $3ee4f50b1ae43a89$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $3ee4f50b1ae43a89$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $3ee4f50b1ae43a89$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $3ee4f50b1ae43a89$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $3ee4f50b1ae43a89$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $3ee4f50b1ae43a89$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $3ee4f50b1ae43a89$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $3ee4f50b1ae43a89$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $3ee4f50b1ae43a89$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $3ee4f50b1ae43a89$var$decode_cell(range),
        e: $3ee4f50b1ae43a89$var$decode_cell(range)
    };
    return {
        s: $3ee4f50b1ae43a89$var$decode_cell(range.slice(0, idx)),
        e: $3ee4f50b1ae43a89$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $3ee4f50b1ae43a89$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $3ee4f50b1ae43a89$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $3ee4f50b1ae43a89$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $3ee4f50b1ae43a89$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $3ee4f50b1ae43a89$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $3ee4f50b1ae43a89$var$decode_range(a1);
    return "$" + $3ee4f50b1ae43a89$var$encode_col(s.s.c) + "$" + $3ee4f50b1ae43a89$var$encode_row(s.s.r) + ":$" + $3ee4f50b1ae43a89$var$encode_col(s.e.c) + "$" + $3ee4f50b1ae43a89$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $3ee4f50b1ae43a89$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $3ee4f50b1ae43a89$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $3ee4f50b1ae43a89$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, q ? $3ee4f50b1ae43a89$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $3ee4f50b1ae43a89$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $3ee4f50b1ae43a89$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $3ee4f50b1ae43a89$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $3ee4f50b1ae43a89$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $3ee4f50b1ae43a89$var$safe_format_cell(cell, cell.v);
    return $3ee4f50b1ae43a89$var$safe_format_cell(cell, v);
}
function $3ee4f50b1ae43a89$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $3ee4f50b1ae43a89$var$sheet_new(opts) {
    var out = {};
    var o = opts || {};
    if (o.dense) out["!data"] = [];
    return out;
}
function $3ee4f50b1ae43a89$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($3ee4f50b1ae43a89$var$DENSE != null && dense == null) dense = $3ee4f50b1ae43a89$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? {
        "!data": []
    } : {} /*:any*/ );
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = ws["!ref"] ? _range.e.r + 1 : 0;
    } else range.s.c = range.e.c = range.s.r = range.e.r = 0;
    var row = [], seen = false;
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R;
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        var data_R = data[R];
        for(var C = 0; C != data_R.length; ++C){
            if (typeof data_R[C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data_R[C],
                t: ""
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            seen = true;
            if (data_R[C] && typeof data_R[C] === 'object' && !Array.isArray(data_R[C]) && !(data_R[C] instanceof Date)) cell = data_R[C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data_R[C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') {
                    if (isFinite(cell.v)) cell.t = 'n';
                    else if (isNaN(cell.v)) {
                        cell.t = 'e';
                        cell.v = 0x0F; /* #VALUE! */ 
                    } else {
                        cell.t = 'e';
                        cell.v = 0x07; /*# DIV/0 */ 
                    }
                } else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                    if (!o.UTC) cell.v = $3ee4f50b1ae43a89$var$local_to_utc(cell.v);
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, $3ee4f50b1ae43a89$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $3ee4f50b1ae43a89$var$datenum(cell.v, o.date1904);
                        cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $3ee4f50b1ae43a89$var$encode_col(__C) + (__R + 1 /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (seen && range.s.c < 10400000) ws['!ref'] = $3ee4f50b1ae43a89$var$encode_range(range);
    return ws;
}
function $3ee4f50b1ae43a89$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $3ee4f50b1ae43a89$var$sheet_add_aoa(null, data, opts);
}
function $3ee4f50b1ae43a89$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $3ee4f50b1ae43a89$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $3ee4f50b1ae43a89$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $3ee4f50b1ae43a89$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $3ee4f50b1ae43a89$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $3ee4f50b1ae43a89$var$write_StrRun(run, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $3ee4f50b1ae43a89$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($3ee4f50b1ae43a89$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $3ee4f50b1ae43a89$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $3ee4f50b1ae43a89$var$parse_BrtCommentText = $3ee4f50b1ae43a89$var$parse_RichStr;
function $3ee4f50b1ae43a89$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $3ee4f50b1ae43a89$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $3ee4f50b1ae43a89$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $3ee4f50b1ae43a89$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $3ee4f50b1ae43a89$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $3ee4f50b1ae43a89$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $3ee4f50b1ae43a89$var$parse_XLSBCodeName = $3ee4f50b1ae43a89$var$parse_XLWideString;
var $3ee4f50b1ae43a89$var$write_XLSBCodeName = $3ee4f50b1ae43a89$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $3ee4f50b1ae43a89$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $3ee4f50b1ae43a89$var$parse_XLNameWideString = $3ee4f50b1ae43a89$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $3ee4f50b1ae43a89$var$parse_RelID = $3ee4f50b1ae43a89$var$parse_XLNullableWideString;
var $3ee4f50b1ae43a89$var$write_RelID = $3ee4f50b1ae43a89$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $3ee4f50b1ae43a89$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $3ee4f50b1ae43a89$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $3ee4f50b1ae43a89$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $3ee4f50b1ae43a89$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $3ee4f50b1ae43a89$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $3ee4f50b1ae43a89$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $3ee4f50b1ae43a89$var$parse_UncheckedRfX = $3ee4f50b1ae43a89$var$parse_RfX;
var $3ee4f50b1ae43a89$var$write_UncheckedRfX = $3ee4f50b1ae43a89$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $3ee4f50b1ae43a89$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $3ee4f50b1ae43a89$var$write_Xnum(data, o) {
    return (o || $3ee4f50b1ae43a89$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $3ee4f50b1ae43a89$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $3ee4f50b1ae43a89$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $3ee4f50b1ae43a89$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $3ee4f50b1ae43a89$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtColor(color, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $3ee4f50b1ae43a89$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $3ee4f50b1ae43a89$var$write_FontFlags(font, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrAnsiString(o) {
    return $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, 1);
}
function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $3ee4f50b1ae43a89$var$VT_I2 = 0x0002;
var $3ee4f50b1ae43a89$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $3ee4f50b1ae43a89$var$VT_BOOL = 0x000B;
var $3ee4f50b1ae43a89$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $3ee4f50b1ae43a89$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $3ee4f50b1ae43a89$var$VT_FILETIME = 0x0040;
var $3ee4f50b1ae43a89$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $3ee4f50b1ae43a89$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $3ee4f50b1ae43a89$var$VT_VECTOR_VARIANT = 0x100C;
var $3ee4f50b1ae43a89$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $3ee4f50b1ae43a89$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $3ee4f50b1ae43a89$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $3ee4f50b1ae43a89$var$VT_CUSTOM = [
    $3ee4f50b1ae43a89$var$VT_STRING,
    $3ee4f50b1ae43a89$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $3ee4f50b1ae43a89$var$DocSummaryPIDDSI = {
    0x01: {
        n: 'CodePage',
        t: $3ee4f50b1ae43a89$var$VT_I2
    },
    0x02: {
        n: 'Category',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x03: {
        n: 'PresentationFormat',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x04: {
        n: 'ByteCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x05: {
        n: 'LineCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x06: {
        n: 'ParagraphCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x07: {
        n: 'SlideCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x08: {
        n: 'NoteCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x09: {
        n: 'HiddenCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x0a: {
        n: 'MultimediaClipCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x0b: {
        n: 'ScaleCrop',
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    0x0c: {
        n: 'HeadingPairs',
        t: $3ee4f50b1ae43a89$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    0x0d: {
        n: 'TitlesOfParts',
        t: $3ee4f50b1ae43a89$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    0x0e: {
        n: 'Manager',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x0f: {
        n: 'Company',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x10: {
        n: 'LinksUpToDate',
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    0x11: {
        n: 'CharacterCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x13: {
        n: 'SharedDoc',
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    0x16: {
        n: 'HyperlinksChanged',
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    0x17: {
        n: 'AppVersion',
        t: $3ee4f50b1ae43a89$var$VT_I4,
        p: 'version'
    },
    0x18: {
        n: 'DigSig',
        t: $3ee4f50b1ae43a89$var$VT_BLOB
    },
    0x1A: {
        n: 'ContentType',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x1B: {
        n: 'ContentStatus',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x1C: {
        n: 'Language',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x1D: {
        n: 'Version',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $3ee4f50b1ae43a89$var$SummaryPIDSI = {
    0x01: {
        n: 'CodePage',
        t: $3ee4f50b1ae43a89$var$VT_I2
    },
    0x02: {
        n: 'Title',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x03: {
        n: 'Subject',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x04: {
        n: 'Author',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x05: {
        n: 'Keywords',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x06: {
        n: 'Comments',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x07: {
        n: 'Template',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x08: {
        n: 'LastAuthor',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x09: {
        n: 'RevNumber',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x0A: {
        n: 'EditTime',
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    0x0B: {
        n: 'LastPrinted',
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    0x0C: {
        n: 'CreatedDate',
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    0x0D: {
        n: 'ModifiedDate',
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    0x0E: {
        n: 'PageCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x0F: {
        n: 'WordCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x10: {
        n: 'CharCount',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0x11: {
        n: 'Thumbnail',
        t: $3ee4f50b1ae43a89$var$VT_CF
    },
    0x12: {
        n: 'Application',
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    0x13: {
        n: 'DocSecurity',
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $3ee4f50b1ae43a89$var$CountryEnum = {
    0x0001: "US",
    0x0002: "CA",
    0x0003: "",
    0x0007: "RU",
    0x0014: "EG",
    0x001E: "GR",
    0x001F: "NL",
    0x0020: "BE",
    0x0021: "FR",
    0x0022: "ES",
    0x0024: "HU",
    0x0027: "IT",
    0x0029: "CH",
    0x002B: "AT",
    0x002C: "GB",
    0x002D: "DK",
    0x002E: "SE",
    0x002F: "NO",
    0x0030: "PL",
    0x0031: "DE",
    0x0034: "MX",
    0x0037: "BR",
    0x003d: "AU",
    0x0040: "NZ",
    0x0042: "TH",
    0x0051: "JP",
    0x0052: "KR",
    0x0054: "VN",
    0x0056: "CN",
    0x005A: "TR",
    0x0069: "JS",
    0x00D5: "DZ",
    0x00D8: "MA",
    0x00DA: "LY",
    0x015F: "PT",
    0x0162: "IS",
    0x0166: "FI",
    0x01A4: "CZ",
    0x0376: "TW",
    0x03C1: "LB",
    0x03C2: "JO",
    0x03C3: "SY",
    0x03C4: "IQ",
    0x03C5: "KW",
    0x03C6: "SA",
    0x03CB: "AE",
    0x03CC: "IL",
    0x03CE: "QA",
    0x03D5: "IR",
    0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $3ee4f50b1ae43a89$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $3ee4f50b1ae43a89$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $3ee4f50b1ae43a89$var$_XLSIcv = /*#__PURE__*/ $3ee4f50b1ae43a89$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $3ee4f50b1ae43a89$var$XLSIcv = /*#__PURE__*/ $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $3ee4f50b1ae43a89$var$BErr = {
    0x00: "#NULL!",
    0x07: "#DIV/0!",
    0x0F: "#VALUE!",
    0x17: "#REF!",
    0x1D: "#NAME?",
    0x24: "#NUM!",
    0x2A: "#N/A",
    0x2B: "#GETTING_DATA",
    0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $3ee4f50b1ae43a89$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $3ee4f50b1ae43a89$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $3ee4f50b1ae43a89$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $3ee4f50b1ae43a89$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$parse_ct(data /*:?string*/ ) {
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0].replace($3ee4f50b1ae43a89$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$3ee4f50b1ae43a89$var$ct2type[y.ContentType]] !== undefined) ct[$3ee4f50b1ae43a89$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $3ee4f50b1ae43a89$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $3ee4f50b1ae43a89$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $3ee4f50b1ae43a89$var$evert_arr($3ee4f50b1ae43a89$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $3ee4f50b1ae43a89$var$XML_HEADER;
        o[o.length] = $3ee4f50b1ae43a89$var$writextag('Types', null, {
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS.CT,
            'xmlns:xsd': $3ee4f50b1ae43a89$var$XMLNS.xsd,
            'xmlns:xsi': $3ee4f50b1ae43a89$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $3ee4f50b1ae43a89$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $3ee4f50b1ae43a89$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $3ee4f50b1ae43a89$var$CT_LIST[w][opts.bookType] || $3ee4f50b1ae43a89$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $3ee4f50b1ae43a89$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $3ee4f50b1ae43a89$var$CT_LIST[w][opts.bookType] || $3ee4f50b1ae43a89$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $3ee4f50b1ae43a89$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $3ee4f50b1ae43a89$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $3ee4f50b1ae43a89$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $3ee4f50b1ae43a89$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $3ee4f50b1ae43a89$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $3ee4f50b1ae43a89$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_rels(rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS.RELS
        })
    ];
    $3ee4f50b1ae43a89$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $3ee4f50b1ae43a89$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $3ee4f50b1ae43a89$var$RELS.HLINK,
        $3ee4f50b1ae43a89$var$RELS.XPATH,
        $3ee4f50b1ae43a89$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $3ee4f50b1ae43a89$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $3ee4f50b1ae43a89$var$parse_manifest(d, opts) {
    var str = $3ee4f50b1ae43a89$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $3ee4f50b1ae43a89$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $3ee4f50b1ae43a89$var$write_manifest(manifest) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $3ee4f50b1ae43a89$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $3ee4f50b1ae43a89$var$write_rdf(rdf) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($3ee4f50b1ae43a89$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($3ee4f50b1ae43a89$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($3ee4f50b1ae43a89$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $3ee4f50b1ae43a89$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $3ee4f50b1ae43a89$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
function $3ee4f50b1ae43a89$var$parse_core_props(data) {
    var p = {};
    data = $3ee4f50b1ae43a89$var$utf8read(data);
    for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i], cur = $3ee4f50b1ae43a89$var$str_match_xml(data, f[0]);
        if (cur != null && cur.length > 0) p[f[1]] = $3ee4f50b1ae43a89$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $3ee4f50b1ae43a89$var$parseDate(p[f[1]]);
    }
    return p;
}
function $3ee4f50b1ae43a89$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $3ee4f50b1ae43a89$var$escapexml(g);
    o[o.length] = h ? $3ee4f50b1ae43a89$var$writextag(f, g, h) : $3ee4f50b1ae43a89$var$writetag(f, g);
}
function $3ee4f50b1ae43a89$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $3ee4f50b1ae43a89$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $3ee4f50b1ae43a89$var$XMLNS.dc,
            'xmlns:dcterms': $3ee4f50b1ae43a89$var$XMLNS.dcterms,
            'xmlns:dcmitype': $3ee4f50b1ae43a89$var$XMLNS.dcmitype,
            'xmlns:xsi': $3ee4f50b1ae43a89$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $3ee4f50b1ae43a89$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $3ee4f50b1ae43a89$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $3ee4f50b1ae43a89$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $3ee4f50b1ae43a89$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $3ee4f50b1ae43a89$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $3ee4f50b1ae43a89$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $3ee4f50b1ae43a89$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $3ee4f50b1ae43a89$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $3ee4f50b1ae43a89$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $3ee4f50b1ae43a89$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $3ee4f50b1ae43a89$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $3ee4f50b1ae43a89$var$utf8read(data);
    $3ee4f50b1ae43a89$var$EXT_PROPS.forEach(function(f) {
        var xml = ($3ee4f50b1ae43a89$var$str_match_xml_ns(data, f[0]) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $3ee4f50b1ae43a89$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = $3ee4f50b1ae43a89$var$str_match_xml(data, f[0]);
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $3ee4f50b1ae43a89$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $3ee4f50b1ae43a89$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $3ee4f50b1ae43a89$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $3ee4f50b1ae43a89$var$XML_HEADER;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag('Properties', null, {
        'xmlns': $3ee4f50b1ae43a89$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $3ee4f50b1ae43a89$var$XMLNS.vt
    });
    $3ee4f50b1ae43a89$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $3ee4f50b1ae43a89$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $3ee4f50b1ae43a89$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $3ee4f50b1ae43a89$var$custregex = /<[^<>]+>[^<]*/g;
function $3ee4f50b1ae43a89$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($3ee4f50b1ae43a89$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $3ee4f50b1ae43a89$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $3ee4f50b1ae43a89$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $3ee4f50b1ae43a89$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $3ee4f50b1ae43a89$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $3ee4f50b1ae43a89$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $3ee4f50b1ae43a89$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('Properties', null, {
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $3ee4f50b1ae43a89$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $3ee4f50b1ae43a89$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $3ee4f50b1ae43a89$var$writextag('property', $3ee4f50b1ae43a89$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $3ee4f50b1ae43a89$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $3ee4f50b1ae43a89$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $3ee4f50b1ae43a89$var$evert_XLMLDPM;
function $3ee4f50b1ae43a89$var$xlml_set_prop(Props, tag /*:string*/ , val1) {
    if (!$3ee4f50b1ae43a89$var$evert_XLMLDPM) $3ee4f50b1ae43a89$var$evert_XLMLDPM = $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$XLMLDocPropsMap);
    tag = $3ee4f50b1ae43a89$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val1;
}
function $3ee4f50b1ae43a89$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$keys($3ee4f50b1ae43a89$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i)if ($3ee4f50b1ae43a89$var$CORE_PROPS[i][1] == m) return $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        for(i = 0; i < $3ee4f50b1ae43a89$var$EXT_PROPS.length; ++i)if ($3ee4f50b1ae43a89$var$EXT_PROPS[i][1] == m) return $3ee4f50b1ae43a89$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($3ee4f50b1ae43a89$var$writetag($3ee4f50b1ae43a89$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $3ee4f50b1ae43a89$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $3ee4f50b1ae43a89$var$XLMLNS.o
    });
}
function $3ee4f50b1ae43a89$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $3ee4f50b1ae43a89$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i)if (k == $3ee4f50b1ae43a89$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $3ee4f50b1ae43a89$var$EXT_PROPS.length; ++i)if (k == $3ee4f50b1ae43a89$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($3ee4f50b1ae43a89$var$writextag($3ee4f50b1ae43a89$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $3ee4f50b1ae43a89$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($3ee4f50b1ae43a89$var$writextag($3ee4f50b1ae43a89$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $3ee4f50b1ae43a89$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $3ee4f50b1ae43a89$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $3ee4f50b1ae43a89$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $3ee4f50b1ae43a89$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $3ee4f50b1ae43a89$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $3ee4f50b1ae43a89$var$parse_lpwstr(blob);
    return $3ee4f50b1ae43a89$var$parse_lpstr(blob, stringType, pad);
}
function $3ee4f50b1ae43a89$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $3ee4f50b1ae43a89$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $3ee4f50b1ae43a89$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($3ee4f50b1ae43a89$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $3ee4f50b1ae43a89$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($3ee4f50b1ae43a89$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $3ee4f50b1ae43a89$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $3ee4f50b1ae43a89$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($3ee4f50b1ae43a89$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($3ee4f50b1ae43a89$var$chr0, '').replace($3ee4f50b1ae43a89$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $3ee4f50b1ae43a89$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $3ee4f50b1ae43a89$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $3ee4f50b1ae43a89$var$VT_VARIANT) {
        if (t !== type && $3ee4f50b1ae43a89$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $3ee4f50b1ae43a89$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            blob.l += 4;
            val = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x1F /*VT_LPWSTR*/ :
            blob.l += 4;
            val = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x40 /*VT_FILETIME*/ :
            return $3ee4f50b1ae43a89$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $3ee4f50b1ae43a89$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $3ee4f50b1ae43a89$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $3ee4f50b1ae43a89$var$parse_VtString(blob, t, !opts.raw).replace($3ee4f50b1ae43a89$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $3ee4f50b1ae43a89$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($3ee4f50b1ae43a89$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $3ee4f50b1ae43a89$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $3ee4f50b1ae43a89$var$parse_VtVecLpwstrValue(blob) : $3ee4f50b1ae43a89$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $3ee4f50b1ae43a89$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $3ee4f50b1ae43a89$var$new_buf(4), p = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $3ee4f50b1ae43a89$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $3ee4f50b1ae43a89$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $3ee4f50b1ae43a89$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $3ee4f50b1ae43a89$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $3ee4f50b1ae43a89$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $3ee4f50b1ae43a89$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_I2);
                $3ee4f50b1ae43a89$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val1;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val1 = $3ee4f50b1ae43a89$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val1 = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val1 = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val1 = $3ee4f50b1ae43a89$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val1 = $3ee4f50b1ae43a89$var$parseDate($3ee4f50b1ae43a89$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val1;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $3ee4f50b1ae43a89$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $3ee4f50b1ae43a89$var$guess_property_type(val1 /*:any*/ ) /*:number*/ {
    switch(typeof val1){
        case "boolean":
            return 0x0B;
        case "number":
            return (val1 | 0) == val1 ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val1 instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $3ee4f50b1ae43a89$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $3ee4f50b1ae43a89$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $3ee4f50b1ae43a89$var$new_buf(8), pio = $3ee4f50b1ae43a89$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $3ee4f50b1ae43a89$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $3ee4f50b1ae43a89$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $3ee4f50b1ae43a89$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($3ee4f50b1ae43a89$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $3ee4f50b1ae43a89$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val1 = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val1 == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val1.split(".");
                val1 = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $3ee4f50b1ae43a89$var$write_TypedPropertyValue(pinfo.t, val1);
        } else {
            var T = $3ee4f50b1ae43a89$var$guess_property_type(val1);
            if (T == -1) {
                T = 0x1F;
                val1 = String(val1);
            }
            pr = $3ee4f50b1ae43a89$var$write_TypedPropertyValue(T, val1);
        }
        prop.push(pr);
        pio = $3ee4f50b1ae43a89$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $3ee4f50b1ae43a89$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $3ee4f50b1ae43a89$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $3ee4f50b1ae43a89$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $3ee4f50b1ae43a89$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $3ee4f50b1ae43a89$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $3ee4f50b1ae43a89$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $3ee4f50b1ae43a89$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $3ee4f50b1ae43a89$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $3ee4f50b1ae43a89$var$bconcat(bufs);
}
function $3ee4f50b1ae43a89$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $3ee4f50b1ae43a89$var$writezeroes(n, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $3ee4f50b1ae43a89$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $3ee4f50b1ae43a89$var$writebool(v /*:any*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $3ee4f50b1ae43a89$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $3ee4f50b1ae43a89$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $3ee4f50b1ae43a89$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $3ee4f50b1ae43a89$var$parslurp(blob, length, $3ee4f50b1ae43a89$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $3ee4f50b1ae43a89$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $3ee4f50b1ae43a89$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $3ee4f50b1ae43a89$var$current_codepage;
    if (opts && opts.biff >= 8) $3ee4f50b1ae43a89$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $3ee4f50b1ae43a89$var$current_codepage;
    $3ee4f50b1ae43a89$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    return z;
}
function $3ee4f50b1ae43a89$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $3ee4f50b1ae43a89$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $3ee4f50b1ae43a89$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $3ee4f50b1ae43a89$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $3ee4f50b1ae43a89$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $3ee4f50b1ae43a89$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($3ee4f50b1ae43a89$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $3ee4f50b1ae43a89$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($3ee4f50b1ae43a89$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $3ee4f50b1ae43a89$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $3ee4f50b1ae43a89$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $3ee4f50b1ae43a89$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($3ee4f50b1ae43a89$var$chr0, "") : "";
    return o;
}
function $3ee4f50b1ae43a89$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $3ee4f50b1ae43a89$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $3ee4f50b1ae43a89$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $3ee4f50b1ae43a89$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $3ee4f50b1ae43a89$var$write_Hyperlink(hl) {
    var out = $3ee4f50b1ae43a89$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $3ee4f50b1ae43a89$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $3ee4f50b1ae43a89$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $3ee4f50b1ae43a89$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $3ee4f50b1ae43a89$var$parse_LongRGB(blob, length) {
    var x = $3ee4f50b1ae43a89$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $3ee4f50b1ae43a89$var$parse_XLSCell(blob, length, opts) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ret = {
        r: rw,
        c: col,
        ixfe: 0
    } /*:any*/ ;
    if (opts && opts.biff == 2 || length == 7) {
        /* TODO: pass back flags */ var flags = blob.read_shift(1);
        ret.ixfe = flags & 0x3F;
        blob.l += 2;
    /*
		var ifntifmt = blob.read_shift(1);
		var ifmt = ifntifmt & 0x3f, ifnt = ifntifmt >> 6;
		var flags3 = blob.read_shift(1);
		*/ } else ret.ixfe = blob.read_shift(2);
    return ret;
}
function $3ee4f50b1ae43a89$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $3ee4f50b1ae43a89$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $3ee4f50b1ae43a89$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $3ee4f50b1ae43a89$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $3ee4f50b1ae43a89$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $3ee4f50b1ae43a89$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $3ee4f50b1ae43a89$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $3ee4f50b1ae43a89$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $3ee4f50b1ae43a89$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $3ee4f50b1ae43a89$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $3ee4f50b1ae43a89$var$parse_Ref = $3ee4f50b1ae43a89$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $3ee4f50b1ae43a89$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $3ee4f50b1ae43a89$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $3ee4f50b1ae43a89$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $3ee4f50b1ae43a89$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $3ee4f50b1ae43a89$var$FtTab = {
    0x00: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtEnd */ 0x04: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtMacro */ 0x05: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtButton */ 0x06: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtGmo */ 0x07: $3ee4f50b1ae43a89$var$parse_FtCf,
    /* FtCf */ 0x08: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtPioGrbit */ 0x09: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtPictFmla */ 0x0A: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCbls */ 0x0B: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtRbo */ 0x0C: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtSbs */ 0x0D: $3ee4f50b1ae43a89$var$parse_FtNts,
    /* FtNts */ 0x0E: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtSbsFmla */ 0x0F: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtGboData */ 0x10: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtEdoData */ 0x11: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtRboData */ 0x12: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCblsData */ 0x13: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtLbsData */ 0x14: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCblsFmla */ 0x15: $3ee4f50b1ae43a89$var$parse_FtCmo
};
function $3ee4f50b1ae43a89$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $3ee4f50b1ae43a89$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $3ee4f50b1ae43a89$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $3ee4f50b1ae43a89$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $3ee4f50b1ae43a89$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $3ee4f50b1ae43a89$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $3ee4f50b1ae43a89$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $3ee4f50b1ae43a89$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $3ee4f50b1ae43a89$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $3ee4f50b1ae43a89$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $3ee4f50b1ae43a89$var$parse_BoundSheet8(blob, length, opts) {
    var name = "";
    if (opts.biff == 4) {
        name = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            name: name
        };
    }
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    name = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $3ee4f50b1ae43a89$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $3ee4f50b1ae43a89$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($3ee4f50b1ae43a89$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $3ee4f50b1ae43a89$var$write_SST(sst, opts) {
    var header = $3ee4f50b1ae43a89$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $3ee4f50b1ae43a89$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $3ee4f50b1ae43a89$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $3ee4f50b1ae43a89$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $3ee4f50b1ae43a89$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $3ee4f50b1ae43a89$var$parse_ForceFullCalculation(blob) {
    var header = $3ee4f50b1ae43a89$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $3ee4f50b1ae43a89$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $3ee4f50b1ae43a89$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $3ee4f50b1ae43a89$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $3ee4f50b1ae43a89$var$write_Window1() {
    var o = $3ee4f50b1ae43a89$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $3ee4f50b1ae43a89$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $3ee4f50b1ae43a89$var$write_Window2(view) {
    var o = $3ee4f50b1ae43a89$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $3ee4f50b1ae43a89$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $3ee4f50b1ae43a89$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $3ee4f50b1ae43a89$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $3ee4f50b1ae43a89$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $3ee4f50b1ae43a89$var$parse_LabelSst(blob, length, opts) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, length, opts);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $3ee4f50b1ae43a89$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(10);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $3ee4f50b1ae43a89$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, length, opts);
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $3ee4f50b1ae43a89$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $3ee4f50b1ae43a89$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $3ee4f50b1ae43a89$var$parse_BIFF2Format = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2;
function $3ee4f50b1ae43a89$var$write_BIFF2Format(f /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(1 + f.length);
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
function $3ee4f50b1ae43a89$var$write_BIFF4Format(f /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(3 + f.length);
    o.l += 2;
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.90 */ function $3ee4f50b1ae43a89$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $3ee4f50b1ae43a89$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $3ee4f50b1ae43a89$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $3ee4f50b1ae43a89$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $3ee4f50b1ae43a89$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $3ee4f50b1ae43a89$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($3ee4f50b1ae43a89$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $3ee4f50b1ae43a89$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $3ee4f50b1ae43a89$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $3ee4f50b1ae43a89$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $3ee4f50b1ae43a89$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $3ee4f50b1ae43a89$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $3ee4f50b1ae43a89$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    blob.l++;
    o.flags = blob.read_shift(1);
    o.numFmtId = o.flags & 0x3F;
    o.flags >>= 6;
    o.fStyle = 0;
    o.data = {}; // TODO
    return o;
}
function $3ee4f50b1ae43a89$var$write_BIFF2XF(xf) {
    var o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.l += 2;
    o.write_shift(1, xf.numFmtId);
    o.l++;
    return o;
}
function $3ee4f50b1ae43a89$var$write_BIFF3XF(xf) {
    var o = $3ee4f50b1ae43a89$var$new_buf(12);
    o.l++;
    o.write_shift(1, xf.numFmtId);
    o.l += 10;
    return o;
}
/* TODO: check other fields */ var $3ee4f50b1ae43a89$var$write_BIFF4XF = $3ee4f50b1ae43a89$var$write_BIFF3XF;
function $3ee4f50b1ae43a89$var$parse_BIFF3XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BIFF4XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
/* [MS-XLS] 2.4.134 */ function $3ee4f50b1ae43a89$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $3ee4f50b1ae43a89$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $3ee4f50b1ae43a89$var$parse_BoolErr(blob, length, opts) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6, opts);
    var val1 = $3ee4f50b1ae43a89$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    $3ee4f50b1ae43a89$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $3ee4f50b1ae43a89$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6, opts);
    var xnum = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(14);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    $3ee4f50b1ae43a89$var$write_Xnum(v, o);
    return o;
}
var $3ee4f50b1ae43a89$var$parse_XLHeaderFooter = $3ee4f50b1ae43a89$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $3ee4f50b1ae43a89$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $3ee4f50b1ae43a89$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $3ee4f50b1ae43a89$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $3ee4f50b1ae43a89$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $3ee4f50b1ae43a89$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $3ee4f50b1ae43a89$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $3ee4f50b1ae43a89$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $3ee4f50b1ae43a89$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($3ee4f50b1ae43a89$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $3ee4f50b1ae43a89$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $3ee4f50b1ae43a89$var$parse_ShrFmla(blob, length, opts) {
    var ref = $3ee4f50b1ae43a89$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $3ee4f50b1ae43a89$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $3ee4f50b1ae43a89$var$parse_Array(blob, length, opts) {
    var ref = $3ee4f50b1ae43a89$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $3ee4f50b1ae43a89$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $3ee4f50b1ae43a89$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 */ function $3ee4f50b1ae43a89$var$parse_NoteSh(blob, length, opts) {
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $3ee4f50b1ae43a89$var$parse_Note(blob, length, opts) {
    if (opts && opts.biff < 8) {
        var row = blob.read_shift(2), col = blob.read_shift(2);
        if (row == 0xFFFF || row == -1) return; // TODO: test continuation
        var cch = blob.read_shift(2);
        var cmnt = blob.read_shift(Math.min(cch, 2048), 'cpstr');
        return [
            {
                r: row,
                c: col
            },
            cmnt
        ];
    }
    /* TODO: Support revisions */ return $3ee4f50b1ae43a89$var$parse_NoteSh(blob, length, opts);
}
function $3ee4f50b1ae43a89$var$write_NOTE_BIFF2(text /*:string*/ , R /*:number*/ , C /*:number*/ , len /*?:number*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(6 + (len || text.length));
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, len || text.length);
    o.write_shift(text.length, text, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.168 */ function $3ee4f50b1ae43a89$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($3ee4f50b1ae43a89$var$parse_Ref8U(blob, length));
    return merges;
}
function $3ee4f50b1ae43a89$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$3ee4f50b1ae43a89$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $3ee4f50b1ae43a89$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $3ee4f50b1ae43a89$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $3ee4f50b1ae43a89$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $3ee4f50b1ae43a89$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $3ee4f50b1ae43a89$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($3ee4f50b1ae43a89$var$parse_BIFF5OT[ot] || $3ee4f50b1ae43a89$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $3ee4f50b1ae43a89$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $3ee4f50b1ae43a89$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $3ee4f50b1ae43a89$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $3ee4f50b1ae43a89$var$parse_HLink(blob, length) {
    var ref = $3ee4f50b1ae43a89$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $3ee4f50b1ae43a89$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $3ee4f50b1ae43a89$var$write_HLink(hl) {
    var O = $3ee4f50b1ae43a89$var$new_buf(24);
    var ref = $3ee4f50b1ae43a89$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $3ee4f50b1ae43a89$var$bconcat([
        O,
        $3ee4f50b1ae43a89$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $3ee4f50b1ae43a89$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $3ee4f50b1ae43a89$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($3ee4f50b1ae43a89$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $3ee4f50b1ae43a89$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $3ee4f50b1ae43a89$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $3ee4f50b1ae43a89$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $3ee4f50b1ae43a89$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $3ee4f50b1ae43a89$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $3ee4f50b1ae43a89$var$CountryEnum[d] || d;
    return o;
}
function $3ee4f50b1ae43a89$var$write_Country(o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $3ee4f50b1ae43a89$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($3ee4f50b1ae43a89$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $3ee4f50b1ae43a89$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($3ee4f50b1ae43a89$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $3ee4f50b1ae43a89$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $3ee4f50b1ae43a89$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $3ee4f50b1ae43a89$var$write_ColInfo(col, idx) {
    var o = $3ee4f50b1ae43a89$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $3ee4f50b1ae43a89$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    o.footer = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $3ee4f50b1ae43a89$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $3ee4f50b1ae43a89$var$write_RRTabId(n /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $3ee4f50b1ae43a89$var$parse_Blank = $3ee4f50b1ae43a89$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $3ee4f50b1ae43a89$var$parse_Scl = $3ee4f50b1ae43a89$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $3ee4f50b1ae43a89$var$parse_String = $3ee4f50b1ae43a89$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $3ee4f50b1ae43a89$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
function $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    if (!out) out = $3ee4f50b1ae43a89$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(1, ixfe || 0 /* & 0x3F */ );
    out.write_shift(1, ifmt || 0 /* & 0x3F */ );
    out.write_shift(1, 0);
    return out;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $3ee4f50b1ae43a89$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 7, opts);
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2NUM(blob, length, opts) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 7, opts);
    var num = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe, ifmt) {
    var out = $3ee4f50b1ae43a89$var$new_buf(15);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(8, val1, 'f');
    return out;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2INT(blob, length, opts) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 7, opts);
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(2, val1);
    return out;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
function $3ee4f50b1ae43a89$var$parse_BIFF2BOOLERR(blob, length, opts) {
    var bestart = blob.l + 7;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6, opts);
    blob.l = bestart;
    var val1 = $3ee4f50b1ae43a89$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
/* TODO: convert to BIFF8 font struct */ function $3ee4f50b1ae43a89$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $3ee4f50b1ae43a89$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6, opts);
    var cch = blob.read_shift(2);
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $3ee4f50b1ae43a89$var$parse_BIFF4SheetInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(4);
    var cch = blob.read_shift(1), name = blob.read_shift(cch, "sbcs");
    if (name.length === 0) name = "Sheet1";
    return {
        flags: flags,
        name: name
    };
}
var $3ee4f50b1ae43a89$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $3ee4f50b1ae43a89$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        /* shapefile DBF extension */ 0x00: 20127,
        0x08: 865,
        0x09: 437,
        0x0A: 850,
        0x0B: 437,
        0x0D: 437,
        0x0E: 850,
        0x0F: 437,
        0x10: 850,
        0x11: 437,
        0x12: 850,
        0x13: 932,
        0x14: 850,
        0x15: 437,
        0x16: 850,
        0x17: 865,
        0x18: 437,
        0x19: 437,
        0x1A: 850,
        0x1B: 437,
        0x1C: 863,
        0x1D: 850,
        0x1F: 852,
        0x22: 852,
        0x23: 852,
        0x24: 860,
        0x25: 850,
        0x26: 866,
        0x37: 850,
        0x40: 852,
        0x4D: 936,
        0x4E: 949,
        0x4F: 950,
        0x50: 874,
        0x57: 1252,
        0x58: 1252,
        0x59: 1252,
        0x6C: 863,
        0x86: 737,
        0x87: 852,
        0x88: 857,
        0xCC: 1257,
        0xFF: 16969
    };
    var dbf_reverse_map = $3ee4f50b1ae43a89$var$evert({
        0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $3ee4f50b1ae43a89$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $3ee4f50b1ae43a89$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $3ee4f50b1ae43a89$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $3ee4f50b1ae43a89$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n][\S\s]*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $3ee4f50b1ae43a89$var$prep_blob(dd, 0);
                var s = typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(current_cp, dd) : $3ee4f50b1ae43a89$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/([^\s])\s+$/, "$1");
                        break;
                    case 'D':
                        if (s.length === 8) {
                            out[R][C] = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 0, 0, 0, 0));
                            if (!(opts && opts.UTC)) out[R][C] = $3ee4f50b1ae43a89$var$utc_to_local(out[R][C]);
                        } else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '\x00':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        var hi = dd.read_shift(4), lo = dd.read_shift(4);
                        if (hi == 0 && lo == 0) break;
                        out[R][C] = new Date((hi - 0x253D8C) * 0x5265C00 + lo);
                        if (!(opts && opts.UTC)) out[R][C] = $3ee4f50b1ae43a89$var$utc_to_local(out[R][C]);
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $3ee4f50b1ae43a89$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $3ee4f50b1ae43a89$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DBF");
        var o = opts || {};
        var old_cp = $3ee4f50b1ae43a89$var$current_codepage;
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        var aoa /*:AOA*/  = $3ee4f50b1ae43a89$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" && typeof col[j] == "string" ? $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $3ee4f50b1ae43a89$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $3ee4f50b1ae43a89$var$current_codepage + ", using 1252");
            $3ee4f50b1ae43a89$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $3ee4f50b1ae43a89$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $3ee4f50b1ae43a89$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $3ee4f50b1ae43a89$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
    try {
        sylk_char_regex = new RegExp("\u001BN(" + $3ee4f50b1ae43a89$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    } catch (e) {}
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $3ee4f50b1ae43a89$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $3ee4f50b1ae43a89$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: evert the escape map */ var encode_sylk_str = function($$) {
        return $$.replace(/\n/g, "\x1b :").replace(/\r/g, "\x1b =");
    };
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString('binary') : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val1;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $3ee4f50b1ae43a89$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    var cmnt = "";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            cmnt = record[rj].slice(1);
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val1 = record[rj].slice(1);
                            if (val1.charAt(0) === '"') {
                                val1 = val1.slice(1, val1.length - 1);
                                cell_t = "s";
                            } else if (val1 === 'TRUE' || val1 === 'FALSE') {
                                val1 = val1 === 'TRUE';
                                cell_t = "b";
                            } else if (val1.charAt(0) == "#" && $3ee4f50b1ae43a89$var$RBErr[val1] != null) {
                                cell_t = "e";
                                val1 = $3ee4f50b1ae43a89$var$RBErr[val1];
                            } else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(val1))) {
                                val1 = $3ee4f50b1ae43a89$var$fuzzynum(val1);
                                cell_t = "n";
                                if (next_cell_format !== null && $3ee4f50b1ae43a89$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val1 = $3ee4f50b1ae43a89$var$numdate(wb.Workbook.WBProps.date1904 ? val1 + 1462 : val1);
                                    cell_t = typeof val1 == "number" ? "n" : "d";
                                }
                            }
                            if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined' && typeof val1 == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val1 = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, val1);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $3ee4f50b1ae43a89$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val1
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val1;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $3ee4f50b1ae43a89$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $3ee4f50b1ae43a89$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    if (cmnt) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'z'
                        };
                        arr[R][C].c = [
                            {
                                a: "SheetJSYLK",
                                t: cmnt
                            }
                        ];
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $3ee4f50b1ae43a89$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $3ee4f50b1ae43a89$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $3ee4f50b1ae43a89$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $3ee4f50b1ae43a89$var$aoa_to_sheet(aoa, _opts);
        $3ee4f50b1ae43a89$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $3ee4f50b1ae43a89$var$sheet_to_workbook(o, opts);
        $3ee4f50b1ae43a89$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += isFinite(cell.v) ? cell.v || 0 : $3ee4f50b1ae43a89$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                if (cell.f && !cell.F) o += ";E" + $3ee4f50b1ae43a89$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || $3ee4f50b1ae43a89$var$BErr[cell.v] || cell.v;
                break;
            case 'd':
                o += $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v, date1904), date1904);
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cmnt_sylk(cmnt /*:Comment*/ , R /*:number*/ , C /*:number*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";A";
        /* TODO: max length? */ o += encode_sylk_str(cmnt.map(function(c) {
            return c.t;
        }).join(""));
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $3ee4f50b1ae43a89$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $3ee4f50b1ae43a89$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $3ee4f50b1ae43a89$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        if (!opts) opts = {};
        opts._formats = [
            "General"
        ];
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref'] || "A1"), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var _lastfmt = "General";
        preamble.push("P;PGeneral");
        /* Excel has been inconsistent in comment placement */ var R = r.s.r, C = r.s.c, p = [];
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R)];
                if (!cell || !cell.c) continue;
                p.push(write_ws_cmnt_sylk(cell.c, R, C));
            }
            if (p.length) o.push(p.join(RS));
        }
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                if ((cell.z || (cell.t == "d" ? $3ee4f50b1ae43a89$var$table_fmt[14] : "General")) != _lastfmt) {
                    var ifmt = opts._formats.indexOf(cell.z);
                    if (ifmt == -1) {
                        opts._formats.push(cell.z);
                        ifmt = opts._formats.length - 1;
                        preamble.push("P;P" + cell.z.replace(/;/g, ";;"));
                    }
                    p.push("F;P" + ifmt + ";Y" + (R + 1) + ";X" + (C + 1));
                }
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts, d1904));
            }
            o.push(p.join(RS));
        }
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        if (ws["!ref"]) preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        delete opts._formats;
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $3ee4f50b1ae43a89$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString('binary') : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(value))) arr[R][C] = $3ee4f50b1ae43a89$var$fuzzynum(value);
                    else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(value).getDate())) {
                        arr[R][C] = $3ee4f50b1ae43a89$var$parseDate(value);
                        if (!(opts && opts.UTC)) arr[R][C] = $3ee4f50b1ae43a89$var$utc_to_local(arr[R][C]);
                    } else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($3ee4f50b1ae43a89$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $3ee4f50b1ae43a89$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $3ee4f50b1ae43a89$var$DIF_XL;
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DIF");
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z || $3ee4f50b1ae43a89$var$table_fmt[14], $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $3ee4f50b1ae43a89$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $3ee4f50b1ae43a89$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = record[record.length - 1].charAt(0) == "#" ? {
                                t: "e",
                                v: $3ee4f50b1ae43a89$var$RBErr[record[record.length - 1]]
                            } : +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $3ee4f50b1ae43a89$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                    oo.push(encode(cell.v));
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $3ee4f50b1ae43a89$var$SSF_format(cell.z || $3ee4f50b1ae43a89$var$table_fmt[14], t);
                    break;
                case 'n':
                    if (isFinite(cell.v)) {
                        if (!cell.f) {
                            oo[2] = 'v';
                            oo[3] = cell.v;
                        } else {
                            oo[2] = 'vtf';
                            oo[3] = 'n';
                            oo[4] = cell.v;
                            oo[5] = encode(cell.f);
                        }
                    } else {
                        oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                        oo[3] = "e" + $3ee4f50b1ae43a89$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                        oo[4] = "0";
                        oo[5] = cell.f || oo[3].slice(1);
                        oo[6] = "e";
                        oo[7] = oo[3].slice(1);
                    }
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $3ee4f50b1ae43a89$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(data))) arr[R][C] = $3ee4f50b1ae43a89$var$fuzzynum(data);
        else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(data).getDate())) arr[R][C] = $3ee4f50b1ae43a89$var$parseDate(data);
        else if (data.charCodeAt(0) == 35 /* # */  && $3ee4f50b1ae43a89$var$RBErr[data] != null) arr[R][C] = {
            t: 'e',
            v: $3ee4f50b1ae43a89$var$RBErr[data],
            w: data
        };
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        0x2C: ',',
        0x09: "\t",
        0x3B: ';',
        0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        0x2C: 3,
        0x09: 2,
        0x3B: 1,
        0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $3ee4f50b1ae43a89$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            /* TODO: fuzzy parsers should pass back assumed number format */ var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (o.cellText !== false) cell.w = s;
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($3ee4f50b1ae43a89$var$fuzzyfmla(s)) {
                    cell.t = 's';
                    cell.f = s.slice(1);
                    cell.v = s;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $3ee4f50b1ae43a89$var$fuzzynum(s))) {
                cell.t = 'n';
                cell.v = v;
            } else if (!isNaN((v = $3ee4f50b1ae43a89$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                if (_re && s.match(_re)) {
                    var news = $3ee4f50b1ae43a89$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    v = $3ee4f50b1ae43a89$var$parseDate(news);
                    if (o && o.UTC === false) v = $3ee4f50b1ae43a89$var$utc_to_local(v);
                } else if (o && o.UTC === false) v = $3ee4f50b1ae43a89$var$utc_to_local(v);
                else if (o.cellText !== false && o.dateNF) cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, v);
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $3ee4f50b1ae43a89$var$datenum(v);
                }
                if (!o.cellNF) delete cell.z;
            } else if (s.charCodeAt(0) == 35 /* # */  && $3ee4f50b1ae43a89$var$RBErr[s] != null) {
                cell.t = 'e';
                cell.w = s;
                cell.v = $3ee4f50b1ae43a89$var$RBErr[s];
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $3ee4f50b1ae43a89$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $3ee4f50b1ae43a89$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $3ee4f50b1ae43a89$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined') str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, d);
                else str = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString('binary') : $3ee4f50b1ae43a89$var$a2s(d);
                break;
            case 'array':
                str = $3ee4f50b1ae43a89$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $3ee4f50b1ae43a89$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $3ee4f50b1ae43a89$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined' && opts.codepage) str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, $3ee4f50b1ae43a89$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $3ee4f50b1ae43a89$var$ETH.to_sheet(opts.type == 'string' ? str : $3ee4f50b1ae43a89$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        if (!ws["!ref"]) return "";
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $3ee4f50b1ae43a89$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $3ee4f50b1ae43a89$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (e.message.indexOf("SYLK bad record ID") == -1 && OLD_WTF) throw e;
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(d, opts);
    }
}
var $3ee4f50b1ae43a89$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $3ee4f50b1ae43a89$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($3ee4f50b1ae43a89$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    /* NOTE: this list intentionally starts at 1 */ var LOTUS_DATE_FMTS = [
        "mmmm",
        "dd-mmm-yyyy",
        "dd-mmm",
        "mmm-yyyy",
        "@",
        "mm/dd",
        "hh:mm:ss AM/PM",
        "hh:mm AM/PM",
        "mm/dd/yyyy",
        "mm/dd",
        "hh:mm:ss",
        "hh:mm" // 12
    ];
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        var lastcell = {};
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val1;
                        if (val1 >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val1;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val1;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val1) next_n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val1;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        if (o.works || o.works2) val1[1].v = val1[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if ((val1[2] & 0x70) == 0x70 && (val1[2] & 0x0F) > 1 && (val1[2] & 0x0F) < 15) {
                            val1[1].z = o.dateNF || LOTUS_DATE_FMTS[(val1[2] & 0x0F) - 1] || $3ee4f50b1ae43a89$var$table_fmt[14];
                            if (o.cellDates) {
                                val1[1].v = $3ee4f50b1ae43a89$var$numdate(val1[1].v);
                                val1[1].t = typeof val1[1].v == "number" ? 'n' : 'd';
                            }
                        }
                        if (o.qpro) {
                            if (val1[3] > sidx) {
                                s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val1[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val1[0].r] || [])[val1[0].c] : s[$3ee4f50b1ae43a89$var$encode_cell(val1[0])];
                        if (tmpcell) {
                            tmpcell.t = val1[1].t;
                            tmpcell.v = val1[1].v;
                            if (val1[1].z != null) tmpcell.z = val1[1].z;
                            if (val1[1].f != null) tmpcell.f = val1[1].f;
                            lastcell = tmpcell;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$3ee4f50b1ae43a89$var$encode_cell(val1[0])] = val1[1];
                        lastcell = val1[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    case 0x5402:
                        /* TODO: enumerate all extended number formats */ if (val1 == 0x14a1) {
                            lastcell.z = "hh:mm:ss";
                            if (o.cellDates && lastcell.t == "n") {
                                lastcell.v = $3ee4f50b1ae43a89$var$numdate(lastcell.v);
                                lastcell.t = typeof lastcell.v == "number" ? 'n' : 'd';
                            }
                        }
                        break;
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val1[1].v = val1[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val1[3] > sidx) {
                            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val1[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val1[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$3ee4f50b1ae43a89$var$encode_cell(val1[0])] = val1[1];
                        if (refguess.e.c < val1[0].c) refguess.e.c = val1[0].c;
                        if (refguess.e.r < val1[0].r) refguess.e.r = val1[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val1[0x36b0]) realnames[val1[0x36b0][0]] = val1[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val1[0]] = val1[1];
                        if (val1[0] == sidx) n = val1[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to WK1");
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $3ee4f50b1ae43a89$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ switch(cell.t){
                    case "n":
                        if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell));
                        else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell));
                        break;
                    case "d":
                        var dc = $3ee4f50b1ae43a89$var$datenum(cell.v);
                        if ((dc | 0) == dc && dc >= -32768 && dc <= 32767) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $3ee4f50b1ae43a89$var$table_fmt[14]
                        }));
                        else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $3ee4f50b1ae43a89$var$table_fmt[14]
                        }));
                        break;
                    default:
                        var str = $3ee4f50b1ae43a89$var$format_cell(cell);
                        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $3ee4f50b1ae43a89$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $3ee4f50b1ae43a89$var$format_cell(cell);
                        /* TODO: max len? */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $3ee4f50b1ae43a89$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $3ee4f50b1ae43a89$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $3ee4f50b1ae43a89$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function get_wk1_fmt(cell) /*:number*/ {
        /* TODO: some fuzzy matching on the number format */ if (cell.z && $3ee4f50b1ae43a89$var$fmt_is_date(cell.z)) return 0xf0 | (LOTUS_DATE_FMTS.indexOf(cell.z) + 1 || 2);
        return 0xFF;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if ((opts.vers & 0xFFFE) == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $3ee4f50b1ae43a89$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, cell) {
        var o = $3ee4f50b1ae43a89$var$new_buf(7);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, cell.v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, cell) {
        var o = $3ee4f50b1ae43a89$var$new_buf(13);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, cell.v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $3ee4f50b1ae43a89$var$encode_col(V) : $3ee4f50b1ae43a89$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        0x36: [
            "DATE",
            3
        ],
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        0x40: [
            "TIME",
            3
        ],
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $3ee4f50b1ae43a89$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $3ee4f50b1ae43a89$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $3ee4f50b1ae43a89$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        0x0000: {
            n: "BOF",
            f: $3ee4f50b1ae43a89$var$parseuint16
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "CALCMODE"
        },
        0x0003: {
            n: "CALCORDER"
        },
        0x0004: {
            n: "SPLIT"
        },
        0x0005: {
            n: "SYNC"
        },
        0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        0x0007: {
            n: "WINDOW1"
        },
        0x0008: {
            n: "COLW1"
        },
        0x0009: {
            n: "WINTWO"
        },
        0x000A: {
            n: "COLW2"
        },
        0x000B: {
            n: "NAME"
        },
        0x000C: {
            n: "BLANK"
        },
        0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        0x0018: {
            n: "TABLE"
        },
        0x0019: {
            n: "ORANGE"
        },
        0x001A: {
            n: "PRANGE"
        },
        0x001B: {
            n: "SRANGE"
        },
        0x001C: {
            n: "FRANGE"
        },
        0x001D: {
            n: "KRANGE1"
        },
        0x0020: {
            n: "HRANGE"
        },
        0x0023: {
            n: "KRANGE2"
        },
        0x0024: {
            n: "PROTEC"
        },
        0x0025: {
            n: "FOOTER"
        },
        0x0026: {
            n: "HEADER"
        },
        0x0027: {
            n: "SETUP"
        },
        0x0028: {
            n: "MARGINS"
        },
        0x0029: {
            n: "LABELFMT"
        },
        0x002A: {
            n: "TITLES"
        },
        0x002B: {
            n: "SHEETJS"
        },
        0x002D: {
            n: "GRAPH"
        },
        0x002E: {
            n: "NGRAPH"
        },
        0x002F: {
            n: "CALCCOUNT"
        },
        0x0030: {
            n: "UNFORMATTED"
        },
        0x0031: {
            n: "CURSORW12"
        },
        0x0032: {
            n: "WINDOW"
        },
        0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        0x0037: {
            n: "PASSWORD"
        },
        0x0038: {
            n: "LOCKED"
        },
        0x003C: {
            n: "QUERY"
        },
        0x003D: {
            n: "QUERYNAME"
        },
        0x003E: {
            n: "PRINT"
        },
        0x003F: {
            n: "PRINTNAME"
        },
        0x0040: {
            n: "GRAPH2"
        },
        0x0041: {
            n: "GRAPHNAME"
        },
        0x0042: {
            n: "ZOOM"
        },
        0x0043: {
            n: "SYMSPLIT"
        },
        0x0044: {
            n: "NSROWS"
        },
        0x0045: {
            n: "NSCOLS"
        },
        0x0046: {
            n: "RULER"
        },
        0x0047: {
            n: "NNAME"
        },
        0x0048: {
            n: "ACOMM"
        },
        0x0049: {
            n: "AMACRO"
        },
        0x004A: {
            n: "PARSE"
        },
        // 0x0064
        0x0066: {
            n: "PRANGES??"
        },
        0x0067: {
            n: "RRANGES??"
        },
        0x0068: {
            n: "FNAME??"
        },
        0x0069: {
            n: "MRANGES??"
        },
        // 0x0096
        // 0x0099
        // 0x009A
        // 0x009B
        // 0x009C
        // 0x00C0
        // 0x00C7
        // 0x00C9
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        // 0x00CD
        0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        0x00FF: {
            n: "BOF",
            f: $3ee4f50b1ae43a89$var$parseuint16
        },
        0x5402: {
            n: "WKSNF",
            f: $3ee4f50b1ae43a89$var$parseuint16
        },
        0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        0x0000: {
            n: "BOF"
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "PASSWORD"
        },
        0x0003: {
            n: "CALCSET"
        },
        0x0004: {
            n: "WINDOWSET"
        },
        0x0005: {
            n: "SHEETCELLPTR"
        },
        0x0006: {
            n: "SHEETLAYOUT"
        },
        0x0007: {
            n: "COLUMNWIDTH"
        },
        0x0008: {
            n: "HIDDENCOLUMN"
        },
        0x0009: {
            n: "USERRANGE"
        },
        0x000A: {
            n: "SYSTEMRANGE"
        },
        0x000B: {
            n: "ZEROFORCE"
        },
        0x000C: {
            n: "SORTKEYDIR"
        },
        0x000D: {
            n: "FILESEAL"
        },
        0x000E: {
            n: "DATAFILLNUMS"
        },
        0x000F: {
            n: "PRINTMAIN"
        },
        0x0010: {
            n: "PRINTSTRING"
        },
        0x0011: {
            n: "GRAPHMAIN"
        },
        0x0012: {
            n: "GRAPHSTRING"
        },
        0x0013: {
            n: "??"
        },
        0x0014: {
            n: "ERRCELL"
        },
        0x0015: {
            n: "NACELL"
        },
        0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        0x001A: {
            n: "FORMULA1A"
        },
        0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        0x001C: {
            n: "DTLABELMISC"
        },
        0x001D: {
            n: "DTLABELCELL"
        },
        0x001E: {
            n: "GRAPHWINDOW"
        },
        0x001F: {
            n: "CPA"
        },
        0x0020: {
            n: "LPLAUTO"
        },
        0x0021: {
            n: "QUERY"
        },
        0x0022: {
            n: "HIDDENSHEET"
        },
        0x0023: {
            n: "??"
        },
        0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        0x0026: {
            n: "??"
        },
        0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        0x008E: {
            n: "??"
        },
        0x0093: {
            n: "??"
        },
        0x0096: {
            n: "??"
        },
        0x0097: {
            n: "??"
        },
        0x0098: {
            n: "??"
        },
        0x0099: {
            n: "??"
        },
        0x009A: {
            n: "??"
        },
        0x009B: {
            n: "??"
        },
        0x009C: {
            n: "??"
        },
        0x00A3: {
            n: "??"
        },
        0x00AE: {
            n: "??"
        },
        0x00AF: {
            n: "??"
        },
        0x00B0: {
            n: "??"
        },
        0x00B1: {
            n: "??"
        },
        0x00B8: {
            n: "??"
        },
        0x00B9: {
            n: "??"
        },
        0x00BA: {
            n: "??"
        },
        0x00BB: {
            n: "??"
        },
        0x00BC: {
            n: "??"
        },
        0x00C3: {
            n: "??"
        },
        0x00C9: {
            n: "??"
        },
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        0x00CD: {
            n: "??"
        },
        0x00CE: {
            n: "??"
        },
        0x00CF: {
            n: "??"
        },
        0x00D0: {
            n: "??"
        },
        0x0100: {
            n: "??"
        },
        0x0103: {
            n: "??"
        },
        0x0104: {
            n: "??"
        },
        0x0105: {
            n: "??"
        },
        0x0106: {
            n: "??"
        },
        0x0107: {
            n: "??"
        },
        0x0109: {
            n: "??"
        },
        0x010A: {
            n: "??"
        },
        0x010B: {
            n: "??"
        },
        0x010C: {
            n: "??"
        },
        0x010E: {
            n: "??"
        },
        0x010F: {
            n: "??"
        },
        0x0180: {
            n: "??"
        },
        0x0185: {
            n: "??"
        },
        0x0186: {
            n: "??"
        },
        0x0189: {
            n: "??"
        },
        0x018C: {
            n: "??"
        },
        0x0200: {
            n: "??"
        },
        0x0202: {
            n: "??"
        },
        0x0201: {
            n: "??"
        },
        0x0204: {
            n: "??"
        },
        0x0205: {
            n: "??"
        },
        0x0280: {
            n: "??"
        },
        0x0281: {
            n: "??"
        },
        0x0282: {
            n: "??"
        },
        0x0283: {
            n: "??"
        },
        0x0284: {
            n: "??"
        },
        0x0285: {
            n: "??"
        },
        0x0286: {
            n: "??"
        },
        0x0287: {
            n: "??"
        },
        0x0288: {
            n: "??"
        },
        0x0292: {
            n: "??"
        },
        0x0293: {
            n: "??"
        },
        0x0294: {
            n: "??"
        },
        0x0295: {
            n: "??"
        },
        0x0296: {
            n: "??"
        },
        0x0299: {
            n: "??"
        },
        0x029A: {
            n: "??"
        },
        0x0300: {
            n: "??"
        },
        0x0304: {
            n: "??"
        },
        0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        0x0640: {
            n: "??"
        },
        0x0642: {
            n: "??"
        },
        0x0701: {
            n: "??"
        },
        0x0702: {
            n: "??"
        },
        0x0703: {
            n: "??"
        },
        0x0704: {
            n: "??"
        },
        0x0780: {
            n: "??"
        },
        0x0800: {
            n: "??"
        },
        0x0801: {
            n: "??"
        },
        0x0804: {
            n: "??"
        },
        0x0A80: {
            n: "??"
        },
        0x2AF6: {
            n: "??"
        },
        0x3231: {
            n: "??"
        },
        0x6E49: {
            n: "??"
        },
        0x6F44: {
            n: "??"
        },
        0xFFFF: {
            n: ""
        }
    };
    /* TODO: fill out and verify this table across QP versions */ var QPWNFTable = {
        0x05: "dd-mmm-yy",
        0x06: "dd-mmm",
        0x07: "mmm-yy",
        0x08: "mm/dd/yy",
        0x0A: "hh:mm:ss AM/PM",
        0x0B: "hh:mm AM/PM",
        0x0E: "dd-mmm-yyyy",
        0x0F: "mmm-yyyy",
        /* It is suspected that the the low nybble specifies decimal places */ 0x0022: "0.00",
        0x0032: "0.00;[Red]0.00",
        0x0042: "0.00;\(0.00\)",
        0x0052: "0.00;[Red]\(0.00\)",
        0x00A2: '"$"#,##0.00;\\("$"#,##0.00\\)',
        0x0120: '0%',
        0x0130: '0E+00',
        0x0140: '# ?/?'
    };
    function parse_qpw_str(p) {
        var cch = p.read_shift(2);
        var flags = p.read_shift(1);
        /* TODO: find examples with nonzero flags */ if (flags != 0) throw "unsupported QPW string type " + flags.toString(16);
        return p.read_shift(cch, "sbcs-cont");
    }
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $3ee4f50b1ae43a89$var$prep_blob(d, 0);
        var o = opts || {};
        if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        var FMTS = [];
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $3ee4f50b1ae43a89$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                case 0x08:
                    break; // TODO: this is tied to custom number formats
                case 0x0A:
                    var fcnt = p.read_shift(4);
                    var step = (p.length - p.l) / fcnt | 0;
                    for(var ifmt = 0; ifmt < fcnt; ++ifmt){
                        var end = p.l + step;
                        var fmt = {};
                        p.l += 2;
                        fmt.numFmtId = p.read_shift(2);
                        if (QPWNFTable[fmt.numFmtId]) fmt.z = QPWNFTable[fmt.numFmtId];
                        p.l = end;
                        FMTS.push(fmt);
                    }
                    break;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $3ee4f50b1ae43a89$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                    $3ee4f50b1ae43a89$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $3ee4f50b1ae43a89$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1), fmtidx = -1;
                        if (flags & 0x80) fmtidx = p.read_shift(2);
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 0:
                                break;
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 4:
                                cell = {
                                    t: "n",
                                    v: $3ee4f50b1ae43a89$var$parse_RkNumber(p)
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                if (isNaN(cell.v)) cell = {
                                    t: "e",
                                    v: 0x0F
                                }; // #VALUE!
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        if (fmtidx != -1 && (FMTS[fmtidx - 1] || {}).z) cell.z = FMTS[fmtidx - 1].z;
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            var newcell = $3ee4f50b1ae43a89$var$dup(cell);
                            if (cell.t == "n" && cell.z && $3ee4f50b1ae43a89$var$fmt_is_date(cell.z) && o.cellDates) {
                                newcell.v = $3ee4f50b1ae43a89$var$numdate(cell.v);
                                newcell.t = typeof newcell.v == "number" ? 'n' : 'd';
                            }
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = newcell;
                            } else s[CC + $3ee4f50b1ae43a89$var$encode_row(R)] = newcell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            fmtidx;
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $3ee4f50b1ae43a89$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                case 0x0C02:
                    C = p.read_shift(2);
                    R = p.read_shift(4);
                    var str = parse_qpw_str(p);
                    /* TODO: QP10 record has an additional unknown character after the string */ if (s["!data"] != null) {
                        if (!s["!data"][R]) s["!data"][R] = [];
                        s["!data"][R][C] = {
                            t: "s",
                            v: str
                        };
                    } else s[$3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R)] = {
                        t: "s",
                        v: str
                    };
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $3ee4f50b1ae43a89$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($3ee4f50b1ae43a89$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $3ee4f50b1ae43a89$var$parsexmltag(m[i]);
        switch(y[0].replace(/<\w*:/g, "<")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $3ee4f50b1ae43a89$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $3ee4f50b1ae43a89$var$parse_rs = /*#__PURE__*/ function() {
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = $3ee4f50b1ae43a89$var$str_match_xml_ns(r, "t") /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $3ee4f50b1ae43a89$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = $3ee4f50b1ae43a89$var$str_match_xml_ns(r, "rPr");
        if (rpr) o.s = $3ee4f50b1ae43a89$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $3ee4f50b1ae43a89$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $3ee4f50b1ae43a89$var$sitregex = /<(?:\w+:)?t\b[^<>]*>([^<]*)<\/(?:\w+:)?t>/g, $3ee4f50b1ae43a89$var$sirregex = /<(?:\w+:)?r\b[^<>]*>/;
function $3ee4f50b1ae43a89$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $3ee4f50b1ae43a89$var$utf8read(x);
        if (html) z.h = $3ee4f50b1ae43a89$var$escapehtml(z.t);
    } else if (/*y = */ x.match($3ee4f50b1ae43a89$var$sirregex)) {
        z.r = $3ee4f50b1ae43a89$var$utf8read(x);
        z.t = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(($3ee4f50b1ae43a89$var$str_remove_xml_ns_g(x, "rPh").match($3ee4f50b1ae43a89$var$sitregex) || []).join("").replace($3ee4f50b1ae43a89$var$tagregex, "")), true);
        if (html) z.h = $3ee4f50b1ae43a89$var$rs_to_html($3ee4f50b1ae43a89$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $3ee4f50b1ae43a89$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $3ee4f50b1ae43a89$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $3ee4f50b1ae43a89$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "sst");
    if (sst) {
        ss = sst[1].replace($3ee4f50b1ae43a89$var$sstr1, "").split($3ee4f50b1ae43a89$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $3ee4f50b1ae43a89$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $3ee4f50b1ae43a89$var$parsexmltag(sst[0].slice(0, sst[0].indexOf(">")));
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $3ee4f50b1ae43a89$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $3ee4f50b1ae43a89$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag('sst', null, {
        xmlns: $3ee4f50b1ae43a89$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($3ee4f50b1ae43a89$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $3ee4f50b1ae43a89$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $3ee4f50b1ae43a89$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $3ee4f50b1ae43a89$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_sst(val1, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val1[0];
                s.Unique = val1[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val1);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $3ee4f50b1ae43a89$var$write_BrtSSTItem = $3ee4f50b1ae43a89$var$write_RichStr;
function $3ee4f50b1ae43a89$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x009F /* BrtBeginSst */ , $3ee4f50b1ae43a89$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$3ee4f50b1ae43a89$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $3ee4f50b1ae43a89$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $3ee4f50b1ae43a89$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined') return $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $3ee4f50b1ae43a89$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.U = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.W = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $3ee4f50b1ae43a89$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $3ee4f50b1ae43a89$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($3ee4f50b1ae43a89$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $3ee4f50b1ae43a89$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $3ee4f50b1ae43a89$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.U = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.W = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $3ee4f50b1ae43a89$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $3ee4f50b1ae43a89$var$parse_EncryptionInfo(blob) {
    var vers = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, sz);
    var verifier = $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($3ee4f50b1ae43a89$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $3ee4f50b1ae43a89$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $3ee4f50b1ae43a89$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $3ee4f50b1ae43a89$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $3ee4f50b1ae43a89$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $3ee4f50b1ae43a89$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $3ee4f50b1ae43a89$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $3ee4f50b1ae43a89$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $3ee4f50b1ae43a89$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $3ee4f50b1ae43a89$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $3ee4f50b1ae43a89$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $3ee4f50b1ae43a89$var$parseuint16(blob),
        verificationBytes: $3ee4f50b1ae43a89$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $3ee4f50b1ae43a89$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $3ee4f50b1ae43a89$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $3ee4f50b1ae43a89$var$parse_RC4Header(blob, length);
    else o.Data = $3ee4f50b1ae43a89$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $3ee4f50b1ae43a89$var$parse_FilePassHeader(blob, length - 2, o);
    else $3ee4f50b1ae43a89$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $3ee4f50b1ae43a89$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $3ee4f50b1ae43a89$var$rtf_to_sheet_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
        case "binary":
            return $3ee4f50b1ae43a89$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $3ee4f50b1ae43a89$var$rtf_to_sheet_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d), opts);
        case "array":
            return $3ee4f50b1ae43a89$var$rtf_to_sheet_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $3ee4f50b1ae43a89$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = $3ee4f50b1ae43a89$var$str_match_ng(str, "\\trowd", "\\row");
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $3ee4f50b1ae43a89$var$fuzzynum(cell.v);
                        } else if ($3ee4f50b1ae43a89$var$RBErr[cell.v] != null) {
                            cell.t = "e";
                            cell.w = cell.v;
                            cell.v = $3ee4f50b1ae43a89$var$RBErr[cell.v];
                        }
                        if (dense) row[C] = cell;
                        else ws[$3ee4f50b1ae43a89$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    return ws;
}
function $3ee4f50b1ae43a89$var$rtf_to_workbook(d, opts) {
    var wb = $3ee4f50b1ae43a89$var$sheet_to_workbook($3ee4f50b1ae43a89$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $3ee4f50b1ae43a89$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $3ee4f50b1ae43a89$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $3ee4f50b1ae43a89$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $3ee4f50b1ae43a89$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $3ee4f50b1ae43a89$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $3ee4f50b1ae43a89$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $3ee4f50b1ae43a89$var$rgb2HSL($3ee4f50b1ae43a89$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $3ee4f50b1ae43a89$var$rgb2Hex($3ee4f50b1ae43a89$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $3ee4f50b1ae43a89$var$DEF_MDW = 6, $3ee4f50b1ae43a89$var$MAX_MDW = 15, $3ee4f50b1ae43a89$var$MIN_MDW = 1, $3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$DEF_MDW;
function $3ee4f50b1ae43a89$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $3ee4f50b1ae43a89$var$MDW) / 256) * $3ee4f50b1ae43a89$var$MDW);
}
function $3ee4f50b1ae43a89$var$px2char(px) {
    return Math.floor((px - 5) / $3ee4f50b1ae43a89$var$MDW * 100 + 0.5) / 100;
}
function $3ee4f50b1ae43a89$var$char2width(chr) {
    return Math.round((chr * $3ee4f50b1ae43a89$var$MDW + 5) / $3ee4f50b1ae43a89$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $3ee4f50b1ae43a89$var$cycle_width(collw) {
    return $3ee4f50b1ae43a89$var$char2width($3ee4f50b1ae43a89$var$px2char($3ee4f50b1ae43a89$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $3ee4f50b1ae43a89$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw)), _MDW = $3ee4f50b1ae43a89$var$MDW;
    if (delta > 0.005) {
        for($3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$MIN_MDW; $3ee4f50b1ae43a89$var$MDW < $3ee4f50b1ae43a89$var$MAX_MDW; ++$3ee4f50b1ae43a89$var$MDW)if (Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw));
            _MDW = $3ee4f50b1ae43a89$var$MDW;
        }
    }
    $3ee4f50b1ae43a89$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $3ee4f50b1ae43a89$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $3ee4f50b1ae43a89$var$width2px(coll.width);
        coll.wch = $3ee4f50b1ae43a89$var$px2char(coll.wpx);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $3ee4f50b1ae43a89$var$px2char(coll.wpx);
        coll.width = $3ee4f50b1ae43a89$var$char2width(coll.wch);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $3ee4f50b1ae43a89$var$char2width(coll.wch);
        coll.wpx = $3ee4f50b1ae43a89$var$width2px(coll.width);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $3ee4f50b1ae43a89$var$DEF_PPI = 96, $3ee4f50b1ae43a89$var$PPI = $3ee4f50b1ae43a89$var$DEF_PPI;
function $3ee4f50b1ae43a89$var$px2pt(px) {
    return px * 96 / $3ee4f50b1ae43a89$var$PPI;
}
function $3ee4f50b1ae43a89$var$pt2px(pt) {
    return pt * $3ee4f50b1ae43a89$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $3ee4f50b1ae43a89$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $3ee4f50b1ae43a89$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $3ee4f50b1ae43a89$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $3ee4f50b1ae43a89$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $3ee4f50b1ae43a89$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $3ee4f50b1ae43a89$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $3ee4f50b1ae43a89$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            case '</b>':
            case '</b':
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            case '</i>':
            case '</i':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            case '</u>':
            case '</u':
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
            case '</strike':
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
            case '</outline':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
            case '</shadow':
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            case '</condense>':
            case '</condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            case '</extend>':
            case '</extend':
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
            case '</sz':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
            case '</vertAlign':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
            case '</family':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
            case '</scheme':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $3ee4f50b1ae43a89$var$CS2CP[parseInt(y.val, 10)];
                break;
            case '<charset/>':
            case '</charset>':
            case '</charset':
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $3ee4f50b1ae43a89$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $3ee4f50b1ae43a89$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $3ee4f50b1ae43a89$var$XLSIcv[1];
                    if (!icv) icv = $3ee4f50b1ae43a89$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
            case '</color':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
            case '</AlternateContent':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $3ee4f50b1ae43a89$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $3ee4f50b1ae43a89$var$keys($3ee4f50b1ae43a89$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $3ee4f50b1ae43a89$var$table_fmt[k[i]];
    var m = t.match($3ee4f50b1ae43a89$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $3ee4f50b1ae43a89$var$parsexmltag(m[i]);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $3ee4f50b1ae43a89$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $3ee4f50b1ae43a89$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $3ee4f50b1ae43a89$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $3ee4f50b1ae43a89$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $3ee4f50b1ae43a89$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $3ee4f50b1ae43a89$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $3ee4f50b1ae43a89$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $3ee4f50b1ae43a89$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x), i = 0;
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
            case '<xf>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $3ee4f50b1ae43a89$var$cellXF_uint.length; ++i)if (xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]]) xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]] = parseInt(xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]], 10);
                for(i = 0; i < $3ee4f50b1ae43a89$var$cellXF_bool.length; ++i)if (xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]]) xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]] = $3ee4f50b1ae43a89$var$parsexmlbool(xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
            case '<alignment>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $3ee4f50b1ae43a89$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
            case '<protection>':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $3ee4f50b1ae43a89$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $3ee4f50b1ae43a89$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $3ee4f50b1ae43a89$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $3ee4f50b1ae43a89$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = $3ee4f50b1ae43a89$var$remove_doctype($3ee4f50b1ae43a89$var$str_remove_ng(data, "<!--", "-->"));
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "numFmts")) $3ee4f50b1ae43a89$var$parse_numFmts(t[0], styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "fonts")) $3ee4f50b1ae43a89$var$parse_fonts(t[0], styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "fills")) $3ee4f50b1ae43a89$var$parse_fills(t[0], styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "borders")) $3ee4f50b1ae43a89$var$parse_borders(t[0], styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "cellXfs")) $3ee4f50b1ae43a89$var$parse_cellXfs(t[0], styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $3ee4f50b1ae43a89$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('styleSheet', null, {
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS_main[0],
            'xmlns:vt': $3ee4f50b1ae43a89$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $3ee4f50b1ae43a89$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $3ee4f50b1ae43a89$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $3ee4f50b1ae43a89$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $3ee4f50b1ae43a89$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $3ee4f50b1ae43a89$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $3ee4f50b1ae43a89$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $3ee4f50b1ae43a89$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 21);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $3ee4f50b1ae43a89$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $3ee4f50b1ae43a89$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $3ee4f50b1ae43a89$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $3ee4f50b1ae43a89$var$parse_BrtFill = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$write_BrtFill(fill, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(84);
    if (!$3ee4f50b1ae43a89$var$rev_XLSBFillPTNames) $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames = $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$XLSBFillPTNames);
    var fls /*:number*/  = $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $3ee4f50b1ae43a89$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $3ee4f50b1ae43a89$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $3ee4f50b1ae43a89$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $3ee4f50b1ae43a89$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $3ee4f50b1ae43a89$var$write_Blxf(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $3ee4f50b1ae43a89$var$parse_BrtBorder = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$write_BrtBorder(border, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* top */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* bottom */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* left */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* right */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $3ee4f50b1ae43a89$var$write_BrtStyle(style, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $3ee4f50b1ae43a89$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $3ee4f50b1ae43a89$var$new_buf(2052);
    o.write_shift(4, cnt);
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(defTableStyle, o);
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $3ee4f50b1ae43a89$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $3ee4f50b1ae43a89$var$table_fmt)styles.NumberFmt[y] = $3ee4f50b1ae43a89$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_sty(val1, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val1[0]] = val1[1];
                $3ee4f50b1ae43a89$var$SSF__load(val1[1], val1[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val1);
                if (val1.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val1.color.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[val1.color.theme].rgb, val1.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val1);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $3ee4f50b1ae43a89$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $3ee4f50b1ae43a89$var$write_record(ba, 0x002C /* BrtFmt */ , $3ee4f50b1ae43a89$var$write_BrtFmt(i, NF[i]));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $3ee4f50b1ae43a89$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002B /* BrtFont */ , $3ee4f50b1ae43a89$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $3ee4f50b1ae43a89$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x025B /* BrtBeginFills */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002D /* BrtFill */ , $3ee4f50b1ae43a89$var$write_BrtFill({
        patternType: "none"
    }));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002D /* BrtFill */ , $3ee4f50b1ae43a89$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $3ee4f50b1ae43a89$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $3ee4f50b1ae43a89$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002E /* BrtBorder */ , $3ee4f50b1ae43a89$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $3ee4f50b1ae43a89$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002F /* BrtXF */ , $3ee4f50b1ae43a89$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $3ee4f50b1ae43a89$var$write_CELLXFS_bin(ba, data) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $3ee4f50b1ae43a89$var$write_record(ba, 0x002F /* BrtXF */ , $3ee4f50b1ae43a89$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $3ee4f50b1ae43a89$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0030 /* BrtStyle */ , $3ee4f50b1ae43a89$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $3ee4f50b1ae43a89$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $3ee4f50b1ae43a89$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $3ee4f50b1ae43a89$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $3ee4f50b1ae43a89$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $3ee4f50b1ae43a89$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $3ee4f50b1ae43a89$var$write_sty_bin(wb, opts) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $3ee4f50b1ae43a89$var$write_FMTS_bin(ba, wb.SSF);
    $3ee4f50b1ae43a89$var$write_FONTS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_FILLS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_BORDERS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_CELLSTYLEXFS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $3ee4f50b1ae43a89$var$write_STYLES_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_DXFS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_TABLESTYLES_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $3ee4f50b1ae43a89$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $3ee4f50b1ae43a89$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $3ee4f50b1ae43a89$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            case '</a:srgbClr>':
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            case '</a:sysClr>':
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '</a:dk1>':
            case '</a:lt1>':
            case '<a:dk1>':
            case '<a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$3ee4f50b1ae43a89$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $3ee4f50b1ae43a89$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $3ee4f50b1ae43a89$var$parse_fmtScheme() {}
/* 20.1.6.10 themeElements CT_BaseStyles */ function $3ee4f50b1ae43a89$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    /* clrScheme CT_ColorScheme */ if (!(t = $3ee4f50b1ae43a89$var$str_match_xml(data, "a:clrScheme"))) throw new Error('clrScheme not found in themeElements');
    $3ee4f50b1ae43a89$var$parse_clrScheme(t, themes, opts);
    /* fontScheme CT_FontScheme */ if (!(t = $3ee4f50b1ae43a89$var$str_match_xml(data, "a:fontScheme"))) throw new Error('fontScheme not found in themeElements');
    $3ee4f50b1ae43a89$var$parse_fontScheme(t, themes, opts);
    /* fmtScheme CT_StyleMatrix */ if (!(t = $3ee4f50b1ae43a89$var$str_match_xml(data, "a:fmtScheme"))) throw new Error('fmtScheme not found in themeElements');
    $3ee4f50b1ae43a89$var$parse_fmtScheme(t, themes, opts);
}
/* 14.2.7 Theme Part */ function $3ee4f50b1ae43a89$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $3ee4f50b1ae43a89$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = $3ee4f50b1ae43a89$var$str_match_xml(data, "a:themeElements"))) throw new Error('themeElements not found in theme');
    $3ee4f50b1ae43a89$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $3ee4f50b1ae43a89$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $3ee4f50b1ae43a89$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $3ee4f50b1ae43a89$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $3ee4f50b1ae43a89$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $3ee4f50b1ae43a89$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $3ee4f50b1ae43a89$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $3ee4f50b1ae43a89$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $3ee4f50b1ae43a89$var$parse_IcvXF(blob, length) {
    return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $3ee4f50b1ae43a89$var$parse_XFExtGradient(blob, length) {
    return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $3ee4f50b1ae43a89$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $3ee4f50b1ae43a89$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $3ee4f50b1ae43a89$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $3ee4f50b1ae43a89$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($3ee4f50b1ae43a89$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $3ee4f50b1ae43a89$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $3ee4f50b1ae43a89$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 8)
    };
}
function $3ee4f50b1ae43a89$var$write_BrtMdtinfo(data) {
    var o = $3ee4f50b1ae43a89$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $3ee4f50b1ae43a89$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtMdb(mdb) {
    var o = $3ee4f50b1ae43a89$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $3ee4f50b1ae43a89$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $3ee4f50b1ae43a89$var$recordhopper(data, function(val1, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val1.name
                });
                break;
            case 51:
                val1.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val1 ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_xlmeta_bin() {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 332);
    $3ee4f50b1ae43a89$var$write_record(ba, 334, $3ee4f50b1ae43a89$var$write_UInt32LE(1));
    $3ee4f50b1ae43a89$var$write_record(ba, 335, $3ee4f50b1ae43a89$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $3ee4f50b1ae43a89$var$write_record(ba, 336);
    $3ee4f50b1ae43a89$var$write_record(ba, 339, $3ee4f50b1ae43a89$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $3ee4f50b1ae43a89$var$write_record(ba, 52);
    $3ee4f50b1ae43a89$var$write_record(ba, 35, $3ee4f50b1ae43a89$var$write_UInt32LE(514));
    $3ee4f50b1ae43a89$var$write_record(ba, 4096, $3ee4f50b1ae43a89$var$write_UInt32LE(0));
    $3ee4f50b1ae43a89$var$write_record(ba, 4097, $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_record(ba, 36);
    $3ee4f50b1ae43a89$var$write_record(ba, 53);
    $3ee4f50b1ae43a89$var$write_record(ba, 340);
    $3ee4f50b1ae43a89$var$write_record(ba, 337, $3ee4f50b1ae43a89$var$write_BrtBeginEsmdb(1, true));
    $3ee4f50b1ae43a89$var$write_record(ba, 51, $3ee4f50b1ae43a89$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $3ee4f50b1ae43a89$var$write_record(ba, 338);
    $3ee4f50b1ae43a89$var$write_record(ba, 333);
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_xlmeta_xml() {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $3ee4f50b1ae43a89$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $3ee4f50b1ae43a89$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $3ee4f50b1ae43a89$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $3ee4f50b1ae43a89$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_cc(val1, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val1);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $3ee4f50b1ae43a89$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $3ee4f50b1ae43a89$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function xlink_parse(val1, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $3ee4f50b1ae43a89$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^<>]*r:id="([^<>"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $3ee4f50b1ae43a89$var$parse_vml(data /*:string*/ , sheet, comments) {
    var cidx = 0;
    ($3ee4f50b1ae43a89$var$str_match_xml_ns_g(data, "shape") || []).forEach(function(m) {
        var type = "";
        var hidden = true;
        var aidx = -1;
        var R = -1, C = -1;
        m.replace($3ee4f50b1ae43a89$var$tagregex, function(x /*:string*/ , idx /*:number*/ ) {
            var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
            switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
                case '<ClientData':
                    if (y.ObjectType) type = y.ObjectType;
                    break;
                case '<Visible':
                case '<Visible/>':
                    hidden = false;
                    break;
                case '<Row':
                case '<Row>':
                    aidx = idx + x.length;
                    break;
                case '</Row>':
                    R = +m.slice(aidx, idx).trim();
                    break;
                case '<Column':
                case '<Column>':
                    aidx = idx + x.length;
                    break;
                case '</Column>':
                    C = +m.slice(aidx, idx).trim();
                    break;
            }
            return "";
        });
        switch(type){
            case 'Note':
                var cell = $3ee4f50b1ae43a89$var$ws_get_cell_stub(sheet, R >= 0 && C >= 0 ? $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                }) : comments[cidx].ref);
                if (cell.c) cell.c.hidden = hidden;
                ++cidx;
                break;
        }
    });
}
/* comment boxes */ function $3ee4f50b1ae43a89$var$write_vml(rId /*:number*/ , comments, ws) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $3ee4f50b1ae43a89$var$writextag("xml", null, {
            'xmlns:v': $3ee4f50b1ae43a89$var$XLMLNS.v,
            'xmlns:o': $3ee4f50b1ae43a89$var$XLMLNS.o,
            'xmlns:x': $3ee4f50b1ae43a89$var$XLMLNS.x,
            'xmlns:mv': $3ee4f50b1ae43a89$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $3ee4f50b1ae43a89$var$writextag("o:shapelayout", $3ee4f50b1ae43a89$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($3ee4f50b1ae43a89$var$writextag("v:shapetype", [
        $3ee4f50b1ae43a89$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $3ee4f50b1ae43a89$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($3ee4f50b1ae43a89$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_vml_comment(x, _shapeid, ws) /*:string*/ {
    var c = $3ee4f50b1ae43a89$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $3ee4f50b1ae43a89$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $3ee4f50b1ae43a89$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $3ee4f50b1ae43a89$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $3ee4f50b1ae43a89$var$writextag("v:shadow", null, shadata),
        $3ee4f50b1ae43a89$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $3ee4f50b1ae43a89$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $3ee4f50b1ae43a89$var$writetag('x:AutoFill', "False"),
        $3ee4f50b1ae43a89$var$writetag('x:Row', String(c.r)),
        $3ee4f50b1ae43a89$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $3ee4f50b1ae43a89$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $3ee4f50b1ae43a89$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $3ee4f50b1ae43a89$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $3ee4f50b1ae43a89$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "authors");
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^<>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "commentList");
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^<>]*>/);
        if (!cm) return;
        var y = $3ee4f50b1ae43a89$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $3ee4f50b1ae43a89$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = $3ee4f50b1ae43a89$var$str_match_xml_ns(x, "text");
        var rt = !!textMatch && !!textMatch[1] && $3ee4f50b1ae43a89$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $3ee4f50b1ae43a89$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('comments', null, {
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $3ee4f50b1ae43a89$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($3ee4f50b1ae43a89$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $3ee4f50b1ae43a89$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($3ee4f50b1ae43a89$var$escapexml(c.a)) + '"><text>');
            o.push($3ee4f50b1ae43a89$var$writetag("t", c.t == null ? "" : $3ee4f50b1ae43a89$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($3ee4f50b1ae43a89$var$writetag("t", $3ee4f50b1ae43a89$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $3ee4f50b1ae43a89$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('ThreadedComments', null, {
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($3ee4f50b1ae43a89$var$writextag('threadedComment', $3ee4f50b1ae43a89$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $3ee4f50b1ae43a89$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('personList', null, {
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS.TCMNT,
            'xmlns:x': $3ee4f50b1ae43a89$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($3ee4f50b1ae43a89$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $3ee4f50b1ae43a89$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $3ee4f50b1ae43a89$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $3ee4f50b1ae43a89$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $3ee4f50b1ae43a89$var$parse_BrtCommentAuthor = $3ee4f50b1ae43a89$var$parse_XLWideString;
function $3ee4f50b1ae43a89$var$write_BrtCommentAuthor(data) {
    return $3ee4f50b1ae43a89$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $3ee4f50b1ae43a89$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_cmnt(val1, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val1);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val1;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val1.t;
                c.h = val1.h;
                c.r = val1.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $3ee4f50b1ae43a89$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $3ee4f50b1ae43a89$var$write_BrtCommentAuthor(c.a));
            if (c.T && c.ID && iauthor.indexOf("tc=" + c.ID) == -1) {
                iauthor.push("tc=" + c.ID);
                $3ee4f50b1ae43a89$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $3ee4f50b1ae43a89$var$write_BrtCommentAuthor("tc=" + c.ID));
            }
        });
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            var _ia = -1;
            if (c.ID) _ia = iauthor.indexOf("tc=" + c.ID);
            if (_ia == -1 && comment[1][0].T && comment[1][0].ID) _ia = iauthor.indexOf("tc=" + comment[1][0].ID);
            if (_ia == -1) _ia = iauthor.indexOf(c.a);
            c.iauthor = _ia;
            var range = {
                s: $3ee4f50b1ae43a89$var$decode_cell(comment[0]),
                e: $3ee4f50b1ae43a89$var$decode_cell(comment[0])
            };
            $3ee4f50b1ae43a89$var$write_record(ba, 0x027B /* BrtBeginComment */ , $3ee4f50b1ae43a89$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $3ee4f50b1ae43a89$var$write_record(ba, 0x027D /* BrtCommentText */ , $3ee4f50b1ae43a89$var$write_BrtCommentText(c));
            $3ee4f50b1ae43a89$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $3ee4f50b1ae43a89$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $3ee4f50b1ae43a89$var$make_vba_xls(cfb) {
    var newcfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(newcfb);
}
function $3ee4f50b1ae43a89$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/^[\/]*[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $3ee4f50b1ae43a89$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $3ee4f50b1ae43a89$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $3ee4f50b1ae43a89$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $3ee4f50b1ae43a89$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $3ee4f50b1ae43a89$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $3ee4f50b1ae43a89$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(C) + (rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $3ee4f50b1ae43a89$var$crefregex = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
    $3ee4f50b1ae43a89$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch (e) {}
var $3ee4f50b1ae43a89$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($3ee4f50b1ae43a89$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $3ee4f50b1ae43a89$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $3ee4f50b1ae43a89$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $3ee4f50b1ae43a89$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($3ee4f50b1ae43a89$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $3ee4f50b1ae43a89$var$encode_col($3ee4f50b1ae43a89$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $3ee4f50b1ae43a89$var$encode_row($3ee4f50b1ae43a89$var$decode_row($5) + delta.r));
    });
}
function $3ee4f50b1ae43a89$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $3ee4f50b1ae43a89$var$decode_range(range), s = r.s, c = $3ee4f50b1ae43a89$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $3ee4f50b1ae43a89$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $3ee4f50b1ae43a89$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $3ee4f50b1ae43a89$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $3ee4f50b1ae43a89$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $3ee4f50b1ae43a89$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $3ee4f50b1ae43a89$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var C = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2), R = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $3ee4f50b1ae43a89$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var C = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $3ee4f50b1ae43a89$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $3ee4f50b1ae43a89$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $3ee4f50b1ae43a89$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $3ee4f50b1ae43a89$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $3ee4f50b1ae43a89$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $3ee4f50b1ae43a89$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $3ee4f50b1ae43a89$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $3ee4f50b1ae43a89$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $3ee4f50b1ae43a89$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $3ee4f50b1ae43a89$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $3ee4f50b1ae43a89$var$FtabArgc[iftab],
        $3ee4f50b1ae43a89$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $3ee4f50b1ae43a89$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $3ee4f50b1ae43a89$var$Ftab : $3ee4f50b1ae43a89$var$Cetab)[tab[1]]
    ];
}
function $3ee4f50b1ae43a89$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $3ee4f50b1ae43a89$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $3ee4f50b1ae43a89$var$parse_PtgErr(blob) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $3ee4f50b1ae43a89$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $3ee4f50b1ae43a89$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $3ee4f50b1ae43a89$var$parse_PtgNum(blob) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $3ee4f50b1ae43a89$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $3ee4f50b1ae43a89$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val1 = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val1[0]){
        case 0x02:
            val1[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val1[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val1[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val1[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val1[0]){
        case 0x04:
            /* SerBool -- boolean */ val1[1] = $3ee4f50b1ae43a89$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val1[1] = $3ee4f50b1ae43a89$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val1[1] = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val1[1] = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val1[0]); /* Unreachable */ 
    }
    return val1;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $3ee4f50b1ae43a89$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $3ee4f50b1ae43a89$var$parse_UncheckedRfX : $3ee4f50b1ae43a89$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $3ee4f50b1ae43a89$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $3ee4f50b1ae43a89$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $3ee4f50b1ae43a89$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $3ee4f50b1ae43a89$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $3ee4f50b1ae43a89$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $3ee4f50b1ae43a89$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $3ee4f50b1ae43a89$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $3ee4f50b1ae43a89$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $3ee4f50b1ae43a89$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $3ee4f50b1ae43a89$var$parse_PtgMemErr = $3ee4f50b1ae43a89$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $3ee4f50b1ae43a89$var$parse_PtgMemNoMem = $3ee4f50b1ae43a89$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $3ee4f50b1ae43a89$var$parse_PtgTbl = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $3ee4f50b1ae43a89$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $3ee4f50b1ae43a89$var$parse_PtgElfCol = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColS = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColSV = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColV = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $3ee4f50b1ae43a89$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $3ee4f50b1ae43a89$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadical = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadicalLel = $3ee4f50b1ae43a89$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadicalS = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRw = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRwV = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $3ee4f50b1ae43a89$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $3ee4f50b1ae43a89$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $3ee4f50b1ae43a89$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $3ee4f50b1ae43a89$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $3ee4f50b1ae43a89$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $3ee4f50b1ae43a89$var$PtgTypes = {
    0x01: {
        n: 'PtgExp',
        f: $3ee4f50b1ae43a89$var$parse_PtgExp
    },
    0x02: {
        n: 'PtgTbl',
        f: $3ee4f50b1ae43a89$var$parse_PtgTbl
    },
    0x03: {
        n: 'PtgAdd',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x04: {
        n: 'PtgSub',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x05: {
        n: 'PtgMul',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x06: {
        n: 'PtgDiv',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x07: {
        n: 'PtgPower',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x08: {
        n: 'PtgConcat',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x09: {
        n: 'PtgLt',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x0A: {
        n: 'PtgLe',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x0B: {
        n: 'PtgEq',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x0C: {
        n: 'PtgGe',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x0D: {
        n: 'PtgGt',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x0E: {
        n: 'PtgNe',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x0F: {
        n: 'PtgIsect',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x10: {
        n: 'PtgUnion',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x11: {
        n: 'PtgRange',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x12: {
        n: 'PtgUplus',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x13: {
        n: 'PtgUminus',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x14: {
        n: 'PtgPercent',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x15: {
        n: 'PtgParen',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x16: {
        n: 'PtgMissArg',
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    0x17: {
        n: 'PtgStr',
        f: $3ee4f50b1ae43a89$var$parse_PtgStr
    },
    0x1A: {
        n: 'PtgSheet',
        f: $3ee4f50b1ae43a89$var$parse_PtgSheet
    },
    0x1B: {
        n: 'PtgEndSheet',
        f: $3ee4f50b1ae43a89$var$parse_PtgEndSheet
    },
    0x1C: {
        n: 'PtgErr',
        f: $3ee4f50b1ae43a89$var$parse_PtgErr
    },
    0x1D: {
        n: 'PtgBool',
        f: $3ee4f50b1ae43a89$var$parse_PtgBool
    },
    0x1E: {
        n: 'PtgInt',
        f: $3ee4f50b1ae43a89$var$parse_PtgInt
    },
    0x1F: {
        n: 'PtgNum',
        f: $3ee4f50b1ae43a89$var$parse_PtgNum
    },
    0x20: {
        n: 'PtgArray',
        f: $3ee4f50b1ae43a89$var$parse_PtgArray
    },
    0x21: {
        n: 'PtgFunc',
        f: $3ee4f50b1ae43a89$var$parse_PtgFunc
    },
    0x22: {
        n: 'PtgFuncVar',
        f: $3ee4f50b1ae43a89$var$parse_PtgFuncVar
    },
    0x23: {
        n: 'PtgName',
        f: $3ee4f50b1ae43a89$var$parse_PtgName
    },
    0x24: {
        n: 'PtgRef',
        f: $3ee4f50b1ae43a89$var$parse_PtgRef
    },
    0x25: {
        n: 'PtgArea',
        f: $3ee4f50b1ae43a89$var$parse_PtgArea
    },
    0x26: {
        n: 'PtgMemArea',
        f: $3ee4f50b1ae43a89$var$parse_PtgMemArea
    },
    0x27: {
        n: 'PtgMemErr',
        f: $3ee4f50b1ae43a89$var$parse_PtgMemErr
    },
    0x28: {
        n: 'PtgMemNoMem',
        f: $3ee4f50b1ae43a89$var$parse_PtgMemNoMem
    },
    0x29: {
        n: 'PtgMemFunc',
        f: $3ee4f50b1ae43a89$var$parse_PtgMemFunc
    },
    0x2A: {
        n: 'PtgRefErr',
        f: $3ee4f50b1ae43a89$var$parse_PtgRefErr
    },
    0x2B: {
        n: 'PtgAreaErr',
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaErr
    },
    0x2C: {
        n: 'PtgRefN',
        f: $3ee4f50b1ae43a89$var$parse_PtgRefN
    },
    0x2D: {
        n: 'PtgAreaN',
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaN
    },
    0x2E: {
        n: 'PtgMemAreaN',
        f: $3ee4f50b1ae43a89$var$parse_PtgMemAreaN
    },
    0x2F: {
        n: 'PtgMemNoMemN',
        f: $3ee4f50b1ae43a89$var$parse_PtgMemNoMemN
    },
    0x39: {
        n: 'PtgNameX',
        f: $3ee4f50b1ae43a89$var$parse_PtgNameX
    },
    0x3A: {
        n: 'PtgRef3d',
        f: $3ee4f50b1ae43a89$var$parse_PtgRef3d
    },
    0x3B: {
        n: 'PtgArea3d',
        f: $3ee4f50b1ae43a89$var$parse_PtgArea3d
    },
    0x3C: {
        n: 'PtgRefErr3d',
        f: $3ee4f50b1ae43a89$var$parse_PtgRefErr3d
    },
    0x3D: {
        n: 'PtgAreaErr3d',
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaErr3d
    },
    0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $3ee4f50b1ae43a89$var$PtgDupes = {
    0x40: 0x20,
    0x60: 0x20,
    0x41: 0x21,
    0x61: 0x21,
    0x42: 0x22,
    0x62: 0x22,
    0x43: 0x23,
    0x63: 0x23,
    0x44: 0x24,
    0x64: 0x24,
    0x45: 0x25,
    0x65: 0x25,
    0x46: 0x26,
    0x66: 0x26,
    0x47: 0x27,
    0x67: 0x27,
    0x48: 0x28,
    0x68: 0x28,
    0x49: 0x29,
    0x69: 0x29,
    0x4A: 0x2A,
    0x6A: 0x2A,
    0x4B: 0x2B,
    0x6B: 0x2B,
    0x4C: 0x2C,
    0x6C: 0x2C,
    0x4D: 0x2D,
    0x6D: 0x2D,
    0x4E: 0x2E,
    0x6E: 0x2E,
    0x4F: 0x2F,
    0x6F: 0x2F,
    0x58: 0x22,
    0x78: 0x22,
    0x59: 0x39,
    0x79: 0x39,
    0x5A: 0x3A,
    0x7A: 0x3A,
    0x5B: 0x3B,
    0x7B: 0x3B,
    0x5C: 0x3C,
    0x7C: 0x3C,
    0x5D: 0x3D,
    0x7D: 0x3D
};
var $3ee4f50b1ae43a89$var$Ptg18 = {
    0x01: {
        n: 'PtgElfLel',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfLel
    },
    0x02: {
        n: 'PtgElfRw',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRw
    },
    0x03: {
        n: 'PtgElfCol',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfCol
    },
    0x06: {
        n: 'PtgElfRwV',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRwV
    },
    0x07: {
        n: 'PtgElfColV',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColV
    },
    0x0A: {
        n: 'PtgElfRadical',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadical
    },
    0x0B: {
        n: 'PtgElfRadicalS',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadicalS
    },
    0x0D: {
        n: 'PtgElfColS',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColS
    },
    0x0F: {
        n: 'PtgElfColSV',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColSV
    },
    0x10: {
        n: 'PtgElfRadicalLel',
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadicalLel
    },
    0x19: {
        n: 'PtgList',
        f: $3ee4f50b1ae43a89$var$parse_PtgList
    },
    0x1D: {
        n: 'PtgSxName',
        f: $3ee4f50b1ae43a89$var$parse_PtgSxName
    },
    0xFF: {}
};
var $3ee4f50b1ae43a89$var$Ptg19 = {
    0x00: {
        n: 'PtgAttrNoop',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrNoop
    },
    0x01: {
        n: 'PtgAttrSemi',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSemi
    },
    0x02: {
        n: 'PtgAttrIf',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrIf
    },
    0x04: {
        n: 'PtgAttrChoose',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrChoose
    },
    0x08: {
        n: 'PtgAttrGoto',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrGoto
    },
    0x10: {
        n: 'PtgAttrSum',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSum
    },
    0x20: {
        n: 'PtgAttrBaxcel',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel
    },
    0x21: {
        n: 'PtgAttrBaxcel',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel
    },
    0x40: {
        n: 'PtgAttrSpace',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSpace
    },
    0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceSemi
    },
    0x80: {
        n: 'PtgAttrIfError',
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrIfError
    },
    0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $3ee4f50b1ae43a89$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $3ee4f50b1ae43a89$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($3ee4f50b1ae43a89$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $3ee4f50b1ae43a89$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $3ee4f50b1ae43a89$var$PtgTypes[id] || $3ee4f50b1ae43a89$var$PtgTypes[$3ee4f50b1ae43a89$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $3ee4f50b1ae43a89$var$Ptg18 : $3ee4f50b1ae43a89$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $3ee4f50b1ae43a89$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $3ee4f50b1ae43a89$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $3ee4f50b1ae43a89$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $3ee4f50b1ae43a89$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $3ee4f50b1ae43a89$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $3ee4f50b1ae43a89$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $3ee4f50b1ae43a89$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($3ee4f50b1ae43a89$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $3ee4f50b1ae43a89$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $3ee4f50b1ae43a89$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$3ee4f50b1ae43a89$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$3ee4f50b1ae43a89$var$encode_cell(c)];
                    stack.push($3ee4f50b1ae43a89$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($3ee4f50b1ae43a89$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $3ee4f50b1ae43a89$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $3ee4f50b1ae43a89$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $3ee4f50b1ae43a89$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $3ee4f50b1ae43a89$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $3ee4f50b1ae43a89$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $3ee4f50b1ae43a89$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $3ee4f50b1ae43a89$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $3ee4f50b1ae43a89$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $3ee4f50b1ae43a89$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $3ee4f50b1ae43a89$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $3ee4f50b1ae43a89$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $3ee4f50b1ae43a89$var$write_Xnum(value);
    return $3ee4f50b1ae43a89$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $3ee4f50b1ae43a89$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6, opts);
    var val1 = $3ee4f50b1ae43a89$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $3ee4f50b1ae43a89$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val1[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val1[1]
    };
}
function $3ee4f50b1ae43a89$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $3ee4f50b1ae43a89$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $3ee4f50b1ae43a89$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $3ee4f50b1ae43a89$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $3ee4f50b1ae43a89$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $3ee4f50b1ae43a89$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBArrayParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBNameParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBSharedParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaNum(val1 /*:number*/ ) {
    if ((val1 | 0) == val1 && val1 < Math.pow(2, 16) && val1 >= 0) {
        var oint = $3ee4f50b1ae43a89$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val1);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $3ee4f50b1ae43a89$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val1);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaErr(val1 /*:number*/ ) {
    var oint = $3ee4f50b1ae43a89$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val1);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaBool(val1 /*:boolean*/ ) {
    var oint = $3ee4f50b1ae43a89$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val1 ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaStr(val1 /*:string*/ ) {
    var preamble = $3ee4f50b1ae43a89$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val1.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val1.length);
    var body = $3ee4f50b1ae43a89$var$new_buf(2 * val1.length);
    body.write_shift(2 * val1.length, val1, "utf16le");
    var postamble = $3ee4f50b1ae43a89$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $3ee4f50b1ae43a89$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaRef(str) {
    var cell = $3ee4f50b1ae43a89$var$decode_cell(str);
    var out = $3ee4f50b1ae43a89$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $3ee4f50b1ae43a89$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $3ee4f50b1ae43a89$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $3ee4f50b1ae43a89$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $3ee4f50b1ae43a89$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $3ee4f50b1ae43a89$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $3ee4f50b1ae43a89$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    var out = $3ee4f50b1ae43a89$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $3ee4f50b1ae43a89$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $3ee4f50b1ae43a89$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $3ee4f50b1ae43a89$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $3ee4f50b1ae43a89$var$decode_range(_str);
    var out = $3ee4f50b1ae43a89$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $3ee4f50b1ae43a89$var$write_XLSBFormula(val1 /*:string|number*/ , wb) {
    if (typeof val1 == "number") return $3ee4f50b1ae43a89$var$write_XLSBFormulaNum(val1);
    if (typeof val1 == "boolean") return $3ee4f50b1ae43a89$var$write_XLSBFormulaBool(val1);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val1)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaErr(+$3ee4f50b1ae43a89$var$RBErr[val1]);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaRef(val1);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaRange(val1);
    if (val1.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaArea3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaRef3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaRangeWS(val1, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val1)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaRefErr3D(val1, wb);
    if (/^".*"$/.test(val1)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaStr(val1);
    if (/^[+-]\d+$/.test(val1)) return $3ee4f50b1ae43a89$var$write_XLSBFormulaNum(parseInt(val1, 10));
    throw "Formula |" + val1 + "| not supported for XLSB";
}
var $3ee4f50b1ae43a89$var$write_XLSBNameParsedFormula = $3ee4f50b1ae43a89$var$write_XLSBFormula;
var $3ee4f50b1ae43a89$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $3ee4f50b1ae43a89$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $3ee4f50b1ae43a89$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $3ee4f50b1ae43a89$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $3ee4f50b1ae43a89$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($3ee4f50b1ae43a89$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $3ee4f50b1ae43a89$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $3ee4f50b1ae43a89$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".").replace(/:/, ":.");
}
var $3ee4f50b1ae43a89$var$strs = {}; // shared strings
var $3ee4f50b1ae43a89$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $3ee4f50b1ae43a89$var$browser_has_Map = typeof Map !== 'undefined';
function $3ee4f50b1ae43a89$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($3ee4f50b1ae43a89$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $3ee4f50b1ae43a89$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($3ee4f50b1ae43a89$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $3ee4f50b1ae43a89$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $3ee4f50b1ae43a89$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $3ee4f50b1ae43a89$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $3ee4f50b1ae43a89$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $3ee4f50b1ae43a89$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $3ee4f50b1ae43a89$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $3ee4f50b1ae43a89$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $3ee4f50b1ae43a89$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles, date1904) {
    try {
        if (opts.cellNF) p.z = $3ee4f50b1ae43a89$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $3ee4f50b1ae43a89$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($3ee4f50b1ae43a89$var$table_fmt[fmtid] == null) $3ee4f50b1ae43a89$var$SSF__load($3ee4f50b1ae43a89$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $3ee4f50b1ae43a89$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $3ee4f50b1ae43a89$var$datenum(p.v, !!date1904);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $3ee4f50b1ae43a89$var$SSF_general(p.v, $3ee4f50b1ae43a89$var$_ssfopts);
        } else if (p.t === 'd') p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, $3ee4f50b1ae43a89$var$datenum(p.v, !!date1904), $3ee4f50b1ae43a89$var$_ssfopts);
        else p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, p.v, $3ee4f50b1ae43a89$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $3ee4f50b1ae43a89$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $3ee4f50b1ae43a89$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(d);
}
var $3ee4f50b1ae43a89$var$mergecregex = /<(?:\w+:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g;
var $3ee4f50b1ae43a89$var$hlinkregex = /<(?:\w+:)?hyperlink [^<>]*>/mg;
var $3ee4f50b1ae43a89$var$dimregex = /"(\w*:\w*)"/;
var $3ee4f50b1ae43a89$var$colregex = /<(?:\w+:)?col\b[^<>]*[\/]?>/g;
var $3ee4f50b1ae43a89$var$afregex = /<(?:\w+:)?autoFilter[^>]*/g;
var $3ee4f50b1ae43a89$var$marginregex = /<(?:\w+:)?pageMargins[^<>]*\/>/g;
var $3ee4f50b1ae43a89$var$sheetprregex = /<(?:\w+:)?sheetPr\b[^<>]*?\/>/;
/* 18.3 Worksheets */ function $3ee4f50b1ae43a89$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = $3ee4f50b1ae43a89$var$str_match_xml_ns(data, "sheetData");
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($3ee4f50b1ae43a89$var$sheetprregex);
    if (sheetPr) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = $3ee4f50b1ae43a89$var$str_match_xml_ns(data1, "sheetPr")) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($3ee4f50b1ae43a89$var$dimregex);
        if (ref && !(opts && opts.nodim)) $3ee4f50b1ae43a89$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = $3ee4f50b1ae43a89$var$str_match_xml_ns(data1, "sheetViews");
    if (svs && svs[1]) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($3ee4f50b1ae43a89$var$colregex);
        if (cols) $3ee4f50b1ae43a89$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $3ee4f50b1ae43a89$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles, wb);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($3ee4f50b1ae43a89$var$afregex);
    if (afilter) s['!autofilter'] = $3ee4f50b1ae43a89$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($3ee4f50b1ae43a89$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $3ee4f50b1ae43a89$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("=") + 2));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($3ee4f50b1ae43a89$var$hlinkregex);
    if (hlink) $3ee4f50b1ae43a89$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($3ee4f50b1ae43a89$var$marginregex);
    if (margins) s['!margins'] = $3ee4f50b1ae43a89$var$parse_ws_xml_margins($3ee4f50b1ae43a89$var$parsexmltag(margins[0]));
    /* legacyDrawing */ var m;
    if (m = data2.match(/legacyDrawing r:id="(.*?)"/)) s['!legrel'] = m[1];
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $3ee4f50b1ae43a89$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $3ee4f50b1ae43a89$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $3ee4f50b1ae43a89$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(data.codeName));
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $3ee4f50b1ae43a89$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $3ee4f50b1ae43a89$var$utf8write($3ee4f50b1ae43a89$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $3ee4f50b1ae43a89$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $3ee4f50b1ae43a89$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $3ee4f50b1ae43a89$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $3ee4f50b1ae43a89$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $3ee4f50b1ae43a89$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $3ee4f50b1ae43a89$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $3ee4f50b1ae43a89$var$writextag('sheetProtection', null, o);
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val1 = $3ee4f50b1ae43a89$var$parsexmltag($3ee4f50b1ae43a89$var$utf8read(data[i]), true);
        if (!val1.ref) return;
        var rel = ((rels || {})['!id'] || [])[val1.id];
        if (rel) {
            val1.Target = rel.Target;
            if (val1.location) val1.Target += "#" + $3ee4f50b1ae43a89$var$unescapexml(val1.location);
        } else {
            val1.Target = "#" + $3ee4f50b1ae43a89$var$unescapexml(val1.location);
            rel = {
                Target: val1.Target,
                TargetMode: 'Internal'
            };
        }
        val1.Rel = rel;
        if (val1.tooltip) {
            val1.Tooltip = val1.tooltip;
            delete val1.tooltip;
        }
        var rng = $3ee4f50b1ae43a89$var$safe_decode_range(val1.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val1;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val1;
            }
        }
    }
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_margins(margin) /*:string*/ {
    $3ee4f50b1ae43a89$var$default_margins(margin);
    return $3ee4f50b1ae43a89$var$writextag('pageMargins', null, margin);
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $3ee4f50b1ae43a89$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $3ee4f50b1ae43a89$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $3ee4f50b1ae43a89$var$find_mdw_colw(coll.width);
        }
        $3ee4f50b1ae43a89$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $3ee4f50b1ae43a89$var$dup(coll);
    }
}
function $3ee4f50b1ae43a89$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $3ee4f50b1ae43a89$var$writextag('col', null, $3ee4f50b1ae43a89$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $3ee4f50b1ae43a89$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $3ee4f50b1ae43a89$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]).e.r;
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $3ee4f50b1ae43a89$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $3ee4f50b1ae43a89$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $3ee4f50b1ae43a89$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $3ee4f50b1ae43a89$var$sviewregex = /<(?:\w:)?sheetView(?:[^<>a-z][^<>]*)?\/?>/g;
function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($3ee4f50b1ae43a89$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $3ee4f50b1ae43a89$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $3ee4f50b1ae43a89$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $3ee4f50b1ae43a89$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $3ee4f50b1ae43a89$var$writextag("sheetViews", $3ee4f50b1ae43a89$var$writextag("sheetView", null, sview), {});
}
function $3ee4f50b1ae43a89$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts, idx, wb, date1904) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            if (isNaN(cell.v)) {
                cell.t = "e";
                vv = $3ee4f50b1ae43a89$var$BErr[cell.v = 0x24];
            } else if (!isFinite(cell.v)) {
                cell.t = "e";
                vv = $3ee4f50b1ae43a89$var$BErr[cell.v = 0x07];
            } else vv = '' + cell.v;
            break;
        case 'e':
            vv = $3ee4f50b1ae43a89$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) {
                var _vv = $3ee4f50b1ae43a89$var$parseDate(cell.v, date1904);
                vv = _vv.toISOString();
                if (_vv.getUTCFullYear() < 1900) vv = vv.slice(vv.indexOf("T") + 1).replace("Z", "");
            } else {
                cell = $3ee4f50b1ae43a89$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v, date1904), date1904));
            }
            if (typeof cell.z === 'undefined') cell.z = $3ee4f50b1ae43a89$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $3ee4f50b1ae43a89$var$writetag('v', $3ee4f50b1ae43a89$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $3ee4f50b1ae43a89$var$writetag('v', '' + $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $3ee4f50b1ae43a89$var$writextag('f', $3ee4f50b1ae43a89$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $3ee4f50b1ae43a89$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $3ee4f50b1ae43a89$var$writextag('c', v, o);
}
var $3ee4f50b1ae43a89$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/;
    var refregex = /ref=["']([^"']*)["']/;
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles, wb) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        var date1904 = !!((wb || {}).WBProps || {}).date1904;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $3ee4f50b1ae43a89$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $3ee4f50b1ae43a89$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $3ee4f50b1ae43a89$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = $3ee4f50b1ae43a89$var$str_match_xml_ns(d, "v")) != null && /*::cref != null && */ cref[1] !== '') p.v = $3ee4f50b1ae43a89$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = $3ee4f50b1ae43a89$var$str_match_xml_ns(d, "f")) != null) {
                        if (cref[1] == "") {
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $3ee4f50b1ae43a89$var$parsexmltag(cref[0]);
                                if (sharedf[ftag.si]) p.f = $3ee4f50b1ae43a89$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                            }
                        } else {
                            /* TODO: match against XLSXFutureFunctions */ p.f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(cref[1]), true);
                            if (!opts.xlfn) p.f = $3ee4f50b1ae43a89$var$_xlfn(p.f);
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    $3ee4f50b1ae43a89$var$safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $3ee4f50b1ae43a89$var$parsexmltag(cref[0]);
                                var ___f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(cref[1]));
                                if (!opts.xlfn) ___f = $3ee4f50b1ae43a89$var$_xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        }
                    } else if (cref = d.match(/<f[^<>]*\/>/)) {
                        ftag = $3ee4f50b1ae43a89$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $3ee4f50b1ae43a89$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $3ee4f50b1ae43a89$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $3ee4f50b1ae43a89$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $3ee4f50b1ae43a89$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = $3ee4f50b1ae43a89$var$str_match_xml_ns(d, "is");
                        p.t = 's';
                        if (cref != null && (sstr = $3ee4f50b1ae43a89$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $3ee4f50b1ae43a89$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $3ee4f50b1ae43a89$var$parseDate(p.v, date1904);
                        else {
                            p.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(p.v, date1904), date1904);
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $3ee4f50b1ae43a89$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $3ee4f50b1ae43a89$var$safe_format(p, fmtid, fillid, opts, themes, styles, date1904);
                if (opts.cellDates && do_format && p.t == 'n' && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[fmtid])) {
                    p.v = $3ee4f50b1ae43a89$var$numdate(p.v + (date1904 ? 1462 : 0));
                    p.t = typeof p.v == "number" ? 'n' : 'd';
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $3ee4f50b1ae43a89$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $3ee4f50b1ae43a89$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $3ee4f50b1ae43a89$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null, data = dense ? ws["!data"] : [];
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        var data_R = dense ? data[R] : [];
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? data_R[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $3ee4f50b1ae43a89$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb, date1904)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $3ee4f50b1ae43a89$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $3ee4f50b1ae43a89$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $3ee4f50b1ae43a89$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $3ee4f50b1ae43a89$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag('worksheet', null, {
            'xmlns': $3ee4f50b1ae43a89$var$XMLNS_main[0],
            'xmlns:r': $3ee4f50b1ae43a89$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $3ee4f50b1ae43a89$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $3ee4f50b1ae43a89$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $3ee4f50b1ae43a89$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $3ee4f50b1ae43a89$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, $3ee4f50b1ae43a89$var$escapexml(l[1].Target).replace(/#[\s\S]*$/, ""), $3ee4f50b1ae43a89$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $3ee4f50b1ae43a89$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $3ee4f50b1ae43a89$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $3ee4f50b1ae43a89$var$writetag("ignoredErrors", $3ee4f50b1ae43a89$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $3ee4f50b1ae43a89$var$RELS.DRAW);
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $3ee4f50b1ae43a89$var$RELS.VML);
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $3ee4f50b1ae43a89$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $3ee4f50b1ae43a89$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $3ee4f50b1ae43a89$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$3ee4f50b1ae43a89$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$write_row_header(ba, ws, range, R) {
    var o = $3ee4f50b1ae43a89$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $3ee4f50b1ae43a89$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $3ee4f50b1ae43a89$var$parse_BrtWsDim = $3ee4f50b1ae43a89$var$parse_UncheckedRfX;
var $3ee4f50b1ae43a89$var$write_BrtWsDim = $3ee4f50b1ae43a89$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $3ee4f50b1ae43a89$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $3ee4f50b1ae43a89$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $3ee4f50b1ae43a89$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $3ee4f50b1ae43a89$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $3ee4f50b1ae43a89$var$parse_BrtCellBlank(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    return $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
}
function $3ee4f50b1ae43a89$var$parse_BrtShortBlank(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    return $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $3ee4f50b1ae43a89$var$parse_BrtCellBool(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortBool(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(5);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $3ee4f50b1ae43a89$var$parse_BrtCellError(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortError(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $3ee4f50b1ae43a89$var$parse_BrtCellIsst(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortIsst(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $3ee4f50b1ae43a89$var$parse_BrtCellReal(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(16);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_Xnum(cell.v, o);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortReal(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $3ee4f50b1ae43a89$var$parse_BrtCellRk(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_RkNumber(cell.v, o);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortRk(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $3ee4f50b1ae43a89$var$parse_BrtCellRString(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $3ee4f50b1ae43a89$var$parse_BrtCellSt(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12 + 4 * cell.v.length);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortSt(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8 + 4 * data.length);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $3ee4f50b1ae43a89$var$parse_BrtMergeCell = $3ee4f50b1ae43a89$var$parse_UncheckedRfX;
var $3ee4f50b1ae43a89$var$write_BrtMergeCell = $3ee4f50b1ae43a89$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $3ee4f50b1ae43a89$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $3ee4f50b1ae43a89$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    var relId = $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data);
    var loc = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var tooltip = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var display = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtHLink(l, rId) {
    var o = $3ee4f50b1ae43a89$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $3ee4f50b1ae43a89$var$write_UncheckedRfX({
        s: $3ee4f50b1ae43a89$var$decode_cell(l[0]),
        e: $3ee4f50b1ae43a89$var$decode_cell(l[0])
    }, o);
    $3ee4f50b1ae43a89$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $3ee4f50b1ae43a89$var$write_XLWideString(loc || "", o);
    $3ee4f50b1ae43a89$var$write_XLWideString(l[1].Tooltip || "", o);
    $3ee4f50b1ae43a89$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $3ee4f50b1ae43a89$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $3ee4f50b1ae43a89$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $3ee4f50b1ae43a89$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $3ee4f50b1ae43a89$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(18);
    var p = $3ee4f50b1ae43a89$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $3ee4f50b1ae43a89$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $3ee4f50b1ae43a89$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $3ee4f50b1ae43a89$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $3ee4f50b1ae43a89$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $3ee4f50b1ae43a89$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(48);
    $3ee4f50b1ae43a89$var$default_margins(margins);
    $3ee4f50b1ae43a89$var$BrtMarginKeys.forEach(function(k) {
        $3ee4f50b1ae43a89$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $3ee4f50b1ae43a89$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $3ee4f50b1ae43a89$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $3ee4f50b1ae43a89$var$write_BrtCellIgnoreEC(ref) {
    var o = $3ee4f50b1ae43a89$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $3ee4f50b1ae43a89$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $3ee4f50b1ae43a89$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(66);
    o.write_shift(2, sp.password ? $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtDVal() {}
function $3ee4f50b1ae43a89$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $3ee4f50b1ae43a89$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $3ee4f50b1ae43a89$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $3ee4f50b1ae43a89$var$parse_BrtShortReal
    };
    var cm, vm;
    var date1904 = 1462 * +!!((wb || {}).WBProps || {}).date1904;
    $3ee4f50b1ae43a89$var$recordhopper(data, function ws_parse(val1, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val1;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val1;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $3ee4f50b1ae43a89$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val1.hidden || val1.hpt || val1.level != null) {
                    if (val1.hpt) val1.hpx = $3ee4f50b1ae43a89$var$pt2px(val1.hpt);
                    rowinfo[val1.r] = val1;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val1[2]
                } /*:any*/ ;
                switch(val1[2]){
                    case 'n':
                        p.v = val1[1];
                        break;
                    case 's':
                        sstr = $3ee4f50b1ae43a89$var$strs[val1[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val1[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val1[1];
                        if (opts.cellText !== false) p.w = $3ee4f50b1ae43a89$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val1[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val1[1].t;
                        break;
                }
                if (cf = styles.CellXf[val1[0].iStyleRef]) $3ee4f50b1ae43a89$var$safe_format(p, cf.numFmtId, null, opts, themes, styles, date1904 > 0);
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$3ee4f50b1ae43a89$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $3ee4f50b1ae43a89$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val1.length > 3) p.f = val1[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[cf.numFmtId])) {
                    var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(p.v + date1904);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$3ee4f50b1ae43a89$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val1);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val1 - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val1.relId];
                if (rel) {
                    val1.Target = rel.Target;
                    if (val1.loc) val1.Target += "#" + val1.loc;
                    val1.Rel = rel;
                } else if (val1.relId == '') val1.Target = "#" + val1.loc;
                for(R = val1.rfx.s.r; R <= val1.rfx.e.r; ++R)for(C = val1.rfx.s.c; C <= val1.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val1;
                } else {
                    addr = $3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val1;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val1);
                cell = opts.dense ? s["!data"][R][C] : s[$3ee4f50b1ae43a89$var$encode_col(C) + rr];
                cell.f = $3ee4f50b1ae43a89$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $3ee4f50b1ae43a89$var$encode_range(val1[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$3ee4f50b1ae43a89$var$encode_cell(val1[0].s)] = val1[1];
                cell = opts.dense ? s["!data"][R][C] : s[$3ee4f50b1ae43a89$var$encode_col(C) + rr];
                cell.f = $3ee4f50b1ae43a89$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val1.e >= val1.s){
                    colinfo[val1.e--] = {
                        width: val1.w / 256,
                        hidden: !!(val1.flags & 0x01),
                        level: val1.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $3ee4f50b1ae43a89$var$find_mdw_colw(val1.w / 256);
                    }
                    $3ee4f50b1ae43a89$var$process_col(colinfo[val1.e + 1]);
                }
                break;
            case 0x0227:
                /* 'BrtLegacyDrawing' */ if (val1) s["!legrel"] = val1;
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $3ee4f50b1ae43a89$var$encode_range(val1)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val1;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                if (val1.above || val1.left) s['!outline'] = {
                    above: val1.above,
                    left: val1.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val1.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $3ee4f50b1ae43a89$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
/* TODO: something useful -- this is a stub */ function $3ee4f50b1ae43a89$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ , date1904 /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $3ee4f50b1ae43a89$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $3ee4f50b1ae43a89$var$dup(cell);
            cell.z = cell.z || $3ee4f50b1ae43a89$var$table_fmt[14];
            cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v, date1904), date1904);
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $3ee4f50b1ae43a89$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $3ee4f50b1ae43a89$var$write_BrtShortIsst(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $3ee4f50b1ae43a89$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0011 /* BrtShortSt */ , $3ee4f50b1ae43a89$var$write_BrtShortSt(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0006 /* BrtCellSt */ , $3ee4f50b1ae43a89$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000D /* BrtShortRk */ , $3ee4f50b1ae43a89$var$write_BrtShortRk(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0002 /* BrtCellRk */ , $3ee4f50b1ae43a89$var$write_BrtCellRk(cell, o));
            } else if (!isFinite(cell.v)) {
                o.t = "e";
                if (isNaN(cell.v)) {
                    if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000E /* BrtShortError */ , $3ee4f50b1ae43a89$var$write_BrtShortError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                    else $3ee4f50b1ae43a89$var$write_record(ba, 0x0003 /* BrtCellError */ , $3ee4f50b1ae43a89$var$write_BrtCellError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                } else if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000E /* BrtShortError */ , $3ee4f50b1ae43a89$var$write_BrtShortError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0003 /* BrtCellError */ , $3ee4f50b1ae43a89$var$write_BrtCellError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
            } else if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0010 /* BrtShortReal */ , $3ee4f50b1ae43a89$var$write_BrtShortReal(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0005 /* BrtCellReal */ , $3ee4f50b1ae43a89$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000F /* BrtShortBool */ , $3ee4f50b1ae43a89$var$write_BrtShortBool(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0004 /* BrtCellBool */ , $3ee4f50b1ae43a89$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000E /* BrtShortError */ , $3ee4f50b1ae43a89$var$write_BrtShortError(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0003 /* BrtCellError */ , $3ee4f50b1ae43a89$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000C /* BrtShortBlank */ , $3ee4f50b1ae43a89$var$write_BrtShortBlank(cell, o));
    else $3ee4f50b1ae43a89$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $3ee4f50b1ae43a89$var$write_BrtCellBlank(cell, o));
    return true;
}
function $3ee4f50b1ae43a89$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null, row = dense ? ws["!data"][range.s.r] : [];
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        if (dense) row = ws["!data"][R];
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $3ee4f50b1ae43a89$var$write_row_header(ba, ws, range, R);
        if (dense && !row) continue;
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $3ee4f50b1ae43a89$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen, date1904);
        }
    }
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $3ee4f50b1ae43a89$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $3ee4f50b1ae43a89$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $3ee4f50b1ae43a89$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $3ee4f50b1ae43a89$var$write_BrtMergeCell(m));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $3ee4f50b1ae43a89$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $3ee4f50b1ae43a89$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $3ee4f50b1ae43a89$var$write_BrtColInfo(i, m));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $3ee4f50b1ae43a89$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $3ee4f50b1ae43a89$var$write_BrtCellIgnoreEC($3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref'])));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $3ee4f50b1ae43a89$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, l[1].Target.replace(/#[\s\S]*$/, ""), $3ee4f50b1ae43a89$var$RELS.HLINK);
        $3ee4f50b1ae43a89$var$write_record(ba, 0x01EE /* BrtHLink */ , $3ee4f50b1ae43a89$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $3ee4f50b1ae43a89$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $3ee4f50b1ae43a89$var$RELS.VML);
        $3ee4f50b1ae43a89$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $3ee4f50b1ae43a89$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $3ee4f50b1ae43a89$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $3ee4f50b1ae43a89$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $3ee4f50b1ae43a89$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]).e.r;
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $3ee4f50b1ae43a89$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $3ee4f50b1ae43a89$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $3ee4f50b1ae43a89$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $3ee4f50b1ae43a89$var$fix_range(ref)
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $3ee4f50b1ae43a89$var$write_UncheckedRfX($3ee4f50b1ae43a89$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $3ee4f50b1ae43a89$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $3ee4f50b1ae43a89$var$write_WSVIEWS2(ba, ws, Workbook) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $3ee4f50b1ae43a89$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $3ee4f50b1ae43a89$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $3ee4f50b1ae43a89$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $3ee4f50b1ae43a89$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $3ee4f50b1ae43a89$var$write_BrtSheetProtection(ws['!protect']));
}
function $3ee4f50b1ae43a89$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $3ee4f50b1ae43a89$var$write_record(ba, 0x0093 /* BrtWsProp */ , $3ee4f50b1ae43a89$var$write_BrtWsProp(c, ws['!outline']));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0094 /* BrtWsDim */ , $3ee4f50b1ae43a89$var$write_BrtWsDim(r));
    $3ee4f50b1ae43a89$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $3ee4f50b1ae43a89$var$write_WSFMTINFO(ba, ws);
    $3ee4f50b1ae43a89$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $3ee4f50b1ae43a89$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $3ee4f50b1ae43a89$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $3ee4f50b1ae43a89$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $3ee4f50b1ae43a89$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $3ee4f50b1ae43a89$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $3ee4f50b1ae43a89$var$write_record(ba, 0x01DC /* BrtMargins */ , $3ee4f50b1ae43a89$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $3ee4f50b1ae43a89$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $3ee4f50b1ae43a89$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<])<\/c:v><\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<]*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $3ee4f50b1ae43a89$var$unescapexml(($3ee4f50b1ae43a89$var$str_match_xml(data, "c:formatCode") || [
        "",
        "General"
    ])[1]);
    ($3ee4f50b1ae43a89$var$str_match_ng(data, "<c:f>", "</c:f>") || []).forEach(function(F) {
        f = F.replace(/<[^<>]*>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $3ee4f50b1ae43a89$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ ($3ee4f50b1ae43a89$var$str_match_ng(data, "<c:numCache>", "</c:numCache>") || []).forEach(function(nc) {
        var cache = $3ee4f50b1ae43a89$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $3ee4f50b1ae43a89$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $3ee4f50b1ae43a89$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $3ee4f50b1ae43a89$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($3ee4f50b1ae43a89$var$sheetprregex);
    if (sheetPr) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $3ee4f50b1ae43a89$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $3ee4f50b1ae43a89$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function cs_parse(val1, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val1;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $3ee4f50b1ae43a89$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $3ee4f50b1ae43a89$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $3ee4f50b1ae43a89$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $3ee4f50b1ae43a89$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $3ee4f50b1ae43a89$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $3ee4f50b1ae43a89$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $3ee4f50b1ae43a89$var$parse_wb_defaults(wb) {
    $3ee4f50b1ae43a89$var$push_defaults(wb.WBProps, $3ee4f50b1ae43a89$var$WBPropsDef);
    $3ee4f50b1ae43a89$var$push_defaults(wb.CalcPr, $3ee4f50b1ae43a89$var$CalcPrDef);
    $3ee4f50b1ae43a89$var$push_defaults_array(wb.WBView, $3ee4f50b1ae43a89$var$WBViewDef);
    $3ee4f50b1ae43a89$var$push_defaults_array(wb.Sheets, $3ee4f50b1ae43a89$var$SheetDef);
    $3ee4f50b1ae43a89$var$_ssfopts.date1904 = $3ee4f50b1ae43a89$var$parsexmlbool(wb.WBProps.date1904);
}
function $3ee4f50b1ae43a89$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $3ee4f50b1ae43a89$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $3ee4f50b1ae43a89$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $3ee4f50b1ae43a89$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $3ee4f50b1ae43a89$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $3ee4f50b1ae43a89$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $3ee4f50b1ae43a89$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $3ee4f50b1ae43a89$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $3ee4f50b1ae43a89$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$3ee4f50b1ae43a89$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $3ee4f50b1ae43a89$var$formula_quote_sheet_name(n) + "!" + $3ee4f50b1ae43a89$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $3ee4f50b1ae43a89$var$wbnsregex = /<\w+:workbook/;
function $3ee4f50b1ae43a89$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($3ee4f50b1ae43a89$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $3ee4f50b1ae43a89$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $3ee4f50b1ae43a89$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $3ee4f50b1ae43a89$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($3ee4f50b1ae43a89$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($3ee4f50b1ae43a89$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $3ee4f50b1ae43a89$var$parse_wb_defaults(wb);
    return wb;
}
function $3ee4f50b1ae43a89$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag('workbook', null, {
        'xmlns': $3ee4f50b1ae43a89$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $3ee4f50b1ae43a89$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $3ee4f50b1ae43a89$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $3ee4f50b1ae43a89$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $3ee4f50b1ae43a89$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $3ee4f50b1ae43a89$var$writextag('definedName', $3ee4f50b1ae43a89$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $3ee4f50b1ae43a89$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $3ee4f50b1ae43a89$var$parse_RelID(data, length - 8);
    z.name = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtBundleSh(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $3ee4f50b1ae43a89$var$write_RelID(data.strRelID, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $3ee4f50b1ae43a89$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $3ee4f50b1ae43a89$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $3ee4f50b1ae43a89$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $3ee4f50b1ae43a89$var$parse_XLNameWideString(data);
    var formula;
    var comment = "";
    try {
        formula = $3ee4f50b1ae43a89$var$parse_XLSBNameParsedFormula(data, 0, opts);
        try {
            comment = $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data);
        } catch (e) {}
    } catch (e) {
        console.error("Could not parse defined name " + name);
    }
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtName(name, wb) {
    var o = $3ee4f50b1ae43a89$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($3ee4f50b1ae43a89$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $3ee4f50b1ae43a89$var$write_XLWideString(dname),
        $3ee4f50b1ae43a89$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($3ee4f50b1ae43a89$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $3ee4f50b1ae43a89$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $3ee4f50b1ae43a89$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $3ee4f50b1ae43a89$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $3ee4f50b1ae43a89$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $3ee4f50b1ae43a89$var$parse_BrtFRTArchID$
    };
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_wb(val1, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val1.name);
                wb.Sheets.push(val1);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val1;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val1.Sheet != null) opts.SID = val1.Sheet;
                val1.Ref = val1.Ptg ? $3ee4f50b1ae43a89$var$stringify_formula(val1.Ptg, null, null, supbooks, opts) : "#REF!";
                delete opts.SID;
                delete val1.Ptg;
                Names.push(val1);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val1
                ];
                else supbooks.push([
                    RT,
                    val1
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                supbooks.XTI = supbooks.XTI.concat(val1);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $3ee4f50b1ae43a89$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $3ee4f50b1ae43a89$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $3ee4f50b1ae43a89$var$write_record(ba, 0x009C /* BrtBundleSh */ , $3ee4f50b1ae43a89$var$write_BrtBundleSh(d));
    }
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $3ee4f50b1ae43a89$var$write_BrtFileVersion(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_XLWideString("SheetJS", o);
    $3ee4f50b1ae43a89$var$write_XLWideString($3ee4f50b1ae43a89$var$XLSX.version, o);
    $3ee4f50b1ae43a89$var$write_XLWideString($3ee4f50b1ae43a89$var$XLSX.version, o);
    $3ee4f50b1ae43a89$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $3ee4f50b1ae43a89$var$write_BrtBookView(idx, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x009E /* BrtBookView */ , $3ee4f50b1ae43a89$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $3ee4f50b1ae43a89$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $3ee4f50b1ae43a89$var$write_record(ba, 0x0027 /* BrtName */ , $3ee4f50b1ae43a89$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $3ee4f50b1ae43a89$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $3ee4f50b1ae43a89$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$write_EXTERNALS_xlsb(ba, wb) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x016A /* BrtExternSheet */ , $3ee4f50b1ae43a89$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $3ee4f50b1ae43a89$var$write_wb_bin(wb, opts) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $3ee4f50b1ae43a89$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0099 /* BrtWbProp */ , $3ee4f50b1ae43a89$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $3ee4f50b1ae43a89$var$write_BOOKVIEWS(ba, wb, opts);
    $3ee4f50b1ae43a89$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $3ee4f50b1ae43a89$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $3ee4f50b1ae43a89$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_wb_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_wb_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $3ee4f50b1ae43a89$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $3ee4f50b1ae43a89$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_sst_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_sst_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_comments_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_comments_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $3ee4f50b1ae43a89$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $3ee4f50b1ae43a89$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $3ee4f50b1ae43a89$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $3ee4f50b1ae43a89$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $3ee4f50b1ae43a89$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $3ee4f50b1ae43a89$var$attregexg2 = /\b((?:\w+:)?[\w]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $3ee4f50b1ae43a89$var$attregex2 = /\b((?:\w+:)?[\w]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $3ee4f50b1ae43a89$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($3ee4f50b1ae43a89$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $3ee4f50b1ae43a89$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($3ee4f50b1ae43a89$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $3ee4f50b1ae43a89$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $3ee4f50b1ae43a89$var$xlml_format(format, value, date1904) /*:string*/ {
    var fmt = $3ee4f50b1ae43a89$var$XLMLFormatMap[format] || $3ee4f50b1ae43a89$var$unescapexml(format);
    if (fmt === "General") return $3ee4f50b1ae43a89$var$SSF_general(value);
    return $3ee4f50b1ae43a89$var$SSF_format(fmt, value, {
        date1904: !!date1904
    });
}
function $3ee4f50b1ae43a89$var$xlml_set_custprop(Custprops, key, cp, val1 /*:string*/ ) {
    var oval /*:any*/  = val1;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $3ee4f50b1ae43a89$var$parsexmlbool(val1);
            break;
        case "i2":
        case "int":
            oval = parseInt(val1, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val1);
            break;
        case "date":
        case "dateTime.tz":
            oval = $3ee4f50b1ae43a89$var$parseDate(val1);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$3ee4f50b1ae43a89$var$unescapexml(key)] = oval;
}
function $3ee4f50b1ae43a89$var$safe_format_xlml(cell /*:Cell*/ , nf, o, date1904) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $3ee4f50b1ae43a89$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $3ee4f50b1ae43a89$var$SSF_general_num(cell.v);
            } else cell.w = $3ee4f50b1ae43a89$var$SSF_general(cell.v);
        } else cell.w = $3ee4f50b1ae43a89$var$xlml_format(nf || "General", cell.v, date1904);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $3ee4f50b1ae43a89$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $3ee4f50b1ae43a89$var$fmt_is_date(z)) {
            var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(cell.v + (date1904 ? 1462 : 0));
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $3ee4f50b1ae43a89$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $3ee4f50b1ae43a89$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $3ee4f50b1ae43a89$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o, date1904) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        var ssid = styles[sid];
        if (ssid.nf) nf = ssid.nf;
        if (ssid.Interior) interiors.push(ssid.Interior);
        if (!ssid.Parent) break;
        sid = ssid.Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $3ee4f50b1ae43a89$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $3ee4f50b1ae43a89$var$xlml_fixstr($3ee4f50b1ae43a89$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $3ee4f50b1ae43a89$var$unescapexml(ss || xml).replace(/<[^<>]*>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(xml, date1904), date1904);
            if (cell.v !== cell.v) cell.v = $3ee4f50b1ae43a89$var$unescapexml(xml);
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $3ee4f50b1ae43a89$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $3ee4f50b1ae43a89$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $3ee4f50b1ae43a89$var$safe_format_xlml(cell, nf, o, date1904);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $3ee4f50b1ae43a89$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $3ee4f50b1ae43a89$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $3ee4f50b1ae43a89$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $3ee4f50b1ae43a89$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $3ee4f50b1ae43a89$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $3ee4f50b1ae43a89$var$xlml_prefix_dname(dname) {
    return $3ee4f50b1ae43a89$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $3ee4f50b1ae43a89$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $3ee4f50b1ae43a89$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $3ee4f50b1ae43a89$var$make_ssf();
    var str = $3ee4f50b1ae43a89$var$debom($3ee4f50b1ae43a89$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $3ee4f50b1ae43a89$var$$cptable !== 'undefined') str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, $3ee4f50b1ae43a89$var$char_codes(str));
        else str = $3ee4f50b1ae43a89$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $3ee4f50b1ae43a89$var$dup(opts);
        _o.type = "string";
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $3ee4f50b1ae43a89$var$html_to_workbook(str, opts);
    $3ee4f50b1ae43a89$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $3ee4f50b1ae43a89$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $3ee4f50b1ae43a89$var$table_fmt[15],
        "Short Date": $3ee4f50b1ae43a89$var$table_fmt[14],
        "Long Time": $3ee4f50b1ae43a89$var$table_fmt[19],
        "Medium Time": $3ee4f50b1ae43a89$var$table_fmt[18],
        "Short Time": $3ee4f50b1ae43a89$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $3ee4f50b1ae43a89$var$table_fmt[2],
        "Standard": $3ee4f50b1ae43a89$var$table_fmt[4],
        "Percent": $3ee4f50b1ae43a89$var$table_fmt[10],
        "Scientific": $3ee4f50b1ae43a89$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $3ee4f50b1ae43a89$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = 0;
    str = $3ee4f50b1ae43a89$var$str_remove_ng(str, "<!--", "-->");
    var raw_Rn3 = "";
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $3ee4f50b1ae43a89$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts, Workbook.WBProps.date1904);
            else {
                ss = "";
                dtag = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$3ee4f50b1ae43a89$var$encode_col(c) + $3ee4f50b1ae43a89$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $3ee4f50b1ae43a89$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$3ee4f50b1ae43a89$var$encode_col(cma) + $3ee4f50b1ae43a89$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $3ee4f50b1ae43a89$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $3ee4f50b1ae43a89$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                sheetname = $3ee4f50b1ae43a89$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $3ee4f50b1ae43a89$var$process_style_xlml(styles, stag, opts);
            else stag = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($3ee4f50b1ae43a89$var$XLMLFormatMap[stag.nf]) stag.nf = $3ee4f50b1ae43a89$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($3ee4f50b1ae43a89$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($3ee4f50b1ae43a89$var$table_fmt[ssfidx] == null) {
                    $3ee4f50b1ae43a89$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $3ee4f50b1ae43a89$var$process_col(cstys[_col]);
            }
            if (seencol) $3ee4f50b1ae43a89$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $3ee4f50b1ae43a89$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $3ee4f50b1ae43a89$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $3ee4f50b1ae43a89$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $3ee4f50b1ae43a89$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $3ee4f50b1ae43a89$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                if (!$3ee4f50b1ae43a89$var$parsexmlbool(tmp["ShowAlways"] || "0")) comments.hidden = true;
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $3ee4f50b1ae43a89$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $3ee4f50b1ae43a89$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $3ee4f50b1ae43a89$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'hidehorizontalscrollbar' /*case 'HideHorizontalScrollBar'*/ :
                            break;
                        case 'hideverticalscrollbar' /*case 'HideVerticalScrollBar'*/ :
                            break;
                        case 'hideworkbooktabs' /*case 'HideWorkbookTabs'*/ :
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $3ee4f50b1ae43a89$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $3ee4f50b1ae43a89$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $3ee4f50b1ae43a89$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $3ee4f50b1ae43a89$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $3ee4f50b1ae43a89$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml($3ee4f50b1ae43a89$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml(data, opts);
        case "array":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml($3ee4f50b1ae43a89$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $3ee4f50b1ae43a89$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($3ee4f50b1ae43a89$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($3ee4f50b1ae43a89$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($3ee4f50b1ae43a89$var$writextag('NumberFormat', null, {
            "ss:Format": $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($3ee4f50b1ae43a89$var$writextag('Style', payload.join(""), o));
    });
    return $3ee4f50b1ae43a89$var$writextag("Styles", styles.join(""));
}
function $3ee4f50b1ae43a89$var$write_name_xlml(n) {
    return $3ee4f50b1ae43a89$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $3ee4f50b1ae43a89$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $3ee4f50b1ae43a89$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($3ee4f50b1ae43a89$var$write_name_xlml(n));
    }
    return $3ee4f50b1ae43a89$var$writextag("Names", out.join(""));
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($3ee4f50b1ae43a89$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $3ee4f50b1ae43a89$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($3ee4f50b1ae43a89$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($3ee4f50b1ae43a89$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($3ee4f50b1ae43a89$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($3ee4f50b1ae43a89$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($3ee4f50b1ae43a89$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($3ee4f50b1ae43a89$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($3ee4f50b1ae43a89$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($3ee4f50b1ae43a89$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($3ee4f50b1ae43a89$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $3ee4f50b1ae43a89$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $3ee4f50b1ae43a89$var$XLMLNS.x
    });
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    /* TODO: test multiple comments */ return comments.map(function(c) {
        // TODO: formatted text
        var t = $3ee4f50b1ae43a89$var$xlml_unfixstr(c.t || "");
        var d = $3ee4f50b1ae43a89$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        var p = {};
        if (c.a) p["ss:Author"] = c.a;
        if (!comments.hidden) p["ss:ShowAlways"] = "1";
        return $3ee4f50b1ae43a89$var$writextag("Comment", d, p);
    }).join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $3ee4f50b1ae43a89$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $3ee4f50b1ae43a89$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $3ee4f50b1ae43a89$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            if (!isFinite(cell.v)) {
                t = 'Error';
                p = $3ee4f50b1ae43a89$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
            } else {
                t = 'Number';
                p = String(cell.v);
            }
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $3ee4f50b1ae43a89$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $3ee4f50b1ae43a89$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $3ee4f50b1ae43a89$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $3ee4f50b1ae43a89$var$write_ws_xlml_comment(cell.c);
    return $3ee4f50b1ae43a89$var$writextag("Cell", m, attr);
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $3ee4f50b1ae43a89$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $3ee4f50b1ae43a89$var$process_col(n);
        var w = !!n.width;
        var p = $3ee4f50b1ae43a89$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $3ee4f50b1ae43a89$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($3ee4f50b1ae43a89$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    var addr = {
        r: 0,
        c: 0
    };
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $3ee4f50b1ae43a89$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        addr.r = R;
        for(var C = range.s.c; C <= range.e.c; ++C){
            addr.c = C;
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var ref = $3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($3ee4f50b1ae43a89$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $3ee4f50b1ae43a89$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $3ee4f50b1ae43a89$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($3ee4f50b1ae43a89$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws && ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $3ee4f50b1ae43a89$var$a1_to_rc($3ee4f50b1ae43a89$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($3ee4f50b1ae43a89$var$write_props_xlml(wb, opts));
    d.push($3ee4f50b1ae43a89$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push($3ee4f50b1ae43a89$var$write_names_xlml(wb, opts));
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($3ee4f50b1ae43a89$var$writextag("Worksheet", $3ee4f50b1ae43a89$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $3ee4f50b1ae43a89$var$write_sty_xlml(wb, opts);
    return $3ee4f50b1ae43a89$var$XML_HEADER + $3ee4f50b1ae43a89$var$writextag("Workbook", d.join(""), {
        'xmlns': $3ee4f50b1ae43a89$var$XLMLNS.ss,
        'xmlns:o': $3ee4f50b1ae43a89$var$XLMLNS.o,
        'xmlns:x': $3ee4f50b1ae43a89$var$XLMLNS.x,
        'xmlns:ss': $3ee4f50b1ae43a89$var$XLMLNS.ss,
        'xmlns:dt': $3ee4f50b1ae43a89$var$XLMLNS.dt,
        'xmlns:html': $3ee4f50b1ae43a89$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $3ee4f50b1ae43a89$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $3ee4f50b1ae43a89$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $3ee4f50b1ae43a89$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l), next = $3ee4f50b1ae43a89$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $3ee4f50b1ae43a89$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $3ee4f50b1ae43a89$var$XLSRecordEnum[nextrt = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $3ee4f50b1ae43a89$var$bconcat(bufs);
    $3ee4f50b1ae43a89$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $3ee4f50b1ae43a89$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF && p.z == null) p.z = $3ee4f50b1ae43a89$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $3ee4f50b1ae43a89$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(p.v);
            } else p.w = $3ee4f50b1ae43a89$var$SSF_general(p.v);
        } else p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(p.v + (date1904 ? 1462 : 0));
        if (_d) {
            p.t = 'd';
            p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
        }
    }
}
function $3ee4f50b1ae43a89$var$make_cell(val1, ixfe, t) /*:Cell*/ {
    return {
        v: val1,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $3ee4f50b1ae43a89$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && options.dense == null) options.dense = $3ee4f50b1ae43a89$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var biff4w = false;
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $3ee4f50b1ae43a89$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $3ee4f50b1ae43a89$var$XLSIcv[icv];
        return $3ee4f50b1ae43a89$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $3ee4f50b1ae43a89$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $3ee4f50b1ae43a89$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (!biff4w && file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $3ee4f50b1ae43a89$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $3ee4f50b1ae43a89$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $3ee4f50b1ae43a89$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $3ee4f50b1ae43a89$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val1 /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val1 = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val1 = /*::(*/ $3ee4f50b1ae43a89$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val1;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val1;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val1.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val1.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val1;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val1);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $3ee4f50b1ae43a89$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val1;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val1;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val1;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val1;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val1;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val1;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val1;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val1;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val1;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val1;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val1;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val1.fDialog) out["!type"] = "dialog";
                    if (!val1.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val1.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x0043:
                /* BIFF2XF */ case 0x0243:
                /* BIFF3XF */ case 0x0443:
                /* BIFF4XF */ case 0x00e0 /* XF */ :
                    XFs.push(val1);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val1
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val1);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val1.Name,
                        Ref: $3ee4f50b1ae43a89$var$stringify_formula(val1.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val1.itab > 0) last_lbl.Sheet = val1.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val1);
                    if (val1.Name == "_xlnm._FilterDatabase" && val1.itab > 0) {
                        if (val1.rgce && val1.rgce[0] && val1.rgce[0][0] && val1.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val1.itab - 1] = {
                            ref: $3ee4f50b1ae43a89$var$encode_range(val1.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val1;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                    supbooks.XTI = supbooks.XTI.concat(val1);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val1[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val1;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val1 !== 0 && opts.WTF) console.error("Password verifier: " + val1);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[opts.biff == 4 ? opts.snames.length : val1.pos] = val1;
                    opts.snames.push(val1.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth ? !biff4w : biff4w) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        0x0009: 2,
                        0x0209: 3,
                        0x0409: 4
                    })[RecordType] || ({
                        0x0200: 2,
                        0x0300: 3,
                        0x0400: 4,
                        0x0500: 5,
                        0x0600: 8,
                        0x0002: 2,
                        0x0007: 2
                    })[val1.BIFFVer] || 8;
                    opts.biffguess = val1.BIFFVer == 0;
                    if (val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $3ee4f50b1ae43a89$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 4 && val1.dt & 0x100) biff4w = true;
                    if (opts.biff == 8 && val1.BIFFVer == 0 && val1.dt == 16) opts.biff = 2;
                    if (file_depth++ && !biff4w) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $3ee4f50b1ae43a89$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff == 4 && biff4w) cur_sheet = (Directory[opts.snames.indexOf(cur_sheet) + 1] || {
                        name: ""
                    }).name;
                    else if (opts.biff < 5 || val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val1.dt == 0x20) out["!type"] = "chart";
                    if (val1.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val1.r] || [])[val1.c] : out[$3ee4f50b1ae43a89$var$encode_col(val1.c) + $3ee4f50b1ae43a89$var$encode_row(val1.r)]) ++val1.c;
                    }
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe] || {},
                        v: val1.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.val,
                        t: val1.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val1.c; j <= val1.C; ++j){
                        var ixfe = val1.rkrec[j - val1.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val1.rkrec[j - val1.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val1.val == 'String') {
                        last_formula = val1;
                        break;
                    }
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(val1.val, val1.cell.ixfe, val1.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val1.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $3ee4f50b1ae43a89$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val1.cell, temp_val, options);
                    last_formula = val1;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val1;
                        temp_val = $3ee4f50b1ae43a89$var$make_cell(val1, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val1);
                    var _arraystart = $3ee4f50b1ae43a89$var$encode_cell(val1[0].s);
                    cc = options.dense ? (out["!data"][val1[0].s.r] || [])[val1[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val1[1], range, val1[0], supbooks, opts);
                        cc.F = $3ee4f50b1ae43a89$var$encode_range(val1[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$3ee4f50b1ae43a89$var$encode_cell(last_formula.cell)] = val1[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$3ee4f50b1ae43a89$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val1[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(sst[val1.isst].t, val1.ixfe, 's');
                    if (sst[val1.isst].h) temp_val.h = sst[val1.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val1.ixfe,
                            XF: XFs[val1.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val1.c,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val1.c; _j <= val1.C; ++_j){
                        var _ixfe = val1.ixfe[_j - val1.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(val1.val, val1.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val1; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val1;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff >= 3 && opts.biff <= 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val1[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($3ee4f50b1ae43a89$var$table_fmt[b4idx] == val1[1]) break;
                        if (b4idx >= 163) $3ee4f50b1ae43a89$var$SSF__load(val1[1], BIFF2Fmt + 163);
                    } else $3ee4f50b1ae43a89$var$SSF__load(val1[1], val1[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val1;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($3ee4f50b1ae43a89$var$table_fmt[b2idx] == val1) break;
                    if (b2idx >= 163) $3ee4f50b1ae43a89$var$SSF__load(val1, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val1);
                    break;
                case 0x005d /* Obj */ :
                    objects[val1.cmo[0]] = opts.lastobj = val1;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val1;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val1;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val1[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val1[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    /* TODO: comment continuation (row == -1 / 0xFFFF) */ cc = options.dense ? (out["!data"][val1[0].r] || [])[val1[0].c] : out[$3ee4f50b1ae43a89$var$encode_cell(val1[0])];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val1[0].r]) out["!data"][val1[0].r] = [];
                            cc = out["!data"][val1[0].r][val1[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$3ee4f50b1ae43a89$var$encode_cell(val1[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val1[0].r);
                        range.s.r = Math.min(range.s.r, val1[0].r);
                        range.e.c = Math.max(range.e.c, val1[0].c);
                        range.s.c = Math.min(range.s.c, val1[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    if (opts.biff <= 5 && opts.biff >= 2) cmnt = {
                        a: "SheetJ5",
                        t: val1[1]
                    };
                    else {
                        var noteobj = objects[val1[2]];
                        cmnt = {
                            a: val1[1],
                            t: noteobj.TxO.t
                        };
                        if (val1[3] != null && !(val1[3] & 0x02)) cc.c.hidden = true;
                    }
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $3ee4f50b1ae43a89$var$update_xfext(XFs[val1.ixfe], val1.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val1.e >= val1.s){
                        colinfo[val1.e--] = {
                            width: val1.w / 256,
                            level: val1.level || 0,
                            hidden: !!(val1.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $3ee4f50b1ae43a89$var$find_mdw_colw(val1.w / 256);
                        }
                        $3ee4f50b1ae43a89$var$process_col(colinfo[val1.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val1.level != null) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.level = val1.level;
                    }
                    if (val1.hidden) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val1.hpt) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hpt = val1.hpt;
                        rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(val1.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $3ee4f50b1ae43a89$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val1;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $3ee4f50b1ae43a89$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val1.header;
                    out['!margins'].footer = val1.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val1.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val1;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val1;
                    break;
                case 0x008c /* Country */ :
                    country = val1;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val1 || "ThisWorkbook";
                    else wsprops.CodeName = val1 || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $3ee4f50b1ae43a89$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $3ee4f50b1ae43a89$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $3ee4f50b1ae43a89$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $3ee4f50b1ae43a89$var$parse_PropertySetStream(DSI, $3ee4f50b1ae43a89$var$DocSummaryPIDDSI, $3ee4f50b1ae43a89$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $3ee4f50b1ae43a89$var$parse_PropertySetStream(SI, $3ee4f50b1ae43a89$var$SummaryPIDSI, $3ee4f50b1ae43a89$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $3ee4f50b1ae43a89$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $3ee4f50b1ae43a89$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $3ee4f50b1ae43a89$var$evert_key($3ee4f50b1ae43a89$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $3ee4f50b1ae43a89$var$evert_key($3ee4f50b1ae43a89$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $3ee4f50b1ae43a89$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $3ee4f50b1ae43a89$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($3ee4f50b1ae43a89$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $3ee4f50b1ae43a89$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $3ee4f50b1ae43a89$var$write_PropertySetStream(SEntries, $3ee4f50b1ae43a89$var$PSCLSID.SI, SummaryRE, $3ee4f50b1ae43a89$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $3ee4f50b1ae43a89$var$write_PropertySetStream(DSEntries, $3ee4f50b1ae43a89$var$PSCLSID.DSI, DocSummaryRE, $3ee4f50b1ae43a89$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $3ee4f50b1ae43a89$var$PSCLSID.UDI));
}
function $3ee4f50b1ae43a89$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $3ee4f50b1ae43a89$var$fix_read_opts(options);
    $3ee4f50b1ae43a89$var$reset_cp();
    if (options.codepage) $3ee4f50b1ae43a89$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $3ee4f50b1ae43a89$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $3ee4f50b1ae43a89$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $3ee4f50b1ae43a89$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $3ee4f50b1ae43a89$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $3ee4f50b1ae43a89$var$parse_workbook(WB.content, options);
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $3ee4f50b1ae43a89$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $3ee4f50b1ae43a89$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $3ee4f50b1ae43a89$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $3ee4f50b1ae43a89$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $3ee4f50b1ae43a89$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $3ee4f50b1ae43a89$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $3ee4f50b1ae43a89$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $3ee4f50b1ae43a89$var$fill_vba_xls(cfb, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $3ee4f50b1ae43a89$var$XLSBRecordEnum = {
    0x0000: {
        f: $3ee4f50b1ae43a89$var$parse_BrtRowHdr
    },
    0x0001: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellBlank
    },
    0x0002: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellRk
    },
    0x0003: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellError
    },
    0x0004: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellBool
    },
    0x0005: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellReal
    },
    0x0006: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellSt
    },
    0x0007: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellIsst
    },
    0x0008: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaString
    },
    0x0009: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaNum
    },
    0x000A: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaBool
    },
    0x000B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaError
    },
    0x000C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortBlank
    },
    0x000D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortRk
    },
    0x000E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortError
    },
    0x000F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortBool
    },
    0x0010: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortReal
    },
    0x0011: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortSt
    },
    0x0012: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortIsst
    },
    0x0013: {
        f: $3ee4f50b1ae43a89$var$parse_RichStr
    },
    0x0014: {},
    0x0015: {},
    0x0016: {},
    0x0017: {},
    0x0018: {},
    0x0019: {},
    0x001A: {},
    0x001B: {},
    0x001C: {},
    0x001D: {},
    0x001E: {},
    0x001F: {},
    0x0020: {},
    0x0021: {},
    0x0022: {},
    0x0023: {
        T: 1
    },
    0x0024: {
        T: -1
    },
    0x0025: {
        T: 1
    },
    0x0026: {
        T: -1
    },
    0x0027: {
        f: $3ee4f50b1ae43a89$var$parse_BrtName
    },
    0x0028: {},
    0x002A: {},
    0x002B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFont
    },
    0x002C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmt
    },
    0x002D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFill
    },
    0x002E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBorder
    },
    0x002F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtXF
    },
    0x0030: {},
    0x0031: {
        f: $3ee4f50b1ae43a89$var$parse_Int32LE
    },
    0x0032: {},
    0x0033: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMdb
    },
    0x0034: {
        T: 1
    },
    0x0035: {
        T: -1
    },
    0x0036: {
        T: 1
    },
    0x0037: {
        T: -1
    },
    0x0038: {
        T: 1
    },
    0x0039: {
        T: -1
    },
    0x003A: {},
    0x003B: {},
    0x003C: {
        f: $3ee4f50b1ae43a89$var$parse_ColInfo
    },
    0x003E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellRString
    },
    0x003F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCalcChainItem$
    },
    0x0040: {
        f: $3ee4f50b1ae43a89$var$parse_BrtDVal
    },
    0x0041: {},
    0x0042: {},
    0x0043: {},
    0x0044: {},
    0x0045: {},
    0x0046: {},
    0x0080: {},
    0x0081: {
        T: 1
    },
    0x0082: {
        T: -1
    },
    0x0083: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parsenoop,
        p: 0
    },
    0x0084: {
        T: -1
    },
    0x0085: {
        T: 1
    },
    0x0086: {
        T: -1
    },
    0x0087: {
        T: 1
    },
    0x0088: {
        T: -1
    },
    0x0089: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginWsView
    },
    0x008A: {
        T: -1
    },
    0x008B: {
        T: 1
    },
    0x008C: {
        T: -1
    },
    0x008D: {
        T: 1
    },
    0x008E: {
        T: -1
    },
    0x008F: {
        T: 1
    },
    0x0090: {
        T: -1
    },
    0x0091: {
        T: 1
    },
    0x0092: {
        T: -1
    },
    0x0093: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsProp
    },
    0x0094: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsDim,
        p: 16
    },
    0x0097: {
        f: $3ee4f50b1ae43a89$var$parse_BrtPane
    },
    0x0098: {},
    0x0099: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWbProp
    },
    0x009A: {},
    0x009B: {},
    0x009C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBundleSh
    },
    0x009D: {},
    0x009E: {},
    0x009F: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginSst
    },
    0x00A0: {
        T: -1
    },
    0x00A1: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_UncheckedRfX
    },
    0x00A2: {
        T: -1
    },
    0x00A3: {
        T: 1
    },
    0x00A4: {
        T: -1
    },
    0x00A5: {
        T: 1
    },
    0x00A6: {
        T: -1
    },
    0x00A7: {},
    0x00A8: {},
    0x00A9: {},
    0x00AA: {},
    0x00AB: {},
    0x00AC: {
        T: 1
    },
    0x00AD: {
        T: -1
    },
    0x00AE: {},
    0x00AF: {},
    0x00B0: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMergeCell
    },
    0x00B1: {
        T: 1
    },
    0x00B2: {
        T: -1
    },
    0x00B3: {
        T: 1
    },
    0x00B4: {
        T: -1
    },
    0x00B5: {
        T: 1
    },
    0x00B6: {
        T: -1
    },
    0x00B7: {
        T: 1
    },
    0x00B8: {
        T: -1
    },
    0x00B9: {
        T: 1
    },
    0x00BA: {
        T: -1
    },
    0x00BB: {
        T: 1
    },
    0x00BC: {
        T: -1
    },
    0x00BD: {
        T: 1
    },
    0x00BE: {
        T: -1
    },
    0x00BF: {
        T: 1
    },
    0x00C0: {
        T: -1
    },
    0x00C1: {
        T: 1
    },
    0x00C2: {
        T: -1
    },
    0x00C3: {
        T: 1
    },
    0x00C4: {
        T: -1
    },
    0x00C5: {
        T: 1
    },
    0x00C6: {
        T: -1
    },
    0x00C7: {
        T: 1
    },
    0x00C8: {
        T: -1
    },
    0x00C9: {
        T: 1
    },
    0x00CA: {
        T: -1
    },
    0x00CB: {
        T: 1
    },
    0x00CC: {
        T: -1
    },
    0x00CD: {
        T: 1
    },
    0x00CE: {
        T: -1
    },
    0x00CF: {
        T: 1
    },
    0x00D0: {
        T: -1
    },
    0x00D1: {
        T: 1
    },
    0x00D2: {
        T: -1
    },
    0x00D3: {
        T: 1
    },
    0x00D4: {
        T: -1
    },
    0x00D5: {
        T: 1
    },
    0x00D6: {
        T: -1
    },
    0x00D7: {
        T: 1
    },
    0x00D8: {
        T: -1
    },
    0x00D9: {
        T: 1
    },
    0x00DA: {
        T: -1
    },
    0x00DB: {
        T: 1
    },
    0x00DC: {
        T: -1
    },
    0x00DD: {
        T: 1
    },
    0x00DE: {
        T: -1
    },
    0x00DF: {
        T: 1
    },
    0x00E0: {
        T: -1
    },
    0x00E1: {
        T: 1
    },
    0x00E2: {
        T: -1
    },
    0x00E3: {
        T: 1
    },
    0x00E4: {
        T: -1
    },
    0x00E5: {
        T: 1
    },
    0x00E6: {
        T: -1
    },
    0x00E7: {
        T: 1
    },
    0x00E8: {
        T: -1
    },
    0x00E9: {
        T: 1
    },
    0x00EA: {
        T: -1
    },
    0x00EB: {
        T: 1
    },
    0x00EC: {
        T: -1
    },
    0x00ED: {
        T: 1
    },
    0x00EE: {
        T: -1
    },
    0x00EF: {
        T: 1
    },
    0x00F0: {
        T: -1
    },
    0x00F1: {
        T: 1
    },
    0x00F2: {
        T: -1
    },
    0x00F3: {
        T: 1
    },
    0x00F4: {
        T: -1
    },
    0x00F5: {
        T: 1
    },
    0x00F6: {
        T: -1
    },
    0x00F7: {
        T: 1
    },
    0x00F8: {
        T: -1
    },
    0x00F9: {
        T: 1
    },
    0x00FA: {
        T: -1
    },
    0x00FB: {
        T: 1
    },
    0x00FC: {
        T: -1
    },
    0x00FD: {
        T: 1
    },
    0x00FE: {
        T: -1
    },
    0x00FF: {
        T: 1
    },
    0x0100: {
        T: -1
    },
    0x0101: {
        T: 1
    },
    0x0102: {
        T: -1
    },
    0x0103: {
        T: 1
    },
    0x0104: {
        T: -1
    },
    0x0105: {
        T: 1
    },
    0x0106: {
        T: -1
    },
    0x0107: {
        T: 1
    },
    0x0108: {
        T: -1
    },
    0x0109: {
        T: 1
    },
    0x010A: {
        T: -1
    },
    0x010B: {
        T: 1
    },
    0x010C: {
        T: -1
    },
    0x010D: {
        T: 1
    },
    0x010E: {
        T: -1
    },
    0x010F: {
        T: 1
    },
    0x0110: {
        T: -1
    },
    0x0111: {
        T: 1
    },
    0x0112: {
        T: -1
    },
    0x0113: {
        T: 1
    },
    0x0114: {
        T: -1
    },
    0x0115: {},
    0x0116: {
        T: 1
    },
    0x0117: {
        T: -1
    },
    0x0118: {
        T: 1
    },
    0x0119: {
        T: -1
    },
    0x011A: {
        T: 1
    },
    0x011B: {
        T: 1
    },
    0x011C: {
        T: -1
    },
    0x011D: {
        T: 1
    },
    0x011E: {
        T: -1
    },
    0x011F: {
        T: 1
    },
    0x0120: {
        T: -1
    },
    0x0121: {
        T: 1
    },
    0x0122: {
        T: -1
    },
    0x0123: {
        T: 1
    },
    0x0124: {
        T: -1
    },
    0x0125: {
        T: 1
    },
    0x0126: {
        T: -1
    },
    0x0127: {
        T: 1
    },
    0x0128: {
        T: -1
    },
    0x0129: {
        T: 1
    },
    0x012A: {
        T: -1
    },
    0x012B: {
        T: 1
    },
    0x012C: {
        T: -1
    },
    0x012D: {
        T: 1
    },
    0x012E: {
        T: -1
    },
    0x012F: {
        T: 1
    },
    0x0130: {
        T: -1
    },
    0x0131: {
        T: 1
    },
    0x0132: {
        T: -1
    },
    0x0133: {
        T: 1
    },
    0x0134: {
        T: -1
    },
    0x0135: {
        T: 1
    },
    0x0136: {
        T: -1
    },
    0x0137: {
        T: 1
    },
    0x0138: {
        T: -1
    },
    0x0139: {
        T: -1
    },
    0x013A: {
        T: 1
    },
    0x013B: {
        T: -1
    },
    0x013C: {
        T: 1
    },
    0x013D: {
        T: -1
    },
    0x013E: {
        T: 1
    },
    0x013F: {
        T: -1
    },
    0x0140: {
        T: 1
    },
    0x0141: {
        T: -1
    },
    0x0142: {
        T: 1
    },
    0x0143: {
        T: -1
    },
    0x0144: {
        T: 1
    },
    0x0145: {
        T: -1
    },
    0x0146: {
        T: 1
    },
    0x0147: {
        T: -1
    },
    0x0148: {
        T: 1
    },
    0x0149: {
        T: -1
    },
    0x014A: {
        T: 1
    },
    0x014B: {
        T: -1
    },
    0x014C: {
        T: 1
    },
    0x014D: {
        T: -1
    },
    0x014E: {
        T: 1
    },
    0x014F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMdtinfo
    },
    0x0150: {
        T: -1
    },
    0x0151: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginEsmdb,
        T: 1
    },
    0x0152: {
        T: -1
    },
    0x0153: {
        T: 1
    },
    0x0154: {
        T: -1
    },
    0x0155: {
        T: 1
    },
    0x0156: {
        T: -1
    },
    0x0157: {
        T: 1
    },
    0x0158: {
        T: -1
    },
    0x0159: {
        T: 1
    },
    0x015A: {
        T: -1
    },
    0x015B: {
        T: 1
    },
    0x015C: {
        T: -1
    },
    0x015D: {
        T: 1
    },
    0x015E: {
        T: -1
    },
    0x015F: {},
    0x0160: {},
    0x0161: {
        T: 1
    },
    0x0162: {
        T: -1
    },
    0x0163: {
        f: $3ee4f50b1ae43a89$var$parse_RelID
    },
    0x0165: {},
    0x0166: {},
    0x0167: {},
    0x0168: {
        T: 1
    },
    0x0169: {},
    0x016A: {
        f: $3ee4f50b1ae43a89$var$parse_ExternSheet
    },
    0x016B: {},
    0x016C: {},
    0x016E: {},
    0x016F: {},
    0x0170: {},
    0x0171: {},
    0x0172: {},
    0x0173: {},
    0x0174: {
        T: 1
    },
    0x0175: {
        T: -1
    },
    0x0176: {
        T: 1
    },
    0x0177: {
        T: -1
    },
    0x0178: {
        T: 1
    },
    0x0179: {
        T: -1
    },
    0x017A: {
        T: 1
    },
    0x017B: {
        T: -1
    },
    0x017C: {
        T: 1
    },
    0x017D: {
        T: -1
    },
    0x017E: {
        T: 1
    },
    0x017F: {
        T: -1
    },
    0x0180: {
        T: 1
    },
    0x0181: {
        T: -1
    },
    0x0182: {
        T: 1
    },
    0x0183: {
        T: -1
    },
    0x0184: {
        T: 1
    },
    0x0185: {
        T: -1
    },
    0x0186: {
        T: 1
    },
    0x0187: {
        T: -1
    },
    0x0188: {
        T: 1
    },
    0x0189: {
        T: -1
    },
    0x018A: {
        T: 1
    },
    0x018B: {
        T: -1
    },
    0x018C: {},
    0x018D: {},
    0x018E: {},
    0x018F: {},
    0x0190: {},
    0x0191: {
        T: 1
    },
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x0199: {},
    0x019A: {},
    0x019B: {},
    0x019C: {},
    0x019D: {},
    0x019E: {},
    0x019F: {},
    0x01A0: {},
    0x01A1: {},
    0x01A2: {},
    0x01A3: {},
    0x01A4: {},
    0x01A5: {},
    0x01A6: {
        T: 1
    },
    0x01A7: {
        T: 1
    },
    0x01A8: {
        T: -1
    },
    0x01A9: {
        T: -1
    },
    0x01AA: {
        f: $3ee4f50b1ae43a89$var$parse_BrtArrFmla
    },
    0x01AB: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShrFmla
    },
    0x01AC: {},
    0x01AD: {
        T: 1
    },
    0x01AE: {
        T: -1
    },
    0x01AF: {
        T: 1
    },
    0x01B0: {
        T: -1
    },
    0x01B1: {
        T: 1
    },
    0x01B2: {
        T: -1
    },
    0x01B3: {
        T: 1
    },
    0x01B4: {
        T: -1
    },
    0x01B5: {
        T: 1
    },
    0x01B6: {
        T: -1
    },
    0x01B7: {
        T: 1
    },
    0x01B8: {
        T: -1
    },
    0x01B9: {
        T: 1
    },
    0x01BA: {
        T: -1
    },
    0x01BB: {
        T: 1
    },
    0x01BC: {
        T: -1
    },
    0x01BD: {
        T: 1
    },
    0x01BE: {
        T: -1
    },
    0x01BF: {
        T: 1
    },
    0x01C0: {
        T: -1
    },
    0x01C1: {
        T: 1
    },
    0x01C2: {
        T: -1
    },
    0x01C3: {
        T: 1
    },
    0x01C4: {
        T: -1
    },
    0x01C5: {
        T: 1
    },
    0x01C6: {
        T: -1
    },
    0x01C7: {
        T: 1
    },
    0x01C8: {
        T: -1
    },
    0x01C9: {
        T: 1
    },
    0x01CA: {
        T: -1
    },
    0x01CB: {
        T: 1
    },
    0x01CC: {
        T: -1
    },
    0x01CD: {
        T: 1
    },
    0x01CE: {
        T: -1
    },
    0x01CF: {
        T: 1
    },
    0x01D0: {
        T: -1
    },
    0x01D1: {
        T: 1
    },
    0x01D2: {
        T: -1
    },
    0x01D3: {
        T: 1
    },
    0x01D4: {
        T: -1
    },
    0x01D5: {
        T: 1
    },
    0x01D6: {
        T: -1
    },
    0x01D7: {},
    0x01D8: {},
    0x01D9: {
        T: 1
    },
    0x01DA: {
        T: -1
    },
    0x01DB: {},
    0x01DC: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMargins
    },
    0x01DD: {},
    0x01DE: {},
    0x01DF: {
        T: 1
    },
    0x01E0: {
        T: -1
    },
    0x01E1: {
        T: 1
    },
    0x01E2: {
        T: -1
    },
    0x01E3: {
        T: 1
    },
    0x01E4: {
        T: -1
    },
    0x01E5: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsFmtInfo
    },
    0x01E6: {
        T: 1
    },
    0x01E7: {
        T: -1
    },
    0x01E8: {
        T: 1
    },
    0x01E9: {
        T: -1
    },
    0x01EA: {
        T: 1
    },
    0x01EB: {
        T: -1
    },
    0x01EC: {
        T: 1
    },
    0x01ED: {
        T: -1
    },
    0x01EE: {
        f: $3ee4f50b1ae43a89$var$parse_BrtHLink
    },
    0x01EF: {
        T: 1
    },
    0x01F0: {
        T: -1
    },
    0x01F1: {
        T: 1
    },
    0x01F2: {
        T: -1
    },
    0x01F3: {},
    0x01F4: {
        T: 1
    },
    0x01F5: {
        T: -1
    },
    0x01F6: {
        T: 1
    },
    0x01F7: {
        T: -1
    },
    0x01F8: {},
    0x01F9: {
        T: 1
    },
    0x01FA: {
        T: -1
    },
    0x01FB: {},
    0x01FC: {
        T: 1
    },
    0x01FD: {
        T: -1
    },
    0x01FE: {
        T: 1
    },
    0x01FF: {
        T: -1
    },
    0x0200: {},
    0x0201: {},
    0x0202: {
        T: 1
    },
    0x0203: {
        T: -1
    },
    0x0204: {
        T: 1
    },
    0x0205: {
        T: -1
    },
    0x0206: {
        T: 1
    },
    0x0207: {
        T: -1
    },
    0x0208: {
        T: 1
    },
    0x0209: {
        T: -1
    },
    0x020A: {},
    0x020B: {},
    0x020C: {},
    0x020D: {},
    0x020E: {},
    0x020F: {},
    0x0210: {
        T: 1
    },
    0x0211: {
        T: -1
    },
    0x0212: {
        T: 1
    },
    0x0213: {
        T: -1
    },
    0x0214: {
        T: 1
    },
    0x0215: {
        T: -1
    },
    0x0216: {},
    0x0217: {},
    0x0218: {},
    0x0219: {},
    0x021A: {
        T: 1
    },
    0x021B: {
        T: -1
    },
    0x021C: {
        T: 1
    },
    0x021D: {
        T: -1
    },
    0x021E: {
        T: 1
    },
    0x0224: {},
    0x0225: {},
    0x0226: {
        f: $3ee4f50b1ae43a89$var$parse_RelID
    },
    0x0227: {
        f: $3ee4f50b1ae43a89$var$parse_XLNullableWideString
    },
    0x0228: {},
    0x0229: {},
    0x022A: {
        T: 1
    },
    0x022B: {
        T: -1
    },
    0x022C: {
        T: 1
    },
    0x022D: {
        T: -1
    },
    0x022E: {
        T: 1
    },
    0x022F: {
        T: -1
    },
    0x0230: {
        T: 1
    },
    0x0231: {
        T: -1
    },
    0x0232: {},
    0x0234: {},
    0x0235: {
        T: 1
    },
    0x0236: {
        T: -1
    },
    0x0239: {
        T: 1
    },
    0x023A: {
        T: -1
    },
    0x023C: {},
    0x023D: {
        T: 1
    },
    0x023E: {
        T: -1
    },
    0x0241: {},
    0x0242: {},
    0x0243: {},
    0x0244: {},
    0x0245: {},
    0x0246: {},
    0x0247: {},
    0x0248: {},
    0x0249: {},
    0x024A: {},
    0x024B: {},
    0x024C: {
        T: -1
    },
    0x024D: {},
    0x024E: {
        T: 1
    },
    0x024F: {
        T: -1
    },
    0x0250: {
        T: 1
    },
    0x0251: {
        T: -1
    },
    0x0252: {
        T: 1
    },
    0x0253: {
        T: -1
    },
    0x0254: {},
    0x0255: {
        T: 1
    },
    0x0256: {
        T: -1
    },
    0x0257: {
        T: 1
    },
    0x0258: {
        T: -1
    },
    0x0259: {
        T: 1
    },
    0x025A: {
        T: -1
    },
    0x025B: {
        T: 1
    },
    0x025C: {
        T: -1
    },
    0x025D: {
        T: 1
    },
    0x025E: {
        T: -1
    },
    0x025F: {},
    0x0260: {
        T: 1
    },
    0x0261: {
        T: -1
    },
    0x0262: {},
    0x0263: {
        T: 1
    },
    0x0264: {
        T: -1
    },
    0x0265: {
        T: 1
    },
    0x0266: {
        T: -1
    },
    0x0267: {
        T: 1
    },
    0x0268: {
        T: -1
    },
    0x0269: {
        T: 1
    },
    0x026A: {
        T: -1
    },
    0x026B: {
        T: 1
    },
    0x026C: {
        T: -1
    },
    0x0271: {},
    0x0272: {
        T: 1
    },
    0x0273: {
        T: -1
    },
    0x0274: {
        T: 1
    },
    0x0275: {
        T: -1
    },
    0x0276: {
        T: 1
    },
    0x0277: {
        T: -1
    },
    0x0278: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCommentAuthor
    },
    0x0279: {
        T: 1
    },
    0x027A: {
        T: -1
    },
    0x027B: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginComment
    },
    0x027C: {
        T: -1
    },
    0x027D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCommentText
    },
    0x027E: {
        T: 1
    },
    0x027F: {},
    0x0280: {
        T: -1
    },
    0x0281: {
        T: 1
    },
    0x0282: {
        T: -1
    },
    0x0283: {
        T: 1
    },
    0x0284: {},
    0x0285: {
        T: -1
    },
    0x0286: {
        T: 1
    },
    0x0288: {
        T: 1
    },
    0x0289: {},
    0x028A: {
        T: -1
    },
    0x028B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCsProp
    },
    0x028C: {},
    0x028D: {
        T: 1
    },
    0x028E: {
        T: -1
    },
    0x028F: {
        T: 1
    },
    0x0290: {
        T: -1
    },
    0x0291: {
        T: 1
    },
    0x0292: {
        T: -1
    },
    0x0293: {},
    0x0294: {
        T: 1
    },
    0x0295: {},
    0x0296: {
        T: -1
    },
    0x0297: {},
    0x0298: {
        T: 1
    },
    0x0299: {},
    0x029A: {
        T: -1
    },
    0x029B: {},
    0x029C: {},
    0x029D: {},
    0x029F: {
        T: 1
    },
    0x02A0: {
        T: -1
    },
    0x02A1: {
        T: 1
    },
    0x02A2: {
        T: -1
    },
    0x02A3: {},
    0x02A4: {},
    0x02A5: {},
    0x02A6: {},
    0x02A7: {},
    0x02A8: {},
    0x02A9: {},
    0x0400: {},
    0x0401: {},
    0x0402: {
        T: 1
    },
    0x0403: {
        T: -1
    },
    0x0404: {
        T: 1
    },
    0x0405: {
        T: -1
    },
    0x0406: {},
    0x0407: {
        T: 1
    },
    0x0408: {
        T: -1
    },
    0x0409: {
        T: 1
    },
    0x040A: {
        T: -1
    },
    0x040B: {},
    0x040C: {},
    0x040D: {},
    0x040E: {
        T: 1
    },
    0x040F: {
        T: -1
    },
    0x0410: {},
    0x0411: {
        T: 1
    },
    0x0412: {
        T: -1
    },
    0x0413: {},
    0x0414: {},
    0x0415: {},
    0x0416: {
        T: 1
    },
    0x0417: {
        T: -1
    },
    0x0418: {
        T: 1
    },
    0x0419: {
        T: -1
    },
    0x041A: {},
    0x041B: {
        T: 1
    },
    0x041C: {
        T: 1
    },
    0x041D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtDVal14
    },
    0x041E: {
        T: 1
    },
    0x041F: {},
    0x0420: {
        T: 1
    },
    0x0421: {
        T: -1
    },
    0x0422: {
        T: 1
    },
    0x0423: {
        T: -1
    },
    0x0425: {},
    0x0426: {
        T: 1
    },
    0x0427: {
        T: -1
    },
    0x0428: {
        T: 1
    },
    0x0429: {
        T: -1
    },
    0x042A: {
        T: 1
    },
    0x042B: {
        T: -1
    },
    0x042C: {
        T: 1
    },
    0x042D: {
        T: -1
    },
    0x042E: {
        T: 1
    },
    0x042F: {
        T: -1
    },
    0x0430: {
        T: 1
    },
    0x0431: {
        T: -1
    },
    0x0433: {
        T: 1
    },
    0x0434: {
        T: -1
    },
    0x0435: {
        T: 1
    },
    0x0436: {
        T: -1
    },
    0x0437: {
        T: 1
    },
    0x0438: {
        T: -1
    },
    0x0439: {
        T: 1
    },
    0x043A: {
        T: -1
    },
    0x043B: {
        T: 1
    },
    0x043C: {
        T: -1
    },
    0x043D: {},
    0x043E: {
        T: 1
    },
    0x043F: {
        T: -1
    },
    0x0440: {
        T: 1
    },
    0x0441: {
        T: -1
    },
    0x0442: {
        T: 1
    },
    0x0443: {
        T: -1
    },
    0x0444: {
        T: 1
    },
    0x0445: {
        T: -1
    },
    0x0446: {
        T: 1
    },
    0x0447: {
        T: -1
    },
    0x0448: {},
    0x0449: {
        T: 1
    },
    0x044A: {},
    0x044B: {
        T: -1
    },
    0x044C: {
        T: 1
    },
    0x044D: {
        T: -1
    },
    0x044E: {},
    0x044F: {},
    0x0450: {},
    0x0451: {},
    0x0457: {},
    0x0458: {},
    0x0459: {
        T: 1
    },
    0x045A: {
        T: -1
    },
    0x045B: {
        T: 1
    },
    0x045C: {
        T: -1
    },
    0x045D: {},
    0x045E: {
        T: 1
    },
    0x045F: {
        T: -1
    },
    0x0460: {
        T: 1
    },
    0x0461: {
        T: -1
    },
    0x0462: {
        T: 1
    },
    0x0463: {
        T: -1
    },
    0x0464: {
        T: 1
    },
    0x0465: {
        T: -1
    },
    0x0466: {},
    0x0468: {
        T: 1
    },
    0x0469: {
        T: -1
    },
    0x046A: {},
    0x046B: {
        T: 1
    },
    0x046C: {
        T: -1
    },
    0x046D: {
        T: 1
    },
    0x046E: {
        T: -1
    },
    0x046F: {
        T: 1
    },
    0x0470: {
        T: -1
    },
    0x0471: {
        T: 1
    },
    0x0472: {
        T: -1
    },
    0x0473: {
        T: 1
    },
    0x0474: {
        T: -1
    },
    0x0475: {},
    0x0476: {
        T: 1
    },
    0x0477: {
        T: -1
    },
    0x0478: {
        T: 1
    },
    0x0479: {
        T: -1
    },
    0x047A: {},
    0x047B: {
        T: 1
    },
    0x047C: {
        T: -1
    },
    0x047D: {
        T: 1
    },
    0x047E: {
        T: -1
    },
    0x0480: {
        T: 1
    },
    0x0481: {
        T: -1
    },
    0x0482: {
        T: -1
    },
    0x0483: {
        T: -1
    },
    0x0484: {
        T: -1
    },
    0x0485: {
        T: 1
    },
    0x0486: {
        T: -1
    },
    0x0487: {
        T: 1
    },
    0x0488: {
        T: -1
    },
    0x0489: {
        T: 1
    },
    0x048A: {
        T: -1
    },
    0x048B: {
        T: 1
    },
    0x048C: {
        T: -1
    },
    0x048D: {
        T: 1
    },
    0x048E: {
        T: -1
    },
    0x048F: {
        T: 1
    },
    0x0490: {
        T: -1
    },
    0x0491: {
        T: 1
    },
    0x0492: {
        T: -1
    },
    0x0493: {},
    0x0494: {
        T: 1
    },
    0x0495: {
        T: -1
    },
    0x0499: {},
    0x049A: {
        T: 1
    },
    0x049C: {},
    0x049D: {},
    0x049E: {},
    0x0800: {
        T: 1
    },
    0x0801: {
        T: -1
    },
    0x0802: {},
    0x0803: {
        T: 1
    },
    0x0804: {
        T: -1
    },
    0x0805: {},
    0x0806: {},
    0x0807: {
        T: 1
    },
    0x0808: {
        T: -1
    },
    0x0809: {
        T: 1
    },
    0x080A: {
        T: -1
    },
    0x080C: {},
    0x0813: {},
    0x0814: {
        T: 1
    },
    0x0815: {
        T: -1
    },
    0x0816: {},
    0x0817: {},
    0x0818: {
        T: 1
    },
    0x0819: {
        T: -1
    },
    0x081B: {},
    0x081C: {},
    0x081D: {
        T: 1
    },
    0x081E: {
        T: -1
    },
    0x081F: {},
    0x0820: {
        T: 1
    },
    0x0821: {
        T: -1
    },
    0x0822: {},
    0x0823: {
        T: 1
    },
    0x0824: {
        T: -1
    },
    0x0825: {
        T: 1
    },
    0x0826: {
        T: -1
    },
    0x0827: {
        T: 1
    },
    0x0828: {
        T: -1
    },
    0x0829: {
        T: 1
    },
    0x082A: {
        T: -1
    },
    0x082B: {},
    0x082C: {},
    0x082D: {
        T: 1
    },
    0x082E: {
        T: -1
    },
    0x082F: {},
    0x0830: {
        T: 1
    },
    0x0831: {
        T: -1
    },
    0x0832: {
        T: 1
    },
    0x0833: {
        T: -1
    },
    0x0834: {
        T: 1
    },
    0x0835: {
        T: -1
    },
    0x0836: {},
    0x0837: {
        T: 1
    },
    0x0838: {
        T: -1
    },
    0x0839: {},
    0x083A: {
        T: 1
    },
    0x083B: {
        T: -1
    },
    0x083C: {},
    0x083D: {
        T: 1
    },
    0x083E: {
        T: -1
    },
    0x083F: {
        T: 1
    },
    0x0840: {
        T: -1
    },
    0x0841: {
        T: 1
    },
    0x0842: {
        T: -1
    },
    0x0843: {},
    0x0844: {},
    0x0845: {},
    0x0846: {
        T: 1
    },
    0x0847: {
        T: -1
    },
    0x0848: {},
    0x0849: {
        T: 1
    },
    0x084A: {
        T: -1
    },
    0x084B: {
        T: 1
    },
    0x084C: {
        T: -1
    },
    0x084D: {},
    0x084E: {
        T: 1
    },
    0x084F: {
        T: -1
    },
    0x0850: {},
    0x0851: {
        T: 1
    },
    0x0852: {
        T: -1
    },
    0x0853: {
        T: 1
    },
    0x0854: {
        T: -1
    },
    0x0855: {
        T: 1
    },
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {
        T: 1
    },
    0x085A: {
        T: -1
    },
    0x085B: {
        T: 1
    },
    0x085C: {
        T: -1
    },
    0x085D: {},
    0x0C00: {},
    0x0C01: {},
    0x1000: {
        T: 1
    },
    0x1001: {
        T: -1
    },
    0x138A: {
        T: 1
    },
    0x138B: {
        T: -1
    },
    0x13D9: {
        T: 1
    },
    0x13DA: {
        T: -1
    },
    0x13DB: {},
    0x13DC: {
        T: 1
    },
    0x13DD: {
        T: -1
    },
    0x13DE: {
        T: 1
    },
    0x13DF: {
        T: -1
    },
    0x13E0: {},
    0x13E1: {},
    0x13E2: {},
    0x13E4: {
        T: 1
    },
    0x13E5: {
        T: -1
    },
    0x13E6: {},
    0x13E7: {
        T: 1
    },
    0x13E8: {
        T: -1
    },
    0x13E9: {},
    0x13EB: {},
    0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $3ee4f50b1ae43a89$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ 0x0006: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    0x000a: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x000c: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x000d: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x000e: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x000f: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0010: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    0x0011: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0012: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0013: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x0014: {
        f: $3ee4f50b1ae43a89$var$parse_XLHeaderFooter
    },
    0x0015: {
        f: $3ee4f50b1ae43a89$var$parse_XLHeaderFooter
    },
    0x0017: {
        f: $3ee4f50b1ae43a89$var$parse_ExternSheet
    },
    0x0018: {
        f: $3ee4f50b1ae43a89$var$parse_Lbl
    },
    0x0019: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x001a: {},
    0x001b: {},
    0x001c: {
        f: $3ee4f50b1ae43a89$var$parse_Note
    },
    0x001d: {},
    0x0022: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0023: {
        f: $3ee4f50b1ae43a89$var$parse_ExternName
    },
    0x0026: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    0x0027: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    0x0028: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    0x0029: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    0x002a: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x002b: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x002f: {
        f: $3ee4f50b1ae43a89$var$parse_FilePass
    },
    0x0031: {
        f: $3ee4f50b1ae43a89$var$parse_Font
    },
    0x0033: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x003c: {},
    0x003d: {
        f: $3ee4f50b1ae43a89$var$parse_Window1
    },
    0x0040: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0041: {
        f: $3ee4f50b1ae43a89$var$parse_Pane
    },
    0x0042: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x004d: {},
    0x0050: {},
    0x0051: {},
    0x0052: {},
    0x0055: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x0059: {},
    0x005a: {},
    0x005b: {},
    0x005c: {
        f: $3ee4f50b1ae43a89$var$parse_WriteAccess
    },
    0x005d: {
        f: $3ee4f50b1ae43a89$var$parse_Obj
    },
    0x005e: {},
    0x005f: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0060: {},
    0x0061: {},
    0x0063: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x007d: {
        f: $3ee4f50b1ae43a89$var$parse_ColInfo
    },
    0x0080: {
        f: $3ee4f50b1ae43a89$var$parse_Guts
    },
    0x0081: {
        f: $3ee4f50b1ae43a89$var$parse_WsBool
    },
    0x0082: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x0083: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0084: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0085: {
        f: $3ee4f50b1ae43a89$var$parse_BoundSheet8
    },
    0x0086: {},
    0x008c: {
        f: $3ee4f50b1ae43a89$var$parse_Country
    },
    0x008d: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x0090: {},
    0x0092: {
        f: $3ee4f50b1ae43a89$var$parse_Palette
    },
    0x0097: {},
    0x0098: {},
    0x0099: {},
    0x009a: {},
    0x009b: {},
    0x009c: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x009d: {},
    0x009e: {},
    0x00a0: {
        f: $3ee4f50b1ae43a89$var$parse_Scl
    },
    0x00a1: {
        f: $3ee4f50b1ae43a89$var$parse_Setup
    },
    0x00ae: {},
    0x00af: {},
    0x00b0: {},
    0x00b1: {},
    0x00b2: {},
    0x00b4: {},
    0x00b5: {},
    0x00b6: {},
    0x00b8: {},
    0x00b9: {},
    0x00bd: {
        f: $3ee4f50b1ae43a89$var$parse_MulRk
    },
    0x00be: {
        f: $3ee4f50b1ae43a89$var$parse_MulBlank
    },
    0x00c1: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x00c5: {},
    0x00c6: {},
    0x00c7: {},
    0x00c8: {},
    0x00c9: {},
    0x00ca: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x00cb: {},
    0x00cc: {},
    0x00cd: {},
    0x00ce: {},
    0x00cf: {},
    0x00d0: {},
    0x00d1: {},
    0x00d2: {},
    0x00d3: {},
    0x00d5: {},
    0x00d7: {},
    0x00d8: {},
    0x00d9: {},
    0x00da: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x00dc: {},
    0x00dd: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x00de: {},
    0x00e0: {
        f: $3ee4f50b1ae43a89$var$parse_XF
    },
    0x00e1: {
        f: $3ee4f50b1ae43a89$var$parse_InterfaceHdr
    },
    0x00e2: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x00e3: {},
    0x00e5: {
        f: $3ee4f50b1ae43a89$var$parse_MergeCells
    },
    0x00e9: {},
    0x00eb: {},
    0x00ec: {},
    0x00ed: {},
    0x00ef: {},
    0x00f0: {},
    0x00f1: {},
    0x00f2: {},
    0x00f4: {},
    0x00f5: {},
    0x00f6: {},
    0x00f7: {},
    0x00f8: {},
    0x00f9: {},
    0x00fb: {},
    0x00fc: {
        f: $3ee4f50b1ae43a89$var$parse_SST
    },
    0x00fd: {
        f: $3ee4f50b1ae43a89$var$parse_LabelSst
    },
    0x00ff: {
        f: $3ee4f50b1ae43a89$var$parse_ExtSST
    },
    0x0100: {},
    0x0103: {},
    0x0122: {},
    0x0137: {},
    0x0138: {},
    0x013b: {},
    0x013d: {
        f: $3ee4f50b1ae43a89$var$parseuint16a
    },
    0x013e: {},
    0x013f: {},
    0x0140: {},
    0x014a: {},
    0x014b: {},
    0x014d: {},
    0x014e: {},
    0x014f: {},
    0x0150: {},
    0x0151: {},
    0x0152: {},
    0x0153: {},
    0x0154: {},
    0x015f: {},
    0x0160: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x0161: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x0191: {},
    0x0192: {},
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x01a9: {},
    0x01aa: {},
    0x01ab: {},
    0x01ac: {},
    0x01ad: {},
    0x01ae: {
        f: $3ee4f50b1ae43a89$var$parse_SupBook
    },
    0x01af: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x01b0: {},
    0x01b1: {},
    0x01b2: {},
    0x01b5: {},
    0x01b6: {
        f: $3ee4f50b1ae43a89$var$parse_TxO
    },
    0x01b7: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    0x01b8: {
        f: $3ee4f50b1ae43a89$var$parse_HLink
    },
    0x01b9: {},
    0x01ba: {
        f: $3ee4f50b1ae43a89$var$parse_XLUnicodeString
    },
    0x01bb: {},
    0x01bc: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x01bd: {},
    0x01be: {},
    0x01c0: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x01c1: {
        f: $3ee4f50b1ae43a89$var$parse_RecalcId,
        r: 2
    },
    0x01c2: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x0200: {
        f: $3ee4f50b1ae43a89$var$parse_Dimensions
    },
    0x0201: {
        f: $3ee4f50b1ae43a89$var$parse_Blank
    },
    0x0203: {
        f: $3ee4f50b1ae43a89$var$parse_Number
    },
    0x0204: {
        f: $3ee4f50b1ae43a89$var$parse_Label
    },
    0x0205: {
        f: $3ee4f50b1ae43a89$var$parse_BoolErr
    },
    0x0207: {
        f: $3ee4f50b1ae43a89$var$parse_String
    },
    0x0208: {
        f: $3ee4f50b1ae43a89$var$parse_Row
    },
    0x020b: {},
    0x0221: {
        f: $3ee4f50b1ae43a89$var$parse_Array
    },
    0x0225: {
        f: $3ee4f50b1ae43a89$var$parse_DefaultRowHeight
    },
    0x0236: {},
    0x023e: {
        f: $3ee4f50b1ae43a89$var$parse_Window2
    },
    0x027e: {
        f: $3ee4f50b1ae43a89$var$parse_RK
    },
    0x0293: {},
    0x0418: {},
    0x041e: {
        f: $3ee4f50b1ae43a89$var$parse_Format
    },
    0x043c: {},
    0x04bc: {
        f: $3ee4f50b1ae43a89$var$parse_ShrFmla
    },
    0x0800: {
        f: $3ee4f50b1ae43a89$var$parse_HLinkTooltip
    },
    0x0801: {},
    0x0802: {},
    0x0803: {},
    0x0804: {},
    0x0805: {},
    0x0806: {},
    0x0807: {},
    0x0808: {},
    0x0809: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    0x080a: {},
    0x080b: {},
    0x080c: {},
    0x080d: {},
    0x080e: {},
    0x080f: {},
    0x0810: {},
    0x0812: {},
    0x0813: {},
    0x0850: {},
    0x0851: {},
    0x0852: {},
    0x0853: {},
    0x0854: {},
    0x0855: {},
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {},
    0x085a: {},
    0x0862: {},
    0x0863: {
        r: 12
    },
    0x0864: {},
    0x0865: {},
    0x0866: {},
    0x0867: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x0868: {},
    0x086a: {},
    0x086b: {},
    0x086c: {},
    0x0871: {},
    0x0872: {},
    0x0874: {},
    0x0875: {},
    0x0876: {},
    0x0877: {},
    0x0878: {},
    0x0879: {},
    0x087a: {},
    0x087b: {},
    0x087c: {
        f: $3ee4f50b1ae43a89$var$parse_XFCRC,
        r: 12
    },
    0x087d: {
        f: $3ee4f50b1ae43a89$var$parse_XFExt,
        r: 12
    },
    0x087e: {},
    0x087f: {},
    0x0884: {},
    0x0885: {},
    0x0886: {},
    0x0887: {},
    0x0888: {},
    0x0889: {},
    0x088a: {},
    0x088b: {},
    0x088c: {
        f: $3ee4f50b1ae43a89$var$parsebool,
        r: 12
    },
    0x088d: {},
    0x088e: {
        r: 12
    },
    0x088f: {},
    0x0890: {},
    0x0892: {},
    0x0893: {},
    0x0894: {
        f: $3ee4f50b1ae43a89$var$parse_NameCmt,
        r: 12
    },
    0x0895: {},
    0x0896: {
        f: $3ee4f50b1ae43a89$var$parse_Theme,
        r: 12
    },
    0x0897: {},
    0x0898: {},
    0x0899: {},
    0x089a: {
        f: $3ee4f50b1ae43a89$var$parse_MTRSettings,
        r: 12
    },
    0x089b: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    0x089c: {},
    0x089d: {},
    0x089e: {},
    0x089f: {},
    0x08a3: {
        f: $3ee4f50b1ae43a89$var$parse_ForceFullCalculation
    },
    0x08a4: {},
    0x08a5: {},
    0x08a6: {},
    0x08a7: {},
    0x1001: {},
    0x1002: {},
    0x1003: {},
    0x1006: {},
    0x1007: {},
    0x1009: {},
    0x100a: {},
    0x100b: {},
    0x100c: {},
    0x100d: {},
    0x1014: {},
    0x1015: {},
    0x1016: {},
    0x1017: {},
    0x1018: {},
    0x1019: {},
    0x101a: {},
    0x101b: {},
    0x101c: {},
    0x101d: {},
    0x101e: {},
    0x101f: {},
    0x1020: {},
    0x1021: {},
    0x1022: {},
    0x1024: {},
    0x1025: {},
    0x1026: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x1027: {},
    0x1032: {},
    0x1033: {},
    0x1034: {},
    0x1035: {},
    0x103a: {},
    0x103c: {},
    0x103d: {},
    0x103e: {},
    0x103f: {},
    0x1040: {},
    0x1041: {},
    0x1043: {},
    0x1044: {
        f: $3ee4f50b1ae43a89$var$parse_ShtProps
    },
    0x1045: {},
    0x1046: {},
    0x1048: {},
    0x104a: {},
    0x104b: {},
    0x104e: {},
    0x104f: {},
    0x1050: {},
    0x1051: {},
    0x105b: {},
    0x105c: {
        f: $3ee4f50b1ae43a89$var$parse_ClrtClient
    },
    0x105d: {},
    0x105f: {},
    0x1060: {},
    0x1061: {},
    0x1062: {},
    0x1063: {},
    0x1064: {},
    0x1065: {},
    0x1066: {},
    0x1067: {},
    0x1068: {},
    0x0000: {
        f: $3ee4f50b1ae43a89$var$parse_Dimensions
    },
    0x0001: {},
    0x0002: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2INT
    },
    0x0003: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2NUM
    },
    0x0004: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2STR
    },
    0x0005: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2BOOLERR
    },
    0x0007: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2STRING
    },
    0x0008: {},
    0x0009: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    0x000b: {},
    0x0016: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x001e: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2Format
    },
    0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {},
    0x0021: {
        f: $3ee4f50b1ae43a89$var$parse_Array
    },
    0x0024: {},
    0x0025: {
        f: $3ee4f50b1ae43a89$var$parse_DefaultRowHeight
    },
    // 0x002c ??
    // 0x002d ??
    // 0x002e ??
    // 0x0030 FONTCOUNT: number of fonts
    0x0032: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2FONTXTRA
    },
    // 0x0035: INFOOPTS
    // 0x0036: TABLE (BIFF2 only)
    // 0x0037: TABLE2 (BIFF2 only)
    // 0x0038: WNDESK
    // 0x0039 ??
    // 0x003a: BEGINPREF
    // 0x003b: ENDPREF
    0x003e: {},
    // 0x003f ??
    // 0x0046: SHOWSCROLL
    // 0x0047: SHOWFORMULA
    // 0x0048: STATUSBAR
    // 0x0049: SHORTMENUS
    // 0x004A:
    // 0x004B:
    // 0x004C:
    // 0x004E:
    // 0x004F:
    // 0x0058: TOOLBAR (BIFF3)
    /* - - - */ 0x0034: {},
    0x0043: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2XF
    },
    0x0044: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    0x0045: {},
    0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ 0x007e: {},
    /* Not necessarily same as 0x027e */ 0x007f: {
        f: $3ee4f50b1ae43a89$var$parse_ImData
    },
    0x0087: {},
    0x0088: {},
    0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    0x008F: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF4SheetInfo
    },
    0x0091: {},
    // 0x93 STYLE
    0x0094: {},
    0x0095: {},
    0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    0x00a9: {},
    0x00ab: {},
    0x00bc: {},
    /* Not necessarily same as 0x04bc */ 0x00bf: {},
    0x00c0: {},
    0x00c2: {},
    0x00c3: {},
    0x00d6: {
        f: $3ee4f50b1ae43a89$var$parse_RString
    },
    0x00df: {},
    0x00ea: {},
    0x0162: {},
    0x01a5: {},
    0x0206: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    0x0209: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    0x0218: {
        f: $3ee4f50b1ae43a89$var$parse_Lbl
    },
    0x0223: {
        f: $3ee4f50b1ae43a89$var$parse_ExternName
    },
    0x0231: {},
    0x0243: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF3XF
    },
    0x0406: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    0x0409: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    0x0443: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF4XF
    },
    0x086d: {},
    0x0873: {},
    0x0881: {},
    0x08c0: {},
    0x08c1: {},
    0x08c2: {},
    0x08c3: {},
    0x08c4: {},
    0x08c5: {},
    0x08c6: {},
    0x08c7: {},
    0x08c8: {},
    0x08c9: {},
    0x08ca: {},
    0x08cb: {},
    0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ 0x0065: {},
    0x0066: {},
    0x0069: {},
    0x006a: {},
    0x006b: {},
    0x006d: {},
    0x0070: {},
    0x0072: {},
    0x7262: {}
};
function $3ee4f50b1ae43a89$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $3ee4f50b1ae43a89$var$is_buf(payload)) ba.push(payload);
}
function $3ee4f50b1ae43a89$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $3ee4f50b1ae43a89$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $3ee4f50b1ae43a89$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val1, t /*:?string*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    $3ee4f50b1ae43a89$var$write_Bes(val1, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $3ee4f50b1ae43a89$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val1) {
    var out = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * val1.length);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val1.length);
    out.write_shift(val1.length, val1, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $3ee4f50b1ae43a89$var$write_comments_biff2(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    comments.forEach(function(data) {
        var text = data[0].map(function(cc) {
            return cc.t;
        }).join("");
        // TODO: should '\n' be translated to '\r' to correct for Excel 5.0 bug when exporting to BIFF2/3 ?
        if (text.length <= 2048) return $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x001C, $3ee4f50b1ae43a89$var$write_NOTE_BIFF2(text, data[1], data[2]));
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x001C, $3ee4f50b1ae43a89$var$write_NOTE_BIFF2(text.slice(0, 2048), data[1], data[2], text.length));
        for(var i = 2048; i < text.length; i += 2048)$3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x001C, $3ee4f50b1ae43a89$var$write_NOTE_BIFF2(text.slice(i, Math.min(i + 2048, text.length)), -1, -1, Math.min(2048, text.length - i)));
    });
}
/* TODO: BIFF3/4 use different records -- see comments*/ function $3ee4f50b1ae43a89$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var ifmt = 0;
    if (cell.z != null) {
        ifmt = opts._BIFF2FmtTable.indexOf(cell.z);
        if (ifmt == -1) {
            opts._BIFF2FmtTable.push(cell.z);
            ifmt = opts._BIFF2FmtTable.length - 1;
        }
    }
    var ixfe = 0;
    if (cell.z != null) {
        for(; ixfe < opts.cellXfs.length; ++ixfe)if (opts.cellXfs[ixfe].numFmtId == ifmt) break;
        if (ixfe == opts.cellXfs.length) opts.cellXfs.push({
            numFmtId: ifmt
        });
    }
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (opts.biff == 2 && v == (v | 0) && v >= 0 && v < 65536) // 0x027E (RK) in BIFF3/4
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0002, $3ee4f50b1ae43a89$var$write_BIFF2INT(R, C, v, ixfe, ifmt));
            else if (isNaN(v)) // 0x0205 in BIFF3/4
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0005, $3ee4f50b1ae43a89$var$write_BIFF2BERR(R, C, 0x24, "e")); // #NUM!
            else if (!isFinite(v)) // 0x0205 in BIFF3/4
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0005, $3ee4f50b1ae43a89$var$write_BIFF2BERR(R, C, 0x07, "e")); // #DIV/0!
            else // 0x0203 in BIFF3/4
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0003, $3ee4f50b1ae43a89$var$write_BIFF2NUM(R, C, v, ixfe, ifmt));
            return;
        case 'b':
        case 'e':
            // 0x0205 in BIFF3/4
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0005, $3ee4f50b1ae43a89$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            // 0x0204 in BIFF3/4
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0004, $3ee4f50b1ae43a89$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    // 0x0201 in BIFF3/4
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0001, $3ee4f50b1ae43a89$var$write_BIFF2Cell(null, R, C));
}
function $3ee4f50b1ae43a89$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, 0x3FFF);
    }
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    var row = [], comments = [];
    /* TODO: 0x0000 / 0x0200 dimensions? */ for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $3ee4f50b1ae43a89$var$write_ws_biff2_cell(ba, cell, R, C, opts, date1904);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    /* ... 0x12 0x19 0x13 (Password) */ $3ee4f50b1ae43a89$var$write_comments_biff2(ba, comments);
/* 0x3d (Window1) ... */ }
/* Based on test files */ function $3ee4f50b1ae43a89$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x10, o));
    if (((wb.Workbook || {}).WBProps || {}).date1904) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0022, $3ee4f50b1ae43a89$var$writebool(true));
    o.cellXfs = [
        {
            numFmtId: 0
        }
    ];
    o._BIFF2FmtTable = [
        "General"
    ];
    o._Fonts = [];
    var body = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_ws_biff2(body, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    o._BIFF2FmtTable.forEach(function(f) {
        if (o.biff <= 3) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x001E, $3ee4f50b1ae43a89$var$write_BIFF2Format(f));
        else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x041E, $3ee4f50b1ae43a89$var$write_BIFF4Format(f));
    });
    o.cellXfs.forEach(function(xf) {
        switch(o.biff){
            case 2:
                $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0043, $3ee4f50b1ae43a89$var$write_BIFF2XF(xf));
                break;
            case 3:
                $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0243, $3ee4f50b1ae43a89$var$write_BIFF3XF(xf));
                break;
            case 4:
                $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0443, $3ee4f50b1ae43a89$var$write_BIFF4XF(xf));
                break;
        }
    });
    delete o._BIFF2FmtTable;
    delete o.cellXfs;
    delete o._Fonts;
    ba.push(body.end());
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
var $3ee4f50b1ae43a89$var$b8oid = 1, $3ee4f50b1ae43a89$var$b8ocnts /*:Array<[number, number, number]>*/  = [];
function $3ee4f50b1ae43a89$var$write_MsoDrawingGroup() {
    var buf = $3ee4f50b1ae43a89$var$new_buf(82 + 8 * $3ee4f50b1ae43a89$var$b8ocnts.length);
    /* [MS-ODRAW] 2.2.12 OfficeArtDggContainer */ buf.write_shift(2, 0x0F);
    buf.write_shift(2, 0xF000);
    buf.write_shift(4, 74 + 8 * $3ee4f50b1ae43a89$var$b8ocnts.length);
    buf.write_shift(2, 0);
    buf.write_shift(2, 0xF006);
    buf.write_shift(4, 16 + 8 * $3ee4f50b1ae43a89$var$b8ocnts.length);
    buf.write_shift(4, $3ee4f50b1ae43a89$var$b8oid);
    buf.write_shift(4, $3ee4f50b1ae43a89$var$b8ocnts.length + 1);
    var acc = 0;
    for(var i = 0; i < $3ee4f50b1ae43a89$var$b8ocnts.length; ++i)acc += $3ee4f50b1ae43a89$var$b8ocnts[i] && $3ee4f50b1ae43a89$var$b8ocnts[i][1] || 0;
    buf.write_shift(4, acc);
    buf.write_shift(4, $3ee4f50b1ae43a89$var$b8ocnts.length);
    /* 2.2.46 OfficeArtIDCL + */ $3ee4f50b1ae43a89$var$b8ocnts.forEach(function(b8) {
        buf.write_shift(4, b8[0]);
        buf.write_shift(4, b8[2]);
    });
    buf.write_shift(2, 0x33); // 0x03 | (3 << 4)
    buf.write_shift(2, 0xF00B);
    buf.write_shift(4, 0x12); // 3 * 6
    /* 2.3.21.15 Text Boolean Properties */ buf.write_shift(2, 0xBF);
    buf.write_shift(4, 0x00080008);
    /* 2.3.7.2 fillColor */ buf.write_shift(2, 0x0181);
    buf.write_shift(4, 0x08000041);
    /* 2.3.8.1 lineColor */ buf.write_shift(2, 0x01C0);
    buf.write_shift(4, 0x08000040);
    buf.write_shift(2, 0x40);
    buf.write_shift(2, 0xF11E);
    buf.write_shift(4, 16);
    buf.write_shift(4, 0x0800000D);
    buf.write_shift(4, 0x0800000C);
    buf.write_shift(4, 0x08000017);
    buf.write_shift(4, 0x100000F7);
    return buf;
}
function $3ee4f50b1ae43a89$var$write_comments_biff8(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    var notes /*:Array<RawData>*/  = [], sz = 0, pl = $3ee4f50b1ae43a89$var$buf_array(), baseid = $3ee4f50b1ae43a89$var$b8oid;
    var _oasc;
    comments.forEach(function(c, ci) {
        var author = "";
        var text = c[0].map(function(t) {
            if (t.a && !author) author = t.a;
            return t.t;
        }).join("");
        ++$3ee4f50b1ae43a89$var$b8oid;
        var oasc = $3ee4f50b1ae43a89$var$new_buf(0x96);
        oasc.write_shift(2, 0x0F);
        oasc.write_shift(2, 0xF004);
        oasc.write_shift(4, 0x96);
        oasc.write_shift(2, 0xca2); // 0x02 | (0xca << 4)
        oasc.write_shift(2, 0xF00A);
        oasc.write_shift(4, 8);
        oasc.write_shift(4, $3ee4f50b1ae43a89$var$b8oid);
        oasc.write_shift(4, 0xA00);
        oasc.write_shift(2, 0xE3); // 0x03 | (14 << 4)
        oasc.write_shift(2, 0xF00B);
        oasc.write_shift(4, 0x54); // 14 * 6
        /* 2.3.21.1 ITxid */ oasc.write_shift(2, 0x80);
        oasc.write_shift(4, 0);
        /* 2.3.21.12 txdir */ oasc.write_shift(2, 0x8B);
        oasc.write_shift(4, 0x02);
        /* 2.3.21.15 Text Boolean Properties */ oasc.write_shift(2, 0xBF);
        oasc.write_shift(4, 0x00080008);
        /* 2.3.6.30 cxk */ oasc.write_shift(2, 0x0158);
        oasc.l += 4;
        /* 2.3.7.2 fillColor */ oasc.write_shift(2, 0x0181);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.4 fillBackColor */ oasc.write_shift(2, 0x0183);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.6 fillCrMod */ oasc.write_shift(2, 0x0185);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.7.43 Fill Style Boolean Properties */ oasc.write_shift(2, 0x01BF);
        oasc.write_shift(4, 0x00100010);
        /* 2.3.8.1 lineColor */ oasc.write_shift(2, 0x01C0);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.8.4 lineCrMod */ oasc.write_shift(2, 0x01C3);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.2 shadowColor */ oasc.write_shift(2, 0x0201);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.13.4 shadowCrMod */ oasc.write_shift(2, 0x0203);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.23 Shadow Style Boolean Properties */ oasc.write_shift(2, 0x023F);
        oasc.write_shift(4, 0x00030001);
        /* 2.3.4.44 Group Shape Boolean Properties */ oasc.write_shift(2, 0x03BF);
        oasc.write_shift(4, 0x00020000 | (c[0].hidden ? 2 : 0));
        oasc.l += 2;
        oasc.write_shift(2, 0xF010);
        oasc.write_shift(4, 0x12);
        oasc.write_shift(2, 0x3); // do not move or size with cells
        oasc.write_shift(2, c[2] + 2);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 1);
        oasc.l += 2;
        oasc.write_shift(2, c[2] + 4);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 5);
        oasc.l += 2;
        oasc.l += 2;
        oasc.write_shift(2, 0xF011);
        oasc.l += 4;
        oasc.l = 0x96;
        if (ci == 0) /* write_biff_rec(pl, 0x003C, oasc); */ _oasc = oasc;
        else $3ee4f50b1ae43a89$var$write_biff_rec(pl, 0x00EC, oasc);
        sz += 0x96;
        var obj = $3ee4f50b1ae43a89$var$new_buf(52); // 22 + 26 + 4
        /* [MS-XLS] 2.5.143 FtCmo */ obj.write_shift(2, 0x15);
        obj.write_shift(2, 0x12);
        obj.write_shift(2, 0x19);
        obj.write_shift(2, $3ee4f50b1ae43a89$var$b8oid);
        obj.write_shift(2, 0);
        obj.l = 22;
        /* [MS-XLS] 2.5.149 FtNts */ obj.write_shift(2, 0x0D);
        obj.write_shift(2, 0x16);
        obj.write_shift(4, 0x62726272);
        obj.write_shift(4, 0x95374305);
        obj.write_shift(4, 0x80301328);
        obj.write_shift(4, 0x69696904 + $3ee4f50b1ae43a89$var$b8oid * 256);
        obj.write_shift(2, 0);
        obj.write_shift(4, 0);
        // reserved
        obj.l += 4;
        $3ee4f50b1ae43a89$var$write_biff_rec(pl, 0x005D, obj);
        var oact = $3ee4f50b1ae43a89$var$new_buf(8);
        oact.l += 2;
        oact.write_shift(2, 0xF00D);
        oact.l += 4;
        $3ee4f50b1ae43a89$var$write_biff_rec(pl, 0x00EC, oact);
        sz += 8;
        var txo = $3ee4f50b1ae43a89$var$new_buf(18);
        txo.write_shift(2, 0x12);
        txo.l += 8;
        txo.write_shift(2, text.length);
        txo.write_shift(2, 0x10);
        txo.l += 4;
        $3ee4f50b1ae43a89$var$write_biff_rec(pl, 0x01b6, txo);
        var cont = $3ee4f50b1ae43a89$var$new_buf(1 + text.length);
        cont.write_shift(1, 0);
        cont.write_shift(text.length, text, "sbcs");
        $3ee4f50b1ae43a89$var$write_biff_rec(pl, 0x003C, cont);
        var conf = $3ee4f50b1ae43a89$var$new_buf(0x10);
        conf.l += 8;
        conf.write_shift(2, text.length);
        conf.l += 6;
        $3ee4f50b1ae43a89$var$write_biff_rec(pl, 0x003C, conf);
        var notesh = $3ee4f50b1ae43a89$var$new_buf(12 + author.length);
        notesh.write_shift(2, c[1]);
        notesh.write_shift(2, c[2]);
        notesh.write_shift(2, 0 | (c[0].hidden ? 0 : 2));
        notesh.write_shift(2, $3ee4f50b1ae43a89$var$b8oid);
        notesh.write_shift(2, author.length);
        notesh.write_shift(1, 0);
        notesh.write_shift(author.length, author, "sbcs");
        notesh.l++;
        notes.push(notesh);
    });
    var hdr = $3ee4f50b1ae43a89$var$new_buf(80);
    hdr.write_shift(2, 0x0F);
    hdr.write_shift(2, 0xF002);
    hdr.write_shift(4, sz + hdr.length - 8);
    hdr.write_shift(2, 0x10);
    hdr.write_shift(2, 0xF008);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, comments.length + 1);
    hdr.write_shift(4, $3ee4f50b1ae43a89$var$b8oid);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF003);
    hdr.write_shift(4, sz + 0x30);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF004);
    hdr.write_shift(4, 0x28);
    hdr.write_shift(2, 0x01);
    hdr.write_shift(2, 0xF009);
    hdr.write_shift(4, 0x10);
    hdr.l += 16;
    hdr.write_shift(2, 0x02);
    hdr.write_shift(2, 0xF00A);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, baseid);
    hdr.write_shift(4, 0x05);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00EC, /* hdr */ _oasc ? $3ee4f50b1ae43a89$var$bconcat([
        hdr,
        _oasc
    ]) : hdr);
    ba.push(pl.end());
    notes.forEach(function(n) {
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x001C, n);
    });
    $3ee4f50b1ae43a89$var$b8ocnts.push([
        baseid,
        comments.length + 1,
        $3ee4f50b1ae43a89$var$b8oid
    ]);
    ++$3ee4f50b1ae43a89$var$b8oid;
}
function $3ee4f50b1ae43a89$var$write_FONTS_biff8(ba, data, opts) {
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0031 /* Font */ , $3ee4f50b1ae43a89$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $3ee4f50b1ae43a89$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x041E /* Format */ , $3ee4f50b1ae43a89$var$write_Format(i, NF[i], opts));
    });
}
function $3ee4f50b1ae43a89$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $3ee4f50b1ae43a89$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $3ee4f50b1ae43a89$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $3ee4f50b1ae43a89$var$write_Ref8U($3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $3ee4f50b1ae43a89$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e0 /* XF */ , $3ee4f50b1ae43a89$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e0 /* XF */ , $3ee4f50b1ae43a89$var$write_XF(c, 0, opts));
    });
}
function $3ee4f50b1ae43a89$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $3ee4f50b1ae43a89$var$write_HLink(HL));
        if (HL[1].Tooltip) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $3ee4f50b1ae43a89$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $3ee4f50b1ae43a89$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $3ee4f50b1ae43a89$var$write_ColInfo($3ee4f50b1ae43a89$var$col_obj_w(idx, col), idx));
    });
}
function $3ee4f50b1ae43a89$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var os = 16 + $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0201 /* Blank */ , $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0006 /* Formula */ , $3ee4f50b1ae43a89$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (isNaN(v)) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $3ee4f50b1ae43a89$var$write_BoolErr(R, C, 0x24, os, opts, "e")); // #NUM!
            else if (!isFinite(v)) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $3ee4f50b1ae43a89$var$write_BoolErr(R, C, 0x07, os, opts, "e")); // #DIV/0!
            else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0203 /* Number */ , $3ee4f50b1ae43a89$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $3ee4f50b1ae43a89$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $3ee4f50b1ae43a89$var$write_LabelSst(R, C, isst, os, opts));
            } else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0204 /* Label */ , $3ee4f50b1ae43a89$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0201 /* Blank */ , $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $3ee4f50b1ae43a89$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV" + MAX_ROWS);
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, MAX_ROWS - 1);
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0809, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $3ee4f50b1ae43a89$var$writeuint16(100));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $3ee4f50b1ae43a89$var$writebool(true));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $3ee4f50b1ae43a89$var$write_Xnum(0.001));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $3ee4f50b1ae43a89$var$writebool(true));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0080 /* Guts */ , $3ee4f50b1ae43a89$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $3ee4f50b1ae43a89$var$writebool(false));
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $3ee4f50b1ae43a89$var$write_Dimensions(range, opts));
    /* ... */ var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    if (b8) ws['!links'] = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    var comments = [];
    var row = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $3ee4f50b1ae43a89$var$write_ws_biff8_cell(ba, cell, R, C, opts, date1904);
            if (b8 && cell.l) ws['!links'].push([
                cols[C] + rr,
                cell.l
            ]);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_comments_biff8(ba, comments);
    else $3ee4f50b1ae43a89$var$write_comments_biff2(ba, comments);
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x023e /* Window2 */ , $3ee4f50b1ae43a89$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $3ee4f50b1ae43a89$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $3ee4f50b1ae43a89$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $3ee4f50b1ae43a89$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $3ee4f50b1ae43a89$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $3ee4f50b1ae43a89$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $3ee4f50b1ae43a89$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0809, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $3ee4f50b1ae43a89$var$writeuint16(0x04b0) : null);
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00c1 /* Mms */ , $3ee4f50b1ae43a89$var$writezeroes(2));
    if (b5) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $3ee4f50b1ae43a89$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0042 /* CodePage */ , $3ee4f50b1ae43a89$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0161 /* DSF */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x013d /* RRTabId */ , $3ee4f50b1ae43a89$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01ba /* CodeName */ , $3ee4f50b1ae43a89$var$write_XLUnicodeString(cname, opts));
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $3ee4f50b1ae43a89$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0012 /* Protect */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0013 /* Password */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $3ee4f50b1ae43a89$var$writebool(false));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x003d /* Window1 */ , $3ee4f50b1ae43a89$var$write_Window1(opts));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0040 /* Backup */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x008d /* HideObj */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $3ee4f50b1ae43a89$var$writebool($3ee4f50b1ae43a89$var$safe1904(wb) == "true"));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $3ee4f50b1ae43a89$var$writebool(true));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00DA /* BookBool */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    /* ... */ $3ee4f50b1ae43a89$var$write_FONTS_biff8(A, wb, opts);
    $3ee4f50b1ae43a89$var$write_FMTS_biff8(A, wb.SSF, opts);
    $3ee4f50b1ae43a89$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $3ee4f50b1ae43a89$var$writebool(false));
    var a = A.end();
    var C = $3ee4f50b1ae43a89$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(C, 0x008C /* Country */ , $3ee4f50b1ae43a89$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture */ /* BIFF8: MsoDrawingGroup [*Continue] */ if (b8 && $3ee4f50b1ae43a89$var$b8ocnts.length) $3ee4f50b1ae43a89$var$write_biff_rec(C, 0x00EB /* MsoDrawingGroup */ , $3ee4f50b1ae43a89$var$write_MsoDrawingGroup());
    /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $3ee4f50b1ae43a89$var$write_biff_continue(C, 0x00FC /* SST */ , $3ee4f50b1ae43a89$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $3ee4f50b1ae43a89$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $3ee4f50b1ae43a89$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $3ee4f50b1ae43a89$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $3ee4f50b1ae43a89$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $3ee4f50b1ae43a89$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    $3ee4f50b1ae43a89$var$b8oid = 1;
    $3ee4f50b1ae43a89$var$b8ocnts = [];
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $3ee4f50b1ae43a89$var$fix_write_opts(o);
    o.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $3ee4f50b1ae43a89$var$write_ws_biff8(i, o, wb);
    bufs.unshift($3ee4f50b1ae43a89$var$write_biff8_global(wb, bufs, o));
    return $3ee4f50b1ae43a89$var$bconcat(bufs);
}
function $3ee4f50b1ae43a89$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
        if (range.e.r > 65535) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond row 65536.  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $3ee4f50b1ae43a89$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $3ee4f50b1ae43a89$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $3ee4f50b1ae43a89$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $3ee4f50b1ae43a89$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = $3ee4f50b1ae43a89$var$str_remove_ng(str, "<!--", "-->");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $3ee4f50b1ae43a89$var$split_regex(str.slice(i, j), /(:?<tr[^<>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $3ee4f50b1ae43a89$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $3ee4f50b1ae43a89$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(m))) o = {
                t: 'n',
                v: $3ee4f50b1ae43a89$var$fuzzynum(m)
            };
            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $3ee4f50b1ae43a89$var$parseDate(m)
                } /*:any*/ ;
                if (opts.UTC === false) o.v = $3ee4f50b1ae43a89$var$utc_to_local(o.v);
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $3ee4f50b1ae43a89$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
            } else if (m.charCodeAt(0) == 35 /* # */  && $3ee4f50b1ae43a89$var$RBErr[m] != null) {
                o.t = 'e';
                o.w = m;
                o.v = $3ee4f50b1ae43a89$var$RBErr[m];
            }
            if (o.cellText !== false) o.w = m;
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $3ee4f50b1ae43a89$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $3ee4f50b1ae43a89$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        if (cell && cell.t == 'n' && cell.v != null && !isFinite(cell.v)) {
            if (isNaN(cell.v)) cell = {
                t: 'e',
                v: 0x24,
                w: $3ee4f50b1ae43a89$var$BErr[0x24]
            };
            else cell = {
                t: 'e',
                v: 0x07,
                w: $3ee4f50b1ae43a89$var$BErr[0x07]
            };
        }
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $3ee4f50b1ae43a89$var$escapehtml(cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            // note: data-v is unaffected by the timezone interpretation
            if (cell.v != null) sp["data-v"] = $3ee4f50b1ae43a89$var$escapehtml(cell.v instanceof Date ? cell.v.toISOString() : cell.v);
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $3ee4f50b1ae43a89$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($3ee4f50b1ae43a89$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $3ee4f50b1ae43a89$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $3ee4f50b1ae43a89$var$HTML_END = '</body></html>';
function $3ee4f50b1ae43a89$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = $3ee4f50b1ae43a89$var$str_match_xml_ig(str, "table");
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $3ee4f50b1ae43a89$var$sheet_to_workbook($3ee4f50b1ae43a89$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $3ee4f50b1ae43a89$var$book_new();
    mtch.forEach(function(s, idx) {
        $3ee4f50b1ae43a89$var$book_append_sheet(wb, $3ee4f50b1ae43a89$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $3ee4f50b1ae43a89$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $3ee4f50b1ae43a89$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $3ee4f50b1ae43a89$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $3ee4f50b1ae43a89$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $3ee4f50b1ae43a89$var$decode_range(ws['!ref'] || "A1");
    out.push($3ee4f50b1ae43a89$var$make_html_preamble(ws, r, o));
    if (ws["!ref"]) for(var R = r.s.r; R <= r.e.r; ++R)out.push($3ee4f50b1ae43a89$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $3ee4f50b1ae43a89$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($3ee4f50b1ae43a89$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $3ee4f50b1ae43a89$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $3ee4f50b1ae43a89$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (_t == "e" && $3ee4f50b1ae43a89$var$BErr[+v]) o = {
                    t: 'e',
                    v: +v,
                    w: $3ee4f50b1ae43a89$var$BErr[+v]
                };
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $3ee4f50b1ae43a89$var$fuzzynum(v)
                };
                else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $3ee4f50b1ae43a89$var$parseDate(v)
                    } /*:any*/ ;
                    if (opts.UTC) o.v = $3ee4f50b1ae43a89$var$local_to_utc(o.v);
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $3ee4f50b1ae43a89$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                } else if (v.charCodeAt(0) == 35 /* # */  && $3ee4f50b1ae43a89$var$RBErr[v] != null) o = {
                    t: 'e',
                    v: $3ee4f50b1ae43a89$var$RBErr[v],
                    w: v
                };
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $3ee4f50b1ae43a89$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $3ee4f50b1ae43a89$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $3ee4f50b1ae43a89$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $3ee4f50b1ae43a89$var$sheet_add_dom(ws, table, _opts);
}
function $3ee4f50b1ae43a89$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $3ee4f50b1ae43a89$var$sheet_to_workbook($3ee4f50b1ae43a89$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $3ee4f50b1ae43a89$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $3ee4f50b1ae43a89$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $3ee4f50b1ae43a89$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $3ee4f50b1ae43a89$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^<>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $3ee4f50b1ae43a89$var$unescapexml(fixed.replace(/<[^<>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $3ee4f50b1ae43a89$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $3ee4f50b1ae43a89$var$xlml_normalize(d);
    $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = 0;
    str = $3ee4f50b1ae43a89$var$remove_doctype($3ee4f50b1ae43a89$var$str_remove_ng(str, "<!--", "-->"));
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $3ee4f50b1ae43a89$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $3ee4f50b1ae43a89$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $3ee4f50b1ae43a89$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $3ee4f50b1ae43a89$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $3ee4f50b1ae43a89$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            NF += "0." + $3ee4f50b1ae43a89$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $3ee4f50b1ae43a89$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($3ee4f50b1ae43a89$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $3ee4f50b1ae43a89$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $3ee4f50b1ae43a89$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $3ee4f50b1ae43a89$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $3ee4f50b1ae43a89$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $3ee4f50b1ae43a89$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $3ee4f50b1ae43a89$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if ($3ee4f50b1ae43a89$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $3ee4f50b1ae43a89$var$fill("0", +y["min-integer-digits"] || 1);
            if ($3ee4f50b1ae43a89$var$parsexmlbool(y["grouping"])) tNF = $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $3ee4f50b1ae43a89$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $3ee4f50b1ae43a89$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $3ee4f50b1ae43a89$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $3ee4f50b1ae43a89$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $3ee4f50b1ae43a89$var$xlmlregex.lastIndex;
                etpos = -+$3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $3ee4f50b1ae43a89$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var str = $3ee4f50b1ae43a89$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ , ctag2 = {} /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ , oldtextp = "", oldtextpidx = 0;
    var textR = [], oldtextR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = 0;
    str = $3ee4f50b1ae43a89$var$remove_doctype($3ee4f50b1ae43a89$var$str_remove_ng(str, "<!--", "-->"));
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $3ee4f50b1ae43a89$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $3ee4f50b1ae43a89$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') {
                ++C;
                ctag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                if (opts.sheetStubs) {
                    while(colpeat-- > 0){
                        if (opts.dense) {
                            if (!ws["!data"][R]) ws["!data"][R] = [];
                            ws["!data"][R][C] = {
                                t: 'z'
                            };
                        } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                            r: R,
                            c: C
                        })] = {
                            t: 'z'
                        };
                        ++C;
                    }
                    --C;
                } else C += colpeat - 1;
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $3ee4f50b1ae43a89$var$ods_to_csf_formula($3ee4f50b1ae43a89$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $3ee4f50b1ae43a89$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = oldtextp = "";
                textpidx = oldtextpidx = 0;
                textR = [];
                oldtextR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                ctag2 = $3ee4f50b1ae43a89$var$parsexmltagraw(Rn[0], true);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $3ee4f50b1ae43a89$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $3ee4f50b1ae43a89$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $3ee4f50b1ae43a89$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'] || "1", 10) || 1;
                    mC = parseInt(ctag['number-columns-spanned'] || "1", 10) || 1;
                    if (mR * mC > 1) {
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        merges.push(mrange);
                    }
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type TODO: verify ODS and UOS */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $3ee4f50b1ae43a89$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        if (opts.cellDates && q.z && $3ee4f50b1ae43a89$var$fmt_is_date(q.z)) {
                            q.v = $3ee4f50b1ae43a89$var$numdate(q.v + (WB.WBProps.date1904 ? 1462 : 0));
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $3ee4f50b1ae43a89$var$parseDate(ctag['date-value'], WB.WBProps.date1904);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $3ee4f50b1ae43a89$var$datenum(q.v, WB.WBProps.date1904);
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    /* NOTE: for `time`, Excel ODS export incorrectly uses durations relative to 1900 epoch even if 1904 is specified */ case 'time':
                        q.t = 'n';
                        q.v = $3ee4f50b1ae43a89$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.v = $3ee4f50b1ae43a89$var$numdate(q.v);
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $3ee4f50b1ae43a89$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (ctag2['calcext:value-type'] == "error" && $3ee4f50b1ae43a89$var$RBErr[textp] != null) {
                    q.t = 'e';
                    q.w = textp;
                    q.v = $3ee4f50b1ae43a89$var$RBErr[textp];
                }
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $3ee4f50b1ae43a89$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $3ee4f50b1ae43a89$var$dup(q);
                        } else {
                            ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $3ee4f50b1ae43a89$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
                textp = oldtextp;
                textpidx = oldtextpidx;
                textR = oldtextR;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                state.push([
                    Rn[3],
                    false
                ]);
                var annotag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], true);
                /* office:display TODO: check if there is a global override */ if (!(annotag["display"] && $3ee4f50b1ae43a89$var$parsexmlbool(annotag["display"]))) comments.hidden = true;
                oldtextp = textp;
                oldtextpidx = textpidx;
                oldtextR = textR;
                textp = "";
                textpidx = 0;
                textR = [];
            }
            creator = "";
            creatoridx = 0;
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $3ee4f50b1ae43a89$var$xlmlregex.lastIndex;
                $3ee4f50b1ae43a89$var$parse_ods_styles(str.slice(nfidx, $3ee4f50b1ae43a89$var$xlmlregex.lastIndex), _opts, number_format_map);
                $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $3ee4f50b1ae43a89$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                    break;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $3ee4f50b1ae43a89$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else if (Rn[0].slice(-2) == "/>") /* TODO: is self-closing 文本串 valid? */ textp += "\n";
            else {
                textptag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D($3ee4f50b1ae43a89$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        /* 9.5 Filters */ case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'filter-set-item':
            break; // 9.5.6 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $3ee4f50b1ae43a89$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $3ee4f50b1ae43a89$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $3ee4f50b1ae43a89$var$parse_manifest($3ee4f50b1ae43a89$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $3ee4f50b1ae43a89$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $3ee4f50b1ae43a89$var$parse_ods_styles($3ee4f50b1ae43a89$var$utf8read(styles), opts);
    var content = $3ee4f50b1ae43a89$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $3ee4f50b1ae43a89$var$parse_content_xml($3ee4f50b1ae43a89$var$utf8read(content), opts, Styles);
    if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $3ee4f50b1ae43a89$var$parse_core_props($3ee4f50b1ae43a89$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $3ee4f50b1ae43a89$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $3ee4f50b1ae43a89$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $3ee4f50b1ae43a89$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $3ee4f50b1ae43a89$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $3ee4f50b1ae43a89$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $3ee4f50b1ae43a89$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $3ee4f50b1ae43a89$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $3ee4f50b1ae43a89$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $3ee4f50b1ae43a89$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/\b(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $3ee4f50b1ae43a89$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '\\':
                    c = nf[++i];
                    payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $3ee4f50b1ae43a89$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $3ee4f50b1ae43a89$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $3ee4f50b1ae43a89$var$writextag("number:" + type + "-style", payload, nopts);
}
function $3ee4f50b1ae43a89$var$write_names_ods(Names, SheetNames, idx) {
    //var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
    var scoped = [];
    for(var namei = 0; namei < Names.length; ++namei){
        var name = Names[namei];
        if (!name) continue;
        if (name.Sheet == (idx == -1 ? null : idx)) scoped.push(name);
    }
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = (idx == -1 ? "$" : "") + $3ee4f50b1ae43a89$var$csf_to_ods_3D(name.Ref);
        return "        " + $3ee4f50b1ae43a89$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.][^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $3ee4f50b1ae43a89$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ , span) /*:string*/ {
        return $3ee4f50b1ae43a89$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, span ? "<text:line-break/>" : "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs, date1904) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $3ee4f50b1ae43a89$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push('          <table:covered-table-cell/>\n');
                    continue;
                }
                var ref = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $3ee4f50b1ae43a89$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        if (!isFinite(cell.v)) {
                            if (isNaN(cell.v)) {
                                textp = "#NUM!";
                                ct['table:formula'] = "of:=#NUM!";
                            } else {
                                textp = "#DIV/0!";
                                ct['table:formula'] = "of:=" + (cell.v < 0 ? "-" : "") + "1/0";
                            }
                            ct['office:string-value'] = "";
                            ct['office:value-type'] = "string";
                            ct['calcext:value-type'] = "error";
                        } else {
                            textp = cell.w || String(cell.v || 0);
                            ct['office:value-type'] = "float";
                            ct['office:value'] = cell.v || 0;
                        }
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $3ee4f50b1ae43a89$var$parseDate(cell.v, date1904).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $3ee4f50b1ae43a89$var$parseDate(cell.v, date1904).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e': // TODO: translate to ODS errors
                    default:
                        o.push(null_cell_xml);
                        continue; // TODO: empty cell with comments
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $3ee4f50b1ae43a89$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $3ee4f50b1ae43a89$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                var payload = $3ee4f50b1ae43a89$var$writextag('text:p', text_p, {});
                if (cell.c) {
                    var acreator = "", apayload = "", aprops = {};
                    for(var ci = 0; ci < cell.c.length; ++ci){
                        if (!acreator && cell.c[ci].a) acreator = cell.c[ci].a;
                        apayload += "<text:p>" + write_text_p(cell.c[ci].t) + "</text:p>";
                    }
                    if (!cell.c.hidden) aprops["office:display"] = true;
                    payload = $3ee4f50b1ae43a89$var$writextag('office:annotation', apayload, aprops) + payload;
                }
                o.push('          ' + $3ee4f50b1ae43a89$var$writextag('table:table-cell', payload, ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($3ee4f50b1ae43a89$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $3ee4f50b1ae43a89$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            if (!ws["!ref"]) return;
            var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $3ee4f50b1ae43a89$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $3ee4f50b1ae43a89$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $3ee4f50b1ae43a89$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $3ee4f50b1ae43a89$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $3ee4f50b1ae43a89$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($3ee4f50b1ae43a89$var$write_meta_ods().replace(/<office:document-meta[^<>]*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs, ((wb.Workbook || {}).WBProps || {}).date1904));
        if ((wb.Workbook || {}).Names) o.push($3ee4f50b1ae43a89$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $3ee4f50b1ae43a89$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $3ee4f50b1ae43a89$var$write_content_ods(wb, opts);
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$XML_HEADER + $3ee4f50b1ae43a89$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $3ee4f50b1ae43a89$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $3ee4f50b1ae43a89$require$Buffer !== "undefined") {
            if (typeof $3ee4f50b1ae43a89$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $3ee4f50b1ae43a89$require$Buffer.from == "function" ? $3ee4f50b1ae43a89$require$Buffer.from([
                72,
                62
            ]) : new $3ee4f50b1ae43a89$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $3ee4f50b1ae43a89$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $3ee4f50b1ae43a89$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $3ee4f50b1ae43a89$var$utf8read($3ee4f50b1ae43a89$var$a2s(u8));
}
function $3ee4f50b1ae43a89$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$utf8write(str));
}
function $3ee4f50b1ae43a89$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $3ee4f50b1ae43a89$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $3ee4f50b1ae43a89$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $3ee4f50b1ae43a89$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $3ee4f50b1ae43a89$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$3ee4f50b1ae43a89$var$subarray](0, L);
}
function $3ee4f50b1ae43a89$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($3ee4f50b1ae43a89$var$parse_varint49(buf, ptr));
    return out;
}
function $3ee4f50b1ae43a89$var$write_packed_varints(nums) {
    return $3ee4f50b1ae43a89$var$u8concat(nums.map(function(x) {
        return $3ee4f50b1ae43a89$var$write_varint49(x);
    }));
}
function $3ee4f50b1ae43a89$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 7;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 14;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 21;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 15) << 28;
    return i32;
}
function $3ee4f50b1ae43a89$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $3ee4f50b1ae43a89$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$3ee4f50b1ae43a89$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$3ee4f50b1ae43a89$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
                data = buf[$3ee4f50b1ae43a89$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$3ee4f50b1ae43a89$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $3ee4f50b1ae43a89$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($3ee4f50b1ae43a89$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($3ee4f50b1ae43a89$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $3ee4f50b1ae43a89$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
        var ai = $3ee4f50b1ae43a89$var$parse_shallow(buf[$3ee4f50b1ae43a89$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $3ee4f50b1ae43a89$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $3ee4f50b1ae43a89$var$parse_shallow(b.data);
            var fl = $3ee4f50b1ae43a89$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$3ee4f50b1ae43a89$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $3ee4f50b1ae43a89$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $3ee4f50b1ae43a89$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $3ee4f50b1ae43a89$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $3ee4f50b1ae43a89$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $3ee4f50b1ae43a89$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $3ee4f50b1ae43a89$var$write_shallow(ai);
        bufs.push($3ee4f50b1ae43a89$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $3ee4f50b1ae43a89$var$u8concat(bufs);
}
function $3ee4f50b1ae43a89$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$3ee4f50b1ae43a89$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$3ee4f50b1ae43a89$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$3ee4f50b1ae43a89$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$3ee4f50b1ae43a89$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $3ee4f50b1ae43a89$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $3ee4f50b1ae43a89$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $3ee4f50b1ae43a89$var$parse_snappy_chunk(t, buf[$3ee4f50b1ae43a89$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $3ee4f50b1ae43a89$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$3ee4f50b1ae43a89$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
var $3ee4f50b1ae43a89$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: [],
        fmla: [],
        ferr: [],
        cmnt: []
    };
};
function $3ee4f50b1ae43a89$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $3ee4f50b1ae43a89$var$parse_old_storage(buf, lut, v, opts) {
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1));
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $3ee4f50b1ae43a89$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $3ee4f50b1ae43a89$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $3ee4f50b1ae43a89$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[$3ee4f50b1ae43a89$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$3ee4f50b1ae43a89$var$subarray](0, 4)));
    }
    if (zidx > -1) $3ee4f50b1ae43a89$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $3ee4f50b1ae43a89$var$parse_new_storage(buf, lut, opts) {
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1)), eidx = -1, fidx = -1;
    if (fields & 1) {
        d128 = $3ee4f50b1ae43a89$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $3ee4f50b1ae43a89$var$popcnt(fields & 480) * 4;
    if (fields & 512) {
        fidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $3ee4f50b1ae43a89$var$popcnt(fields & 1024) * 4;
    if (fields & 2048) {
        eidx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            ret = {
                t: "z"
            };
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $3ee4f50b1ae43a89$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$3ee4f50b1ae43a89$var$subarray](0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$3ee4f50b1ae43a89$var$subarray](0, 4)));
    }
    doff += $3ee4f50b1ae43a89$var$popcnt(fields & 4096) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 524288) {
        var cmntidx = dv.getUint32(doff, true);
        doff += 4;
        if (lut.cmnt[cmntidx]) ret.c = $3ee4f50b1ae43a89$var$iwa_to_s5s_comment(lut.cmnt[cmntidx]);
    }
    if (zidx > -1) $3ee4f50b1ae43a89$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $3ee4f50b1ae43a89$var$write_new_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $3ee4f50b1ae43a89$var$u8_to_dataview(out), l = 12, fields = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            if (cell.z && $3ee4f50b1ae43a89$var$fmt_is_date(cell.z)) {
                out[1] = 5;
                dv.setFloat64(l, ($3ee4f50b1ae43a89$var$numdate(cell.v + 1462).getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
                fields |= 4;
                l += 8;
                break;
            } else {
                out[1] = 2;
                $3ee4f50b1ae43a89$var$writeDecimal128LE(out, l, cell.v);
                fields |= 1;
                l += 16;
            }
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 16;
                l += 4;
            } else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 8;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 4;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        lut.cmnt.push($3ee4f50b1ae43a89$var$s5s_to_iwa_comment(cell.c));
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 524288;
        l += 4;
    }
    dv.setUint32(8, fields, true);
    return out[$3ee4f50b1ae43a89$var$subarray](0, l);
}
function $3ee4f50b1ae43a89$var$write_old_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $3ee4f50b1ae43a89$var$u8_to_dataview(out), l = 12, fields = 0, s = "";
    out[0] = 4;
    switch(cell.t){
        case "n":
            break;
        case "b":
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 512;
                l += 4;
            }
            break;
        case "d":
            break;
        case "e":
            break;
        case "z":
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 4096;
        l += 4;
    }
    switch(cell.t){
        case "n":
            out[1] = 2;
            dv.setFloat64(l, cell.v, true);
            fields |= 32;
            l += 8;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 32;
            l += 8;
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) ;
            else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 16;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 64;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, fields, true);
    return out[$3ee4f50b1ae43a89$var$subarray](0, l);
}
function $3ee4f50b1ae43a89$var$parse_cell_storage(buf, lut, opts) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $3ee4f50b1ae43a89$var$parse_old_storage(buf, lut, buf[0], opts);
        case 5:
            return $3ee4f50b1ae43a89$var$parse_new_storage(buf, lut, opts);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $3ee4f50b1ae43a89$var$parse_TSP_Reference(buf) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(buf);
    return $3ee4f50b1ae43a89$var$varint_to_i32(pb[1][0].data);
}
function $3ee4f50b1ae43a89$var$write_TSP_Reference(idx) {
    return $3ee4f50b1ae43a89$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(idx)
            }
        ]
    ]);
}
function $3ee4f50b1ae43a89$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $3ee4f50b1ae43a89$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, root) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var type = $3ee4f50b1ae43a89$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var _a, _b;
        var le = $3ee4f50b1ae43a89$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $3ee4f50b1ae43a89$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $3ee4f50b1ae43a89$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $3ee4f50b1ae43a89$var$parse_shallow(rt.data);
                var rtpref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $3ee4f50b1ae43a89$var$parse_shallow(rtpref.data);
                var richtext = {
                    v: tswpsa[3].map(function(x) {
                        return $3ee4f50b1ae43a89$var$u8str(x.data);
                    }).join("")
                };
                data[key] = richtext;
                sfields: if ((_a = tswpsa == null ? void 0 : tswpsa[11]) == null ? void 0 : _a[0]) {
                    var smartfields = (_b = $3ee4f50b1ae43a89$var$parse_shallow(tswpsa[11][0].data)) == null ? void 0 : _b[1];
                    if (!smartfields) break sfields;
                    smartfields.forEach(function(sf) {
                        var _a2, _b2, _c;
                        var attr = $3ee4f50b1ae43a89$var$parse_shallow(sf.data);
                        if ((_a2 = attr[2]) == null ? void 0 : _a2[0]) {
                            var obj = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference((_b2 = attr[2]) == null ? void 0 : _b2[0].data)][0];
                            var objtype = $3ee4f50b1ae43a89$var$varint_to_i32(obj.meta[1][0].data);
                            switch(objtype){
                                case 2032:
                                    var hlink = $3ee4f50b1ae43a89$var$parse_shallow(obj.data);
                                    if (((_c = hlink == null ? void 0 : hlink[2]) == null ? void 0 : _c[0]) && !richtext.l) richtext.l = $3ee4f50b1ae43a89$var$u8str(hlink[2][0].data);
                                    break;
                                case 2039:
                                    break;
                                default:
                                    console.log("unrecognized ObjectAttribute type ".concat(objtype));
                            }
                        }
                    });
                }
                break;
            case 2:
                data[key] = $3ee4f50b1ae43a89$var$parse_shallow(le[6][0].data);
                break;
            case 3:
                data[key] = $3ee4f50b1ae43a89$var$parse_shallow(le[5][0].data);
                break;
            case 10:
                var cs = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(le[10][0].data)][0];
                data[key] = $3ee4f50b1ae43a89$var$parse_TSD_CommentStorageArchive(M, cs.data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $3ee4f50b1ae43a89$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(u8);
    var R = $3ee4f50b1ae43a89$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $3ee4f50b1ae43a89$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $3ee4f50b1ae43a89$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $3ee4f50b1ae43a89$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$3ee4f50b1ae43a89$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$3ee4f50b1ae43a89$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $3ee4f50b1ae43a89$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($3ee4f50b1ae43a89$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $3ee4f50b1ae43a89$var$mappa(pb[5], function(u8) {
        return $3ee4f50b1ae43a89$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $3ee4f50b1ae43a89$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $3ee4f50b1ae43a89$var$parse_TSD_CommentStorageArchive(M, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var out = {
        t: "",
        a: ""
    };
    var csp = $3ee4f50b1ae43a89$var$parse_shallow(data);
    if ((_b = (_a = csp == null ? void 0 : csp[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) out.t = $3ee4f50b1ae43a89$var$u8str((_d = (_c = csp == null ? void 0 : csp[1]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) || "";
    if ((_f = (_e = csp == null ? void 0 : csp[3]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data) {
        var as = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference((_h = (_g = csp == null ? void 0 : csp[3]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data)][0];
        var asp = $3ee4f50b1ae43a89$var$parse_shallow(as.data);
        if ((_j = (_i = asp[1]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) out.a = $3ee4f50b1ae43a89$var$u8str(asp[1][0].data);
    }
    if (csp == null ? void 0 : csp[4]) {
        out.replies = [];
        csp[4].forEach(function(pi) {
            var cs = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(pi.data)][0];
            out.replies.push($3ee4f50b1ae43a89$var$parse_TSD_CommentStorageArchive(M, cs.data));
        });
    }
    return out;
}
function $3ee4f50b1ae43a89$var$iwa_to_s5s_comment(iwa) {
    var out = [];
    out.push({
        t: iwa.t || "",
        a: iwa.a,
        T: iwa.replies && iwa.replies.length > 0
    });
    if (iwa.replies) iwa.replies.forEach(function(reply) {
        out.push({
            t: reply.t || "",
            a: reply.a,
            T: true
        });
    });
    return out;
}
function $3ee4f50b1ae43a89$var$s5s_to_iwa_comment(s5s) {
    var out = {
        a: "",
        t: "",
        replies: []
    };
    for(var i = 0; i < s5s.length; ++i)if (i == 0) {
        out.a = s5s[i].a;
        out.t = s5s[i].t;
    } else out.replies.push({
        a: s5s[i].a,
        t: s5s[i].t
    });
    return out;
}
function $3ee4f50b1ae43a89$var$parse_TST_TableModelArchive(M, root, ws, opts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($3ee4f50b1ae43a89$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($3ee4f50b1ae43a89$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $3ee4f50b1ae43a89$var$parse_shallow(pb[4][0].data);
    var lut = $3ee4f50b1ae43a89$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[6]) == null ? void 0 : _b[0]) lut.fmla = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[6][0].data)][0]);
    if ((_c = store[11]) == null ? void 0 : _c[0]) lut.ofmt = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_d = store[12]) == null ? void 0 : _d[0]) lut.ferr = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[12][0].data)][0]);
    if ((_e = store[17]) == null ? void 0 : _e[0]) lut.rsst = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_f = store[19]) == null ? void 0 : _f[0]) lut.cmnt = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[19][0].data)][0]);
    if ((_g = store[22]) == null ? void 0 : _g[0]) lut.nfmt = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $3ee4f50b1ae43a89$var$parse_shallow(store[3][0].data);
    var _R = 0;
    if (!((_h = store[9]) == null ? void 0 : _h[0])) throw "NUMBERS file missing row tree";
    var rtt = $3ee4f50b1ae43a89$var$parse_shallow(store[9][0].data)[1].map(function(p) {
        return $3ee4f50b1ae43a89$var$parse_shallow(p.data);
    });
    rtt.forEach(function(kv) {
        _R = $3ee4f50b1ae43a89$var$varint_to_i32(kv[1][0].data);
        var tidx = $3ee4f50b1ae43a89$var$varint_to_i32(kv[2][0].data);
        var t = tile[1][tidx];
        if (!t) throw "NUMBERS missing tile " + tidx;
        var tl = $3ee4f50b1ae43a89$var$parse_shallow(t.data);
        var ref2 = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $3ee4f50b1ae43a89$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $3ee4f50b1ae43a89$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $3ee4f50b1ae43a89$var$parse_cell_storage(buf, lut, opts);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_i = store[13]) == null ? void 0 : _i[0]) {
        var ref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_j = $3ee4f50b1ae43a89$var$parse_shallow(ref.data)) == null ? void 0 : _j[1].map(function(pi) {
            var merge = $3ee4f50b1ae43a89$var$parse_shallow(pi.data);
            var origin = $3ee4f50b1ae43a89$var$u8_to_dataview($3ee4f50b1ae43a89$var$parse_shallow(merge[1][0].data)[1][0].data), size = $3ee4f50b1ae43a89$var$u8_to_dataview($3ee4f50b1ae43a89$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
    if (!((_k = ws["!merges"]) == null ? void 0 : _k.length) && ((_l = pb[47]) == null ? void 0 : _l[0])) {
        var merge_owner = $3ee4f50b1ae43a89$var$parse_shallow(pb[47][0].data);
        if ((_m = merge_owner[2]) == null ? void 0 : _m[0]) {
            var formula_store = $3ee4f50b1ae43a89$var$parse_shallow(merge_owner[2][0].data);
            if ((_n = formula_store[3]) == null ? void 0 : _n[0]) ws["!merges"] = $3ee4f50b1ae43a89$var$mappa(formula_store[3], function(u) {
                var _a2, _b2, _c2, _d2, _e2;
                var formula_pair = $3ee4f50b1ae43a89$var$parse_shallow(u);
                var formula = $3ee4f50b1ae43a89$var$parse_shallow(formula_pair[2][0].data);
                var AST_node_array = $3ee4f50b1ae43a89$var$parse_shallow(formula[1][0].data);
                if (!((_a2 = AST_node_array[1]) == null ? void 0 : _a2[0])) return;
                var AST_node0 = $3ee4f50b1ae43a89$var$parse_shallow(AST_node_array[1][0].data);
                var AST_node_type = $3ee4f50b1ae43a89$var$varint_to_i32(AST_node0[1][0].data);
                if (AST_node_type != 67) return;
                var AST_colon_tract = $3ee4f50b1ae43a89$var$parse_shallow(AST_node0[40][0].data);
                if (!((_b2 = AST_colon_tract[3]) == null ? void 0 : _b2[0]) || !((_c2 = AST_colon_tract[4]) == null ? void 0 : _c2[0])) return;
                var colrange = $3ee4f50b1ae43a89$var$parse_shallow(AST_colon_tract[3][0].data);
                var rowrange = $3ee4f50b1ae43a89$var$parse_shallow(AST_colon_tract[4][0].data);
                var c = $3ee4f50b1ae43a89$var$varint_to_i32(colrange[1][0].data);
                var C = ((_d2 = colrange[2]) == null ? void 0 : _d2[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(colrange[2][0].data) : c;
                var r = $3ee4f50b1ae43a89$var$varint_to_i32(rowrange[1][0].data);
                var R = ((_e2 = rowrange[2]) == null ? void 0 : _e2[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(rowrange[2][0].data) : r;
                return {
                    s: {
                        r: r,
                        c: c
                    },
                    e: {
                        r: R,
                        c: C
                    }
                };
            }).filter(function(x) {
                return x != null;
            });
        }
    }
}
function $3ee4f50b1ae43a89$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $3ee4f50b1ae43a89$var$parse_TST_TableModelArchive(M, tableref[0], out, opts);
    return out;
}
function $3ee4f50b1ae43a89$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $3ee4f50b1ae43a89$var$mappa(pb[2], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($3ee4f50b1ae43a89$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $3ee4f50b1ae43a89$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $3ee4f50b1ae43a89$var$book_new();
    out.Workbook = {
        WBProps: {
            date1904: true
        }
    };
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $3ee4f50b1ae43a89$var$mappa(pb[1], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $3ee4f50b1ae43a89$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $3ee4f50b1ae43a89$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $3ee4f50b1ae43a89$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $3ee4f50b1ae43a89$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $3ee4f50b1ae43a89$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $3ee4f50b1ae43a89$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $3ee4f50b1ae43a89$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $3ee4f50b1ae43a89$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $3ee4f50b1ae43a89$var$write_TST_TileRowInfo(data, lut, wide) {
    var _a, _b, _c;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $3ee4f50b1ae43a89$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null || data[C].t == "z" && !((_c = data[C].c) == null ? void 0 : _c.length) || data[C].t == "e") {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(data[C].t){
            case "d":
                if (data[C].v instanceof Date) {
                    celload = $3ee4f50b1ae43a89$var$write_new_storage(data[C], lut);
                    _celload = $3ee4f50b1ae43a89$var$write_old_storage(data[C], lut);
                    break;
                }
                celload = $3ee4f50b1ae43a89$var$write_new_storage(data[C], lut);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage(data[C], lut);
                break;
            case "s":
            case "n":
            case "b":
            case "z":
                celload = $3ee4f50b1ae43a89$var$write_new_storage(data[C], lut);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage(data[C], lut);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $3ee4f50b1ae43a89$var$write_varint49(cnt);
    tri[5][0].data = $3ee4f50b1ae43a89$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $3ee4f50b1ae43a89$var$u8concat(cell_storage);
    tri[3][0].data = $3ee4f50b1ae43a89$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $3ee4f50b1ae43a89$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $3ee4f50b1ae43a89$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $3ee4f50b1ae43a89$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $3ee4f50b1ae43a89$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($3ee4f50b1ae43a89$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $3ee4f50b1ae43a89$var$write_TSP_Color_RGB(r, g, b) {
    return $3ee4f50b1ae43a89$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(1)
            }
        ],
        [],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    r / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    g / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    b / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    1
                ]).buffer)
            }
        ],
        [],
        [],
        [],
        [],
        [],
        [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(1)
            }
        ]
    ]);
}
function $3ee4f50b1ae43a89$var$get_author_color(n) {
    switch(n){
        case 0:
            return $3ee4f50b1ae43a89$var$write_TSP_Color_RGB(99, 222, 171);
        case 1:
            return $3ee4f50b1ae43a89$var$write_TSP_Color_RGB(162, 197, 240);
        case 2:
            return $3ee4f50b1ae43a89$var$write_TSP_Color_RGB(255, 189, 189);
    }
    return $3ee4f50b1ae43a89$var$write_TSP_Color_RGB(Math.random() * 255, Math.random() * 255, Math.random() * 255);
}
function $3ee4f50b1ae43a89$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $3ee4f50b1ae43a89$var$build_numbers_deps(cfb);
    var docroot = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $3ee4f50b1ae43a89$var$mappa($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[1], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $3ee4f50b1ae43a89$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $3ee4f50b1ae43a89$var$mappa($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[1], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
        }
        $3ee4f50b1ae43a89$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $3ee4f50b1ae43a89$var$numbers_add_meta(mlist, newid, newloc) {
    mlist[3].push({
        type: 2,
        data: $3ee4f50b1ae43a89$var$write_shallow([
            [],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(newid)
                }
            ],
            [
                {
                    type: 2,
                    data: $3ee4f50b1ae43a89$var$stru8(newloc.replace(/-[\s\S]*$/, ""))
                }
            ],
            [
                {
                    type: 2,
                    data: $3ee4f50b1ae43a89$var$stru8(newloc)
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [],
            [],
            [],
            [],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(0)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(0)
                }
            ]
        ])
    });
    mlist[1] = [
        {
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(Math.max(newid + 1, $3ee4f50b1ae43a89$var$varint_to_i32(mlist[1][0].data)))
        }
    ];
}
function $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, type, msg, path, deps, id) {
    if (!id) id = $3ee4f50b1ae43a89$var$get_unique_msgid({
        deps: [],
        location: "",
        type: type
    }, deps);
    var loc = "".concat(path, "-").concat(id, ".iwa");
    deps[id].location = "Root Entry" + loc;
    $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, loc, $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file([
        {
            id: id,
            messages: [
                $3ee4f50b1ae43a89$var$write_iwam(type, $3ee4f50b1ae43a89$var$write_shallow(msg))
            ]
        }
    ])));
    var newloc = loc.replace(/^[\/]/, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
        $3ee4f50b1ae43a89$var$numbers_add_meta(mlist, id || 0, newloc);
        ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
    });
    return id;
}
function $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $3ee4f50b1ae43a89$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $3ee4f50b1ae43a89$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $3ee4f50b1ae43a89$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $3ee4f50b1ae43a89$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    (Array.isArray(dep) ? dep : [
        dep
    ]).forEach(function(dep2) {
        parent[6].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $3ee4f50b1ae43a89$var$write_varint49(dep2)
                    }
                ]
            ])
        });
    });
    mlist[3][parentidx].data = $3ee4f50b1ae43a89$var$write_shallow(parent);
}
function $3ee4f50b1ae43a89$var$numbers_meta_del_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $3ee4f50b1ae43a89$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $3ee4f50b1ae43a89$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $3ee4f50b1ae43a89$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $3ee4f50b1ae43a89$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    parent[6] = parent[6].filter(function(m) {
        return $3ee4f50b1ae43a89$var$varint_to_i32($3ee4f50b1ae43a89$var$parse_shallow(m.data)[1][0].data) != dep;
    });
    mlist[3][parentidx].data = $3ee4f50b1ae43a89$var$write_shallow(parent);
}
function $3ee4f50b1ae43a89$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data);
        sheetref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $3ee4f50b1ae43a89$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $3ee4f50b1ae43a89$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(doc);
    });
    var tiaref = -1;
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $3ee4f50b1ae43a89$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $3ee4f50b1ae43a89$var$mappa(sa[2], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $3ee4f50b1ae43a89$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $3ee4f50b1ae43a89$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $3ee4f50b1ae43a89$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
                $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, newsheetref, tiaref);
                ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
            });
            $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(sa);
    });
    var tmaref = -1;
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $3ee4f50b1ae43a89$var$parse_shallow(tiaroot.messages[0].data);
        var da = $3ee4f50b1ae43a89$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $3ee4f50b1ae43a89$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $3ee4f50b1ae43a89$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $3ee4f50b1ae43a89$var$write_shallow(da);
        var oldtmaref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(tia[2][0].data);
        $3ee4f50b1ae43a89$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $3ee4f50b1ae43a89$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $3ee4f50b1ae43a89$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $3ee4f50b1ae43a89$var$write_TSP_Reference(tmaref);
        var tma = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(tia);
    });
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $3ee4f50b1ae43a89$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $3ee4f50b1ae43a89$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(("0000" + wsidx.toString(16)).slice(-4)));
        tma[1][0].data = $3ee4f50b1ae43a89$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $3ee4f50b1ae43a89$var$parse_shallow(tma[45][0].data);
            var ref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(srrta[1][0].data);
            $3ee4f50b1ae43a89$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $3ee4f50b1ae43a89$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $3ee4f50b1ae43a89$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $3ee4f50b1ae43a89$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $3ee4f50b1ae43a89$var$parse_TSP_Reference(hsea[8][0].data);
                    $3ee4f50b1ae43a89$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $3ee4f50b1ae43a89$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $3ee4f50b1ae43a89$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $3ee4f50b1ae43a89$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[n][0].data);
            var newref = $3ee4f50b1ae43a89$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $3ee4f50b1ae43a89$var$numbers_del_oref(tmaroot, oldref);
            $3ee4f50b1ae43a89$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
                    $3ee4f50b1ae43a89$var$numbers_add_meta(mlist, newref, newloc);
                    $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $3ee4f50b1ae43a89$var$write_TSP_Reference(newref);
        });
        var row_headers = $3ee4f50b1ae43a89$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(tspref.data);
            var newref = $3ee4f50b1ae43a89$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $3ee4f50b1ae43a89$var$numbers_del_oref(tmaroot, oldref);
            $3ee4f50b1ae43a89$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
                    $3ee4f50b1ae43a89$var$numbers_add_meta(mlist, newref, newloc);
                    $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
                });
            }
            tspref.data = $3ee4f50b1ae43a89$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $3ee4f50b1ae43a89$var$write_shallow(row_headers);
        var tiles = $3ee4f50b1ae43a89$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $3ee4f50b1ae43a89$var$parse_shallow(t.data);
            var oldtileref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $3ee4f50b1ae43a89$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $3ee4f50b1ae43a89$var$numbers_del_oref(tmaroot, oldtileref);
                $3ee4f50b1ae43a89$var$numbers_add_oref(tmaroot, newtileref);
                $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file([
                    oldtile
                ])));
                $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $3ee4f50b1ae43a89$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $3ee4f50b1ae43a89$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $3ee4f50b1ae43a89$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $3ee4f50b1ae43a89$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $3ee4f50b1ae43a89$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $3ee4f50b1ae43a89$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(Math.max(newtileref + 1, $3ee4f50b1ae43a89$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileref);
                    ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $3ee4f50b1ae43a89$var$write_TSP_Reference(newtileref);
            t.data = $3ee4f50b1ae43a89$var$write_shallow(tst);
        });
        store[3][0].data = $3ee4f50b1ae43a89$var$write_shallow(tiles);
        tma[4][0].data = $3ee4f50b1ae43a89$var$write_shallow(store);
        tmaroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(tma);
    });
}
function $3ee4f50b1ae43a89$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $3ee4f50b1ae43a89$var$stru8(wsname)
            }
        ];
        drawables = $3ee4f50b1ae43a89$var$mappa(sheetref[2], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
        docroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(sheetref);
    });
    var tia = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $3ee4f50b1ae43a89$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $3ee4f50b1ae43a89$var$USE_WIDE_ROWS = true;
function $3ee4f50b1ae43a89$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    if (!ws["!ref"]) throw new Error("Cannot export empty sheet to NUMBERS");
    var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($3ee4f50b1ae43a89$var$encode_range(range)));
    var data = [];
    if (ws["!data"]) data = ws["!data"];
    else {
        var colstr = [];
        for(var _C = 0; _C <= range.e.c; ++_C)colstr[_C] = $3ee4f50b1ae43a89$var$encode_col(_C);
        for(var R_ = 0; R_ <= range.e.r; ++R_){
            data[R_] = [];
            var _R = "" + (R_ + 1);
            for(_C = 0; _C <= range.e.c; ++_C){
                var _cell = ws[colstr[_C] + _R];
                if (!_cell) continue;
                data[R_][_C] = _cell;
            }
        }
    }
    var LUT = {
        cmnt: [
            {
                a: "~54ee77S~",
                t: "... the people who are crazy enough to think they can change the world, are the ones who do."
            }
        ],
        ferr: [],
        fmla: [],
        nfmt: [],
        ofmt: [],
        rsst: [
            {
                v: "~54ee77S~",
                l: "https://sheetjs.com/"
            }
        ],
        sst: [
            "~Sh33tJ5~"
        ]
    };
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $3ee4f50b1ae43a89$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(store[1][0].data)[2][0].data);
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $3ee4f50b1ae43a89$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $3ee4f50b1ae43a89$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(R2);
            _bucket[4][0].data = $3ee4f50b1ae43a89$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $3ee4f50b1ae43a89$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(base_bucket);
    });
    var col_header_ref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[2][0].data);
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $3ee4f50b1ae43a89$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $3ee4f50b1ae43a89$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(C);
            _bucket[4][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $3ee4f50b1ae43a89$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(base_bucket);
    });
    var rbtree = $3ee4f50b1ae43a89$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $3ee4f50b1ae43a89$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(tstride)
        }
    ];
    var tileref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $3ee4f50b1ae43a89$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $3ee4f50b1ae43a89$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $3ee4f50b1ae43a89$var$varint_to_i32($3ee4f50b1ae43a89$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $3ee4f50b1ae43a89$var$varint_to_i32($3ee4f50b1ae43a89$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $3ee4f50b1ae43a89$var$varint_to_i32($3ee4f50b1ae43a89$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        $3ee4f50b1ae43a89$var$numbers_meta_del_dep(mlist, deps, tmaref, tileref);
        ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
    });
    $3ee4f50b1ae43a89$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $3ee4f50b1ae43a89$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49($3ee4f50b1ae43a89$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $3ee4f50b1ae43a89$var$write_TST_TileRowInfo(data[R], LUT, $3ee4f50b1ae43a89$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $3ee4f50b1ae43a89$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $3ee4f50b1ae43a89$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $3ee4f50b1ae43a89$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $3ee4f50b1ae43a89$var$write_iwam(6002, $3ee4f50b1ae43a89$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file([
            newtile
        ]));
        $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(Math.max(newtileid + 1, $3ee4f50b1ae43a89$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileid);
            ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
        });
        $3ee4f50b1ae43a89$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $3ee4f50b1ae43a89$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $3ee4f50b1ae43a89$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $3ee4f50b1ae43a89$var$write_shallow(tilestore);
    store[9][0].data = $3ee4f50b1ae43a89$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $3ee4f50b1ae43a89$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $3ee4f50b1ae43a89$var$write_iwam(6144, $3ee4f50b1ae43a89$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $3ee4f50b1ae43a89$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $3ee4f50b1ae43a89$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_TSP_Reference(mergeid)
            }
        ];
        $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
            $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, tmaref, mergeid);
            ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
        });
        $3ee4f50b1ae43a89$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[4][0].data);
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $3ee4f50b1ae43a89$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        LUT.sst.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(sstdata);
    });
    var rsstref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[17][0].data);
    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, rsstref, function(rsstroot) {
        var rsstdata = $3ee4f50b1ae43a89$var$parse_shallow(rsstroot.messages[0].data);
        rsstdata[3] = [];
        var style_indices = [
            904980,
            903835,
            903815,
            903845
        ];
        LUT.rsst.forEach(function(rsst, i) {
            if (i == 0) return;
            var tswpsa = [
                [],
                [
                    {
                        type: 0,
                        data: new Uint8Array([
                            5
                        ])
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: $3ee4f50b1ae43a89$var$stru8(rsst.v)
                    }
                ]
            ];
            tswpsa[10] = [
                {
                    type: 0,
                    data: new Uint8Array([
                        1
                    ])
                }
            ];
            tswpsa[19] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        18,
                        2,
                        101,
                        110
                    ])
                }
            ];
            tswpsa[5] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        155,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[2] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        8,
                        148,
                        158,
                        55
                    ])
                }
            ];
            tswpsa[6] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[7] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        135,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[8] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        165,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[14] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[24] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            var tswpsaid = $3ee4f50b1ae43a89$var$get_unique_msgid({
                deps: [],
                location: "",
                type: 2001
            }, deps);
            var tswpsarefs = [];
            if (rsst.l) {
                var newhlinkid = $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, 2032, [
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$stru8(rsst.l)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                tswpsa[11] = [];
                var smartfield = [
                    [],
                    []
                ];
                if (!smartfield[1]) smartfield[1] = [];
                smartfield[1].push({
                    type: 2,
                    data: $3ee4f50b1ae43a89$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $3ee4f50b1ae43a89$var$write_varint49(0)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $3ee4f50b1ae43a89$var$write_TSP_Reference(newhlinkid)
                            }
                        ]
                    ])
                });
                tswpsa[11][0] = {
                    type: 2,
                    data: $3ee4f50b1ae43a89$var$write_shallow(smartfield)
                };
                tswpsarefs.push(newhlinkid);
            }
            $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, 2001, tswpsa, "/Index/Tables/DataList", deps, tswpsaid);
            $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, tswpsaid, function(iwa) {
                style_indices.forEach(function(ref) {
                    return $3ee4f50b1ae43a89$var$numbers_add_oref(iwa, ref);
                });
                tswpsarefs.forEach(function(ref) {
                    return $3ee4f50b1ae43a89$var$numbers_add_oref(iwa, ref);
                });
            });
            var rtpaid = $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, 6218, [
                [],
                [
                    {
                        type: 2,
                        data: $3ee4f50b1ae43a89$var$write_TSP_Reference(tswpsaid)
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: new Uint8Array([
                            13,
                            255,
                            255,
                            255,
                            0,
                            18,
                            10,
                            16,
                            255,
                            255,
                            1,
                            24,
                            255,
                            255,
                            255,
                            255,
                            7
                        ])
                    }
                ]
            ], "/Index/Tables/DataList", deps);
            $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, rtpaid, function(iwa) {
                return $3ee4f50b1ae43a89$var$numbers_add_oref(iwa, tswpsaid);
            });
            rsstdata[3].push({
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(1)
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$write_TSP_Reference(rtpaid)
                        }
                    ]
                ])
            });
            $3ee4f50b1ae43a89$var$numbers_add_oref(rsstroot, rtpaid);
            $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
                $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, rsstref, rtpaid);
                $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, rtpaid, tswpsaid);
                $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, tswpsaid, tswpsarefs);
                $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, tswpsaid, style_indices);
                ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
            });
        });
        rsstroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(rsstdata);
    });
    if (LUT.cmnt.length > 1) {
        var cmntref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[19][0].data);
        var authors = {}, iauthor = 0;
        $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, cmntref, function(cmntroot) {
            var cmntdata = $3ee4f50b1ae43a89$var$parse_shallow(cmntroot.messages[0].data);
            cmntdata[3] = [];
            LUT.cmnt.forEach(function(cc, i) {
                if (i == 0) return;
                var replies = [];
                if (cc.replies) cc.replies.forEach(function(c) {
                    if (!authors[c.a || ""]) authors[c.a || ""] = $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, 212, [
                        [],
                        [
                            {
                                type: 2,
                                data: $3ee4f50b1ae43a89$var$stru8(c.a || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $3ee4f50b1ae43a89$var$get_author_color(++iauthor)
                            }
                        ],
                        [],
                        [
                            {
                                type: 0,
                                data: $3ee4f50b1ae43a89$var$write_varint49(0)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    var aaaid2 = authors[c.a || ""];
                    var csaid2 = $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, 3056, [
                        [],
                        [
                            {
                                type: 2,
                                data: $3ee4f50b1ae43a89$var$stru8(c.t || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $3ee4f50b1ae43a89$var$write_shallow([
                                    [],
                                    [
                                        {
                                            type: 1,
                                            data: new Uint8Array([
                                                0,
                                                0,
                                                0,
                                                128,
                                                116,
                                                109,
                                                182,
                                                65
                                            ])
                                        }
                                    ]
                                ])
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $3ee4f50b1ae43a89$var$write_TSP_Reference(aaaid2)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, csaid2, function(iwa) {
                        return $3ee4f50b1ae43a89$var$numbers_add_oref(iwa, aaaid2);
                    });
                    replies.push(csaid2);
                    $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                        var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
                        $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, csaid2, aaaid2);
                        ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
                    });
                });
                if (!authors[cc.a || ""]) authors[cc.a || ""] = $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, 212, [
                    [],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$stru8(cc.a || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$get_author_color(++iauthor)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $3ee4f50b1ae43a89$var$write_varint49(0)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                var aaaid = authors[cc.a || ""];
                var csaid = $3ee4f50b1ae43a89$var$numbers_add_msg(cfb, 3056, [
                    [],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$stru8(cc.t || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 1,
                                        data: new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            128,
                                            116,
                                            109,
                                            182,
                                            65
                                        ])
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$write_TSP_Reference(aaaid)
                        }
                    ],
                    replies.map(function(r) {
                        return {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$write_TSP_Reference(r)
                        };
                    }),
                    [
                        {
                            type: 2,
                            data: $3ee4f50b1ae43a89$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 0,
                                        data: $3ee4f50b1ae43a89$var$write_varint49(i)
                                    }
                                ],
                                [
                                    {
                                        type: 0,
                                        data: $3ee4f50b1ae43a89$var$write_varint49(0)
                                    }
                                ]
                            ])
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, csaid, function(iwa) {
                    $3ee4f50b1ae43a89$var$numbers_add_oref(iwa, aaaid);
                    replies.forEach(function(r) {
                        return $3ee4f50b1ae43a89$var$numbers_add_oref(iwa, r);
                    });
                });
                cmntdata[3].push({
                    type: 2,
                    data: $3ee4f50b1ae43a89$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $3ee4f50b1ae43a89$var$write_varint49(i)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: $3ee4f50b1ae43a89$var$write_varint49(1)
                            }
                        ],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [
                            {
                                type: 2,
                                data: $3ee4f50b1ae43a89$var$write_TSP_Reference(csaid)
                            }
                        ]
                    ])
                });
                $3ee4f50b1ae43a89$var$numbers_add_oref(cmntroot, csaid);
                $3ee4f50b1ae43a89$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $3ee4f50b1ae43a89$var$parse_shallow(ai.messages[0].data);
                    $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, cmntref, csaid);
                    $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, csaid, aaaid);
                    if (replies.length) $3ee4f50b1ae43a89$var$numbers_meta_add_dep(mlist, deps, csaid, replies);
                    ai.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(mlist);
                });
            });
            cmntdata[2][0].data = $3ee4f50b1ae43a89$var$write_varint49(LUT.cmnt.length + 1);
            cmntroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(cmntdata);
        });
    }
    pb[4][0].data = $3ee4f50b1ae43a89$var$write_shallow(store);
    tmaroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(pb);
}
function $3ee4f50b1ae43a89$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $3ee4f50b1ae43a89$var$fix_read_opts(opts) {
    $3ee4f50b1ae43a89$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $3ee4f50b1ae43a89$var$fix_write_opts(opts) {
    $3ee4f50b1ae43a89$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $3ee4f50b1ae43a89$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($3ee4f50b1ae43a89$var$RELS.CS && n == $3ee4f50b1ae43a89$var$RELS.CS) return "chart";
    if ($3ee4f50b1ae43a89$var$RELS.DS && n == $3ee4f50b1ae43a89$var$RELS.DS) return "dialog";
    if ($3ee4f50b1ae43a89$var$RELS.MS && n == $3ee4f50b1ae43a89$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $3ee4f50b1ae43a89$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $3ee4f50b1ae43a89$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $3ee4f50b1ae43a89$var$parse_sheet_legacy_drawing(sheet, type, zip, path, idx, opts, wb, comments) {
    if (!sheet || !sheet['!legdrawel']) return;
    var dfile = $3ee4f50b1ae43a89$var$resolve_path(sheet['!legdrawel'].Target, path);
    var draw = $3ee4f50b1ae43a89$var$getzipstr(zip, dfile, true);
    if (draw) $3ee4f50b1ae43a89$var$parse_vml($3ee4f50b1ae43a89$var$utf8read(draw), sheet, comments || []);
}
function $3ee4f50b1ae43a89$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, relsPath, true), path);
        var data = $3ee4f50b1ae43a89$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $3ee4f50b1ae43a89$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $3ee4f50b1ae43a89$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $3ee4f50b1ae43a89$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $3ee4f50b1ae43a89$var$get_rels_path(dfile);
                var draw = $3ee4f50b1ae43a89$var$parse_drawing($3ee4f50b1ae43a89$var$getzipstr(zip, dfile, true), $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $3ee4f50b1ae43a89$var$resolve_path(draw, dfile);
                var crelsp = $3ee4f50b1ae43a89$var$get_rels_path(chartp);
                _ws = $3ee4f50b1ae43a89$var$parse_chart($3ee4f50b1ae43a89$var$getzipstr(zip, chartp, true), chartp, opts, $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $3ee4f50b1ae43a89$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $3ee4f50b1ae43a89$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $3ee4f50b1ae43a89$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $3ee4f50b1ae43a89$var$RELS.CMNT) {
                dfile = $3ee4f50b1ae43a89$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $3ee4f50b1ae43a89$var$parse_cmnt($3ee4f50b1ae43a89$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $3ee4f50b1ae43a89$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $3ee4f50b1ae43a89$var$RELS.TCMNT) {
                dfile = $3ee4f50b1ae43a89$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($3ee4f50b1ae43a89$var$parse_tcmnt_xml($3ee4f50b1ae43a89$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $3ee4f50b1ae43a89$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
        $3ee4f50b1ae43a89$var$parse_sheet_legacy_drawing(_ws, stype, zip, path, idx, opts, wb, comments);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $3ee4f50b1ae43a89$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $3ee4f50b1ae43a89$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$make_ssf();
    opts = opts || {};
    $3ee4f50b1ae43a89$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $3ee4f50b1ae43a89$var$parse_ods(zip, opts);
    /* UOC */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, 'objectdata.xml')) return $3ee4f50b1ae43a89$var$parse_ods(zip, opts);
    /* Numbers */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $3ee4f50b1ae43a89$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $3ee4f50b1ae43a89$var$parse_numbers_iwa(zip, opts);
            var _zip = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new();
            $3ee4f50b1ae43a89$var$zipentries(zip).forEach(function(e) {
                $3ee4f50b1ae43a89$var$zip_add_file(_zip, e, $3ee4f50b1ae43a89$var$getzipbin(zip, e));
            });
            return $3ee4f50b1ae43a89$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $3ee4f50b1ae43a89$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $3ee4f50b1ae43a89$require$Buffer.isBuffer(index_zip.content)) return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $3ee4f50b1ae43a89$var$zipentries(zip);
    var dir = $3ee4f50b1ae43a89$var$parse_ct($3ee4f50b1ae43a89$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($3ee4f50b1ae43a89$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$3ee4f50b1ae43a89$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $3ee4f50b1ae43a89$var$strs = [];
        if (dir.sst) try {
            $3ee4f50b1ae43a89$var$strs = $3ee4f50b1ae43a89$var$parse_sst($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $3ee4f50b1ae43a89$var$parse_theme_xml($3ee4f50b1ae43a89$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $3ee4f50b1ae43a89$var$parse_sty($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, $3ee4f50b1ae43a89$var$get_rels_path($3ee4f50b1ae43a89$var$strip_front_slash(link))), link);
            return $3ee4f50b1ae43a89$var$parse_xlink($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $3ee4f50b1ae43a89$var$parse_wb($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $3ee4f50b1ae43a89$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $3ee4f50b1ae43a89$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $3ee4f50b1ae43a89$var$getzipstr(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $3ee4f50b1ae43a89$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $3ee4f50b1ae43a89$var$parse_cc($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $3ee4f50b1ae43a89$var$parse_xlmeta($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $3ee4f50b1ae43a89$var$parse_people_xml($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $3ee4f50b1ae43a89$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $3ee4f50b1ae43a89$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/[\S\s]*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $3ee4f50b1ae43a89$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $3ee4f50b1ae43a89$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $3ee4f50b1ae43a89$var$CT_VBA) out.vbaraw = $3ee4f50b1ae43a89$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metadata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $3ee4f50b1ae43a89$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $3ee4f50b1ae43a89$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $3ee4f50b1ae43a89$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $3ee4f50b1ae43a89$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $3ee4f50b1ae43a89$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $3ee4f50b1ae43a89$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $3ee4f50b1ae43a89$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($3ee4f50b1ae43a89$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    $3ee4f50b1ae43a89$var$fix_write_opts(opts = opts || {});
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 2, f, $3ee4f50b1ae43a89$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 3, f, $3ee4f50b1ae43a89$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $3ee4f50b1ae43a89$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.rels, 4, f, $3ee4f50b1ae43a89$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $3ee4f50b1ae43a89$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $3ee4f50b1ae43a89$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $3ee4f50b1ae43a89$var$zip_add_file(zip, $3ee4f50b1ae43a89$var$get_rels_path(f), $3ee4f50b1ae43a89$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $3ee4f50b1ae43a89$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 1, f, $3ee4f50b1ae43a89$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $3ee4f50b1ae43a89$var$write_theme(wb.Themes, opts);
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $3ee4f50b1ae43a89$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "styles." + wbext, $3ee4f50b1ae43a89$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $3ee4f50b1ae43a89$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $3ee4f50b1ae43a89$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_people_xml(people, opts));
        ct.people.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "persons/person.xml", $3ee4f50b1ae43a89$var$RELS.PEOPLE);
    }
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "[Content_Types].xml", $3ee4f50b1ae43a89$var$write_ct(ct, opts));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, '_rels/.rels', $3ee4f50b1ae43a89$var$write_rels(opts.rels));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $3ee4f50b1ae43a89$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $3ee4f50b1ae43a89$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($3ee4f50b1ae43a89$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $3ee4f50b1ae43a89$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    $3ee4f50b1ae43a89$var$fix_write_opts(opts = opts || {});
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 2, f, $3ee4f50b1ae43a89$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 3, f, $3ee4f50b1ae43a89$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $3ee4f50b1ae43a89$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.rels, 4, f, $3ee4f50b1ae43a89$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $3ee4f50b1ae43a89$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $3ee4f50b1ae43a89$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $3ee4f50b1ae43a89$var$zip_add_file(zip, $3ee4f50b1ae43a89$var$get_rels_path(f), $3ee4f50b1ae43a89$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $3ee4f50b1ae43a89$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 1, f, $3ee4f50b1ae43a89$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $3ee4f50b1ae43a89$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "styles." + wbext, $3ee4f50b1ae43a89$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $3ee4f50b1ae43a89$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $3ee4f50b1ae43a89$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_people_xml(people, opts));
        ct.people.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "persons/person.xml", $3ee4f50b1ae43a89$var$RELS.PEOPLE);
    }
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "[Content_Types].xml", $3ee4f50b1ae43a89$var$write_ct(ct, opts));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, '_rels/.rels', $3ee4f50b1ae43a89$var$write_rels(opts.rels));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $3ee4f50b1ae43a89$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $3ee4f50b1ae43a89$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $3ee4f50b1ae43a89$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $3ee4f50b1ae43a89$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $3ee4f50b1ae43a89$var$parse_xlsxcfb(cfb, opts);
    return $3ee4f50b1ae43a89$export$b41972a043aba84c(cfb, opts);
}
function $3ee4f50b1ae43a89$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $3ee4f50b1ae43a89$var$zip_read(d, o);
    return $3ee4f50b1ae43a89$export$b165387946f79a1(zip, o);
}
function $3ee4f50b1ae43a89$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $3ee4f50b1ae43a89$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $3ee4f50b1ae43a89$var$PRN.to_workbook(data, o);
}
function $3ee4f50b1ae43a89$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $3ee4f50b1ae43a89$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $3ee4f50b1ae43a89$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $3ee4f50b1ae43a89$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $3ee4f50b1ae43a89$var$utf8read(str);
    o.type = "binary";
    return $3ee4f50b1ae43a89$var$read_plaintext(str, o);
}
function $3ee4f50b1ae43a89$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $3ee4f50b1ae43a89$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $3ee4f50b1ae43a89$var$utf16lereadu(d.slice(2)) : $3ee4f50b1ae43a89$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $3ee4f50b1ae43a89$var$read_plaintext(d, o);
}
function $3ee4f50b1ae43a89$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $3ee4f50b1ae43a89$var$utf8write(data);
}
function $3ee4f50b1ae43a89$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(data, o);
    }
    return $3ee4f50b1ae43a89$var$PRN.to_workbook(d, o);
}
function $3ee4f50b1ae43a89$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $3ee4f50b1ae43a89$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(new Uint8Array(data), (o = $3ee4f50b1ae43a89$var$dup(o), o.type = "array", o));
    /* Javet projects `byte[]` to `Int8Array` */ if (typeof Int8Array !== 'undefined' && data instanceof Int8Array) return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(new Uint8Array(data.buffer, data.byteOffset, data.length), o);
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $3ee4f50b1ae43a89$var$_ssfopts = {};
    if (o.dateNF) $3ee4f50b1ae43a89$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $3ee4f50b1ae43a89$var$has_buf ? "buffer" : "binary";
        d = $3ee4f50b1ae43a89$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$3ee4f50b1ae43a89$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $3ee4f50b1ae43a89$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $3ee4f50b1ae43a89$var$dup(o);
            o.type = 'array';
            return $3ee4f50b1ae43a89$export$aafa59e2e03f2942($3ee4f50b1ae43a89$var$ab2a(d), o);
        }
    }
    switch((n = $3ee4f50b1ae43a89$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $3ee4f50b1ae43a89$var$read_cfb($3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $3ee4f50b1ae43a89$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $3ee4f50b1ae43a89$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $3ee4f50b1ae43a89$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $3ee4f50b1ae43a89$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $3ee4f50b1ae43a89$var$read_zip(d, o) : $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $3ee4f50b1ae43a89$var$parse_xlml(d, o) : $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $3ee4f50b1ae43a89$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $3ee4f50b1ae43a89$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $3ee4f50b1ae43a89$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $3ee4f50b1ae43a89$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($3ee4f50b1ae43a89$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $3ee4f50b1ae43a89$var$DBF.to_workbook(d, o);
    return $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
}
function $3ee4f50b1ae43a89$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(filename, o);
}
function $3ee4f50b1ae43a89$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(o.file, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(cfb, {
                type: $3ee4f50b1ae43a89$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(cfb, o);
}
function $3ee4f50b1ae43a89$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $3ee4f50b1ae43a89$var$write_ods(wb, opts);
        case "numbers":
            return $3ee4f50b1ae43a89$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $3ee4f50b1ae43a89$var$write_zip_xlsb(wb, opts);
        default:
            return $3ee4f50b1ae43a89$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $3ee4f50b1ae43a89$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    var z = $3ee4f50b1ae43a89$var$write_zip(wb, o);
    return $3ee4f50b1ae43a89$var$write_zip_denouement(z, o);
}
function $3ee4f50b1ae43a89$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    var z = $3ee4f50b1ae43a89$var$write_zip_xlsx(wb, o);
    return $3ee4f50b1ae43a89$var$write_zip_denouement(z, o);
}
function $3ee4f50b1ae43a89$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $3ee4f50b1ae43a89$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($3ee4f50b1ae43a89$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $3ee4f50b1ae43a89$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $3ee4f50b1ae43a89$var$write_dl(o.file, out);
    return o.type == "string" ? $3ee4f50b1ae43a89$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $3ee4f50b1ae43a89$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $3ee4f50b1ae43a89$var$write_xlscfb(wb, o);
    return $3ee4f50b1ae43a89$var$write_cfb_ctr(cfb, o);
}
function $3ee4f50b1ae43a89$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $3ee4f50b1ae43a89$var$Base64_encode($3ee4f50b1ae43a89$var$utf8write(o));
        case "binary":
            return $3ee4f50b1ae43a89$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $3ee4f50b1ae43a89$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $3ee4f50b1ae43a89$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $3ee4f50b1ae43a89$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $3ee4f50b1ae43a89$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $3ee4f50b1ae43a89$var$Base64_encode(bstr) : opts.type == 'string' ? $3ee4f50b1ae43a89$var$utf8read(bstr) : bstr;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $3ee4f50b1ae43a89$var$reset_cp();
    $3ee4f50b1ae43a89$var$check_wb(wb);
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $3ee4f50b1ae43a89$var$s2ab(out);
    }
    return $3ee4f50b1ae43a89$var$write_zip_typeXLSX(wb, o);
}
function $3ee4f50b1ae43a89$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $3ee4f50b1ae43a89$var$reset_cp();
    $3ee4f50b1ae43a89$var$check_wb(wb);
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $3ee4f50b1ae43a89$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $3ee4f50b1ae43a89$var$write_stxt_type($3ee4f50b1ae43a89$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$write_ods(wb, o), o);
        case 'wk1':
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $3ee4f50b1ae43a89$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $3ee4f50b1ae43a89$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $3ee4f50b1ae43a89$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $3ee4f50b1ae43a89$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    return $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o);
}
function $3ee4f50b1ae43a89$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    return $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb, o);
}
function $3ee4f50b1ae43a89$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $3ee4f50b1ae43a89$var$_fs.writeFile(filename, $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $3ee4f50b1ae43a89$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $3ee4f50b1ae43a89$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val1 = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val1 == null || val1.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val1.v;
        switch(val1.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'b':
            case 'n':
                if (!val1.z || !$3ee4f50b1ae43a89$var$fmt_is_date(val1.z)) break;
                v = $3ee4f50b1ae43a89$var$numdate(v); // TODO: date1904 setting should also be stored in worksheet object
                if (typeof v == "number") break;
            /* falls through */ case 'd':
                if (!(o && (o.UTC || o.raw === false))) v = $3ee4f50b1ae43a89$var$utc_to_local(new Date(v));
                break;
            default:
                throw new Error('unrecognized type ' + val1.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val1.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = (val1.t === 'n' && typeof o.rawNumbers === 'boolean' ? o.rawNumbers : raw) ? v : $3ee4f50b1ae43a89$var$format_cell(val1, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $3ee4f50b1ae43a89$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $3ee4f50b1ae43a89$var$safe_decode_range(range);
            break;
        case 'number':
            r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $3ee4f50b1ae43a89$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $3ee4f50b1ae43a89$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $3ee4f50b1ae43a89$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $3ee4f50b1ae43a89$var$qreg = /"/g;
function $3ee4f50b1ae43a89$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , w /*:number*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $3ee4f50b1ae43a89$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val1 = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val1 == null) txt = "";
        else if (val1.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val1.t == "n" ? val1.v : $3ee4f50b1ae43a89$var$format_cell(val1, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($3ee4f50b1ae43a89$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID" && w == 0 && row.length == 0) txt = '"ID"';
        } else if (val1.f != null && !val1.F) {
            isempty = false;
            txt = '=' + val1.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($3ee4f50b1ae43a89$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.strip) while(row[row.length - 1] === "")--row.length;
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $3ee4f50b1ae43a89$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $3ee4f50b1ae43a89$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, w, o);
        if (row == null) continue;
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $3ee4f50b1ae43a89$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $3ee4f50b1ae43a89$var$sheet_to_csv(sheet, opts);
    if (typeof $3ee4f50b1ae43a89$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $3ee4f50b1ae43a89$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $3ee4f50b1ae43a89$var$sheet_to_formulae(sheet /*:Worksheet*/ , opts /*:?Sheet2FormulaOpts*/ ) /*:Array<string>*/ {
    var y = "", x, val1 = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val1 = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val1 = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val1 = x.f;
            else if (opts && opts.values === false) continue;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val1 = "" + x.v;
            else if (x.t == 'b') val1 = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val1 = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val1 = "'" + x.v;
            else val1 = "" + x.v;
            cmds[cmds.length] = y + "=" + val1;
        }
    }
    return cmds;
}
function $3ee4f50b1ae43a89$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($3ee4f50b1ae43a89$var$DENSE != null && dense == null) dense = $3ee4f50b1ae43a89$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $3ee4f50b1ae43a89$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $3ee4f50b1ae43a89$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $3ee4f50b1ae43a89$var$encode_col(_C + C) + $3ee4f50b1ae43a89$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.UTC) v = $3ee4f50b1ae43a89$var$local_to_utc(v);
                    if (!o.cellDates) {
                        t = 'n';
                        v = $3ee4f50b1ae43a89$var$datenum(v);
                    }
                    z = cell != null && cell.z && $3ee4f50b1ae43a89$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $3ee4f50b1ae43a89$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$3ee4f50b1ae43a89$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $3ee4f50b1ae43a89$var$encode_range(range);
    return ws;
}
function $3ee4f50b1ae43a89$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $3ee4f50b1ae43a89$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $3ee4f50b1ae43a89$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, $3ee4f50b1ae43a89$var$encode_cell(R));
    /* R and C are 0-based indices */ return $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, $3ee4f50b1ae43a89$var$encode_col(C || 0) + $3ee4f50b1ae43a89$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $3ee4f50b1ae43a89$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank or single-sheet workbook object */ function $3ee4f50b1ae43a89$var$book_new(ws /*:?Worksheet*/ , wsname /*:?string*/ ) /*:Workbook*/ {
    var wb = {
        SheetNames: [],
        Sheets: {}
    };
    if (ws) $3ee4f50b1ae43a89$var$book_append_sheet(wb, ws, wsname || "Sheet1");
    return wb;
}
/* add a worksheet to the end of a given workbook */ function $3ee4f50b1ae43a89$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0 && name.length < 32) {
        var m = name.match(/\d+$/); // at this point, name length is capped at 32
        i = m && +m[0] || 0;
        var root = m && name.slice(0, m.index) || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $3ee4f50b1ae43a89$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $3ee4f50b1ae43a89$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $3ee4f50b1ae43a89$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $3ee4f50b1ae43a89$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $3ee4f50b1ae43a89$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $3ee4f50b1ae43a89$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $3ee4f50b1ae43a89$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $3ee4f50b1ae43a89$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $3ee4f50b1ae43a89$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $3ee4f50b1ae43a89$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $3ee4f50b1ae43a89$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(wsr);
    return ws;
}
var $3ee4f50b1ae43a89$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $3ee4f50b1ae43a89$var$encode_col,
    encode_row: $3ee4f50b1ae43a89$var$encode_row,
    encode_cell: $3ee4f50b1ae43a89$var$encode_cell,
    encode_range: $3ee4f50b1ae43a89$var$encode_range,
    decode_col: $3ee4f50b1ae43a89$var$decode_col,
    decode_row: $3ee4f50b1ae43a89$var$decode_row,
    split_cell: $3ee4f50b1ae43a89$var$split_cell,
    decode_cell: $3ee4f50b1ae43a89$var$decode_cell,
    decode_range: $3ee4f50b1ae43a89$var$decode_range,
    format_cell: $3ee4f50b1ae43a89$var$format_cell,
    sheet_new: $3ee4f50b1ae43a89$var$sheet_new,
    sheet_add_aoa: $3ee4f50b1ae43a89$var$sheet_add_aoa,
    sheet_add_json: $3ee4f50b1ae43a89$var$sheet_add_json,
    sheet_add_dom: $3ee4f50b1ae43a89$var$sheet_add_dom,
    aoa_to_sheet: $3ee4f50b1ae43a89$var$aoa_to_sheet,
    json_to_sheet: $3ee4f50b1ae43a89$var$json_to_sheet,
    table_to_sheet: $3ee4f50b1ae43a89$var$parse_dom_table,
    table_to_book: $3ee4f50b1ae43a89$var$table_to_book,
    sheet_to_csv: $3ee4f50b1ae43a89$var$sheet_to_csv,
    sheet_to_txt: $3ee4f50b1ae43a89$var$sheet_to_txt,
    sheet_to_json: $3ee4f50b1ae43a89$var$sheet_to_json,
    sheet_to_html: $3ee4f50b1ae43a89$var$sheet_to_html,
    sheet_to_formulae: $3ee4f50b1ae43a89$var$sheet_to_formulae,
    sheet_to_row_object_array: $3ee4f50b1ae43a89$var$sheet_to_json,
    sheet_get_cell: $3ee4f50b1ae43a89$var$ws_get_cell_stub,
    book_new: $3ee4f50b1ae43a89$var$book_new,
    book_append_sheet: $3ee4f50b1ae43a89$var$book_append_sheet,
    book_set_sheet_visibility: $3ee4f50b1ae43a89$var$book_set_sheet_visibility,
    cell_set_number_format: $3ee4f50b1ae43a89$var$cell_set_number_format,
    cell_set_hyperlink: $3ee4f50b1ae43a89$var$cell_set_hyperlink,
    cell_set_internal_link: $3ee4f50b1ae43a89$var$cell_set_internal_link,
    cell_add_comment: $3ee4f50b1ae43a89$var$cell_add_comment,
    sheet_set_array_formula: $3ee4f50b1ae43a89$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $3ee4f50b1ae43a89$var$_Readable;
function $3ee4f50b1ae43a89$var$set_readable(R) {
    $3ee4f50b1ae43a89$var$_Readable = R;
}
function $3ee4f50b1ae43a89$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $3ee4f50b1ae43a89$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, w, o);
            if (row != null) {
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $3ee4f50b1ae43a89$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $3ee4f50b1ae43a89$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $3ee4f50b1ae43a89$var$HTML_END;
    stream.push(header);
    var r = $3ee4f50b1ae43a89$var$decode_range(ws['!ref']);
    stream.push($3ee4f50b1ae43a89$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($3ee4f50b1ae43a89$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $3ee4f50b1ae43a89$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $3ee4f50b1ae43a89$var$safe_decode_range(range);
            break;
        case 'number':
            r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $3ee4f50b1ae43a89$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $3ee4f50b1ae43a89$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $3ee4f50b1ae43a89$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $3ee4f50b1ae43a89$var$write_xlml_stream(wb /*:Workbook*/ , o /*:?Sheet2XLMLOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable();
    var opts = o == null ? {} : o;
    var stride = +opts.stride || 10;
    if (!wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    /* do one pass to determine styles since they must be added before tables */ wb.SheetNames.forEach(function(n) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!ref"]) return;
        var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var ddata = dense ? ws["!data"] : [];
        var addr = {
            r: 0,
            c: 0
        };
        for(var R = range.s.r; R <= range.e.r; ++R){
            addr.r = R;
            if (dense && !ddata[R]) continue;
            for(var C = range.s.c; C <= range.e.c; ++C){
                addr.c = C;
                var cell = dense ? ddata[R][C] : ws[$3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R)];
                if (!cell) continue;
                if (cell.t == "d" && cell.z == null) {
                    cell = $3ee4f50b1ae43a89$var$dup(cell);
                    cell.z = $3ee4f50b1ae43a89$var$table_fmt[14];
                }
                $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
            }
        }
    });
    var sty = $3ee4f50b1ae43a89$var$write_sty_xlml(wb, opts);
    var stage = 0, wsidx = 0, ws = wb.Sheets[wb.SheetNames[wsidx]], range = $3ee4f50b1ae43a89$var$safe_decode_range(ws), R = -1, T = false;
    var marr = [], mi = 0, dense = false, darr = [], addr = {
        r: 0,
        c: 0
    };
    stream._read = function() {
        switch(stage){
            /* header */ case 0:
                stage = 1;
                stream.push($3ee4f50b1ae43a89$var$XML_HEADER);
                stream.push("<Workbook" + $3ee4f50b1ae43a89$var$wxt_helper({
                    'xmlns': $3ee4f50b1ae43a89$var$XLMLNS.ss,
                    'xmlns:o': $3ee4f50b1ae43a89$var$XLMLNS.o,
                    'xmlns:x': $3ee4f50b1ae43a89$var$XLMLNS.x,
                    'xmlns:ss': $3ee4f50b1ae43a89$var$XLMLNS.ss,
                    'xmlns:dt': $3ee4f50b1ae43a89$var$XLMLNS.dt,
                    'xmlns:html': $3ee4f50b1ae43a89$var$XLMLNS.html
                }) + ">");
                break;
            /* preamble */ case 1:
                stage = 2;
                stream.push($3ee4f50b1ae43a89$var$write_props_xlml(wb, opts));
                stream.push($3ee4f50b1ae43a89$var$write_wb_xlml(wb, opts));
                break;
            /* style and name tables */ case 2:
                stage = 3;
                stream.push(sty);
                stream.push($3ee4f50b1ae43a89$var$write_names_xlml(wb, opts));
                break;
            /* worksheet preamble */ case 3:
                T = false;
                if (wsidx >= wb.SheetNames.length) {
                    stage = -1;
                    stream.push("");
                    break;
                }
                stream.push("<Worksheet" + $3ee4f50b1ae43a89$var$wxt_helper({
                    "ss:Name": $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[wsidx])
                }) + ">");
                ws = wb.Sheets[wb.SheetNames[wsidx]];
                if (!ws) {
                    stream.push("</Worksheet>");
                    return void ++wsidx;
                }
                var names = $3ee4f50b1ae43a89$var$write_ws_xlml_names(ws, opts, wsidx, wb);
                if (names.length) stream.push("<Names>" + names + "</Names>");
                if (!ws["!ref"]) return stage = 5;
                range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
                R = range.s.r;
                stage = 4;
                break;
            /* worksheet intramble */ case 4:
                if (R < 0 || R > range.e.r) {
                    if (T) stream.push("</Table>");
                    return void (stage = 5);
                }
                if (R <= range.s.r) {
                    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
                        $3ee4f50b1ae43a89$var$process_col(n);
                        var w = !!n.width;
                        var p = $3ee4f50b1ae43a89$var$col_obj_w(i, n);
                        var k /*:any*/  = {
                            "ss:Index": i + 1
                        };
                        if (w) k['ss:Width'] = $3ee4f50b1ae43a89$var$width2px(p.width);
                        if (n.hidden) k['ss:Hidden'] = "1";
                        if (!T) {
                            T = true;
                            stream.push("<Table>");
                        }
                        stream.push($3ee4f50b1ae43a89$var$writextag("Column", null, k));
                    });
                    dense = ws["!data"] != null;
                    if (dense) darr = ws["!data"];
                    addr.r = addr.c = 0;
                }
                /* process `stride` rows per invocation */ for(var cnt = 0; R <= range.e.r && cnt < stride; ++R, ++cnt){
                    var row = [
                        $3ee4f50b1ae43a89$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
                    ];
                    addr.r = R;
                    if (!(dense && !darr[R])) for(var C = range.s.c; C <= range.e.c; ++C){
                        addr.c = C;
                        var skip = false;
                        for(mi = 0; mi != marr.length; ++mi){
                            if (marr[mi].s.c > C) continue;
                            if (marr[mi].s.r > R) continue;
                            if (marr[mi].e.c < C) continue;
                            if (marr[mi].e.r < R) continue;
                            if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                            break;
                        }
                        if (skip) continue;
                        var ref = $3ee4f50b1ae43a89$var$encode_col(C) + $3ee4f50b1ae43a89$var$encode_row(R), cell = dense ? darr[R][C] : ws[ref];
                        row.push($3ee4f50b1ae43a89$var$write_ws_xlml_cell(cell, ref, ws, opts, wsidx, wb, addr));
                    }
                    row.push("</Row>");
                    if (!T) {
                        T = true;
                        stream.push("<Table>");
                    }
                    stream.push(row.join(""));
                }
                break;
            /* worksheet postamble */ case 5:
                stream.push($3ee4f50b1ae43a89$var$write_ws_xlml_wsopts(ws, opts, wsidx, wb));
                if (ws && ws["!autofilter"]) stream.push('<AutoFilter x:Range="' + $3ee4f50b1ae43a89$var$a1_to_rc($3ee4f50b1ae43a89$var$fix_range(ws["!autofilter"].ref), {
                    r: 0,
                    c: 0
                }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
                stream.push("</Worksheet>");
                wsidx++;
                R = -1;
                return void (stage = 3);
            /* footer */ case -1:
                stage = -2;
                stream.push("</Workbook>");
                break;
            /* exeunt */ case -2:
                stream.push(null);
                break;
        }
    };
    return stream;
}
var $3ee4f50b1ae43a89$export$4938110305e6185f = {
    to_json: $3ee4f50b1ae43a89$var$write_json_stream,
    to_html: $3ee4f50b1ae43a89$var$write_html_stream,
    to_csv: $3ee4f50b1ae43a89$var$write_csv_stream,
    to_xlml: $3ee4f50b1ae43a89$var$write_xlml_stream,
    set_readable: $3ee4f50b1ae43a89$var$set_readable
};
const $3ee4f50b1ae43a89$export$83d89fbfd8236492 = $3ee4f50b1ae43a89$var$XLSX.version;
var $3ee4f50b1ae43a89$export$2e2bcd8739ae039 = {
    parse_xlscfb: $3ee4f50b1ae43a89$export$b41972a043aba84c,
    parse_zip: $3ee4f50b1ae43a89$export$b165387946f79a1,
    read: $3ee4f50b1ae43a89$export$aafa59e2e03f2942,
    readFile: $3ee4f50b1ae43a89$export$72c04af63de9061a,
    readFileSync: $3ee4f50b1ae43a89$export$72c04af63de9061a,
    write: $3ee4f50b1ae43a89$export$68d8715fc104d294,
    writeFile: $3ee4f50b1ae43a89$export$552bfb764b5cd2b4,
    writeFileSync: $3ee4f50b1ae43a89$export$552bfb764b5cd2b4,
    writeFileAsync: $3ee4f50b1ae43a89$export$25469296c4b8ebda,
    writeXLSX: $3ee4f50b1ae43a89$export$f6ca43591cb061b1,
    writeFileXLSX: $3ee4f50b1ae43a89$export$40a06aea54ee074e,
    utils: $3ee4f50b1ae43a89$export$eab97d15b1788b8d,
    set_fs: $3ee4f50b1ae43a89$export$a48eb669e1768bcf,
    set_cptable: $3ee4f50b1ae43a89$export$58f247d16f363b86,
    stream: $3ee4f50b1ae43a89$export$4938110305e6185f,
    SSF: $3ee4f50b1ae43a89$export$40d8edd678456c2b,
    CFB: $3ee4f50b1ae43a89$export$9f0e51cd97c572a
};


var $639d3d0ba3765287$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $639d3d0ba3765287$exports = t();
})($639d3d0ba3765287$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});




var $jCgCX = parcelRequire("jCgCX");
var $a6c118bc22509e47$exports = {};
!function(e, t) {
    $a6c118bc22509e47$exports = t();
}($a6c118bc22509e47$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $7dcf79494e571a47$exports = {};
!function(n, e) {
    $7dcf79494e571a47$exports = e();
}($7dcf79494e571a47$exports, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function() {
            return t.Ls[t.locale()];
        }, a = function(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function() {
            var n = this;
            return {
                months: function(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function() {
                    return n.weekStart || 0;
                },
                weekdays: function() {
                    return t.weekdays();
                },
                weekdaysShort: function() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function() {
                    return t.weekdaysMin();
                },
                months: function() {
                    return t.months();
                },
                monthsShort: function() {
                    return t.monthsShort();
                },
                longDateFormat: function(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});


var $d6453f5b1de19d5c$exports = {};
!function(e, n) {
    $d6453f5b1de19d5c$exports = n();
}($d6453f5b1de19d5c$exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});


var $3c36a28f525fea22$exports = {};

!function(e, t) {
    $3c36a28f525fea22$exports = t((parcelRequire("jCgCX")));
}($3c36a28f525fea22$exports, function(e) {
    "use strict";
    function t(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var d = t(e), a = {
        name: "da",
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),
        weekdaysShort: "s\xf8n._man._tirs._ons._tors._fre._l\xf8r.".split("_"),
        weekdaysMin: "s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),
        months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
        monthsShort: "jan._feb._mar._apr._maj_juni_juli_aug._sept._okt._nov._dec.".split("_"),
        weekStart: 1,
        yearStart: 4,
        ordinal: function(e) {
            return e + ".";
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm"
        },
        relativeTime: {
            future: "om %s",
            past: "%s siden",
            s: "f\xe5 sekunder",
            m: "et minut",
            mm: "%d minutter",
            h: "en time",
            hh: "%d timer",
            d: "en dag",
            dd: "%d dage",
            M: "en m\xe5ned",
            MM: "%d m\xe5neder",
            y: "et \xe5r",
            yy: "%d \xe5r"
        }
    };
    return d.default.locale(a, null, !0), a;
});


var $0dc6c268eecabca2$exports = {};

!function(e, a) {
    $0dc6c268eecabca2$exports = a((parcelRequire("jCgCX")));
}($0dc6c268eecabca2$exports, function(e) {
    "use strict";
    function a(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var d = a(e), n = {
        name: "nl",
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
        ordinal: function(e) {
            return "[" + e + (1 === e || 8 === e || e >= 20 ? "ste" : "de") + "]";
        },
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            m: "een minuut",
            mm: "%d minuten",
            h: "een uur",
            hh: "%d uur",
            d: "een dag",
            dd: "%d dagen",
            M: "een maand",
            MM: "%d maanden",
            y: "een jaar",
            yy: "%d jaar"
        }
    };
    return d.default.locale(n, null, !0), n;
});


var $5e541a21df3f2727$exports = {};

!function(e, n) {
    $5e541a21df3f2727$exports = n((parcelRequire("jCgCX")));
}($5e541a21df3f2727$exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), i = {
        name: "fr",
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        ordinal: function(e) {
            return "" + e + (1 === e ? "er" : "");
        }
    };
    return t.default.locale(i, null, !0), i;
});


var $fcec668db3e6f0ad$exports = {};

!function(e, n) {
    $fcec668db3e6f0ad$exports = n((parcelRequire("jCgCX")));
}($fcec668db3e6f0ad$exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), a = {
        s: "ein paar Sekunden",
        m: [
            "eine Minute",
            "einer Minute"
        ],
        mm: "%d Minuten",
        h: [
            "eine Stunde",
            "einer Stunde"
        ],
        hh: "%d Stunden",
        d: [
            "ein Tag",
            "einem Tag"
        ],
        dd: [
            "%d Tage",
            "%d Tagen"
        ],
        M: [
            "ein Monat",
            "einem Monat"
        ],
        MM: [
            "%d Monate",
            "%d Monaten"
        ],
        y: [
            "ein Jahr",
            "einem Jahr"
        ],
        yy: [
            "%d Jahre",
            "%d Jahren"
        ]
    };
    function i(e, n, t) {
        var i = a[t];
        return Array.isArray(i) && (i = i[n ? 0 : 1]), i.replace("%d", e);
    }
    var r = {
        name: "de",
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"),
        ordinal: function(e) {
            return e + ".";
        },
        weekStart: 1,
        yearStart: 4,
        formats: {
            LTS: "HH:mm:ss",
            LT: "HH:mm",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: i,
            m: i,
            mm: i,
            h: i,
            hh: i,
            d: i,
            dd: i,
            M: i,
            MM: i,
            y: i,
            yy: i
        }
    };
    return t.default.locale(r, null, !0), r;
});


var $a3b814bf568428e8$exports = {};

!function(e, o) {
    $a3b814bf568428e8$exports = o((parcelRequire("jCgCX")));
}($a3b814bf568428e8$exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = o(e), n = {
        name: "it",
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        weekStart: 1,
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "tra %s",
            past: "%s fa",
            s: "qualche secondo",
            m: "un minuto",
            mm: "%d minuti",
            h: "un' ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        },
        ordinal: function(e) {
            return e + "\xba";
        }
    };
    return t.default.locale(n, null, !0), n;
});


var $9e521bf3675acebb$exports = {};

!function(e, t) {
    $9e521bf3675acebb$exports = t((parcelRequire("jCgCX")));
}($9e521bf3675acebb$exports, function(e) {
    "use strict";
    function t(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var i = t(e);
    function a(e) {
        return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1;
    }
    function n(e, t, i) {
        var n = e + " ";
        switch(i){
            case "m":
                return t ? "minuta" : "minut\u0119";
            case "mm":
                return n + (a(e) ? "minuty" : "minut");
            case "h":
                return t ? "godzina" : "godzin\u0119";
            case "hh":
                return n + (a(e) ? "godziny" : "godzin");
            case "MM":
                return n + (a(e) ? "miesi\u0105ce" : "miesi\u0119cy");
            case "yy":
                return n + (a(e) ? "lata" : "lat");
        }
    }
    var r = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split("_"), _ = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split("_"), s = /D MMMM/, d = function(e, t) {
        return s.test(t) ? r[e.month()] : _[e.month()];
    };
    d.s = _, d.f = r;
    var o = {
        name: "pl",
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split("_"),
        weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split("_"),
        months: d,
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split("_"),
        ordinal: function(e) {
            return e + ".";
        },
        weekStart: 1,
        yearStart: 4,
        relativeTime: {
            future: "za %s",
            past: "%s temu",
            s: "kilka sekund",
            m: n,
            mm: n,
            h: n,
            hh: n,
            d: "1 dzie\u0144",
            dd: "%d dni",
            M: "miesi\u0105c",
            MM: n,
            y: "rok",
            yy: n
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        }
    };
    return i.default.locale(o, null, !0), o;
});


var $88649b3e282d9aa8$exports = {};

!function(e, i) {
    $88649b3e282d9aa8$exports = i((parcelRequire("jCgCX")));
}($88649b3e282d9aa8$exports, function(e) {
    "use strict";
    function i(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = i(e), _ = {
        name: "ro",
        weekdays: "Duminic\u0103_Luni_Mar\u021Bi_Miercuri_Joi_Vineri_S\xe2mb\u0103t\u0103".split("_"),
        weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),
        weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),
        months: "Ianuarie_Februarie_Martie_Aprilie_Mai_Iunie_Iulie_August_Septembrie_Octombrie_Noiembrie_Decembrie".split("_"),
        monthsShort: "Ian._Febr._Mart._Apr._Mai_Iun._Iul._Aug._Sept._Oct._Nov._Dec.".split("_"),
        weekStart: 1,
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        relativeTime: {
            future: "peste %s",
            past: "acum %s",
            s: "c\xe2teva secunde",
            m: "un minut",
            mm: "%d minute",
            h: "o or\u0103",
            hh: "%d ore",
            d: "o zi",
            dd: "%d zile",
            M: "o lun\u0103",
            MM: "%d luni",
            y: "un an",
            yy: "%d ani"
        },
        ordinal: function(e) {
            return e;
        }
    };
    return t.default.locale(_, null, !0), _;
});


var $d16252c1a37e959b$exports = {};

!function(e, o) {
    $d16252c1a37e959b$exports = o((parcelRequire("jCgCX")));
}($d16252c1a37e959b$exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var s = o(e), d = {
        name: "es",
        monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        weekStart: 1,
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        ordinal: function(e) {
            return e + "\xba";
        }
    };
    return s.default.locale(d, null, !0), d;
});


var $51afd46850701b6f$exports = {};

!function(e, t) {
    $51afd46850701b6f$exports = t((parcelRequire("jCgCX")));
}($51afd46850701b6f$exports, function(e) {
    "use strict";
    function t(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var a = t(e), d = {
        name: "sv",
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),
        months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekStart: 1,
        yearStart: 4,
        ordinal: function(e) {
            var t = e % 10;
            return "[" + e + (1 === t || 2 === t ? "a" : "e") + "]";
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [kl.] HH:mm",
            LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd D MMM YYYY HH:mm"
        },
        relativeTime: {
            future: "om %s",
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            m: "en minut",
            mm: "%d minuter",
            h: "en timme",
            hh: "%d timmar",
            d: "en dag",
            dd: "%d dagar",
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        }
    };
    return a.default.locale(d, null, !0), d;
});


var $d6ea8aaff424b0b6$exports = {};

!function(a, e) {
    $d6ea8aaff424b0b6$exports = e((parcelRequire("jCgCX")));
}($d6ea8aaff424b0b6$exports, function(a) {
    "use strict";
    function e(a) {
        return a && "object" == typeof a && "default" in a ? a : {
            default: a
        };
    }
    var t = e(a), _ = {
        name: "tr",
        weekdays: "Pazar_Pazartesi_Sal\u0131_\xc7ar\u015Famba_Per\u015Fembe_Cuma_Cumartesi".split("_"),
        weekdaysShort: "Paz_Pts_Sal_\xc7ar_Per_Cum_Cts".split("_"),
        weekdaysMin: "Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),
        months: "Ocak_\u015Eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011Fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),
        monthsShort: "Oca_\u015Eub_Mar_Nis_May_Haz_Tem_A\u011Fu_Eyl_Eki_Kas_Ara".split("_"),
        weekStart: 1,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \xf6nce",
            s: "birka\xe7 saniye",
            m: "bir dakika",
            mm: "%d dakika",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir ay",
            MM: "%d ay",
            y: "bir y\u0131l",
            yy: "%d y\u0131l"
        },
        ordinal: function(a) {
            return a + ".";
        }
    };
    return t.default.locale(_, null, !0), _;
});


(0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($7dcf79494e571a47$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($d6453f5b1de19d5c$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a6c118bc22509e47$exports))));
function $4890db420b2f6223$var$monthsToLower(months) {
    return months.map((name)=>name.toLowerCase());
}
function $4890db420b2f6223$export$29beae0674e9193d(timestamp, hourstring) {
    const STRING_US = 'h:mm:ss A';
    const STRING_EU = 'HH:mm:ss';
    const day = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).unix(timestamp).startOf('day');
    const time = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(hourstring, [
        STRING_US,
        STRING_EU
    ]);
    return day.set("hour", time.hour()).set("minute", time.minute()).set("second", time.second()).unix();
}
function $4890db420b2f6223$export$2e2bcd8739ae039(datestring) {
    const culturearray = [
        "tr",
        "sv",
        "es",
        "ro",
        "pl",
        "it",
        "de",
        "fr",
        "nl",
        "da",
        "en"
    ];
    const STRING_US = 'MMMM D[,]YYYY [at] h:mm A';
    const STRING_EU = 'MMMM DD[,]YYYY HH:mm';
    let cultures;
    // make it a nice string
    if (typeof datestring == "string") {
        datestring = datestring.trim();
        datestring = datestring.replace(/\"/g, '');
        datestring = datestring.replace(/\u202f/g, ' ');
        if (/[AP]M$/.test(datestring)) datestring = datestring.replace(/ at /, ' ');
        if (/ um /.test(datestring)) datestring = datestring.replace(/ um /, ' ');
    }
    console.debug("[_getdatestring]: trying to convert: " + datestring);
    let culture = 'en';
    let validconversion = false;
    let datedate = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))("1990-01-01");
    let phase = 0;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(datestring).isValid()) validconversion = true;
    if (validconversion === false) {
        //make it lowercase so the months will fetch it
        datestring = datestring.toLowerCase();
        // try it the easy way
        phase = 1;
        cultures = culturearray.slice(0);
        while(validconversion === false && cultures.length > 0){
            culture = cultures.pop();
            (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).locale(culture);
            //validate culture
            //console.log("supposed culture: " + culture)
            //console.log("current culture: " + dayjs.locale());
            if (culture !== (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).locale()) console.warn("[_getdatestring]: Culture " + culture + " missing.");
            // make all monthname lowercase
            //console.log(dayjs.months());
            (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).updateLocale(culture, {
                months: $4890db420b2f6223$var$monthsToLower((0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).months())
            });
            //console.log(dayjs.months());
            validconversion = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(datestring).isValid();
            if (validconversion) console.debug("[_getdatestring]: phase 1 conversion worked with " + (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).locale() + " and " + (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(datestring).format("DD-MM-YYYY") + ".");
        }
    }
    // go creative
    if (validconversion == false) {
        phase = 2;
        cultures = culturearray.slice(0);
        while(validconversion == false && cultures.length > 0){
            culture = cultures.pop();
            //console.log(culture)
            validconversion = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(datestring, [
                STRING_US,
                STRING_EU
            ], culture).isValid();
            if (validconversion) console.debug("[_getdatestring]: phase 2 conversion worked with " + culture);
        }
    }
    if (validconversion === true && phase in [
        0,
        1
    ]) // convert it
    datedate = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(datestring);
    else if (validconversion === true && phase == 2) // convert it
    datedate = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(datestring, [
        STRING_US,
        STRING_EU
    ], culture);
    else console.warn("[_getdatestring]: No conversion found for " + datestring);
    //return it
    //return [datedate.getDate().toString().padStart(2,'0') + "-" + (datedate.getMonth()+1).toString().padStart(2,'0') + "-" + datedate.getFullYear(),datedate.getHours().toString().padStart(2,'0') + "-" + datedate.getMinutes().toString().padStart(2,'0') + "-" + datedate.getSeconds().toString().padStart(2,'0')];
    //const datestring = item.timestamp.getDate().toString().padStart(2,'0') + "-" + (item.timestamp.getMonth()+1).toString().padStart(2,'0') + "-" + item.timestamp.getFullYear() 
    //const timestring = item.timestamp.getHours().toString().padStart(2,'0') + ":" + item.timestamp.getMinutes().toString().padStart(2,'0')+ ":" + item.timestamp.getSeconds().toString().padStart(2,'0')
    console.debug("[_getdatestring]: conversion done with " + culture + " to " + datedate.format("DD-MM-YYYY") + " " + datedate.format("HH:mm:ss"));
    (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).locale('en');
    return [
        datedate.format("DD-MM-YYYY"),
        datedate.format("HH:mm:ss"),
        datedate.unix()
    ];
}



function $6234c3dc946ef4db$export$2e2bcd8739ae039(fileData, ofilename) {
    return new Promise(async (resolve, reject)=>{
        const start = Date.now();
        const dec = new TextDecoder("utf-8");
        const source = typeof fileData != 'string' /* 'object'*/  ? dec.decode(fileData) : fileData;
        let checksum;
        if (typeof fileData != 'string') checksum = (0, $f86ba9a509d1cca0$export$585b273162778445)(fileData);
        else {
            const enc = new TextEncoder();
            checksum = (0, $f86ba9a509d1cca0$export$585b273162778445)(enc.encode(source).buffer);
        }
        const cleansource = source.replace(/, /g, ',');
        let sourceparts = cleansource.split(/-,{3,}[\n]/);
        let fallback = false;
        if (sourceparts.length == 1) {
            console.log("[csv2db]: " + ofilename + ' trying to apply fallback');
            sourceparts = cleansource.split(/^,{6,}$/gm);
            fallback = true;
        }
        if (sourceparts.length == 1) {
            console.error("[csv2db]: " + ofilename + ' not a working csv file.');
            reject("Error: " + ofilename + ' is not a working csv file.');
            return;
        }
        try {
            const sourceparts0 = sourceparts[0].split('\n');
            let title = sourceparts0.shift();
            const header = sourceparts0.shift()?.split(',');
            const shotlist = sourceparts0.join("\n");
            if (title && header && shotlist) {
                const shots = (0, (/*@__PURE__*/$parcel$interopDefault($639d3d0ba3765287$exports))).parse(shotlist, {
                    newline: "\n",
                    skipEmtpyLines: true,
                    dynamicTyping: true
                });
                let dump = "";
                let stats;
                let dt;
                let filename;
                dump = shots.data.pop();
                if (dump !== "") shots.data.push();
                if (fallback) {
                    dt = {
                        data: []
                    };
                    stats = (0, (/*@__PURE__*/$parcel$interopDefault($639d3d0ba3765287$exports))).parse(sourceparts[1], {
                        newline: "\n",
                        skipEmtpyLines: true,
                        dynamicTyping: true
                    });
                    dump = stats.data.shift() //get rid of the first newline 
                    ;
                    if (dump !== "") stats.data.unshift();
                    //fill dt
                    dt.data.push(stats.data.pop());
                    dt.data.unshift(stats.data.pop());
                } else {
                    stats = (0, (/*@__PURE__*/$parcel$interopDefault($639d3d0ba3765287$exports))).parse(sourceparts[1], {
                        newline: "\n"
                    });
                    dump = stats.data.pop();
                    if (dump !== "") stats.data.push();
                    dt = (0, (/*@__PURE__*/$parcel$interopDefault($639d3d0ba3765287$exports))).parse(sourceparts[2], {
                        newline: '\n',
                        quoteChar: '"'
                    });
                    dump = dt.data.pop();
                    if (dump !== "") dt.data.push();
                }
                const [datestring, hourstring, timestamp] = (0, $4890db420b2f6223$export$2e2bcd8739ae039)(dt.data[0][1]);
                if (datestring == 'Invalid Date' || datestring == "01-01-1990") {
                    reject("Date " + dt.data[0][1] + " does not parse. Ping the dev on github.");
                    return;
                }
                title = title.split('\n')[0].replace(/,{2,}/g, '').replace(/"/g, '');
                if (ofilename.includes(datestring) || ofilename.includes(datestring.split('-').reverse().join('-'))) filename = ofilename.replace(/\.csv$/, '-xeroconv.csv');
                else filename = ofilename.replace(/\.csv$/, '') + '_' + datestring + '_' + hourstring.replaceAll(':', '-') + '-xeroconv.csv';
                //extending the stats array for missing values when no bullet weight is available
                if (5 > stats.data.length) {
                    stats.data.splice(1, 0, [
                        "AVERAGE POWER FACTOR",
                        '',
                        '',
                        '',
                        '',
                        ''
                    ]);
                    stats.data.splice(4, 0, [
                        "Gewicht des Projektils (GRAN)",
                        '',
                        '',
                        '',
                        '',
                        ''
                    ]);
                }
                const unit_velocity = /\(MPS\)/i.test(header[1]) ? false : true;
                const unit_distance = /\(MPS\)/i.test(header[1]) ? false : true;
                const unit_energy = /\(J\)/.test(header[3]) ? false : true;
                const unit_weight = /\(GRAN\)*/.test(stats.data[4][0]) ? true : false;
                const speeds = shots.data.map((row)=>(0, $fbe7bf898f270681$export$2e2bcd8739ae039)(row[1]));
                const speed_max = Math.max(...speeds);
                const speed_min = Math.min(...speeds);
                const speed_avg = Math.round(speeds.reduce((a, b)=>a + b) / speeds.length * 1000) / 1000;
                /*/ write data to database
        await AddFile(ofilename,title,"useyournose-xeroconv")
        .then(async (db_fileid) => {
          Promise.all([
          Promise.resolve(db_fileid),
          AddUnits(db_fileid,{
            velocity: unit_velocity,
            distance: unit_distance,
            energy: unit_energy,
            weight: unit_weight ,
          } as SessionUnits ),

          AddStats(db_fileid, {
            shots_total: shots.data.length as number,
            speed_avg: speed_avg,
            speed_max: speed_max,
            speed_min: speed_min,
            speed_es: nnf(stats.data[3][1]),
            speed_sd: nnf(stats.data[2][1]),
            projectile: nnf(stats.data[4][1]),
            timestamp: timestamp,
            timezone: 0
          } as SessionStats),

          AddShots(db_fileid,
            shots.data.map((row) => ({
              shotnumber: row[0] as number,
              velocity: nnf(row[1]),
              energy: nnf(row[3]),
              timestamp: gettimestamp(timestamp, row[5]) as number
            })
          ))])
          .then((values) => {
            resolve(values[0])
          })
      })
      }*/ return resolve({
                    file: {
                        name: ofilename,
                        title: ofilename,
                        deviceid: "useyournose-xeroconv",
                        checksum: checksum
                    },
                    stats: {
                        shots_total: shots.data.length,
                        speed_avg: speed_avg,
                        speed_max: speed_max,
                        speed_min: speed_min,
                        speed_es: (0, $fbe7bf898f270681$export$2e2bcd8739ae039)(stats.data[3][1]),
                        speed_sd: (0, $fbe7bf898f270681$export$2e2bcd8739ae039)(stats.data[2][1]),
                        projectile: (0, $fbe7bf898f270681$export$2e2bcd8739ae039)(stats.data[4][1]),
                        timestamp: timestamp,
                        timezone: 0
                    },
                    units: {
                        velocity: unit_velocity,
                        distance: unit_distance,
                        energy: unit_energy,
                        weight: unit_weight
                    },
                    shots: shots.data.map((row)=>({
                            shotnumber: row[0],
                            velocity: (0, $fbe7bf898f270681$export$2e2bcd8739ae039)(row[1]),
                            energy: (0, $fbe7bf898f270681$export$2e2bcd8739ae039)(row[3]),
                            timestamp: (0, $4890db420b2f6223$export$29beae0674e9193d)(timestamp, row[5])
                        }))
                });
            }
        } catch (err) {
            console.error("[csv2db]: " + err);
            if (Object.hasOwn(err, 'message')) reject(err.message);
            else reject(err);
        }
    });
}


let $5115409d5d67d81a$var$timeoutid;
function $5115409d5d67d81a$var$showNotification(message, classlist) {
    // inspired from https://www.w3schools.com/howto/howto_js_snackbar.asp
    // Get the snackbar DIV
    const x = document.getElementById("snackbar");
    if (null != x) {
        const elem = document.createElement("div");
        elem.classList.value = classlist;
        elem.id = crypto.randomUUID();
        elem.innerText = message;
        x.appendChild(elem);
        setTimeout(function() {
            document.getElementById(elem.id)?.remove();
        }, 3000);
        // Add the "show" class to DIV
        x.className = "show";
        clearTimeout($5115409d5d67d81a$var$timeoutid);
        // After 3 seconds, remove the show class from DIV
        $5115409d5d67d81a$var$timeoutid = setTimeout(function() {
            x.className = x.className.replace("show", "");
        }, 3000);
    }
}
function $5115409d5d67d81a$export$3879b24e8245693d(message) {
    $5115409d5d67d81a$var$showNotification(message, 'notification is-danger');
}
function $5115409d5d67d81a$export$d841eba85c078f0b(message) {
    $5115409d5d67d81a$var$showNotification(message, 'notification is-success');
}


function $2db6704966f8bd16$export$2e2bcd8739ae039(fileData, ofilename) {
    return new Promise(async (resolve, reject)=>{
        const Sessions = [];
        const xlsfile = (0, $3ee4f50b1ae43a89$export$2e2bcd8739ae039).read(fileData, {
            type: "array"
        });
        var promises = xlsfile.SheetNames.map(async (sheetname)=>{
            return new Promise((resolve, reject)=>{
                const worksheet = xlsfile.Sheets[sheetname];
                const csvdata = (0, $3ee4f50b1ae43a89$export$2e2bcd8739ae039).utils.sheet_to_csv(worksheet);
                const title = csvdata.split('\n')[0].replace(/,{2,}/g, '').replace(/"/g, '');
                (0, $6234c3dc946ef4db$export$2e2bcd8739ae039)(csvdata, title + '.csv').then((Session)=>{
                    Sessions.push(Session);
                    console.log("[xls2json]: parsed " + sheetname);
                    return resolve(true);
                }).catch((err)=>{
                    console.warn("[xls2json]: " + err);
                    (0, $5115409d5d67d81a$export$3879b24e8245693d)(err);
                    return reject(err);
                });
            });
        });
        await Promise.allSettled(promises).then((values)=>{
            return resolve(Sessions);
        }).catch((err)=>{
            return reject(err);
        });
    });
}



function $f466f95b1741c789$export$2e2bcd8739ae039(files) {
    return new Promise(async (resolve, reject)=>{
        var success = 0;
        var failure = 0;
        //inspired from https://stackoverflow.com/a/18197341
        await Promise.allSettled(files.map(async (file)=>{
            try {
                await file.text().then((value)=>{
                    const element = document.createElement('a');
                    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(value));
                    element.setAttribute('download', file.name);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    console.log("[download]: file " + file.name + " saved.");
                    (0, $5115409d5d67d81a$export$d841eba85c078f0b)("Saved " + file.name + ".");
                    success++;
                    return Promise.resolve;
                });
            } catch (err) {
                console.error("[download]: " + err);
                failure++;
                return Promise.reject;
            /*if (Object.hasOwn(err,'message')) {
          reject(err.message)
        } else {
          reject(err);
        }*/ }
        })).then((results)=>{
            if (success == files.length) return resolve(true);
            else {
                (0, $5115409d5d67d81a$export$3879b24e8245693d)("[download]: " + success + " successful and " + failure + " unsuccessful downloads.");
                return reject("[download]: " + success + " successful and " + failure + " unsuccessful downloads.");
            }
        });
    });
}


function $7bc8d9a91d710879$export$2e2bcd8739ae039(files) {
    function cleanfiles() {
        var junk;
        while(files.length > 0)junk = files.pop();
        return true;
    }
    var sharing = false;
    return new Promise(async (resolve, reject)=>{
        /*if (navigator.canShare && navigator.canShare({files}) && sharing === false) {
      console.log('Sharing files is supported');
      const target = document.getElementById('modal-download');
      const shareButton = document.getElementById('dl-share');
      const dlButton = document.getElementById('dl-store');
      sharing = true
      shareButton.addEventListener('click', async () => {
        try{
          await navigator.share({title : "Open Files", text : "with your preferred app", files})
          .then((res) => {
            console.log("[download]: file saved.", res);
            showSuccess("Saved via fileshare.");
            return resolve(true);
            sharing = false
          })
          .catch((err) => {
            cleanfiles()
            showError(`The file could not be shared: ${err}`)
            console.error(`The file could not be shared: ${err}`);
            sharing = false
            return reject(err)
          })
          .finally(() => {closeModal(target); cleanfiles()})
        } catch (err) {
          showError(`The file could not be shared: ${err}`)
          console.error(`The file could not be shared: ${err}`);
          closeModal(target);
          sharing = false
          return reject(err);   
        }
      })
        
      dlButton.addEventListener('click', () => {
        downloadFiles(files)
        closeModal(target)
      })

      target.addEventListener('close', cleanfiles)

      openModal(target);
    } else {
      console.info('Sharing files is not supported');*/ //inspired from https://stackoverflow.com/a/18197341
        return (0, $f466f95b1741c789$export$2e2bcd8739ae039)(files).then(()=>{
            cleanfiles;
        });
    //}
    });
}





async function $3df8ae0cc8e721c9$export$4e8266427aee529d(name, title, deviceid, checksum) {
    if (await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).files.where('checksum').equals(checksum).count() == 0) return await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).files.add({
        name: name,
        title: title,
        deviceid: deviceid,
        exported: 0,
        added: Date.now(),
        checked: 0,
        checksum: checksum
    });
    else return Promise.reject("File with the same checksum already exists in IndexedDB");
}
async function $3df8ae0cc8e721c9$export$883cd28a25e244ea(fileid, Stat) {
    if (Stat.timestamp > 9999999999) Stat.timestamp = Stat.timestamp / 1000;
    return await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).stats.add({
        fileid: fileid,
        ...Stat
    });
}
async function $3df8ae0cc8e721c9$export$13cd421e467fd80b(fileid, units) {
    return await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).units.add({
        fileid: fileid,
        ...units
    });
}
async function $3df8ae0cc8e721c9$export$d5dd4b6bc80fac06(fileid, shots) {
    const FShots = shots.map((shot)=>({
            ...shot,
            fileid: fileid
        }));
    FShots.map((shot)=>{
        if (shot.timestamp > 9999999999) shot.timestamp = shot.timestamp / 1000;
    });
    return await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).shots.bulkAdd(FShots);
}
async function $3df8ae0cc8e721c9$export$dc1bdaad27d9e52c(Session) {
    return new Promise(async (resolve, reject)=>{
        await $3df8ae0cc8e721c9$export$4e8266427aee529d(Session.file.name, Session.file.title, Session.file.deviceid, Session.file.checksum).then(async (db_fileid)=>{
            Promise.all([
                Promise.resolve(db_fileid),
                $3df8ae0cc8e721c9$export$13cd421e467fd80b(db_fileid, {
                    velocity: Session.units.velocity,
                    distance: Session.units.distance,
                    energy: Session.units.energy,
                    weight: Session.units.weight
                }),
                $3df8ae0cc8e721c9$export$883cd28a25e244ea(db_fileid, {
                    shots_total: Session.stats.shots_total,
                    speed_avg: Session.stats.speed_avg,
                    speed_max: Session.stats.speed_max,
                    speed_min: Session.stats.speed_min,
                    speed_es: Session.stats.speed_es,
                    speed_sd: Session.stats.speed_sd,
                    projectile: Session.stats.projectile,
                    timestamp: Session.stats.timestamp,
                    timezone: 0
                }),
                $3df8ae0cc8e721c9$export$d5dd4b6bc80fac06(db_fileid, Session.shots)
            ]).then((values)=>{
                console.log("[json2db]: added " + Session.file.name);
                resolve(values[0]);
            });
        }).catch((err)=>{
            return reject(err);
        });
    });
}



var $jCgCX = parcelRequire("jCgCX");
//found  here https://github.com/christianliebel/paint/blob/6b4703cabfb818683c348c212651923a282d3aab/types/static.d.ts#L8
/*type UserChoice = Promise<{
  outcome: 'accepted' | 'dismissed';
  platform: string;
}>;

export interface BeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: UserChoice;
    prompt(): () => UserChoice
}
  
export interface LaunchParams {
readonly targetURL?: string | null;
readonly files: readonly FileSystemFileHandle[];
}

export type LaunchConsumer = (params: LaunchParams) => any;

export interface LaunchQueue {
setConsumer(consumer: LaunchConsumer): void;
}

declare global {
    interface Window {
        readonly launchQueue: LaunchQueue;
    }
  
    interface WindowEventMap {
        beforeinstallprompt: BeforeInstallPromptEvent;
        appinstalled: Event;
    }
}
*/ // units
const $b116a038e81e017a$export$fe555dc4c0065de2 = [
    'metric',
    'imperial'
];
var $b116a038e81e017a$export$23d539def18b903f = /*#__PURE__*/ function(Unit_Velocity) {
    Unit_Velocity["metric"] = "m/s";
    Unit_Velocity["imperial"] = "fps";
    return Unit_Velocity;
}({});
var $b116a038e81e017a$export$3d7d38d6d5f6fb0c = /*#__PURE__*/ function(Unit_Distance) {
    Unit_Distance["metric"] = "m";
    Unit_Distance["imperial"] = "yrds";
    return Unit_Distance;
}({});
var $b116a038e81e017a$export$ae5281324d9542b5 = /*#__PURE__*/ function(Unit_Energy) {
    Unit_Energy["metric"] = "j";
    Unit_Energy["imperial"] = "ft-lbs";
    return Unit_Energy;
}({});
var $b116a038e81e017a$export$853ff69f19ae8ad0 = /*#__PURE__*/ function(Unit_Weight) {
    Unit_Weight["metric"] = "grains (grs)";
    Unit_Weight["imperial"] = "gram (g)";
    return Unit_Weight;
}({});
const $b116a038e81e017a$export$8668e6b8e9a6e50f = [
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ant.fit"
];
const $b116a038e81e017a$export$4325568133855ee7 = [
    "csv",
    "xls",
    "xlsx",
    "fit"
];


function $f40838819d86b1f9$var$getLabradartemplate() {
    /*just replace the following valiables
    {DEVICEID}
    {SHOTS_TOTAL}
    {UNIT_VELOCITY}
    {UNIT_DISTANCE}
    {UNIT_ENERGY}
    {UNIT_WEIGHT}
    {SPEED_AVG}
    {SPEED_MAX}
    {SPEED_MIN}
    {SPEED_ES}
    {SPEED_SD}
    */ return `sep=;
Device ID;{DEVICEID};;

Series No;0001;;
Total number of shots;{SHOTS_TOTAL};;

Units velocity;{UNIT_VELOCITY};;
Units distances;{UNIT_DISTANCE};;
Units kinetic energy;{UNIT_ENERGY};;
Units weight;{UNIT_WEIGHT};;

Stats - Average;{SPEED_AVG};{UNIT_VELOCITY};
Stats - Highest;{SPEED_MAX};{UNIT_VELOCITY};
Stats - Lowest;{SPEED_MIN};{UNIT_VELOCITY};
Stats - Ext. Spread;{SPEED_ES};{UNIT_VELOCITY};
Stats - Std. Dev;{SPEED_SD};{UNIT_VELOCITY};

Shot ID;V0;Ke0;Proj. Weight;Date;Time\n`;
}
var $f40838819d86b1f9$export$2e2bcd8739ae039 = $f40838819d86b1f9$var$getLabradartemplate;



var $jCgCX = parcelRequire("jCgCX");
function $48ea2d31a22f42b4$export$fb7f86e7d6312a02(filename, title, timestamp = 1) {
    const filedate = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).unix(timestamp);
    const datestring = filedate.format("DD-MM-YYYY");
    const hourstring = filedate.format("HH:mm:ss");
    if (/.fit$/.test(filename)) return filename.replace(/\.fit$/, '-xeroconv.csv');
    if (title && title != filename) filename = title + ".csv";
    if (filename.includes(datestring) || filename.includes(datestring.split('-').reverse().join('-'))) return filename.replace(/\.csv$/, '-xeroconv.csv');
    else return filename.replace(/\.csv$/, '') + '_' + datestring + '_' + hourstring.replaceAll(':', '-') + '-xeroconv.csv';
}


function $cc375d08fa8a0041$var$jsonconverter(file, units, stats, shots) {
    let stream = (0, $f40838819d86b1f9$export$2e2bcd8739ae039)();
    stream = stream.replace("{DEVICEID}", file.deviceid ?? "useyournose-xeroconv");
    stream = stream.replace("{SHOTS_TOTAL}", shots.length.toString());
    stream = stream.replaceAll("{UNIT_VELOCITY}", (0, $b116a038e81e017a$export$23d539def18b903f)[(0, $b116a038e81e017a$export$fe555dc4c0065de2)[Number(units.velocity)]]);
    stream = stream.replaceAll("{UNIT_DISTANCE}", (0, $b116a038e81e017a$export$3d7d38d6d5f6fb0c)[(0, $b116a038e81e017a$export$fe555dc4c0065de2)[Number(units.distance)]]);
    stream = stream.replaceAll("{UNIT_ENERGY}", (0, $b116a038e81e017a$export$ae5281324d9542b5)[(0, $b116a038e81e017a$export$fe555dc4c0065de2)[Number(units.energy)]]);
    stream = stream.replaceAll("{UNIT_WEIGHT}", (0, $b116a038e81e017a$export$853ff69f19ae8ad0)[(0, $b116a038e81e017a$export$fe555dc4c0065de2)[Number(units.weight)]]);
    if (stats.speed_avg) stream = stream.replace("{SPEED_AVG}", stats.speed_avg.toFixed(3).toString());
    if (stats.speed_max) stream = stream.replace("{SPEED_MAX}", stats.speed_max.toString());
    if (stats.speed_min) stream = stream.replace("{SPEED_MIN}", stats.speed_min.toString());
    if (stats.speed_es) stream = stream.replace("{SPEED_ES}", stats.speed_es.toString());
    if (stats.speed_sd) stream = stream.replace("{SPEED_SD}", stats.speed_sd.toString());
    shots.forEach(function(item, index) {
        //Shot ID;V0;Ke0;Proj. Weight;Date;Time\n`
        stream += item.shotnumber.toString() + ";" + item.velocity.toString() + ";" + item.energy.toString() + ";" + (stats.projectile?.toString() ?? "") + ";" + (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).unix(item.timestamp).format('DD-MM-YYYY') + ";" + (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).unix(item.timestamp).format('HH:mm:ss') + ";\n";
    });
    return stream;
}
async function $cc375d08fa8a0041$export$e9b6167d11884409(Session) {
    return new Promise((resolve, reject)=>{
        const stream = $cc375d08fa8a0041$var$jsonconverter(Session.file, Session.units, Session.stats, Session.shots);
        const filename = (0, $48ea2d31a22f42b4$export$fb7f86e7d6312a02)(Session.file.name, Session.file.title, Session.stats.timestamp);
        const blob = new Blob([
            stream
        ], {
            type: "text/plain;charset=utf-8"
        });
        const file = new File([
            blob
        ], filename, {
            type: "text/plain"
        });
        return resolve(file);
    });
} /*
    stream = stream.replace("{DEVICEID}", "useyournose-xeroconv");
        stream = stream.replace("{SHOTS_TOTAL}",shots.data.length.toString().padStart(4, '0'));
        stream = stream.replaceAll("{UNIT_VELOCITY}",unit_velocity);
        stream = stream.replaceAll("{UNIT_DISTANCE}",unit_distance);
        stream = stream.replaceAll("{UNIT_ENERGY}",unit_energy);
        stream = stream.replaceAll("{UNIT_WEIGHT}",unit_weight);
        stream = stream.replace("{SPEED_AVG}",speed_avg.toFixed(3).toString());
        stream = stream.replace("{SPEED_MAX}",speed_max.toString());
        stream = stream.replace("{SPEED_MIN}",speed_min.toString());
        stream = stream.replace("{SPEED_ES}",nnf(stats.data[3][1]).toString());
        stream = stream.replace("{SPEED_SD}",nnf(stats.data[2][1]).toString());
    
        shots.data.forEach(function (item,index) { 
            stream+=item[0].toString().padStart(4, '0') + ";" + nnf(item[1]) +";" + nnf(item[3]) + ";" + nnf(stats.data[4][1]) + ";" + datestring +";" + item[5]  + ";\n";
        })
        console.log("[csv2labradar]: parsed " + title + " in " + (Date.now() - start) + " milliseconds.")
        const downloadstatus:Promise<string|boolean> = download(stream,filename)
        downloadstatus
        .then((value) => {resolve(value.toString())})
        .catch((error) => {console.error(error); reject(error as string); return;})

}*/ 



function $d6b2f3b3294bcb63$export$2e2bcd8739ae039(velocity_in_ms) {
    return velocity_in_ms * 0.3048;
}


function $e4e03b38f2f038df$export$2e2bcd8739ae039(velocity_in_fs) {
    return velocity_in_fs / 0.3048;
}


async function $6fff0b6879cf2be0$export$97ed27106c9caf4f() {
    const files = await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).files.toArray();
    const result = await Promise.all(files.map(async (file)=>{
        const stats = await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).stats.where('fileid').equals(file.id).first();
        file.stats = stats;
        if (file.stats.speed_es != file.stats.speed_max - file.stats.speed_min) {
            console.log("spread " + file.stats.speed_es.toString() + " not matching, updating.");
            file.stats.speed_es = Math.round((file.stats.speed_max - file.stats.speed_min) * 1000) / 1000;
        }
    }));
    return files;
/*
    const someBands = await Promise.all(bands.map(async band => {
        band.albums = await db.albums.where('id').anyOf(band.albumIds).toArray()
        return band
    }));
    */ }
async function $6fff0b6879cf2be0$export$b14df340dbcbe3f(fileid) {
    return (0, $8c181515f0907a6d$export$2e2bcd8739ae039).files.update(fileid, {
        exported: 1
    });
}
async function $6fff0b6879cf2be0$export$1512cdff1d871a63(fileid) {
    return (0, $8c181515f0907a6d$export$2e2bcd8739ae039).files.update(fileid, {
        checked: 1
    });
}
async function $6fff0b6879cf2be0$export$af41bf4625c84616(fileid) {
    return (0, $8c181515f0907a6d$export$2e2bcd8739ae039).files.update(fileid, {
        checked: 0
    });
}
function $6fff0b6879cf2be0$export$504e6df272de04fe(alpha = 1) {
    const fallback = 'rgba(128,128,128,1)';
    const root = getComputedStyle(document.documentElement);
    // Bulma registers an RGB tuple as --bulma-{name}-rgb (three numbers separated by commas)
    const rgbVar = root.getPropertyValue(`--bulma-primary-rgb`).trim();
    if (rgbVar) // rgbVar often looks like "34, 139, 230" so we can interpolate directly
    return `rgba(${rgbVar}, ${alpha})`;
    else return fallback;
}
function $6fff0b6879cf2be0$var$convvelo(velocity, su, tu) {
    if (su == tu) return velocity;
    if (su == true && tu == false) return (0, $d6b2f3b3294bcb63$export$2e2bcd8739ae039)(velocity);
    if (su == false && tu == true) return (0, $e4e03b38f2f038df$export$2e2bcd8739ae039)(velocity);
}
async function $6fff0b6879cf2be0$export$b7f56bfef011c9e7(targetunits = false) {
    let speedDatasets = [];
    const files = await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).files.where('checked').equals(1).toArray();
    const speeds = await Promise.all(files.map(async (file, ix, arr)=>{
        const shots = await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).shots.where('fileid').equals(file.id).toArray();
        const units = await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).units.where('fileid').equals(file.id).first();
        const velocities = shots.map((s)=>$6fff0b6879cf2be0$var$convvelo(s.velocity, units.velocity, targetunits));
        speedDatasets.push({
            label: file.id.toString() + ": " + file.name,
            values: velocities,
            //color: bulmaColorRGBA((ix + 1) /arr.length)
            // take che checksum, shorten it
            color: '#' + file.checksum.toUpperCase().substring(0, 6)
        });
    }));
    return speedDatasets;
} /*export function GetFile (fileid: number){
    db.files.get().toArray()
}

export function GetShots (fileid: number) {
    const query = db.query(`select shotnumber, velocity, energy, timestamp from shots where fileid = $fileid`)
    query.all({ $fileid: fileid}) as Shot[]
}

export function GetStats (fileid: number){
    const query = db.query(`select shots_total, speed_avg, speed_max, speed_min, speed_es, projectile, timestamp, timezone from stats where fileid = $fileid`)
    query.get({ $fileid: fileid}) as SessionStats
}


export function GetUnits (fileid: number){
    const query = db.query(`select velocity, distance, energy, weight from units where fileid = $fileid`)
    query.get({ $fileid: fileid}) as SessionUnits
}

export function GetSpeeds (fileid: number) {
    const query = db.query(`select velocity from shots where fileid = $fileid`)
    query.all({ $fileid: fileid}) as number[]
}

export function GetSpeedBins (fileid:number, binSize:number = 10) {
    const query = db.query(`
        SELECT CAST(velocity / $binSize AS INTEGER) AS bin, COUNT(*) AS cnt
        FROM shots
        WHERE fileid = $fileid
        GROUP BY bin
        ORDER BY bin
        `)
    query.all({$fileid: fileid, $binSize: binSize}) as any;
}*/ 


async function $502ca2c4c2e13c84$export$29482465873902ce() {
    const tbody = document.querySelector("#table tbody");
    tbody.innerHTML = "";
    // toArray returns a Promise with all matching objects
    const rows = await (0, $6fff0b6879cf2be0$export$97ed27106c9caf4f)();
    rows.forEach((elem)=>{
        const tr = document.createElement("tr");
        tr.dataset.fileid = elem.id.toString();
        const tdCb = document.createElement("td");
        const Cb = document.createElement("input");
        Cb.type = "checkbox";
        Cb.className = "checkbox";
        if (elem.checked == 1) Cb.checked = true;
        tdCb.appendChild(Cb);
        tr.appendChild(tdCb);
        const tdId = document.createElement("td");
        tdId.textContent = elem.id.toString() ?? "";
        tr.appendChild(tdId);
        /*const tdName = document.createElement("td");
        tdName.textContent = elem.name ?? "";
        tr.appendChild(tdName);*/ const tdTitle = document.createElement("td");
        tdTitle.textContent = elem.title ?? "";
        tr.appendChild(tdTitle);
        const tdShotCount = document.createElement("td");
        tdShotCount.textContent = elem.stats.shots_total.toString() ?? "";
        tr.appendChild(tdShotCount);
        const tdAvg = document.createElement("td");
        tdAvg.textContent = elem.stats.speed_avg.toFixed(1) ?? "";
        tr.appendChild(tdAvg);
        const tdSD = document.createElement("td");
        tdSD.textContent = elem.stats.speed_sd.toFixed(1) ?? "";
        tr.appendChild(tdSD);
        const tdES = document.createElement("td");
        tdES.textContent = elem.stats.speed_es.toFixed(1) ?? "";
        tr.appendChild(tdES);
        const tdProjectile = document.createElement("td");
        tdProjectile.textContent = elem.stats.projectile.toString() ?? "";
        tr.appendChild(tdProjectile);
        const tdCreated = document.createElement("td");
        tdCreated.textContent = new Date(elem.stats.timestamp * 1000).toLocaleString() ?? "";
        tr.appendChild(tdCreated);
        tbody.appendChild(tr);
        const tdDate = document.createElement("td");
        tdDate.textContent = new Date(elem.added).toLocaleString() ?? "";
        tr.appendChild(tdDate);
        tbody.appendChild(tr);
    });
}


async function $2f6a798bf6d12b9e$var$fileSystemHandleToArrayBuffer(fileHandle) {
    // Get the file from the file handle
    const file = await fileHandle.getFile();
    // Read the file as an ArrayBuffer
    const arrayBuffer = await file.arrayBuffer();
    return arrayBuffer;
}
function $2f6a798bf6d12b9e$var$fileToArrayBuffer(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = ()=>reject(reader.error);
        reader.readAsArrayBuffer(file);
    });
}
async function $2f6a798bf6d12b9e$export$4a2ae512745da1fe(files, indexedDBavailable) {
    return new Promise(async (resolve, reject)=>{
        var localstoragecount = Number(localStorage.total) || 0;
        var outfiles = [];
        var outpromises = [];
        async function handleFile(file) {
            var fileData = new ArrayBuffer();
            if (file instanceof FileSystemFileHandle) fileData = await $2f6a798bf6d12b9e$var$fileSystemHandleToArrayBuffer(file);
            else if (file instanceof File) fileData = await $2f6a798bf6d12b9e$var$fileToArrayBuffer(file);
            else return Promise.reject(false);
            if (/\.fit$/g.test(file.name)) return (0, $c91d22194aeccb79$export$2e2bcd8739ae039)(fileData, file.name).then(async (Session)=>{
                if (indexedDBavailable) {
                    const fid = await (0, $3df8ae0cc8e721c9$export$dc1bdaad27d9e52c)(Session).catch((err)=>(0, $5115409d5d67d81a$export$3879b24e8245693d)(err));
                }
                return (0, $cc375d08fa8a0041$export$e9b6167d11884409)(Session);
            }).then((blob)=>{
                outfiles.push(blob);
                return Promise.resolve(true);
            });
            else if (/\.csv$/g.test(file.name)) return (0, $6234c3dc946ef4db$export$2e2bcd8739ae039)(fileData, file.name).then(async (Session)=>{
                if (indexedDBavailable) {
                    const fid = await (0, $3df8ae0cc8e721c9$export$dc1bdaad27d9e52c)(Session).catch((err)=>(0, $5115409d5d67d81a$export$3879b24e8245693d)(err));
                }
                return (0, $cc375d08fa8a0041$export$e9b6167d11884409)(Session);
            }).then((blob)=>{
                outfiles.push(blob);
                return Promise.resolve(true);
            });
            else if (/\.xlsx?$/g.test(file.name)) return (0, $2db6704966f8bd16$export$2e2bcd8739ae039)(fileData, file.name).then((sessions)=>Promise.all(sessions.map(async (session)=>{
                    if (indexedDBavailable) {
                        const fid = await (0, $3df8ae0cc8e721c9$export$dc1bdaad27d9e52c)(session);
                    }
                    return (0, $cc375d08fa8a0041$export$e9b6167d11884409)(session);
                }))).then((blobs)=>outfiles = [
                    ...outfiles,
                    ...blobs
                ]).then(()=>{
                return Promise.resolve(true);
            });
            else {
                console.error('[handlefiles]: what is ' + file.name + ' doing here?');
                return Promise.reject(false);
            }
        }
        for (const file of files)outpromises.push(handleFile(file));
        await Promise.allSettled(outpromises).then((values)=>{
            values.filter((value)=>value.status == 'rejected').map((value)=>(0, $5115409d5d67d81a$export$3879b24e8245693d)(value.reason));
            if (outfiles.length === 0) console.log("nothing here");
            else (0, $7bc8d9a91d710879$export$2e2bcd8739ae039)(outfiles);
        }).then((result)=>{
            console.log(result);
            localstoragecount += outfiles.length;
            localStorage.total = localstoragecount;
            outpromises.length = 0;
            if (indexedDBavailable) (0, $502ca2c4c2e13c84$export$29482465873902ce)();
            console.log("total converted Files: ", localstoragecount);
            return resolve(true);
        }).catch((err)=>{
            console.warn(err);
            (0, $5115409d5d67d81a$export$3879b24e8245693d)(err);
            return reject(false);
        });
    });
}


// Functions to open and close a modal
function $f7be2c8e22c715f0$export$a7f6cffb6b8ba11c($el) {
    $el.classList.add('is-active');
}
function $f7be2c8e22c715f0$export$3f6fecd573f3fa48($el) {
    if ($el.id == 'modal-download') {
        var shareButton = document.getElementById('dl-share');
        shareButton.replaceWith(shareButton.cloneNode(true));
        var dlButton = document.getElementById('dl-store');
        dlButton.replaceWith(dlButton.cloneNode(true));
    }
    $el.classList.remove('is-active');
}
function $f7be2c8e22c715f0$export$8d2660641b6fb76a() {
    (document.querySelectorAll('.modal') || []).forEach(($modal)=>{
        $f7be2c8e22c715f0$export$3f6fecd573f3fa48($modal);
    });
}


/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $f8e092a558195575$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $f8e092a558195575$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $f8e092a558195575$export$bcc6e673dfa14d36(v) {
    return $f8e092a558195575$export$837ba5c449269406($f8e092a558195575$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $f8e092a558195575$export$869b26d4e1bbdb63(v) {
    return $f8e092a558195575$export$837ba5c449269406($f8e092a558195575$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $f8e092a558195575$export$ed9bd8dcaeba14f6(v) {
    return $f8e092a558195575$export$837ba5c449269406($f8e092a558195575$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $f8e092a558195575$export$dbf961a8d278dbef(v) {
    return $f8e092a558195575$export$837ba5c449269406($f8e092a558195575$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $f8e092a558195575$export$aa35ef1f24408ab9(v) {
    return $f8e092a558195575$export$837ba5c449269406($f8e092a558195575$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $f8e092a558195575$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $f8e092a558195575$var$hex = [
    ...'0123456789ABCDEF'
];
const $f8e092a558195575$var$h1 = (b)=>$f8e092a558195575$var$hex[b & 0xF];
const $f8e092a558195575$var$h2 = (b)=>$f8e092a558195575$var$hex[(b & 0xF0) >> 4] + $f8e092a558195575$var$hex[b & 0xF];
const $f8e092a558195575$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $f8e092a558195575$var$isShort = (v)=>$f8e092a558195575$var$eq(v.r) && $f8e092a558195575$var$eq(v.g) && $f8e092a558195575$var$eq(v.b) && $f8e092a558195575$var$eq(v.a);
function $f8e092a558195575$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $f8e092a558195575$var$map$1[str[1]] * 17,
            g: 255 & $f8e092a558195575$var$map$1[str[2]] * 17,
            b: 255 & $f8e092a558195575$var$map$1[str[3]] * 17,
            a: len === 5 ? $f8e092a558195575$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $f8e092a558195575$var$map$1[str[1]] << 4 | $f8e092a558195575$var$map$1[str[2]],
            g: $f8e092a558195575$var$map$1[str[3]] << 4 | $f8e092a558195575$var$map$1[str[4]],
            b: $f8e092a558195575$var$map$1[str[5]] << 4 | $f8e092a558195575$var$map$1[str[6]],
            a: len === 9 ? $f8e092a558195575$var$map$1[str[7]] << 4 | $f8e092a558195575$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $f8e092a558195575$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $f8e092a558195575$export$1b06654353ef9f67(v) {
    var f = $f8e092a558195575$var$isShort(v) ? $f8e092a558195575$var$h1 : $f8e092a558195575$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $f8e092a558195575$var$alpha(v.a, f) : undefined;
}
const $f8e092a558195575$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f8e092a558195575$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $f8e092a558195575$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $f8e092a558195575$var$hwb2rgbn(h, w, b) {
    const rgb = $f8e092a558195575$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $f8e092a558195575$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $f8e092a558195575$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $f8e092a558195575$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $f8e092a558195575$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($f8e092a558195575$export$ed9bd8dcaeba14f6);
}
function $f8e092a558195575$export$4c15bd42559b811d(h, s, l) {
    return $f8e092a558195575$var$calln($f8e092a558195575$var$hsl2rgbn, h, s, l);
}
function $f8e092a558195575$export$e2710022c70fc9ee(h, w, b) {
    return $f8e092a558195575$var$calln($f8e092a558195575$var$hwb2rgbn, h, w, b);
}
function $f8e092a558195575$export$b785a357c84e4a04(h, s, v) {
    return $f8e092a558195575$var$calln($f8e092a558195575$var$hsv2rgbn, h, s, v);
}
function $f8e092a558195575$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $f8e092a558195575$export$5e91288c399be4f9(str) {
    const m = $f8e092a558195575$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $f8e092a558195575$export$bcc6e673dfa14d36(+m[5]) : $f8e092a558195575$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $f8e092a558195575$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $f8e092a558195575$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $f8e092a558195575$export$b785a357c84e4a04(h, p1, p2);
    else v = $f8e092a558195575$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $f8e092a558195575$export$bb628a54ab399bc9(v, deg) {
    var h = $f8e092a558195575$export$b5ba70b240f8f7f(v);
    h[0] = $f8e092a558195575$var$hue(h[0] + deg);
    h = $f8e092a558195575$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $f8e092a558195575$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $f8e092a558195575$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $f8e092a558195575$export$aa35ef1f24408ab9(a[1]);
    const l = $f8e092a558195575$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$f8e092a558195575$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $f8e092a558195575$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $f8e092a558195575$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $f8e092a558195575$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($f8e092a558195575$var$names$1);
    const tkeys = Object.keys($f8e092a558195575$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $f8e092a558195575$var$map[k]);
        }
        k = parseInt($f8e092a558195575$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $f8e092a558195575$var$names;
function $f8e092a558195575$export$b2f06b640faad956(str) {
    if (!$f8e092a558195575$var$names) {
        $f8e092a558195575$var$names = $f8e092a558195575$var$unpack();
        $f8e092a558195575$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $f8e092a558195575$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $f8e092a558195575$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f8e092a558195575$export$91aedb20f296e541(str) {
    const m = $f8e092a558195575$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $f8e092a558195575$export$bcc6e673dfa14d36(v) : $f8e092a558195575$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $f8e092a558195575$export$bcc6e673dfa14d36(r) : $f8e092a558195575$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $f8e092a558195575$export$bcc6e673dfa14d36(g) : $f8e092a558195575$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $f8e092a558195575$export$bcc6e673dfa14d36(b) : $f8e092a558195575$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $f8e092a558195575$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$f8e092a558195575$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $f8e092a558195575$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $f8e092a558195575$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $f8e092a558195575$var$interpolate(rgb1, rgb2, t) {
    const r = $f8e092a558195575$var$from($f8e092a558195575$export$dbf961a8d278dbef(rgb1.r));
    const g = $f8e092a558195575$var$from($f8e092a558195575$export$dbf961a8d278dbef(rgb1.g));
    const b = $f8e092a558195575$var$from($f8e092a558195575$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $f8e092a558195575$export$ed9bd8dcaeba14f6($f8e092a558195575$var$to(r + t * ($f8e092a558195575$var$from($f8e092a558195575$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $f8e092a558195575$export$ed9bd8dcaeba14f6($f8e092a558195575$var$to(g + t * ($f8e092a558195575$var$from($f8e092a558195575$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $f8e092a558195575$export$ed9bd8dcaeba14f6($f8e092a558195575$var$to(b + t * ($f8e092a558195575$var$from($f8e092a558195575$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $f8e092a558195575$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $f8e092a558195575$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $f8e092a558195575$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $f8e092a558195575$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $f8e092a558195575$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $f8e092a558195575$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $f8e092a558195575$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $f8e092a558195575$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $f8e092a558195575$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $f8e092a558195575$export$91aedb20f296e541(str);
    return $f8e092a558195575$export$5e91288c399be4f9(str);
}
class $f8e092a558195575$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $f8e092a558195575$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $f8e092a558195575$var$fromObject(input);
        else if (type === 'string') v = $f8e092a558195575$export$625a38b961e8b5e9(input) || $f8e092a558195575$export$b2f06b640faad956(input) || $f8e092a558195575$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $f8e092a558195575$var$clone(this._rgb);
        if (v) v.a = $f8e092a558195575$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $f8e092a558195575$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $f8e092a558195575$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $f8e092a558195575$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $f8e092a558195575$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $f8e092a558195575$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $f8e092a558195575$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $f8e092a558195575$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $f8e092a558195575$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $f8e092a558195575$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $f8e092a558195575$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $f8e092a558195575$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $f8e092a558195575$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $f8e092a558195575$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $f8e092a558195575$export$2e2bcd8739ae039(input) {
    return new $f8e092a558195575$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $b60b13ac57f6e12e$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $b60b13ac57f6e12e$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $b60b13ac57f6e12e$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $b60b13ac57f6e12e$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $b60b13ac57f6e12e$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $b60b13ac57f6e12e$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $b60b13ac57f6e12e$export$c4ce752e73470fba(value, defaultValue) {
    return $b60b13ac57f6e12e$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $b60b13ac57f6e12e$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $b60b13ac57f6e12e$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $b60b13ac57f6e12e$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $b60b13ac57f6e12e$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $b60b13ac57f6e12e$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($b60b13ac57f6e12e$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($b60b13ac57f6e12e$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $b60b13ac57f6e12e$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $b60b13ac57f6e12e$export$667d3bf0c5f83305(source) {
    if ($b60b13ac57f6e12e$export$8b22cf2602fb60ce(source)) return source.map($b60b13ac57f6e12e$export$667d3bf0c5f83305);
    if ($b60b13ac57f6e12e$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $b60b13ac57f6e12e$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $b60b13ac57f6e12e$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $b60b13ac57f6e12e$export$317a3d46287192d8(key, target, source, options) {
    if (!$b60b13ac57f6e12e$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($b60b13ac57f6e12e$export$23f2a1d2818174ef(tval) && $b60b13ac57f6e12e$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $b60b13ac57f6e12e$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $b60b13ac57f6e12e$export$667d3bf0c5f83305(sval);
}
function $b60b13ac57f6e12e$export$efca4cbe5dd06740(target, source, options) {
    const sources = $b60b13ac57f6e12e$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$b60b13ac57f6e12e$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $b60b13ac57f6e12e$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$b60b13ac57f6e12e$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $b60b13ac57f6e12e$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $b60b13ac57f6e12e$export$efca4cbe5dd06740(target, source, {
        merger: $b60b13ac57f6e12e$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $b60b13ac57f6e12e$export$1ee57be6f6687d2c(key, target, source) {
    if (!$b60b13ac57f6e12e$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($b60b13ac57f6e12e$export$23f2a1d2818174ef(tval) && $b60b13ac57f6e12e$export$23f2a1d2818174ef(sval)) $b60b13ac57f6e12e$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $b60b13ac57f6e12e$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $b60b13ac57f6e12e$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $b60b13ac57f6e12e$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $b60b13ac57f6e12e$var$_getKeyResolver(key) {
    const keys = $b60b13ac57f6e12e$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $b60b13ac57f6e12e$export$2d1720544b23b823(obj, key) {
    const resolver = $b60b13ac57f6e12e$var$keyResolvers[key] || ($b60b13ac57f6e12e$var$keyResolvers[key] = $b60b13ac57f6e12e$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $b60b13ac57f6e12e$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $b60b13ac57f6e12e$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $b60b13ac57f6e12e$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $b60b13ac57f6e12e$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $b60b13ac57f6e12e$export$56c0d5a1e737357d = Math.PI;
const $b60b13ac57f6e12e$export$971d5caa766a69d7 = 2 * $b60b13ac57f6e12e$export$56c0d5a1e737357d;
const $b60b13ac57f6e12e$export$2ec5befb9e6c97d4 = $b60b13ac57f6e12e$export$971d5caa766a69d7 + $b60b13ac57f6e12e$export$56c0d5a1e737357d;
const $b60b13ac57f6e12e$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $b60b13ac57f6e12e$export$39c1cc7c062529d4 = $b60b13ac57f6e12e$export$56c0d5a1e737357d / 180;
const $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd = $b60b13ac57f6e12e$export$56c0d5a1e737357d / 2;
const $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88 = $b60b13ac57f6e12e$export$56c0d5a1e737357d / 4;
const $b60b13ac57f6e12e$export$c18d01048907ea92 = $b60b13ac57f6e12e$export$56c0d5a1e737357d * 2 / 3;
const $b60b13ac57f6e12e$export$faec65b429be379 = Math.log10;
const $b60b13ac57f6e12e$export$2408f22a0fab9ae5 = Math.sign;
function $b60b13ac57f6e12e$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $b60b13ac57f6e12e$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $b60b13ac57f6e12e$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($b60b13ac57f6e12e$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $b60b13ac57f6e12e$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $b60b13ac57f6e12e$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $b60b13ac57f6e12e$export$d141bba7fdc215a3(n) {
    return !$b60b13ac57f6e12e$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $b60b13ac57f6e12e$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $b60b13ac57f6e12e$export$625550452a3fa3ec(degrees) {
    return degrees * ($b60b13ac57f6e12e$export$56c0d5a1e737357d / 180);
}
function $b60b13ac57f6e12e$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $b60b13ac57f6e12e$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $b60b13ac57f6e12e$export$91477dc880baac21(x) {
    if (!$b60b13ac57f6e12e$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $b60b13ac57f6e12e$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $b60b13ac57f6e12e$export$56c0d5a1e737357d) angle += $b60b13ac57f6e12e$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $b60b13ac57f6e12e$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $b60b13ac57f6e12e$export$f074adc9fbd50943(a, b) {
    return (a - b + $b60b13ac57f6e12e$export$2ec5befb9e6c97d4) % $b60b13ac57f6e12e$export$971d5caa766a69d7 - $b60b13ac57f6e12e$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $b60b13ac57f6e12e$export$ab83b03e4111b1d0(a) {
    return (a % $b60b13ac57f6e12e$export$971d5caa766a69d7 + $b60b13ac57f6e12e$export$971d5caa766a69d7) % $b60b13ac57f6e12e$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $b60b13ac57f6e12e$export$ab83b03e4111b1d0(angle);
    const s = $b60b13ac57f6e12e$export$ab83b03e4111b1d0(start);
    const e = $b60b13ac57f6e12e$export$ab83b03e4111b1d0(end);
    const angleToStart = $b60b13ac57f6e12e$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $b60b13ac57f6e12e$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $b60b13ac57f6e12e$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $b60b13ac57f6e12e$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $b60b13ac57f6e12e$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $b60b13ac57f6e12e$export$71cec2538cb2c617(value) {
    return $b60b13ac57f6e12e$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $b60b13ac57f6e12e$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $b60b13ac57f6e12e$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $b60b13ac57f6e12e$export$ef35774e6d314e91 = (table, key, value, last)=>$b60b13ac57f6e12e$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $b60b13ac57f6e12e$export$ebd11618f299a286 = (table, key, value)=>$b60b13ac57f6e12e$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $b60b13ac57f6e12e$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $b60b13ac57f6e12e$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $b60b13ac57f6e12e$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $b60b13ac57f6e12e$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $b60b13ac57f6e12e$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $b60b13ac57f6e12e$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $b60b13ac57f6e12e$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $b60b13ac57f6e12e$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $b60b13ac57f6e12e$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $b60b13ac57f6e12e$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $b60b13ac57f6e12e$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $b60b13ac57f6e12e$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $b60b13ac57f6e12e$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $b60b13ac57f6e12e$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $b60b13ac57f6e12e$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $b60b13ac57f6e12e$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $b60b13ac57f6e12e$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($b60b13ac57f6e12e$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $b60b13ac57f6e12e$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$b60b13ac57f6e12e$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $b60b13ac57f6e12e$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($b60b13ac57f6e12e$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $b60b13ac57f6e12e$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$b60b13ac57f6e12e$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $b60b13ac57f6e12e$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $b60b13ac57f6e12e$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $b60b13ac57f6e12e$var$atEdge = (t)=>t === 0 || t === 1;
const $b60b13ac57f6e12e$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $b60b13ac57f6e12e$export$971d5caa766a69d7 / p));
const $b60b13ac57f6e12e$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $b60b13ac57f6e12e$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $b60b13ac57f6e12e$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($b60b13ac57f6e12e$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$b60b13ac57f6e12e$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$b60b13ac57f6e12e$var$atEdge(t) ? t : $b60b13ac57f6e12e$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$b60b13ac57f6e12e$var$atEdge(t) ? t : $b60b13ac57f6e12e$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $b60b13ac57f6e12e$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $b60b13ac57f6e12e$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $b60b13ac57f6e12e$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $b60b13ac57f6e12e$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $b60b13ac57f6e12e$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $b60b13ac57f6e12e$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $b60b13ac57f6e12e$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $b60b13ac57f6e12e$export$db3b6bfb95261072(value) {
    return $b60b13ac57f6e12e$export$738ab4df8bf92ae9(value) ? value : new (0, $f8e092a558195575$export$892596cec99bc70e)(value);
}
function $b60b13ac57f6e12e$export$d377dcb2b61d6c4e(value) {
    return $b60b13ac57f6e12e$export$738ab4df8bf92ae9(value) ? value : new (0, $f8e092a558195575$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $b60b13ac57f6e12e$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $b60b13ac57f6e12e$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $b60b13ac57f6e12e$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $b60b13ac57f6e12e$var$colors
        },
        numbers: {
            type: 'number',
            properties: $b60b13ac57f6e12e$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $b60b13ac57f6e12e$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $b60b13ac57f6e12e$var$intlCache = new Map();
function $b60b13ac57f6e12e$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $b60b13ac57f6e12e$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $b60b13ac57f6e12e$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $b60b13ac57f6e12e$export$ae1af26003f05816(num, locale, options) {
    return $b60b13ac57f6e12e$var$getNumberFormat(locale, options).format(num);
}
const $b60b13ac57f6e12e$var$formatters = {
    values (value) {
        return $b60b13ac57f6e12e$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $b60b13ac57f6e12e$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $b60b13ac57f6e12e$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $b60b13ac57f6e12e$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($b60b13ac57f6e12e$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $b60b13ac57f6e12e$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $b60b13ac57f6e12e$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $b60b13ac57f6e12e$export$9f4f30ee63539e24 = {
    formatters: $b60b13ac57f6e12e$var$formatters
};
function $b60b13ac57f6e12e$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $b60b13ac57f6e12e$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $b60b13ac57f6e12e$export$6559d589eb85fbb6 = Object.create(null);
const $b60b13ac57f6e12e$export$2e2af4578d910ddf = Object.create(null);
function $b60b13ac57f6e12e$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $b60b13ac57f6e12e$var$set(root, scope, values) {
    if (typeof scope === 'string') return $b60b13ac57f6e12e$export$efca4cbe5dd06740($b60b13ac57f6e12e$var$getScope$1(root, scope), values);
    return $b60b13ac57f6e12e$export$efca4cbe5dd06740($b60b13ac57f6e12e$var$getScope$1(root, ''), scope);
}
class $b60b13ac57f6e12e$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$b60b13ac57f6e12e$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$b60b13ac57f6e12e$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$b60b13ac57f6e12e$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $b60b13ac57f6e12e$var$set(this, scope, values);
    }
    get(scope) {
        return $b60b13ac57f6e12e$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $b60b13ac57f6e12e$var$set($b60b13ac57f6e12e$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $b60b13ac57f6e12e$var$set($b60b13ac57f6e12e$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $b60b13ac57f6e12e$var$getScope$1(this, scope);
        const targetScopeObject = $b60b13ac57f6e12e$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($b60b13ac57f6e12e$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $b60b13ac57f6e12e$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $b60b13ac57f6e12e$export$4368d992c4eafac0 = /* #__PURE__ */ new $b60b13ac57f6e12e$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $b60b13ac57f6e12e$var$applyAnimationsDefaults,
    $b60b13ac57f6e12e$var$applyLayoutsDefaults,
    $b60b13ac57f6e12e$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $b60b13ac57f6e12e$export$e171bab687b50e0(font) {
    if (!font || $b60b13ac57f6e12e$export$342063e11d6c3cad(font.size) || $b60b13ac57f6e12e$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $b60b13ac57f6e12e$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$b60b13ac57f6e12e$export$8b22cf2602fb60ce(thing)) longest = $b60b13ac57f6e12e$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($b60b13ac57f6e12e$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$b60b13ac57f6e12e$export$8b22cf2602fb60ce(nestedThing)) longest = $b60b13ac57f6e12e$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $b60b13ac57f6e12e$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $b60b13ac57f6e12e$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $b60b13ac57f6e12e$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $b60b13ac57f6e12e$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $b60b13ac57f6e12e$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $b60b13ac57f6e12e$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $b60b13ac57f6e12e$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $b60b13ac57f6e12e$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $b60b13ac57f6e12e$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $b60b13ac57f6e12e$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $b60b13ac57f6e12e$export$56c0d5a1e737357d, rad - $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd, rad + $b60b13ac57f6e12e$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $b60b13ac57f6e12e$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $b60b13ac57f6e12e$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $b60b13ac57f6e12e$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $b60b13ac57f6e12e$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $b60b13ac57f6e12e$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$b60b13ac57f6e12e$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $b60b13ac57f6e12e$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $b60b13ac57f6e12e$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $b60b13ac57f6e12e$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $b60b13ac57f6e12e$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $b60b13ac57f6e12e$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $b60b13ac57f6e12e$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$b60b13ac57f6e12e$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $b60b13ac57f6e12e$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $b60b13ac57f6e12e$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $b60b13ac57f6e12e$export$56c0d5a1e737357d, $b60b13ac57f6e12e$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $b60b13ac57f6e12e$export$56c0d5a1e737357d, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $b60b13ac57f6e12e$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $b60b13ac57f6e12e$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $b60b13ac57f6e12e$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($b60b13ac57f6e12e$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $b60b13ac57f6e12e$var$numberOrZero = (v)=>+v || 0;
function $b60b13ac57f6e12e$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $b60b13ac57f6e12e$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $b60b13ac57f6e12e$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$b60b13ac57f6e12e$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $b60b13ac57f6e12e$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $b60b13ac57f6e12e$export$9fa96a7d116ea3ce(value) {
    return $b60b13ac57f6e12e$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $b60b13ac57f6e12e$export$28f7fcd39efa255(value) {
    return $b60b13ac57f6e12e$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca(value) {
    const obj = $b60b13ac57f6e12e$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $b60b13ac57f6e12e$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $b60b13ac57f6e12e$export$4368d992c4eafac0.font;
    let size = $b60b13ac57f6e12e$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $b60b13ac57f6e12e$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($b60b13ac57f6e12e$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $b60b13ac57f6e12e$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $b60b13ac57f6e12e$export$d29e374196577086($b60b13ac57f6e12e$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $b60b13ac57f6e12e$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $b60b13ac57f6e12e$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $b60b13ac57f6e12e$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $b60b13ac57f6e12e$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $b60b13ac57f6e12e$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $b60b13ac57f6e12e$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $b60b13ac57f6e12e$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $b60b13ac57f6e12e$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $b60b13ac57f6e12e$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$b60b13ac57f6e12e$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $b60b13ac57f6e12e$var$_cached(target, prop, ()=>$b60b13ac57f6e12e$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $b60b13ac57f6e12e$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $b60b13ac57f6e12e$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $b60b13ac57f6e12e$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $b60b13ac57f6e12e$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$b60b13ac57f6e12e$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$b60b13ac57f6e12e$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $b60b13ac57f6e12e$var$_cached(target, prop, ()=>$b60b13ac57f6e12e$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $b60b13ac57f6e12e$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $b60b13ac57f6e12e$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $b60b13ac57f6e12e$var$readKey = (prefix, name)=>prefix ? prefix + $b60b13ac57f6e12e$export$a8550f7dbe79f93a(name) : name;
const $b60b13ac57f6e12e$var$needsSubResolver = (prop, value)=>$b60b13ac57f6e12e$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $b60b13ac57f6e12e$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $b60b13ac57f6e12e$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($b60b13ac57f6e12e$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $b60b13ac57f6e12e$var$_resolveScriptable(prop, value, target, receiver);
    if ($b60b13ac57f6e12e$export$8b22cf2602fb60ce(value) && value.length) value = $b60b13ac57f6e12e$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($b60b13ac57f6e12e$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $b60b13ac57f6e12e$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $b60b13ac57f6e12e$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($b60b13ac57f6e12e$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $b60b13ac57f6e12e$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $b60b13ac57f6e12e$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($b60b13ac57f6e12e$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $b60b13ac57f6e12e$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($b60b13ac57f6e12e$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $b60b13ac57f6e12e$var$resolveFallback(fallback, prop, value) {
    return $b60b13ac57f6e12e$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $b60b13ac57f6e12e$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $b60b13ac57f6e12e$export$2d1720544b23b823(parent, key) : undefined;
function $b60b13ac57f6e12e$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $b60b13ac57f6e12e$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $b60b13ac57f6e12e$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $b60b13ac57f6e12e$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $b60b13ac57f6e12e$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $b60b13ac57f6e12e$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $b60b13ac57f6e12e$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $b60b13ac57f6e12e$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$b60b13ac57f6e12e$var$subGetTarget(resolver, prop, value));
}
function $b60b13ac57f6e12e$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $b60b13ac57f6e12e$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $b60b13ac57f6e12e$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($b60b13ac57f6e12e$export$8b22cf2602fb60ce(target) && $b60b13ac57f6e12e$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $b60b13ac57f6e12e$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $b60b13ac57f6e12e$var$_resolve($b60b13ac57f6e12e$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $b60b13ac57f6e12e$var$needsSubResolver(prop, value) ? $b60b13ac57f6e12e$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $b60b13ac57f6e12e$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $b60b13ac57f6e12e$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $b60b13ac57f6e12e$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $b60b13ac57f6e12e$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $b60b13ac57f6e12e$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($b60b13ac57f6e12e$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $b60b13ac57f6e12e$var$EPSILON = Number.EPSILON || 1e-14;
const $b60b13ac57f6e12e$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $b60b13ac57f6e12e$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $b60b13ac57f6e12e$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $b60b13ac57f6e12e$export$cf2f7c5792f80b46(current, previous);
    const d12 = $b60b13ac57f6e12e$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $b60b13ac57f6e12e$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $b60b13ac57f6e12e$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $b60b13ac57f6e12e$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($b60b13ac57f6e12e$export$23ebac1979863676(deltaK[i], 0, $b60b13ac57f6e12e$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $b60b13ac57f6e12e$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $b60b13ac57f6e12e$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $b60b13ac57f6e12e$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $b60b13ac57f6e12e$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $b60b13ac57f6e12e$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $b60b13ac57f6e12e$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $b60b13ac57f6e12e$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $b60b13ac57f6e12e$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $b60b13ac57f6e12e$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $b60b13ac57f6e12e$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $b60b13ac57f6e12e$var$monotoneAdjust(points, deltaK, mK);
    $b60b13ac57f6e12e$var$monotoneCompute(points, mK, indexAxis);
}
function $b60b13ac57f6e12e$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $b60b13ac57f6e12e$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $b60b13ac57f6e12e$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $b60b13ac57f6e12e$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $b60b13ac57f6e12e$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $b60b13ac57f6e12e$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $b60b13ac57f6e12e$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $b60b13ac57f6e12e$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $b60b13ac57f6e12e$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $b60b13ac57f6e12e$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $b60b13ac57f6e12e$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $b60b13ac57f6e12e$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $b60b13ac57f6e12e$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $b60b13ac57f6e12e$export$fef3dfd9bad05307(el, property) {
    return $b60b13ac57f6e12e$var$getComputedStyle(el).getPropertyValue(property);
}
const $b60b13ac57f6e12e$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $b60b13ac57f6e12e$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $b60b13ac57f6e12e$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $b60b13ac57f6e12e$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $b60b13ac57f6e12e$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($b60b13ac57f6e12e$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $b60b13ac57f6e12e$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $b60b13ac57f6e12e$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $b60b13ac57f6e12e$var$getPositionedStyle(style, 'padding');
    const borders = $b60b13ac57f6e12e$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $b60b13ac57f6e12e$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $b60b13ac57f6e12e$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $b60b13ac57f6e12e$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $b60b13ac57f6e12e$var$getComputedStyle(container);
            const containerBorder = $b60b13ac57f6e12e$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $b60b13ac57f6e12e$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $b60b13ac57f6e12e$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $b60b13ac57f6e12e$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $b60b13ac57f6e12e$export$53c86fa97d611818,
        maxHeight: maxHeight || $b60b13ac57f6e12e$export$53c86fa97d611818
    };
}
const $b60b13ac57f6e12e$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $b60b13ac57f6e12e$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $b60b13ac57f6e12e$var$getComputedStyle(canvas);
    const margins = $b60b13ac57f6e12e$var$getPositionedStyle(style, 'margin');
    const maxWidth = $b60b13ac57f6e12e$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $b60b13ac57f6e12e$export$53c86fa97d611818;
    const maxHeight = $b60b13ac57f6e12e$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $b60b13ac57f6e12e$export$53c86fa97d611818;
    const containerSize = $b60b13ac57f6e12e$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $b60b13ac57f6e12e$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $b60b13ac57f6e12e$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $b60b13ac57f6e12e$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $b60b13ac57f6e12e$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $b60b13ac57f6e12e$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $b60b13ac57f6e12e$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $b60b13ac57f6e12e$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $b60b13ac57f6e12e$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($b60b13ac57f6e12e$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $b60b13ac57f6e12e$export$b4171a6734a65d42(element, property) {
    const value = $b60b13ac57f6e12e$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $b60b13ac57f6e12e$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $b60b13ac57f6e12e$export$6554612db691658e(p1, cp1, t);
    const b = $b60b13ac57f6e12e$export$6554612db691658e(cp1, cp2, t);
    const c = $b60b13ac57f6e12e$export$6554612db691658e(cp2, p2, t);
    const d = $b60b13ac57f6e12e$export$6554612db691658e(a, b, t);
    const e = $b60b13ac57f6e12e$export$6554612db691658e(b, c, t);
    return $b60b13ac57f6e12e$export$6554612db691658e(d, e, t);
}
const $b60b13ac57f6e12e$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $b60b13ac57f6e12e$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $b60b13ac57f6e12e$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $b60b13ac57f6e12e$var$getRightToLeftAdapter(rectX, width) : $b60b13ac57f6e12e$var$getLeftToRightAdapter();
}
function $b60b13ac57f6e12e$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $b60b13ac57f6e12e$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $b60b13ac57f6e12e$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $b60b13ac57f6e12e$export$ffb5f4729a158638,
        compare: $b60b13ac57f6e12e$export$f074adc9fbd50943,
        normalize: $b60b13ac57f6e12e$export$ab83b03e4111b1d0
    };
    return {
        between: $b60b13ac57f6e12e$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $b60b13ac57f6e12e$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $b60b13ac57f6e12e$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $b60b13ac57f6e12e$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $b60b13ac57f6e12e$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $b60b13ac57f6e12e$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $b60b13ac57f6e12e$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($b60b13ac57f6e12e$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($b60b13ac57f6e12e$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $b60b13ac57f6e12e$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $b60b13ac57f6e12e$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $b60b13ac57f6e12e$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $b60b13ac57f6e12e$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $b60b13ac57f6e12e$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $b60b13ac57f6e12e$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $b60b13ac57f6e12e$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $b60b13ac57f6e12e$var$splitByStyles(line, $b60b13ac57f6e12e$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $b60b13ac57f6e12e$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $b60b13ac57f6e12e$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $b60b13ac57f6e12e$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $b60b13ac57f6e12e$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $b60b13ac57f6e12e$var$readStyle(segmentOptions.setContext($b60b13ac57f6e12e$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($b60b13ac57f6e12e$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $b60b13ac57f6e12e$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $b60b13ac57f6e12e$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$b60b13ac57f6e12e$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $b60b13ac57f6e12e$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $b60b13ac57f6e12e$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $b60b13ac57f6e12e$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $b60b13ac57f6e12e$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $b60b13ac57f6e12e$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $b60b13ac57f6e12e$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $b60b13ac57f6e12e$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $b60b13ac57f6e12e$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $8ad0206f64f59332$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $b60b13ac57f6e12e$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $8ad0206f64f59332$export$a424a0aa8f687495 = /* #__PURE__ */ new $8ad0206f64f59332$var$Animator();
const $8ad0206f64f59332$var$transparent = 'transparent';
const $8ad0206f64f59332$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $b60b13ac57f6e12e$export$db3b6bfb95261072)(from || $8ad0206f64f59332$var$transparent);
        const c1 = c0.valid && (0, $b60b13ac57f6e12e$export$db3b6bfb95261072)(to || $8ad0206f64f59332$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $8ad0206f64f59332$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $b60b13ac57f6e12e$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $b60b13ac57f6e12e$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $8ad0206f64f59332$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $b60b13ac57f6e12e$export$f1e1789686576879)[cfg.easing] || (0, $b60b13ac57f6e12e$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $b60b13ac57f6e12e$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $b60b13ac57f6e12e$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $8ad0206f64f59332$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $b60b13ac57f6e12e$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $8ad0206f64f59332$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $8ad0206f64f59332$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $8ad0206f64f59332$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $8ad0206f64f59332$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $8ad0206f64f59332$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $8ad0206f64f59332$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $8ad0206f64f59332$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $8ad0206f64f59332$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $8ad0206f64f59332$var$scaleClip(xScale, allowedOverflow);
    const y = $8ad0206f64f59332$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $8ad0206f64f59332$var$toClip(value) {
    let t, r, b, l;
    if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $8ad0206f64f59332$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $8ad0206f64f59332$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(value) === (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $8ad0206f64f59332$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $8ad0206f64f59332$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $8ad0206f64f59332$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $8ad0206f64f59332$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $8ad0206f64f59332$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $8ad0206f64f59332$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $8ad0206f64f59332$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $8ad0206f64f59332$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $8ad0206f64f59332$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $8ad0206f64f59332$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $8ad0206f64f59332$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $8ad0206f64f59332$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $8ad0206f64f59332$var$createDatasetContext(parent, index) {
    return (0, $b60b13ac57f6e12e$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $8ad0206f64f59332$var$createDataContext(parent, index, element) {
    return (0, $b60b13ac57f6e12e$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $8ad0206f64f59332$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $8ad0206f64f59332$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $8ad0206f64f59332$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $8ad0206f64f59332$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $8ad0206f64f59332$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $8ad0206f64f59332$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $8ad0206f64f59332$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $8ad0206f64f59332$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(dataset.xAxisID, $8ad0206f64f59332$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(dataset.yAxisID, $8ad0206f64f59332$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(dataset.rAxisID, $8ad0206f64f59332$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $b60b13ac57f6e12e$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $8ad0206f64f59332$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $8ad0206f64f59332$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $b60b13ac57f6e12e$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $8ad0206f64f59332$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $b60b13ac57f6e12e$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $8ad0206f64f59332$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $8ad0206f64f59332$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $8ad0206f64f59332$var$updateStacks(this, meta._parsed);
            meta._stacked = $8ad0206f64f59332$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $8ad0206f64f59332$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $b60b13ac57f6e12e$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $b60b13ac57f6e12e$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $8ad0206f64f59332$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $8ad0206f64f59332$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $8ad0206f64f59332$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $8ad0206f64f59332$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $8ad0206f64f59332$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $8ad0206f64f59332$var$toClip((0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(this.options.clip, $8ad0206f64f59332$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $8ad0206f64f59332$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $8ad0206f64f59332$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $b60b13ac57f6e12e$export$dda1d9f60106f0e9)(index);
        if (cached) return $8ad0206f64f59332$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $b60b13ac57f6e12e$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($8ad0206f64f59332$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $8ad0206f64f59332$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $8ad0206f64f59332$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($8ad0206f64f59332$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$8ad0206f64f59332$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $8ad0206f64f59332$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $8ad0206f64f59332$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $b60b13ac57f6e12e$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $8ad0206f64f59332$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $8ad0206f64f59332$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $b60b13ac57f6e12e$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $8ad0206f64f59332$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $8ad0206f64f59332$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $8ad0206f64f59332$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $8ad0206f64f59332$var$parseValue(entry, item, vScale, i) {
    if ((0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(entry)) $8ad0206f64f59332$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $8ad0206f64f59332$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($8ad0206f64f59332$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $8ad0206f64f59332$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $8ad0206f64f59332$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $8ad0206f64f59332$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $8ad0206f64f59332$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $8ad0206f64f59332$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$8ad0206f64f59332$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$8ad0206f64f59332$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $8ad0206f64f59332$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $8ad0206f64f59332$var$swap(edge, a, b);
        edge = $8ad0206f64f59332$var$startEnd(edge, b, a);
    } else edge = $8ad0206f64f59332$var$startEnd(edge, a, b);
    return edge;
}
function $8ad0206f64f59332$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $8ad0206f64f59332$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $8ad0206f64f59332$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $8ad0206f64f59332$export$e97d5dc64e999004 extends $8ad0206f64f59332$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $8ad0206f64f59332$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $8ad0206f64f59332$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $b60b13ac57f6e12e$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($8ad0206f64f59332$var$parseValue((0, $b60b13ac57f6e12e$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $8ad0206f64f59332$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $8ad0206f64f59332$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $8ad0206f64f59332$var$setBorderSkipped(properties, options, stack, index);
            $8ad0206f64f59332$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $8ad0206f64f59332$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $8ad0206f64f59332$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(value) !== (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $8ad0206f64f59332$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $8ad0206f64f59332$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $8ad0206f64f59332$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $8ad0206f64f59332$export$19b5c4773f17abe extends $8ad0206f64f59332$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $8ad0206f64f59332$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $b60b13ac57f6e12e$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $b60b13ac57f6e12e$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $b60b13ac57f6e12e$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $b60b13ac57f6e12e$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) + (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $8ad0206f64f59332$export$e04603e7d8b77172 extends $8ad0206f64f59332$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $b60b13ac57f6e12e$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $b60b13ac57f6e12e$export$971d5caa766a69d7);
        let max = -(0, $b60b13ac57f6e12e$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $b60b13ac57f6e12e$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $8ad0206f64f59332$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $b60b13ac57f6e12e$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $b60b13ac57f6e12e$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $b60b13ac57f6e12e$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $b60b13ac57f6e12e$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $8ad0206f64f59332$export$3c9b5d28c11cbfd0 extends $8ad0206f64f59332$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $b60b13ac57f6e12e$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $b60b13ac57f6e12e$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $b60b13ac57f6e12e$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $8ad0206f64f59332$export$2a270b3a0d973c85 extends $8ad0206f64f59332$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $b60b13ac57f6e12e$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $b60b13ac57f6e12e$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $8ad0206f64f59332$export$b21a3f1286706191 extends $8ad0206f64f59332$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $8ad0206f64f59332$export$48dbc6ac651bf8be extends $8ad0206f64f59332$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $b60b13ac57f6e12e$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $8ad0206f64f59332$export$b2f2bae6713db87 extends $8ad0206f64f59332$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $b60b13ac57f6e12e$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $b60b13ac57f6e12e$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $b60b13ac57f6e12e$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $8ad0206f64f59332$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $8ad0206f64f59332$export$e97d5dc64e999004,
    BubbleController: $8ad0206f64f59332$export$19b5c4773f17abe,
    DoughnutController: $8ad0206f64f59332$export$e04603e7d8b77172,
    LineController: $8ad0206f64f59332$export$3c9b5d28c11cbfd0,
    PieController: $8ad0206f64f59332$export$b21a3f1286706191,
    PolarAreaController: $8ad0206f64f59332$export$2a270b3a0d973c85,
    RadarController: $8ad0206f64f59332$export$48dbc6ac651bf8be,
    ScatterController: $8ad0206f64f59332$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $8ad0206f64f59332$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $8ad0206f64f59332$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($8ad0206f64f59332$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $8ad0206f64f59332$var$abstract();
    }
    parse() {
        return $8ad0206f64f59332$var$abstract();
    }
    format() {
        return $8ad0206f64f59332$var$abstract();
    }
    add() {
        return $8ad0206f64f59332$var$abstract();
    }
    diff() {
        return $8ad0206f64f59332$var$abstract();
    }
    startOf() {
        return $8ad0206f64f59332$var$abstract();
    }
    endOf() {
        return $8ad0206f64f59332$var$abstract();
    }
}
var $8ad0206f64f59332$export$f32766ea09ec8bc4 = {
    _date: $8ad0206f64f59332$var$DateAdapterBase
};
function $8ad0206f64f59332$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $b60b13ac57f6e12e$export$ebd11618f299a286) : (0, $b60b13ac57f6e12e$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $8ad0206f64f59332$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $8ad0206f64f59332$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $8ad0206f64f59332$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $8ad0206f64f59332$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $b60b13ac57f6e12e$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $8ad0206f64f59332$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $8ad0206f64f59332$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $b60b13ac57f6e12e$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $b60b13ac57f6e12e$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $8ad0206f64f59332$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $8ad0206f64f59332$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $8ad0206f64f59332$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $8ad0206f64f59332$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $8ad0206f64f59332$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $8ad0206f64f59332$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $8ad0206f64f59332$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $8ad0206f64f59332$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $8ad0206f64f59332$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $8ad0206f64f59332$export$a13296960cae0384 = {
    evaluateInteractionItems: $8ad0206f64f59332$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $b60b13ac57f6e12e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $8ad0206f64f59332$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $8ad0206f64f59332$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $b60b13ac57f6e12e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $8ad0206f64f59332$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $8ad0206f64f59332$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $b60b13ac57f6e12e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $8ad0206f64f59332$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $b60b13ac57f6e12e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $8ad0206f64f59332$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $b60b13ac57f6e12e$export$df995fae86a55f06)(e, chart);
            return $8ad0206f64f59332$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $b60b13ac57f6e12e$export$df995fae86a55f06)(e, chart);
            return $8ad0206f64f59332$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $8ad0206f64f59332$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $8ad0206f64f59332$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $8ad0206f64f59332$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$8ad0206f64f59332$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $8ad0206f64f59332$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $8ad0206f64f59332$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $8ad0206f64f59332$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$8ad0206f64f59332$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $8ad0206f64f59332$var$setLayoutDims(layouts, params) {
    const stacks = $8ad0206f64f59332$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $8ad0206f64f59332$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $8ad0206f64f59332$var$wrapBoxes(boxes);
    const fullSize = $8ad0206f64f59332$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $8ad0206f64f59332$var$sortByWeight($8ad0206f64f59332$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $8ad0206f64f59332$var$sortByWeight($8ad0206f64f59332$var$filterByPosition(layoutBoxes, 'right'));
    const top = $8ad0206f64f59332$var$sortByWeight($8ad0206f64f59332$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $8ad0206f64f59332$var$sortByWeight($8ad0206f64f59332$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $8ad0206f64f59332$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $8ad0206f64f59332$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $8ad0206f64f59332$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $8ad0206f64f59332$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $8ad0206f64f59332$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $8ad0206f64f59332$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $8ad0206f64f59332$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $8ad0206f64f59332$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $8ad0206f64f59332$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $8ad0206f64f59332$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $8ad0206f64f59332$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $8ad0206f64f59332$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $8ad0206f64f59332$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $8ad0206f64f59332$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $8ad0206f64f59332$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $8ad0206f64f59332$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $8ad0206f64f59332$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $b60b13ac57f6e12e$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $8ad0206f64f59332$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $8ad0206f64f59332$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $b60b13ac57f6e12e$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $8ad0206f64f59332$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $8ad0206f64f59332$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $8ad0206f64f59332$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $8ad0206f64f59332$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $8ad0206f64f59332$var$updateMaxPadding(maxPadding, (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $8ad0206f64f59332$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $8ad0206f64f59332$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $8ad0206f64f59332$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($8ad0206f64f59332$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $8ad0206f64f59332$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $8ad0206f64f59332$var$handleMaxPadding(chartArea);
        $8ad0206f64f59332$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $8ad0206f64f59332$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $8ad0206f64f59332$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $8ad0206f64f59332$export$a40a96b24b46cf35 extends $8ad0206f64f59332$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $8ad0206f64f59332$var$EXPANDO_KEY = '$chartjs';
const $8ad0206f64f59332$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $8ad0206f64f59332$var$isNullOrEmpty = (value)=>value === null || value === '';
function $8ad0206f64f59332$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$8ad0206f64f59332$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($8ad0206f64f59332$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $b60b13ac57f6e12e$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($8ad0206f64f59332$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $b60b13ac57f6e12e$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $8ad0206f64f59332$var$eventListenerOptions = (0, $b60b13ac57f6e12e$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $8ad0206f64f59332$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $8ad0206f64f59332$var$eventListenerOptions);
}
function $8ad0206f64f59332$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $8ad0206f64f59332$var$eventListenerOptions);
}
function $8ad0206f64f59332$var$fromNativeEvent(event, chart) {
    const type = $8ad0206f64f59332$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $b60b13ac57f6e12e$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $8ad0206f64f59332$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $8ad0206f64f59332$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $8ad0206f64f59332$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$8ad0206f64f59332$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $8ad0206f64f59332$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $8ad0206f64f59332$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$8ad0206f64f59332$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $8ad0206f64f59332$var$drpListeningCharts = new Map();
let $8ad0206f64f59332$var$oldDevicePixelRatio = 0;
function $8ad0206f64f59332$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $8ad0206f64f59332$var$oldDevicePixelRatio) return;
    $8ad0206f64f59332$var$oldDevicePixelRatio = dpr;
    $8ad0206f64f59332$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $8ad0206f64f59332$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$8ad0206f64f59332$var$drpListeningCharts.size) window.addEventListener('resize', $8ad0206f64f59332$var$onWindowResize);
    $8ad0206f64f59332$var$drpListeningCharts.set(chart, resize);
}
function $8ad0206f64f59332$var$unlistenDevicePixelRatioChanges(chart) {
    $8ad0206f64f59332$var$drpListeningCharts.delete(chart);
    if (!$8ad0206f64f59332$var$drpListeningCharts.size) window.removeEventListener('resize', $8ad0206f64f59332$var$onWindowResize);
}
function $8ad0206f64f59332$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $b60b13ac57f6e12e$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $b60b13ac57f6e12e$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $8ad0206f64f59332$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $8ad0206f64f59332$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $8ad0206f64f59332$var$unlistenDevicePixelRatioChanges(chart);
}
function $8ad0206f64f59332$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $b60b13ac57f6e12e$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($8ad0206f64f59332$var$fromNativeEvent(event, chart));
    }, chart);
    $8ad0206f64f59332$var$addListener(canvas, type, proxy);
    return proxy;
}
class $8ad0206f64f59332$export$f02da7f882cf6b2e extends $8ad0206f64f59332$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $8ad0206f64f59332$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$8ad0206f64f59332$var$EXPANDO_KEY]) return false;
        const initial = canvas[$8ad0206f64f59332$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$8ad0206f64f59332$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $8ad0206f64f59332$var$createAttachObserver,
            detach: $8ad0206f64f59332$var$createDetachObserver,
            resize: $8ad0206f64f59332$var$createResizeObserver
        };
        const handler = handlers[type] || $8ad0206f64f59332$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $8ad0206f64f59332$var$releaseObserver,
            detach: $8ad0206f64f59332$var$releaseObserver,
            resize: $8ad0206f64f59332$var$releaseObserver
        };
        const handler = handlers[type] || $8ad0206f64f59332$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $b60b13ac57f6e12e$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $b60b13ac57f6e12e$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $8ad0206f64f59332$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $b60b13ac57f6e12e$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $8ad0206f64f59332$export$a40a96b24b46cf35;
    return $8ad0206f64f59332$export$f02da7f882cf6b2e;
}
class $8ad0206f64f59332$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $b60b13ac57f6e12e$export$d141bba7fdc215a3)(this.x) && (0, $b60b13ac57f6e12e$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $8ad0206f64f59332$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $8ad0206f64f59332$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $8ad0206f64f59332$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $8ad0206f64f59332$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $8ad0206f64f59332$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $8ad0206f64f59332$var$skip(ticks, newTicks, spacing, (0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$8ad0206f64f59332$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $8ad0206f64f59332$var$skip(ticks, newTicks, spacing, last, (0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $8ad0206f64f59332$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $8ad0206f64f59332$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $8ad0206f64f59332$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $8ad0206f64f59332$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $b60b13ac57f6e12e$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $8ad0206f64f59332$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $8ad0206f64f59332$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $8ad0206f64f59332$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $8ad0206f64f59332$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $8ad0206f64f59332$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $8ad0206f64f59332$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $8ad0206f64f59332$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $8ad0206f64f59332$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $8ad0206f64f59332$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $8ad0206f64f59332$var$garbageCollect(caches, length) {
    (0, $b60b13ac57f6e12e$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $8ad0206f64f59332$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $8ad0206f64f59332$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $8ad0206f64f59332$var$createScaleContext(parent, scale) {
    return (0, $b60b13ac57f6e12e$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $8ad0206f64f59332$var$createTickContext(parent, index, tick) {
    return (0, $b60b13ac57f6e12e$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $8ad0206f64f59332$var$titleAlign(align, position, reverse) {
    let ret = (0, $b60b13ac57f6e12e$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $8ad0206f64f59332$var$reverseAlign(ret);
    return ret;
}
function $8ad0206f64f59332$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $8ad0206f64f59332$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $8ad0206f64f59332$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd) : (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $8ad0206f64f59332$export$d60cfc58d3c358b6 extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(min, (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(max, min)),
            max: (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(max, (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $b60b13ac57f6e12e$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $8ad0206f64f59332$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $8ad0206f64f59332$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $8ad0206f64f59332$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $8ad0206f64f59332$var$getTickMarkLength(options.grid) - tickOpts.padding - $8ad0206f64f59332$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $b60b13ac57f6e12e$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $b60b13ac57f6e12e$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $8ad0206f64f59332$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $8ad0206f64f59332$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $8ad0206f64f59332$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $8ad0206f64f59332$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $8ad0206f64f59332$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(label) && !(0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(label)) {
                width = (0, $b60b13ac57f6e12e$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(nestedLabel) && !(0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $b60b13ac57f6e12e$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $8ad0206f64f59332$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $b60b13ac57f6e12e$export$71cec2538cb2c617)(this._alignToPixels ? (0, $b60b13ac57f6e12e$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $8ad0206f64f59332$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $8ad0206f64f59332$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $8ad0206f64f59332$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $b60b13ac57f6e12e$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $8ad0206f64f59332$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $b60b13ac57f6e12e$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $8ad0206f64f59332$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $b60b13ac57f6e12e$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $b60b13ac57f6e12e$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $b60b13ac57f6e12e$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $b60b13ac57f6e12e$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $b60b13ac57f6e12e$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $b60b13ac57f6e12e$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $b60b13ac57f6e12e$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(title.font);
        const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $8ad0206f64f59332$var$titleArgs(this, offset, position, align);
        (0, $b60b13ac57f6e12e$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $8ad0206f64f59332$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $8ad0206f64f59332$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $b60b13ac57f6e12e$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $8ad0206f64f59332$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($8ad0206f64f59332$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $8ad0206f64f59332$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $b60b13ac57f6e12e$export$4368d992c4eafac0)[scope]) {
            delete (0, $b60b13ac57f6e12e$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $b60b13ac57f6e12e$export$6559d589eb85fbb6)[id];
        }
    }
}
function $8ad0206f64f59332$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $b60b13ac57f6e12e$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $8ad0206f64f59332$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $8ad0206f64f59332$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $8ad0206f64f59332$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $8ad0206f64f59332$var$Registry {
    constructor(){
        this.controllers = new $8ad0206f64f59332$var$TypedRegistry($8ad0206f64f59332$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $8ad0206f64f59332$var$TypedRegistry($8ad0206f64f59332$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $8ad0206f64f59332$var$TypedRegistry(Object, 'plugins');
        this.scales = new $8ad0206f64f59332$var$TypedRegistry($8ad0206f64f59332$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $b60b13ac57f6e12e$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $b60b13ac57f6e12e$export$a8550f7dbe79f93a)(method);
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $8ad0206f64f59332$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $8ad0206f64f59332$var$Registry();
class $8ad0206f64f59332$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $8ad0206f64f59332$var$allPlugins(config);
        return options === false && !all ? [] : $8ad0206f64f59332$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $8ad0206f64f59332$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($8ad0206f64f59332$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($8ad0206f64f59332$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $8ad0206f64f59332$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $8ad0206f64f59332$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $8ad0206f64f59332$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $8ad0206f64f59332$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $8ad0206f64f59332$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $8ad0206f64f59332$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $8ad0206f64f59332$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $8ad0206f64f59332$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $8ad0206f64f59332$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $8ad0206f64f59332$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $8ad0206f64f59332$var$determineAxis(id, ...scaleOptions) {
    if ($8ad0206f64f59332$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $8ad0206f64f59332$var$axisFromPosition(opts.position) || id.length > 1 && $8ad0206f64f59332$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $8ad0206f64f59332$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $8ad0206f64f59332$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $8ad0206f64f59332$var$getAxisFromDataset(id, 'x', boundDs[0]) || $8ad0206f64f59332$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $8ad0206f64f59332$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $b60b13ac57f6e12e$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $8ad0206f64f59332$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $8ad0206f64f59332$var$determineAxis(id, scaleConf, $8ad0206f64f59332$var$retrieveAxisFromDatasets(id, config), (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $8ad0206f64f59332$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $b60b13ac57f6e12e$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $8ad0206f64f59332$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $b60b13ac57f6e12e$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $8ad0206f64f59332$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $b60b13ac57f6e12e$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $b60b13ac57f6e12e$export$555508cbc6add439)(scale, [
            (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).scales[scale.type],
            (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $8ad0206f64f59332$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $8ad0206f64f59332$var$mergeScaleConfig(config, options);
}
function $8ad0206f64f59332$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $8ad0206f64f59332$var$initConfig(config) {
    config = config || {};
    config.data = $8ad0206f64f59332$var$initData(config.data);
    $8ad0206f64f59332$var$initOptions(config);
    return config;
}
const $8ad0206f64f59332$var$keyCache = new Map();
const $8ad0206f64f59332$var$keysCached = new Set();
function $8ad0206f64f59332$var$cachedKeys(cacheKey, generate) {
    let keys = $8ad0206f64f59332$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $8ad0206f64f59332$var$keyCache.set(cacheKey, keys);
        $8ad0206f64f59332$var$keysCached.add(keys);
    }
    return keys;
}
const $8ad0206f64f59332$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $b60b13ac57f6e12e$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $8ad0206f64f59332$var$Config {
    constructor(config){
        this._config = $8ad0206f64f59332$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $8ad0206f64f59332$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $8ad0206f64f59332$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $8ad0206f64f59332$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $8ad0206f64f59332$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $8ad0206f64f59332$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $8ad0206f64f59332$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$8ad0206f64f59332$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$8ad0206f64f59332$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$8ad0206f64f59332$var$addIfFound(scopes, (0, $b60b13ac57f6e12e$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$8ad0206f64f59332$var$addIfFound(scopes, (0, $b60b13ac57f6e12e$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$8ad0206f64f59332$var$addIfFound(scopes, (0, $b60b13ac57f6e12e$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($8ad0206f64f59332$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $b60b13ac57f6e12e$export$6559d589eb85fbb6)[type] || {},
            (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $b60b13ac57f6e12e$export$4368d992c4eafac0),
            (0, $b60b13ac57f6e12e$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $8ad0206f64f59332$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($8ad0206f64f59332$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $b60b13ac57f6e12e$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $b60b13ac57f6e12e$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $8ad0206f64f59332$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(context) ? (0, $b60b13ac57f6e12e$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $8ad0206f64f59332$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $b60b13ac57f6e12e$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $8ad0206f64f59332$var$hasFunction = (value)=>(0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $b60b13ac57f6e12e$export$a93c5207d687da10)(value[key]));
function $8ad0206f64f59332$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $b60b13ac57f6e12e$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $b60b13ac57f6e12e$export$a93c5207d687da10)(value) || $8ad0206f64f59332$var$hasFunction(value)) || indexable && (0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $8ad0206f64f59332$var$version = "4.5.0";
const $8ad0206f64f59332$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $8ad0206f64f59332$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $8ad0206f64f59332$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $8ad0206f64f59332$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $8ad0206f64f59332$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $8ad0206f64f59332$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $8ad0206f64f59332$var$getCanvas(item) {
    if ((0, $b60b13ac57f6e12e$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $8ad0206f64f59332$var$instances = {};
const $8ad0206f64f59332$var$getChart = (key)=>{
    const canvas = $8ad0206f64f59332$var$getCanvas(key);
    return Object.values($8ad0206f64f59332$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $8ad0206f64f59332$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $8ad0206f64f59332$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $8ad0206f64f59332$export$acaa6426d77a227e {
    static defaults = (0, $b60b13ac57f6e12e$export$4368d992c4eafac0);
    static instances = $8ad0206f64f59332$var$instances;
    static overrides = (0, $b60b13ac57f6e12e$export$6559d589eb85fbb6);
    static registry = $8ad0206f64f59332$export$4bb7493d241fd8a5;
    static version = $8ad0206f64f59332$var$version;
    static getChart = $8ad0206f64f59332$var$getChart;
    static register(...items) {
        $8ad0206f64f59332$export$4bb7493d241fd8a5.add(...items);
        $8ad0206f64f59332$var$invalidatePlugins();
    }
    static unregister(...items) {
        $8ad0206f64f59332$export$4bb7493d241fd8a5.remove(...items);
        $8ad0206f64f59332$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $8ad0206f64f59332$var$Config(userConfig);
        const initialCanvas = $8ad0206f64f59332$var$getCanvas(item);
        const existingChart = $8ad0206f64f59332$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $8ad0206f64f59332$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $b60b13ac57f6e12e$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $8ad0206f64f59332$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $b60b13ac57f6e12e$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $8ad0206f64f59332$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $8ad0206f64f59332$export$a424a0aa8f687495.listen(this, 'complete', $8ad0206f64f59332$var$onAnimationsComplete);
        $8ad0206f64f59332$export$a424a0aa8f687495.listen(this, 'progress', $8ad0206f64f59332$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $8ad0206f64f59332$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $b60b13ac57f6e12e$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $b60b13ac57f6e12e$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $8ad0206f64f59332$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$8ad0206f64f59332$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $b60b13ac57f6e12e$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $8ad0206f64f59332$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $8ad0206f64f59332$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $8ad0206f64f59332$var$positionIsHorizontal(scaleOptions.position, axis) !== $8ad0206f64f59332$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $8ad0206f64f59332$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(scales, (scale)=>{
            $8ad0206f64f59332$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $8ad0206f64f59332$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($8ad0206f64f59332$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $8ad0206f64f59332$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $8ad0206f64f59332$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $8ad0206f64f59332$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $8ad0206f64f59332$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $b60b13ac57f6e12e$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($8ad0206f64f59332$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this.scales, (scale)=>{
            $8ad0206f64f59332$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $b60b13ac57f6e12e$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $8ad0206f64f59332$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $b60b13ac57f6e12e$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $8ad0206f64f59332$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $b60b13ac57f6e12e$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($8ad0206f64f59332$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$8ad0206f64f59332$export$a424a0aa8f687495.running(this)) $8ad0206f64f59332$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $8ad0206f64f59332$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $b60b13ac57f6e12e$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $b60b13ac57f6e12e$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $b60b13ac57f6e12e$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $b60b13ac57f6e12e$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $8ad0206f64f59332$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $b60b13ac57f6e12e$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $b60b13ac57f6e12e$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $8ad0206f64f59332$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $b60b13ac57f6e12e$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $8ad0206f64f59332$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $b60b13ac57f6e12e$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $b60b13ac57f6e12e$export$3b513254972cfc9c)(e);
        const lastEvent = $8ad0206f64f59332$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $b60b13ac57f6e12e$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $8ad0206f64f59332$var$invalidatePlugins() {
    return (0, $b60b13ac57f6e12e$export$d66501df72047452)($8ad0206f64f59332$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $8ad0206f64f59332$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / 2, startAngle + (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $8ad0206f64f59332$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd), startAngle - (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $8ad0206f64f59332$var$toRadiusCorners(value) {
    return (0, $b60b13ac57f6e12e$export$1a82df3d29112e01)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $8ad0206f64f59332$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $8ad0206f64f59332$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $8ad0206f64f59332$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $8ad0206f64f59332$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $8ad0206f64f59332$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $8ad0206f64f59332$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $8ad0206f64f59332$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $8ad0206f64f59332$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $8ad0206f64f59332$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $8ad0206f64f59332$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $8ad0206f64f59332$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $8ad0206f64f59332$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $8ad0206f64f59332$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $b60b13ac57f6e12e$export$971d5caa766a69d7) || (0, $b60b13ac57f6e12e$export$971d5caa766a69d7));
    }
    $8ad0206f64f59332$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $8ad0206f64f59332$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $8ad0206f64f59332$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $b60b13ac57f6e12e$export$971d5caa766a69d7) || (0, $b60b13ac57f6e12e$export$971d5caa766a69d7));
    }
    if (inner) $8ad0206f64f59332$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) && borderRadius === 0 && borderJoinStyle !== 'miter') $8ad0206f64f59332$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $8ad0206f64f59332$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $8ad0206f64f59332$export$d48203c759d6a1fc extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $b60b13ac57f6e12e$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $b60b13ac57f6e12e$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $b60b13ac57f6e12e$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $b60b13ac57f6e12e$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $b60b13ac57f6e12e$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $b60b13ac57f6e12e$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $b60b13ac57f6e12e$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $8ad0206f64f59332$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $8ad0206f64f59332$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $8ad0206f64f59332$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $8ad0206f64f59332$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $8ad0206f64f59332$var$getLineMethod(options) {
    if (options.stepped) return 0, $b60b13ac57f6e12e$export$493d36ec626b6698;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $b60b13ac57f6e12e$export$1fbe638ecf81657e;
    return $8ad0206f64f59332$var$lineTo;
}
function $8ad0206f64f59332$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $8ad0206f64f59332$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $8ad0206f64f59332$var$pathVars(points, segment, params);
    const lineMethod = $8ad0206f64f59332$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $8ad0206f64f59332$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $8ad0206f64f59332$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $8ad0206f64f59332$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $8ad0206f64f59332$var$fastPathSegment : $8ad0206f64f59332$var$pathSegment;
}
function $8ad0206f64f59332$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $b60b13ac57f6e12e$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $b60b13ac57f6e12e$export$d24c54395ce0c509;
    return 0, $b60b13ac57f6e12e$export$6554612db691658e;
}
function $8ad0206f64f59332$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $8ad0206f64f59332$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $8ad0206f64f59332$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $8ad0206f64f59332$var$_getSegmentMethod(line);
    for (const segment of segments){
        $8ad0206f64f59332$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $8ad0206f64f59332$var$usePath2D = typeof Path2D === 'function';
function $8ad0206f64f59332$var$draw(ctx, line, start, count) {
    if ($8ad0206f64f59332$var$usePath2D && !line.options.segment) $8ad0206f64f59332$var$strokePathWithCache(ctx, line, start, count);
    else $8ad0206f64f59332$var$strokePathDirect(ctx, line, start, count);
}
class $8ad0206f64f59332$export$55e463fa7bcd3469 extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $b60b13ac57f6e12e$export$306ddfe3a8403e2)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $b60b13ac57f6e12e$export$7a38258bbe170828)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $b60b13ac57f6e12e$export$2f6ca3d3b1f80bf5)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $8ad0206f64f59332$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $8ad0206f64f59332$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $8ad0206f64f59332$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $8ad0206f64f59332$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $8ad0206f64f59332$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $8ad0206f64f59332$export$bd159b522b230b7a extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $8ad0206f64f59332$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $8ad0206f64f59332$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $b60b13ac57f6e12e$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $b60b13ac57f6e12e$export$d66dc83d8cfc8dd)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $8ad0206f64f59332$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $8ad0206f64f59332$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(value, min, max);
}
function $8ad0206f64f59332$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $b60b13ac57f6e12e$export$9fa96a7d116ea3ce)(value);
    return {
        t: $8ad0206f64f59332$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $8ad0206f64f59332$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $8ad0206f64f59332$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $8ad0206f64f59332$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $8ad0206f64f59332$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $b60b13ac57f6e12e$export$28f7fcd39efa255)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $8ad0206f64f59332$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $8ad0206f64f59332$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $8ad0206f64f59332$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $8ad0206f64f59332$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $8ad0206f64f59332$var$boundingRects(bar) {
    const bounds = $8ad0206f64f59332$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $8ad0206f64f59332$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $8ad0206f64f59332$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $8ad0206f64f59332$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $8ad0206f64f59332$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $b60b13ac57f6e12e$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $b60b13ac57f6e12e$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $8ad0206f64f59332$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $8ad0206f64f59332$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $8ad0206f64f59332$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $8ad0206f64f59332$export$a16ed71bf4b07672 extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $8ad0206f64f59332$var$boundingRects(this);
        const addRectPath = $8ad0206f64f59332$var$hasRadius(outer.radius) ? (0, $b60b13ac57f6e12e$export$92108d983e8ee699) : $8ad0206f64f59332$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $8ad0206f64f59332$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $8ad0206f64f59332$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $8ad0206f64f59332$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $8ad0206f64f59332$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $8ad0206f64f59332$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $8ad0206f64f59332$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $8ad0206f64f59332$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $8ad0206f64f59332$export$d48203c759d6a1fc,
    BarElement: $8ad0206f64f59332$export$a16ed71bf4b07672,
    LineElement: $8ad0206f64f59332$export$55e463fa7bcd3469,
    PointElement: $8ad0206f64f59332$export$bd159b522b230b7a
});
const $8ad0206f64f59332$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $8ad0206f64f59332$var$BACKGROUND_COLORS = /* #__PURE__ */ $8ad0206f64f59332$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $8ad0206f64f59332$var$getBorderColor(i) {
    return $8ad0206f64f59332$var$BORDER_COLORS[i % $8ad0206f64f59332$var$BORDER_COLORS.length];
}
function $8ad0206f64f59332$var$getBackgroundColor(i) {
    return $8ad0206f64f59332$var$BACKGROUND_COLORS[i % $8ad0206f64f59332$var$BACKGROUND_COLORS.length];
}
function $8ad0206f64f59332$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $8ad0206f64f59332$var$getBorderColor(i);
    dataset.backgroundColor = $8ad0206f64f59332$var$getBackgroundColor(i);
    return ++i;
}
function $8ad0206f64f59332$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$8ad0206f64f59332$var$getBorderColor(i++));
    return i;
}
function $8ad0206f64f59332$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$8ad0206f64f59332$var$getBackgroundColor(i++));
    return i;
}
function $8ad0206f64f59332$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $8ad0206f64f59332$export$e04603e7d8b77172) i = $8ad0206f64f59332$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $8ad0206f64f59332$export$2a270b3a0d973c85) i = $8ad0206f64f59332$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $8ad0206f64f59332$var$colorizeDefaultDataset(dataset, i);
    };
}
function $8ad0206f64f59332$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $8ad0206f64f59332$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $8ad0206f64f59332$var$containsDefaultColorsDefenitions() {
    return (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $8ad0206f64f59332$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $8ad0206f64f59332$var$containsColorsDefinitions(datasets) || $8ad0206f64f59332$var$containsColorsDefinition(chartOptions) || elements && $8ad0206f64f59332$var$containsColorsDefinitions(elements) || $8ad0206f64f59332$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $8ad0206f64f59332$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $8ad0206f64f59332$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $8ad0206f64f59332$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(minIndex) && !(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $8ad0206f64f59332$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $8ad0206f64f59332$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $8ad0206f64f59332$var$cleanDecimatedDataset(dataset);
    });
}
function $8ad0206f64f59332$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)((0, $b60b13ac57f6e12e$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)((0, $b60b13ac57f6e12e$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $8ad0206f64f59332$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $8ad0206f64f59332$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $b60b13ac57f6e12e$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $8ad0206f64f59332$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $8ad0206f64f59332$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $8ad0206f64f59332$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $8ad0206f64f59332$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $8ad0206f64f59332$var$cleanDecimatedData(chart);
    }
};
function $8ad0206f64f59332$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $8ad0206f64f59332$var$_findSegmentEnd(start, end, points);
        const bounds = $8ad0206f64f59332$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $b60b13ac57f6e12e$export$2f6ca3d3b1f80bf5)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $8ad0206f64f59332$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $b60b13ac57f6e12e$export$3d12bd131bb975d1)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $8ad0206f64f59332$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $8ad0206f64f59332$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $8ad0206f64f59332$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(start);
        end = (0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $8ad0206f64f59332$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $8ad0206f64f59332$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $8ad0206f64f59332$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $8ad0206f64f59332$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $8ad0206f64f59332$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $8ad0206f64f59332$var$_pointsFromSegments(boundary, line);
    return points.length ? new $8ad0206f64f59332$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $8ad0206f64f59332$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $8ad0206f64f59332$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $8ad0206f64f59332$var$_decodeFill(line, index, count) {
    const fill = $8ad0206f64f59332$var$parseFillOption(line);
    if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $8ad0206f64f59332$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $8ad0206f64f59332$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $8ad0206f64f59332$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $8ad0206f64f59332$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $8ad0206f64f59332$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $8ad0206f64f59332$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $8ad0206f64f59332$var$getLinesBelow(scale, index);
    linesBelow.push($8ad0206f64f59332$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$8ad0206f64f59332$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $8ad0206f64f59332$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $8ad0206f64f59332$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $8ad0206f64f59332$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $8ad0206f64f59332$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $8ad0206f64f59332$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $b60b13ac57f6e12e$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $8ad0206f64f59332$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $b60b13ac57f6e12e$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $8ad0206f64f59332$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(fill)) return $8ad0206f64f59332$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $8ad0206f64f59332$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $8ad0206f64f59332$var$computeBoundary(source);
    if (boundary instanceof $8ad0206f64f59332$var$simpleArc) return boundary;
    return $8ad0206f64f59332$var$_createBoundaryLine(boundary, line);
}
function $8ad0206f64f59332$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $8ad0206f64f59332$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $8ad0206f64f59332$var$computeCircularBoundary(source);
    return $8ad0206f64f59332$var$computeLinearBoundary(source);
}
function $8ad0206f64f59332$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $8ad0206f64f59332$var$_getTargetPixel(fill, scale);
    if ((0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $8ad0206f64f59332$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $8ad0206f64f59332$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $8ad0206f64f59332$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $8ad0206f64f59332$var$_drawfill(ctx, source, area) {
    const target = $8ad0206f64f59332$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $b60b13ac57f6e12e$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $b60b13ac57f6e12e$export$8743009a87fcb00f)(ctx, area);
        $8ad0206f64f59332$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $b60b13ac57f6e12e$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $8ad0206f64f59332$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $8ad0206f64f59332$var$clipVertical(ctx, target, area.top);
            $8ad0206f64f59332$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $8ad0206f64f59332$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $8ad0206f64f59332$var$clipHorizontal(ctx, target, area.left);
            $8ad0206f64f59332$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $8ad0206f64f59332$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $8ad0206f64f59332$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $8ad0206f64f59332$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$8ad0206f64f59332$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $8ad0206f64f59332$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$8ad0206f64f59332$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $8ad0206f64f59332$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $8ad0206f64f59332$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $8ad0206f64f59332$var$clipBounds(ctx, scale, clip, notShape && $8ad0206f64f59332$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $8ad0206f64f59332$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $8ad0206f64f59332$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $8ad0206f64f59332$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $8ad0206f64f59332$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $8ad0206f64f59332$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $8ad0206f64f59332$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $8ad0206f64f59332$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $8ad0206f64f59332$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $8ad0206f64f59332$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($8ad0206f64f59332$var$_shouldApplyFill(source)) $8ad0206f64f59332$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$8ad0206f64f59332$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $8ad0206f64f59332$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $8ad0206f64f59332$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $8ad0206f64f59332$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $8ad0206f64f59332$var$Legend extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $8ad0206f64f59332$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $8ad0206f64f59332$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $b60b13ac57f6e12e$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $b60b13ac57f6e12e$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $b60b13ac57f6e12e$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $b60b13ac57f6e12e$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $8ad0206f64f59332$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $b60b13ac57f6e12e$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $b60b13ac57f6e12e$export$28f7fcd39efa255)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $b60b13ac57f6e12e$export$92108d983e8ee699)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $b60b13ac57f6e12e$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $b60b13ac57f6e12e$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $b60b13ac57f6e12e$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $8ad0206f64f59332$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $b60b13ac57f6e12e$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $b60b13ac57f6e12e$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $b60b13ac57f6e12e$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $b60b13ac57f6e12e$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $b60b13ac57f6e12e$export$21579262ef46735b)(x, this.left, this.right) && (0, $b60b13ac57f6e12e$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $b60b13ac57f6e12e$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $b60b13ac57f6e12e$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$8ad0206f64f59332$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $8ad0206f64f59332$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $8ad0206f64f59332$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $8ad0206f64f59332$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $8ad0206f64f59332$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $8ad0206f64f59332$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $8ad0206f64f59332$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $8ad0206f64f59332$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $8ad0206f64f59332$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $8ad0206f64f59332$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $8ad0206f64f59332$export$ed247974535929c7 = {
    id: 'legend',
    _element: $8ad0206f64f59332$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $8ad0206f64f59332$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $8ad0206f64f59332$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $8ad0206f64f59332$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $8ad0206f64f59332$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $8ad0206f64f59332$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $8ad0206f64f59332$var$Title extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $b60b13ac57f6e12e$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $b60b13ac57f6e12e$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $b60b13ac57f6e12e$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $b60b13ac57f6e12e$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $8ad0206f64f59332$var$createTitle(chart, titleOpts) {
    const title = new $8ad0206f64f59332$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $8ad0206f64f59332$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $8ad0206f64f59332$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $8ad0206f64f59332$export$f99233281efd08a0 = {
    id: 'title',
    _element: $8ad0206f64f59332$var$Title,
    start (chart, _args, options) {
        $8ad0206f64f59332$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $8ad0206f64f59332$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $8ad0206f64f59332$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $8ad0206f64f59332$var$map = new WeakMap();
var $8ad0206f64f59332$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $8ad0206f64f59332$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $8ad0206f64f59332$export$1ecca0613f5e56d2.configure(chart, title, options);
        $8ad0206f64f59332$export$1ecca0613f5e56d2.addBox(chart, title);
        $8ad0206f64f59332$var$map.set(chart, title);
    },
    stop (chart) {
        $8ad0206f64f59332$export$1ecca0613f5e56d2.removeBox(chart, $8ad0206f64f59332$var$map.get(chart));
        $8ad0206f64f59332$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $8ad0206f64f59332$var$map.get(chart);
        $8ad0206f64f59332$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $8ad0206f64f59332$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $b60b13ac57f6e12e$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $8ad0206f64f59332$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $8ad0206f64f59332$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $8ad0206f64f59332$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $8ad0206f64f59332$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $b60b13ac57f6e12e$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $b60b13ac57f6e12e$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $b60b13ac57f6e12e$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $b60b13ac57f6e12e$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $8ad0206f64f59332$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $8ad0206f64f59332$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $8ad0206f64f59332$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($8ad0206f64f59332$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $8ad0206f64f59332$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $8ad0206f64f59332$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $8ad0206f64f59332$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $8ad0206f64f59332$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $8ad0206f64f59332$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $8ad0206f64f59332$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $b60b13ac57f6e12e$export$28f7fcd39efa255)(cornerRadius);
    let x = $8ad0206f64f59332$var$alignX(size, xAlign);
    const y = $8ad0206f64f59332$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $8ad0206f64f59332$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $8ad0206f64f59332$var$getBeforeAfterBodyLines(callback) {
    return $8ad0206f64f59332$var$pushOrConcat([], $8ad0206f64f59332$var$splitNewlines(callback));
}
function $8ad0206f64f59332$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $b60b13ac57f6e12e$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $8ad0206f64f59332$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $8ad0206f64f59332$var$defaultCallbacks = {
    beforeTitle: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    beforeBody: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    beforeLabel: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    afterBody: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    beforeFooter: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    footer: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346),
    afterFooter: (0, $b60b13ac57f6e12e$export$53a70dd1ebbae346)
};
function $8ad0206f64f59332$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $8ad0206f64f59332$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $8ad0206f64f59332$var$Tooltip extends $8ad0206f64f59332$export$db77ccec0bb4ccac {
    static positioners = $8ad0206f64f59332$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $8ad0206f64f59332$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $8ad0206f64f59332$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $8ad0206f64f59332$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $8ad0206f64f59332$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $8ad0206f64f59332$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $8ad0206f64f59332$var$pushOrConcat(lines, $8ad0206f64f59332$var$splitNewlines(beforeTitle));
        lines = $8ad0206f64f59332$var$pushOrConcat(lines, $8ad0206f64f59332$var$splitNewlines(title));
        lines = $8ad0206f64f59332$var$pushOrConcat(lines, $8ad0206f64f59332$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $8ad0206f64f59332$var$getBeforeAfterBodyLines($8ad0206f64f59332$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $8ad0206f64f59332$var$overrideCallbacks(callbacks, context);
            $8ad0206f64f59332$var$pushOrConcat(bodyItem.before, $8ad0206f64f59332$var$splitNewlines($8ad0206f64f59332$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $8ad0206f64f59332$var$pushOrConcat(bodyItem.lines, $8ad0206f64f59332$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $8ad0206f64f59332$var$pushOrConcat(bodyItem.after, $8ad0206f64f59332$var$splitNewlines($8ad0206f64f59332$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $8ad0206f64f59332$var$getBeforeAfterBodyLines($8ad0206f64f59332$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $8ad0206f64f59332$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $8ad0206f64f59332$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $8ad0206f64f59332$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $8ad0206f64f59332$var$pushOrConcat(lines, $8ad0206f64f59332$var$splitNewlines(beforeFooter));
        lines = $8ad0206f64f59332$var$pushOrConcat(lines, $8ad0206f64f59332$var$splitNewlines(footer));
        lines = $8ad0206f64f59332$var$pushOrConcat(lines, $8ad0206f64f59332$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($8ad0206f64f59332$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $8ad0206f64f59332$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($8ad0206f64f59332$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($8ad0206f64f59332$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($8ad0206f64f59332$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $8ad0206f64f59332$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $8ad0206f64f59332$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $8ad0206f64f59332$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $8ad0206f64f59332$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $b60b13ac57f6e12e$export$28f7fcd39efa255)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $b60b13ac57f6e12e$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $8ad0206f64f59332$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.bodyFont);
        const colorX = $8ad0206f64f59332$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $b60b13ac57f6e12e$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $b60b13ac57f6e12e$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $b60b13ac57f6e12e$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $b60b13ac57f6e12e$export$28f7fcd39efa255)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $b60b13ac57f6e12e$export$92108d983e8ee699)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $b60b13ac57f6e12e$export$92108d983e8ee699)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $b60b13ac57f6e12e$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $8ad0206f64f59332$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $b60b13ac57f6e12e$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $b60b13ac57f6e12e$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $b60b13ac57f6e12e$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $b60b13ac57f6e12e$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $8ad0206f64f59332$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $b60b13ac57f6e12e$export$28f7fcd39efa255)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $8ad0206f64f59332$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $8ad0206f64f59332$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $8ad0206f64f59332$var$determineAlignment(chart, options, positionAndSize);
            const point = $8ad0206f64f59332$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $b60b13ac57f6e12e$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $b60b13ac57f6e12e$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $b60b13ac57f6e12e$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $b60b13ac57f6e12e$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $8ad0206f64f59332$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $8ad0206f64f59332$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $8ad0206f64f59332$var$Tooltip,
    positioners: $8ad0206f64f59332$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $8ad0206f64f59332$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $8ad0206f64f59332$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $8ad0206f64f59332$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $8ad0206f64f59332$export$c537fa0d021d010b,
    Decimation: $8ad0206f64f59332$export$be17f937e9aa7533,
    Filler: $8ad0206f64f59332$export$d19ba4d812bed757,
    Legend: $8ad0206f64f59332$export$ed247974535929c7,
    SubTitle: $8ad0206f64f59332$export$d5c56664638992a4,
    Title: $8ad0206f64f59332$export$f99233281efd08a0,
    Tooltip: $8ad0206f64f59332$export$28c660c63b792dea
});
const $8ad0206f64f59332$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $8ad0206f64f59332$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $8ad0206f64f59332$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $8ad0206f64f59332$var$validIndex = (index, max)=>index === null ? null : (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $8ad0206f64f59332$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $8ad0206f64f59332$export$29e663ba4d09fe7 extends $8ad0206f64f59332$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $8ad0206f64f59332$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $8ad0206f64f59332$var$findOrAddLabel(labels, raw, (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $8ad0206f64f59332$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $8ad0206f64f59332$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $8ad0206f64f59332$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $b60b13ac57f6e12e$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $b60b13ac57f6e12e$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $b60b13ac57f6e12e$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $b60b13ac57f6e12e$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $b60b13ac57f6e12e$export$91477dc880baac21)(spacing), (0, $b60b13ac57f6e12e$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $b60b13ac57f6e12e$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $8ad0206f64f59332$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $b60b13ac57f6e12e$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $8ad0206f64f59332$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $8ad0206f64f59332$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $8ad0206f64f59332$var$LinearScaleBase extends $8ad0206f64f59332$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $b60b13ac57f6e12e$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $8ad0206f64f59332$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $b60b13ac57f6e12e$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $b60b13ac57f6e12e$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $8ad0206f64f59332$export$e7f4e5e8656f0b93 extends $8ad0206f64f59332$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $b60b13ac57f6e12e$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $8ad0206f64f59332$var$log10Floor = (v)=>Math.floor((0, $b60b13ac57f6e12e$export$faec65b429be379)(v));
const $8ad0206f64f59332$var$changeExponent = (v, m)=>Math.pow(10, $8ad0206f64f59332$var$log10Floor(v) + m);
function $8ad0206f64f59332$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $8ad0206f64f59332$var$log10Floor(tickVal));
    return remain === 1;
}
function $8ad0206f64f59332$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $8ad0206f64f59332$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $8ad0206f64f59332$var$log10Floor(range);
    while($8ad0206f64f59332$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($8ad0206f64f59332$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $8ad0206f64f59332$var$log10Floor(min));
}
function $8ad0206f64f59332$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $8ad0206f64f59332$var$log10Floor(min);
    let exp = $8ad0206f64f59332$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $8ad0206f64f59332$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $b60b13ac57f6e12e$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $8ad0206f64f59332$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $8ad0206f64f59332$export$85295eaf7cb3ac3e extends $8ad0206f64f59332$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $b60b13ac57f6e12e$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $8ad0206f64f59332$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(this._userMin)) this.min = min === $8ad0206f64f59332$var$changeExponent(this.min, 0) ? $8ad0206f64f59332$var$changeExponent(this.min, -1) : $8ad0206f64f59332$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($8ad0206f64f59332$var$changeExponent(min, -1));
                setMax($8ad0206f64f59332$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($8ad0206f64f59332$var$changeExponent(max, -1));
        if (max <= 0) setMax($8ad0206f64f59332$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $8ad0206f64f59332$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $b60b13ac57f6e12e$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $b60b13ac57f6e12e$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $b60b13ac57f6e12e$export$faec65b429be379)(start);
        this._valueRange = (0, $b60b13ac57f6e12e$export$faec65b429be379)(this.max) - (0, $b60b13ac57f6e12e$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $b60b13ac57f6e12e$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $8ad0206f64f59332$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $b60b13ac57f6e12e$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $8ad0206f64f59332$var$measureLabelSize(ctx, font, label) {
    label = (0, $b60b13ac57f6e12e$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $b60b13ac57f6e12e$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $8ad0206f64f59332$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $8ad0206f64f59332$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(opts.font);
        const textSize = $8ad0206f64f59332$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $b60b13ac57f6e12e$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $8ad0206f64f59332$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $8ad0206f64f59332$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $8ad0206f64f59332$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $8ad0206f64f59332$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $8ad0206f64f59332$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $8ad0206f64f59332$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $b60b13ac57f6e12e$export$3a6d5c9ae78a2c08)((0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(pointLabelPosition.angle + (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd))));
    const y = $8ad0206f64f59332$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $8ad0206f64f59332$var$getTextAlignForAngle(angle);
    const left = $8ad0206f64f59332$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $8ad0206f64f59332$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $b60b13ac57f6e12e$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $b60b13ac57f6e12e$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $b60b13ac57f6e12e$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $b60b13ac57f6e12e$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $8ad0206f64f59332$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $8ad0206f64f59332$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $b60b13ac57f6e12e$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $8ad0206f64f59332$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $8ad0206f64f59332$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $8ad0206f64f59332$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $8ad0206f64f59332$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $8ad0206f64f59332$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $8ad0206f64f59332$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $b60b13ac57f6e12e$export$28f7fcd39efa255)(opts.borderRadius);
        const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $b60b13ac57f6e12e$export$92108d983e8ee699)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $8ad0206f64f59332$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $8ad0206f64f59332$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $b60b13ac57f6e12e$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $8ad0206f64f59332$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $b60b13ac57f6e12e$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $8ad0206f64f59332$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $8ad0206f64f59332$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $8ad0206f64f59332$var$createPointLabelContext(parent, index, label) {
    return (0, $b60b13ac57f6e12e$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $8ad0206f64f59332$export$cfafc36d95386d38 extends $8ad0206f64f59332$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $b60b13ac57f6e12e$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)($8ad0206f64f59332$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $8ad0206f64f59332$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $8ad0206f64f59332$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $8ad0206f64f59332$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $b60b13ac57f6e12e$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $b60b13ac57f6e12e$export$ab83b03e4111b1d0)(index * angleMultiplier + (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $8ad0206f64f59332$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $b60b13ac57f6e12e$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $8ad0206f64f59332$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $8ad0206f64f59332$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $8ad0206f64f59332$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $b60b13ac57f6e12e$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $b60b13ac57f6e12e$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $b60b13ac57f6e12e$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $8ad0206f64f59332$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $8ad0206f64f59332$var$UNITS = /* #__PURE__ */ Object.keys($8ad0206f64f59332$var$INTERVALS);
function $8ad0206f64f59332$var$sorter(a, b) {
    return a - b;
}
function $8ad0206f64f59332$var$parse(scale, input) {
    if ((0, $b60b13ac57f6e12e$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $b60b13ac57f6e12e$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $8ad0206f64f59332$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $8ad0206f64f59332$var$UNITS.length;
    for(let i = $8ad0206f64f59332$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $8ad0206f64f59332$var$INTERVALS[$8ad0206f64f59332$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $8ad0206f64f59332$var$UNITS[i];
    }
    return $8ad0206f64f59332$var$UNITS[ilen - 1];
}
function $8ad0206f64f59332$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $8ad0206f64f59332$var$UNITS.length - 1; i >= $8ad0206f64f59332$var$UNITS.indexOf(minUnit); i--){
        const unit = $8ad0206f64f59332$var$UNITS[i];
        if ($8ad0206f64f59332$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $8ad0206f64f59332$var$UNITS[minUnit ? $8ad0206f64f59332$var$UNITS.indexOf(minUnit) : 0];
}
function $8ad0206f64f59332$var$determineMajorUnit(unit) {
    for(let i = $8ad0206f64f59332$var$UNITS.indexOf(unit) + 1, ilen = $8ad0206f64f59332$var$UNITS.length; i < ilen; ++i){
        if ($8ad0206f64f59332$var$INTERVALS[$8ad0206f64f59332$var$UNITS[i]].common) return $8ad0206f64f59332$var$UNITS[i];
    }
}
function $8ad0206f64f59332$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $b60b13ac57f6e12e$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $8ad0206f64f59332$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $8ad0206f64f59332$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $8ad0206f64f59332$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $8ad0206f64f59332$export$a894c72689ff3ec extends $8ad0206f64f59332$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $8ad0206f64f59332$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $b60b13ac57f6e12e$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $8ad0206f64f59332$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $b60b13ac57f6e12e$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $b60b13ac57f6e12e$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $8ad0206f64f59332$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $8ad0206f64f59332$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $8ad0206f64f59332$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $8ad0206f64f59332$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $b60b13ac57f6e12e$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $8ad0206f64f59332$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $b60b13ac57f6e12e$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $b60b13ac57f6e12e$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$8ad0206f64f59332$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $8ad0206f64f59332$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($8ad0206f64f59332$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $b60b13ac57f6e12e$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $b60b13ac57f6e12e$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $8ad0206f64f59332$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($8ad0206f64f59332$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $b60b13ac57f6e12e$export$71511d61b312f219)(values.sort($8ad0206f64f59332$var$sorter));
    }
}
function $8ad0206f64f59332$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $b60b13ac57f6e12e$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $b60b13ac57f6e12e$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $8ad0206f64f59332$export$85df64a8eb6dc986 extends $8ad0206f64f59332$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $8ad0206f64f59332$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $8ad0206f64f59332$var$interpolate(table, this.min);
        this._tableRange = $8ad0206f64f59332$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($8ad0206f64f59332$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $8ad0206f64f59332$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $8ad0206f64f59332$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $8ad0206f64f59332$export$29e663ba4d09fe7,
    LinearScale: $8ad0206f64f59332$export$e7f4e5e8656f0b93,
    LogarithmicScale: $8ad0206f64f59332$export$85295eaf7cb3ac3e,
    RadialLinearScale: $8ad0206f64f59332$export$cfafc36d95386d38,
    TimeScale: $8ad0206f64f59332$export$a894c72689ff3ec,
    TimeSeriesScale: $8ad0206f64f59332$export$85df64a8eb6dc986
});
const $8ad0206f64f59332$export$e8959e79e3af550f = [
    $8ad0206f64f59332$export$a6506504f799c5d5,
    $8ad0206f64f59332$export$7a5d735b2ab6389d,
    $8ad0206f64f59332$export$8b3ca321c77fdea6,
    $8ad0206f64f59332$export$bcac1c16f1530ec2
];


(0, $8ad0206f64f59332$export$acaa6426d77a227e).register(...(0, $8ad0206f64f59332$export$e8959e79e3af550f));
var $c98a0dc47b75720b$export$2e2bcd8739ae039 = (0, $8ad0206f64f59332$export$acaa6426d77a227e);



function $e9c5ff7374aebd78$var$getCssVar(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
const $e9c5ff7374aebd78$export$59366c9640b4fc95 = $e9c5ff7374aebd78$var$getCssVar('--bulma-text') || '#363636'; // fallback if undefined


function $1f082d0b055bfa9e$export$1ce691f85baaa52(arr) {
    return arr.reduce((a, b)=>a + b, 0) / arr.length;
}



function $10e1917f99a297d6$export$26bc52c5fdd04532(x, mu, sigma) {
    return 1 / (sigma * Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * ((x - mu) / sigma) ** 2);
}


function $29d407fa61f0c526$export$5812ca140303747d(u) {
    return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-0.5 * u * u);
}


function $7771ed5fa9696052$export$8ddd4266aa49b096(xs, data, bandwidth) {
    return xs.map((x)=>data.reduce((sum, xi)=>sum + (0, $29d407fa61f0c526$export$5812ca140303747d)((x - xi) / bandwidth), 0) / (data.length * bandwidth));
}



function $d2e4ff1e480ef9c5$export$9b77da0927470c3d(arr, ddof = 0) {
    if (arr.length - ddof <= 0) return 0;
    const m = (0, $1f082d0b055bfa9e$export$1ce691f85baaa52)(arr);
    return arr.reduce((s, v)=>s + (v - m) ** 2, 0) / (arr.length - ddof);
}


function $d775f4859c7cc4b7$export$b14c5e819cb6c927(arr, ddof = 0) {
    return Math.sqrt((0, $d2e4ff1e480ef9c5$export$9b77da0927470c3d)(arr, ddof));
}


function $7366662199903242$export$fe5e8bb339edc33b(n) {
    return Math.max(1, Math.ceil(Math.log2(n) + 1));
}


function $8f27905d216e5941$export$651fb4afdb6caa4b(sorted, p) {
    const idx = (sorted.length - 1) * p;
    const lo = Math.floor(idx);
    const hi = Math.ceil(idx);
    if (hi === lo) return sorted[lo];
    const w = idx - lo;
    return sorted[lo] * (1 - w) + sorted[hi] * w;
}



function $6595846b37d071bc$export$bc479ddbce9dbbe0(sorted) {
    const med = (0, $8f27905d216e5941$export$651fb4afdb6caa4b)(sorted, 0.5);
    const devs = sorted.map((v)=>Math.abs(v - med)).sort((a, b)=>a - b);
    return (0, $8f27905d216e5941$export$651fb4afdb6caa4b)(devs, 0.5);
}


function $34b24554f0650f61$export$f8f30e7e6cdf607(Values, n, range) {
    // Freedman-Diaconis bin width: 2 * IQR / n^(1/3) -> bins = range / h
    const sorted = [
        ...Values
    ].sort((a, b)=>a - b);
    const q1 = (0, $8f27905d216e5941$export$651fb4afdb6caa4b)(sorted, 0.25);
    const q3 = (0, $8f27905d216e5941$export$651fb4afdb6caa4b)(sorted, 0.75);
    const iqr = q3 - q1 || (0, $6595846b37d071bc$export$bc479ddbce9dbbe0)(sorted) || 1e-9;
    const h = 2 * iqr / Math.cbrt(n) || range / Math.max(1, Math.cbrt(n));
    const bins = Math.max(1, Math.ceil(range / h));
    return bins;
}


(0, $c98a0dc47b75720b$export$2e2bcd8739ae039).register((0, $8ad0206f64f59332$export$c537fa0d021d010b));
const $86dd3a50fbb9df25$var$newLegendClickHandler = function(e, legendItem, legend) {
    const index = legendItem.datasetIndex;
    const type = legend.chart.config.type;
    let ci = legend.chart;
    [
        ci.getDatasetMeta(index),
        ci.getDatasetMeta(index + 1),
        ci.getDatasetMeta(index + 2)
    ].forEach(function(meta) {
        meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
    });
    ci.update();
};
function $86dd3a50fbb9df25$var$binData(data, binSize) {
    const min = Math.min(...data);
    const max = Math.max(...data);
    const bins = Math.ceil((max - min) / binSize);
    const counts = new Array(bins).fill(0);
    const labels = new Array(bins).fill("").map((_, i)=>{
        const start = min + i * binSize;
        const end = start + binSize;
        return `${start.toFixed(1)}\u{2013}${end.toFixed(1)}`;
    });
    data.forEach((value)=>{
        const index = Math.floor((value - min) / binSize);
        counts[index]++;
    });
    return {
        labels: labels,
        counts: counts
    };
}
function $86dd3a50fbb9df25$export$3c23a673c50df7fb(canvasId, data, binSize) {
    const { labels: labels, counts: counts } = $86dd3a50fbb9df25$var$binData(data, binSize);
    new (0, $c98a0dc47b75720b$export$2e2bcd8739ae039)(document.getElementById(canvasId), {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [
                {
                    label: 'Frequency',
                    data: counts,
                    backgroundColor: 'rgba(54, 162, 235, 0.6)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    borderWidth: 1
                }
            ]
        },
        options: {
            scales: {
                x: {
                    title: {
                        display: true,
                        text: 'Bins'
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: 'Count'
                    },
                    beginAtZero: true,
                    stacked: false
                }
            }
        }
    });
}
function $86dd3a50fbb9df25$export$bbfa002beb0e079c(raw, opts) {
    const method = opts?.method ?? 'sturges';
    const minBins = Math.max(2, Math.floor(opts?.minBins ?? 3));
    const maxBins = Math.max(minBins, Math.floor(opts?.maxBins ?? 10));
    const allValues = raw.flatMap((r)=>r.values).filter((v)=>Number.isFinite(v));
    if (allValues.length === 0) return {
        labels: [],
        edges: [],
        datasets: raw.map((r)=>({
                label: r.label,
                data: [],
                color: r.color
            }))
    };
    const n = allValues.length;
    const min = Math.min(...allValues);
    const max = Math.max(...allValues);
    const range = Math.max(Number.EPSILON, max - min);
    function sqrtCount() {
        return Math.max(1, Math.ceil(Math.sqrt(n)));
    }
    let kRaw;
    if (method === 'fd') kRaw = (0, $34b24554f0650f61$export$f8f30e7e6cdf607)(allValues, n, range);
    else if (method === 'sqrt') kRaw = sqrtCount();
    else kRaw = (0, $7366662199903242$export$fe5e8bb339edc33b)(n);
    // For very small n (3-20), force a sensible minimum and maximum
    let k = Math.min(maxBins, Math.max(minBins, kRaw));
    // Additional heuristic: if n is extremely small, prefer fewer bins
    if (n <= 5) k = Math.min(k, Math.max(2, Math.floor(n / 1.5)));
    if (n <= 10) k = Math.min(k, Math.max(3, Math.floor(n / 1.2)));
    // Build equally spaced edges (inclusive last edge)
    const edges = [];
    if (k === 1) edges.push(min, max);
    else {
        for(let i = 0; i <= k; i++)edges.push(min + i / k * range);
        edges[edges.length - 1] = max;
    }
    const labels = edges.slice(0, -1).map((lo, i)=>{
        const hi = edges[i + 1];
        return `${lo.toFixed(3)} - ${hi.toFixed(3)}`;
    });
    function countsFor(values) {
        const counts = Array(edges.length - 1).fill(0);
        for (const v of values){
            if (!Number.isFinite(v)) continue;
            // assign to bin (include left edge, exclude right except for last bin)
            for(let i = 0; i < edges.length - 1; i++){
                const left = edges[i];
                const right = edges[i + 1];
                const isLast = i === edges.length - 2;
                if (v >= left && v < right || isLast && v === right) {
                    counts[i]++;
                    break;
                }
            }
        }
        return counts;
    }
    const datasets = raw.map((r)=>({
            label: r.label,
            data: countsFor(r.values),
            color: r.color
        }));
    return {
        labels: labels,
        edges: edges,
        datasets: datasets
    };
}
function $86dd3a50fbb9df25$export$efdb07b38b0c740c(canvasId, labels, datasets) {
    const el = document.getElementById(canvasId);
    if (!el) return null;
    // if re-rendering, destroy existing Chart instance bound to canvas
    // @ts-ignore 
    if (el._chart) // @ts-ignore
    el._chart.destroy();
    const chart = new (0, $c98a0dc47b75720b$export$2e2bcd8739ae039)(el, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: datasets.map((ds, i)=>({
                    label: ds.label,
                    data: ds.data,
                    backgroundColor: /*ds.color.replace(/rgba?\((.+)\)/, 'rgba($1,0.5)') ?? */ ds.color,
                    borderColor: ds.color,
                    borderWidth: 1,
                    barPercentage: 1.0,
                    categoryPercentage: 1.0,
                    order: i
                }))
        },
        options: {
            responsive: true,
            scales: {
                x: {
                    stacked: false
                },
                y: {
                    beginAtZero: true,
                    stacked: false
                }
            },
            plugins: {
                legend: {
                    position: 'top'
                },
                tooltip: {
                    mode: 'index',
                    intersect: false
                }
            }
        }
    });
    // store reference for later cleanup
    // @ts-ignore
    el._chart = chart;
    return chart;
}
function $86dd3a50fbb9df25$export$103d8ec267fff713(canvasId, RawData) {
    const el = document.getElementById(canvasId);
    if (!el) return null;
    // if re-rendering, destroy existing Chart instance bound to canvas
    // @ts-ignore 
    if (el._chart) // @ts-ignore
    el._chart.destroy();
    // Gemeinsame X-Achse für Dichten
    const globalMin = Math.min(...RawData.flatMap(({ values: values })=>values));
    const globalMax = Math.max(...RawData.flatMap(({ values: values })=>values));
    const widener = (globalMax - globalMin) * 0.25;
    const xValues = [];
    for(let x = globalMin - widener; x <= globalMax + widener; x += 0.2)xValues.push(x);
    // Gemeinsames h
    function silverman(data) {
        const sd = (0, $d775f4859c7cc4b7$export$b14c5e819cb6c927)(data), n = data.length;
        return 1.06 * sd * Math.pow(n, -0.2);
    }
    const pooledValues = RawData.flatMap((d)=>d.values).filter(Number.isFinite);
    const pooledh = silverman(pooledValues);
    // Datasets sammeln
    const datasets = [];
    RawData.forEach((s, idx)=>{
        const mu = (0, $1f082d0b055bfa9e$export$1ce691f85baaa52)(s.values);
        const sigma = (0, $ba78bcf4027a58ae$export$1cb78577db373fdf)(s.values, mu);
        // Histogramm
        const binCount = 10;
        const binWidth = (globalMax - globalMin) / binCount;
        const bins = Array(binCount).fill(0);
        s.values.forEach((v)=>{
            const i = Math.min(Math.floor((v - globalMin) / binWidth), binCount - 1);
            bins[i]++;
        });
        const binCenters = bins.map((_, i)=>globalMin + (i + 0.5) * binWidth);
        // Normalverteilung
        const normalValues = xValues.map((x)=>(0, $10e1917f99a297d6$export$26bc52c5fdd04532)(x, mu, sigma));
        // KDE
        const h = 1.06 * sigma * Math.pow(s.values.length, -0.2);
        //const kdeValues = kde(xValues, s.values, h);
        const kdeValues = (0, $7771ed5fa9696052$export$8ddd4266aa49b096)(xValues, s.values, pooledh);
        // Histogramm-Dataset
        /*datasets.push({
      type: "bar",
      label: `${s.label} Histogramm`,
      data: bins,
      backgroundColor: s.color,
      xAxisID: "xBins" + idx,
      yAxisID: "y"
    });*/ // Normalverteilung
        /*datasets.push({
      type: "line",
      label: `${s.label} Normal`,
      data: normalValues.map(v => v * s.values.length * binWidth),
      borderColor: s.color,
      fill: false,
      tension: 0.2,
      xAxisID: "xDensity",
      yAxisID: "y"
    });*/ // KDE
        datasets.push({
            type: 'line',
            label: s.label,
            data: kdeValues.map((v)=>v * s.values.length * binWidth).map((value)=>value === 0 ? null : value),
            borderColor: s.color,
            backgroundColor: s.color + 'AA',
            fill: false,
            tension: 0.2,
            xAxisID: "xDensity",
            yAxisID: "y",
            pointStyle: false,
            order: 1
        });
        const maxY = Math.max(...kdeValues.flatMap((v)=>v * s.values.length * binWidth));
        // shots
        datasets.push({
            type: "scatter",
            data: s.values.map((v)=>{
                return {
                    x: v,
                    y: maxY * 0.1
                };
            }),
            label: s.label + ` - Shot`,
            showLine: false,
            borderColor: s.color,
            backgroundColor: s.color + '77',
            pointRadius: 5,
            xAxisID: "xDensity",
            order: 3
        });
        // average bar    
        datasets.push({
            type: 'line',
            label: s.label + ' - AVG',
            data: [
                {
                    x: mu,
                    y: 0
                },
                {
                    x: mu,
                    y: maxY || 2
                }
            ],
            borderColor: s.color,
            borderWidth: 2,
            borderDash: [
                6,
                6
            ],
            pointRadius: 0,
            tension: 0,
            fill: false,
            // Put scales & z index so these lines render above KDE curves
            order: 2,
            xAxisID: "xDensity",
            yAxisID: "y"
        });
    });
    // Chart Config
    const cfg = {
        type: "line",
        data: {
            labels: xValues.map((v)=>v.toFixed(1)),
            datasets: datasets
        },
        options: {
            responsive: true,
            scales: {
                xDensity: {
                    type: "linear",
                    position: "bottom",
                    min: globalMin - widener,
                    max: globalMax + widener,
                    title: {
                        display: true,
                        text: "Velocity",
                        color: (0, $e9c5ff7374aebd78$export$59366c9640b4fc95)
                    },
                    grid: {
                        color: (0, $e9c5ff7374aebd78$export$59366c9640b4fc95)
                    },
                    ticks: {
                        color: (0, $e9c5ff7374aebd78$export$59366c9640b4fc95)
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: "Density",
                        color: (0, $e9c5ff7374aebd78$export$59366c9640b4fc95)
                    },
                    grid: {
                        color: (0, $e9c5ff7374aebd78$export$59366c9640b4fc95)
                    },
                    ticks: {
                        color: (0, $e9c5ff7374aebd78$export$59366c9640b4fc95)
                    }
                }
            },
            plugins: {
                legend: {
                    labels: {
                        filter: (legendItem, chart)=>{
                            const ds = chart.datasets[legendItem.datasetIndex];
                            return ds.type !== 'scatter' && !ds.label.endsWith(" - AVG");
                        },
                        color: (0, $e9c5ff7374aebd78$export$59366c9640b4fc95)
                    },
                    onClick: $86dd3a50fbb9df25$var$newLegendClickHandler
                }
            }
        }
    };
    const chart = new (0, $c98a0dc47b75720b$export$2e2bcd8739ae039)(el, cfg);
    // store reference for later cleanup
    // @ts-ignore
    el._chart = chart;
    return chart;
}





document.addEventListener('DOMContentLoaded', ()=>{
    const feature_IndexedDB = 'indexedDB' in window;
    if (feature_IndexedDB) {
        //wipe indexedDB
        (0, $8c181515f0907a6d$export$2e2bcd8739ae039).delete().then(async ()=>await (0, $8c181515f0907a6d$export$2e2bcd8739ae039).open());
        document.getElementById('NavAnalyse').classList.remove('is-hidden');
    }
    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger)=>{
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);
        $trigger.addEventListener('click', ()=>{
            (0, $f7be2c8e22c715f0$export$a7f6cffb6b8ba11c)($target);
        });
    });
    // Add a click event on various child elements to close the parent modal
    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close)=>{
        const $target = $close.closest('.modal');
        $close.addEventListener('click', ()=>{
            (0, $f7be2c8e22c715f0$export$3f6fecd573f3fa48)($target);
        });
    });
    // Add a keyboard event to close all modals
    document.addEventListener('keydown', (event)=>{
        if (event.key === "Escape") (0, $f7be2c8e22c715f0$export$8d2660641b6fb76a)();
    });
    // Get all "navbar-burger" elements
    (document.querySelectorAll('.navbar-burger') || []).forEach((el)=>{
        el.addEventListener('click', ()=>{
            // Get the target from the "data-target" attribute
            const target = el.dataset.target;
            const $target = document.getElementById(target);
            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle('is-active');
            $target.classList.toggle('is-active');
        });
    });
    //install button handling https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps/How_to/Trigger_install_prompt
    let installPrompt = null;
    const installButton = document.querySelector("#install");
    window.addEventListener("beforeinstallprompt", (event)=>{
        event.preventDefault();
        installPrompt = event;
        installButton.removeAttribute("hidden");
    //return false;
    });
    installButton.addEventListener("click", async ()=>{
        if (!installPrompt) return;
        installPrompt.prompt();
        const { outcome: outcome } = await installPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        disableInAppInstallPrompt();
    /*const result = await installPrompt.prompt();
    console.log(`Install prompt was: ${result.outcome}`);
    disableInAppInstallPrompt();
    installPrompt = null;*/ });
    function disableInAppInstallPrompt() {
        installPrompt = null;
        installButton.setAttribute("hidden", "");
    }
    (document.querySelectorAll('.js-page-trigger') || []).forEach((el)=>{
        el.addEventListener('click', ()=>{
            const target = el.dataset.target;
            const $target = document.getElementById(target);
            (document.querySelectorAll('.js-page-trigger') || []).forEach((elem)=>{
                elem.classList.remove("is-active");
                const target = elem.dataset.target;
                const $target = document.getElementById(target);
                $target.classList.add("is-hidden");
            });
            el.classList.toggle('is-active');
            $target.classList.remove("is-hidden");
        });
    });
    //register Eventlisteners
    document.getElementById('xero2labradar').addEventListener("change", (event)=>{
        (0, $2f6a798bf6d12b9e$export$4a2ae512745da1fe)(event.target.files, feature_IndexedDB).finally(()=>{
            event.target.value = '';
        });
    }, false);
    0, $502ca2c4c2e13c84$export$29482465873902ce;
    document.getElementById('table').addEventListener('change', (e)=>{
        const target = e.target;
        const targetunits = document.getElementById('units-imperial').checked;
        if (!target) return;
        if (target instanceof HTMLInputElement && target.type === 'checkbox') {
            const checked = target.checked;
            let check;
            if (checked) check = (0, $6fff0b6879cf2be0$export$1512cdff1d871a63)(Number(target.parentElement.parentElement.dataset.fileid));
            else check = (0, $6fff0b6879cf2be0$export$af41bf4625c84616)(Number(target.parentElement.parentElement.dataset.fileid));
            check.then(()=>(0, $502ca2c4c2e13c84$export$29482465873902ce)).then(()=>(0, $6fff0b6879cf2be0$export$b7f56bfef011c9e7)(targetunits))//.then( shots => autoBinDatasets(shots))
            //.then( result => renderHistogramOverlay('histogramCanvas', result.labels, result.datasets))
            .then((shots)=>(0, $86dd3a50fbb9df25$export$103d8ec267fff713)('histogramCanvas', shots));
        }
    });
    //radio button to switch units
    document.getElementById('units-radio').addEventListener('change', ()=>{
        const targetunits = document.getElementById('units-imperial').checked;
        (0, $6fff0b6879cf2be0$export$b7f56bfef011c9e7)(targetunits).then((shots)=>(0, $86dd3a50fbb9df25$export$103d8ec267fff713)('histogramCanvas', shots));
    //.then( shots => autoBinDatasets(shots))
    //.then( result => renderHistogramOverlay('histogramCanvas', result.labels, result.datasets))
    });
    // drag and drop files
    document.getElementById("x2l").addEventListener("drop", (event)=>{
        event.preventDefault();
        const files = [
            ...event.dataTransfer.items
        ].map((item)=>item.getAsFile()).filter((file)=>(0, $b116a038e81e017a$export$8668e6b8e9a6e50f).includes(file.type) || (0, $b116a038e81e017a$export$4325568133855ee7).includes(file.name.split('.').pop()));
        (0, $2f6a798bf6d12b9e$export$4a2ae512745da1fe)(files, feature_IndexedDB).finally(()=>{
            event.target.value = '';
        });
    });
    document.getElementById("x2l").addEventListener("dragover", (e)=>{
        const fileItems = [
            ...e.dataTransfer.items
        ].filter((item)=>item.kind === "file");
        if (fileItems.length > 0) {
            e.preventDefault();
            //if (fileItems.some((item) => allowedFileTypes.includes(item.type))) {
            e.dataTransfer.dropEffect = "copy";
        //} else {
        //  fileItems.some((item) => console.log(item.kind))
        //  e.dataTransfer.dropEffect = "none";
        //}
        }
    });
    window.addEventListener("dragover", (e)=>{
        const fileItems = [
            ...e.dataTransfer.items
        ].filter((item)=>item.kind === "file");
        if (fileItems.length > 0) {
            e.preventDefault();
            if (!document.getElementById("x2l").contains(e.target)) e.dataTransfer.dropEffect = "none";
        }
    });
    // prevent the browser from it's default bahaviour of downloading drag&dropped files
    window.addEventListener("drop", (e)=>{
        if ([
            ...e.dataTransfer.items
        ].some((item)=>item.kind === "file")) e.preventDefault();
    });
});


//# sourceMappingURL=xeroconv-dev.c812ab9c.js.map
